import { createElement as _ } from 'react';
export const Home = /*#__PURE__*/ (() => {
    function HomeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-12v-6l6-4.5z" })
        );
    }
    function Home({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HomeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home.SVG = HomeSVG;
    return Home;
})();
export const Home2 = /*#__PURE__*/ (() => {
    function Home2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-4v-4h-4v4h-4v-6l6-4.5z" })
        );
    }
    function Home2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home2.SVG = Home2SVG;
    return Home2;
})();
export const Home3 = /*#__PURE__*/ (() => {
    function Home3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h4v-3h2v3h4v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
        );
    }
    function Home3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home3.SVG = Home3SVG;
    return Home3;
})();
export const Home4 = /*#__PURE__*/ (() => {
    function Home4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h10v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
        );
    }
    function Home4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home4.SVG = Home4SVG;
    return Home4;
})();
export const Home5 = /*#__PURE__*/ (() => {
    function Home5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9.5l-3-3v-4.5h-2v2.5l-3-3-8 8v0.5h2v5h5v-3h2v3h5v-5h2z" })
        );
    }
    function Home5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home5.SVG = Home5SVG;
    return Home5;
})();
export const Home6 = /*#__PURE__*/ (() => {
    function Home6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0l-8 6v3l2-1.5v7.5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-7.5l2 1.5v-3l-8-6zM13 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-4.998v-5h-3v5h-1.998c-0.001-0.001-0.001-0.001-0.002-0.002v-8.248l5-3.75 5 3.75v8.248zM9 7h2v2h-2z" })
        );
    }
    function Home6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home6.SVG = Home6SVG;
    return Home6;
})();
export const Home7 = /*#__PURE__*/ (() => {
        function Home7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.6 6l4.4-4h-4.5l-4.4 4z" }),
_('path', { d: "M0 7h4v8h-4v-8z" }),
_('path', { d: "M10.5 2l-5.5 5v8h4v-4h3v4h4v-8z" })
            );
        }
        function Home7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Home7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Home7.SVG = Home7SVG;
        return Home7;
    })();
export const Home8 = /*#__PURE__*/ (() => {
    function Home8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8.5l-8-8-8 8 1.5 1.5 1.5-1.5v7.5h4v-3h2v3h4v-7.5l1.5 1.5 1.5-1.5zM12 15h-2v-3h-4v3h-2v-7.5l4-4 4 4v7.5z" })
        );
    }
    function Home8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home8.SVG = Home8SVG;
    return Home8;
})();
export const Home9 = /*#__PURE__*/ (() => {
    function Home9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l-8 8 1.5 1.5 1.5-1.5v7.5h4v-3h2v3h4v-7.5l1.5 1.5 1.5-1.5-8-8zM4.125 15h-0.125v-7.5l0.125-0.125v7.625zM4.625 15h-0.25v-7.875l0.25-0.25v8.125zM5.125 15h-0.25v-8.375l0.25-0.25v8.625zM5.625 15h-0.25v-8.875l0.25-0.25v9.125zM6.125 12h-0.125v3h-0.125v-9.375l0.25-0.25v6.625zM6.625 12h-0.25v-6.875l0.25-0.25v7.125zM7.125 12h-0.25v-7.375l0.25-0.25v7.625zM7.625 12h-0.25v-7.875l0.25-0.25v8.125zM8.125 12h-0.25v-8.375l0.125-0.125 0.125 0.125v8.375zM8.625 12h-0.25v-8.125l0.25 0.25v7.875zM9.125 12h-0.25v-7.625l0.25 0.25v7.375zM9.625 12h-0.25v-7.125l0.25 0.25v6.875zM10.125 15h-0.125v-3h-0.125v-6.625l0.25 0.25v9.375zM10.625 15h-0.25v-9.125l0.25 0.25v8.875zM11.125 15h-0.25v-8.625l0.25 0.25v8.375zM11.625 15h-0.25v-8.125l0.25 0.25v7.875zM12 15h-0.125v-7.625l0.125 0.125v7.5z" })
        );
    }
    function Home9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Home9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Home9.SVG = Home9SVG;
    return Home9;
})();
export const Office = /*#__PURE__*/ (() => {
    function OfficeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 16h8v-16h-8v16zM5 2h2v2h-2v-2zM5 6h2v2h-2v-2zM5 10h2v2h-2v-2zM1 2h2v2h-2v-2zM1 6h2v2h-2v-2zM1 10h2v2h-2v-2zM9 5h7v1h-7zM9 16h2v-4h3v4h2v-9h-7z" })
        );
    }
    function Office({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( OfficeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Office.SVG = OfficeSVG;
    return Office;
})();
export const City = /*#__PURE__*/ (() => {
        function CitySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 4h-0.5v-1.5c0-0.276-0.224-0.5-0.5-0.5h-1.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5v1.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5v2.5h3c0.552 0 1 0.448 1 1v7h-1v-6.5c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276 0-0.5 0.224-0.5 0.5v6.5h-1v-7c0-0.552 0.448-1 1-1h2v-4.5c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-11c0-0.276-0.224-0.5-0.5-0.5zM11 6h-1v-1h1v1zM5 3h1v1h-1v-1zM5 5h1v1h-1v-1zM3 3h1v1h-1v-1zM2 12h-1v-1h1v1zM2 10h-1v-1h1v1zM2 8h-1v-1h1v1zM2 6h-1v-1h1v1zM2 4h-1v-1h1v1zM3 5h1v1h-1v-1zM11 15h-5v-6h5v6zM13 6h-1v-1h1v1zM15 12h-1v-2h1v2zM15 9h-1v-2h1v2zM15 6h-1v-1h1v1z" }),
_('path', { d: "M7 10h1v1h-1v-1z" }),
_('path', { d: "M9 10h1v1h-1v-1z" }),
_('path', { d: "M7 12h1v1h-1v-1z" }),
_('path', { d: "M9 12h1v1h-1v-1z" })
            );
        }
        function City({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CitySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        City.SVG = CitySVG;
        return City;
    })();
export const Newspaper = /*#__PURE__*/ (() => {
    function NewspaperSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z" })
        );
    }
    function Newspaper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NewspaperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Newspaper.SVG = NewspaperSVG;
    return Newspaper;
})();
export const Magazine = /*#__PURE__*/ (() => {
        function MagazineSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.5 6h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M10.5 4h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M10.5 8h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M3.5 12h9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-9c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M3.5 10h9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-9c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M14.5 0h-11.5c-0.638 0-1.138 0.177-1.485 0.525-0.345 0.347-0.519 0.844-0.515 1.475v13.5c0 0.276 0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5v-0.5h1.5c0.276 0 0.5-0.224 0.5-0.5v-14c0-0.276-0.224-0.5-0.5-0.5zM14 14h-12l0-12.003c-0.002-0.357 0.074-0.615 0.224-0.767 0.152-0.153 0.413-0.231 0.776-0.231h11v13z" }),
_('path', { d: "M8.5 2h-5c-0.275 0-0.5 0.225-0.5 0.5v5c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-5c0-0.275-0.225-0.5-0.5-0.5zM8 7h-4v-1c0-0.552 0.448-1 1-1h1c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1h1c0.552 0 1 0.448 1 1v1z" })
            );
        }
        function Magazine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagazineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Magazine.SVG = MagazineSVG;
        return Magazine;
    })();
export const Design = /*#__PURE__*/ (() => {
        function DesignSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 4.5v-4l-15.5 15.5h4v-1h0.5v1h1.5v-2h0.5v2h1.5v-1h0.5v1h1.5v-2h0.5v2h1.5v-1h0.5v1h3v-3h-1v-0.5h1v-1.5h-2v-0.5h2v-1.5h-1v-0.5h1v-1.5h-2v-0.5h2v-1.5h-1v-0.5h1zM13 13h-5.5l5.5-5.5v5.5z" }),
_('path', { d: "M9.5 0l-8 8-1.5 4 4-1.5 8-8c0-1.5-1-2.5-2.5-2.5zM3.5 9l-1-1 7-7 1 1-7 7z" })
            );
        }
        function Design({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DesignSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Design.SVG = DesignSVG;
        return Design;
    })();
export const Pencil = /*#__PURE__*/ (() => {
    function PencilSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z" })
        );
    }
    function Pencil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PencilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil.SVG = PencilSVG;
    return Pencil;
})();
export const Pencil2 = /*#__PURE__*/ (() => {
    function Pencil2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.445 0.055l-8.945 8.945-2.5 7 6.995-2.5 8.95-8.945c0.5-2-2.5-5-4.5-4.5zM4.5 11l-1-1 8.5-8.5 1 1-8.5 8.5z" })
        );
    }
    function Pencil2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pencil2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil2.SVG = Pencil2SVG;
    return Pencil2;
})();
export const Pencil3 = /*#__PURE__*/ (() => {
    function Pencil3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.91 0c-0.159 0-0.315 0.018-0.465 0.055l-8.945 8.945-2.5 7 6.995-2.5 8.95-8.945c0.462-1.85-2.069-4.555-4.035-4.555zM6.525 12.025l-2.553-2.553 7.5-7.5 2.555 2.555-7.502 7.498z" })
        );
    }
    function Pencil3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pencil3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil3.SVG = Pencil3SVG;
    return Pencil3;
})();
export const Pencil4 = /*#__PURE__*/ (() => {
        function Pencil4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.445 0.055l-8.945 8.945h1.5v1h1v1h1v1h1v1.495l8.945-8.939c0.5-2-2.5-5-4.5-4.5z" }),
_('path', { d: "M6 13h-1v-1h-1v-1h-1v-1h-0.857l-2.143 6 6-2.144z" })
            );
        }
        function Pencil4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pencil4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pencil4.SVG = Pencil4SVG;
        return Pencil4;
    })();
export const Pencil5 = /*#__PURE__*/ (() => {
        function Pencil5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 8.5v5.5h-10v-10h5.5l2-2h-8c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h11c0.825 0 1.5-0.675 1.5-1.5v-8l-2 2z" }),
_('path', { d: "M13.5 0l-9.5 9.5v2.5h2.5l9.5-9.5c0-1.5-1-2.5-2.5-2.5z" })
            );
        }
        function Pencil5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pencil5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pencil5.SVG = Pencil5SVG;
        return Pencil5;
    })();
export const Pencil6 = /*#__PURE__*/ (() => {
    function Pencil6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 10l2-1 7-7-1-1-7 7-1 2zM4.52 13.548c-0.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6v-3l-6 6-1.217 2z" })
        );
    }
    function Pencil6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pencil6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pencil6.SVG = Pencil6SVG;
    return Pencil6;
})();
export const Pencil7 = /*#__PURE__*/ (() => {
        function Pencil7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 8.5v5.5h-10v-10h5.5l2-2h-8c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h11c0.825 0 1.5-0.675 1.5-1.5v-8l-2 2z" }),
_('path', { d: "M13.5 0l-9.5 9.5v2.5h2.5l9.5-9.5c0-1.5-1-2.5-2.5-2.5zM6.5 10l-0.75-0.75 7.5-7.5 0.75 0.75-7.5 7.5z" })
            );
        }
        function Pencil7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pencil7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pencil7.SVG = Pencil7SVG;
        return Pencil7;
    })();
export const Eraser = /*#__PURE__*/ (() => {
    function EraserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.995 4.366c-0.058-0.875-0.668-1.441-1.161-1.668-0.003-0.001-0.055-0.024-0.077-0.033l-3.143-1.257c-0.203-0.081-0.427-0.122-0.665-0.122-0.572 0-1.141 0.242-1.487 0.631 0 0-6.715 7.556-6.735 7.582-0.001 0.001-0.001 0.002-0.002 0.002-0.44 0.5-0.725 1-0.725 2v1c0 0.751 0.546 1.557 1.243 1.836l2.954 1.182c0.456 0.178 1.216 0.584 2.144-0.243 0.067-0.054 0.133-0.117 0.197-0.19l0.075-0.084c0-0 0-0 0-0v0l6.596-7.42c0.443-0.499 0.791-1.412 0.791-2.080v-1c0-0.027-0.005-0.133-0.005-0.134zM2.538 10.085l6.671-7.505c0.157-0.176 0.454-0.295 0.74-0.295 0.109 0 0.21 0.018 0.294 0.051l3.143 1.257c0.087 0.035 0.149 0.086 0.16 0.132s-0.021 0.119-0.084 0.19l-6.671 7.505c-0.157 0.176-0.454 0.295-0.74 0.295-0.109 0-0.21-0.018-0.294-0.051l-3.143-1.257c-0.087-0.035-0.149-0.086-0.16-0.133s0.021-0.12 0.084-0.19zM2 12.5v-1c0-0.195 0.075-0.195 0.107-0.195 0.027 0 0.072 0.005 0.135 0.031l3.143 1.257c0.321 0.129 0.614 0.561 0.614 0.907v1c0 0.195-0.075 0.195-0.107 0.195-0.027 0-0.072-0.005-0.135-0.031l-3.143-1.257c-0.321-0.129-0.614-0.561-0.614-0.907zM14 5.5c0 0.424-0.256 1.098-0.538 1.415l-6.462 7.27v-0.685c0-0.424 0.256-1.098 0.538-1.415l6.462-7.27v0.685z" })
        );
    }
    function Eraser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EraserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eraser.SVG = EraserSVG;
    return Eraser;
})();
export const Eraser2 = /*#__PURE__*/ (() => {
    function Eraser2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.998 4.422c-0.001-0.018-0.003-0.055-0.003-0.057-0.058-0.875-0.668-1.441-1.161-1.668-0.003-0.001-0.055-0.024-0.077-0.033l-3.143-1.257c-0.203-0.081-0.427-0.122-0.665-0.122-0.572 0-1.141 0.242-1.487 0.631l-6.671 7.505c-0.022 0.025-0.043 0.051-0.064 0.077-0.001 0.001-0.001 0.002-0.002 0.002-0.44 0.5-0.725 1-0.725 2v1c0 0.751 0.546 1.557 1.243 1.836l2.954 1.182c0.456 0.178 1.216 0.584 2.144-0.243 0.067-0.054 0.133-0.117 0.197-0.19l0.075-0.084c0-0 0-0 0-0l6.596-7.42c0.443-0.499 0.791-1.412 0.791-2.080v-1c0-0.027-0.001-0.052-0.002-0.078zM9.209 2.58c0.157-0.176 0.454-0.295 0.74-0.295 0.109 0 0.21 0.018 0.294 0.051l3.143 1.257c0.087 0.035 0.149 0.086 0.16 0.132s-0.021 0.119-0.084 0.19l-3.914 4.404-4.013-1.605 3.675-4.134zM14 5.5c0 0.424-0.256 1.098-0.538 1.415l-3.462 3.895v-1.495l4-4.5v0.685z" })
        );
    }
    function Eraser2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eraser2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eraser2.SVG = Eraser2SVG;
    return Eraser2;
})();
export const Eraser3 = /*#__PURE__*/ (() => {
    function Eraser3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.995 4.366c-0.058-0.875-0.668-1.441-1.161-1.668-0.003-0.001-0.055-0.024-0.077-0.033l-3.143-1.257c-0.203-0.081-0.427-0.122-0.665-0.122-0.572 0-1.141 0.242-1.487 0.631 0 0-6.715 7.556-6.735 7.582-0.001 0.001-0.001 0.002-0.002 0.002-0.44 0.5-0.725 1-0.725 2v1c0 0.751 0.546 1.557 1.243 1.836l2.954 1.182c0.456 0.178 1.216 0.584 2.144-0.243 0.067-0.054 0.133-0.117 0.197-0.19l0.075-0.084c0-0 0-0 0-0v0l6.596-7.42c0.443-0.499 0.791-1.412 0.791-2.080v-1c0-0.027-0.005-0.133-0.005-0.134zM2.538 10.085l6.671-7.505c0.157-0.176 0.454-0.295 0.74-0.295 0.109 0 0.21 0.018 0.294 0.051l3.143 1.257c0.087 0.035 0.149 0.086 0.16 0.132s-0.021 0.119-0.084 0.19l-6.671 7.505c-0.157 0.176-0.454 0.295-0.74 0.295-0.109 0-0.21-0.018-0.294-0.051l-3.143-1.257c-0.087-0.035-0.149-0.086-0.16-0.133s0.021-0.12 0.084-0.19z" })
        );
    }
    function Eraser3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eraser3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eraser3.SVG = Eraser3SVG;
    return Eraser3;
})();
export const Quill = /*#__PURE__*/ (() => {
    function QuillSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 16c2-6 7.234-16 16-16-4.109 3.297-6 11-9 11s-3 0-3 0l-3 5h-1z" })
        );
    }
    function Quill({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuillSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Quill.SVG = QuillSVG;
    return Quill;
})();
export const Quill2 = /*#__PURE__*/ (() => {
    function Quill2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 16h1l3-5c0 0 0 0 3 0s4.891-7.703 9-11c-8.766 0-14 10-16 16zM6.125 9h-1.125c0 0 2.766-5 7-7 0 0-3.797 3.359-5.875 7z" })
        );
    }
    function Quill2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Quill2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Quill2.SVG = Quill2SVG;
    return Quill2;
})();
export const Quill3 = /*#__PURE__*/ (() => {
    function Quill3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.914 0.22c-0.093-0.137-0.248-0.22-0.414-0.22-2.176 0-4.229 0.349-6.102 1.039-1.886 0.694-3.544 1.716-4.93 3.037-2.923 2.787-4.467 6.924-4.467 11.924h1.5c0-0.924 0.732-4 2-4 0.777 0 2.31-0.076 3.846-0.588 1.651-0.55 2.856-1.443 3.583-2.655 0.078-0.13 0.093-0.288 0.040-0.431s-0.167-0.253-0.311-0.301c-0.020-0.007-0.337-0.11-0.902-0.181 1.602-0.718 3.377-1.761 4.173-3.087 0.082-0.136 0.094-0.302 0.033-0.449s-0.187-0.255-0.341-0.294c-0.027-0.007-0.478-0.118-1.163-0.186 1.874-0.954 3.053-2.012 3.506-3.144 0.062-0.154 0.043-0.329-0.050-0.466zM11.914 2.984c-1.322 0.663-2.546 1.034-2.558 1.037-0.26 0.078-0.41 0.35-0.338 0.611s0.34 0.418 0.603 0.353c0.55-0.138 1.157-0.207 1.805-0.207 0.447 0 0.85 0.034 1.173 0.074-0.692 0.729-1.832 1.453-3.351 2.123-1.512 0.666-2.866 1.039-2.88 1.043-0.26 0.071-0.417 0.335-0.355 0.597s0.32 0.428 0.585 0.375c0.705-0.141 1.395-0.213 2.050-0.213 0.395 0 0.727 0.026 0.991 0.060-1.734 1.996-5.082 2.162-6.139 2.162-1.186 0-1.912 1.021-2.336 1.997 0.448-3.31 1.806-6.112 3.994-8.198 1.286-1.226 2.829-2.176 4.585-2.822 1.506-0.554 3.14-0.875 4.868-0.956-0.538 0.672-1.452 1.34-2.696 1.963z" })
        );
    }
    function Quill3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Quill3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Quill3.SVG = Quill3SVG;
    return Quill3;
})();
export const Quill4 = /*#__PURE__*/ (() => {
    function Quill4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 16c0-2.291 0.377-4.698 1.122-6.663 0.719-1.899 1.764-3.574 3.104-4.979 1.327-1.391 2.902-2.474 4.682-3.218 1.809-0.757 3.775-1.14 5.843-1.14 0.085 0 0.164 0.043 0.21 0.115s0.053 0.161 0.017 0.239c-0.522 1.148-1.851 2.212-3.952 3.162-0.298 0.135-0.594 0.259-0.879 0.372 0.195-0.007 0.393-0.010 0.594-0.010 1.176 0 2.010 0.12 2.045 0.125 0.084 0.012 0.156 0.066 0.191 0.143s0.029 0.167-0.016 0.238c-0.755 1.186-2.404 2.281-4.901 3.255-0.206 0.080-0.409 0.156-0.608 0.228 0.146-0.004 0.292-0.006 0.438-0.006 1.163 0 1.878 0.138 1.908 0.144 0.086 0.017 0.157 0.078 0.187 0.161s0.014 0.175-0.042 0.243c-2.28 2.786-3.837 3.592-6.944 3.592-0.707 0-1.258 0.614-1.636 1.825-0.3 0.96-0.364 2.175-0.364 2.175z" })
        );
    }
    function Quill4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Quill4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Quill4.SVG = Quill4SVG;
    return Quill4;
})();
export const Pen = /*#__PURE__*/ (() => {
    function PenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 6l-4.5-4.5 1.5-1.5 4.5 4.5-1.5 1.5zM9.75 2.75l3.5 3.5-2.25 5.75-9 4-0.646-0.646 5.388-5.388c0.083 0.022 0.169 0.034 0.259 0.034 0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1c0 0.090 0.012 0.176 0.034 0.259l-5.388 5.388-0.646-0.646 4-9 5.75-2.25z" })
        );
    }
    function Pen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pen.SVG = PenSVG;
    return Pen;
})();
export const PenPlus = /*#__PURE__*/ (() => {
        function PenPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 19 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 19 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 6l-4.5-4.5 1.5-1.5 4.5 4.5-1.5 1.5zM12.75 2.75l3.5 3.5-2.25 5.75-9 4-0.646-0.646 5.388-5.388c0.083 0.022 0.169 0.034 0.259 0.034 0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1c0 0.090 0.012 0.176 0.034 0.259l-5.388 5.388-0.646-0.646 4-9 5.75-2.25z" }),
_('path', { d: "M6 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z" })
            );
        }
        function PenPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PenPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PenPlus.SVG = PenPlusSVG;
        return PenPlus;
    })();
export const PenMinus = /*#__PURE__*/ (() => {
        function PenMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 19 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 19 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.5 6l-4.5-4.5 1.5-1.5 4.5 4.5-1.5 1.5zM12.75 2.75l3.5 3.5-2.25 5.75-9 4-0.646-0.646 5.388-5.388c0.083 0.022 0.169 0.034 0.259 0.034 0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1c0 0.090 0.012 0.176 0.034 0.259l-5.388 5.388-0.646-0.646 4-9 5.75-2.25z" }),
_('path', { d: "M0 2h6v2h-6v-2z" })
            );
        }
        function PenMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PenMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PenMinus.SVG = PenMinusSVG;
        return PenMinus;
    })();
export const Pen2 = /*#__PURE__*/ (() => {
        function Pen2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.909 4.561l-4.47-4.47c-0.146-0.146-0.338-0.113-0.427 0.073l-0.599 1.248 4.175 4.175 1.248-0.599c0.186-0.089 0.219-0.282 0.073-0.427z" }),
_('path', { d: "M9.615 2.115l-4.115 0.343c-0.273 0.034-0.501 0.092-0.58 0.449-0 0-0 0.001-0 0.001-1.116 5.36-4.92 10.591-4.92 10.591l0.896 0.896 4.25-4.25c-0.094-0.196-0.146-0.415-0.146-0.647 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.232 0-0.451-0.053-0.647-0.146l-4.25 4.25 0.896 0.896c0 0 5.231-3.804 10.591-4.92 0-0 0.001-0 0.001-0 0.357-0.078 0.415-0.306 0.449-0.58l0.343-4.115-4.269-4.269z" })
            );
        }
        function Pen2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pen2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pen2.SVG = Pen2SVG;
        return Pen2;
    })();
export const Pen3 = /*#__PURE__*/ (() => {
        function Pen3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2h-7l-0.5-2h8z" }),
_('path', { d: "M12 3h-7l-2 4.5 4 8.5h1v-8.086c-0.583-0.206-1-0.761-1-1.414 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.653-0.417 1.208-1 1.414v8.086h1l4-8.5-2-4.5z" })
            );
        }
        function Pen3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pen3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pen3.SVG = Pen3SVG;
        return Pen3;
    })();
export const Pen4 = /*#__PURE__*/ (() => {
    function Pen4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.185 2.444l0.815-2.444h-7l0.815 2.444-2.315 5.556 4 8h2l4-8-2.315-5.556zM9.613 1l-0.333 1h-3.559l-0.333-1h4.225zM8 14.764v-5.85c0.583-0.206 1-0.761 1-1.414 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.653 0.417 1.208 1 1.414v5.85l-3.401-6.802 2.068-4.962h3.667l2.068 4.962-3.401 6.802z" })
        );
    }
    function Pen4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pen4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pen4.SVG = Pen4SVG;
    return Pen4;
})();
export const Pen5 = /*#__PURE__*/ (() => {
    function Pen5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.313 3.813c-0.663 0.643-2.003 1.973-2.239 2.209-1.838 1.838-6.153 6.957-6.074 9.977 3.020 0.080 8.139-4.236 9.977-6.074 0.236-0.236 1.566-1.576 2.209-2.239l-3.873-3.873zM14.761 3.19l-0.282-0.281 1.521-1.257-1.652-1.652-1.257 1.521-0.282-0.282c-0.872-0.051-2.278 0.793-3.663 1.907l3.707 3.707c0.419-0.521 0.798-1.045 1.107-1.542 0.93 0.767 0.243 3.017-3.682 5.967l0.722 0.722c3.5-2.5 5.766-5.5 3.571-7.882 0.131-0.346 0.205-0.663 0.19-0.928z" })
        );
    }
    function Pen5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pen5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pen5.SVG = Pen5SVG;
    return Pen5;
})();
export const Marker = /*#__PURE__*/ (() => {
    function MarkerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.726 3.301c-0.343-0.829-0.995-1.663-1.789-2.288-0.829-0.653-1.716-1.013-2.499-1.013-0.607 0-1.128 0.213-1.548 0.632l-7.171 7.171c-0.073 0.073-0.128 0.16-0.163 0.256l-2.513 6.644c-0.094 0.257-0.030 0.545 0.163 0.738l0.352 0.352c0.134 0.134 0.314 0.206 0.497 0.206 0.081 0 0.162-0.014 0.241-0.043l6.644-2.513c0.096-0.035 0.184-0.091 0.256-0.163l7.171-7.171c0.694-0.694 0.821-1.691 0.358-2.809zM7.495 11.995l-3.489-3.489 6-6 3.489 3.489-6 6z" })
        );
    }
    function Marker({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MarkerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Marker.SVG = MarkerSVG;
    return Marker;
})();
export const Marker2 = /*#__PURE__*/ (() => {
        function Marker2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.726 3.301c-0.343-0.829-0.995-1.663-1.789-2.288-0.829-0.653-1.716-1.013-2.499-1.013-0.607 0-1.128 0.213-1.548 0.632l-7.171 7.171c-0.073 0.073-0.128 0.16-0.163 0.256l-2.513 6.644c-0.094 0.257-0.030 0.545 0.163 0.738l0.352 0.352c0.134 0.134 0.314 0.206 0.497 0.206 0.081 0 0.162-0.014 0.241-0.043l6.644-2.513c0.096-0.035 0.184-0.091 0.256-0.163l7.171-7.171c0.694-0.694 0.821-1.691 0.358-2.809zM7.495 11.995l-3.489-3.489 6-6 3.489 3.489-6 6z" }),
_('path', { d: "M8.625 14.875h7.375v-0.25h-7.125z" }),
_('path', { d: "M8.125 15.375h7.875v-0.25h-7.625z" }),
_('path', { d: "M7.625 15.875h8.375v-0.25h-8.125z" }),
_('path', { d: "M9.625 13.875h6.375v-0.25h-6.125z" }),
_('path', { d: "M9.125 14.375h6.875v-0.25h-6.625z" }),
_('path', { d: "M10.125 13.375h5.875v-0.25h-5.625z" })
            );
        }
        function Marker2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Marker2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Marker2.SVG = Marker2SVG;
        return Marker2;
    })();
export const Blog = /*#__PURE__*/ (() => {
        function BlogSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z" }),
_('path', { d: "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7z" }),
_('path', { d: "M7.5 6l-1 1-3.5 1-3 6.5 0.396 0.396 3.638-3.638c-0.022-0.083-0.034-0.169-0.034-0.259 0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.090 0-0.176-0.012-0.259-0.034l-3.638 3.638 0.396 0.396 6.5-3 1-3.5 1-1-2.5-2.5z" })
            );
        }
        function Blog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BlogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Blog.SVG = BlogSVG;
        return Blog;
    })();
export const Blog2 = /*#__PURE__*/ (() => {
        function Blog2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7zM6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z" }),
_('path', { d: "M8.414 7.586c-0.781-0.781-2.047-0.781-2.828-0l-5.586 5.586v2.828h2.828l5.586-5.586c0.781-0.781 0.781-2.047 0-2.828zM2 14.5l-1-1 5-5 1 1-5 5z" })
            );
        }
        function Blog2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Blog2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Blog2.SVG = Blog2SVG;
        return Blog2;
    })();
export const Pen6 = /*#__PURE__*/ (() => {
        function Pen6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 2.5c0-1.381-1.119-2.5-2.5-2.5-0.818 0-1.544 0.393-2 1l-9 9 3.5 3.5 9-9c0.607-0.456 1-1.182 1-2z" }),
_('path', { d: "M0 16l1.5-5 3.5 3.5z" })
            );
        }
        function Pen6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pen6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pen6.SVG = Pen6SVG;
        return Pen6;
    })();
export const Brush = /*#__PURE__*/ (() => {
        function BrushSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.45 15.992c-0 0-0 0-0 0-1.856-0-3.204-1.056-3.261-1.101-0.166-0.132-0.231-0.355-0.161-0.556s0.259-0.335 0.472-0.335c1.49 0 1.838-0.801 2.279-1.815 0.424-0.973 0.951-2.185 2.721-2.185 0.668 0 1.295 0.26 1.767 0.732s0.732 1.1 0.732 1.768c0 0.668-0.26 1.296-0.732 1.768-1.144 1.144-2.429 1.724-3.818 1.724z" }),
_('path', { d: "M15.662 0.251c-0.415-0.366-1.048-0.327-1.414 0.087l-7.565 8.561c-0.045 0.051-0.093 0.113-0.132 0.17-0.066 0.097-0.121 0.198-0.165 0.302 0.529 0.149 1.014 0.431 1.413 0.83 0.402 0.402 0.685 0.89 0.833 1.422 0.298-0.124 0.565-0.332 0.76-0.618l6.435-9.439c0.281-0.411 0.218-0.977-0.164-1.315z" })
            );
        }
        function Brush({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrushSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Brush.SVG = BrushSVG;
        return Brush;
    })();
export const Spray = /*#__PURE__*/ (() => {
        function SpraySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M6 1.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M4 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M2 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M1 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M2 1.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M1 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M1 0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M4 1.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3 0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M2 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14.45 4.308c-0.421-0.105-0.914-0.185-1.45-0.237v-1.57c0-0.276-0.672-0.5-1.5-0.5s-1.5 0.224-1.5 0.5v0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.53-0.5 0.53l-0 0c-0.729 0.045-1.4 0.14-1.95 0.277-0.383 0.096-1.55 0.388-1.55 1.192v9c0 0.805 1.167 1.096 1.55 1.192 0.794 0.198 1.842 0.308 2.95 0.308s2.156-0.109 2.95-0.308c0.383-0.096 1.55-0.388 1.55-1.192v-9c0-0.805-1.167-1.096-1.55-1.192zM15 10.473c-0.221-0.082-0.427-0.134-0.55-0.165-0.673-0.168-1.529-0.272-2.45-0.3v3.492c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.492c-0.92 0.028-1.776 0.132-2.45 0.3-0.124 0.031-0.329 0.082-0.55 0.165v-3.945c0.221 0.082 0.427 0.134 0.55 0.165 0.673 0.168 1.529 0.272 2.45 0.3v3.016c0.165-0.005 0.332-0.008 0.5-0.008s0.335 0.003 0.5 0.008v-3.016c0.92-0.028 1.776-0.132 2.45-0.3 0.124-0.031 0.329-0.082 0.55-0.165v3.945z" })
            );
        }
        function Spray({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpraySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spray.SVG = SpraySVG;
        return Spray;
    })();
export const Palette = /*#__PURE__*/ (() => {
    function PaletteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.048 2c-5.142 0-8.048 3.417-8.048 5.917 0 3.809 3.417 5.952 6.26 6.655s3.912-0.586 3.866-2.072c-0.055-1.805 0.846-1.828 1.485-1.764s4.389 0.93 4.389-1.944c0-3.557-2.81-6.791-7.952-6.791zM7 3c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM2.5 9.008c-0.28 0-0.508-0.227-0.508-0.508s0.227-0.508 0.508-0.508 0.508 0.227 0.508 0.508-0.227 0.508-0.508 0.508zM4 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM8 11c-1.105 0-2-0.672-2-1.5s0.895-1.5 2-1.5c1.105 0 2 0.672 2 1.5s-0.895 1.5-2 1.5zM11.5 7c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function Palette({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PaletteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Palette.SVG = PaletteSVG;
    return Palette;
})();
export const Palette2 = /*#__PURE__*/ (() => {
    function Palette2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 2c-4.418 0-8 3.134-8 7 0 2.592 1.61 4.855 4.003 6.065 1.35 0.667 2.504 0.182 1.692-0.965-0.434-0.434-0.695-0.992-0.695-1.6 0-1.381 1.343-2.5 3-2.5s3 1.119 3 2.5c0 0.609-0.261 1.167-0.695 1.6-0.812 1.146 0.342 1.632 1.692 0.965 2.393-1.21 4.003-3.473 4.003-6.065 0-3.866-3.582-7-8-7zM2 10c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM4 6.866c-0.717 0.414-1.523 0.362-1.799-0.116s0.082-1.202 0.799-1.616 1.523-0.362 1.799 0.116c0.276 0.478-0.082 1.202-0.799 1.616zM8 6c-1.105 0-2-0.672-2-1.5s0.895-1.5 2-1.5c1.105 0 2 0.672 2 1.5s-0.895 1.5-2 1.5zM12 6.866c-0.717-0.414-1.075-1.138-0.799-1.616s1.082-0.53 1.799-0.116 1.075 1.138 0.799 1.616-1.082 0.53-1.799 0.116zM14 10c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Palette2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Palette2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Palette2.SVG = Palette2SVG;
    return Palette2;
})();
export const ColorSampler = /*#__PURE__*/ (() => {
        function ColorSamplerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 11h-11c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5zM10 14c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" }),
_('path', { d: "M12 10.581v-7.081c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v3.081l4 4z" }),
_('path', { d: "M15.698 4.646l-2.698-1.302v8.042l2.931-6.072c0.12-0.249 0.016-0.548-0.233-0.668z" }),
_('path', { d: "M9.828 10l-5.132-5.132c-0.195-0.195-0.512-0.195-0.707 0l-2.121 2.121c-0.195 0.195-0.195 0.512 0 0.707l2.303 2.303h5.657z" })
            );
        }
        function ColorSampler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ColorSamplerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ColorSampler.SVG = ColorSamplerSVG;
        return ColorSampler;
    })();
export const Toggle = /*#__PURE__*/ (() => {
        function ToggleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 6v-3.5c0-0.276-0.224-0.5-0.5-0.5h-3.5v-2l-2.5 2.5 2.5 2.5v-2h3v3h-2l2.5 2.5 2.5-2.5h-2z" }),
_('path', { d: "M11.25 8h-3.25v-3.25c0-0.412-0.338-0.75-0.75-0.75h-6.5c-0.412 0-0.75 0.338-0.75 0.75v6.5c0 0.412 0.338 0.75 0.75 0.75h3.25v3.25c0 0.412 0.338 0.75 0.75 0.75h6.5c0.412 0 0.75-0.338 0.75-0.75v-6.5c0-0.412-0.338-0.75-0.75-0.75zM11 15h-6v-3h2.25c0.412 0 0.75-0.338 0.75-0.75v-2.25h3v6z" })
            );
        }
        function Toggle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Toggle.SVG = ToggleSVG;
        return Toggle;
    })();
export const Bucket = /*#__PURE__*/ (() => {
        function BucketSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.265 5.651c-0.312-0.134-0.745-0.252-1.287-0.35-1.067-0.194-2.48-0.301-3.979-0.301s-2.911 0.107-3.979 0.301c-0.542 0.099-0.975 0.216-1.287 0.35-0.488 0.21-0.735 0.495-0.735 0.849 0 0.047 0.005 0.092 0.013 0.136l0.988 7.902c0.034 0.703 0.988 0.997 1.709 1.157 0.885 0.197 2.053 0.305 3.29 0.305s2.406-0.108 3.29-0.305c0.721-0.16 1.675-0.454 1.709-1.157l0.988-7.902c0.009-0.044 0.013-0.090 0.013-0.136 0-0.354-0.247-0.639-0.735-0.849zM4.539 6.228c0.964-0.147 2.193-0.228 3.461-0.228s2.497 0.081 3.461 0.228c0.601 0.092 0.984 0.191 1.223 0.272-0.239 0.081-0.622 0.18-1.223 0.272-0.964 0.147-2.193 0.228-3.461 0.228s-2.497-0.081-3.461-0.228c-0.601-0.092-0.984-0.191-1.223-0.272 0.239-0.081 0.622-0.18 1.223-0.272zM12.010 14.388c-0.087 0.063-0.387 0.235-1.227 0.39-0.776 0.143-1.764 0.222-2.783 0.222s-2.007-0.079-2.783-0.222c-0.84-0.155-1.14-0.326-1.227-0.39l-0.862-6.898c0.252 0.077 0.551 0.147 0.894 0.209 0.301 0.055 0.629 0.102 0.979 0.143v2.158c0 0.552 0.448 1 1 1s1-0.448 1-1v-2.016c0.327 0.011 0.661 0.016 1 0.016v4.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-4.516c0.343-0.011 0.677-0.028 1-0.051v1.567c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.658c0.35-0.040 0.678-0.088 0.979-0.143 0.343-0.062 0.642-0.132 0.894-0.209l-0.862 6.898z" }),
_('path', { d: "M13.696 2.040c-0.549-0.656-1.284-1.16-2.184-1.498-0.959-0.36-2.141-0.542-3.512-0.542s-2.552 0.182-3.511 0.542c-0.9 0.338-1.635 0.842-2.184 1.498-0.89 1.063-1.304 2.48-1.304 4.46 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.732 0.34-2.945 1.071-3.818 0.443-0.53 1.022-0.923 1.769-1.203 0.847-0.318 1.91-0.478 3.16-0.478s2.314 0.161 3.16 0.478c0.747 0.28 1.325 0.674 1.769 1.203 0.731 0.873 1.071 2.086 1.071 3.818 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.98-0.414-3.397-1.304-4.46z" })
            );
        }
        function Bucket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BucketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bucket.SVG = BucketSVG;
        return Bucket;
    })();
export const Bucket2 = /*#__PURE__*/ (() => {
        function Bucket2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.696 2.040c-0.549-0.656-1.284-1.16-2.184-1.498-0.959-0.36-2.141-0.542-3.512-0.542s-2.552 0.182-3.511 0.542c-0.9 0.338-1.635 0.842-2.184 1.498-0.89 1.063-1.304 2.48-1.304 4.46 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.732 0.34-2.945 1.071-3.818 0.443-0.53 1.022-0.923 1.769-1.203 0.847-0.318 1.91-0.478 3.16-0.478s2.314 0.161 3.16 0.478c0.747 0.28 1.325 0.674 1.769 1.203 0.731 0.873 1.071 2.086 1.071 3.818 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.98-0.414-3.397-1.304-4.46z" }),
_('path', { d: "M13.265 5.651c-0.312-0.134-0.745-0.252-1.287-0.35-1.067-0.194-2.48-0.301-3.979-0.301s-2.911 0.107-3.979 0.301c-0.542 0.099-0.975 0.216-1.287 0.35-0.488 0.21-0.735 0.495-0.735 0.849 0 0.047 0.005 0.092 0.013 0.136l0.988 7.902c0.034 0.703 0.988 0.997 1.709 1.157 0.885 0.197 2.053 0.305 3.29 0.305s2.406-0.108 3.29-0.305c0.721-0.16 1.675-0.454 1.709-1.157l0.988-7.902c0.009-0.044 0.013-0.090 0.013-0.136 0-0.354-0.247-0.639-0.735-0.849zM11.461 6.772c-0.964 0.147-2.193 0.228-3.461 0.228s-2.497-0.081-3.461-0.228c-0.601-0.092-0.984-0.191-1.223-0.272 0.239-0.081 0.622-0.18 1.223-0.272 0.964-0.147 2.193-0.228 3.461-0.228s2.497 0.081 3.461 0.228c0.601 0.092 0.984 0.191 1.223 0.272-0.239 0.081-0.622 0.18-1.223 0.272z" })
            );
        }
        function Bucket2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bucket2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bucket2.SVG = Bucket2SVG;
        return Bucket2;
    })();
export const Gradient = /*#__PURE__*/ (() => {
        function GradientSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM5 1v0.5h-0.5v-0.5h0.5zM4.5 12.5v-0.5h0.5v0.5h-0.5zM5 13v0.5h-0.5v-0.5h0.5zM4.5 11.5v-0.5h0.5v0.5h-0.5zM4.5 10.5v-0.5h0.5v0.5h-0.5zM4.5 9.5v-0.5h0.5v0.5h-0.5zM4.5 8.5v-0.5h0.5v0.5h-0.5zM4.5 7.5v-0.5h0.5v0.5h-0.5zM4.5 6.5v-0.5h0.5v0.5h-0.5zM4.5 5.5v-0.5h0.5v0.5h-0.5zM4.5 4.5v-0.5h0.5v0.5h-0.5zM4.5 3.5v-0.5h0.5v0.5h-0.5zM4.5 2.5v-0.5h0.5v0.5h-0.5zM4.5 14h0.5v0.5h-0.5v-0.5zM4 1v0.5h-0.5v-0.5h0.5zM3.5 12.5v-0.5h0.5v0.5h-0.5zM4 13v0.5h-0.5v-0.5h0.5zM3.5 11.5v-0.5h0.5v0.5h-0.5zM3.5 10.5v-0.5h0.5v0.5h-0.5zM3.5 9.5v-0.5h0.5v0.5h-0.5zM3.5 8.5v-0.5h0.5v0.5h-0.5zM3.5 7.5v-0.5h0.5v0.5h-0.5zM3.5 6.5v-0.5h0.5v0.5h-0.5zM3.5 5.5v-0.5h0.5v0.5h-0.5zM3.5 4.5v-0.5h0.5v0.5h-0.5zM3.5 3.5v-0.5h0.5v0.5h-0.5zM3.5 2.5v-0.5h0.5v0.5h-0.5zM3.5 14h0.5v0.5h-0.5v-0.5zM3 1v0.5h-0.5v-0.5h0.5zM2.5 12.5v-0.5h0.5v0.5h-0.5zM3 13v0.5h-0.5v-0.5h0.5zM2.5 11.5v-0.5h0.5v0.5h-0.5zM2.5 10.5v-0.5h0.5v0.5h-0.5zM2.5 9.5v-0.5h0.5v0.5h-0.5zM2.5 8.5v-0.5h0.5v0.5h-0.5zM2.5 7.5v-0.5h0.5v0.5h-0.5zM2.5 6.5v-0.5h0.5v0.5h-0.5zM2.5 5.5v-0.5h0.5v0.5h-0.5zM2.5 4.5v-0.5h0.5v0.5h-0.5zM2.5 3.5v-0.5h0.5v0.5h-0.5zM2.5 2.5v-0.5h0.5v0.5h-0.5zM2.5 14h0.5v0.5h-0.5v-0.5zM15 15h-2v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v0.5h-0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v-0.5h-0.5v-0.5h0.5v0.5h0.5v-0.5h0.5v0.5h0.5v-0.5h0.5v0.5h0.5v-0.5h0.5v0.5h0.5v-0.5h5.5v14z" }),
_('path', { d: "M7.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 2h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 2h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 2h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 2h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 1.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 2.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 3h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 3h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 4h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 4h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 3h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 3h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 4h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 4h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 3.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 4.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 6h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 6h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 6h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 6h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 5.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 6.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 7h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 7h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 8h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 8h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 7h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 7h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 8h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 8h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 7.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 8.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 9h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 9h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 10h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 10h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 9h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 9h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 10h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 10h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 9.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 10.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 11h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 11h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 12h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 12h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 11h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 11h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 12h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 12h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 11.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 12.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 13h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 13h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M10.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M8 14h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M9 14h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 13h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 13h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M6 14h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M7 14h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M11.5 13.5h0.5v0.5h-0.5v-0.5z" }),
_('path', { d: "M12.5 13.5h0.5v0.5h-0.5v-0.5z" })
            );
        }
        function Gradient({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GradientSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Gradient.SVG = GradientSVG;
        return Gradient;
    })();
export const Eyedropper = /*#__PURE__*/ (() => {
    function EyedropperSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM2.705 15h-1.705v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z" })
        );
    }
    function Eyedropper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyedropperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eyedropper.SVG = EyedropperSVG;
    return Eyedropper;
})();
export const Eyedropper2 = /*#__PURE__*/ (() => {
    function Eyedropper2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM7.705 10h-3.409l4.042-4.042 1.704 1.705-2.337 2.337z" })
        );
    }
    function Eyedropper2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eyedropper2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eyedropper2.SVG = Eyedropper2SVG;
    return Eyedropper2;
})();
export const Eyedropper3 = /*#__PURE__*/ (() => {
    function Eyedropper3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 5h-1.75c-1 0-0.25-1-0.25-3 0-0.236-0.028-0.416-0.077-0.55-0.239-0.837-1.009-1.45-1.923-1.45s-1.684 0.613-1.923 1.45c-0.049 0.134-0.077 0.314-0.077 0.55 0 2 0.75 3-0.25 3h-1.75v2h2v7.75c0 0.137 0.112 0.25 0.25 0.25h0.5c0.138 0 0.25 0.113 0.25 0.25v0.5c0 0.137 0.112 0.25 0.25 0.25h1.5c0.137 0 0.25-0.113 0.25-0.25v-0.5c0-0.137 0.113-0.25 0.25-0.25h0.5c0.137 0 0.25-0.113 0.25-0.25v-7.75h2v-2zM9 14.025c-0.489 0.1-0.875 0.486-0.975 0.975h-0.050c-0.1-0.489-0.486-0.875-0.975-0.975v-7.025h2v7.025z" })
        );
    }
    function Eyedropper3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eyedropper3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eyedropper3.SVG = Eyedropper3SVG;
    return Eyedropper3;
})();
export const Droplet = /*#__PURE__*/ (() => {
    function DropletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM11.543 11.859c-0.684 1.301-2.075 2.141-3.543 2.141-0.861 0-1.696-0.29-2.377-0.791 0.207 0.027 0.416 0.041 0.627 0.041 1.835 0 3.573-1.050 4.428-2.676 0.701-1.333 0.64-2.716 0.373-3.818 0.227 0.44 0.42 0.878 0.576 1.311 0.353 0.985 0.625 2.443-0.084 3.791z" })
        );
    }
    function Droplet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DropletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Droplet.SVG = DropletSVG;
    return Droplet;
})();
export const Droplet2 = /*#__PURE__*/ (() => {
    function Droplet2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 2.014c0.762 0.725 1.448 1.48 2.046 2.256 0.931 1.207 1.621 2.428 2.052 3.629 0.387 1.080 0.682 2.683-0.112 4.192-0.77 1.463-2.334 2.408-3.986 2.408s-3.216-0.945-3.986-2.408c-0.794-1.509-0.499-3.113-0.112-4.192 0.431-1.201 1.121-2.422 2.052-3.629 0.598-0.776 1.284-1.531 2.046-2.256v0zM8 0c-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397-1.027-2.866-3.205-5.44-5.51-7.393v0z" })
        );
    }
    function Droplet2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Droplet2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Droplet2.SVG = Droplet2SVG;
    return Droplet2;
})();
export const DropletContrast = /*#__PURE__*/ (() => {
    function DropletContrastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM4.014 12.092c-0.794-1.509-0.499-3.113-0.112-4.192 0.431-1.201 1.121-2.422 2.052-3.629 0.598-0.776 1.284-1.531 2.046-2.256v12.486c-1.651 0-3.216-0.945-3.986-2.408z" })
        );
    }
    function DropletContrast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DropletContrastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    DropletContrast.SVG = DropletContrastSVG;
    return DropletContrast;
})();
export const ColorClear = /*#__PURE__*/ (() => {
        function ColorClearSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.707 14.293l-13-13-1.414 1.414 2.326 2.326c-0.453 0.758-0.837 1.547-1.129 2.36-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21 1.739 0 3.395-0.778 4.523-2.063l1.77 1.77 1.414-1.414z" }),
_('path', { d: "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-0.805 0.682-1.595 1.441-2.325 2.261l8.288 8.288c0.090-1.054-0.085-2.13-0.453-3.155z" })
            );
        }
        function ColorClear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ColorClearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ColorClear.SVG = ColorClearSVG;
        return ColorClear;
    })();
export const PaintFormat = /*#__PURE__*/ (() => {
    function PaintFormatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z" })
        );
    }
    function PaintFormat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PaintFormatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PaintFormat.SVG = PaintFormatSVG;
    return PaintFormat;
})();
export const Stamp = /*#__PURE__*/ (() => {
        function StampSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 11h-5c-0.828 0-1.5-0.672-1.5-1.5v-3.671c1.165-0.412 2-1.523 2-2.829 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.306 0.835 2.417 2 2.829v3.671c0 0.828-0.672 1.5-1.5 1.5h-5c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M1 14.5v1c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-1h-14z" })
            );
        }
        function Stamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stamp.SVG = StampSVG;
        return Stamp;
    })();
export const Images = /*#__PURE__*/ (() => {
    function ImagesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-1v-12h14v1h-12c-0.55 0-1 0.45-1 1zM15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5zM16 14h-12v-2l3.5-6 4 5h1l3.5-3v6z" })
        );
    }
    function Images({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ImagesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Images.SVG = ImagesSVG;
    return Images;
})();
export const Image = /*#__PURE__*/ (() => {
    function ImageSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM11.5 3c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM14 13h-12v-2l3.5-6 4 5h1l3.5-3v6z" })
        );
    }
    function Image({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ImageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Image.SVG = ImageSVG;
    return Image;
})();
export const Image2 = /*#__PURE__*/ (() => {
        function Image2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.998 2c0.001 0.001 0.001 0.001 0.002 0.002v11.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1v0z" }),
_('path', { d: "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z" }),
_('path', { d: "M14 13h-12v-2l3.5-6 4 5h1l3.5-3z" })
            );
        }
        function Image2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Image2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Image2.SVG = Image2SVG;
        return Image2;
    })();
export const ImageCompare = /*#__PURE__*/ (() => {
        function ImageCompareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M0 3v10c0 0.55 0.45 1 1 1h6v-1h-5.998c-0.001-0.001-0.001-0.001-0.002-0.002v-9.996c0.001-0.001 0.001-0.001 0.002-0.002h5.998v-1h-6c-0.55 0-1 0.45-1 1z" }),
_('path', { d: "M15 2h-6v-2h-1v16h1v-2h6c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM15 12.998c-0.001 0.001-0.001 0.001-0.002 0.002h-5.998v-1h5v-5l-3.5 3h-1l-0.5-0.625v-6.375h5.998c0.001 0.001 0.001 0.001 0.002 0.002v9.996z" }),
_('path', { d: "M2 11v1h5v-5.125l-1.5-1.875z" })
            );
        }
        function ImageCompare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ImageCompareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ImageCompare.SVG = ImageCompareSVG;
        return ImageCompare;
    })();
export const Images2 = /*#__PURE__*/ (() => {
        function Images2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-0.998c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-12c-0.55 0-1 0.45-1 1v0zM17 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v11.996z" }),
_('path', { d: "M15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z" }),
_('path', { d: "M16 14h-12v-2l3.5-6 4 5h1l3.5-3z" })
            );
        }
        function Images2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Images2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Images2.SVG = Images2SVG;
        return Images2;
    })();
export const Image3 = /*#__PURE__*/ (() => {
    function Image3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v15h16v-15h-16zM14 12h-12v-9h12v9zM13 9l-1-2-2 2-3-5-4 6v1h10z" })
        );
    }
    function Image3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Image3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Image3.SVG = Image3SVG;
    return Image3;
})();
export const Images3 = /*#__PURE__*/ (() => {
    function Images3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 1h-12v12h12v-12zM11 10h-10v-8h10v8zM8 5l-0.714 1.429-2.286-3.429-3 6h8zM13 3.856v10.144h-11.11l-0.078 0.746 11.934 1.254 1.254-11.934z" })
        );
    }
    function Images3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Images3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Images3.SVG = Images3SVG;
    return Images3;
})();
export const Image4 = /*#__PURE__*/ (() => {
        function Image4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 6l-3.5 3.5-3-3-5 5v1.5h12v-7z" }),
_('path', { d: "M14.5 2c0.271 0 0.5 0.229 0.5 0.5v11c0 0.271-0.229 0.5-0.5 0.5h-13c-0.271 0-0.5-0.229-0.5-0.5v-11c0-0.271 0.229-0.5 0.5-0.5h13zM14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-11c0-0.825-0.675-1.5-1.5-1.5v0z" })
            );
        }
        function Image4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Image4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Image4.SVG = Image4SVG;
        return Image4;
    })();
export const Image5 = /*#__PURE__*/ (() => {
        function Image5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 3v10h-12v-10h12zM14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v11c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-11c0-0.825-0.675-1.5-1.5-1.5v0z" }),
_('path', { d: "M10 9.5l-3-3-4 4v1.5h10v-5.5z" })
            );
        }
        function Image5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Image5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Image5.SVG = Image5SVG;
        return Image5;
    })();
export const Image6 = /*#__PURE__*/ (() => {
        function Image6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.952 2.125h-15.904c-0.021 0.081-0.035 0.165-0.042 0.25h15.989c-0.007-0.085-0.021-0.169-0.042-0.25z" }),
_('path', { d: "M15.097 1.125h-14.194c-0.144 0.063-0.276 0.148-0.392 0.25h14.978c-0.116-0.102-0.248-0.187-0.392-0.25z" }),
_('path', { d: "M15.716 1.625h-15.432c-0.056 0.078-0.106 0.162-0.146 0.25h15.725c-0.041-0.088-0.090-0.172-0.146-0.25z" }),
_('path', { d: "M0.903 14.875h14.194c0.144-0.063 0.276-0.148 0.392-0.25h-14.978c0.116 0.102 0.248 0.187 0.392 0.25z" }),
_('path', { d: "M0.284 14.375h15.432c0.056-0.078 0.106-0.162 0.146-0.25h-15.725c0.041 0.088 0.090 0.172 0.146 0.25z" }),
_('path', { d: "M16 2.875v-0.25h-16v0.25h0.125v10.25h-0.125v0.25h16v-0.25h-0.125v-10.25h0.125zM1.375 2.875h0.25v10.25h-0.25v-10.25zM1.125 13.125h-0.25v-10.25h0.25v10.25zM1.875 2.875h12.25v10.25h-12.25v-10.25zM14.375 2.875h0.25v10.25h-0.25v-10.25zM14.875 2.875h0.25v10.25h-0.25v-10.25zM0.375 2.875h0.25v10.25h-0.25v-10.25zM15.625 13.125h-0.25v-10.25h0.25v10.25z" }),
_('path', { d: "M0.048 13.875h15.904c0.021-0.081 0.035-0.165 0.042-0.25h-15.989c0.007 0.085 0.021 0.169 0.042 0.25z" }),
_('path', { d: "M13.5 6l-3.5 3.5-3-3-5 5v1.5h12v-7z" })
            );
        }
        function Image6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Image6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Image6.SVG = Image6SVG;
        return Image6;
    })();
export const Camera = /*#__PURE__*/ (() => {
    function CameraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.75 9.5c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25zM15 4h-3.5c-0.25-1-0.5-2-1.5-2h-4c-1 0-1.25 1-1.5 2h-3.5c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM8 13.938c-2.451 0-4.438-1.987-4.438-4.438s1.987-4.438 4.438-4.438c2.451 0 4.438 1.987 4.438 4.438s-1.987 4.438-4.438 4.438zM15 7h-2v-1h2v1z" })
        );
    }
    function Camera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Camera.SVG = CameraSVG;
    return Camera;
})();
export const Camera2 = /*#__PURE__*/ (() => {
        function Camera2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 5h-3c-0.086 0-0.238-0.094-0.276-0.171l-0.553-1.106c-0.206-0.413-0.71-0.724-1.171-0.724h-4c-0.461 0-0.965 0.311-1.171 0.724l-0.553 1.106c-0.038 0.077-0.191 0.171-0.276 0.171v-0.5c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v0.5c-0.551 0-1 0.449-1 1v9c0 0.551 0.449 1 1 1h14c0.551 0 1-0.449 1-1v-9c0-0.551-0.449-1-1-1zM1 15v-9h3c0.461 0 0.965-0.311 1.171-0.724l0.553-1.106c0.038-0.077 0.191-0.171 0.276-0.171h4c0.086 0 0.238 0.094 0.276 0.171l0.553 1.106c0.206 0.412 0.71 0.724 1.171 0.724h3l0 9h-14z" }),
_('path', { d: "M8 5.875c-2.275 0-4.125 1.85-4.125 4.125s1.85 4.125 4.125 4.125 4.125-1.85 4.125-4.125-1.85-4.125-4.125-4.125zM8 13.094c-1.706 0-3.094-1.388-3.094-3.094s1.388-3.094 3.094-3.094 3.094 1.388 3.094 3.094-1.388 3.094-3.094 3.094z" }),
_('path', { d: "M10 10c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" }),
_('path', { d: "M13 7h1v1h-1v-1z" })
            );
        }
        function Camera2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Camera2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Camera2.SVG = Camera2SVG;
        return Camera2;
    })();
export const Camera3 = /*#__PURE__*/ (() => {
    function Camera3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1h-10c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h10c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zM10.5 9c0 1.379-1.121 2.5-2.5 2.5s-2.5-1.121-2.5-2.5c0-0.817 0.394-1.544 1.002-2h2.997c0.608 0.456 1.002 1.183 1.002 2zM5 3h1v2h-1v-2zM3 3h1v2h-1v-2zM13 12.996c-0.001 0.001-0.002 0.003-0.004 0.004h-9.993c-0.001-0.001-0.003-0.002-0.004-0.004v-5.996h1.535c-0.34 0.588-0.535 1.271-0.535 2 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.729-0.195-1.412-0.535-2h1.535v5.996z" })
        );
    }
    function Camera3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Camera3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Camera3.SVG = Camera3SVG;
    return Camera3;
})();
export const Shutter = /*#__PURE__*/ (() => {
        function ShutterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.113 7l3.997-6.923c-0.363-0.050-0.733-0.077-1.11-0.077-2.183 0-4.161 0.875-5.605 2.292l2.718 4.708z" }),
_('path', { d: "M7.423 5h7.995c-0.925-2.284-2.873-4.043-5.276-4.71l-2.719 4.71z" }),
_('path', { d: "M5.691 10l-3.997-6.923c-1.061 1.357-1.694 3.066-1.694 4.923 0 0.691 0.087 1.361 0.252 2h5.439z" }),
_('path', { d: "M10.309 6l3.997 6.923c1.061-1.357 1.694-3.066 1.694-4.923 0-0.691-0.088-1.361-0.252-2h-5.439z" }),
_('path', { d: "M8.577 11h-7.995c0.925 2.284 2.873 4.043 5.276 4.71l2.719-4.71z" }),
_('path', { d: "M10.887 9l-3.997 6.923c0.363 0.050 0.733 0.077 1.11 0.077 2.183 0 4.161-0.875 5.605-2.292l-2.718-4.708z" })
            );
        }
        function Shutter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShutterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shutter.SVG = ShutterSVG;
        return Shutter;
    })();
export const Headphones = /*#__PURE__*/ (() => {
        function HeadphonesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z" }),
_('path', { d: "M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z" }),
_('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z" })
            );
        }
        function Headphones({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeadphonesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Headphones.SVG = HeadphonesSVG;
        return Headphones;
    })();
export const Headset = /*#__PURE__*/ (() => {
    function HeadsetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.95 2.050c-1.322-1.322-3.080-2.050-4.95-2.050s-3.628 0.728-4.95 2.050-2.050 3.080-2.050 4.95v3.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-2c0-0.828-0.672-1.5-1.5-1.5-0.168 0-0.329 0.028-0.479 0.079v-0.079c0.255-3.075 2.839-5.5 5.979-5.5s5.724 2.425 5.979 5.5v0.079c-0.15-0.051-0.311-0.079-0.479-0.079-0.828 0-1.5 0.672-1.5 1.5v2c0 0.828 0.672 1.5 1.5 1.5 0.175 0 0.344-0.030 0.5-0.086v1.586c0 0.276-0.224 0.5-0.5 0.5h-2.586c-0.206-0.583-0.761-1-1.414-1-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.653 0 1.208-0.417 1.414-1h2.586c0.827 0 1.5-0.673 1.5-1.5v-6.5c0-1.87-0.728-3.628-2.050-4.95z" })
        );
    }
    function Headset({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeadsetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Headset.SVG = HeadsetSVG;
    return Headset;
})();
export const Music = /*#__PURE__*/ (() => {
    function MusicSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.69 4.6c-1.36-1.91-1.232-0.561-2.55-4.37l-1.393-0.23-1.55 11.452c-3.494-1.999-5.698 0.054-5.14 2.639 0.296 1.37 2.522 2.661 4.716 1.387 1.037-0.623 1.37-1.628 1.502-2.341l1.107-8.498c3.951 3.484 2.69 5.592 1.873 8.019 1.68-0.693 4.311-3.748 1.436-8.059z" })
        );
    }
    function Music({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music.SVG = MusicSVG;
    return Music;
})();
export const Music2 = /*#__PURE__*/ (() => {
    function Music2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 3v8.241c-0.455-0.154-0.963-0.241-1.5-0.241-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-4.737l7-1.909v2.387c-0.455-0.154-0.963-0.241-1.5-0.241-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-11.5l-11 3zM7 7.208v-1.521l7-1.909v1.521l-7 1.909z" })
        );
    }
    function Music2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Music2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music2.SVG = Music2SVG;
    return Music2;
})();
export const Music3 = /*#__PURE__*/ (() => {
    function Music3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 3l11-3v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.537 0 1.045 0.086 1.5 0.241v-5.15l-7 1.909v7.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.537 0 1.045 0.086 1.5 0.241v-8.241z" })
        );
    }
    function Music3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Music3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music3.SVG = Music3SVG;
    return Music3;
})();
export const Music4 = /*#__PURE__*/ (() => {
    function Music4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0l-9 2v9.751c-0.635-0.463-1.521-0.751-2.5-0.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-6.46l8-1.778v4.488c-0.635-0.463-1.521-0.751-2.5-0.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-11.5h-1zM15 3.982l-8 1.778v-1.982l8-1.778v1.982z" })
        );
    }
    function Music4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Music4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music4.SVG = Music4SVG;
    return Music4;
})();
export const Music5 = /*#__PURE__*/ (() => {
    function Music5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z" })
        );
    }
    function Music5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Music5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music5.SVG = Music5SVG;
    return Music5;
})();
export const Music6 = /*#__PURE__*/ (() => {
    function Music6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0l-9 2v9.751c-0.635-0.463-1.521-0.751-2.5-0.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-6.46l8-1.778v4.488c-0.635-0.463-1.521-0.751-2.5-0.751-1.933 0-3.5 1.119-3.5 2.5s1.567 2.5 3.5 2.5 3.5-1.119 3.5-2.5v-11.5h-1zM3.5 14.813c-1.324 0-2.313-0.693-2.313-1.313s0.989-1.313 2.313-1.313 2.313 0.693 2.313 1.313-0.989 1.313-2.313 1.313zM12.5 12.813c-1.324 0-2.313-0.693-2.313-1.313s0.989-1.313 2.313-1.313 2.313 0.693 2.313 1.313-0.989 1.313-2.313 1.313zM15 3.982l-8 1.778v-1.982l8-1.778v1.982z" })
        );
    }
    function Music6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Music6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Music6.SVG = Music6SVG;
    return Music6;
})();
export const Album = /*#__PURE__*/ (() => {
        function AlbumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 4h-13c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h13c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM12 12.5c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-2.915l-4 1.429v3.786c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-4.201l6-2v6.5z" }),
_('path', { d: "M13.5 3h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 1h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Album({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlbumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Album.SVG = AlbumSVG;
        return Album;
    })();
export const Cassette = /*#__PURE__*/ (() => {
        function CassetteSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.86 12l-0.667 2h9.609l-0.663-2z" }),
_('path', { d: "M15.5 3h-15c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h1.64l0.886-2.658c0.068-0.204 0.259-0.342 0.474-0.342h9c0.216 0 0.407 0.138 0.475 0.343l0.881 2.657h1.644c0.276 0 0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5zM4 10c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2c0 1.105-0.895 2-2 2zM12 10c-1.105 0-2-0.895-2-2s0.895-2 2-2 2 0.895 2 2c0 1.105-0.895 2-2 2zM13.5 5h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M5 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M13 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Cassette({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CassetteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cassette.SVG = CassetteSVG;
        return Cassette;
    })();
export const Tape = /*#__PURE__*/ (() => {
    function TapeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 5c-1.933 0-3.5 1.567-3.5 3.5 0 0.537 0.121 1.045 0.337 1.5h-2.674c0.216-0.455 0.337-0.963 0.337-1.5 0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.933 1.567 3.5 3.5 3.5h9c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5zM2 8.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM12.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function Tape({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TapeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tape.SVG = TapeSVG;
    return Tape;
})();
export const Piano = /*#__PURE__*/ (() => {
    function PianoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h15v-16h-15zM3 15h-2v-14h1v10h1v4zM7 15h-3v-4h1v-10h1v10h1v4zM11 15h-3v-4h1v-10h1v10h1v4zM14 15h-2v-4h1v-10h1v14z" })
        );
    }
    function Piano({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PianoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Piano.SVG = PianoSVG;
    return Piano;
})();
export const Guitar = /*#__PURE__*/ (() => {
    function GuitarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.75 4l2.25-2c-0.189-1.010-0.99-1.811-2-2l-2 2.25v0.535l-2.835 2.835c-1.47-1.201-2.486-1.037-3.146-0.494-0.64 0.527-0.88 1.571-1.234 1.883-0.716 0.63-2.476-0.002-3.975 1.629-1.734 1.887-0.366 3.9 1.143 5.409s3.522 2.878 5.409 1.143c1.631-1.499 0.999-3.26 1.628-3.975 0.312-0.354 1.356-0.593 1.883-1.233 0.543-0.66 0.707-1.676-0.494-3.146l2.835-2.835h0.535zM4.58 13.42l-2-2 0.84-0.84 2 2-0.84 0.84zM7.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function Guitar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GuitarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Guitar.SVG = GuitarSVG;
    return Guitar;
})();
export const Trumpet = /*#__PURE__*/ (() => {
    function TrumpetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 3c-0.276 0-0.5 0.224-0.5 0.5 0 1.271-0.739 2.080-1.358 2.534-0.837 0.614-1.982 0.966-3.142 0.966h-0.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-4v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5h2.172c-0.111 0.313-0.172 0.649-0.172 1 0 1.654 1.346 3 3 3h3c1.654 0 3-1.346 3-3 0-0.289-0.041-0.568-0.118-0.833 0.654 0.161 1.262 0.433 1.76 0.799 0.62 0.454 1.358 1.263 1.358 2.534 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-9c0-0.276-0.224-0.5-0.5-0.5zM9 11h-3c-0.551 0-1-0.449-1-1s0.449-1 1-1h3c0.551 0 1 0.449 1 1s-0.449 1-1 1z" })
        );
    }
    function Trumpet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrumpetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trumpet.SVG = TrumpetSVG;
    return Trumpet;
})();
export const Speakers = /*#__PURE__*/ (() => {
        function SpeakersSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.5 0h-9c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8 1c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM8 15c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M8 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM8 12c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" }),
_('path', { d: "M9 3c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Speakers({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeakersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Speakers.SVG = SpeakersSVG;
        return Speakers;
    })();
export const Play = /*#__PURE__*/ (() => {
    function PlaySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.331 2.502c-2.244-0.323-4.724-0.502-7.331-0.502s-5.087 0.179-7.331 0.502c-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM6 11v-6l5 3-5 3z" })
        );
    }
    function Play({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Play.SVG = PlaySVG;
    return Play;
})();
export const Play2 = /*#__PURE__*/ (() => {
    function Play2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 5.654v4.692l4.064-2.346zM0 4v10h16v-10h-16zM15 13h-14v-1h14v1zM15 11h-14v-6h14v6z" })
        );
    }
    function Play2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Play2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Play2.SVG = Play2SVG;
    return Play2;
})();
export const ClapboardPlay = /*#__PURE__*/ (() => {
    function ClapboardPlaySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1.223 4.102l13.523-3.623 0.776 2.898-13.523 3.623zM2 7v9h14v-9h-14zM7 14v-5l4 2.5-4 2.5z" })
        );
    }
    function ClapboardPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClapboardPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ClapboardPlay.SVG = ClapboardPlaySVG;
    return ClapboardPlay;
})();
export const Clapboard = /*#__PURE__*/ (() => {
        function ClapboardSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 2c-0.552 0-1 0.448-1 1v4h16v-5h-15zM1 6v-0.5l2.5-2.5h2l-3 3h-1.5zM4.5 6l3-3h2l-3 3h-2zM8.5 6l3-3h2l-3 3h-2zM15 5.5l-0.5 0.5h-2l2.5-2.5v2z" }),
_('path', { d: "M0 8h16v8h-16v-8z" })
            );
        }
        function Clapboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ClapboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clapboard.SVG = ClapboardSVG;
        return Clapboard;
    })();
export const Media = /*#__PURE__*/ (() => {
        function MediaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 13.5c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-2.915l-4 1.429v3.786c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-4.201l6-2v6.5z" }),
_('path', { d: "M4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5z" }),
_('path', { d: "M8.5 1h-2.191l-0.362-0.724c-0.085-0.169-0.258-0.276-0.447-0.276h-2c-0.189 0-0.362 0.107-0.447 0.276l-0.362 0.724h-2.191c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h8c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM4.5 7c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5z" })
            );
        }
        function Media({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MediaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Media.SVG = MediaSVG;
        return Media;
    })();
export const Presentation = /*#__PURE__*/ (() => {
    function PresentationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.25 0h-13.5c-0.412 0-0.75 0.338-0.75 0.75v11.5c0 0.412 0.338 0.75 0.75 0.75h4.455l-2.040 2.040c-0.22 0.22-0.22 0.576 0 0.795 0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165l2.835-2.835h0.205v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h0.205l2.835 2.835c0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165c0.22-0.22 0.22-0.576 0-0.795l-2.040-2.040h4.455c0.412 0 0.75-0.338 0.75-0.75v-11.5c0-0.412-0.338-0.75-0.75-0.75zM6 3l4 2.5-4 2.5v-5zM12.5 11h-10c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
        );
    }
    function Presentation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PresentationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Presentation.SVG = PresentationSVG;
    return Presentation;
})();
export const Movie = /*#__PURE__*/ (() => {
    function MovieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 1.775c0.943 0 1.708 0.765 1.708 1.708s-0.765 1.708-1.708 1.708c-0.943 0-1.708-0.765-1.708-1.708s0.765-1.708 1.708-1.708zM1.806 6.48c0-0.943 0.765-1.708 1.708-1.708s1.708 0.765 1.708 1.708c0 0.943-0.765 1.708-1.708 1.708s-1.708-0.765-1.708-1.708zM5.288 13.208c-0.943 0-1.708-0.765-1.708-1.708s0.765-1.708 1.708-1.708c0.943 0 1.708 0.765 1.708 1.708s-0.765 1.708-1.708 1.708zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM10.712 13.218c-0.943 0-1.708-0.765-1.708-1.708s0.765-1.708 1.708-1.708c0.943 0 1.708 0.765 1.708 1.708s-0.765 1.708-1.708 1.708zM12.486 8.198c-0.943 0-1.708-0.765-1.708-1.708s0.765-1.708 1.708-1.708c0.943 0 1.708 0.765 1.708 1.708s-0.765 1.708-1.708 1.708z" })
        );
    }
    function Movie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MovieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Movie.SVG = MovieSVG;
    return Movie;
})();
export const Film = /*#__PURE__*/ (() => {
    function FilmSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM10 1h2v2h-2v-2zM7 1h2v2h-2v-2zM4 1h2v2h-2v-2zM1 1h2v2h-2v-2zM1 4h6v8h-6v-8zM3 15h-2v-2h2v2zM6 15h-2v-2h2v2zM9 15h-2v-2h2v2zM12 15h-2v-2h2v2zM15 15h-2v-2h2v2zM15 12h-7v-8h7v8zM15 3h-2v-2h2v2z" })
        );
    }
    function Film({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Film.SVG = FilmSVG;
    return Film;
})();
export const Film2 = /*#__PURE__*/ (() => {
    function Film2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v14h16v-14h-16zM3 14h-2v-2h2v2zM3 11h-2v-2h2v2zM3 7h-2v-2h2v2zM3 4h-2v-2h2v2zM12 14h-8v-5h8v5zM12 7h-8v-5h8v5zM15 14h-2v-2h2v2zM15 11h-2v-2h2v2zM15 7h-2v-2h2v2zM15 4h-2v-2h2v2z" })
        );
    }
    function Film2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Film2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Film2.SVG = Film2SVG;
    return Film2;
})();
export const Film3 = /*#__PURE__*/ (() => {
    function Film3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2z" })
        );
    }
    function Film3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Film3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Film3.SVG = Film3SVG;
    return Film3;
})();
export const Film4 = /*#__PURE__*/ (() => {
    function Film4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2zM6 5v6l4-3z" })
        );
    }
    function Film4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Film4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Film4.SVG = Film4SVG;
    return Film4;
})();
export const VideoCamera = /*#__PURE__*/ (() => {
    function VideoCameraSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM0 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM12 9.5v-1.5c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-1.5l4 2.5v-7l-4 2.5zM10 12h-8v-3h8v3z" })
        );
    }
    function VideoCamera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCameraSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCamera.SVG = VideoCameraSVG;
    return VideoCamera;
})();
export const VideoCamera2 = /*#__PURE__*/ (() => {
    function VideoCamera2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788z" })
        );
    }
    function VideoCamera2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCamera2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCamera2.SVG = VideoCamera2SVG;
    return VideoCamera2;
})();
export const VideoCameraSlash = /*#__PURE__*/ (() => {
        function VideoCameraSlashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.5 3c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.361 0.13 0.694 0.344 0.954l6.302-9.454h-5.147z" }),
_('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-0.265l1.389-2.084-1.248-0.832-10 15 1.248 0.832 1.944-2.916h6.932c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788z" })
            );
        }
        function VideoCameraSlash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VideoCameraSlashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VideoCameraSlash.SVG = VideoCameraSlashSVG;
        return VideoCameraSlash;
    })();
export const VideoCamera3 = /*#__PURE__*/ (() => {
    function VideoCamera3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788zM4 11v-6l5 3-5 3z" })
        );
    }
    function VideoCamera3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCamera3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCamera3.SVG = VideoCamera3SVG;
    return VideoCamera3;
})();
export const VideoCamera4 = /*#__PURE__*/ (() => {
    function VideoCamera4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788zM15 10.743l-2.469-1.743h-1.531v2.5c0 0.271-0.229 0.5-0.5 0.5h-9c-0.271 0-0.5-0.229-0.5-0.5v-7c0-0.271 0.229-0.5 0.5-0.5h9c0.271 0 0.5 0.229 0.5 0.5v2.5h1.531l2.469-1.743v5.486z" })
        );
    }
    function VideoCamera4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCamera4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCamera4.SVG = VideoCamera4SVG;
    return VideoCamera4;
})();
export const VideoCameraSlash2 = /*#__PURE__*/ (() => {
    function VideoCameraSlash2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-0.213l1.617-2.204c0.163-0.223 0.115-0.536-0.107-0.699s-0.536-0.115-0.699 0.107l-2.050 2.796h-7.547c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h0.213l-1.617 2.204c-0.163 0.223-0.115 0.536 0.107 0.699 0.089 0.065 0.193 0.097 0.295 0.097 0.154 0 0.306-0.071 0.404-0.204l2.050-2.796h7.547c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788zM1.5 12c-0.271 0-0.5-0.229-0.5-0.5v-7c0-0.271 0.229-0.5 0.5-0.5h6.813l-5.867 8h-0.947zM15 10.743l-2.469-1.743h-1.531v2.5c0 0.271-0.229 0.5-0.5 0.5h-6.813l5.867-8h0.947c0.271 0 0.5 0.229 0.5 0.5v2.5h1.531l2.469-1.743v5.486z" })
        );
    }
    function VideoCameraSlash2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VideoCameraSlash2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VideoCameraSlash2.SVG = VideoCameraSlash2SVG;
    return VideoCameraSlash2;
})();
export const VideoCamera5 = /*#__PURE__*/ (() => {
        function VideoCamera5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788zM15 10.743l-2.469-1.743h-1.531v2.5c0 0.271-0.229 0.5-0.5 0.5h-9c-0.271 0-0.5-0.229-0.5-0.5v-7c0-0.271 0.229-0.5 0.5-0.5h9c0.271 0 0.5 0.229 0.5 0.5v2.5h1.531l2.469-1.743v5.486z" }),
_('path', { d: "M4 5l5 3-5 3z" })
            );
        }
        function VideoCamera5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VideoCamera5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VideoCamera5.SVG = VideoCamera5SVG;
        return VideoCamera5;
    })();
export const Recording = /*#__PURE__*/ (() => {
        function RecordingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z" }),
_('path', { d: "M9.5 10c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-2h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-2h2.5z" }),
_('path', { d: "M4 11c0-1.103-0.897-2-2-2h-1.5c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h0.691l1.362 2.724c0.088 0.175 0.264 0.277 0.448 0.277 0.075 0 0.151-0.017 0.223-0.053 0.247-0.123 0.347-0.424 0.224-0.671l-1.209-2.418c0.738-0.294 1.262-1.016 1.262-1.858zM2 12h-1v-2h1c0.551 0 1 0.449 1 1s-0.449 1-1 1z" }),
_('path', { d: "M15.5 15h-1.5c-0.551 0-1-0.449-1-1v-3c0-0.551 0.449-1 1-1h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5c-1.103 0-2 0.897-2 2v3c0 1.103 0.897 2 2 2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Recording({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RecordingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Recording.SVG = RecordingSVG;
        return Recording;
    })();
export const Dice = /*#__PURE__*/ (() => {
    function DiceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 3h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.375 1.125 2.5 2.5 2.5h8c1.375 0 2.5-1.125 2.5-2.5v-8c0-1.375-1.125-2.5-2.5-2.5zM6.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM9.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.949 2c-0.233-1.138-1.245-2-2.449-2h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.204 0.862 2.216 2 2.449v-9.949c0-0.55 0.45-1 1-1h9.949z" })
        );
    }
    function Dice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DiceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dice.SVG = DiceSVG;
    return Dice;
})();
export const Gamepad = /*#__PURE__*/ (() => {
    function GamepadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 5h-1v1h-1v1h1v1h1v-1h1v-1h-1zM10 5.75c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75zM11.5 7.25c0-0.414 0.336-0.75 0.75-0.75s0.75 0.336 0.75 0.75c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75zM11.554 2.685c-1.816 0-2.099 1.076-3.554 1.076s-1.738-1.076-3.554-1.076c-2.929 0-4.446 3.586-4.446 6.15 0 2.427 0.228 4.192 1.136 4.44s2.065-0.731 3.193-1.793c1.128-1.062 1.318-0.993 2.226-0.993l1.445 0.032 1.445-0.032c0.908 0 1.098-0.069 2.226 0.993s2.285 2.041 3.193 1.793c0.908-0.248 1.136-2.014 1.136-4.44 0-2.565-1.517-6.15-4.446-6.15zM4.5 9c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 9c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z" })
        );
    }
    function Gamepad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GamepadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gamepad.SVG = GamepadSVG;
    return Gamepad;
})();
export const Gamepad2 = /*#__PURE__*/ (() => {
    function Gamepad2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.873 4.935c-0.406-0.663-0.89-1.188-1.439-1.561-0.626-0.425-1.321-0.641-2.063-0.641-1.017 0-1.588 0.322-2.092 0.606-0.411 0.231-0.735 0.414-1.278 0.414s-0.867-0.183-1.278-0.414c-0.504-0.284-1.075-0.606-2.092-0.606-0.743 0-1.437 0.216-2.063 0.641-0.549 0.373-1.034 0.898-1.44 1.561-0.706 1.152-1.127 2.664-1.127 4.044 0 1.326 0.072 2.269 0.225 2.969 0.209 0.949 0.587 1.486 1.157 1.641 0.125 0.034 0.258 0.052 0.393 0.052 0.982 0 2.035-0.914 3.029-1.849 0.881-0.829 1.037-0.829 1.553-0.829 0.039 0 0.080 0 0.123 0 0.046 0 0.095 0 0.145 0l1.375 0.030 1.375-0.030c0.051 0 0.099-0 0.145-0 0.043-0 0.083-0 0.123-0 0.517 0 0.673 0 1.553 0.829 0.994 0.936 2.046 1.849 3.029 1.849 0 0 0 0 0 0 0.135 0 0.267-0.017 0.392-0.052 0.57-0.156 0.949-0.693 1.157-1.641 0.154-0.7 0.225-1.643 0.225-2.969 0-1.38-0.421-2.892-1.127-4.044zM14.798 11.734c-0.111 0.505-0.281 0.847-0.444 0.892-0.039 0.011-0.082 0.016-0.128 0.016-0.668-0-1.799-1.065-2.343-1.577-0.532-0.502-0.847-0.745-1.162-0.897-0.42-0.204-0.769-0.204-1.077-0.204-0.041 0-0.084 0-0.128 0s-0.091 0-0.14 0h-0.011l-1.364 0.030-1.375-0.030c-0.049 0-0.095-0-0.14-0s-0.087-0-0.128-0c-0.308 0-0.656 0-1.077 0.204-0.315 0.153-0.63 0.396-1.162 0.897-0.544 0.512-1.675 1.577-2.343 1.577-0.046 0-0.089-0.005-0.129-0.016-0.162-0.044-0.332-0.386-0.443-0.891-0.138-0.627-0.202-1.502-0.202-2.754 0-0.588 0.091-1.223 0.262-1.839 0.171-0.614 0.419-1.196 0.718-1.683 0.331-0.541 0.718-0.964 1.149-1.256 0.457-0.311 0.963-0.468 1.502-0.468 0.755 0 1.147 0.221 1.602 0.477 0.452 0.254 0.963 0.543 1.769 0.543s1.317-0.288 1.768-0.543c0.454-0.256 0.846-0.477 1.601-0.477 0.539 0 1.044 0.158 1.502 0.468 0.431 0.293 0.817 0.715 1.149 1.256 0.299 0.488 0.547 1.070 0.718 1.683 0.171 0.615 0.262 1.251 0.262 1.839-0 1.251-0.064 2.127-0.202 2.754v0zM10 6c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM12 8c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM4 5c-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2-0.897-2-2-2v0z" })
        );
    }
    function Gamepad2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Gamepad2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gamepad2.SVG = Gamepad2SVG;
    return Gamepad2;
})();
export const Gamepad3 = /*#__PURE__*/ (() => {
    function Gamepad3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 20 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 20 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 3.025v-0.025h-10.5c-2.761 0-5 2.239-5 5s2.239 5 5 5c1.636 0 3.088-0.786 4-2h2c0.912 1.214 2.364 2 4 2 2.761 0 5-2.239 5-5 0-2.593-1.973-4.724-4.5-4.975zM8 9h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2zM14 9c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM17 9c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1c0 0.552-0.448 1-1 1z" })
        );
    }
    function Gamepad3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Gamepad3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gamepad3.SVG = Gamepad3SVG;
    return Gamepad3;
})();
export const Pacman = /*#__PURE__*/ (() => {
    function PacmanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.074 2.794c-1.467-1.71-3.644-2.794-6.074-2.794-4.418 0-8 3.582-8 8s3.582 8 8 8c2.43 0 4.607-1.084 6.074-2.794l-5.074-5.206 5.074-5.206zM11 1.884c0.616 0 1.116 0.499 1.116 1.116s-0.499 1.116-1.116 1.116-1.116-0.499-1.116-1.116c0-0.616 0.499-1.116 1.116-1.116z" })
        );
    }
    function Pacman({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PacmanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pacman.SVG = PacmanSVG;
    return Pacman;
})();
export const Spades = /*#__PURE__*/ (() => {
    function SpadesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.775 5.44c-3.024-2.248-4.067-4.047-4.774-5.44v0c-0 0-0-0-0-0v0c-0.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-0.303 9.182 3.965 6.238-0.278 1.827-1.227 3.159-2.191 3.733v0.59h6v-0.59c-0.964-0.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z" })
        );
    }
    function Spades({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpadesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spades.SVG = SpadesSVG;
    return Spades;
})();
export const Clubs = /*#__PURE__*/ (() => {
    function ClubsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.294 6.137c-0.922 0-1.751 0.384-2.341 1.011-0.25 0.265-0.684 0.58-1.153 0.856 0.22-0.842 0.917-1.902 1.4-2.367 0.619-0.596 1-1.435 1-2.367 0-1.795-1.429-3.252-3.2-3.271-1.771 0.019-3.2 1.475-3.2 3.271 0 0.932 0.38 1.771 1 2.367 0.484 0.465 1.18 1.525 1.4 2.367-0.469-0.277-0.903-0.591-1.153-0.856-0.59-0.627-1.419-1.011-2.341-1.011-1.787 0-3.236 1.463-3.236 3.271s1.448 3.271 3.236 3.271c0.923 0 1.751-0.396 2.341-1.023 0.263-0.279 0.726-0.627 1.223-0.916-0.047 2.308-1.149 4.003-2.271 4.67v0.59h6v-0.59c-1.122-0.668-2.224-2.363-2.271-4.67 0.498 0.289 0.961 0.637 1.223 0.916 0.59 0.626 1.419 1.023 2.341 1.023 1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z" })
        );
    }
    function Clubs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClubsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clubs.SVG = ClubsSVG;
    return Clubs;
})();
export const Diamonds = /*#__PURE__*/ (() => {
    function DiamondsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0l-5 8 5 8 5-8z" })
        );
    }
    function Diamonds({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DiamondsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamonds.SVG = DiamondsSVG;
    return Diamonds;
})();
export const ChessKing = /*#__PURE__*/ (() => {
    function ChessKingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.22 4.148c-0.527-0.527-1.252-0.78-2.055-0.78-1.076 0-2.294 0.455-3.368 1.314-0.254-0.778-0.726-1.367-1.297-1.588v-1.095h1.5v-1h-1.5v-1h-1v1h-1.5v1h1.5v1.095c-0.571 0.22-1.043 0.809-1.297 1.588-1.074-0.859-2.291-1.314-3.368-1.314-0.803 0-1.527 0.253-2.055 0.78-1.367 1.367-0.892 4.058 1.061 6.010 0.365 0.365 0.756 0.678 1.159 0.937v1.465c1.37 0.275 3.108 0.439 5 0.439s3.63-0.164 5-0.439v-1.465c0.403-0.259 0.794-0.572 1.159-0.937 1.953-1.953 2.427-4.644 1.061-6.010zM2.548 5.916c0.017-0.011 0.107-0.048 0.287-0.048h0c0.498 0 1.369 0.29 2.188 1.109 0.54 0.54 0.927 1.193 1.061 1.791 0.096 0.427 0.024 0.648-0 0.683-0.017 0.011-0.107 0.048-0.287 0.048-0.498 0-1.369-0.29-2.188-1.109-0.54-0.54-0.927-1.193-1.061-1.792-0.096-0.427-0.024-0.648 0-0.683zM13.452 6.6c-0.134 0.598-0.521 1.251-1.061 1.791-0.819 0.819-1.69 1.109-2.188 1.109-0.18 0-0.27-0.037-0.287-0.048-0.024-0.035-0.096-0.256-0-0.683 0.134-0.598 0.521-1.251 1.061-1.792 0.819-0.819 1.69-1.109 2.188-1.109 0.18 0 0.27 0.037 0.287 0.048 0.024 0.035 0.096 0.256 0 0.683zM3 14.088v1.473c1.37 0.275 3.108 0.439 5 0.439s3.63-0.164 5-0.439v-1.473c-1.466 0.27-3.187 0.412-5 0.412s-3.534-0.142-5-0.412z" })
        );
    }
    function ChessKing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessKingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessKing.SVG = ChessKingSVG;
    return ChessKing;
})();
export const ChessQueen = /*#__PURE__*/ (() => {
    function ChessQueenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 15c-1.79 0-3.528-0.155-4.891-0.437-0.037-0.008-0.073-0.015-0.109-0.023v1.021c1.37 0.274 3.108 0.439 5 0.439s3.63-0.164 5-0.439v-1.021c-0.036 0.008-0.072 0.015-0.109 0.023-1.364 0.282-3.101 0.437-4.891 0.437zM12 13.469v-0.469l-0.5-1h-7l-0.5 1v0.469c1.177 0.17 2.543 0.268 4 0.268s2.823-0.097 4-0.268zM15.649 4.401c-0.469-0.469-1.228-0.469-1.697 0-0.398 0.398-0.458 1.005-0.181 1.466l-3.052 1.831 0.602-2.839c0.526 0.112 1.081-0.143 1.327-0.648 0.291-0.596 0.043-1.314-0.553-1.605s-1.314-0.043-1.605 0.553c-0.247 0.505-0.106 1.099 0.307 1.445l-1.847 2.198-0.659-2.638c0.522-0.13 0.909-0.602 0.909-1.164 0-0.663-0.537-1.2-1.2-1.2s-1.2 0.537-1.2 1.2c0 0.562 0.387 1.034 0.909 1.164l-0.659 2.638-1.847-2.198c0.412-0.346 0.553-0.939 0.307-1.445-0.291-0.596-1.009-0.843-1.605-0.553s-0.843 1.009-0.552 1.605c0.247 0.505 0.801 0.76 1.327 0.648l0.602 2.839-3.052-1.831c0.277-0.461 0.217-1.068-0.181-1.466-0.469-0.469-1.228-0.469-1.697 0s-0.469 1.228 0 1.697c0.398 0.398 1.005 0.458 1.466 0.181l2.833 4.722h6.699l2.833-4.722c0.461 0.277 1.068 0.217 1.466-0.181 0.469-0.469 0.469-1.228 0-1.697z" })
        );
    }
    function ChessQueen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessQueenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessQueen.SVG = ChessQueenSVG;
    return ChessQueen;
})();
export const ChessRook = /*#__PURE__*/ (() => {
    function ChessRookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 4.5h9v8h-9zM12 4l2-2v-2h-2v1h-3v-1h-3v1h-3v-1h-2v2l2 2h9zM12 2.5l-0.5 0.5h-8l-0.5-0.5h9zM2 13h11v1h-11zM14 14.5h-13c0 0-0.766 0.5-1 1.5h15c-0.234-1-1-1.5-1-1.5z" })
        );
    }
    function ChessRook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessRookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessRook.SVG = ChessRookSVG;
    return ChessRook;
})();
export const ChessBishop = /*#__PURE__*/ (() => {
    function ChessBishopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.4 12h-9.8c0.463 1.141 2.481 2 4.9 2s4.437-0.859 4.9-2zM0 16h1.406c0-0.040 0.044-0.175 0.174-0.314s0.257-0.186 0.295-0.186h4.219c0.835-0.016 1.406-0.984 1.406-1.5 0 0-4.688 0-5.625 0s-1.875 1-1.875 2zM13.125 14c-0.938 0-5.625 0-5.625 0 0 0.516 0.571 1.484 1.406 1.5h4.219c0.038 0 0.164 0.047 0.295 0.186s0.174 0.274 0.174 0.314h1.406c0-1-0.938-2-1.875-2zM7.5 11h4.9c-0.203-0.5-0.705-0.946-1.409-1.29 0.324-0.438 0.509-1.001 0.509-1.71 0-2.515-1.827-4.15-3.105-4.746 0.512-0.305 0.855-0.864 0.855-1.504 0-0.967-0.784-1.75-1.75-1.75s-1.75 0.783-1.75 1.75c0 0.639 0.343 1.198 0.855 1.504-1.278 0.597-3.105 2.232-3.105 4.746 0 0.71 0.185 1.273 0.509 1.71-0.704 0.343-1.206 0.789-1.409 1.29h4.9c0 0 0 0 0 0zM5 7v-1h2v-2h1v2h2v1h-2v2h-1v-2h-2z" })
        );
    }
    function ChessBishop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessBishopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessBishop.SVG = ChessBishopSVG;
    return ChessBishop;
})();
export const ChessKnight = /*#__PURE__*/ (() => {
    function ChessKnightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 15h-11.5l-0.5 1h12.5zM8.867 8c0.21 3.248-2.649 4.524-3.635 6.5h9.768c0-1.119 0-2.905 0-5.5 0-3.474-1.361-5.982-2.967-7.19-0.074-0.315-0.186-0.664-0.311-0.947l-0.193-0.438c-0.222-0.503-0.692-0.57-1.045-0.148l-0.604 0.722c-0.004-0-0.009-0-0.013-0-0.257 0-0.494 0.008-0.714 0.023l-1.321-0.881c-0.458-0.305-0.832-0.105-0.832 0.445v1.018c-0.406 0.23-0.746 0.508-1.133 0.803-1 0.762-3.404 3.783-5 5.591-1.476 1.672-0.679 3 0.719 2.688-0.070 1.313 1.024 0.891 1.781 0.313 1.747-1.333 5.649-0.703 5.5-3zM12.108 2.704c0.539 0.546 1.005 1.244 1.367 2.055 0.556 1.246 0.838 2.672 0.838 4.241v4.5l-1.5-1.5v-3c0-1.357-0.238-2.578-0.707-3.63-0.288-0.645-0.648-1.19-1.057-1.605l1.061-1.061zM2.5 9.207c-0.391 0-0.707-0.317-0.707-0.707s0.317-0.707 0.707-0.707c0.39 0 0.707 0.317 0.707 0.707s-0.317 0.707-0.707 0.707zM7.53 4.499c-0.586 0.586-1.298 0.823-1.591 0.53s-0.055-1.005 0.53-1.591 1.298-0.823 1.591-0.53c0.293 0.293 0.055 1.005-0.53 1.591z" })
        );
    }
    function ChessKnight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessKnightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessKnight.SVG = ChessKnightSVG;
    return ChessKnight;
})();
export const ChessPawn = /*#__PURE__*/ (() => {
    function ChessPawnSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 9.937c0.318-0.574 0.5-1.234 0.5-1.937 0-1.614-0.956-3.005-2.333-3.637 0.511-0.458 0.833-1.123 0.833-1.863 0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5c0 0.74 0.322 1.405 0.833 1.863-1.377 0.632-2.333 2.023-2.333 3.637 0 0.703 0.181 1.363 0.5 1.937-2.092 1.21-3.5 3.472-3.5 6.063h14c0-2.591-1.408-4.853-3.5-6.063z" })
        );
    }
    function ChessPawn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessPawnSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ChessPawn.SVG = ChessPawnSVG;
    return ChessPawn;
})();
export const Chess = /*#__PURE__*/ (() => {
    function ChessSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h2v2h-2zM14 4h2v2h-2zM14 8h2v2h-2zM14 12h2v2h-2zM12 2h2v2h-2zM12 6h2v2h-2zM12 10h2v2h-2zM12 14h2v2h-2zM10 0h2v2h-2zM10 4h2v2h-2zM10 8h2v2h-2zM10 12h2v2h-2zM8 2h2v2h-2zM8 6h2v2h-2zM8 10h2v2h-2zM8 14h2v2h-2zM6 0h2v2h-2zM6 4h2v2h-2zM6 8h2v2h-2zM6 12h2v2h-2zM4 2h2v2h-2zM4 6h2v2h-2zM4 10h2v2h-2zM4 14h2v2h-2zM2 0h2v2h-2zM2 4h2v2h-2zM2 8h2v2h-2zM2 12h2v2h-2zM0 2h2v2h-2zM0 6h2v2h-2zM0 10h2v2h-2zM0 14h2v2h-2z" })
        );
    }
    function Chess({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChessSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chess.SVG = ChessSVG;
    return Chess;
})();
export const Bullhorn = /*#__PURE__*/ (() => {
    function BullhornSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.707c0-3.139-0.919-5.687-2.054-5.707 0.005-0 0.009-0 0.014-0h-1.296c0 0-3.044 2.287-7.425 3.184-0.134 0.708-0.219 1.551-0.219 2.523s0.085 1.816 0.219 2.523c4.382 0.897 7.425 3.184 7.425 3.184h1.296c-0.005 0-0.009-0-0.014-0.001 1.136-0.020 2.054-2.567 2.054-5.707zM13.513 11.551c-0.147 0-0.305-0.152-0.387-0.243-0.197-0.22-0.387-0.562-0.55-0.989-0.363-0.957-0.564-2.239-0.564-3.611s0.2-2.655 0.564-3.611c0.162-0.428 0.353-0.77 0.55-0.99 0.081-0.091 0.24-0.243 0.387-0.243s0.305 0.152 0.387 0.243c0.197 0.22 0.387 0.562 0.55 0.99 0.363 0.957 0.564 2.239 0.564 3.611s-0.2 2.655-0.564 3.611c-0.162 0.428-0.353 0.77-0.55 0.989-0.081 0.091-0.24 0.243-0.387 0.243zM3.935 6.707c0-0.812 0.060-1.6 0.173-2.33-0.74 0.102-1.39 0.161-2.193 0.161-1.048 0-1.048 0-1.048 0l-0.867 1.479v1.378l0.867 1.479c0 0 0 0 1.048 0 0.803 0 1.453 0.059 2.193 0.161-0.113-0.729-0.173-1.518-0.173-2.33zM5.752 10.034l-2-0.383 1.279 5.024c0.066 0.26 0.324 0.391 0.573 0.291l1.852-0.741c0.249-0.1 0.349-0.374 0.222-0.611l-1.926-3.581zM13.513 8.574c-0.057 0-0.118-0.059-0.149-0.094-0.076-0.085-0.149-0.217-0.212-0.381-0.14-0.369-0.217-0.863-0.217-1.392s0.077-1.023 0.217-1.392c0.063-0.165 0.136-0.297 0.212-0.381 0.031-0.035 0.092-0.094 0.149-0.094s0.118 0.059 0.149 0.094c0.076 0.085 0.149 0.217 0.212 0.381 0.14 0.369 0.217 0.863 0.217 1.392s-0.077 1.023-0.217 1.392c-0.063 0.165-0.136 0.297-0.212 0.381-0.031 0.035-0.092 0.094-0.149 0.094z" })
        );
    }
    function Bullhorn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BullhornSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bullhorn.SVG = BullhornSVG;
    return Bullhorn;
})();
export const Megaphone = /*#__PURE__*/ (() => {
    function MegaphoneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 6h-2v5h2v-1l2 0.572c-0 0.008-0 0.015-0 0.023v1.406c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-0.286l5 1.429v-9.286l-11 3.143v-1zM5 10.857l1.998 0.571v0.572h-1.998v-1.143zM14 3.571v9.857l2 0.571v-11z" })
        );
    }
    function Megaphone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MegaphoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Megaphone.SVG = MegaphoneSVG;
    return Megaphone;
})();
export const New = /*#__PURE__*/ (() => {
    function NewSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 3h-12c-1.1 0-2 0.9-2 2v7c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-7c0-1.1-0.9-2-2-2zM5 11h-1l-2-3.333v3.333h-1v-5h1l2 3.333v-3.333h1v5zM9 7h-2v1h2v1h-2v1h2v1l-3 0v-5h3v1zM15 11h-1.5l-1-2-1 2h-1.5v-5h1v4l1-2h1l1 2v-4h1v5z" })
        );
    }
    function New({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NewSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    New.SVG = NewSVG;
    return New;
})();
export const Connection = /*#__PURE__*/ (() => {
    function ConnectionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 20 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 20 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759zM2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414zM15.45 2.101c1.667 0.705 3.164 1.715 4.45 3v0l-1.414 1.414c-2.267-2.266-5.28-3.515-8.485-3.515s-6.219 1.248-8.485 3.515l-1.414-1.414c1.285-1.285 2.783-2.295 4.45-3 1.727-0.73 3.56-1.101 5.45-1.101s3.723 0.37 5.45 1.101zM9 14c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z" })
        );
    }
    function Connection({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConnectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Connection.SVG = ConnectionSVG;
    return Connection;
})();
export const Connection2 = /*#__PURE__*/ (() => {
        function Connection2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759v0z" }),
_('path', { d: "M2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414z" }),
_('path', { d: "M9 14c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z" }),
_('path', { d: "M13.125 3.409c0.084 0.022 0.167 0.046 0.25 0.070v-2.070c-0.083-0.021-0.166-0.041-0.25-0.060v2.060z" }),
_('path', { d: "M12.625 3.286c0.084 0.019 0.167 0.038 0.25 0.058v-2.050c-0.083-0.017-0.166-0.034-0.25-0.050v2.041z" }),
_('path', { d: "M14.625 3.92c0.084 0.035 0.167 0.071 0.25 0.108v-2.155c-0.083-0.031-0.166-0.061-0.25-0.091v2.138z" }),
_('path', { d: "M13.625 3.554c0.084 0.026 0.167 0.054 0.25 0.082v-2.094c-0.083-0.024-0.166-0.047-0.25-0.070v2.081z" }),
_('path', { d: "M14.125 3.725c0.084 0.031 0.167 0.062 0.25 0.095v-2.122c-0.083-0.027-0.166-0.054-0.25-0.080v2.107z" }),
_('path', { d: "M11.125 3.052c0.084 0.008 0.167 0.016 0.25 0.026v-2.011c-0.083-0.008-0.167-0.015-0.25-0.022v2.007z" }),
_('path', { d: "M10.125 3.001c0.083 0.001 0.167 0.003 0.25 0.005v-2.001c-0.083-0.002-0.167-0.004-0.25-0.004v2z" }),
_('path', { d: "M12.125 3.187c0.084 0.015 0.167 0.030 0.25 0.047v-2.034c-0.083-0.014-0.166-0.028-0.25-0.040v2.027z" }),
_('path', { d: "M11.625 3.108c0.084 0.011 0.167 0.023 0.25 0.036v-2.021c-0.083-0.011-0.167-0.022-0.25-0.031v2.015z" }),
_('path', { d: "M10.625 3.016c0.084 0.004 0.167 0.009 0.25 0.015v-2.005c-0.083-0.005-0.167-0.009-0.25-0.013v2.002z" }),
_('path', { d: "M19.125 5.875l0.25-0.25v-1.023c-0.083-0.075-0.166-0.148-0.25-0.221v1.493z" }),
_('path', { d: "M18.625 6.375l0.25-0.25v-1.954c-0.083-0.068-0.166-0.135-0.25-0.201v2.405z" }),
_('path', { d: "M18.125 6.169c0.084 0.078 0.168 0.157 0.25 0.237v-2.627c-0.083-0.062-0.166-0.123-0.25-0.183v2.573z" }),
_('path', { d: "M19.625 4.834v0.541l0.25-0.25v-0.049c-0.082-0.082-0.166-0.163-0.25-0.243z" }),
_('path', { d: "M15.125 1.968v2.175c0.084 0.040 0.167 0.080 0.25 0.122v-2.195c-0.083-0.035-0.166-0.069-0.25-0.102z" }),
_('path', { d: "M15.625 4.394c0.084 0.045 0.167 0.090 0.25 0.137v-2.242c-0.083-0.038-0.166-0.076-0.25-0.113v2.217z" }),
_('path', { d: "M16.125 4.675c0.084 0.050 0.167 0.101 0.25 0.153v-2.296c-0.083-0.042-0.166-0.084-0.25-0.124v2.268z" }),
_('path', { d: "M17.125 5.341c0.084 0.062 0.167 0.126 0.25 0.19v-2.435c-0.083-0.051-0.166-0.102-0.25-0.151v2.396z" }),
_('path', { d: "M17.625 5.733c0.084 0.069 0.167 0.14 0.25 0.212v-2.523c-0.083-0.056-0.166-0.112-0.25-0.166v2.477z" }),
_('path', { d: "M16.625 4.99c0.084 0.056 0.167 0.113 0.25 0.171v-2.36c-0.083-0.047-0.166-0.093-0.25-0.138v2.327z" }),
_('path', { d: "M3.125 5.161c0.083-0.058 0.166-0.115 0.25-0.171v-2.327c-0.084 0.045-0.167 0.091-0.25 0.138v2.36z" }),
_('path', { d: "M9.625 3.006c0.083-0.003 0.167-0.004 0.25-0.005v-2c-0.083 0.001-0.167 0.002-0.25 0.004v2.001z" }),
_('path', { d: "M3.625 4.829c0.083-0.052 0.166-0.103 0.25-0.153v-2.268c-0.084 0.041-0.167 0.082-0.25 0.124v2.296z" }),
_('path', { d: "M2.125 5.945c0.083-0.072 0.166-0.143 0.25-0.212v-2.477c-0.084 0.055-0.167 0.11-0.25 0.166v2.523z" }),
_('path', { d: "M4.125 2.289v2.242c0.083-0.047 0.166-0.092 0.25-0.137v-2.217c-0.084 0.037-0.167 0.074-0.25 0.113z" }),
_('path', { d: "M0.125 5.125l0.25 0.25v-0.542c-0.084 0.080-0.168 0.161-0.25 0.243v0.049z" }),
_('path', { d: "M1.625 6.406c0.082-0.080 0.166-0.159 0.25-0.237v-2.573c-0.084 0.060-0.167 0.121-0.25 0.183v2.627z" }),
_('path', { d: "M4.625 4.264c0.083-0.042 0.166-0.082 0.25-0.122v-2.175c-0.084 0.033-0.167 0.067-0.25 0.102v2.195z" }),
_('path', { d: "M0.625 5.625l0.25 0.25v-1.493c-0.084 0.072-0.167 0.146-0.25 0.221v1.023z" }),
_('path', { d: "M1.125 6.125l0.25 0.25v-2.405c-0.084 0.066-0.167 0.133-0.25 0.201v1.954z" }),
_('path', { d: "M2.625 5.532c0.083-0.065 0.166-0.128 0.25-0.19v-2.396c-0.084 0.050-0.167 0.1-0.25 0.151v2.435z" }),
_('path', { d: "M5.125 4.028c0.083-0.037 0.166-0.073 0.25-0.108v-2.138c-0.084 0.029-0.167 0.060-0.25 0.091v2.155z" }),
_('path', { d: "M8.625 3.078c0.083-0.009 0.166-0.018 0.25-0.026v-2.007c-0.083 0.007-0.167 0.014-0.25 0.022v2.011z" }),
_('path', { d: "M9.125 3.031c0.083-0.006 0.166-0.011 0.25-0.015v-2.002c-0.083 0.004-0.167 0.008-0.25 0.013v2.005z" }),
_('path', { d: "M7.625 3.234c0.083-0.017 0.166-0.032 0.25-0.047v-2.027c-0.083 0.013-0.167 0.026-0.25 0.040v2.034z" }),
_('path', { d: "M8.125 3.145c0.083-0.013 0.166-0.025 0.25-0.036v-2.015c-0.083 0.010-0.167 0.020-0.25 0.031v2.021z" }),
_('path', { d: "M6.125 3.637c0.083-0.028 0.166-0.056 0.25-0.082v-2.081c-0.084 0.022-0.167 0.046-0.25 0.070v2.093z" }),
_('path', { d: "M5.625 3.819c0.083-0.032 0.166-0.064 0.25-0.095v-2.107c-0.084 0.026-0.167 0.053-0.25 0.080v2.122z" }),
_('path', { d: "M7.125 3.345c0.083-0.020 0.166-0.040 0.25-0.058v-2.041c-0.083 0.016-0.167 0.033-0.25 0.050v2.050z" }),
_('path', { d: "M6.625 3.479c0.083-0.024 0.166-0.047 0.25-0.070v-2.060c-0.084 0.019-0.167 0.039-0.25 0.060v2.070z" })
            );
        }
        function Connection2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Connection2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Connection2.SVG = Connection2SVG;
        return Connection2;
    })();
export const Connection3 = /*#__PURE__*/ (() => {
        function Connection3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759v0z" }),
_('path', { d: "M9 14c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z" }),
_('path', { d: "M13.125 3.409c0.084 0.022 0.167 0.046 0.25 0.070v-2.070c-0.083-0.021-0.166-0.041-0.25-0.060v2.060z" }),
_('path', { d: "M12.625 3.286c0.084 0.019 0.167 0.038 0.25 0.058v-2.050c-0.083-0.017-0.166-0.034-0.25-0.050v2.041z" }),
_('path', { d: "M14.625 3.92c0.084 0.035 0.167 0.071 0.25 0.108v-2.155c-0.083-0.031-0.166-0.061-0.25-0.091v2.138z" }),
_('path', { d: "M13.625 3.554c0.084 0.026 0.167 0.054 0.25 0.082v-2.094c-0.083-0.024-0.166-0.047-0.25-0.070v2.081z" }),
_('path', { d: "M14.125 3.725c0.084 0.031 0.167 0.062 0.25 0.095v-2.122c-0.083-0.027-0.166-0.054-0.25-0.080v2.107z" }),
_('path', { d: "M11.125 3.052c0.084 0.008 0.167 0.016 0.25 0.026v-2.011c-0.083-0.008-0.167-0.015-0.25-0.022v2.007z" }),
_('path', { d: "M10.125 3.001c0.083 0.001 0.167 0.003 0.25 0.005v-2.001c-0.083-0.002-0.167-0.004-0.25-0.004v2z" }),
_('path', { d: "M12.125 3.187c0.084 0.015 0.167 0.030 0.25 0.047v-2.034c-0.083-0.014-0.166-0.028-0.25-0.040v2.027z" }),
_('path', { d: "M11.625 3.108c0.084 0.011 0.167 0.023 0.25 0.036v-2.021c-0.083-0.011-0.167-0.022-0.25-0.031v2.015z" }),
_('path', { d: "M10.625 3.016c0.084 0.004 0.167 0.009 0.25 0.015v-2.005c-0.083-0.005-0.167-0.009-0.25-0.013v2.002z" }),
_('path', { d: "M19.125 5.875l0.25-0.25v-1.023c-0.083-0.075-0.166-0.148-0.25-0.221v1.493z" }),
_('path', { d: "M18.625 6.375l0.25-0.25v-1.954c-0.083-0.068-0.166-0.135-0.25-0.201v2.405z" }),
_('path', { d: "M18.125 6.169c0.084 0.078 0.168 0.157 0.25 0.237v-2.627c-0.083-0.062-0.166-0.123-0.25-0.183v2.573z" }),
_('path', { d: "M19.625 4.834v0.541l0.25-0.25v-0.049c-0.082-0.082-0.166-0.163-0.25-0.243z" }),
_('path', { d: "M15.125 1.968v2.175c0.084 0.040 0.167 0.080 0.25 0.122v-2.195c-0.083-0.035-0.166-0.069-0.25-0.102z" }),
_('path', { d: "M15.625 4.394c0.084 0.045 0.167 0.090 0.25 0.137v-2.242c-0.083-0.038-0.166-0.076-0.25-0.113v2.217z" }),
_('path', { d: "M16.125 4.675c0.084 0.050 0.167 0.101 0.25 0.153v-2.296c-0.083-0.042-0.166-0.084-0.25-0.124v2.268z" }),
_('path', { d: "M17.125 5.341c0.084 0.062 0.167 0.126 0.25 0.19v-2.435c-0.083-0.051-0.166-0.102-0.25-0.151v2.396z" }),
_('path', { d: "M17.625 5.733c0.084 0.069 0.167 0.14 0.25 0.212v-2.523c-0.083-0.056-0.166-0.112-0.25-0.166v2.477z" }),
_('path', { d: "M16.625 4.99c0.084 0.056 0.167 0.113 0.25 0.171v-2.36c-0.083-0.047-0.166-0.093-0.25-0.138v2.327z" }),
_('path', { d: "M3.125 5.161c0.083-0.058 0.166-0.115 0.25-0.171v-2.327c-0.084 0.045-0.167 0.091-0.25 0.138v2.36z" }),
_('path', { d: "M9.625 3.006c0.083-0.003 0.167-0.004 0.25-0.005v-2c-0.083 0.001-0.167 0.002-0.25 0.004v2.001z" }),
_('path', { d: "M3.625 4.829c0.083-0.052 0.166-0.103 0.25-0.153v-2.268c-0.084 0.041-0.167 0.082-0.25 0.124v2.296z" }),
_('path', { d: "M2.125 5.945c0.083-0.072 0.166-0.143 0.25-0.212v-2.477c-0.084 0.055-0.167 0.11-0.25 0.166v2.523z" }),
_('path', { d: "M4.125 2.289v2.242c0.083-0.047 0.166-0.092 0.25-0.137v-2.217c-0.084 0.037-0.167 0.074-0.25 0.113z" }),
_('path', { d: "M0.125 5.125l0.25 0.25v-0.542c-0.084 0.080-0.168 0.161-0.25 0.243v0.049z" }),
_('path', { d: "M1.625 6.406c0.082-0.080 0.166-0.159 0.25-0.237v-2.573c-0.084 0.060-0.167 0.121-0.25 0.183v2.627z" }),
_('path', { d: "M4.625 4.264c0.083-0.042 0.166-0.082 0.25-0.122v-2.175c-0.084 0.033-0.167 0.067-0.25 0.102v2.195z" }),
_('path', { d: "M0.625 5.625l0.25 0.25v-1.493c-0.084 0.072-0.167 0.146-0.25 0.221v1.023z" }),
_('path', { d: "M1.125 6.125l0.25 0.25v-2.405c-0.084 0.066-0.167 0.133-0.25 0.201v1.954z" }),
_('path', { d: "M2.625 5.532c0.083-0.065 0.166-0.128 0.25-0.19v-2.396c-0.084 0.050-0.167 0.1-0.25 0.151v2.435z" }),
_('path', { d: "M5.125 4.028c0.083-0.037 0.166-0.073 0.25-0.108v-2.138c-0.084 0.029-0.167 0.060-0.25 0.091v2.155z" }),
_('path', { d: "M8.625 3.078c0.083-0.009 0.166-0.018 0.25-0.026v-2.007c-0.083 0.007-0.167 0.014-0.25 0.022v2.011z" }),
_('path', { d: "M9.125 3.031c0.083-0.006 0.166-0.011 0.25-0.015v-2.002c-0.083 0.004-0.167 0.008-0.25 0.013v2.005z" }),
_('path', { d: "M7.625 3.234c0.083-0.017 0.166-0.032 0.25-0.047v-2.027c-0.083 0.013-0.167 0.026-0.25 0.040v2.034z" }),
_('path', { d: "M8.125 3.145c0.083-0.013 0.166-0.025 0.25-0.036v-2.015c-0.083 0.010-0.167 0.020-0.25 0.031v2.021z" }),
_('path', { d: "M6.125 3.637c0.083-0.028 0.166-0.056 0.25-0.082v-2.081c-0.084 0.022-0.167 0.046-0.25 0.070v2.093z" }),
_('path', { d: "M5.625 3.819c0.083-0.032 0.166-0.064 0.25-0.095v-2.107c-0.084 0.026-0.167 0.053-0.25 0.080v2.122z" }),
_('path', { d: "M7.125 3.345c0.083-0.020 0.166-0.040 0.25-0.058v-2.041c-0.083 0.016-0.167 0.033-0.25 0.050v2.050z" }),
_('path', { d: "M6.625 3.479c0.083-0.024 0.166-0.047 0.25-0.070v-2.060c-0.084 0.019-0.167 0.039-0.25 0.060v2.070z" }),
_('path', { d: "M12.125 7.284c0.084 0.023 0.167 0.047 0.25 0.073v-2.074c-0.083-0.020-0.166-0.039-0.25-0.057v2.058z" }),
_('path', { d: "M12.625 7.439c0.084 0.029 0.167 0.059 0.25 0.091v-2.112c-0.083-0.025-0.166-0.048-0.25-0.071v2.092z" }),
_('path', { d: "M11.125 7.079c0.084 0.012 0.167 0.024 0.25 0.039v-2.023c-0.083-0.011-0.166-0.022-0.25-0.031v2.016z" }),
_('path', { d: "M10.625 7.024c0.084 0.006 0.167 0.014 0.25 0.023v-2.009c-0.083-0.007-0.166-0.013-0.25-0.018v2.004z" }),
_('path', { d: "M11.625 7.165c0.084 0.017 0.167 0.036 0.25 0.056v-2.045c-0.083-0.016-0.166-0.030-0.25-0.044v2.033z" }),
_('path', { d: "M13.125 7.631c0.084 0.036 0.167 0.073 0.25 0.111v-2.161c-0.083-0.030-0.166-0.058-0.25-0.085v2.136z" }),
_('path', { d: "M13.625 7.864c0.084 0.043 0.167 0.087 0.25 0.133v-2.222c-0.083-0.035-0.166-0.069-0.25-0.101v2.19z" }),
_('path', { d: "M16.125 8.875l0.25-0.25v-1.33c-0.082-0.068-0.166-0.136-0.25-0.201v1.781z" }),
_('path', { d: "M16.625 7.51v0.865l0.25-0.25v-0.387c-0.082-0.078-0.166-0.154-0.25-0.229z" }),
_('path', { d: "M15.625 9.312c0.011 0.010 0.021 0.021 0.032 0.031l0.218-0.218v-2.219c-0.083-0.060-0.166-0.119-0.25-0.176v2.583z" }),
_('path', { d: "M14.125 8.142c0.084 0.051 0.167 0.104 0.25 0.158v-2.297c-0.083-0.040-0.166-0.080-0.25-0.118v2.257z" }),
_('path', { d: "M15.125 8.857c0.085 0.071 0.168 0.143 0.25 0.218v-2.511c-0.083-0.053-0.166-0.105-0.25-0.155v2.448z" }),
_('path', { d: "M10.125 7.002c0.084 0.001 0.167 0.003 0.25 0.007v-2.001c-0.083-0.003-0.166-0.005-0.25-0.006v2z" }),
_('path', { d: "M14.625 8.47c0.084 0.060 0.168 0.122 0.25 0.185v-2.392c-0.083-0.046-0.166-0.091-0.25-0.135v2.341z" }),
_('path', { d: "M7.125 7.53c0.083-0.032 0.166-0.062 0.25-0.091v-2.092c-0.084 0.023-0.167 0.046-0.25 0.071v2.112z" }),
_('path', { d: "M4.625 9.075c0.082-0.075 0.165-0.147 0.25-0.218v-2.448c-0.084 0.050-0.167 0.102-0.25 0.155v2.511z" }),
_('path', { d: "M4.125 9.125l0.218 0.218c0.011-0.011 0.021-0.021 0.032-0.031v-2.583c-0.084 0.057-0.167 0.116-0.25 0.176v2.219z" }),
_('path', { d: "M5.125 8.656c0.082-0.063 0.166-0.125 0.25-0.185v-2.341c-0.084 0.044-0.167 0.089-0.25 0.135v2.392z" }),
_('path', { d: "M5.625 8.3c0.082-0.054 0.166-0.107 0.25-0.158v-2.257c-0.084 0.038-0.167 0.077-0.25 0.118v2.297z" }),
_('path', { d: "M3.625 8.625l0.25 0.25v-1.781c-0.084 0.066-0.168 0.133-0.25 0.201v1.33z" }),
_('path', { d: "M3.125 8.125l0.25 0.25v-0.865c-0.084 0.075-0.168 0.151-0.25 0.229v0.387z" }),
_('path', { d: "M9.125 7.048c0.083-0.009 0.166-0.017 0.25-0.023v-2.004c-0.084 0.005-0.167 0.011-0.25 0.018v2.009z" }),
_('path', { d: "M6.125 7.998c0.083-0.046 0.166-0.090 0.25-0.133v-2.19c-0.084 0.033-0.167 0.066-0.25 0.101v2.222z" }),
_('path', { d: "M9.625 7.009c0.083-0.004 0.166-0.006 0.25-0.007v-2c-0.084 0.001-0.167 0.003-0.25 0.006v2.001z" }),
_('path', { d: "M8.125 7.22c0.083-0.020 0.166-0.038 0.25-0.056v-2.033c-0.084 0.014-0.167 0.028-0.25 0.044v2.045z" }),
_('path', { d: "M8.625 7.117c0.083-0.014 0.166-0.027 0.25-0.039v-2.016c-0.084 0.009-0.167 0.020-0.25 0.031v2.023z" }),
_('path', { d: "M6.625 7.743c0.083-0.038 0.166-0.075 0.25-0.111v-2.136c-0.084 0.027-0.167 0.056-0.25 0.085v2.161z" }),
_('path', { d: "M7.625 7.357c0.083-0.026 0.166-0.050 0.25-0.073v-2.058c-0.084 0.018-0.167 0.037-0.25 0.057v2.074z" })
            );
        }
        function Connection3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Connection3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Connection3.SVG = Connection3SVG;
        return Connection3;
    })();
export const Connection4 = /*#__PURE__*/ (() => {
        function Connection4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 14c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z" }),
_('path', { d: "M13.125 3.409c0.084 0.022 0.167 0.046 0.25 0.070v-2.070c-0.083-0.021-0.166-0.041-0.25-0.060v2.060z" }),
_('path', { d: "M12.625 3.286c0.084 0.019 0.167 0.038 0.25 0.058v-2.050c-0.083-0.017-0.166-0.034-0.25-0.050v2.041z" }),
_('path', { d: "M14.625 3.92c0.084 0.035 0.167 0.071 0.25 0.108v-2.155c-0.083-0.031-0.166-0.061-0.25-0.091v2.138z" }),
_('path', { d: "M13.625 3.554c0.084 0.026 0.167 0.054 0.25 0.082v-2.094c-0.083-0.024-0.166-0.047-0.25-0.070v2.081z" }),
_('path', { d: "M14.125 3.725c0.084 0.031 0.167 0.062 0.25 0.095v-2.122c-0.083-0.027-0.166-0.054-0.25-0.080v2.107z" }),
_('path', { d: "M11.125 3.052c0.084 0.008 0.167 0.016 0.25 0.026v-2.011c-0.083-0.008-0.167-0.015-0.25-0.022v2.007z" }),
_('path', { d: "M10.125 3.001c0.083 0.001 0.167 0.003 0.25 0.005v-2.001c-0.083-0.002-0.167-0.004-0.25-0.004v2z" }),
_('path', { d: "M12.125 3.187c0.084 0.015 0.167 0.030 0.25 0.047v-2.034c-0.083-0.014-0.166-0.028-0.25-0.040v2.027z" }),
_('path', { d: "M11.625 3.108c0.084 0.011 0.167 0.023 0.25 0.036v-2.021c-0.083-0.011-0.167-0.022-0.25-0.031v2.015z" }),
_('path', { d: "M10.625 3.016c0.084 0.004 0.167 0.009 0.25 0.015v-2.005c-0.083-0.005-0.167-0.009-0.25-0.013v2.002z" }),
_('path', { d: "M19.125 5.875l0.25-0.25v-1.023c-0.083-0.075-0.166-0.148-0.25-0.221v1.493z" }),
_('path', { d: "M18.625 6.375l0.25-0.25v-1.954c-0.083-0.068-0.166-0.135-0.25-0.201v2.405z" }),
_('path', { d: "M18.125 6.169c0.084 0.078 0.168 0.157 0.25 0.237v-2.627c-0.083-0.062-0.166-0.123-0.25-0.183v2.573z" }),
_('path', { d: "M19.625 4.834v0.541l0.25-0.25v-0.049c-0.082-0.082-0.166-0.163-0.25-0.243z" }),
_('path', { d: "M15.125 1.968v2.175c0.084 0.040 0.167 0.080 0.25 0.122v-2.195c-0.083-0.035-0.166-0.069-0.25-0.102z" }),
_('path', { d: "M15.625 4.394c0.084 0.045 0.167 0.090 0.25 0.137v-2.242c-0.083-0.038-0.166-0.076-0.25-0.113v2.217z" }),
_('path', { d: "M16.125 4.675c0.084 0.050 0.167 0.101 0.25 0.153v-2.296c-0.083-0.042-0.166-0.084-0.25-0.124v2.268z" }),
_('path', { d: "M17.125 5.341c0.084 0.062 0.167 0.126 0.25 0.19v-2.435c-0.083-0.051-0.166-0.102-0.25-0.151v2.396z" }),
_('path', { d: "M17.625 5.733c0.084 0.069 0.167 0.14 0.25 0.212v-2.523c-0.083-0.056-0.166-0.112-0.25-0.166v2.477z" }),
_('path', { d: "M16.625 4.99c0.084 0.056 0.167 0.113 0.25 0.171v-2.36c-0.083-0.047-0.166-0.093-0.25-0.138v2.327z" }),
_('path', { d: "M3.125 5.161c0.083-0.058 0.166-0.115 0.25-0.171v-2.327c-0.084 0.045-0.167 0.091-0.25 0.138v2.36z" }),
_('path', { d: "M9.625 3.006c0.083-0.003 0.167-0.004 0.25-0.005v-2c-0.083 0.001-0.167 0.002-0.25 0.004v2.001z" }),
_('path', { d: "M3.625 4.829c0.083-0.052 0.166-0.103 0.25-0.153v-2.268c-0.084 0.041-0.167 0.082-0.25 0.124v2.296z" }),
_('path', { d: "M2.125 5.945c0.083-0.072 0.166-0.143 0.25-0.212v-2.477c-0.084 0.055-0.167 0.11-0.25 0.166v2.523z" }),
_('path', { d: "M4.125 2.289v2.242c0.083-0.047 0.166-0.092 0.25-0.137v-2.217c-0.084 0.037-0.167 0.074-0.25 0.113z" }),
_('path', { d: "M0.125 5.125l0.25 0.25v-0.542c-0.084 0.080-0.168 0.161-0.25 0.243v0.049z" }),
_('path', { d: "M1.625 6.406c0.082-0.080 0.166-0.159 0.25-0.237v-2.573c-0.084 0.060-0.167 0.121-0.25 0.183v2.627z" }),
_('path', { d: "M4.625 4.264c0.083-0.042 0.166-0.082 0.25-0.122v-2.175c-0.084 0.033-0.167 0.067-0.25 0.102v2.195z" }),
_('path', { d: "M0.625 5.625l0.25 0.25v-1.493c-0.084 0.072-0.167 0.146-0.25 0.221v1.023z" }),
_('path', { d: "M1.125 6.125l0.25 0.25v-2.405c-0.084 0.066-0.167 0.133-0.25 0.201v1.954z" }),
_('path', { d: "M2.625 5.532c0.083-0.065 0.166-0.128 0.25-0.19v-2.396c-0.084 0.050-0.167 0.1-0.25 0.151v2.435z" }),
_('path', { d: "M5.125 4.028c0.083-0.037 0.166-0.073 0.25-0.108v-2.138c-0.084 0.029-0.167 0.060-0.25 0.091v2.155z" }),
_('path', { d: "M8.625 3.078c0.083-0.009 0.166-0.018 0.25-0.026v-2.007c-0.083 0.007-0.167 0.014-0.25 0.022v2.011z" }),
_('path', { d: "M9.125 3.031c0.083-0.006 0.166-0.011 0.25-0.015v-2.002c-0.083 0.004-0.167 0.008-0.25 0.013v2.005z" }),
_('path', { d: "M7.625 3.234c0.083-0.017 0.166-0.032 0.25-0.047v-2.027c-0.083 0.013-0.167 0.026-0.25 0.040v2.034z" }),
_('path', { d: "M8.125 3.145c0.083-0.013 0.166-0.025 0.25-0.036v-2.015c-0.083 0.010-0.167 0.020-0.25 0.031v2.021z" }),
_('path', { d: "M6.125 3.637c0.083-0.028 0.166-0.056 0.25-0.082v-2.081c-0.084 0.022-0.167 0.046-0.25 0.070v2.093z" }),
_('path', { d: "M5.625 3.819c0.083-0.032 0.166-0.064 0.25-0.095v-2.107c-0.084 0.026-0.167 0.053-0.25 0.080v2.122z" }),
_('path', { d: "M7.125 3.345c0.083-0.020 0.166-0.040 0.25-0.058v-2.041c-0.083 0.016-0.167 0.033-0.25 0.050v2.050z" }),
_('path', { d: "M6.625 3.479c0.083-0.024 0.166-0.047 0.25-0.070v-2.060c-0.084 0.019-0.167 0.039-0.25 0.060v2.070z" }),
_('path', { d: "M12.125 7.284c0.084 0.023 0.167 0.047 0.25 0.073v-2.074c-0.083-0.020-0.166-0.039-0.25-0.057v2.058z" }),
_('path', { d: "M12.625 7.439c0.084 0.029 0.167 0.059 0.25 0.091v-2.112c-0.083-0.025-0.166-0.048-0.25-0.071v2.092z" }),
_('path', { d: "M11.125 7.079c0.084 0.012 0.167 0.024 0.25 0.039v-2.023c-0.083-0.011-0.166-0.022-0.25-0.031v2.016z" }),
_('path', { d: "M10.625 7.024c0.084 0.006 0.167 0.014 0.25 0.023v-2.009c-0.083-0.007-0.166-0.013-0.25-0.018v2.004z" }),
_('path', { d: "M11.625 7.165c0.084 0.017 0.167 0.036 0.25 0.056v-2.045c-0.083-0.016-0.166-0.030-0.25-0.044v2.033z" }),
_('path', { d: "M13.125 7.631c0.084 0.036 0.167 0.073 0.25 0.111v-2.161c-0.083-0.030-0.166-0.058-0.25-0.085v2.136z" }),
_('path', { d: "M13.625 7.864c0.084 0.043 0.167 0.087 0.25 0.133v-2.222c-0.083-0.035-0.166-0.069-0.25-0.101v2.19z" }),
_('path', { d: "M16.125 8.875l0.25-0.25v-1.33c-0.082-0.068-0.166-0.136-0.25-0.201v1.781z" }),
_('path', { d: "M16.625 7.51v0.865l0.25-0.25v-0.387c-0.082-0.078-0.166-0.154-0.25-0.229z" }),
_('path', { d: "M15.625 9.312c0.011 0.010 0.021 0.021 0.032 0.031l0.218-0.218v-2.219c-0.083-0.060-0.166-0.119-0.25-0.176v2.583z" }),
_('path', { d: "M14.125 8.142c0.084 0.051 0.167 0.104 0.25 0.158v-2.297c-0.083-0.040-0.166-0.080-0.25-0.118v2.257z" }),
_('path', { d: "M15.125 8.857c0.085 0.071 0.168 0.143 0.25 0.218v-2.511c-0.083-0.053-0.166-0.105-0.25-0.155v2.448z" }),
_('path', { d: "M10.125 7.002c0.084 0.001 0.167 0.003 0.25 0.007v-2.001c-0.083-0.003-0.166-0.005-0.25-0.006v2z" }),
_('path', { d: "M14.625 8.47c0.084 0.060 0.168 0.122 0.25 0.185v-2.392c-0.083-0.046-0.166-0.091-0.25-0.135v2.341z" }),
_('path', { d: "M7.125 7.53c0.083-0.032 0.166-0.062 0.25-0.091v-2.092c-0.084 0.023-0.167 0.046-0.25 0.071v2.112z" }),
_('path', { d: "M4.625 9.075c0.082-0.075 0.165-0.147 0.25-0.218v-2.448c-0.084 0.050-0.167 0.102-0.25 0.155v2.511z" }),
_('path', { d: "M4.125 9.125l0.218 0.218c0.011-0.011 0.021-0.021 0.032-0.031v-2.583c-0.084 0.057-0.167 0.116-0.25 0.176v2.219z" }),
_('path', { d: "M5.125 8.656c0.082-0.063 0.166-0.125 0.25-0.185v-2.341c-0.084 0.044-0.167 0.089-0.25 0.135v2.392z" }),
_('path', { d: "M5.625 8.3c0.082-0.054 0.166-0.107 0.25-0.158v-2.257c-0.084 0.038-0.167 0.077-0.25 0.118v2.297z" }),
_('path', { d: "M3.625 8.625l0.25 0.25v-1.781c-0.084 0.066-0.168 0.133-0.25 0.201v1.33z" }),
_('path', { d: "M3.125 8.125l0.25 0.25v-0.865c-0.084 0.075-0.168 0.151-0.25 0.229v0.387z" }),
_('path', { d: "M9.125 7.048c0.083-0.009 0.166-0.017 0.25-0.023v-2.004c-0.084 0.005-0.167 0.011-0.25 0.018v2.009z" }),
_('path', { d: "M6.125 7.998c0.083-0.046 0.166-0.090 0.25-0.133v-2.19c-0.084 0.033-0.167 0.066-0.25 0.101v2.222z" }),
_('path', { d: "M9.625 7.009c0.083-0.004 0.166-0.006 0.25-0.007v-2c-0.084 0.001-0.167 0.003-0.25 0.006v2.001z" }),
_('path', { d: "M8.125 7.22c0.083-0.020 0.166-0.038 0.25-0.056v-2.033c-0.084 0.014-0.167 0.028-0.25 0.044v2.045z" }),
_('path', { d: "M8.625 7.117c0.083-0.014 0.166-0.027 0.25-0.039v-2.016c-0.084 0.009-0.167 0.020-0.25 0.031v2.023z" }),
_('path', { d: "M6.625 7.743c0.083-0.038 0.166-0.075 0.25-0.111v-2.136c-0.084 0.027-0.167 0.056-0.25 0.085v2.161z" }),
_('path', { d: "M7.625 7.357c0.083-0.026 0.166-0.050 0.25-0.073v-2.058c-0.084 0.018-0.167 0.037-0.25 0.057v2.074z" }),
_('path', { d: "M10.125 11.002c0.084 0.003 0.167 0.008 0.25 0.016v-2.006c-0.083-0.005-0.166-0.009-0.25-0.010v2.001z" }),
_('path', { d: "M11.125 11.161c0.084 0.025 0.168 0.052 0.25 0.082v-2.084c-0.083-0.019-0.166-0.037-0.25-0.053v2.055z" }),
_('path', { d: "M10.625 11.049c0.084 0.013 0.168 0.029 0.25 0.048v-2.033c-0.083-0.012-0.166-0.023-0.25-0.032v2.017z" }),
_('path', { d: "M12.125 11.613c0.086 0.054 0.169 0.111 0.25 0.171v-2.293c-0.082-0.036-0.166-0.069-0.25-0.101v2.224z" }),
_('path', { d: "M11.625 11.345c0.085 0.038 0.168 0.079 0.25 0.122v-2.167c-0.083-0.027-0.166-0.053-0.25-0.077v2.122z" }),
_('path', { d: "M12.625 11.984c0.069 0.061 0.137 0.123 0.202 0.189l0.048-0.048v-2.39c-0.082-0.045-0.166-0.088-0.25-0.129v2.379z" }),
_('path', { d: "M14.125 10.647v0.228l0.116-0.116c-0.038-0.038-0.077-0.075-0.116-0.112z" }),
_('path', { d: "M13.625 11.375l0.25-0.25v-0.702c-0.082-0.069-0.165-0.136-0.25-0.201v1.153z" }),
_('path', { d: "M13.125 11.875l0.25-0.25v-1.583c-0.082-0.056-0.165-0.11-0.25-0.162v1.995z" }),
_('path', { d: "M9.625 11.018c0.083-0.008 0.166-0.013 0.25-0.016v-2.001c-0.084 0.002-0.167 0.005-0.25 0.010v2.006z" }),
_('path', { d: "M6.625 11.625l0.25 0.25v-1.995c-0.085 0.052-0.168 0.106-0.25 0.162v1.583z" }),
_('path', { d: "M9.125 11.097c0.082-0.018 0.166-0.034 0.25-0.048v-2.016c-0.084 0.009-0.167 0.019-0.25 0.032v2.033z" }),
_('path', { d: "M5.875 10.875v-0.228c-0.039 0.037-0.078 0.074-0.116 0.112l0.116 0.116z" }),
_('path', { d: "M7.125 12.125l0.048 0.048c0.065-0.065 0.133-0.128 0.202-0.189v-2.379c-0.084 0.041-0.168 0.084-0.25 0.129v2.39z" }),
_('path', { d: "M6.125 11.125l0.25 0.25v-1.153c-0.085 0.065-0.168 0.132-0.25 0.201v0.702z" }),
_('path', { d: "M7.625 11.784c0.081-0.060 0.164-0.117 0.25-0.171v-2.224c-0.084 0.032-0.168 0.066-0.25 0.101v2.293z" }),
_('path', { d: "M8.625 11.244c0.082-0.030 0.165-0.057 0.25-0.082v-2.055c-0.084 0.016-0.167 0.034-0.25 0.053v2.084z" }),
_('path', { d: "M8.125 11.468c0.082-0.044 0.165-0.084 0.25-0.122v-2.122c-0.084 0.024-0.167 0.049-0.25 0.077v2.167z" })
            );
        }
        function Connection4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Connection4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Connection4.SVG = Connection4SVG;
        return Connection4;
    })();
export const Podcast = /*#__PURE__*/ (() => {
    function PodcastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 3.438 2.169 6.37 5.214 7.501l-0.214 0.499h6l-0.214-0.499c3.045-1.131 5.214-4.063 5.214-7.501zM7.606 9.919c-0.356-0.153-0.606-0.507-0.606-0.919 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.412-0.25 0.766-0.606 0.919l-0.394-0.919-0.394 0.919zM8.41 9.958c0.908-0.189 1.59-0.994 1.59-1.958 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.964 0.682 1.768 1.59 1.957l-1.166 2.721c-1.425-0.612-2.424-2.028-2.424-3.677 0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188c0 1.649-0.999 3.066-2.424 3.677l-1.166-2.72zM10.757 15.433l-1.155-2.695c1.976-0.668 3.398-2.537 3.398-4.738 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.201 1.422 4.070 3.398 4.738l-1.155 2.695c-2.494-1.070-4.24-3.547-4.24-6.433 0-3.865 3.133-7.185 6.997-7.185s6.997 3.32 6.997 7.185c0 2.886-1.747 5.363-4.24 6.433z" })
        );
    }
    function Podcast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PodcastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Podcast.SVG = PodcastSVG;
    return Podcast;
})();
export const Station = /*#__PURE__*/ (() => {
    function StationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 5c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.709 0.369 1.331 0.925 1.686l-2.54 9.314h1.231l0.273-1h4.224l0.273 1h1.231l-2.54-9.314c0.556-0.355 0.925-0.977 0.925-1.686zM9.294 12h-2.587l0.273-1h2.042l0.273 1zM7.252 10l0.748-2.743 0.748 2.743h-1.496zM6.161 14l0.273-1h3.133l0.273 1h-3.678zM10.38 0.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM13.38 0.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM5.62 9.398c-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398s0.431 3.302 1.12 4.398zM0 5c0-1.9 1.059-3.552 2.62-4.398-0.689 1.096-1.12 2.66-1.12 4.398s0.431 3.302 1.12 4.398c-1.56-0.846-2.62-2.498-2.62-4.398z" })
        );
    }
    function Station({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Station.SVG = StationSVG;
    return Station;
})();
export const Station2 = /*#__PURE__*/ (() => {
        function Station2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.128 11.347l0.643-1.415c-1.389-1.193-2.271-2.961-2.271-4.932 0-1.535 0.535-2.947 1.428-4.060l-1.174-0.94c-1.136 1.414-1.754 3.159-1.754 5 0 2.137 0.832 4.146 2.343 5.657 0.249 0.249 0.511 0.478 0.785 0.69z" }),
_('path', { d: "M12.229 9.932l0.643 1.415c0.274-0.211 0.536-0.441 0.785-0.69 1.511-1.511 2.343-3.52 2.343-5.657 0-1.84-0.618-3.585-1.754-5l-1.174 0.94c0.893 1.113 1.428 2.525 1.428 4.060 0 1.971-0.882 3.739-2.271 4.932z" }),
_('path', { d: "M11.006 7.242l0.68 1.496c0.009-0.009 0.018-0.017 0.026-0.025 1.909-1.909 2.037-4.934 0.386-6.993l-1.171 0.937c1.067 1.331 1.093 3.226 0.079 4.585z" }),
_('path', { d: "M4.288 8.712c0.009 0.009 0.017 0.017 0.026 0.025l0.68-1.496c-1.015-1.359-0.988-3.254 0.079-4.585l-1.171-0.937c-1.651 2.060-1.523 5.084 0.386 6.993z" }),
_('path', { d: "M10 5c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.583 0.25 1.108 0.648 1.473l-4.33 9.527h1.648l0.909-2h6.252l0.909 2h1.648l-4.33-9.527c0.398-0.366 0.648-0.89 0.648-1.473zM8 7.123l1.308 2.877h-2.616l1.308-2.877zM10.671 13h-5.343l0.909-2h3.525l0.909 2z" })
            );
        }
        function Station2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Station2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Station2.SVG = Station2SVG;
        return Station2;
    })();
export const Antenna = /*#__PURE__*/ (() => {
        function AntennaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.182 11.932c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.462-1.462 1.462-3.841 0-5.303s-3.841-1.462-5.303 0c-0.708 0.708-1.098 1.65-1.098 2.652s0.39 1.943 1.098 2.652c0.293 0.293 0.293 0.768 0 1.061s-0.768 0.293-1.061 0c-0.992-0.992-1.538-2.31-1.538-3.712s0.546-2.721 1.538-3.712c2.047-2.047 5.378-2.047 7.425 0s2.047 5.378 0 7.425c-0.146 0.146-0.338 0.22-0.53 0.22v0z" }),
_('path', { d: "M13.127 13.877c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.534-2.534 2.534-6.658 0-9.192s-6.658-2.534-9.192 0c-2.534 2.534-2.534 6.658 0 9.192 0.293 0.293 0.293 0.768 0 1.061s-0.768 0.293-1.061 0c-1.511-1.511-2.343-3.52-2.343-5.657s0.832-4.146 2.343-5.657c1.511-1.511 3.52-2.343 5.657-2.343s4.146 0.832 5.657 2.343c1.511 1.511 2.343 3.52 2.343 5.657s-0.832 4.146-2.343 5.657c-0.146 0.146-0.338 0.22-0.53 0.22v0z" }),
_('path', { d: "M9.5 15h-0.501l0.001-5.268c0.598-0.346 1-0.992 1-1.732 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.74 0.402 1.386 1 1.732l-0.001 5.268h-0.499c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Antenna({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AntennaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Antenna.SVG = AntennaSVG;
        return Antenna;
    })();
export const SatelliteDish = /*#__PURE__*/ (() => {
        function SatelliteDishSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.973 0.625c0.058-0.165 0.022-0.356-0.11-0.488s-0.323-0.168-0.488-0.11l-0-0-5.491 1.951c-0.338-0.234-0.678-0.446-1.014-0.634-1.124-0.628-2.171-0.96-3.026-0.96-0.679 0-1.25 0.212-1.651 0.613-0.201 0.201-0.352 0.44-0.454 0.712-0.474 1.018-0.739 2.152-0.739 3.348 0 4.387 3.556 7.944 7.944 7.944 1.201 0 2.339-0.267 3.36-0.744 0.269-0.103 0.505-0.253 0.7-0.448 0.757-0.757 0.813-2.049 0.158-3.639-0.274-0.665-0.661-1.36-1.14-2.053l1.95-5.49zM12.058 8.843c-0.087 0.244 0.041 0.512 0.285 0.599 0.052 0.018 0.105 0.027 0.157 0.027 0.193 0 0.373-0.12 0.442-0.312l0.653-1.837c0.264 0.435 0.485 0.863 0.656 1.278 0.427 1.037 0.483 1.891 0.147 2.228-0.145 0.145-0.382 0.218-0.705 0.218-1.159 0-3.319-0.99-5.532-3.203-1.302-1.302-2.31-2.726-2.838-4.009-0.427-1.037-0.484-1.891-0.147-2.228 0.145-0.145 0.382-0.218 0.705-0.218 0.664 0 1.658 0.326 2.801 1.020l-1.838 0.653c-0.244 0.087-0.371 0.355-0.285 0.599s0.355 0.371 0.599 0.285l6.574-2.336-4.563 4.563c-0.183 0.183-0.183 0.48 0 0.663 0.091 0.092 0.211 0.137 0.331 0.137s0.24-0.046 0.331-0.137l4.563-4.563-2.336 6.574z" }),
_('path', { d: "M9 15.5v-0.5c0-0.248-0.030-0.488-0.087-0.718-1.508-0.329-2.909-1.023-4.097-2.039-1.068 0.459-1.816 1.521-1.816 2.757v0.5c0 0.276 0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5z" })
            );
        }
        function SatelliteDish({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SatelliteDishSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SatelliteDish.SVG = SatelliteDishSVG;
        return SatelliteDish;
    })();
export const SatelliteDish2 = /*#__PURE__*/ (() => {
        function SatelliteDish2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 0c-0.552 0-1 0.448-1 1 0 0.175 0.045 0.34 0.124 0.483l-5.5 3.931c0.534 0.763 1.199 1.428 1.962 1.962l3.931-5.5c0.143 0.079 0.308 0.124 0.483 0.124 0.552 0 1-0.448 1-1s-0.448-1-1-1z" }),
_('path', { d: "M13.476 5.374l-0.619 0.866c0.605 0.799 1.082 1.602 1.393 2.357 0.427 1.037 0.483 1.891 0.147 2.228-0.145 0.145-0.382 0.218-0.705 0.218-1.159 0-3.319-0.99-5.532-3.203-1.302-1.302-2.31-2.726-2.838-4.009-0.427-1.037-0.484-1.891-0.147-2.228 0.145-0.145 0.382-0.218 0.705-0.218 0.867 0 2.292 0.554 3.881 1.757l0.865-0.618c-0.581-0.456-1.172-0.855-1.756-1.181-1.124-0.628-2.171-0.96-3.026-0.96-0.679 0-1.25 0.212-1.651 0.613-0.201 0.201-0.352 0.44-0.454 0.712-0.474 1.018-0.739 2.152-0.739 3.348 0 4.387 3.556 7.944 7.944 7.944 1.201 0 2.339-0.267 3.36-0.744 0.269-0.103 0.505-0.253 0.7-0.448 0.757-0.757 0.813-2.049 0.158-3.639-0.372-0.902-0.952-1.859-1.686-2.794z" }),
_('path', { d: "M9 15.5v-0.5c0-0.248-0.030-0.488-0.087-0.718-1.508-0.329-2.909-1.023-4.097-2.039-1.068 0.459-1.816 1.521-1.816 2.757v0.5c0 0.276 0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5z" })
            );
        }
        function SatelliteDish2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SatelliteDish2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SatelliteDish2.SVG = SatelliteDish2SVG;
        return SatelliteDish2;
    })();
export const Feed = /*#__PURE__*/ (() => {
    function FeedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.38 3.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM4.5 8c0 1.738 0.431 3.302 1.12 4.398-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398zM1.5 8c0 2.686 0.85 5.097 2.198 6.746-2.223-1.421-3.698-3.911-3.698-6.746s1.474-5.325 3.698-6.746c-1.348 1.649-2.198 4.060-2.198 6.746zM12.302 1.254c2.223 1.421 3.698 3.911 3.698 6.746s-1.474 5.325-3.698 6.746c1.348-1.649 2.198-4.060 2.198-6.746s-0.85-5.097-2.198-6.746z" })
        );
    }
    function Feed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FeedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Feed.SVG = FeedSVG;
    return Feed;
})();
export const Podcast2 = /*#__PURE__*/ (() => {
    function Podcast2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8 0 2.209 0.895 4.209 2.343 5.657l0.707-0.707c-1.267-1.267-2.050-3.017-2.050-4.95 0-3.866 3.134-7 7-7s7 3.134 7 7c0 1.933-0.784 3.683-2.050 4.95l0.707 0.707c1.448-1.448 2.343-3.448 2.343-5.657 0-4.418-3.582-8-8-8zM8 3c-2.761 0-5 2.239-5 5 0 1.381 0.56 2.631 1.464 3.536l0.707-0.707c-0.724-0.724-1.171-1.724-1.171-2.828 0-2.209 1.791-4 4-4s3.999 1.791 3.999 4c0 1.104-0.448 2.104-1.171 2.828l0.707 0.707c0.905-0.905 1.464-2.155 1.464-3.536 0-2.761-2.239-5-5-5v0zM9.414 9.414c0.362-0.362 0.586-0.862 0.586-1.414 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.552 0.224 1.052 0.586 1.414l0.707-0.707c-0.181-0.181-0.293-0.431-0.293-0.707 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.276-0.112 0.526-0.293 0.707l0.707 0.707zM7.625 9l-2.625 7h6l-2.625-7h-0.75z" })
        );
    }
    function Podcast2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Podcast2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Podcast2.SVG = Podcast2SVG;
    return Podcast2;
})();
export const Antenna2 = /*#__PURE__*/ (() => {
    function Antenna2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 16h6l-2-2v-7.268c0.598-0.346 1-0.992 1-1.732 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.74 0.402 1.386 1 1.732v7.268l-2 2zM11.122 2.5c0.549 0.685 0.878 1.554 0.878 2.5s-0.329 1.815-0.878 2.5l0.781 0.625c0.686-0.856 1.097-1.942 1.097-3.125s-0.411-2.269-1.097-3.125l-0.781 0.625zM4.097 1.875c-0.686 0.856-1.097 1.942-1.097 3.125s0.411 2.269 1.097 3.125l0.781-0.625c-0.549-0.685-0.878-1.554-0.878-2.5s0.329-1.815 0.878-2.5l-0.781-0.625zM1.755 0c-1.098 1.37-1.755 3.108-1.755 5s0.657 3.63 1.755 5l0.781-0.625c-0.961-1.198-1.536-2.719-1.536-4.375s0.575-3.176 1.536-4.375l-0.781-0.625zM14.245 0l-0.781 0.625c0.961 1.198 1.536 2.719 1.536 4.375s-0.575 3.176-1.536 4.375l0.781 0.625c1.098-1.37 1.755-3.108 1.755-5s-0.657-3.63-1.755-5z" })
        );
    }
    function Antenna2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Antenna2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Antenna2.SVG = Antenna2SVG;
    return Antenna2;
})();
export const Mic = /*#__PURE__*/ (() => {
    function MicSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 11c1.381 0 2.5-1.119 2.5-2.5v-6c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v6c0 1.381 1.119 2.5 2.5 2.5zM11 7v1.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5v-1.5h-1v1.5c0 2.316 1.75 4.223 4 4.472v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1z" })
        );
    }
    function Mic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mic.SVG = MicSVG;
    return Mic;
})();
export const MicOff = /*#__PURE__*/ (() => {
    function MicOffSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 2.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v5.379l5-5v-0.379zM4.018 8.86c-0.012-0.118-0.018-0.239-0.018-0.36v-1.5h-1v1.5c0 0.42 0.058 0.827 0.166 1.213l0.853-0.853zM11 8.5c0 1.933-1.567 3.5-3.5 3.5-1.041 0-1.975-0.455-2.617-1.176l0.709-0.709c0.458 0.541 1.142 0.885 1.907 0.885 1.381 0 2.5-1.119 2.5-2.5v-2.793l4.010-4.010-0.707-0.707-3.303 3.303-9.969 10.010 0.707 0.707 3.437-3.478c0.717 0.786 1.709 1.317 2.825 1.441v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1v1.5z" })
        );
    }
    function MicOff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MicOffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MicOff.SVG = MicOffSVG;
    return MicOff;
})();
export const Mic2 = /*#__PURE__*/ (() => {
        function Mic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 7c0-0.098-0.002-0.197-0.007-0.294-0.020-0.414-0.371-0.733-0.785-0.713s-0.733 0.372-0.713 0.785c0.004 0.073 0.005 0.148 0.005 0.222 0 2.483-2.019 4.503-4.5 4.503s-4.5-2.020-4.5-4.503c0-0.073 0.002-0.147 0.005-0.22 0.020-0.414-0.299-0.765-0.713-0.785s-0.765 0.299-0.785 0.713c-0.005 0.097-0.007 0.195-0.007 0.292 0 2.969 2.166 5.441 5 5.919v2.081c0 0.552 0.448 1 1 1s1-0.448 1-1v-2.081c2.834-0.478 5-2.95 5-5.919z" }),
_('path', { d: "M8 0c-1.657 0-3 1.343-3 3v4c0 1.657 1.343 3 3 3s3-1.343 3-3v-4c0-1.657-1.343-3-3-3z" })
            );
        }
        function Mic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Mic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic2.SVG = Mic2SVG;
        return Mic2;
    })();
export const MicOff2 = /*#__PURE__*/ (() => {
        function MicOff2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.735 1.765c-0.471-1.041-1.518-1.765-2.735-1.765-1.657 0-3 1.343-3 3v4c0 0.158 0.012 0.313 0.036 0.464l5.699-5.699z" }),
_('path', { d: "M3.824 8.676c-0.209-0.518-0.324-1.084-0.324-1.676 0-0.073 0.002-0.147 0.005-0.22 0.020-0.414-0.299-0.765-0.713-0.785s-0.765 0.299-0.785 0.713c-0.005 0.097-0.007 0.195-0.007 0.292 0 1.012 0.252 1.967 0.696 2.804l1.128-1.128z" }),
_('path', { d: "M13.208 5.993c-0.414 0.020-0.733 0.372-0.713 0.785 0.004 0.073 0.005 0.148 0.005 0.222 0 2.483-2.019 4.503-4.5 4.503-0.858 0-1.66-0.241-2.343-0.66l1.108-1.108c0.377 0.17 0.795 0.265 1.235 0.265 1.657 0 3-1.343 3-3v-1.5l4.5-4.5-1-1-14.5 14.5 1 1 3.575-3.575c0.712 0.497 1.535 0.844 2.425 0.994v2.081c0 0.552 0.448 1 1 1s1-0.448 1-1v-2.081c2.834-0.478 5-2.95 5-5.919 0-0.098-0.002-0.197-0.007-0.294-0.020-0.414-0.371-0.733-0.785-0.713z" })
            );
        }
        function MicOff2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MicOff2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MicOff2.SVG = MicOff2SVG;
        return MicOff2;
    })();
export const Mic3 = /*#__PURE__*/ (() => {
        function Mic3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 7c0-0.098-0.002-0.197-0.007-0.294-0.020-0.414-0.371-0.733-0.785-0.713s-0.733 0.372-0.713 0.785c0.004 0.073 0.005 0.148 0.005 0.222 0 2.483-2.019 4.503-4.5 4.503s-4.5-2.020-4.5-4.503c0-0.073 0.002-0.147 0.005-0.22 0.020-0.414-0.299-0.765-0.713-0.785s-0.765 0.299-0.785 0.713c-0.005 0.097-0.007 0.195-0.007 0.292 0 2.969 2.166 5.441 5 5.919v2.081c0 0.552 0.448 1 1 1s1-0.448 1-1v-2.081c2.834-0.478 5-2.95 5-5.919z" }),
_('path', { d: "M8 1.5c0.827 0 1.5 0.673 1.5 1.5v4c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-4c0-0.827 0.673-1.5 1.5-1.5zM8 0c-1.657 0-3 1.343-3 3v4c0 1.657 1.343 3 3 3s3-1.343 3-3v-4c0-1.657-1.343-3-3-3v0z" })
            );
        }
        function Mic3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Mic3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic3.SVG = Mic3SVG;
        return Mic3;
    })();
export const Mic4 = /*#__PURE__*/ (() => {
        function Mic4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 9c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-3h-8v3z" }),
_('path', { d: "M14.5 5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3c0 1.654-1.346 3-3 3h-4c-1.654 0-3-1.346-3-3v-3h0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3c0 2.206 1.794 4 4 4h1v2h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-2h1c2.206 0 4-1.794 4-4v-3h0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M10 0h-4c-1.1 0-2 0.9-2 2v3h8v-3c0-1.1-0.9-2-2-2zM5.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM5.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM5.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM6.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM6.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM6.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM7.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM7.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM7.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM8.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM8.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM8.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM9.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM9.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM9.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM10.5 3.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM10.5 2.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM10.5 1.75c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25z" })
            );
        }
        function Mic4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Mic4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic4.SVG = Mic4SVG;
        return Mic4;
    })();
export const Mic5 = /*#__PURE__*/ (() => {
        function Mic5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.158 5.251l-7.158 8.749c0 1 1 2 2 2l8.749-7.158c-1.756-0.452-3.138-1.835-3.591-3.591z" }),
_('path', { d: "M9.109 1.236c-0.687 0.718-1.109 1.692-1.109 2.764 0 2.209 1.791 4 4 4 1.072 0 2.046-0.422 2.764-1.109-2.875-0.512-5.143-2.78-5.655-5.655z" }),
_('path', { d: "M12 0c-0.719 0-1.394 0.19-1.977 0.522 0.25 2.897 2.558 5.205 5.455 5.455 0.332-0.583 0.522-1.258 0.522-1.977 0-2.209-1.791-4-4-4zM13.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM11.5 2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12.5 3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM14.5 5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM14.5 3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z" })
            );
        }
        function Mic5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Mic5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mic5.SVG = Mic5SVG;
        return Mic5;
    })();
export const Book = /*#__PURE__*/ (() => {
        function BookSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.889 3.604c-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314 0-0.114-0.039-0.225-0.111-0.314-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314v10c0 0.212 0.134 0.401 0.334 0.471s0.423 0.008 0.556-0.157c0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.097 0.12 0.241 0.186 0.389 0.186h1c0.148 0 0.292-0.066 0.389-0.186 0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.133 0.165 0.356 0.228 0.556 0.157s0.334-0.26 0.334-0.471v-10c0-0.114-0.039-0.225-0.111-0.314zM7 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717zM15 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717z" }),
_('path', { d: "M10 5h4v1h-4v-1z" }),
_('path', { d: "M10 7h4v1h-4v-1z" }),
_('path', { d: "M10 9h3v1h-3v-1z" }),
_('path', { d: "M2 5h4v1h-4v-1z" }),
_('path', { d: "M2 7h4v1h-4v-1z" }),
_('path', { d: "M2 9h3v1h-3v-1z" })
            );
        }
        function Book({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Book.SVG = BookSVG;
        return Book;
    })();
export const Book2 = /*#__PURE__*/ (() => {
    function Book2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.889 3.604c-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314 0-0.114-0.039-0.225-0.111-0.314-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314v10c0 0.212 0.134 0.401 0.334 0.471s0.423 0.008 0.556-0.157c0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.097 0.12 0.241 0.186 0.389 0.186h1c0.148 0 0.292-0.066 0.389-0.186 0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.133 0.165 0.356 0.228 0.556 0.157s0.334-0.26 0.334-0.471v-10c0-0.114-0.039-0.225-0.111-0.314zM7 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717zM15 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717z" })
        );
    }
    function Book2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Book2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Book2.SVG = Book2SVG;
    return Book2;
})();
export const BookPlay = /*#__PURE__*/ (() => {
        function BookPlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 5.5l5 3-5 3v-6z" }),
_('path', { d: "M8 15.231c-0.151 0-0.294-0.068-0.389-0.186-0.588-0.729-2.257-1.544-3.611-1.544-1.306 0-2.498 0.472-3.111 1.232-0.133 0.165-0.356 0.228-0.556 0.157s-0.334-0.26-0.334-0.471v-10.5c0-0.114 0.039-0.225 0.111-0.314 0.798-0.989 2.289-1.604 3.889-1.604 1.457 0 3.092 0.728 4 1.519 0.908-0.791 2.543-1.519 4-1.519 1.601 0 3.091 0.615 3.889 1.604 0.072 0.089 0.111 0.2 0.111 0.314v10.5c0 0.212-0.134 0.401-0.334 0.471s-0.423 0.007-0.556-0.157c-0.613-0.76-1.805-1.232-3.111-1.232-1.353 0-3.023 0.815-3.611 1.544-0.095 0.118-0.238 0.186-0.389 0.186zM4 12.5c1.457 0 3.092 0.728 4 1.519 0.908-0.791 2.543-1.519 4-1.519 1.121 0 2.187 0.301 3 0.822v-9.217c-0.639-0.685-1.769-1.104-3-1.104-1.353 0-3.023 0.815-3.611 1.545-0.095 0.118-0.238 0.186-0.389 0.186s-0.294-0.068-0.389-0.186c-0.588-0.729-2.258-1.545-3.611-1.545-1.231 0-2.361 0.42-3 1.104v9.217c0.813-0.52 1.879-0.822 3-0.822z" })
            );
        }
        function BookPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BookPlay.SVG = BookPlaySVG;
        return BookPlay;
    })();
export const Book3 = /*#__PURE__*/ (() => {
        function Book3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z" }),
_('path', { d: "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z" })
            );
        }
        function Book3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Book3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Book3.SVG = Book3SVG;
        return Book3;
    })();
export const Bookmark = /*#__PURE__*/ (() => {
        function BookmarkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1zM5 0.5h5v7l-2.5-2.5-2.5 2.5v-7z" }),
_('path', { d: "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z" })
            );
        }
        function Bookmark({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BookmarkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bookmark.SVG = BookmarkSVG;
        return Bookmark;
    })();
export const Books = /*#__PURE__*/ (() => {
        function BooksSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z" }),
_('path', { d: "M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z" }),
_('path', { d: "M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z" })
            );
        }
        function Books({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BooksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Books.SVG = BooksSVG;
        return Books;
    })();
export const Archive = /*#__PURE__*/ (() => {
    function ArchiveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 17 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 17 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1h-3c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h3c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM3 12.625c0 0.206-0.169 0.375-0.375 0.375h-0.25c-0.206 0-0.375-0.169-0.375-0.375v-0.25c0-0.206 0.169-0.375 0.375-0.375h0.25c0.206 0 0.375 0.169 0.375 0.375v0.25zM4 10h-3v-5h3v5zM4 4h-3v-1h3v1zM10 1h-3c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h3c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM9 12.625c0 0.206-0.169 0.375-0.375 0.375h-0.25c-0.206 0-0.375-0.169-0.375-0.375v-0.25c0-0.206 0.169-0.375 0.375-0.375h0.25c0.206 0 0.375 0.169 0.375 0.375v0.25zM10 10h-3v-5h3v5zM10 4h-3v-1h3v1zM16 1h-3c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h3c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM15 12.625c0 0.206-0.169 0.375-0.375 0.375h-0.25c-0.206 0-0.375-0.169-0.375-0.375v-0.25c0-0.206 0.169-0.375 0.375-0.375h0.25c0.206 0 0.375 0.169 0.375 0.375v0.25zM16 10h-3v-5h3v5zM16 4h-3v-1h3v1z" })
        );
    }
    function Archive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArchiveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Archive.SVG = ArchiveSVG;
    return Archive;
})();
export const Reading = /*#__PURE__*/ (() => {
    function ReadingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 2.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM15.781 11.375l-4-5c-0.197-0.247-0.488-0.375-0.781-0.375l-0-0-6 0c-0.293 0-0.583 0.128-0.781 0.375l-4 5c-0.263 0.328-0.292 0.786-0.073 1.145 0.184 0.302 0.51 0.48 0.854 0.48 0.065 0 0.131-0.006 0.196-0.019l2.804-0.561v3.58h8v-3.58l2.804 0.561c0.066 0.013 0.131 0.019 0.196 0.019 0.344 0 0.67-0.178 0.854-0.48 0.219-0.359 0.189-0.816-0.073-1.145zM11 10.18l-0.804-0.161c-0.541-0.108-1.068 0.243-1.177 0.784s0.243 1.068 0.784 1.177l1.196 0.239v0.78l-3 1-3-1v-0.78l1.196-0.239c0.542-0.108 0.893-0.635 0.784-1.177s-0.635-0.893-1.177-0.784l-0.804 0.161v-2.18l3 1 3-1v2.18z" })
        );
    }
    function Reading({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReadingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reading.SVG = ReadingSVG;
    return Reading;
})();
export const Library = /*#__PURE__*/ (() => {
        function LibrarySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z" }),
_('path', { d: "M8 0h1l8 5v1h-17v-1l8-5z" })
            );
        }
        function Library({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LibrarySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Library.SVG = LibrarySVG;
        return Library;
    })();
export const Library2 = /*#__PURE__*/ (() => {
        function Library2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 7h-2v7h-2v-7h-2v7h-2v-7h-2v7h-2v-7h-2v8h-1v1h16v-1h-1v-8z" }),
_('path', { d: "M8.5 0h-1l-7.5 5v1h16v-1l-7.5-5zM8 4c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
            );
        }
        function Library2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Library2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Library2.SVG = Library2SVG;
        return Library2;
    })();
export const Graduation = /*#__PURE__*/ (() => {
    function GraduationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 9.177v2.323c0 1 2.239 2.5 5 2.5s5-1.5 5-2.5v-2.323l-5 2.5-5-2.5zM8 2l-8 4 8 4 6.491-3.246-0.491 4.246h1v-4.5l1-0.5-8-4zM8.5 6.225c-0.4 0-0.725-0.325-0.725-0.725s0.325-0.725 0.725-0.725 0.725 0.325 0.725 0.725c0 0.4-0.325 0.725-0.725 0.725z" })
        );
    }
    function Graduation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GraduationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Graduation.SVG = GraduationSVG;
    return Graduation;
})();
export const FileText = /*#__PURE__*/ (() => {
    function FileTextSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z" })
        );
    }
    function FileText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileText.SVG = FileTextSVG;
    return FileText;
})();
export const Profile = /*#__PURE__*/ (() => {
    function ProfileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 9h7v1h-7zM4 11h7v1h-7zM5 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM7.5 6h-2c-0.825 0-1.5 0.45-1.5 1v1h5v-1c0-0.55-0.675-1-1.5-1z" })
        );
    }
    function Profile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ProfileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Profile.SVG = ProfileSVG;
    return Profile;
})();
export const FileEmpty = /*#__PURE__*/ (() => {
    function FileEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
        );
    }
    function FileEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FileEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FileEmpty.SVG = FileEmptySVG;
    return FileEmpty;
})();
export const FileEmpty2 = /*#__PURE__*/ (() => {
        function FileEmpty2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10 4.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5c-0.276 0-0.5-0.224-0.5-0.5z" })
            );
        }
        function FileEmpty2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileEmpty2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileEmpty2.SVG = FileEmpty2SVG;
        return FileEmpty2;
    })();
export const FilesEmpty = /*#__PURE__*/ (() => {
        function FilesEmptySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z" }),
_('path', { d: "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z" })
            );
        }
        function FilesEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilesEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilesEmpty.SVG = FilesEmptySVG;
        return FilesEmpty;
    })();
export const FilesEmpty2 = /*#__PURE__*/ (() => {
        function FilesEmpty2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z" }),
_('path', { d: "M11 6h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10 6.5v-4.5h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75h-4.5c-0.276 0-0.5-0.224-0.5-0.5z" })
            );
        }
        function FilesEmpty2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilesEmpty2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilesEmpty2.SVG = FilesEmpty2SVG;
        return FilesEmpty2;
    })();
export const FilePlus = /*#__PURE__*/ (() => {
        function FilePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h6.25c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-6.25c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5c0-0.224-0.068-0.615-0.659-1.421zM11 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" }),
_('path', { d: "M16 12h-2v-2h-2v2h-2v2h2v2h2v-2h2z" })
            );
        }
        function FilePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePlus.SVG = FilePlusSVG;
        return FilePlus;
    })();
export const FilePlus2 = /*#__PURE__*/ (() => {
        function FilePlus2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M7.875 12.5c0-2.55 2.075-4.625 4.625-4.625 0.92 0 1.779 0.27 2.5 0.736v-3.611h-4.5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h7.23c-0.982-0.849-1.605-2.103-1.605-3.5z" }),
_('path', { d: "M12.5 9c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5zM13 13v2h-1v-2h-2v-1h2v-2h1v2h2v1h-2z" })
            );
        }
        function FilePlus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePlus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePlus2.SVG = FilePlus2SVG;
        return FilePlus2;
    })();
export const FileMinus = /*#__PURE__*/ (() => {
        function FileMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h6.25c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-6.25c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5c0-0.224-0.068-0.615-0.659-1.421zM11 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" }),
_('path', { d: "M10 12h6v2h-6v-2z" })
            );
        }
        function FileMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMinus.SVG = FileMinusSVG;
        return FileMinus;
    })();
export const FileMinus2 = /*#__PURE__*/ (() => {
        function FileMinus2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M7.875 12.5c0-2.55 2.075-4.625 4.625-4.625 0.92 0 1.779 0.27 2.5 0.736v-3.611h-4.5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h7.23c-0.982-0.849-1.605-2.103-1.605-3.5z" }),
_('path', { d: "M12.5 9c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5zM10 13v-1h5v1h-5z" })
            );
        }
        function FileMinus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMinus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMinus2.SVG = FileMinus2SVG;
        return FileMinus2;
    })();
export const FileDownload = /*#__PURE__*/ (() => {
        function FileDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-6.75c-0.689 0-1.25 0.561-1.25 1.25v3.75l0.5 11 0.5-11v-3.75c0-0.135 0.115-0.25 0.25-0.25 0 0 6.749-0 6.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5l0.5 11 0.5-11c0-0.224-0.068-0.615-0.659-1.421zM10 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" }),
_('path', { d: "M9 7h-3v5h-2.5l4 4 4-4h-2.5z" })
            );
        }
        function FileDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileDownload.SVG = FileDownloadSVG;
        return FileDownload;
    })();
export const FileDownload2 = /*#__PURE__*/ (() => {
        function FileDownload2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM8 15.5l-3.5-3.5h2.5v-5h2v5h2.5l-3.5 3.5z" })
            );
        }
        function FileDownload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileDownload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileDownload2.SVG = FileDownload2SVG;
        return FileDownload2;
    })();
export const FileUpload = /*#__PURE__*/ (() => {
        function FileUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-6.75c-0.689 0-1.25 0.561-1.25 1.25v3.75l0.5 11 0.5-11v-3.75c0-0.135 0.115-0.25 0.25-0.25 0 0 6.749-0 6.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5l0.5 11 0.5-11c0-0.224-0.068-0.615-0.659-1.421zM10 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" }),
_('path', { d: "M6 16h3v-5h2.5l-4-4-4 4h2.5z" })
            );
        }
        function FileUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileUpload.SVG = FileUploadSVG;
        return FileUpload;
    })();
export const FileUpload2 = /*#__PURE__*/ (() => {
        function FileUpload2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM8 6.5l3.5 3.5h-2.5v5h-2v-5h-2.5l3.5-3.5z" })
            );
        }
        function FileUpload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileUpload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileUpload2.SVG = FileUpload2SVG;
        return FileUpload2;
    })();
export const FileCheck = /*#__PURE__*/ (() => {
        function FileCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 16l-3-3.5 1.273-1.273 1.727 1.738 4-3.965 1 1-5 6z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h6.25c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-6.25c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5c0-0.224-0.068-0.615-0.659-1.421zM11 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" })
            );
        }
        function FileCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCheck.SVG = FileCheckSVG;
        return FileCheck;
    })();
export const FileCheck2 = /*#__PURE__*/ (() => {
        function FileCheck2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM6.719 14.352l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914-5.207 5.707z" })
            );
        }
        function FileCheck2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCheck2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCheck2.SVG = FileCheck2SVG;
        return FileCheck2;
    })();
export const FileEye = /*#__PURE__*/ (() => {
        function FileEyeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.95 10.807c-0.466-1.113-1.267-2.062-2.318-2.745-1.070-0.695-2.326-1.062-3.632-1.062s-2.562 0.367-3.632 1.062c-1.051 0.683-1.853 1.632-2.318 2.745-0.052 0.123-0.052 0.262 0 0.386 0.465 1.113 1.267 2.062 2.318 2.745 1.070 0.695 2.326 1.062 3.632 1.062s2.562-0.367 3.632-1.062c1.051-0.683 1.853-1.632 2.318-2.745 0.052-0.123 0.052-0.262-0-0.386zM10 10c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1zM13.087 13.099c-0.908 0.589-1.975 0.901-3.087 0.901s-2.18-0.312-3.087-0.901c-0.82-0.533-1.458-1.255-1.855-2.099 0.397-0.844 1.035-1.566 1.855-2.099 0.102-0.066 0.206-0.128 0.311-0.188-0.199 0.405-0.311 0.86-0.311 1.342 0 1.681 1.363 3.044 3.044 3.044s3.044-1.363 3.044-3.044c0-0.508-0.125-0.986-0.344-1.407 0.147 0.078 0.292 0.162 0.432 0.253 0.82 0.533 1.457 1.255 1.855 2.099-0.397 0.844-1.035 1.566-1.855 2.099v0z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h5.25c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-5.25c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5c0-0.224-0.068-0.615-0.659-1.421zM11 4v-2.405c0.359 0.278 0.792 0.654 1.271 1.134s0.856 0.912 1.134 1.271h-2.406z" })
            );
        }
        function FileEye({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileEyeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileEye.SVG = FileEyeSVG;
        return FileEye;
    })();
export const FileEye2 = /*#__PURE__*/ (() => {
        function FileEye2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M5.755 15.881c-1.241-0.806-2.19-1.932-2.743-3.254-0.167-0.399-0.167-0.856 0-1.254 0.553-1.322 1.502-2.448 2.743-3.254 1.253-0.814 2.721-1.244 4.245-1.244s2.992 0.43 4.245 1.244c0.266 0.172 0.518 0.36 0.755 0.56v-3.679h-4.5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h3.695c-0.064-0.039-0.127-0.078-0.19-0.119z" }),
_('path', { d: "M15.95 11.807c-0.466-1.113-1.267-2.062-2.318-2.745-1.070-0.695-2.326-1.062-3.632-1.062s-2.562 0.367-3.632 1.062c-1.051 0.683-1.853 1.632-2.318 2.745-0.052 0.123-0.052 0.262 0 0.386 0.466 1.113 1.267 2.062 2.318 2.745 1.070 0.695 2.326 1.062 3.632 1.062s2.562-0.367 3.632-1.062c1.051-0.683 1.853-1.632 2.318-2.745 0.052-0.123 0.052-0.262-0-0.386zM10 11c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1zM13.087 14.099c-0.908 0.589-1.975 0.901-3.087 0.901s-2.18-0.312-3.087-0.901c-0.82-0.533-1.458-1.255-1.855-2.099 0.397-0.844 1.035-1.566 1.855-2.099 0.102-0.066 0.206-0.128 0.311-0.188-0.199 0.405-0.311 0.86-0.311 1.342 0 1.681 1.363 3.044 3.044 3.044s3.044-1.363 3.044-3.044c0-0.508-0.125-0.986-0.344-1.407 0.147 0.078 0.292 0.162 0.432 0.253 0.82 0.533 1.457 1.255 1.855 2.099-0.397 0.844-1.035 1.566-1.855 2.099v0 0z" })
            );
        }
        function FileEye2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileEye2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileEye2.SVG = FileEye2SVG;
        return FileEye2;
    })();
export const FileText2 = /*#__PURE__*/ (() => {
        function FileText2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function FileText2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileText2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileText2.SVG = FileText2SVG;
        return FileText2;
    })();
export const FileText3 = /*#__PURE__*/ (() => {
        function FileText3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function FileText3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileText3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileText3.SVG = FileText3SVG;
        return FileText3;
    })();
export const FilePicture = /*#__PURE__*/ (() => {
        function FilePictureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 14h-10v-2l3-5 4.109 5 2.891-2v4z" }),
_('path', { d: "M13 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FilePicture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePicture.SVG = FilePictureSVG;
        return FilePicture;
    })();
export const FilePicture2 = /*#__PURE__*/ (() => {
        function FilePicture2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM13 14h-10v-2l3-5 4.109 5 2.891-2v4zM11.5 9c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5z" })
            );
        }
        function FilePicture2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePicture2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePicture2.SVG = FilePicture2SVG;
        return FilePicture2;
    })();
export const FileMusic = /*#__PURE__*/ (() => {
        function FileMusicSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M11.817 6.113c-0.116-0.095-0.268-0.133-0.415-0.104l-5 1c-0.234 0.047-0.402 0.252-0.402 0.49v3.701c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-3.59l4-0.8v2.091c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-5c0-0.15-0.067-0.292-0.183-0.387z" })
            );
        }
        function FileMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMusic.SVG = FileMusicSVG;
        return FileMusic;
    })();
export const FileMusic2 = /*#__PURE__*/ (() => {
        function FileMusic2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM12 12.5c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-2.091l-4 0.8v3.59c0 0.828-0.895 1.5-2 1.5s-2-0.672-2-1.5 0.895-1.5 2-1.5c0.364 0 0.706 0.073 1 0.201v-3.701c0-0.238 0.168-0.444 0.402-0.49l5-1c0.147-0.029 0.299 0.009 0.415 0.104s0.183 0.237 0.183 0.387v5z" })
            );
        }
        function FileMusic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileMusic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileMusic2.SVG = FileMusic2SVG;
        return FileMusic2;
    })();
export const FilePlay = /*#__PURE__*/ (() => {
        function FilePlaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6l5 3.5-5 3.5v-7z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FilePlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePlay.SVG = FilePlaySVG;
        return FilePlay;
    })();
export const FilePlay2 = /*#__PURE__*/ (() => {
        function FilePlay2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM6 13v-7l5 3.5-5 3.5z" })
            );
        }
        function FilePlay2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePlay2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePlay2.SVG = FilePlay2SVG;
        return FilePlay2;
    })();
export const FileVideo = /*#__PURE__*/ (() => {
        function FileVideoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M4 8h5v5h-5v-5z" }),
_('path', { d: "M9 10l3-2v5l-3-2z" })
            );
        }
        function FileVideo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileVideoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileVideo.SVG = FileVideoSVG;
        return FileVideo;
    })();
export const FileVideo2 = /*#__PURE__*/ (() => {
        function FileVideo2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM12 14l-3-2v2h-5v-5h5v2l3-2v5z" })
            );
        }
        function FileVideo2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileVideo2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileVideo2.SVG = FileVideo2SVG;
        return FileVideo2;
    })();
export const Copy = /*#__PURE__*/ (() => {
    function CopySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 2h-1v1h0.5v8h-4v4h-6v-12h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h7.875l3.625-3.625v-9.875c0-0.275-0.225-0.5-0.5-0.5zM10 15v-3h3l-3 3zM12 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM9 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998z" })
        );
    }
    function Copy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CopySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Copy.SVG = CopySVG;
    return Copy;
})();
export const Copy2 = /*#__PURE__*/ (() => {
    function Copy2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 2c0.275 0 0.5 0.225 0.5 0.5v9.5l-4 4h-7.5c-0.275 0-0.5-0.225-0.5-0.5v-13c0-0.275 0.225-0.5 0.5-0.5h1v1h-0.5v12h6v-4h4v-8h-0.5v-1h1zM12 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM9 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998z" })
        );
    }
    function Copy2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Copy2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Copy2.SVG = Copy2SVG;
    return Copy2;
})();
export const FileZip = /*#__PURE__*/ (() => {
        function FileZipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M4 1h2v1h-2v-1z" }),
_('path', { d: "M6 2h2v1h-2v-1z" }),
_('path', { d: "M4 3h2v1h-2v-1z" }),
_('path', { d: "M6 4h2v1h-2v-1z" }),
_('path', { d: "M4 5h2v1h-2v-1z" }),
_('path', { d: "M6 6h2v1h-2v-1z" }),
_('path', { d: "M4 7h2v1h-2v-1z" }),
_('path', { d: "M6 8h2v1h-2v-1z" }),
_('path', { d: "M4 13.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-1.25v-1h-2v4.25zM7 12v1h-2v-1h2z" })
            );
        }
        function FileZip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileZipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileZip.SVG = FileZipSVG;
        return FileZip;
    })();
export const FileZip2 = /*#__PURE__*/ (() => {
        function FileZip2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM7 3h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h1.25c0.412 0 0.75 0.338 0.75 0.75v2.5c0 0.412-0.338 0.75-0.75 0.75h-2.5c-0.413 0-0.75-0.338-0.75-0.75v-4.25h2v-1h-2v-1h2v-1h-2v-1h2v-1h-2v-1h2v-1h-2v-1h2v1h2v1z" }),
_('path', { d: "M4 12h2v1h-2v-1z" })
            );
        }
        function FileZip2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileZip2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileZip2.SVG = FileZip2SVG;
        return FileZip2;
    })();
export const FileXml = /*#__PURE__*/ (() => {
        function FileXmlSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 9l-1-1-3 3 3 3 1-1-2-2 2-2z" }),
_('path', { d: "M8.5 13l1 1 3-3-3-3-1 1 2 2-2 2z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FileXml({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileXmlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileXml.SVG = FileXmlSVG;
        return FileXml;
    })();
export const FileXml2 = /*#__PURE__*/ (() => {
        function FileXml2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM7.5 13l-1 1-3-3 3-3 1 1-2 2 2 2zM9.5 14l-1-1 2-2-2-2 1-1 3 3-3 3z" })
            );
        }
        function FileXml2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileXml2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileXml2.SVG = FileXml2SVG;
        return FileXml2;
    })();
export const FileCss = /*#__PURE__*/ (() => {
        function FileCssSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M6.5 13c-0.276 0-0.5-0.224-0.5-0.5v-1.25c0-0.281-0.093-0.541-0.251-0.75 0.157-0.209 0.251-0.469 0.251-0.75v-1.25c0-0.276 0.224-0.5 0.5-0.5s0.5-0.224 0.5-0.5-0.224-0.5-0.5-0.5c-0.827 0-1.5 0.673-1.5 1.5v1.25c0 0.138-0.112 0.25-0.25 0.25h-0.25c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.25c0.138 0 0.25 0.112 0.25 0.25v1.25c0 0.827 0.673 1.5 1.5 1.5 0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M9.5 13c0.276 0 0.5-0.224 0.5-0.5v-1.25c0-0.281 0.093-0.541 0.251-0.75-0.157-0.209-0.251-0.469-0.251-0.75v-1.25c0-0.276-0.224-0.5-0.5-0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5c0.827 0 1.5 0.673 1.5 1.5v1.25c0 0.138 0.112 0.25 0.25 0.25h0.25c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.25c-0.138 0-0.25 0.112-0.25 0.25v1.25c0 0.827-0.673 1.5-1.5 1.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5z" })
            );
        }
        function FileCss({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCssSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCss.SVG = FileCssSVG;
        return FileCss;
    })();
export const FileCss2 = /*#__PURE__*/ (() => {
        function FileCss2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM6 11.25v1.25c0 0.276 0.224 0.5 0.5 0.5s0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5c-0.827 0-1.5-0.673-1.5-1.5v-1.25c0-0.138-0.112-0.25-0.25-0.25h-0.25c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.25c0.138 0 0.25-0.112 0.25-0.25v-1.25c0-0.827 0.673-1.5 1.5-1.5 0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5v1.25c0 0.281-0.093 0.541-0.251 0.75 0.157 0.209 0.251 0.469 0.251 0.75zM11.5 11h-0.25c-0.138 0-0.25 0.112-0.25 0.25v1.25c0 0.827-0.673 1.5-1.5 1.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c0.276 0 0.5-0.224 0.5-0.5v-1.25c0-0.281 0.093-0.541 0.251-0.75-0.157-0.209-0.251-0.469-0.251-0.75v-1.25c0-0.276-0.224-0.5-0.5-0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5c0.827 0 1.5 0.673 1.5 1.5v1.25c0 0.138 0.112 0.25 0.25 0.25h0.25c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function FileCss2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileCss2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileCss2.SVG = FileCss2SVG;
        return FileCss2;
    })();
export const FilePresentation = /*#__PURE__*/ (() => {
        function FilePresentationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 8h3v1h-3v-1zM3 10h3v1h-3v-1zM3 12h3v1h-3v-1zM9 11h2.95c-0.232 1.141-1.24 2-2.45 2-1.381 0-2.5-1.119-2.5-2.5 0-1.209 0.859-2.218 2-2.45v2.95zM10.5 7c1.381 0 2.5 1.119 2.5 2.5 0 0.171-0.017 0.338-0.050 0.5h-2.95v-2.95c0.162-0.033 0.329-0.050 0.5-0.050z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FilePresentation({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePresentationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePresentation.SVG = FilePresentationSVG;
        return FilePresentation;
    })();
export const FilePresentation2 = /*#__PURE__*/ (() => {
        function FilePresentation2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM6 14h-3v-1h3v1zM6 12h-3v-1h3v1zM6 10h-3v-1h3v1zM9.5 14c-1.381 0-2.5-1.119-2.5-2.5 0-1.209 0.859-2.218 2-2.45v2.95h2.95c-0.232 1.141-1.24 2-2.45 2zM12.95 11h-2.95v-2.95c0.162-0.033 0.329-0.050 0.5-0.050 1.381 0 2.5 1.119 2.5 2.5 0 0.171-0.017 0.338-0.050 0.5z" })
            );
        }
        function FilePresentation2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePresentation2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePresentation2.SVG = FilePresentation2SVG;
        return FilePresentation2;
    })();
export const FileStats = /*#__PURE__*/ (() => {
        function FileStatsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M4 5h2v9h-2v-9z" }),
_('path', { d: "M7 9h2v5h-2v-5z" }),
_('path', { d: "M10 11h2v3h-2v-3z" })
            );
        }
        function FileStats({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileStatsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileStats.SVG = FileStatsSVG;
        return FileStats;
    })();
export const FileStats2 = /*#__PURE__*/ (() => {
        function FileStats2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM6 14h-2v-9h2v9zM9 14h-2v-5h2v5zM12 14h-2v-3h2v3z" })
            );
        }
        function FileStats2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileStats2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileStats2.SVG = FileStats2SVG;
        return FileStats2;
    })();
export const FileLocked = /*#__PURE__*/ (() => {
        function FileLockedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M10.5 9h-0.5v-2.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v2.5h-0.5c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h5c0.275 0 0.5-0.225 0.5-0.5v-4c0-0.275-0.225-0.5-0.5-0.5zM7 7h2v2h-2v-2z" })
            );
        }
        function FileLocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileLockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileLocked.SVG = FileLockedSVG;
        return FileLocked;
    })();
export const FileLocked2 = /*#__PURE__*/ (() => {
        function FileLocked2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M7 7h2v2h-2v-2z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM11 13.5c0 0.275-0.225 0.5-0.5 0.5h-5c-0.275 0-0.5-0.225-0.5-0.5v-4c0-0.275 0.225-0.5 0.5-0.5h0.5v-2.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v2.5h0.5c0.275 0 0.5 0.225 0.5 0.5v4z" })
            );
        }
        function FileLocked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileLocked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileLocked2.SVG = FileLocked2SVG;
        return FileLocked2;
    })();
export const FileSpreadsheet = /*#__PURE__*/ (() => {
        function FileSpreadsheetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" }),
_('path', { d: "M3 7v7h10v-7h-10zM6 13h-2v-2h2v2zM6 10h-2v-2h2v2zM9 13h-2v-2h2v2zM9 10h-2v-2h2v2zM12 13h-2v-2h2v2zM12 10h-2v-2h2v2z" })
            );
        }
        function FileSpreadsheet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileSpreadsheetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileSpreadsheet.SVG = FileSpreadsheetSVG;
        return FileSpreadsheet;
    })();
export const FileSpreadsheet2 = /*#__PURE__*/ (() => {
        function FileSpreadsheet2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 4h3.627c-0.078-0.126-0.172-0.266-0.286-0.421-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.155-0.114-0.295-0.208-0.421-0.286v3.627z" }),
_('path', { d: "M7 11h2v2h-2v-2z" }),
_('path', { d: "M10 11h2v2h-2v-2z" }),
_('path', { d: "M10 8h2v2h-2v-2z" }),
_('path', { d: "M7 8h2v2h-2v-2z" }),
_('path', { d: "M10.5 5c-0.276 0-0.5-0.224-0.5-0.5v-4.5h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75h-4.5zM13 14h-10v-7h10v7z" }),
_('path', { d: "M4 8h2v2h-2v-2z" }),
_('path', { d: "M4 11h2v2h-2v-2z" })
            );
        }
        function FileSpreadsheet2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileSpreadsheet2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileSpreadsheet2.SVG = FileSpreadsheet2SVG;
        return FileSpreadsheet2;
    })();
export const Copy3 = /*#__PURE__*/ (() => {
    function Copy3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3 3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z" })
        );
    }
    function Copy3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Copy3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Copy3.SVG = Copy3SVG;
    return Copy3;
})();
export const Copy4 = /*#__PURE__*/ (() => {
    function Copy4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 4h-3v-1l-3-3h-7v12h6v4h10v-9l-3-3zM13 5.414l1.586 1.586h-1.586v-1.586zM7 1.414l1.586 1.586h-1.586v-1.586zM1 1h5v3h3v7h-8v-10zM15 15h-8v-3h3v-7h2v3h3v7z" })
        );
    }
    function Copy4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Copy4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Copy4.SVG = Copy4SVG;
    return Copy4;
})();
export const Paste = /*#__PURE__*/ (() => {
    function PasteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-6v7h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h7l3-3v-8h-3zM13 14.586v-1.586h1.586l-1.586 1.586zM15 12h-3v3h-5v-9h8v6z" })
        );
    }
    function Paste({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PasteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paste.SVG = PasteSVG;
    return Paste;
})();
export const Paste2 = /*#__PURE__*/ (() => {
    function Paste2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-3.5v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-3.5c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h7l3-3v-8h-3zM6 1.002c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-2v-0.998zM3 4v-1h8v1h-8zM13 14.586v-1.586h1.586l-1.586 1.586zM15 12h-3v3h-5v-9h8v6z" })
        );
    }
    function Paste2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Paste2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paste2.SVG = Paste2SVG;
    return Paste2;
})();
export const Paste3 = /*#__PURE__*/ (() => {
        function Paste3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 8v2h0.5l0.5-1h1v4h-0.75v1h3.5v-1h-0.75v-4h1l0.5 1h0.5v-2z" }),
_('path', { d: "M13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-3.5v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-3.5c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM6 1.002c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-2v-0.998zM3 4v-1h8v1h-8zM15 15h-8v-9h8v9z" })
            );
        }
        function Paste3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Paste3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Paste3.SVG = Paste3SVG;
        return Paste3;
    })();
export const Paste4 = /*#__PURE__*/ (() => {
    function Paste4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-3l-3 3v4h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM9 6.414v1.586h-1.586l1.586-1.586zM15 15h-8v-6h3v-3h5v9z" })
        );
    }
    function Paste4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Paste4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paste4.SVG = Paste4SVG;
    return Paste4;
})();
export const Stack = /*#__PURE__*/ (() => {
    function StackSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.75 4h-0.75v-0.75c0-0.689-0.561-1.25-1.25-1.25h-0.75v-0.75c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v9.5c0 0.689 0.561 1.25 1.25 1.25h0.75v0.75c0 0.689 0.561 1.25 1.25 1.25h0.75v0.75c0 0.689 0.561 1.25 1.25 1.25h7.5c0.689 0 1.25-0.561 1.25-1.25v-9.5c0-0.689-0.561-1.25-1.25-1.25zM2.25 11c-0.138 0-0.25-0.113-0.25-0.25v-9.5c0-0.137 0.112-0.25 0.25-0.25h7.5c0.137 0 0.25 0.113 0.25 0.25v0.75h-5.75c-0.689 0-1.25 0.561-1.25 1.25v7.75h-0.75zM4.25 13c-0.138 0-0.25-0.113-0.25-0.25v-9.5c0-0.138 0.112-0.25 0.25-0.25h7.5c0.137 0 0.25 0.112 0.25 0.25v0.75h-5.75c-0.689 0-1.25 0.561-1.25 1.25v7.75h-0.75zM14 14.75c0 0.137-0.113 0.25-0.25 0.25h-7.5c-0.138 0-0.25-0.113-0.25-0.25v-9.5c0-0.138 0.112-0.25 0.25-0.25h7.5c0.137 0 0.25 0.112 0.25 0.25v9.5z" })
        );
    }
    function Stack({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stack.SVG = StackSVG;
    return Stack;
})();
export const Stack2 = /*#__PURE__*/ (() => {
    function Stack2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z" })
        );
    }
    function Stack2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stack2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stack2.SVG = Stack2SVG;
    return Stack2;
})();
export const Stack3 = /*#__PURE__*/ (() => {
    function Stack3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 9l-8-4 8-4 8 4zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z" })
        );
    }
    function Stack3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stack3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stack3.SVG = Stack3SVG;
    return Stack3;
})();
export const Folder = /*#__PURE__*/ (() => {
    function FolderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h16l-1 10h-14l-1-10zM14.5 3l0.5 1h-14l1-2h5.5l0.5 1h6.5z" })
        );
    }
    function Folder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder.SVG = FolderSVG;
    return Folder;
})();
export const FolderSearch = /*#__PURE__*/ (() => {
        function FolderSearchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 2h-6.5l-0.5-1h-5.5l-1 2h14z" }),
_('path', { d: "M14.13 11h1.17l0.7-7h-16l1 10h7.564c-1.639-0.59-2.814-2.16-2.814-4 0-2.343 1.907-4.25 4.25-4.25s4.25 1.907 4.25 4.25c0 0.339-0.041 0.674-0.12 1z" }),
_('path', { d: "M15.672 14.277l-3.101-2.73c0.273-0.452 0.43-0.981 0.43-1.548 0-1.657-1.343-3-3-3s-3 1.343-3 3 1.343 3 3 3c0.566 0 1.096-0.157 1.548-0.43l2.73 3.101c0.359 0.417 0.971 0.44 1.359 0.051l0.086-0.086c0.389-0.389 0.366-1.001-0.051-1.359zM10 11.938c-1.070 0-1.938-0.867-1.938-1.938s0.867-1.938 1.938-1.938 1.938 0.867 1.938 1.938-0.867 1.938-1.938 1.938z" })
            );
        }
        function FolderSearch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderSearchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderSearch.SVG = FolderSearchSVG;
        return FolderSearch;
    })();
export const FolderDownload = /*#__PURE__*/ (() => {
    function FolderDownloadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM0 5l1 10h14l1-10h-16zM8 14.5l-4.5-4.5h3.5v-2.985h2v2.985h3.5l-4.5 4.5z" })
        );
    }
    function FolderDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderDownload.SVG = FolderDownloadSVG;
    return FolderDownload;
})();
export const FolderUpload = /*#__PURE__*/ (() => {
    function FolderUploadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM0 5l1 10h14l1-10h-16zM9 11v2.985h-2v-2.985h-3.5l4.5-4.5 4.5 4.5h-3.5z" })
        );
    }
    function FolderUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderUpload.SVG = FolderUploadSVG;
    return FolderUpload;
})();
export const FolderPlus = /*#__PURE__*/ (() => {
    function FolderPlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM7.813 12.5c0 0.918 0.266 1.776 0.724 2.5h-7.537l-1-10h16l-0.399 3.988c-0.827-0.731-1.913-1.176-3.101-1.176-2.585 0-4.688 2.103-4.688 4.687zM12.5 9c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5zM13 13v2h-1v-2h-2v-1h2v-2h1v2h2v1h-2z" })
        );
    }
    function FolderPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderPlus.SVG = FolderPlusSVG;
    return FolderPlus;
})();
export const FolderPlus2 = /*#__PURE__*/ (() => {
    function FolderPlus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM0 5l1 10h14l1-10h-16zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z" })
        );
    }
    function FolderPlus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderPlus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderPlus2.SVG = FolderPlus2SVG;
    return FolderPlus2;
})();
export const FolderMinus = /*#__PURE__*/ (() => {
    function FolderMinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM7.813 12.5c0 0.918 0.266 1.776 0.724 2.5h-7.537l-1-10h16l-0.399 3.988c-0.827-0.731-1.913-1.176-3.101-1.176-2.585 0-4.688 2.103-4.688 4.687zM12.5 9c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5 3.5-1.567 3.5-3.5-1.567-3.5-3.5-3.5zM10 13v-1h5v1h-5z" })
        );
    }
    function FolderMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderMinus.SVG = FolderMinusSVG;
    return FolderMinus;
})();
export const FolderMinus2 = /*#__PURE__*/ (() => {
    function FolderMinus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM0 5l1 10h14l1-10h-16zM11 11h-6v-2h6v2z" })
        );
    }
    function FolderMinus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderMinus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderMinus2.SVG = FolderMinus2SVG;
    return FolderMinus2;
})();
export const FolderCheck = /*#__PURE__*/ (() => {
    function FolderCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5zM0 5l1 10h14l1-10h-16zM6.719 13.352l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914-5.207 5.707z" })
        );
    }
    function FolderCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderCheck.SVG = FolderCheckSVG;
    return FolderCheck;
})();
export const FolderHeart = /*#__PURE__*/ (() => {
        function FolderHeartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 3h-6.5l-0.5-1h-5.5l-1 2h14z" }),
_('path', { d: "M0 5l1 10h14l1-10h-16zM11.5 10.494l-0.004 0.004c-0.075 0.088-3.496 3.502-3.496 3.502s-3.418-3.411-3.488-3.492l-0.006-0.006 0.001-0c-0.316-0.371-0.507-0.851-0.507-1.377 0-1.174 0.951-2.125 2.125-2.125 0.812 0 1.517 0.455 1.875 1.125 0.358-0.669 1.063-1.125 1.875-1.125 1.174 0 2.125 0.951 2.125 2.125 0 0.522-0.188 0.999-0.5 1.369l0 0z" })
            );
        }
        function FolderHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FolderHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FolderHeart.SVG = FolderHeartSVG;
        return FolderHeart;
    })();
export const FolderRemove = /*#__PURE__*/ (() => {
    function FolderRemoveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-14l1-2h5.5l0.5 1h6.5l0.5 1zM0 5l1 10h14l1-10h-16zM11.25 7.811l-2.189 2.189 2.189 2.189-1.061 1.061-2.189-2.189-2.189 2.189-1.061-1.061 2.189-2.189-2.189-2.189 1.061-1.061 2.189 2.189 2.189-2.189 1.061 1.061z" })
        );
    }
    function FolderRemove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderRemoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderRemove.SVG = FolderRemoveSVG;
    return FolderRemove;
})();
export const Folder2 = /*#__PURE__*/ (() => {
    function Folder2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 2l2 2h7v11h-16v-13z" })
        );
    }
    function Folder2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Folder2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder2.SVG = Folder2SVG;
    return Folder2;
})();
export const FolderOpen = /*#__PURE__*/ (() => {
    function FolderOpenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z" })
        );
    }
    function FolderOpen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderOpenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderOpen.SVG = FolderOpenSVG;
    return FolderOpen;
})();
export const Folder3 = /*#__PURE__*/ (() => {
    function Folder3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM8.586 5h6.414v0.125h-14v-0.25h7.461l0.125 0.125zM1 14v-0.125h14v0.125h-14zM1 13.625v-0.25h14v0.25h-14zM1 13.125v-0.25h14v0.25h-14zM1 12.625v-0.25h14v0.25h-14zM1 12.125v-0.25h14v0.25h-14zM1 11.625v-0.25h14v0.25h-14zM1 11.125v-0.25h14v0.25h-14zM1 10.625v-0.25h14v0.25h-14zM1 10.125v-0.25h14v0.25h-14zM1 9.625v-0.25h14v0.25h-14zM1 9.125v-0.25h14v0.25h-14zM1 8.625v-0.25h14v0.25h-14zM1 8.125v-0.25h14v0.25h-14zM1 7.625v-0.25h14v0.25h-14zM1 7.125v-0.25h14v0.25h-14zM1 6.625v-0.25h14v0.25h-14zM1 6.125v-0.25h14v0.25h-14zM1 5.625v-0.25h14v0.25h-14zM6.586 3l0.125 0.125h-5.711v-0.125h5.586zM6.961 3.375l0.25 0.25h-6.211v-0.25h5.961zM7.461 3.875l0.25 0.25h-6.711v-0.25h6.461zM7.961 4.375l0.25 0.25h-7.211v-0.25h6.961z" })
        );
    }
    function Folder3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Folder3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder3.SVG = Folder3SVG;
    return Folder3;
})();
export const Folder4 = /*#__PURE__*/ (() => {
    function Folder4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.586 3l2 2h6.414v9h-14v-11h5.586zM7 2h-7v13h16v-11h-7l-2-2z" })
        );
    }
    function Folder4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Folder4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder4.SVG = Folder4SVG;
    return Folder4;
})();
export const FolderPlus3 = /*#__PURE__*/ (() => {
    function FolderPlus3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z" })
        );
    }
    function FolderPlus3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderPlus3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderPlus3.SVG = FolderPlus3SVG;
    return FolderPlus3;
})();
export const FolderMinus3 = /*#__PURE__*/ (() => {
    function FolderMinus3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-6v-2h6v2z" })
        );
    }
    function FolderMinus3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderMinus3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderMinus3.SVG = FolderMinus3SVG;
    return FolderMinus3;
})();
export const FolderPlus4 = /*#__PURE__*/ (() => {
    function FolderPlus4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM15 14h-14v-11h5.586l2 2h6.414v9zM9 7h-2v2h-2v2h2v2h2v-2h2v-2h-2z" })
        );
    }
    function FolderPlus4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderPlus4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderPlus4.SVG = FolderPlus4SVG;
    return FolderPlus4;
})();
export const FolderMinus4 = /*#__PURE__*/ (() => {
    function FolderMinus4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM15 14h-14v-11h5.586l2 2h6.414v9zM5 9h6v2h-6z" })
        );
    }
    function FolderMinus4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderMinus4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderMinus4.SVG = FolderMinus4SVG;
    return FolderMinus4;
})();
export const FolderDownload2 = /*#__PURE__*/ (() => {
    function FolderDownload2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM8 13.5l-3.5-3.5h2.5v-4h2v4h2.5l-3.5 3.5z" })
        );
    }
    function FolderDownload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderDownload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderDownload2.SVG = FolderDownload2SVG;
    return FolderDownload2;
})();
export const FolderUpload2 = /*#__PURE__*/ (() => {
    function FolderUpload2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM8 7.5l3.5 3.5h-2.5v4h-2v-4h-2.5l3.5-3.5z" })
        );
    }
    function FolderUpload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderUpload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderUpload2.SVG = FolderUpload2SVG;
    return FolderUpload2;
})();
export const FolderDownload3 = /*#__PURE__*/ (() => {
    function FolderDownload3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM15 14h-14v-11h5.586l2 2h6.414v9zM9 10v-3h-2v3h-3l4 4 4-4z" })
        );
    }
    function FolderDownload3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderDownload3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderDownload3.SVG = FolderDownload3SVG;
    return FolderDownload3;
})();
export const FolderUpload3 = /*#__PURE__*/ (() => {
    function FolderUpload3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4l-2-2h-7v13h16v-11h-7zM15 14h-6v-3h3l-4-4-4 4h3v3h-6v-11h5.586l2 2h6.414v9z" })
        );
    }
    function FolderUpload3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderUpload3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderUpload3.SVG = FolderUpload3SVG;
    return FolderUpload3;
})();
export const Folder5 = /*#__PURE__*/ (() => {
    function Folder5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.383 4h-14.766c-0.412 0-0.684 0.331-0.603 0.735l1.839 8.529c0.081 0.405 0.485 0.735 0.897 0.735h10.5c0.412 0 0.816-0.331 0.897-0.735l1.839-8.529c0.081-0.404-0.19-0.735-0.603-0.735zM14 2.75c0-0.414-0.336-0.75-0.75-0.75h-6.75l-0.5-1h-3.25c-0.414 0-0.75 0.336-0.75 0.75v1.25h12v-0.25z" })
        );
    }
    function Folder5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Folder5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder5.SVG = Folder5SVG;
    return Folder5;
})();
export const FolderOpen2 = /*#__PURE__*/ (() => {
    function FolderOpen2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.383 6c0.412 0 0.684 0.331 0.603 0.735l-1.839 6.529c-0.081 0.405-0.485 0.735-0.897 0.735h-10.5c-0.413 0-0.816-0.331-0.897-0.735l-1.839-6.529c-0.081-0.404 0.19-0.735 0.603-0.735h14.766zM14 2.75v2.25h-12v-3.25c0-0.414 0.336-0.75 0.75-0.75h3.25l0.5 1h6.75c0.414 0 0.75 0.336 0.75 0.75z" })
        );
    }
    function FolderOpen2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderOpen2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderOpen2.SVG = FolderOpen2SVG;
    return FolderOpen2;
})();
export const Folder6 = /*#__PURE__*/ (() => {
    function Folder6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.383 4h-1.383v-1.25c0-0.414-0.336-0.75-0.75-0.75h-6.75l-0.5-1h-3.25c-0.414 0-0.75 0.336-0.75 0.75v2.25h-1.383c-0.412 0-0.684 0.331-0.603 0.735l1.839 8.529c0.081 0.405 0.485 0.735 0.897 0.735h10.5c0.412 0 0.816-0.331 0.897-0.735l1.839-8.529c0.081-0.404-0.19-0.735-0.603-0.735zM3 2h2.382l0.5 1h7.118v1h-10v-2zM13.181 13h-10.362l-1.725-8h13.811l-1.725 8z" })
        );
    }
    function Folder6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Folder6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Folder6.SVG = Folder6SVG;
    return Folder6;
})();
export const FolderOpen3 = /*#__PURE__*/ (() => {
    function FolderOpen3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.383 6h-1.383v-3.25c0-0.414-0.336-0.75-0.75-0.75h-6.75l-0.5-1h-3.25c-0.414 0-0.75 0.336-0.75 0.75v4.25h-1.383c-0.412 0-0.684 0.331-0.603 0.735l1.839 6.529c0.081 0.405 0.485 0.735 0.897 0.735h10.5c0.412 0 0.816-0.331 0.897-0.735l1.839-6.529c0.081-0.404-0.19-0.735-0.603-0.735zM3 2h2.382l0.5 1h7.118v3h-10v-4zM13.181 13h-10.362l-1.725-6h13.811l-1.725 6z" })
        );
    }
    function FolderOpen3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FolderOpen3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FolderOpen3.SVG = FolderOpen3SVG;
    return FolderOpen3;
})();
export const Certificate = /*#__PURE__*/ (() => {
        function CertificateSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 0v16h14v-16h-14zM14 15h-12v-14h12v14zM3 3h5v1h-5v-1zM3 5h5v1h-5v-1zM3 7h5v1h-5v-1zM3 8.99h5v1h-5v-1zM3 11h5v1h-5v-1zM3 13h10v1h-10v-1zM13 3.414l-0.586 0.586 0.586 0.586v0.414h-1v1h-0.414l-0.586-0.586-0.586 0.586h-0.414v-1h-1v-0.414l0.586-0.586-0.586-0.586v-0.414h1v-1h0.414l0.586 0.586 0.586-0.586h0.414v1h1v0.414z" }),
_('path', { d: "M12 7v4.5l-1-1-1 1v-4.5z" })
            );
        }
        function Certificate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CertificateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Certificate.SVG = CertificateSVG;
        return Certificate;
    })();
export const Cc = /*#__PURE__*/ (() => {
    function CcSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.989 0c-2.192 0-4.121 0.811-5.611 2.323-1.534 1.556-2.367 3.573-2.367 5.677 0 2.126 0.811 4.098 2.345 5.633s3.529 2.367 5.633 2.367 4.143-0.833 5.721-2.389c1.491-1.469 2.279-3.419 2.279-5.611 0-2.17-0.789-4.143-2.301-5.655-1.534-1.534-3.507-2.345-5.699-2.345zM8.011 1.447c1.797 0 3.397 0.679 4.647 1.929 1.227 1.228 1.885 2.849 1.885 4.625 0 1.797-0.636 3.375-1.863 4.581-1.293 1.271-2.959 1.951-4.669 1.951-1.731 0-3.354-0.679-4.603-1.929s-1.951-2.893-1.951-4.603c0-1.732 0.702-3.375 1.951-4.647 1.227-1.249 2.806-1.907 4.603-1.907zM7.908 6.671c-0.452-0.824-1.223-1.152-2.118-1.152-1.303 0-2.34 0.922-2.34 2.481 0 1.586 0.975 2.481 2.384 2.481 0.904 0 1.675-0.496 2.1-1.249l-0.993-0.505c-0.222 0.532-0.558 0.691-0.984 0.691-0.735 0-1.072-0.611-1.072-1.418s0.284-1.418 1.072-1.418c0.213 0 0.638 0.115 0.886 0.647l1.063-0.558zM12.523 6.671c-0.452-0.824-1.223-1.152-2.118-1.152-1.303 0-2.34 0.922-2.34 2.481 0 1.586 0.975 2.481 2.384 2.481 0.904 0 1.675-0.496 2.1-1.249l-0.993-0.505c-0.221 0.532-0.558 0.691-0.984 0.691-0.735 0-1.072-0.611-1.072-1.418s0.284-1.418 1.072-1.418c0.213 0 0.638 0.115 0.887 0.647l1.063-0.558z" })
        );
    }
    function Cc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CcSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cc.SVG = CcSVG;
    return Cc;
})();
export const PriceTag = /*#__PURE__*/ (() => {
    function PriceTagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 8h1v2h-1zM8 11h1v2h-1zM12.514 4.47l-3.611-3.939c-0.267-0.292-0.796-0.53-1.174-0.53h-0.458c-0.378 0-0.906 0.239-1.174 0.53l-3.611 3.939c-0.267 0.292-0.486 0.868-0.486 1.28v9.5c0 0.412 0.309 0.75 0.688 0.75h9.625c0.378 0 0.688-0.338 0.688-0.75v-9.5c0-0.412-0.219-0.989-0.486-1.28zM10 8h-2v2h2v4h-2v1h-1v-1h-2v-1h2v-2h-2v-4h2v-1h1v1h2v1zM8.281 2.5c0 0.431-0.35 0.781-0.781 0.781s-0.781-0.35-0.781-0.781 0.35-0.781 0.781-0.781 0.781 0.35 0.781 0.781z" })
        );
    }
    function PriceTag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PriceTagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PriceTag.SVG = PriceTagSVG;
    return PriceTag;
})();
export const PriceTag2 = /*#__PURE__*/ (() => {
    function PriceTag2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function PriceTag2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PriceTag2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PriceTag2.SVG = PriceTag2SVG;
    return PriceTag2;
})();
export const PriceTags = /*#__PURE__*/ (() => {
        function PriceTagsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z" })
            );
        }
        function PriceTags({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTagsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTags.SVG = PriceTagsSVG;
        return PriceTags;
    })();
export const PriceTag3 = /*#__PURE__*/ (() => {
        function PriceTag3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 1v5.75c0 0.147-0.133 0.469-0.237 0.573l-7.263 7.263-6.086-6.086 7.263-7.263c0.104-0.104 0.426-0.237 0.573-0.237h5.75zM15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.146 0.146 0.338 0.219 0.53 0.219s0.385-0.073 0.53-0.219l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75v0z" }),
_('path', { d: "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function PriceTag3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTag3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTag3.SVG = PriceTag3SVG;
        return PriceTag3;
    })();
export const PriceTags2 = /*#__PURE__*/ (() => {
        function PriceTags2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M19 1v5.75c0 0.147-0.133 0.469-0.237 0.573l-7.263 7.263-6.086-6.086 7.263-7.263c0.104-0.104 0.426-0.237 0.573-0.237h5.75zM19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.146 0.146 0.338 0.219 0.53 0.219s0.384-0.073 0.53-0.219l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75v0z" }),
_('path', { d: "M17 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M9.914 0h-0.664c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.146 0.146 0.338 0.219 0.53 0.219s0.385-0.073 0.53-0.219l0.177-0.177-6.793-6.793 8.5-8.5z" })
            );
        }
        function PriceTags2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTags2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTags2.SVG = PriceTags2SVG;
        return PriceTags2;
    })();
export const PriceTag4 = /*#__PURE__*/ (() => {
    function PriceTag4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.47 7.97l-4.439-4.439c-0.292-0.292-0.868-0.53-1.28-0.53h-9c-0.412 0-0.75 0.337-0.75 0.75v9.5c0 0.412 0.338 0.75 0.75 0.75h9c0.412 0 0.989-0.239 1.28-0.53l4.439-4.439c0.292-0.292 0.292-0.769-0-1.061zM10.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function PriceTag4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PriceTag4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PriceTag4.SVG = PriceTag4SVG;
    return PriceTag4;
})();
export const PriceTags3 = /*#__PURE__*/ (() => {
        function PriceTags3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17.47 9.97l-4.439-4.439c-0.292-0.292-0.868-0.53-1.28-0.53h-9c-0.413 0-0.75 0.338-0.75 0.75v9.5c0 0.412 0.337 0.75 0.75 0.75h9c0.412 0 0.989-0.239 1.28-0.53l4.439-4.439c0.292-0.292 0.292-0.769-0-1.061zM12.5 12c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M1 4h10.5l-0.47-0.47c-0.292-0.292-0.868-0.53-1.28-0.53h-9c-0.412 0-0.75 0.337-0.75 0.75v9.5c0 0.412 0.338 0.75 0.75 0.75h0.25v-10z" })
            );
        }
        function PriceTags3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTags3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTags3.SVG = PriceTags3SVG;
        return PriceTags3;
    })();
export const PriceTag5 = /*#__PURE__*/ (() => {
        function PriceTag5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.75 4c0.148 0 0.469 0.133 0.573 0.237l4.263 4.263-4.263 4.263c-0.104 0.104-0.426 0.237-0.573 0.237h-8.75v-9h8.75zM9.75 3h-9c-0.412 0-0.75 0.337-0.75 0.75v9.5c0 0.412 0.338 0.75 0.75 0.75h9c0.412 0 0.989-0.239 1.28-0.53l4.439-4.439c0.292-0.292 0.292-0.769 0-1.061l-4.439-4.439c-0.292-0.292-0.868-0.53-1.28-0.53v0z" }),
_('path', { d: "M12 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function PriceTag5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTag5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTag5.SVG = PriceTag5SVG;
        return PriceTag5;
    })();
export const PriceTags4 = /*#__PURE__*/ (() => {
        function PriceTags4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.75 6c0.148 0 0.469 0.133 0.573 0.237l4.263 4.263-4.263 4.263c-0.104 0.104-0.426 0.237-0.573 0.237h-8.75v-9h8.75zM11.75 5h-9c-0.413 0-0.75 0.338-0.75 0.75v9.5c0 0.412 0.337 0.75 0.75 0.75h9c0.412 0 0.989-0.239 1.28-0.53l4.439-4.439c0.292-0.292 0.292-0.769 0-1.061l-4.439-4.439c-0.292-0.292-0.868-0.53-1.28-0.53v0z" }),
_('path', { d: "M14 10.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M1 13v-9h10.5l-0.47-0.47c-0.292-0.292-0.868-0.53-1.28-0.53h-9c-0.412 0-0.75 0.337-0.75 0.75v9.5c0 0.412 0.338 0.75 0.75 0.75h0.25v-1z" })
            );
        }
        function PriceTags4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PriceTags4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PriceTags4.SVG = PriceTags4SVG;
        return PriceTags4;
    })();
export const Barcode = /*#__PURE__*/ (() => {
    function BarcodeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3h2v10h-2zM3 3h1v10h-1zM5 3h1v10h-1zM8 3h1v10h-1zM12 3h1v10h-1zM15 3h1v10h-1zM10 3h0.5v10h-0.5zM7 3h0.5v10h-0.5zM13.5 3h0.5v10h-0.5z" })
        );
    }
    function Barcode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BarcodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Barcode.SVG = BarcodeSVG;
    return Barcode;
})();
export const Barcode2 = /*#__PURE__*/ (() => {
    function Barcode2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z" })
        );
    }
    function Barcode2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Barcode2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Barcode2.SVG = Barcode2SVG;
    return Barcode2;
})();
export const Qrcode = /*#__PURE__*/ (() => {
    function QrcodeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z" })
        );
    }
    function Qrcode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QrcodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Qrcode.SVG = QrcodeSVG;
    return Qrcode;
})();
export const Ticket = /*#__PURE__*/ (() => {
    function TicketSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 5l2 2-4 4-2-2zM15.649 4.649l-1.149-1.149-0.5 0.5c-0.256 0.256-0.61 0.414-1 0.414-0.781 0-1.414-0.633-1.414-1.414 0-0.391 0.158-0.744 0.415-1l0.5-0.5-1.149-1.149c-0.468-0.468-1.235-0.468-1.703 0l-9.297 9.297c-0.468 0.468-0.468 1.235 0 1.703l1.149 1.149 0.499-0.499c0.256-0.256 0.61-0.415 1.001-0.415 0.781 0 1.414 0.633 1.414 1.414 0 0.391-0.158 0.744-0.415 1l-0.5 0.5 1.149 1.149c0.468 0.468 1.234 0.468 1.703 0l9.297-9.297c0.468-0.468 0.468-1.235 0-1.703zM7 13l-4-4 6-6 4 4-6 6z" })
        );
    }
    function Ticket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TicketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ticket.SVG = TicketSVG;
    return Ticket;
})();
export const Ticket2 = /*#__PURE__*/ (() => {
    function Ticket2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 17 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 17 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6v-2.25c0-0.413-0.338-0.75-0.75-0.75h-11.5c0.138 0 0.25 0.112 0.25 0.25s-0.112 0.25-0.25 0.25-0.25-0.112-0.25-0.25 0.112-0.25 0.25-0.25h-3c-0.412 0-0.75 0.337-0.75 0.75v2.25c1.105 0 2 0.895 2 2s-0.895 2-2 2v2.25c0 0.412 0.338 0.75 0.75 0.75h3c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25h11.5c0.412 0 0.75-0.338 0.75-0.75v-2.25c-1.105 0-2-0.895-2-2s0.895-2 2-2zM3.75 12c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 11c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 10c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 9c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 7.5c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 6.5c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 5.5c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM3.75 4.5c-0.138 0-0.25-0.112-0.25-0.25s0.112-0.25 0.25-0.25 0.25 0.112 0.25 0.25-0.112 0.25-0.25 0.25zM10.373 10.578l-1.873-1.361-1.873 1.361 0.715-2.201-1.873-1.361h2.315l0.715-2.202 0.715 2.202h2.315l-1.873 1.361 0.715 2.201z" })
        );
    }
    function Ticket2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Ticket2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ticket2.SVG = Ticket2SVG;
    return Ticket2;
})();
export const Theater = /*#__PURE__*/ (() => {
        function TheaterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.977 0c-1.721 0.611-3.773 1.215-5.977 1.215s-4.256-0.605-5.977-1.215c-0.015 0.318-0.023 0.64-0.023 0.965 0 6.094 2.686 11.035 6 11.035s6-4.94 6-11.035c0-0.325-0.008-0.647-0.023-0.965zM7 4c0-0.552 0.672-1 1.5-1s1.5 0.448 1.5 1h-3zM11 10c-1.314 0-2.431-1.268-2.837-3.033 0.725 0.638 1.728 1.033 2.837 1.033s2.112-0.395 2.837-1.033c-0.406 1.765-1.522 3.033-2.837 3.033zM12 4c0-0.552 0.672-1 1.5-1s1.5 0.448 1.5 1h-3z" }),
_('path', { d: "M7.935 12.089c-0.844-0.657-1.592-1.577-2.221-2.735-0.562-1.034-1.008-2.219-1.327-3.502-1.597-0.096-3.082-0.396-4.366-0.852-0.014 0.292-0.021 0.587-0.021 0.885 0 5.586 2.462 10.115 5.5 10.115 1.547 0 2.945-1.175 3.944-3.066-0.52-0.187-1.024-0.469-1.508-0.845zM2 8h2c0 0.552-0.448 1-1 1s-1-0.448-1-1zM5.5 12.969c-0.672 0-1.309 0.131-1.881 0.365 0.458-0.837 1.131-1.365 1.881-1.365s1.423 0.529 1.881 1.365c-0.572-0.234-1.209-0.365-1.881-0.365z" })
            );
        }
        function Theater({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TheaterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Theater.SVG = TheaterSVG;
        return Theater;
    })();
export const Store = /*#__PURE__*/ (() => {
        function StoreSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 15v-6h-12v6h-1v1h14v-1h-1zM8 14h-4v-3h4v3z" }),
_('path', { d: "M14 1h-12l-2 4v3h3v-2h1v2h2v-2h1v2h2v-2h1v2h2v-2h1v2h3v-3z" })
            );
        }
        function Store({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StoreSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Store.SVG = StoreSVG;
        return Store;
    })();
export const Store2 = /*#__PURE__*/ (() => {
        function Store2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5zM6 12h-2v-2h2v2z" }),
_('path', { d: "M16 6v-4.5c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5v4.5c0 0.739 0.403 1.385 1 1.731v7.269h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.5v-7.269c0.597-0.346 1-0.992 1-1.731zM10 2h2v4c0 0.551-0.449 1-1 1s-1-0.449-1-1v-4zM4 2h2v4c0 0.551-0.449 1-1 1s-1-0.449-1-1v-4zM12 15h-2v-4h2v4zM14 15h-1v-4.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v4.5h-7v-7c0.597 0 1.133-0.263 1.5-0.679 0.367 0.416 0.903 0.679 1.5 0.679s1.133-0.263 1.5-0.679c0.367 0.416 0.903 0.679 1.5 0.679s1.133-0.263 1.5-0.679c0.367 0.416 0.903 0.679 1.5 0.679s1.133-0.263 1.5-0.679c0.367 0.416 0.903 0.679 1.5 0.679v7z" })
            );
        }
        function Store2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Store2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Store2.SVG = Store2SVG;
        return Store2;
    })();
export const Cart = /*#__PURE__*/ (() => {
        function CartSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M16 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M16 8v-6h-12c0-0.552-0.448-1-1-1h-3v1h2l0.751 6.438c-0.458 0.367-0.751 0.93-0.751 1.562 0 1.105 0.895 2 2 2h12v-1h-12c-0.552 0-1-0.448-1-1 0-0.003 0-0.007 0-0.010l13-1.99z" })
            );
        }
        function Cart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cart.SVG = CartSVG;
        return Cart;
    })();
export const Cart2 = /*#__PURE__*/ (() => {
        function Cart2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.238 9c0.55 0 1.124-0.433 1.275-0.962l1.451-5.077c0.151-0.529-0.175-0.962-0.725-0.962h-10.238c0-1.105-0.895-2-2-2h-3v2h3v8.5c0 0.828 0.672 1.5 1.5 1.5h9.5c0.552 0 1-0.448 1-1s-0.448-1-1-1h-9v-1h8.238zM5 4h9.044l-0.857 3h-8.187v-3z" }),
_('path', { d: "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M15 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function Cart2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cart2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cart2.SVG = Cart2SVG;
        return Cart2;
    })();
export const Cart3 = /*#__PURE__*/ (() => {
        function Cart3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.238 9c0.55 0 1.124-0.433 1.275-0.962l1.451-5.077c0.151-0.529-0.175-0.962-0.725-0.962h-10.238c0-1.105-0.895-2-2-2h-3v2h3v8.5c0 0.828 0.672 1.5 1.5 1.5h9.5c0.552 0 1-0.448 1-1s-0.448-1-1-1h-9v-1h8.238zM5 7v-0.125h8.222l-0.036 0.125h-8.187zM13.794 4.875l-0.071 0.25h-8.722v-0.25h8.794zM5 4.625v-0.25h8.937l-0.071 0.25h-8.865zM13.651 5.375l-0.071 0.25h-8.58v-0.25h8.651zM13.508 5.875l-0.071 0.25h-8.437v-0.25h8.508zM13.365 6.375l-0.071 0.25h-8.294v-0.25h8.365zM14.044 4l-0.036 0.125h-9.008v-0.125h9.044z" }),
_('path', { d: "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M15 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function Cart3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cart3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cart3.SVG = Cart3SVG;
        return Cart3;
    })();
export const Cart4 = /*#__PURE__*/ (() => {
    function Cart4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.275 3.038c0.531 0.152 0.839 0.705 0.687 1.236l-2 7c-0.123 0.429-0.515 0.725-0.962 0.725h-8.5c-0.504 0-0.93-0.376-0.992-0.876l-0.89-7.124h-1.617c-0.552 0-1-0.448-1-1s0.448-1 1-1h2.5c0.504 0 0.93 0.376 0.992 0.876l0.891 7.124h6.863l1.793-6.275c0.152-0.531 0.705-0.838 1.236-0.687zM4 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM10 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" })
        );
    }
    function Cart4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cart4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cart4.SVG = Cart4SVG;
    return Cart4;
})();
export const Cart5 = /*#__PURE__*/ (() => {
    function Cart5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.275 3.038c-0.531-0.152-1.085 0.156-1.236 0.687l-0.078 0.275h-9.327l-0.141-1.124c-0.063-0.5-0.488-0.876-0.992-0.876h-2.5c-0.552 0-1 0.448-1 1s0.448 1 1 1h1.617l0.89 7.124c0.063 0.5 0.488 0.876 0.992 0.876h8.5c0.446 0 0.839-0.296 0.962-0.725l2-7c0.152-0.531-0.156-1.085-0.687-1.236zM8 8v-1h2v1h-2zM10 9v1h-2v-1h2zM8 6v-1h2v1h-2zM4.758 5h2.242v1h-2.117l-0.125-1zM5.008 7h1.992v1h-1.867l-0.125-1zM5.258 9h1.742v1h-1.617l-0.125-1zM12.246 10h-1.246v-1h1.531l-0.286 1zM12.817 8h-1.817v-1h2.103l-0.286 1zM13.389 6h-2.389v-1h2.674l-0.286 1zM4 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM10 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" })
        );
    }
    function Cart5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cart5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cart5.SVG = Cart5SVG;
    return Cart5;
})();
export const CartAdd = /*#__PURE__*/ (() => {
    function CartAddSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 12h-8.5c-0.504 0-0.93-0.376-0.992-0.876l-0.89-7.124h-1.617c-0.552 0-1-0.448-1-1s0.448-1 1-1h2.5c0.504 0 0.93 0.376 0.992 0.876l0.891 7.124h6.863l1.793-6.275c0.152-0.531 0.705-0.838 1.236-0.687s0.839 0.705 0.687 1.236l-2 7c-0.123 0.429-0.515 0.725-0.962 0.725zM4 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM10 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM12 7h-2v2h-2v-2h-2v-2h2v-2h2v2h2z" })
        );
    }
    function CartAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CartAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CartAdd.SVG = CartAddSVG;
    return CartAdd;
})();
export const CartAdd2 = /*#__PURE__*/ (() => {
    function CartAdd2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.275 3.038c0.531 0.152 0.839 0.705 0.687 1.236l-2 7c-0.123 0.429-0.515 0.725-0.962 0.725h-8.5c-0.504 0-0.93-0.376-0.992-0.876l-0.89-7.124h-1.617c-0.552 0-1-0.448-1-1s0.448-1 1-1h2.5c0.504 0 0.93 0.376 0.992 0.876l0.891 7.124h6.863l1.793-6.275c0.152-0.531 0.705-0.838 1.236-0.687zM4 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM10 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM5.688 5h2.313v-3h2v3h2.313l-3.313 3.563z" })
        );
    }
    function CartAdd2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CartAdd2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CartAdd2.SVG = CartAdd2SVG;
    return CartAdd2;
})();
export const CartRemove = /*#__PURE__*/ (() => {
    function CartRemoveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.275 3.038c0.531 0.152 0.839 0.705 0.687 1.236l-2 7c-0.123 0.429-0.515 0.725-0.962 0.725h-8.5c-0.504 0-0.93-0.376-0.992-0.876l-0.89-7.124h-1.617c-0.552 0-1-0.448-1-1s0.448-1 1-1h2.5c0.504 0 0.93 0.376 0.992 0.876l0.891 7.124h6.863l1.793-6.275c0.152-0.531 0.705-0.838 1.236-0.687zM4 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM10 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM12.313 6h-2.313v3h-2v-3h-2.313l3.313-3.563z" })
        );
    }
    function CartRemove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CartRemoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CartRemove.SVG = CartRemoveSVG;
    return CartRemove;
})();
export const Basket = /*#__PURE__*/ (() => {
    function BasketSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.703 6l-2.779-3.618c0.049-0.118 0.076-0.247 0.076-0.382 0-0.552-0.448-1-1-1s-1 0.448-1 1 0.448 1 1 1c0.044 0 0.088-0.003 0.131-0.009l2.311 3.009h-6.884l2.311-3.009c0.043 0.006 0.086 0.009 0.131 0.009 0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1c0 0.135 0.027 0.265 0.076 0.382l-2.779 3.618h-3.297v2h1l1 8h12l1-8h1v-2h-3.297zM5 14h-2v-2h2v2zM5 10h-2v-2h2v2zM9 14h-2v-2h2v2zM9 10h-2v-2h2v2zM13 14h-2v-2h2v2zM13 10h-2v-2h2v2z" })
        );
    }
    function Basket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BasketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Basket.SVG = BasketSVG;
    return Basket;
})();
export const Bag = /*#__PURE__*/ (() => {
    function BagSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 3v-0.5c0-1.381-1.119-2.5-2.5-2.5-0.563 0-1.082 0.186-1.5 0.5-0.418-0.314-0.937-0.5-1.5-0.5-1.381 0-2.5 1.119-2.5 2.5v1.7l-2 0.3v10.5h2l1 1 10-1.5v-10.5l-3-1zM3 14h-1v-8.639l1-0.15v8.789zM8.5 1c0.827 0 1.5 0.673 1.5 1.5v0.65l-2 0.3v-0.95c0-0.454-0.122-0.88-0.333-1.247 0.239-0.16 0.525-0.253 0.833-0.253zM4 2.5c0-0.827 0.673-1.5 1.5-1.5 0.308 0 0.595 0.093 0.833 0.253-0.212 0.367-0.333 0.792-0.333 1.247v1.25l-2 0.3v-1.55zM13 13.639l-8 1.2v-8.478l8-1.2v8.478z" })
        );
    }
    function Bag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bag.SVG = BagSVG;
    return Bag;
})();
export const Bag2 = /*#__PURE__*/ (() => {
    function Bag2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 3v-0.5c0-1.381-1.119-2.5-2.5-2.5-0.563 0-1.082 0.186-1.5 0.5-0.418-0.314-0.937-0.5-1.5-0.5-1.381 0-2.5 1.119-2.5 2.5v1.7l-2 0.3v10.5h2l1 1 10-1.5v-10.5l-3-1zM2 13.125v-0.25h1v0.25h-1zM3 13.375v0.25h-1v-0.25h1zM2 12.625v-0.25h1v0.25h-1zM2 12.125v-0.25h1v0.25h-1zM2 11.625v-0.25h1v0.25h-1zM2 11.125v-0.25h1v0.25h-1zM2 10.625v-0.25h1v0.25h-1zM2 10.125v-0.25h1v0.25h-1zM2 9.625v-0.25h1v0.25h-1zM2 9.125v-0.25h1v0.25h-1zM2 8.625v-0.25h1v0.25h-1zM2 8.125v-0.25h1v0.25h-1zM2 7.625v-0.25h1v0.25h-1zM2 7.125v-0.25h1v0.25h-1zM2 6.625v-0.25h1v0.25h-1zM2 6.125v-0.25h1v0.25h-1zM2 5.625v-0.25h1v0.25h-1zM2 14v-0.125h1v0.125h-1zM11.875 5.33l0.25-0.037v8.478l-0.25 0.037v-8.478zM11.625 13.845l-0.25 0.037v-8.478l0.25-0.037v8.478zM12.375 5.255l0.25-0.037v8.478l-0.25 0.037v-8.478zM11.125 5.442v8.478l-0.25 0.037v-8.478l0.25-0.037zM7.875 5.93l0.25-0.037v8.478l-0.25 0.037v-8.478zM7.625 14.445l-0.25 0.037v-8.478l0.25-0.037v8.478zM8.375 5.855l0.25-0.037v8.478l-0.25 0.037v-8.478zM8.875 5.78l0.25-0.037v8.478l-0.25 0.037v-8.478zM9.375 5.705l0.25-0.037v8.478l-0.25 0.037v-8.478zM9.875 5.63l0.25-0.037v8.478l-0.25 0.037v-8.478zM10.375 5.555l0.25-0.037v8.478l-0.25 0.037v-8.478zM8.5 1c0.827 0 1.5 0.673 1.5 1.5v0.65l-2 0.3v-0.95c0-0.454-0.122-0.88-0.333-1.247 0.239-0.16 0.525-0.253 0.833-0.253zM7.125 6.042v8.478l-0.25 0.037v-8.478l0.25-0.037zM5.625 6.267v8.478l-0.25 0.037v-8.478l0.25-0.037zM5.875 6.23l0.25-0.037v8.478l-0.25 0.037v-8.478zM6.375 6.155l0.25-0.037v8.478l-0.25 0.037v-8.478zM4 2.5c0-0.827 0.673-1.5 1.5-1.5 0.308 0 0.595 0.093 0.833 0.253-0.212 0.367-0.333 0.792-0.333 1.247v1.25l-2 0.3v-1.55zM5 6.361l0.125-0.019v8.478l-0.125 0.019v-8.478zM13 13.639l-0.125 0.019v-8.478l0.125-0.019v8.478z" })
        );
    }
    function Bag2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bag2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bag2.SVG = Bag2SVG;
    return Bag2;
})();
export const Percent = /*#__PURE__*/ (() => {
        function PercentSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 10h1v2h-1v-2z" }),
_('path', { d: "M5 4h1v2h-1v-2z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 3.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5-0.224-0.5-0.5v-3zM12 12.5c0 0.276-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3zM11.944 3.845l-7 9c-0.111 0.143-0.277 0.217-0.444 0.217-0.121 0-0.242-0.039-0.345-0.119-0.245-0.191-0.289-0.544-0.099-0.789l7-9c0.191-0.245 0.544-0.289 0.789-0.099s0.289 0.544 0.099 0.789z" })
            );
        }
        function Percent({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PercentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Percent.SVG = PercentSVG;
        return Percent;
    })();
export const Coins = /*#__PURE__*/ (() => {
    function CoinsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.479 4.958c-0.364 0-0.72 0.036-1.064 0.103-0.027-0.021-0.055-0.041-0.084-0.061 0.425-0.294 0.669-0.636 0.669-1v-1c0-1.105-2.239-2-5-2s-5 0.895-5 2v1c0 0.364 0.244 0.706 0.669 1-0.425 0.294-0.669 0.636-0.669 1v1c0 0.364 0.244 0.706 0.669 1-0.425 0.294-0.669 0.636-0.669 1v1c0 0.364 0.244 0.706 0.669 1-0.425 0.294-0.669 0.636-0.669 1v1c0 1.105 2.239 2 5 2 0.738 0 1.438-0.064 2.069-0.179 0.939 0.739 2.123 1.179 3.41 1.179 3.049 0 5.521-2.472 5.521-5.521s-2.472-5.521-5.521-5.521zM0.5 3c0-0.298 0.451-0.671 1.15-0.95 0.887-0.355 2.076-0.55 3.35-0.55s2.463 0.195 3.35 0.55c0.699 0.279 1.15 0.652 1.15 0.95s-0.451 0.671-1.15 0.95c-0.288 0.115-0.609 0.214-0.954 0.294-0.716 0.167-1.536 0.256-2.396 0.256s-1.68-0.089-2.396-0.256c-0.345-0.080-0.666-0.179-0.954-0.294-0.699-0.279-1.15-0.652-1.15-0.95zM0.5 9c0-0.221 0.249-0.483 0.663-0.718 0.917 0.439 2.296 0.718 3.837 0.718 0.053 0 0.106-0.001 0.159-0.001-0.131 0.471-0.201 0.968-0.201 1.481 0 0.007 0 0.014 0 0.021-0.844-0.003-1.65-0.091-2.354-0.256-0.345-0.080-0.666-0.179-0.954-0.294-0.699-0.279-1.15-0.652-1.15-0.95zM5 13.5c-1.273 0-2.463-0.195-3.35-0.55-0.699-0.279-1.15-0.652-1.15-0.95 0-0.221 0.249-0.483 0.663-0.718 0.917 0.439 2.296 0.718 3.837 0.718 0.057 0 0.114-0.001 0.17-0.002 0.151 0.527 0.378 1.022 0.668 1.472-0.274 0.019-0.554 0.029-0.839 0.029zM5 7.5c-0.859 0-1.68-0.089-2.396-0.256-0.345-0.080-0.666-0.179-0.954-0.294-0.699-0.279-1.15-0.652-1.15-0.95 0-0.221 0.249-0.483 0.663-0.718 0.917 0.439 2.296 0.718 3.837 0.718 1.030 0 1.987-0.125 2.782-0.339-0.781 0.438-1.444 1.060-1.932 1.808-0.278 0.020-0.562 0.030-0.85 0.030zM10.479 14.996c-2.495 0-4.517-2.022-4.517-4.517s2.022-4.517 4.517-4.517c2.495 0 4.517 2.022 4.517 4.517s-2.022 4.517-4.517 4.517zM11 7h-1v1h-2v3h2v1h-2v1h2v1h1v-1h2v-3h-2v-1h2v-1h-2v-1zM10 10h-1v-1h1v1zM12 11v1h-1v-1h1z" })
        );
    }
    function Coins({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoinsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Coins.SVG = CoinsSVG;
    return Coins;
})();
export const CoinDollar = /*#__PURE__*/ (() => {
    function CoinDollarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM8 8v-2h2v-1h-2v-1h-1v1h-2v4h2v2h-2v1h2v1h1v-1h2l-0-4h-2zM7 8h-1v-2h1v2zM9 11h-1v-2h1v2z" })
        );
    }
    function CoinDollar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoinDollarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CoinDollar.SVG = CoinDollarSVG;
    return CoinDollar;
})();
export const CoinEuro = /*#__PURE__*/ (() => {
        function CoinEuroSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" }),
_('path', { d: "M10.482 10.068c-0.239-0.139-0.545-0.058-0.684 0.181-0.27 0.463-0.767 0.751-1.298 0.751h-2c-0.652 0-1.208-0.418-1.414-1h2.414c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.414c0.206-0.582 0.762-1 1.414-1h2c0.531 0 1.028 0.288 1.298 0.751 0.139 0.239 0.445 0.32 0.684 0.181s0.32-0.445 0.181-0.684c-0.448-0.77-1.277-1.249-2.162-1.249h-2c-1.207 0-2.217 0.86-2.45 2h-0.55c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.55c0.232 1.14 1.242 2 2.45 2h2c0.886 0 1.714-0.478 2.162-1.249 0.139-0.239 0.058-0.545-0.181-0.684z" })
            );
        }
        function CoinEuro({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoinEuroSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CoinEuro.SVG = CoinEuroSVG;
        return CoinEuro;
    })();
export const CoinPound = /*#__PURE__*/ (() => {
        function CoinPoundSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" }),
_('path', { d: "M9.5 11h-3.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.827 0.673-1.5 1.5-1.5 0.534 0 1.032 0.288 1.3 0.75 0.138 0.239 0.444 0.321 0.683 0.182s0.321-0.444 0.182-0.683c-0.446-0.771-1.276-1.25-2.165-1.25-1.378 0-2.5 1.122-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h4.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function CoinPound({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoinPoundSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CoinPound.SVG = CoinPoundSVG;
        return CoinPound;
    })();
export const CoinYen = /*#__PURE__*/ (() => {
        function CoinYenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" }),
_('path', { d: "M9.5 9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.066l1.482-2.223c0.153-0.23 0.091-0.54-0.139-0.693s-0.54-0.091-0.693 0.139l-1.584 2.376-1.584-2.376c-0.153-0.23-0.464-0.292-0.693-0.139s-0.292 0.464-0.139 0.693l1.482 2.223h-1.066c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5z" })
            );
        }
        function CoinYen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoinYenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CoinYen.SVG = CoinYenSVG;
        return CoinYen;
    })();
export const PiggyBank = /*#__PURE__*/ (() => {
    function PiggyBankSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.023 6h-1.523c-0.359-0.684-0.896-1.289-1.562-1.772 0.005-0.43 0.167-0.84 0.458-1.158 0.059-0.064 0.123-0.125 0.19-0.179 0.16-0.13 0.224-0.346 0.16-0.542s-0.242-0.334-0.448-0.345c-0.037-0.002-0.074-0.003-0.111-0.003-0.885 0-1.637 0.578-1.9 1.377-0.705-0.243-1.477-0.377-2.287-0.377-3.243 0-5.885 2.145-5.996 4.825-0.059-0.002-0.118-0.002-0.179-0.002-0.682 0.011-0.782-0.792-0.815-1.328-0.065-0.597-0.967-0.606-1 0.010-0.116 0.385 0.010 0.983 0.122 1.346 0.262 0.851 0.998 1.255 1.834 1.328 0.068 0.005 0.135-0 0.198-0.013 0.193 0.675 0.551 1.296 1.035 1.834v0c0.041 0.045 0.083 0.090 0.126 0.134 0.225 0.265 0.674 0.912 0.674 1.866v1c0 0.552 0.672 1 1.5 1s1.5-0.448 1.5-1v-1.070c0.325 0.045 0.659 0.070 1 0.070s0.675-0.024 1-0.070v1.070c0 0.552 0.672 1 1.5 1s1.5-0.448 1.5-1v-1c0-0.954 0.449-1.601 0.674-1.866 0.043-0.044 0.085-0.089 0.126-0.134 0-0 0-0 0-0h-0c0.277-0.308 0.513-0.643 0.7-1h1.523c0.552 0 1-0.895 1-2s-0.448-2-1-2zM9.5 5h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM12 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1c0 0.552-0.448 1-1 1z" })
        );
    }
    function PiggyBank({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PiggyBankSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PiggyBank.SVG = PiggyBankSVG;
    return PiggyBank;
})();
export const Wallet = /*#__PURE__*/ (() => {
    function WalletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 17 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 17 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 2h-13c-1.105 0-2 0.895-2 2v10c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-1h1c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM1 6h0.5v1h-0.5v-1zM1 8h0.5v1h-0.5v-1zM1 10h0.5v1h-0.5v-1zM1 12h0.5v1h-0.5v-1zM2 14h-1v-0.5h1v0.5zM2 5.5h-1v-0.5h1v0.5zM4 14h-1v-0.5h1v0.5zM4 5.5h-1v-0.5h1v0.5zM6 14h-1v-0.5h1v0.5zM6 5.5h-1v-0.5h1v0.5zM8 14h-1v-0.5h1v0.5zM8 5.5h-1v-0.5h1v0.5zM10 14h-1v-0.5h1v0.5zM12 14h-1v-0.5h1v0.5zM15 7h-4v3h4v1.998c-0.001 0.001-0.001 0.001-0.002 0.002h-0.998v-1h-4v-5h4v-1c0-0.55-0.45-1-1-1h-12c0-0.551 0.449-1 1-1h12.998c0.001 0.001 0.001 0.001 0.002 0.002v3.998zM13 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z" })
        );
    }
    function Wallet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WalletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wallet.SVG = WalletSVG;
    return Wallet;
})();
export const Cash = /*#__PURE__*/ (() => {
        function CashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 7h1v1h-1v-1z" }),
_('path', { d: "M0 4v9h17v-9h-17zM3 12h-2v-2h1v1h1v1zM3 6h-1v1h-1v-2h2v1zM10.5 8c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5h-1.5v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5h-1.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.5v-1h-1.5c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5h1.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5h1.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.5v1h1.5zM16 12h-2v-1h1v-1h1v2zM16 7h-1v-1h-1v-1h2v2z" }),
_('path', { d: "M9 9h1v1h-1v-1z" })
            );
        }
        function Cash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cash.SVG = CashSVG;
        return Cash;
    })();
export const Cash2 = /*#__PURE__*/ (() => {
        function Cash2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 4v9h17v-9h-17zM3 12h-2v-2h1v1h1v1zM3 6h-1v1h-1v-2h2v1zM8.5 12c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zM16 12h-2v-1h1v-1h1v2zM16 7h-1v-1h-1v-1h2v2z" }),
_('path', { d: "M8.5 6c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5z" })
            );
        }
        function Cash2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cash2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cash2.SVG = Cash2SVG;
        return Cash2;
    })();
export const Cash3 = /*#__PURE__*/ (() => {
        function Cash3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 9h1v1h-1v-1z" }),
_('path', { d: "M0 6v9h17v-9h-17zM3 14h-2v-2h1v1h1v1zM3 8h-1v1h-1v-2h2v1zM10.5 10c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5h-1.5v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5h-1.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1.5v-1h-1.5c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5h1.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5h1.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.5v1h1.5zM16 14h-2v-1h1v-1h1v2zM16 9h-1v-1h-1v-1h2v2z" }),
_('path', { d: "M9 11h1v1h-1v-1z" }),
_('path', { d: "M1 4h15v1.5h-15v-1.5z" }),
_('path', { d: "M2 2h13v1.5h-13v-1.5z" })
            );
        }
        function Cash3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cash3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cash3.SVG = Cash3SVG;
        return Cash3;
    })();
export const Cash4 = /*#__PURE__*/ (() => {
        function Cash4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 4h15v1.5h-15v-1.5z" }),
_('path', { d: "M2 2h13v1.5h-13v-1.5z" }),
_('path', { d: "M0 6v9h17v-9h-17zM3 14h-2v-2h1v1h1v1zM3 8h-1v1h-1v-2h2v1zM8.5 14c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zM16 14h-2v-1h1v-1h1v2zM16 9h-1v-1h-1v-1h2v2z" }),
_('path', { d: "M8.5 8c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5z" })
            );
        }
        function Cash4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cash4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cash4.SVG = Cash4SVG;
        return Cash4;
    })();
export const CreditCard = /*#__PURE__*/ (() => {
    function CreditCardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z" })
        );
    }
    function CreditCard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CreditCardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CreditCard.SVG = CreditCardSVG;
    return CreditCard;
})();
export const CreditCard2 = /*#__PURE__*/ (() => {
    function CreditCard2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM3 12h-1v-2h1v2zM5 12h-1v-2h1v2zM7 12h-1v-2h1v2zM15.5 8h-15v-3h15v3z" })
        );
    }
    function CreditCard2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CreditCard2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CreditCard2.SVG = CreditCard2SVG;
    return CreditCard2;
})();
export const Calculator = /*#__PURE__*/ (() => {
    function CalculatorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 0h-8c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h8c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM6 15h-2v-2h2v2zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM9 15h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM12 15h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM12 6h-8v-5h8v5z" })
        );
    }
    function Calculator({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CalculatorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calculator.SVG = CalculatorSVG;
    return Calculator;
})();
export const Calculator2 = /*#__PURE__*/ (() => {
        function Calculator2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 16h-14c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5zM1 15h13v-14h-13v14z" }),
_('path', { d: "M2 2h11v3h-11v-3z" }),
_('path', { d: "M2 6h2v2h-2v-2z" }),
_('path', { d: "M5 6h2v2h-2v-2z" }),
_('path', { d: "M8 6h2v2h-2v-2z" }),
_('path', { d: "M2 9h2v2h-2v-2z" }),
_('path', { d: "M5 9h2v2h-2v-2z" }),
_('path', { d: "M8 9h2v2h-2v-2z" }),
_('path', { d: "M2 12h2v2h-2v-2z" }),
_('path', { d: "M5 12h2v2h-2v-2z" }),
_('path', { d: "M8 12h2v2h-2v-2z" }),
_('path', { d: "M11 9h2v5h-2v-5z" }),
_('path', { d: "M11 6h2v2h-2v-2z" })
            );
        }
        function Calculator2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calculator2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calculator2.SVG = Calculator2SVG;
        return Calculator2;
    })();
export const Calculator3 = /*#__PURE__*/ (() => {
    function Calculator3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 1h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 5h-5v-1h5v1zM14 1h-5c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-13c0-0.55-0.45-1-1-1zM14 10h-5v-1h5v1zM14 7h-5v-1h5v1zM6 9h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 13h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z" })
        );
    }
    function Calculator3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Calculator3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calculator3.SVG = Calculator3SVG;
    return Calculator3;
})();
export const Chip = /*#__PURE__*/ (() => {
    function ChipSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 8c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1.5l-0.5-0.5h-1.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1.5l-0.5 0.5v1.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5l0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5l0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5zM9 10h-3v-3h3v3z" })
        );
    }
    function Chip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chip.SVG = ChipSVG;
    return Chip;
})();
export const Lifebuoy = /*#__PURE__*/ (() => {
    function LifebuoySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM14.468 10.679v0l-2.772-1.148c0.196-0.472 0.304-0.989 0.304-1.531s-0.108-1.059-0.304-1.531l2.772-1.148c0.342 0.825 0.532 1.73 0.532 2.679s-0.189 1.854-0.532 2.679v0zM10.679 1.532v0 0l-1.148 2.772c-0.472-0.196-0.989-0.304-1.531-0.304s-1.059 0.108-1.531 0.304l-1.148-2.772c0.825-0.342 1.73-0.532 2.679-0.532s1.854 0.189 2.679 0.532zM1.532 5.321l2.772 1.148c-0.196 0.472-0.304 0.989-0.304 1.531s0.108 1.059 0.304 1.531l-2.772 1.148c-0.342-0.825-0.532-1.73-0.532-2.679s0.189-1.854 0.532-2.679zM5.321 14.468l1.148-2.772c0.472 0.196 0.989 0.304 1.531 0.304s1.059-0.108 1.531-0.304l1.148 2.772c-0.825 0.342-1.73 0.532-2.679 0.532s-1.854-0.189-2.679-0.532z" })
        );
    }
    function Lifebuoy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LifebuoySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lifebuoy.SVG = LifebuoySVG;
    return Lifebuoy;
})();
export const Phone = /*#__PURE__*/ (() => {
        function PhoneSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.095 2.763c-0.444-0.375-1.053-0.702-1.809-0.972-1.427-0.51-3.305-0.79-5.286-0.79 0 0 0 0-0 0-1.981 0-3.859 0.281-5.286 0.79-0.756 0.27-1.365 0.597-1.809 0.972-0.748 0.632-0.905 1.293-0.905 1.737l0 1c0 0.265 0.105 0.52 0.293 0.707l0.5 0.5c0.191 0.191 0.447 0.293 0.707 0.293 0.125 0 0.251-0.023 0.371-0.072l2.5-1c0.38-0.152 0.629-0.52 0.629-0.928v-1.744c0.915-0.167 1.941-0.256 3-0.256 0 0 0 0 0 0 1.059 0 2.085 0.089 3 0.256v1.744c0 0.409 0.249 0.777 0.629 0.928l2.5 1c0.12 0.048 0.246 0.072 0.371 0.072 0.26 0 0.516-0.102 0.707-0.293l0.5-0.5c0.188-0.188 0.293-0.442 0.293-0.707l0-1c0-0.444-0.157-1.106-0.905-1.737z" }),
_('path', { d: "M14.931 12.44c-0.015-0.053-0.382-1.325-1.006-2.618-0.904-1.872-2.426-2.821-4.426-2.821h-3c-2 0-3.522 0.949-4.426 2.821-0.624 1.293-0.99 2.565-1.006 2.618-0.188 0.656-0.085 1.311 0.281 1.797s0.968 0.764 1.65 0.764h10c0.683 0 1.284-0.278 1.65-0.764s0.469-1.14 0.281-1.797zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z" })
            );
        }
        function Phone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Phone.SVG = PhoneSVG;
        return Phone;
    })();
export const Phone2 = /*#__PURE__*/ (() => {
    function Phone2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z" })
        );
    }
    function Phone2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Phone2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Phone2.SVG = Phone2SVG;
    return Phone2;
})();
export const PhoneSlash = /*#__PURE__*/ (() => {
        function PhoneSlashSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.020 8.98c-0.584-0.66-1.020-1.32-1.020-1.98 0-1 1-1 2-2s-2-4-3-4-3 3-3 3c0 1.682 1.453 4.816 3.072 6.928l1.948-1.948z" }),
_('path', { d: "M11 10c-1 1-1 2-2 2-0.649 0-1.299-0.422-1.948-0.991l6.728-6.728c0.293-0.293 0.293-0.768 0-1.061s-0.768-0.293-1.061 0l-11.5 11.5c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l2.826-2.826c2.111 1.608 5.221 3.046 6.893 3.046 0 0 3-2 3-3s-3-4-4-3z" })
            );
        }
        function PhoneSlash({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneSlashSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneSlash.SVG = PhoneSlashSVG;
        return PhoneSlash;
    })();
export const PhoneWave = /*#__PURE__*/ (() => {
        function PhoneWaveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4s-4-6-4-8c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2z" }),
_('path', { d: "M11.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-1.378-1.121-2.5-2.5-2.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c1.93 0 3.5 1.57 3.5 3.5 0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M13.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-2.481-2.019-4.5-4.5-4.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c3.033 0 5.5 2.467 5.5 5.5 0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M15.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-3.584-2.916-6.5-6.5-6.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c2.003 0 3.887 0.78 5.303 2.197s2.197 3.3 2.197 5.303c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function PhoneWave({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneWaveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneWave.SVG = PhoneWaveSVG;
        return PhoneWave;
    })();
export const PhonePlus = /*#__PURE__*/ (() => {
    function PhonePlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4s-4-6-4-8c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM11.5 0c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5zM12 5v1.996h-1v-1.996h-1.996v-1h1.996v-1.996h1v1.996h1.996v1h-1.996z" })
        );
    }
    function PhonePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhonePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhonePlus.SVG = PhonePlusSVG;
    return PhonePlus;
})();
export const PhoneMinus = /*#__PURE__*/ (() => {
    function PhoneMinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4s-4-6-4-8c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM11.5 0c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5zM13.996 5h-4.992v-1h4.992v1z" })
        );
    }
    function PhoneMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhoneMinus.SVG = PhoneMinusSVG;
    return PhoneMinus;
})();
export const PhonePlus2 = /*#__PURE__*/ (() => {
    function PhonePlus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4s-4-6-4-8c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM15 5h-2v2h-2v-2h-2v-2h2v-2h2v2h2z" })
        );
    }
    function PhonePlus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhonePlus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhonePlus2.SVG = PhonePlus2SVG;
    return PhonePlus2;
})();
export const PhoneMinus2 = /*#__PURE__*/ (() => {
    function PhoneMinus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 10c1-1 4 2 4 3s-3 3-3 3c-2 0-6.055-2.055-8-4s-4-6-4-8c0 0 2-3 3-3s4 3 3 4-2 1-2 2 1 2 2 3 2 2 3 2 1-1 2-2zM9 3h6v2h-6zM9 3h6v2h-6z" })
        );
    }
    function PhoneMinus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneMinus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhoneMinus2.SVG = PhoneMinus2SVG;
    return PhoneMinus2;
})();
export const PhoneIncoming = /*#__PURE__*/ (() => {
        function PhoneIncomingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.457 5.957l3.543-3.543-1.414-1.414-3.543 3.543-2.043-2.043v5.5h5.5z" }),
_('path', { d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z" })
            );
        }
        function PhoneIncoming({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneIncomingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneIncoming.SVG = PhoneIncomingSVG;
        return PhoneIncoming;
    })();
export const PhoneOutgoing = /*#__PURE__*/ (() => {
        function PhoneOutgoingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z" }),
_('path', { d: "M9.414 8l3.543-3.543 2.043 2.043v-5.5h-5.5l2.043 2.043-3.543 3.543z" })
            );
        }
        function PhoneOutgoing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneOutgoingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneOutgoing.SVG = PhoneOutgoingSVG;
        return PhoneOutgoing;
    })();
export const Phone3 = /*#__PURE__*/ (() => {
    function Phone3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.614 16h-0.189c-1.026 0-2.569-0.48-4.234-1.316-1.627-0.817-3.112-1.838-4.075-2.801s-1.984-2.448-2.801-4.075c-0.836-1.665-1.316-3.208-1.316-4.234v-0.189l0.105-0.157c0.021-0.031 0.517-0.774 1.146-1.528 0.66-0.791 1.52-1.7 2.324-1.7 0.694 0 1.555 0.696 2.006 1.111 0.346 0.319 1.194 1.161 1.58 2.092 0.408 0.986 0.054 1.549-0.194 1.797-0.427 0.427-0.848 0.687-1.185 0.896-0.531 0.328-0.598 0.399-0.598 0.629 0 0.724 0.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c0.23 0 0.301-0.067 0.629-0.598 0.209-0.338 0.469-0.758 0.896-1.185 0.249-0.249 0.58-0.381 0.955-0.381 0.407 0 0.871 0.156 1.379 0.463 0.402 0.243 0.827 0.579 1.23 0.97 0.337 0.328 1.436 1.464 1.436 2.339 0 0.804-0.908 1.664-1.7 2.324-0.755 0.629-1.497 1.125-1.528 1.146l-0.157 0.105zM1.257 3.759c0.058 0.837 0.488 2.119 1.176 3.489 0.748 1.49 1.708 2.892 2.567 3.752s2.262 1.819 3.752 2.567c1.37 0.688 2.652 1.119 3.489 1.176 0.243-0.169 0.725-0.514 1.209-0.913 1.139-0.94 1.284-1.351 1.299-1.409-0.028-0.182-0.368-0.781-1.095-1.477-0.747-0.716-1.404-1.042-1.698-1.042-0.038 0-0.062 0.005-0.072 0.015-0.324 0.324-0.524 0.647-0.716 0.959-0.345 0.558-0.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-0.956 0.633-1.347 1.191-1.692 0.312-0.193 0.635-0.392 0.959-0.716 0.019-0.019 0.033-0.134-0.046-0.355-0.165-0.461-0.631-1.093-1.215-1.648-0.632-0.602-1.107-0.839-1.244-0.862-0.059 0.016-0.471 0.162-1.415 1.306-0.398 0.483-0.739 0.96-0.907 1.201z" })
        );
    }
    function Phone3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Phone3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Phone3.SVG = Phone3SVG;
    return Phone3;
})();
export const PhoneSlash2 = /*#__PURE__*/ (() => {
        function PhoneSlash2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.614 16h-0.189c-1.026 0-2.569-0.48-4.234-1.316-1.627-0.817-3.112-1.838-4.075-2.801s-1.984-2.448-2.801-4.075c-0.836-1.665-1.316-3.208-1.316-4.234v-0.189l0.105-0.157c0.021-0.031 0.517-0.774 1.146-1.528 0.66-0.791 1.52-1.7 2.324-1.7 0.694 0 1.555 0.696 2.006 1.111 0.346 0.319 1.194 1.161 1.58 2.092 0.408 0.986 0.054 1.549-0.194 1.797-0.427 0.427-0.848 0.687-1.185 0.896-0.531 0.328-0.598 0.399-0.598 0.629 0 0.724 0.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c0.23 0 0.301-0.067 0.629-0.598 0.209-0.338 0.469-0.758 0.896-1.185 0.249-0.249 0.58-0.381 0.955-0.381 0.407 0 0.871 0.156 1.379 0.463 0.402 0.243 0.827 0.579 1.23 0.971 0.337 0.328 1.436 1.464 1.436 2.339 0 0.804-0.908 1.664-1.7 2.324-0.755 0.629-1.497 1.125-1.528 1.146l-0.157 0.105zM1.257 3.759c0.058 0.837 0.488 2.119 1.176 3.489 0.748 1.49 1.708 2.892 2.567 3.752s2.262 1.819 3.752 2.567c1.37 0.688 2.652 1.119 3.489 1.176 0.243-0.169 0.725-0.514 1.209-0.913 1.139-0.94 1.284-1.351 1.299-1.409-0.028-0.182-0.368-0.781-1.095-1.478-0.747-0.716-1.404-1.042-1.698-1.042-0.038 0-0.062 0.005-0.072 0.015-0.324 0.324-0.524 0.647-0.716 0.959-0.345 0.558-0.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-0.956 0.633-1.347 1.191-1.692 0.312-0.193 0.635-0.392 0.959-0.716 0.019-0.019 0.033-0.134-0.046-0.355-0.165-0.461-0.631-1.093-1.215-1.648-0.632-0.602-1.107-0.839-1.244-0.862-0.059 0.016-0.471 0.162-1.415 1.306-0.398 0.483-0.739 0.96-0.907 1.201v0z" }),
_('path', { d: "M0.75 16c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061l11.5-11.5c0.293-0.293 0.768-0.293 1.061 0s0.293 0.768 0 1.061l-11.5 11.5c-0.146 0.146-0.338 0.22-0.53 0.22z" })
            );
        }
        function PhoneSlash2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneSlash2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneSlash2.SVG = PhoneSlash2SVG;
        return PhoneSlash2;
    })();
export const PhoneWave2 = /*#__PURE__*/ (() => {
        function PhoneWave2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.614 16h-0.189c-1.026 0-2.569-0.48-4.234-1.316-1.627-0.817-3.112-1.838-4.075-2.801s-1.984-2.448-2.801-4.075c-0.836-1.665-1.316-3.208-1.316-4.234v-0.189l0.105-0.157c0.021-0.031 0.517-0.774 1.146-1.528 0.66-0.791 1.52-1.7 2.324-1.7 0.694 0 1.555 0.696 2.006 1.111 0.346 0.319 1.194 1.161 1.58 2.092 0.408 0.986 0.054 1.549-0.194 1.797-0.427 0.427-0.848 0.687-1.185 0.896-0.531 0.328-0.598 0.399-0.598 0.629 0 0.724 0.907 1.631 1.783 2.508s1.784 1.784 2.508 1.784c0.23 0 0.301-0.067 0.629-0.598 0.209-0.338 0.469-0.758 0.896-1.185 0.249-0.249 0.58-0.381 0.955-0.381 0.407 0 0.871 0.156 1.379 0.463 0.402 0.243 0.827 0.579 1.23 0.971 0.337 0.328 1.436 1.464 1.436 2.339 0 0.804-0.908 1.664-1.7 2.324-0.755 0.629-1.497 1.125-1.528 1.146l-0.157 0.105zM1.257 3.759c0.058 0.837 0.488 2.119 1.176 3.489 0.748 1.49 1.708 2.892 2.567 3.752s2.262 1.819 3.752 2.567c1.37 0.688 2.652 1.119 3.489 1.176 0.243-0.169 0.725-0.514 1.209-0.913 1.139-0.94 1.284-1.351 1.299-1.409-0.028-0.182-0.368-0.781-1.095-1.478-0.747-0.716-1.404-1.042-1.698-1.042-0.038 0-0.062 0.005-0.072 0.015-0.324 0.324-0.524 0.647-0.716 0.959-0.345 0.558-0.736 1.191-1.692 1.191-1.242 0-2.335-1.093-3.392-2.15s-2.15-2.15-2.15-3.392c0-0.956 0.633-1.347 1.191-1.692 0.312-0.193 0.635-0.392 0.959-0.716 0.019-0.019 0.033-0.134-0.046-0.355-0.165-0.461-0.631-1.093-1.215-1.648-0.632-0.602-1.107-0.839-1.244-0.862-0.059 0.016-0.471 0.162-1.415 1.306-0.398 0.483-0.739 0.96-0.907 1.201v0z" }),
_('path', { d: "M11.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-1.378-1.121-2.5-2.5-2.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c1.93 0 3.5 1.57 3.5 3.5 0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M13.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-2.481-2.019-4.5-4.5-4.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c3.033 0 5.5 2.467 5.5 5.5 0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M15.5 8c-0.276 0-0.5-0.224-0.5-0.5 0-3.584-2.916-6.5-6.5-6.5-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5c2.003 0 3.887 0.78 5.303 2.197s2.197 3.3 2.197 5.303c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function PhoneWave2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PhoneWave2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PhoneWave2.SVG = PhoneWave2SVG;
        return PhoneWave2;
    })();
export const PhoneHangUp = /*#__PURE__*/ (() => {
    function PhoneHangUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.897 9c0.125 0.867 0.207 2.053-0.182 2.507-0.643 0.751-4.714 0.751-4.714-0.751 0-0.756 0.67-1.252 0.027-2.003-0.632-0.738-1.766-0.75-3.027-0.751s-2.394 0.012-3.027 0.751c-0.643 0.751 0.027 1.247 0.027 2.003 0 1.501-4.071 1.501-4.714 0.751-0.389-0.454-0.307-1.64-0.182-2.507 0.096-0.579 0.339-1.203 1.118-2 0-0 0-0 0-0 1.168-1.090 2.935-1.98 6.716-2v-0c0.021 0 0.042 0 0.063 0s0.041-0 0.063-0v0c3.781 0.019 5.548 0.91 6.716 2 0 0 0 0 0 0 0.778 0.797 1.022 1.421 1.118 2z" })
        );
    }
    function PhoneHangUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneHangUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhoneHangUp.SVG = PhoneHangUpSVG;
    return PhoneHangUp;
})();
export const PhoneHangUp2 = /*#__PURE__*/ (() => {
    function PhoneHangUp2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.262 12.15c0.529 0 1.814-0.064 2.327-0.652 0.258-0.295 0.391-0.744 0.409-1.372 0.011-0.392-0.023-0.857-0.1-1.383l-0.002-0.013c-0.132-0.777-0.502-1.436-1.2-2.137l-0.020-0.019c-0.941-0.862-2.473-1.847-6.025-1.962v-0.011l-1.303 0v0.011c-3.552 0.115-5.084 1.1-6.025 1.962l-0.020 0.019c-0.698 0.701-1.068 1.361-1.2 2.137l-0.002 0.013c-0.077 0.526-0.111 0.991-0.1 1.383 0.018 0.628 0.151 1.077 0.409 1.372 0.513 0.588 1.799 0.652 2.327 0.652 0.718 0 1.394-0.108 1.903-0.305 1.022-0.396 1.175-1.059 1.175-1.419 0-0.346-0.103-0.631-0.186-0.86-0.127-0.353-0.136-0.397 0.015-0.57 0.417-0.478 1.358-0.479 2.355-0.479s1.937 0 2.355 0.479c0.151 0.173 0.142 0.218 0.015 0.57-0.083 0.229-0.186 0.514-0.186 0.86 0 0.36 0.153 1.023 1.175 1.419 0.509 0.197 1.185 0.305 1.903 0.306 0 0 0 0 0 0zM8 7.329c-1.218 0-2.477 0-3.249 0.886-0.615 0.706-0.378 1.362-0.237 1.754 0.062 0.171 0.115 0.319 0.115 0.457 0 0.182-0.667 0.537-1.891 0.537-0.799 0-1.324-0.161-1.437-0.25-0.071-0.095-0.202-0.581-0.025-1.79 0.063-0.369 0.217-0.833 0.86-1.482 0.836-0.762 2.254-1.634 5.809-1.652l0.044-0 0.012 0 0.007-0 0.047 0c3.556 0.018 4.974 0.89 5.809 1.652 0.643 0.649 0.797 1.114 0.86 1.482 0.177 1.209 0.045 1.695-0.025 1.79-0.113 0.089-0.638 0.25-1.437 0.25-1.223-0-1.891-0.355-1.891-0.537 0-0.138 0.053-0.286 0.115-0.457 0.142-0.392 0.379-1.049-0.237-1.754-0.772-0.885-2.032-0.886-3.25-0.886z" })
        );
    }
    function PhoneHangUp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PhoneHangUp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PhoneHangUp2.SVG = PhoneHangUp2SVG;
    return PhoneHangUp2;
})();
export const AddressBook = /*#__PURE__*/ (() => {
        function AddressBookSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 0v16h12v-16h-12zM9 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995v0zM12 12h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z" }),
_('path', { d: "M1 1h1.5v3h-1.5v-3z" }),
_('path', { d: "M1 5h1.5v3h-1.5v-3z" }),
_('path', { d: "M1 9h1.5v3h-1.5v-3z" }),
_('path', { d: "M1 13h1.5v3h-1.5v-3z" })
            );
        }
        function AddressBook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AddressBookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AddressBook.SVG = AddressBookSVG;
        return AddressBook;
    })();
export const AddressBook2 = /*#__PURE__*/ (() => {
        function AddressBook2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 8h0.5c0.552 0 1-0.448 1-1v-2h-1.5v3z" }),
_('path', { d: "M14.5 1v3h0.5c0.552 0 1-0.448 1-1v-2h-1.5z" }),
_('path', { d: "M14 9v-9h-13c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h13v-7zM8 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995zM3 15h-1v-14h1v14zM11 12h-6v-1c0-1.105 0.895-2 2-2h2c1.105 0 2 0.895 2 2v1z" }),
_('path', { d: "M14.5 12h0.5c0.552 0 1-0.448 1-1v-2h-1.5v3z" })
            );
        }
        function AddressBook2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AddressBook2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AddressBook2.SVG = AddressBook2SVG;
        return AddressBook2;
    })();
export const AddressBook3 = /*#__PURE__*/ (() => {
    function AddressBook3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 1h-11c-0.276 0-0.5 0.224-0.5 0.5v1.5h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1.5c0 0.276 0.224 0.5 0.5 0.5h11c0.827 0 1.5-0.673 1.5-1.5v-12c0-0.827-0.673-1.5-1.5-1.5zM5 15h-2v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1h2v13zM12 6h-1.611c-0.251 0.693-0.389 1.575-0.389 2.5s0.138 1.807 0.389 2.5h1.611v3h-1c-0.528 0-1.035-0.218-1.468-0.629-0.334-0.317-0.623-0.749-0.86-1.283-0.433-0.975-0.672-2.249-0.672-3.588s0.239-2.613 0.672-3.588c0.237-0.534 0.527-0.965 0.86-1.283 0.433-0.412 0.94-0.629 1.468-0.629h1v3z" })
        );
    }
    function AddressBook3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AddressBook3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AddressBook3.SVG = AddressBook3SVG;
    return AddressBook3;
})();
export const Notebook = /*#__PURE__*/ (() => {
    function NotebookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 1h-11c-0.276 0-0.5 0.224-0.5 0.5v1.5h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1h-1c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v1.5c0 0.276 0.224 0.5 0.5 0.5h11c0.827 0 1.5-0.673 1.5-1.5v-12c0-0.827-0.673-1.5-1.5-1.5zM3 14c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1c0.552 0 1-0.448 1-1s-0.448-1-1-1v-1h2v13h-2v-1z" })
        );
    }
    function Notebook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NotebookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Notebook.SVG = NotebookSVG;
    return Notebook;
})();
export const AtSign = /*#__PURE__*/ (() => {
    function AtSignSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343 1.199 0 2.353-0.259 3.429-0.77 0.499-0.237 0.711-0.834 0.474-1.332s-0.834-0.711-1.332-0.474c-0.806 0.383-1.671 0.577-2.571 0.577-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6v1c0 0.551-0.449 1-1 1s-1-0.449-1-1v-4c0-0.552-0.448-1-1-1-0.406 0-0.755 0.242-0.912 0.59-0.608-0.374-1.323-0.59-2.088-0.59-2.206 0-4 1.794-4 4s1.794 4 4 4c1.045 0 1.998-0.403 2.712-1.062 0.551 0.649 1.372 1.062 2.288 1.062 1.654 0 3-1.346 3-3v-1c0-2.137-0.832-4.146-2.343-5.657zM8 10c-1.103 0-2-0.897-2-2s0.897-2 2-2c1.103 0 2 0.897 2 2s-0.897 2-2 2z" })
        );
    }
    function AtSign({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AtSignSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AtSign.SVG = AtSignSVG;
    return AtSign;
})();
export const Envelop = /*#__PURE__*/ (() => {
    function EnvelopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 2h-14c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM5.831 9.773l-3 2.182c-0.1 0.073-0.216 0.108-0.33 0.108-0.174 0-0.345-0.080-0.455-0.232-0.183-0.251-0.127-0.603 0.124-0.786l3-2.182c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786zM13.955 11.831c-0.11 0.151-0.282 0.232-0.455 0.232-0.115 0-0.23-0.035-0.33-0.108l-3-2.182c-0.251-0.183-0.307-0.534-0.124-0.786s0.535-0.307 0.786-0.124l3 2.182c0.251 0.183 0.307 0.535 0.124 0.786zM13.831 4.955l-5.5 4c-0.099 0.072-0.215 0.108-0.331 0.108s-0.232-0.036-0.331-0.108l-5.5-4c-0.251-0.183-0.307-0.534-0.124-0.786s0.535-0.307 0.786-0.124l5.169 3.759 5.169-3.759c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786z" })
        );
    }
    function Envelop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EnvelopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Envelop.SVG = EnvelopSVG;
    return Envelop;
})();
export const Envelop2 = /*#__PURE__*/ (() => {
        function Envelop2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.998 3c0.001 0.001 0.001 0.001 0.002 0.002v9.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-9.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 2h-14c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1v0z" }),
_('path', { d: "M5.831 9.773l-3 2.182c-0.1 0.073-0.216 0.108-0.33 0.108-0.174 0-0.345-0.080-0.455-0.232-0.183-0.251-0.127-0.603 0.124-0.786l3-2.182c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786z" }),
_('path', { d: "M13.955 11.831c-0.11 0.151-0.282 0.232-0.455 0.232-0.115 0-0.23-0.035-0.33-0.108l-3-2.182c-0.251-0.183-0.307-0.534-0.124-0.786s0.534-0.307 0.786-0.124l3 2.182c0.251 0.183 0.307 0.535 0.124 0.786z" }),
_('path', { d: "M13.831 4.955l-5.5 4c-0.099 0.072-0.215 0.108-0.331 0.108s-0.232-0.036-0.331-0.108l-5.5-4c-0.251-0.183-0.307-0.534-0.124-0.786s0.535-0.307 0.786-0.124l5.169 3.759 5.169-3.759c0.251-0.183 0.603-0.127 0.786 0.124s0.127 0.603-0.124 0.786v0z" })
            );
        }
        function Envelop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Envelop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Envelop2.SVG = Envelop2SVG;
        return Envelop2;
    })();
export const Envelop3 = /*#__PURE__*/ (() => {
    function Envelop3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 2h-14c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM14 4v0.719l-6 3.536-6-3.536v-0.719h12zM2 12v-5.54l6 3.536 6-3.536v5.54h-12z" })
        );
    }
    function Envelop3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Envelop3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Envelop3.SVG = Envelop3SVG;
    return Envelop3;
})();
export const Envelop4 = /*#__PURE__*/ (() => {
    function Envelop4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM6.23 8.6l-4.23 3.295v-7.838l4.23 4.543zM2.756 4h10.488l-5.244 3.938-5.244-3.938zM6.395 8.777l1.605 1.723 1.605-1.723 3.29 4.223h-9.79l3.29-4.223zM9.77 8.6l4.23-4.543v7.838l-4.23-3.295z" })
        );
    }
    function Envelop4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Envelop4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Envelop4.SVG = Envelop4SVG;
    return Envelop4;
})();
export const Envelop5 = /*#__PURE__*/ (() => {
    function Envelop5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM14 5l-6 4.5-6-4.5v-1l6 3 6-3v1z" })
        );
    }
    function Envelop5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Envelop5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Envelop5.SVG = Envelop5SVG;
    return Envelop5;
})();
export const Mailbox = /*#__PURE__*/ (() => {
        function MailboxSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 3h-6c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5.5v7h-12v-7h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-4c-0.276 0-0.5 0.224-0.5 0.5v8c0 0.276 0.224 0.5 0.5 0.5h4.5v3.5c0 0.276 0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5v-3.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-8c0-0.276-0.224-0.5-0.5-0.5zM1 4h1v7h-1v-7zM9 15h-3v-3h3v3z" }),
_('path', { d: "M7.5 8c0.828 0 1.5-0.672 1.5-1.5 0-0.653-0.417-1.208-1-1.414v-3.086h2v-2h-4v6.5c0 0.828 0.672 1.5 1.5 1.5z" })
            );
        }
        function Mailbox({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MailboxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Mailbox.SVG = MailboxSVG;
        return Mailbox;
    })();
export const Pushpin = /*#__PURE__*/ (() => {
    function PushpinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z" })
        );
    }
    function Pushpin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PushpinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pushpin.SVG = PushpinSVG;
    return Pushpin;
})();
export const Pushpin2 = /*#__PURE__*/ (() => {
    function Pushpin2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.209 0-4 1.791-4 4 0 1.864 1.275 3.43 3 3.874v7.626l2-2v-5.626c1.725-0.444 3-2.010 3-3.874 0-2.209-1.791-4-4-4zM7 4c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Pushpin2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pushpin2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pushpin2.SVG = Pushpin2SVG;
    return Pushpin2;
})();
export const Location = /*#__PURE__*/ (() => {
    function LocationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" })
        );
    }
    function Location({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LocationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location.SVG = LocationSVG;
    return Location;
})();
export const Location2 = /*#__PURE__*/ (() => {
    function Location2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.761 0-5 2.239-5 5 0 5 5 9 5 9s5-4 5-9c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3c1.657 0 3 1.343 3 3s-1.343 3-3 3zM12.285 10.9c-0.222 0.348-0.451 0.678-0.682 0.988 0.037 0.017 0.073 0.035 0.108 0.052 0.76 0.38 1.101 0.806 1.101 1.059s-0.34 0.679-1.101 1.059c-0.957 0.479-2.31 0.753-3.712 0.753s-2.754-0.275-3.712-0.753c-0.76-0.38-1.101-0.806-1.101-1.059s0.34-0.679 1.101-1.059c0.036-0.018 0.072-0.035 0.108-0.052-0.231-0.31-0.461-0.64-0.682-0.988-1.061 0.541-1.715 1.282-1.715 2.1 0 1.657 2.686 3 6 3s6-1.343 6-3c0-0.817-0.654-1.558-1.715-2.1z" })
        );
    }
    function Location2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location2.SVG = Location2SVG;
    return Location2;
})();
export const Location3 = /*#__PURE__*/ (() => {
    function Location3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z" })
        );
    }
    function Location3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location3.SVG = Location3SVG;
    return Location3;
})();
export const Location4 = /*#__PURE__*/ (() => {
    function Location4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.761 0-5 2.239-5 5 0 5 5 9 5 9s5-4 5-9c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0 1.070 0.867 1.938 1.938 1.938s1.938-0.867 1.938-1.938-0.867-1.938-1.938-1.938c-1.070 0-1.938 0.867-1.938 1.938zM12.285 10.9c-0.222 0.348-0.451 0.678-0.682 0.988 0.037 0.017 0.073 0.035 0.108 0.052 0.76 0.38 1.101 0.806 1.101 1.059s-0.34 0.679-1.101 1.059c-0.957 0.479-2.31 0.753-3.712 0.753s-2.754-0.275-3.712-0.753c-0.76-0.38-1.101-0.806-1.101-1.059s0.34-0.679 1.101-1.059c0.036-0.018 0.072-0.035 0.108-0.052-0.231-0.31-0.461-0.64-0.682-0.988-1.061 0.541-1.715 1.282-1.715 2.1 0 1.657 2.686 3 6 3s6-1.343 6-3c0-0.817-0.654-1.558-1.715-2.1z" })
        );
    }
    function Location4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location4.SVG = Location4SVG;
    return Location4;
})();
export const Location5 = /*#__PURE__*/ (() => {
    function Location5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-3.314 0-6 2.686-6 6 0 6 6 10 6 10s6-4 6-10c0-3.314-2.686-6-6-6zM8 7c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z" })
        );
    }
    function Location5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location5.SVG = Location5SVG;
    return Location5;
})();
export const Location6 = /*#__PURE__*/ (() => {
    function Location6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-3.314 0-6 2.686-6 6 0 6 6 10 6 10s6-4 6-10c0-3.314-2.686-6-6-6zM10.093 12.387c-0.772 0.909-1.555 1.608-2.093 2.046-0.539-0.439-1.321-1.137-2.093-2.046-0.785-0.924-1.407-1.883-1.849-2.85-0.536-1.171-0.807-2.361-0.807-3.537 0-1.269 0.494-2.462 1.391-3.359s2.090-1.391 3.359-1.391c1.269 0 2.462 0.494 3.359 1.391s1.391 2.090 1.391 3.359c0 1.175-0.272 2.365-0.807 3.537-0.442 0.967-1.064 1.926-1.849 2.85zM8 3c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2s-0.895-2-2-2zM8 6c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
        );
    }
    function Location6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location6.SVG = Location6SVG;
    return Location6;
})();
export const Location7 = /*#__PURE__*/ (() => {
    function Location7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.761 0-5 2.099-5 4.688 0 3.75 4 5.023 4 10.313v0.5c0 0.264 0.205 0.48 0.464 0.499v0.001h1.036c0.276 0 0.5-0.224 0.5-0.5v-0.5c0-5.29 4-6.563 4-10.313 0-2.589-2.239-4.688-5-4.688z" })
        );
    }
    function Location7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Location7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Location7.SVG = Location7SVG;
    return Location7;
})();
export const Compass = /*#__PURE__*/ (() => {
    function CompassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289zM2.754 7h5.746c0.276 0 0.5 0.224 0.5 0.5v5.746l5.465-11.712-11.712 5.465z" })
        );
    }
    function Compass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CompassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass.SVG = CompassSVG;
    return Compass;
})();
export const Compass2 = /*#__PURE__*/ (() => {
    function Compass2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.854 0.146c-0.149-0.149-0.374-0.188-0.565-0.1l-15 7c-0.212 0.099-0.327 0.333-0.277 0.561s0.254 0.392 0.488 0.392h7.5v7.5c0 0.234 0.163 0.437 0.392 0.488 0.036 0.008 0.073 0.012 0.108 0.012 0.191 0 0.37-0.11 0.453-0.289l7-15c0.089-0.191 0.049-0.416-0.1-0.565zM9 13.246v-6.246l5.465-5.465-5.465 11.712z" })
        );
    }
    function Compass2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Compass2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass2.SVG = Compass2SVG;
    return Compass2;
})();
export const Compass3 = /*#__PURE__*/ (() => {
    function Compass3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289z" })
        );
    }
    function Compass3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Compass3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass3.SVG = Compass3SVG;
    return Compass3;
})();
export const Compass4 = /*#__PURE__*/ (() => {
        function Compass4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.673 7.501l1.327-1.796v-0.706h-0.706l-1.796 1.327-0.768-3.327h-0.462l-0.768 3.327-1.796-1.327h-0.706v0.706l1.327 1.796-3.327 0.768v0.462l3.327 0.768-1.327 1.796v0.706h0.706l1.796-1.327 0.768 3.327h0.462l0.768-3.327 1.796 1.327h0.706v-0.706l-1.327-1.796 3.327-0.768v-0.462l-3.327-0.768zM7.5 9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6z" })
            );
        }
        function Compass4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Compass4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Compass4.SVG = Compass4SVG;
        return Compass4;
    })();
export const Compass5 = /*#__PURE__*/ (() => {
    function Compass5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9.143 9.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z" })
        );
    }
    function Compass5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Compass5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass5.SVG = Compass5SVG;
    return Compass5;
})();
export const Compass6 = /*#__PURE__*/ (() => {
    function Compass6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z" })
        );
    }
    function Compass6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Compass6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Compass6.SVG = Compass6SVG;
    return Compass6;
})();
export const Map = /*#__PURE__*/ (() => {
        function MapSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.5 2c-1.933 0-3.5 1.567-3.5 3.5 0 0.744 0.232 1.433 0.628 2l2.872 3.5 2.872-3.5c0.396-0.567 0.628-1.256 0.628-2 0-1.933-1.567-3.5-3.5-3.5zM5.5 7c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" }),
_('path', { d: "M15.5 0h-15c-0.276 0-0.5 0.224-0.5 0.5v15c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-15c0-0.276-0.224-0.5-0.5-0.5zM1 15v-1h8v-2h-8v-11h9v14h-9zM15 15h-3v-1h3v1zM15 12h-3v-11h3v11z" })
            );
        }
        function Map({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MapSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Map.SVG = MapSVG;
        return Map;
    })();
export const Map2 = /*#__PURE__*/ (() => {
    function Map2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2.5l-8-2-4 2.5v13l4-2.5 8 2 4-2.5v-13l-4 2.5zM11 14.219l-6-1.5v-10.938l6 1.5v10.938z" })
        );
    }
    function Map2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Map2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Map2.SVG = Map2SVG;
    return Map2;
})();
export const Map3 = /*#__PURE__*/ (() => {
    function Map3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2.5l-8-2-4 2.5v13l4-2.5 8 2 4-2.5v-13l-4 2.5zM5 12.719v-10.938l0.125 0.031v10.938l-0.125-0.031zM5.375 12.813v-10.938l0.25 0.063v10.938l-0.25-0.063zM5.875 12.938v-10.938l0.25 0.063v10.938l-0.25-0.063zM6.375 13.063v-10.938l0.25 0.063v10.938l-0.25-0.063zM6.875 13.188v-10.938l0.25 0.063v10.938l-0.25-0.063zM7.375 13.313v-10.938l0.25 0.063v10.938l-0.25-0.063zM7.875 13.438v-10.938l0.25 0.063v10.938l-0.25-0.063zM8.375 13.563v-10.938l0.25 0.063v10.938l-0.25-0.063zM8.875 13.688v-10.938l0.25 0.063v10.938l-0.25-0.063zM9.375 13.813v-10.938l0.25 0.063v10.938l-0.25-0.063zM9.875 13.938v-10.938l0.25 0.063v10.938l-0.25-0.063zM10.375 14.063v-10.938l0.25 0.063v10.938l-0.25-0.063zM11 14.219l-0.125-0.031v-10.938l0.125 0.031v10.938z" })
        );
    }
    function Map3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Map3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Map3.SVG = Map3SVG;
    return Map3;
})();
export const Map4 = /*#__PURE__*/ (() => {
        function Map4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3l5-2v12l-5 2z" }),
_('path', { d: "M6 0.5l5 3v11.5l-5-2.5z" }),
_('path', { d: "M12 3.5l4-3v12l-4 3z" })
            );
        }
        function Map4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Map4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Map4.SVG = Map4SVG;
        return Map4;
    })();
export const Map5 = /*#__PURE__*/ (() => {
    function Map5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 3l-5-2-5.5 2v12l5.5-2 5 2 5.5-2v-12l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6v-9.846zM1 3.7l4-1.455v9.872l-4 1.454v-9.872zM15 12.3l-4 1.455v-9.872l4-1.455v9.872z" })
        );
    }
    function Map5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Map5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Map5.SVG = Map5SVG;
    return Map5;
})();
export const Direction = /*#__PURE__*/ (() => {
    function DirectionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 6l2-2-2-2h-4.5v-1.25c0-0.412-0.338-0.75-0.75-0.75h-0.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-5v4h5v1h-5.5l-1.5 1.5 1.5 1.5h5.5v6h2v-6h4v-3h-4v-1h4.5z" })
        );
    }
    function Direction({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DirectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Direction.SVG = DirectionSVG;
    return Direction;
})();
export const Reset = /*#__PURE__*/ (() => {
    function ResetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.126 9c-0.082 0.32-0.126 0.655-0.126 1 0 2.209 1.791 4 4 4s4-1.791 4-4-1.791-4-4-4v3l-5-4 5-4v3c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6c0-0.341 0.029-0.675 0.084-1h2.043z" })
        );
    }
    function Reset({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ResetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reset.SVG = ResetSVG;
    return Reset;
})();
export const History = /*#__PURE__*/ (() => {
    function HistorySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 17 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 17 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 1c3.866 0 7 3.134 7 7s-3.134 7-7 7v-1.5c1.469 0 2.85-0.572 3.889-1.611s1.611-2.42 1.611-3.889c0-1.469-0.572-2.85-1.611-3.889s-2.42-1.611-3.889-1.611c-1.469 0-2.85 0.572-3.889 1.611-0.799 0.799-1.322 1.801-1.52 2.889h2.909l-3.5 4-3.5-4h2.571c0.485-3.392 3.402-6 6.929-6zM13 7v2h-4v-5h2v3z" })
        );
    }
    function History({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HistorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    History.SVG = HistorySVG;
    return History;
})();
export const Clock = /*#__PURE__*/ (() => {
    function ClockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" })
        );
    }
    function Clock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clock.SVG = ClockSVG;
    return Clock;
})();
export const Clock2 = /*#__PURE__*/ (() => {
    function Clock2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707-1.414 1.414z" })
        );
    }
    function Clock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Clock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clock2.SVG = Clock2SVG;
    return Clock2;
})();
export const Clock3 = /*#__PURE__*/ (() => {
    function Clock3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 7v2h-5v-6h2v4zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" })
        );
    }
    function Clock3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Clock3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clock3.SVG = Clock3SVG;
    return Clock3;
})();
export const Clock4 = /*#__PURE__*/ (() => {
    function Clock4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12 9h-5v-6h2v4h3v2z" })
        );
    }
    function Clock4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Clock4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clock4.SVG = Clock4SVG;
    return Clock4;
})();
export const Watch = /*#__PURE__*/ (() => {
        function WatchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 3h-0.5l-0.5-3h-5l-0.5 3h-0.5c-1.1 0-2 0.75-2 1.667v6.667c0 0.917 0.9 1.667 2 1.667h0.5l0.5 3h5l0.5-3h0.5c1.1 0 2-0.75 2-1.667v-6.667c0-0.917-0.9-1.667-2-1.667zM12 11.333c0 0.191-0.143 0.338-0.228 0.409-0.197 0.164-0.478 0.258-0.772 0.258h-7c-0.294 0-0.576-0.094-0.772-0.258-0.085-0.071-0.228-0.218-0.228-0.409v-6.667c0-0.191 0.143-0.338 0.228-0.409 0.197-0.164 0.478-0.258 0.772-0.258h7c0.294 0 0.576 0.094 0.772 0.258 0.085 0.071 0.228 0.218 0.228 0.409v6.667z" }),
_('path', { d: "M6.5 6h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M10.5 6c-0.276 0-0.5 0.224-0.5 0.5v1.5h-1v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Watch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WatchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Watch.SVG = WatchSVG;
        return Watch;
    })();
export const Watch2 = /*#__PURE__*/ (() => {
        function Watch2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.5 8h-1.5v-2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M14 8c0-2.422-1.435-4.508-3.501-5.455h0.001l-0.5-2.545h-4l-0.5 2.545h0.001c-2.066 0.948-3.501 3.034-3.501 5.455s1.435 4.507 3.5 5.455l-0 0 0.5 2.545h4l0.5-2.545h-0.001c2.066-0.948 3.501-3.034 3.501-5.455zM8 12.5c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.485 0 4.5 2.015 4.5 4.5s-2.015 4.5-4.5 4.5z" })
            );
        }
        function Watch2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Watch2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Watch2.SVG = Watch2SVG;
        return Watch2;
    })();
export const Alarm = /*#__PURE__*/ (() => {
        function AlarmSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z" }),
_('path', { d: "M8 9v-4h-1v5h4v-1z" })
            );
        }
        function Alarm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Alarm.SVG = AlarmSVG;
        return Alarm;
    })();
export const AlarmAdd = /*#__PURE__*/ (() => {
        function AlarmAddSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z" }),
_('path', { d: "M11 8h-2v-2h-2v2h-2v2h2v2h2v-2h2z" })
            );
        }
        function AlarmAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmAdd.SVG = AlarmAddSVG;
        return AlarmAdd;
    })();
export const AlarmCheck = /*#__PURE__*/ (() => {
        function AlarmCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z" }),
_('path', { d: "M11 6.5l-4 4-1.5-1.5-1 1 2.5 2.5 5-5z" })
            );
        }
        function AlarmCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmCheck.SVG = AlarmCheckSVG;
        return AlarmCheck;
    })();
export const AlarmCancel = /*#__PURE__*/ (() => {
        function AlarmCancelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z" }),
_('path', { d: "M11.457 11.043l-1.414 1.414-2.043-2.043-2.043 2.043-1.414-1.414 2.043-2.043-2.043-2.043 1.414-1.414 2.043 2.043 2.043-2.043 1.414 1.414-2.043 2.043 2.043 2.043z" })
            );
        }
        function AlarmCancel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AlarmCancelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AlarmCancel.SVG = AlarmCancelSVG;
        return AlarmCancel;
    })();
export const Bell = /*#__PURE__*/ (() => {
    function BellSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16.023 12.5c0-4.5-4-3.5-4-7 0-0.29-0.028-0.538-0.079-0.749-0.263-1.766-1.44-3.183-2.965-3.615 0.014-0.062 0.021-0.125 0.021-0.191 0-0.52-0.45-0.945-1-0.945s-1 0.425-1 0.945c0 0.065 0.007 0.129 0.021 0.191-1.71 0.484-2.983 2.208-3.020 4.273-0.001 0.030-0.001 0.060-0.001 0.091 0 3.5-4 2.5-4 7 0 1.191 2.665 2.187 6.234 2.439 0.336 0.631 1.001 1.061 1.766 1.061s1.43-0.43 1.766-1.061c3.568-0.251 6.234-1.248 6.234-2.439 0-0.004-0-0.007-0-0.011l0.024 0.011zM12.91 13.345c-0.847 0.226-1.846 0.389-2.918 0.479-0.089-1.022-0.947-1.824-1.992-1.824s-1.903 0.802-1.992 1.824c-1.072-0.090-2.071-0.253-2.918-0.479-1.166-0.311-1.724-0.659-1.928-0.845 0.204-0.186 0.762-0.534 1.928-0.845 1.356-0.362 3.1-0.561 4.91-0.561s3.554 0.199 4.91 0.561c1.166 0.311 1.724 0.659 1.928 0.845-0.204 0.186-0.762 0.534-1.928 0.845z" })
        );
    }
    function Bell({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bell.SVG = BellSVG;
    return Bell;
})();
export const Bell2 = /*#__PURE__*/ (() => {
    function Bell2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1z" })
        );
    }
    function Bell2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bell2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bell2.SVG = Bell2SVG;
    return Bell2;
})();
export const Bell3 = /*#__PURE__*/ (() => {
        function Bell3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1z" }),
_('path', { d: "M15.483 6c-0.261 0-0.481-0.203-0.498-0.467-0.118-1.787-0.908-3.444-2.226-4.666-0.202-0.188-0.214-0.504-0.027-0.707s0.504-0.214 0.707-0.027c1.506 1.397 2.409 3.291 2.543 5.334 0.018 0.276-0.191 0.514-0.466 0.532-0.011 0.001-0.022 0.001-0.033 0.001z" }),
_('path', { d: "M0.517 6c-0.011 0-0.022-0-0.033-0.001-0.276-0.018-0.484-0.256-0.466-0.532 0.134-2.043 1.038-3.937 2.543-5.334 0.203-0.188 0.519-0.176 0.707 0.027s0.176 0.519-0.027 0.707c-1.318 1.222-2.108 2.879-2.226 4.666-0.017 0.264-0.237 0.467-0.498 0.467z" })
            );
        }
        function Bell3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bell3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bell3.SVG = Bell3SVG;
        return Bell3;
    })();
export const BellPlus = /*#__PURE__*/ (() => {
    function BellPlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1zM11 9h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z" })
        );
    }
    function BellPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BellPlus.SVG = BellPlusSVG;
    return BellPlus;
})();
export const BellMinus = /*#__PURE__*/ (() => {
    function BellMinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1zM11 9h-6v-2h6v2z" })
        );
    }
    function BellMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BellMinus.SVG = BellMinusSVG;
    return BellMinus;
})();
export const BellCheck = /*#__PURE__*/ (() => {
    function BellCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1zM7 11.559l-2.42-3.201 0.747-0.747 1.674 1.205 3.83-3.392 0.778 0.778-4.608 5.358z" })
        );
    }
    function BellCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BellCheck.SVG = BellCheckSVG;
    return BellCheck;
})();
export const BellCross = /*#__PURE__*/ (() => {
    function BellCrossSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13c-1.657 0-3-1.343-3-3v-4.455c0-2.199-1.718-4.033-4-4.454v-1.091h-2v1.091c-2.282 0.421-4 2.255-4 4.454v4.455c0 1.657-1.343 3-3 3v1h6.712c-0.081 0.178-0.127 0.377-0.127 0.586 0 0.781 0.633 1.414 1.414 1.414s1.414-0.633 1.414-1.414c0-0.209-0.045-0.407-0.127-0.586h6.713v-1zM11 9.5l-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2 1 1-2 2 2 2z" })
        );
    }
    function BellCross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BellCrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BellCross.SVG = BellCrossSVG;
    return BellCross;
})();
export const Stopwatch = /*#__PURE__*/ (() => {
    function StopwatchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3.019v-1.019h2v-1c0-0.552-0.448-1-1-1h-3c-0.552 0-1 0.448-1 1v1h2v1.019c-3.356 0.255-6 3.059-6 6.481 0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-3.422-2.644-6.226-6-6.481zM11.036 13.036c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.907-0.907 2.101-1.422 3.377-1.462l-0.339 4.907c-0.029 0.411 0.195 0.591 0.497 0.591s0.527-0.18 0.497-0.591l-0.339-4.907c1.276 0.040 2.47 0.555 3.377 1.462 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536z" })
        );
    }
    function Stopwatch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StopwatchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stopwatch.SVG = StopwatchSVG;
    return Stopwatch;
})();
export const Calendar = /*#__PURE__*/ (() => {
    function CalendarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 15c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-9h-16v9zM11 7h4v2h-4v-2zM11 10h4v2h-4v-2zM11 13h4v2h-4v-2zM6 7h4v2h-4v-2zM6 10h4v2h-4v-2zM6 13h4v2h-4v-2zM1 7h4v2h-4v-2zM1 10h4v2h-4v-2zM1 13h4v2h-4v-2zM15 2h-2v-1.429c0-0.316-0.224-0.571-0.5-0.571s-0.5 0.256-0.5 0.571v1.429h-8v-1.429c0-0.316-0.224-0.571-0.5-0.571s-0.5 0.256-0.5 0.571v1.429h-2c-0.552 0-1 0.448-1 1v2h16v-2c0-0.552-0.448-1-1-1zM3.5 4.5c-0.552 0-1-0.448-1-1 0-0.37 0.201-0.693 0.5-0.866v0.866c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.866c0.299 0.173 0.5 0.496 0.5 0.866 0 0.552-0.448 1-1 1zM12.5 4.5c-0.552 0-1-0.448-1-1 0-0.37 0.201-0.693 0.5-0.866v0.866c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.866c0.299 0.173 0.5 0.496 0.5 0.866 0 0.552-0.448 1-1 1z" })
        );
    }
    function Calendar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CalendarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calendar.SVG = CalendarSVG;
    return Calendar;
})();
export const Calendar2 = /*#__PURE__*/ (() => {
    function Calendar2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 6h2v2h-2zM8 6h2v2h-2zM11 6h2v2h-2zM2 12h2v2h-2zM5 12h2v2h-2zM8 12h2v2h-2zM5 9h2v2h-2zM8 9h2v2h-2zM11 9h2v2h-2zM2 9h2v2h-2zM13 0v1h-2v-1h-7v1h-2v-1h-2v16h15v-16h-2zM14 15h-13v-11h13v11z" })
        );
    }
    function Calendar2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Calendar2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calendar2.SVG = Calendar2SVG;
    return Calendar2;
})();
export const Calendar3 = /*#__PURE__*/ (() => {
        function Calendar3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 7h1v1h-1v-1z" }),
_('path', { d: "M10 9h1v1h-1v-1z" }),
_('path', { d: "M10 11h1v1h-1v-1z" }),
_('path', { d: "M8 5h1v1h-1v-1z" }),
_('path', { d: "M8 9h1v1h-1v-1z" }),
_('path', { d: "M8 13h1v1h-1v-1z" }),
_('path', { d: "M8 11h1v1h-1v-1z" }),
_('path', { d: "M6 5h1v1h-1v-1z" }),
_('path', { d: "M12 9h1v1h-1v-1z" }),
_('path', { d: "M12 7h1v1h-1v-1z" }),
_('path', { d: "M12 5h1v1h-1v-1z" }),
_('path', { d: "M12 11h1v1h-1v-1z" }),
_('path', { d: "M10 5h1v1h-1v-1z" }),
_('path', { d: "M12 13h1v1h-1v-1z" }),
_('path', { d: "M10 7h1v1h-1v-1z" }),
_('path', { d: "M10 13h1v1h-1v-1z" }),
_('path', { d: "M2 7h1v1h-1v-1z" }),
_('path', { d: "M2 9h1v1h-1v-1z" }),
_('path', { d: "M4 13h1v1h-1v-1z" }),
_('path', { d: "M6 7h1v1h-1v-1z" }),
_('path', { d: "M2 13h1v1h-1v-1z" }),
_('path', { d: "M2 11h1v1h-1v-1z" }),
_('path', { d: "M2 5h1v1h-1v-1z" }),
_('path', { d: "M6 11h1v1h-1v-1z" }),
_('path', { d: "M4 11h1v1h-1v-1z" }),
_('path', { d: "M6 9h1v1h-1v-1z" }),
_('path', { d: "M6 13h1v1h-1v-1z" }),
_('path', { d: "M4 5h1v1h-1v-1z" }),
_('path', { d: "M4 9h1v1h-1v-1z" }),
_('path', { d: "M4 7h1v1h-1v-1z" }),
_('path', { d: "M12 1v-1h-2v1h-5v-1h-2v1h-3v15h15v-15h-3zM10 2h2v1h-2v-1zM3 2h2v1h-2v-1zM14 15h-13v-11h13v11z" })
            );
        }
        function Calendar3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Calendar3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Calendar3.SVG = Calendar3SVG;
        return Calendar3;
    })();
export const Calendar4 = /*#__PURE__*/ (() => {
    function Calendar4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 3h-1v2h-3v-2h-3v2h-3v-2h-1c-0.55 0-1 0.45-1 1v11c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-11c0-0.55-0.45-1-1-1zM4 15h-1.998c-0.001-0.001-0.001-0.001-0.002-0.002v-1.998h2v2zM4 12h-2v-2h2v2zM4 9h-2v-2h2v2zM7 15h-2v-2h2v2zM7 12h-2v-2h2v2zM7 9h-2v-2h2v2zM10 15h-2v-2h2v2zM10 12h-2v-2h2v2zM10 9h-2v-2h2v2zM13 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-1.998v-2h2v1.998zM13 12h-2v-2h2v2zM13 9h-2v-2h2v2zM5 2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2h1v-2zM11 2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2h1v-2z" })
        );
    }
    function Calendar4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Calendar4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calendar4.SVG = Calendar4SVG;
    return Calendar4;
})();
export const Calendar5 = /*#__PURE__*/ (() => {
    function Calendar5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 2h-1.5v0.5c0 0.551-0.449 1-1 1s-1-0.449-1-1v-0.5h-5v0.5c0 0.551-0.449 1-1 1s-1-0.449-1-1v-0.5h-1.5c-0.55 0-1 0.45-1 1v11c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-11c0-0.55-0.45-1-1-1zM14 13.998c-0.001 0.001-0.001 0.001-0.002 0.002h-11.996c-0.001-0.001-0.001-0.001-0.002-0.002v-8.998h12v8.998zM4.5 3c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5zM11.5 3c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5zM9 6h-5v1h4v2h-4v1h4v2h-4v1h5zM11 13h1v-7h-2v1h1zM13.625 15.375h-11.25c-0.55 0-1-0.325-1-0.875v0.5c0 0.55 0.45 1 1 1h11.25c0.55 0 1-0.45 1-1v-0.5c0 0.55-0.45 0.875-1 0.875z" })
        );
    }
    function Calendar5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Calendar5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Calendar5.SVG = Calendar5SVG;
    return Calendar5;
})();
export const CalendarEmpty = /*#__PURE__*/ (() => {
    function CalendarEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 2v-2h-2v2h-8v-2h-2v2h-2v14h16v-14h-2zM3 15h-2v-2h2v2zM3 12h-2v-2h2v2zM3 9h-2v-2h2v2zM3 6h-2v-2h2v2zM6 15h-2v-2h2v2zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM6 6h-2v-2h2v2zM9 15h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM9 6h-2v-2h2v2zM12 15h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM12 6h-2v-2h2v2zM15 15h-2v-2h2v2zM15 12h-2v-2h2v2zM15 9h-2v-2h2v2zM15 6h-2v-2h2v2z" })
        );
    }
    function CalendarEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CalendarEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CalendarEmpty.SVG = CalendarEmptySVG;
    return CalendarEmpty;
})();
export const CalendarDay = /*#__PURE__*/ (() => {
        function CalendarDaySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 9c-0.553 0-1-0.447-1-1s0.447-1 1-1 1 0.447 1 1-0.447 1-1 1z" }),
_('path', { d: "M14 2v-2h-2v2h-8v-2h-2v2h-2v14h16v-14h-2zM3 15h-2v-2h2v2zM3 12h-2v-2h2v2zM3 9h-2v-2h2v2zM3 6h-2v-2h2v2zM6 15h-2v-2h2v2zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM6 6h-2v-2h2v2zM9 15h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM9 6h-2v-2h2v2zM12 15h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM12 6h-2v-2h2v2zM15 15h-2v-2h2v2zM15 12h-2v-2h2v2zM15 9h-2v-2h2v2zM15 6h-2v-2h2v2z" })
            );
        }
        function CalendarDay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarDaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarDay.SVG = CalendarDaySVG;
        return CalendarDay;
    })();
export const CalendarWeek = /*#__PURE__*/ (() => {
        function CalendarWeekSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 9c-0.553 0-1-0.447-1-1s0.447-1 1-1 1 0.447 1 1-0.447 1-1 1zM12 8c0-0.553-0.447-1-1-1s-1 0.447-1 1 0.447 1 1 1 1-0.447 1-1zM15 8c0-0.553-0.447-1-1-1s-1 0.447-1 1 0.447 1 1 1 1-0.447 1-1zM6 8c0-0.553-0.447-1-1-1s-1 0.447-1 1 0.447 1 1 1 1-0.447 1-1zM3 8c0-0.553-0.447-1-1-1s-1 0.447-1 1 0.447 1 1 1 1-0.447 1-1z" }),
_('path', { d: "M14 2v-2h-2v2h-8v-2h-2v2h-2v14h16v-14h-2zM3 15h-2v-2h2v2zM3 12h-2v-2h2v2zM3 9h-2v-2h2v2zM3 6h-2v-2h2v2zM6 15h-2v-2h2v2zM6 12h-2v-2h2v2zM6 9h-2v-2h2v2zM6 6h-2v-2h2v2zM9 15h-2v-2h2v2zM9 12h-2v-2h2v2zM9 9h-2v-2h2v2zM9 6h-2v-2h2v2zM12 15h-2v-2h2v2zM12 12h-2v-2h2v2zM12 9h-2v-2h2v2zM12 6h-2v-2h2v2zM15 15h-2v-2h2v2zM15 12h-2v-2h2v2zM15 9h-2v-2h2v2zM15 6h-2v-2h2v2z" })
            );
        }
        function CalendarWeek({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CalendarWeekSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CalendarWeek.SVG = CalendarWeekSVG;
        return CalendarWeek;
    })();
export const Printer = /*#__PURE__*/ (() => {
        function PrinterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.916 7.223l-2-3c-0.093-0.139-0.249-0.223-0.416-0.223h-1.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276 0-0.5 0.224-0.5 0.5v3.5h-1.5c-0.167 0-0.323 0.084-0.416 0.223l-2 3c-0.055 0.082-0.084 0.179-0.084 0.277v5c0 0.276 0.224 0.5 0.5 0.5h2.306l-0.781 2.342c-0.051 0.152-0.025 0.32 0.069 0.45s0.245 0.208 0.406 0.208h11c0.161 0 0.312-0.077 0.406-0.208s0.12-0.298 0.069-0.45l-0.781-2.342h2.306c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.099-0.029-0.195-0.084-0.277zM5 1h6v4h-6v-4zM3.194 15l1.667-5h6.279l1.667 5h-9.613zM15 12h-2.14l-0.886-2.658c-0.068-0.204-0.259-0.342-0.474-0.342h-7c-0.215 0-0.406 0.138-0.474 0.342l-0.886 2.658h-2.14v-4.349l1.768-2.651h1.232v0.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-0.5h1.232l1.768 2.651v4.349z" }),
_('path', { d: "M9.5 11h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M10.5 13h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Printer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PrinterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Printer.SVG = PrinterSVG;
        return Printer;
    })();
export const Printer2 = /*#__PURE__*/ (() => {
        function Printer2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.5 11h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M10.5 13h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M15.916 7.223l-2-3c-0.093-0.139-0.249-0.223-0.416-0.223h-1.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-7c-0.276 0-0.5 0.224-0.5 0.5v3.5h-1.5c-0.167 0-0.323 0.084-0.416 0.223l-2 3c-0.055 0.082-0.084 0.179-0.084 0.277v5c0 0.276 0.224 0.5 0.5 0.5h2.306l-0.781 2.342c-0.051 0.152-0.025 0.32 0.069 0.45s0.245 0.208 0.406 0.208h11c0.161 0 0.312-0.077 0.406-0.208s0.12-0.298 0.069-0.45l-0.781-2.342h2.306c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.099-0.029-0.195-0.084-0.277zM5 1h6v4h-6v-4zM3.194 15l1.667-5h6.279l1.667 5h-9.613z" })
            );
        }
        function Printer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Printer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Printer2.SVG = Printer2SVG;
        return Printer2;
    })();
export const Printer3 = /*#__PURE__*/ (() => {
        function Printer3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 1h8v2h-8v-2z" }),
_('path', { d: "M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z" })
            );
        }
        function Printer3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Printer3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Printer3.SVG = Printer3SVG;
        return Printer3;
    })();
export const Printer4 = /*#__PURE__*/ (() => {
    function Printer4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9v4h-12v-4h-2v6h16v-6zM13 1h-10v11h10v-11zM11 10h-6v-1h6v1zM11 7h-6v-1h6v1zM11 4h-6v-1h6v1z" })
        );
    }
    function Printer4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Printer4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Printer4.SVG = Printer4SVG;
    return Printer4;
})();
export const Shredder = /*#__PURE__*/ (() => {
        function ShredderSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M6.5 15c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8.5 15c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 5h-2.5v1h-9v-1h-2.5c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h2.5v-3h9v3h2.5c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M4 0h7v5h-7v-5z" })
            );
        }
        function Shredder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShredderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shredder.SVG = ShredderSVG;
        return Shredder;
    })();
export const Mouse = /*#__PURE__*/ (() => {
    function MouseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 1.232v4.768h-4v-4.768c-1.494 0.347-3 1.144-3 2.768v6.625c0 2.416 2.239 4.375 5 4.375s5-1.959 5-4.375v-6.625c0-1.624-1.506-2.42-3-2.768zM9 1.060c-0.366-0.042-0.709-0.060-1-0.060s-0.634 0.018-1 0.060v3.94h2v-3.94z" })
        );
    }
    function Mouse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MouseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mouse.SVG = MouseSVG;
    return Mouse;
})();
export const Mouse2 = /*#__PURE__*/ (() => {
    function Mouse2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.43 9.942l-2.4-4c-1.11-1.851-3.481-2.479-5.356-1.447-0.404-0.726-0.674-1.413-0.674-1.995 0-0.546 0.118-1.255 0.683-1.526 0.043-0.021 0.107-0.052 0.171-0.115 0.195-0.195 0.195-0.512 0-0.707-0.165-0.165-0.415-0.19-0.607-0.078-0.804 0.388-1.247 1.249-1.247 2.426 0 0.812 0.345 1.688 0.858 2.587-1.342 1.261-1.674 3.327-0.688 4.971l2.4 4c0.75 1.25 2.075 1.943 3.434 1.943 0.7 0 1.41-0.184 2.054-0.571 1.894-1.137 2.509-3.594 1.372-5.488zM7.377 9.307c-0.143 0.091-0.303 0.134-0.461 0.134-0.284 0-0.562-0.141-0.726-0.398l-1.149-1.806c-0.255-0.4-0.137-0.932 0.264-1.186s0.932-0.137 1.186 0.264l1.149 1.806c0.255 0.4 0.137 0.932-0.264 1.186z" })
        );
    }
    function Mouse2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mouse2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mouse2.SVG = Mouse2SVG;
    return Mouse2;
})();
export const MouseLeft = /*#__PURE__*/ (() => {
    function MouseLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1c-1.5 0-4.5 0.584-4.5 3v6.625c0 2.416 2.015 4.375 4.5 4.375s4.5-1.959 4.5-4.375v-6.625c0-2.416-3-3-4.5-3zM11 10.625c0 0.896-0.361 1.74-1.015 2.377-0.321 0.313-0.696 0.558-1.114 0.73-0.434 0.178-0.895 0.269-1.371 0.269s-0.938-0.090-1.371-0.269c-0.417-0.172-0.792-0.417-1.114-0.73-0.655-0.636-1.015-1.48-1.015-2.377v-3.625h7v3.625zM11 6h-3v-4c0.59 0.051 1.294 0.216 1.881 0.496 0.369 0.176 0.65 0.387 0.835 0.627 0.191 0.247 0.284 0.534 0.284 0.877v2z" })
        );
    }
    function MouseLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MouseLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MouseLeft.SVG = MouseLeftSVG;
    return MouseLeft;
})();
export const MouseRight = /*#__PURE__*/ (() => {
    function MouseRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1c-1.5 0-4.5 0.584-4.5 3v6.625c0 2.416 2.015 4.375 4.5 4.375s4.5-1.959 4.5-4.375v-6.625c0-2.416-3-3-4.5-3zM4 4c0-0.343 0.093-0.63 0.284-0.877 0.185-0.24 0.466-0.451 0.835-0.627 0.587-0.28 1.292-0.445 1.881-0.496v4h-3v-2zM11 10.625c0 0.896-0.361 1.74-1.015 2.377-0.321 0.313-0.696 0.558-1.114 0.73-0.434 0.178-0.895 0.269-1.371 0.269s-0.938-0.090-1.371-0.269c-0.417-0.172-0.792-0.417-1.114-0.73-0.655-0.636-1.015-1.48-1.015-2.377v-3.625h7v3.625z" })
        );
    }
    function MouseRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MouseRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MouseRight.SVG = MouseRightSVG;
    return MouseRight;
})();
export const Keyboard = /*#__PURE__*/ (() => {
    function KeyboardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 2h-16c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM10 4h2v2h-2v-2zM13 7v2h-2v-2h2zM7 4h2v2h-2v-2zM10 7v2h-2v-2h2zM4 4h2v2h-2v-2zM7 7v2h-2v-2h2zM2 4h1v2h-1v-2zM2 7h2v2h-2v-2zM3 12h-1v-2h1v2zM12 12h-8v-2h8v2zM16 12h-3v-2h3v2zM16 9h-2v-2h2v2zM16 6h-3v-2h3v2z" })
        );
    }
    function Keyboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Keyboard.SVG = KeyboardSVG;
    return Keyboard;
})();
export const Keyboard2 = /*#__PURE__*/ (() => {
    function Keyboard2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v7c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-7c0-0.55-0.45-1-1-1zM14 11.998c-0.001 0.001-0.001 0.001-0.002 0.002h-12.996c-0.001-0.001-0.001-0.001-0.002-0.002v-6.996c0.001-0.001 0.001-0.001 0.002-0.002h12.996c0.001 0.001 0.001 0.001 0.002 0.002v6.996zM4 10h7v1h-7zM11 8h1v1h-1zM9 8h1v1h-1zM7 8h1v1h-1zM5 8h1v1h-1zM3 8h1v1h-1zM10 6h1v1h-1zM12 6h1v1h-1zM8 6h1v1h-1zM6 6h1v1h-1zM4 6h1v1h-1zM2 6h1v1h-1z" })
        );
    }
    function Keyboard2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Keyboard2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Keyboard2.SVG = Keyboard2SVG;
    return Keyboard2;
})();
export const Typewriter = /*#__PURE__*/ (() => {
        function TypewriterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 6v-5h6.293l1.707 1.707v3.293h1v-3.5c0-0.133-0.053-0.26-0.146-0.354l-2-2c-0.094-0.094-0.221-0.146-0.354-0.146h-7c-0.276 0-0.5 0.224-0.5 0.5v5.5h1z" }),
_('path', { d: "M15.928 13.243l0-0.001-2.546-4.243h1.617v-2h-14v2h1.617l-2.545 4.243c-0.045 0.075-0.072 0.163-0.072 0.257v2c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.094-0.026-0.182-0.072-0.257zM10.5 9h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM10.5 11h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM7.5 9h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM7.5 11h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM4.5 9h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM4.5 11h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM13.5 14h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M5.5 3h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-4c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5z" }),
_('path', { d: "M10.5 4h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Typewriter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TypewriterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Typewriter.SVG = TypewriterSVG;
        return Typewriter;
    })();
export const Display = /*#__PURE__*/ (() => {
    function DisplaySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z" })
        );
    }
    function Display({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DisplaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Display.SVG = DisplaySVG;
    return Display;
})();
export const Display2 = /*#__PURE__*/ (() => {
    function Display2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1zM1.5 7.125h13v0.25h-13zM1.5 6.625h13v0.25h-13zM1.5 7.625h13v0.25h-13zM1.5 6.125h13v0.25h-13zM1.5 8.125h13v0.25h-13zM1.5 9.125h13v0.25h-13zM1.5 8.625h13v0.25h-13zM1.5 3.125h13v0.25h-13zM1.5 5.625h13v0.25h-13zM1.5 3.625h13v0.25h-13zM1.5 2.625h13v0.25h-13zM1.5 5.125h13v0.25h-13zM1.5 4.625h13v0.25h-13zM1.5 4.125h13v0.25h-13z" })
        );
    }
    function Display2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Display2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Display2.SVG = Display2SVG;
    return Display2;
})();
export const Display3 = /*#__PURE__*/ (() => {
    function Display3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1.5 7.375h8.906l-0.438-0.25h-8.469zM1.5 6.875h8.031l-0.438-0.25h-7.594zM1.5 6.375h7.156l-0.438-0.25h-6.719zM1.5 5.875h6.281l-0.438-0.25h-5.844zM1.5 7.875h9.781l-0.438-0.25h-9.344zM1.5 8.375h10.656l-0.438-0.25h-10.219zM1.5 8.875h11.531l-0.438-0.25h-11.094zM1.5 2.875h1.031l-0.438-0.25h-0.594zM1.5 9.125v0.25h12.406l-0.438-0.25zM1.5 3.375h1.906l-0.438-0.25h-1.469zM1.5 3.875h2.781l-0.438-0.25h-2.344zM1.5 4.875h4.531l-0.438-0.25h-4.094zM1.5 4.375h3.656l-0.438-0.25h-3.219zM1.5 5.375h5.406l-0.438-0.25h-4.969zM0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z" })
        );
    }
    function Display3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Display3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Display3.SVG = Display3SVG;
    return Display3;
})();
export const Display4 = /*#__PURE__*/ (() => {
    function Display4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-12h-16v12h7v1h-3v1h8v-1h-3v-1h7zM2 3h12v8h-12v-8z" })
        );
    }
    function Display4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Display4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Display4.SVG = Display4SVG;
    return Display4;
})();
export const Laptop = /*#__PURE__*/ (() => {
    function LaptopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z" })
        );
    }
    function Laptop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LaptopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Laptop.SVG = LaptopSVG;
    return Laptop;
})();
export const Mobile = /*#__PURE__*/ (() => {
    function MobileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 0h-7c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h7c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 0.75h4v0.5h-4v-0.5zM8 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM12 12h-8v-10h8v10z" })
        );
    }
    function Mobile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MobileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mobile.SVG = MobileSVG;
    return Mobile;
})();
export const Mobile2 = /*#__PURE__*/ (() => {
    function Mobile2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 0h-9c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM7.5 15.278c-0.43 0-0.778-0.348-0.778-0.778s0.348-0.778 0.778-0.778 0.778 0.348 0.778 0.778-0.348 0.778-0.778 0.778zM12 13h-9v-11h9v11z" })
        );
    }
    function Mobile2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mobile2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mobile2.SVG = Mobile2SVG;
    return Mobile2;
})();
export const Tablet = /*#__PURE__*/ (() => {
    function TabletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 0h-10c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h10c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7.5 15.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12 14h-9v-12h9v12z" })
        );
    }
    function Tablet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TabletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tablet.SVG = TabletSVG;
    return Tablet;
})();
export const Mobile3 = /*#__PURE__*/ (() => {
    function Mobile3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 0c-0.276 0-0.5 0.224-0.5 0.5v1.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5v-15c0-0.276-0.224-0.5-0.5-0.5zM6 15h-1v-1h1v1zM6 13h-1v-1h1v1zM6 11h-1v-1h1v1zM8 15h-1v-1h1v1zM8 13h-1v-1h1v1zM8 11h-1v-1h1v1zM10 15h-1v-1h1v1zM10 13h-1v-1h1v1zM10 11h-1v-1h1v1zM10 9h-5v-6h5v6z" })
        );
    }
    function Mobile3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mobile3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mobile3.SVG = Mobile3SVG;
    return Mobile3;
})();
export const Tv = /*#__PURE__*/ (() => {
    function TvSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.331 4.502c-1.388-0.199-2.865-0.344-4.407-0.425l2.576-2.576-1-1-3.509 3.509c-0.328-0.006-0.659-0.009-0.991-0.009v0l-4-4-1 1 3.034 3.034c-1.889 0.066-3.693 0.227-5.365 0.467-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM13.498 13.666c-1.683 0.215-3.543 0.334-5.498 0.334s-3.815-0.119-5.498-0.334c-0.323-1.122-0.502-2.362-0.502-3.666s0.179-2.543 0.502-3.666c1.683-0.215 3.543-0.334 5.498-0.334s3.815 0.119 5.498 0.334c0.323 1.122 0.502 2.362 0.502 3.666s-0.179 2.543-0.502 3.666z" })
        );
    }
    function Tv({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TvSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tv.SVG = TvSVG;
    return Tv;
})();
export const Radio = /*#__PURE__*/ (() => {
        function RadioSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 5h-10.249l9.928-4.033c0.247-0.101 0.374-0.381 0.282-0.634-0.094-0.26-0.381-0.394-0.641-0.299l-13.59 5.004c-0.42 0.119-0.73 0.506-0.73 0.963v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM2 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM2 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM3 7v1h-2v-2h7v2h-4v-1h-1zM11.5 15c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5-1.567 3.5-3.5 3.5z" }),
_('path', { d: "M11 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Radio({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RadioSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Radio.SVG = RadioSVG;
        return Radio;
    })();
export const Cabinet = /*#__PURE__*/ (() => {
        function CabinetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 16h12v-4h-12v4zM6 13.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5h-2v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1z" }),
_('path', { d: "M2 11h12v-4h-12v4zM6 8.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5h-2v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1z" }),
_('path', { d: "M11 0h-6l-3 2v4h12v-4l-3-2zM10 4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5h-2v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v1z" })
            );
        }
        function Cabinet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CabinetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cabinet.SVG = CabinetSVG;
        return Cabinet;
    })();
export const Drawer = /*#__PURE__*/ (() => {
        function DrawerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z" }),
_('path', { d: "M11.5 8h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 10h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Drawer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Drawer.SVG = DrawerSVG;
        return Drawer;
    })();
export const Drawer2 = /*#__PURE__*/ (() => {
    function Drawer2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z" })
        );
    }
    function Drawer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Drawer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Drawer2.SVG = Drawer2SVG;
    return Drawer2;
})();
export const DrawerOut = /*#__PURE__*/ (() => {
        function DrawerOutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.89 10.188l-4-5c-0.172-0.216-0.487-0.251-0.703-0.078s-0.251 0.487-0.078 0.703l3.89 4.863v0.325h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.89-4.863c0.173-0.216 0.138-0.53-0.078-0.703s-0.53-0.138-0.703 0.078l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312z" }),
_('path', { d: "M8 0.5l-3.5 3.5h2.5v5h2v-5h2.5z" })
            );
        }
        function DrawerOut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerOutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerOut.SVG = DrawerOutSVG;
        return DrawerOut;
    })();
export const DrawerIn = /*#__PURE__*/ (() => {
        function DrawerInSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.89 10.188l-4-5c-0.172-0.216-0.487-0.251-0.703-0.078s-0.251 0.487-0.078 0.703l3.89 4.863v0.325h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.89-4.863c0.173-0.216 0.138-0.53-0.078-0.703s-0.53-0.138-0.703 0.078l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312z" }),
_('path', { d: "M8 11.5l3.5-3.5h-2.5v-5h-2v5h-2.5z" })
            );
        }
        function DrawerIn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DrawerInSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DrawerIn.SVG = DrawerInSVG;
        return DrawerIn;
    })();
export const Drawer3 = /*#__PURE__*/ (() => {
    function Drawer3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.039 0l1.051 8.931-1.179 0.139-0.938-7.976h-9.944l-0.938 7.976-1.179-0.139 1.051-8.931zM4 2h8v1h-8zM4 4h8v1h-8zM4 6h8v1h-8zM4 8h8v1h-8zM15.5 10h-15c-0.275 0-0.429 0.213-0.342 0.474l1.684 5.051c0.087 0.261 0.383 0.474 0.658 0.474h11c0.275 0 0.571-0.213 0.658-0.474l1.684-5.051c0.087-0.261-0.067-0.474-0.342-0.474zM10 12h-4v-1h4v1z" })
        );
    }
    function Drawer3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Drawer3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Drawer3.SVG = Drawer3SVG;
    return Drawer3;
})();
export const Box = /*#__PURE__*/ (() => {
    function BoxSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 2h14v2h-14zM2 14h12v-9h-12v9zM6 6h4v1h-4v-1z" })
        );
    }
    function Box({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Box.SVG = BoxSVG;
    return Box;
})();
export const BoxAdd = /*#__PURE__*/ (() => {
    function BoxAddSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM8 13l-5-4h3v-3h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1h-11.172z" })
        );
    }
    function BoxAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoxAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BoxAdd.SVG = BoxAddSVG;
    return BoxAdd;
})();
export const BoxRemove = /*#__PURE__*/ (() => {
    function BoxRemoveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM10 10v3h-4v-3h-3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1h-11.171z" })
        );
    }
    function BoxRemove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoxRemoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BoxRemove.SVG = BoxRemoveSVG;
    return BoxRemove;
})();
export const Download = /*#__PURE__*/ (() => {
    function DownloadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z" })
        );
    }
    function Download({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download.SVG = DownloadSVG;
    return Download;
})();
export const Upload = /*#__PURE__*/ (() => {
    function UploadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 9h2v-4h3l-4-4-4 4h3zM10 6.75v1.542l4.579 1.708-6.579 2.453-6.579-2.453 4.579-1.708v-1.542l-6 2.25v4l8 3 8-3v-4z" })
        );
    }
    function Upload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload.SVG = UploadSVG;
    return Upload;
})();
export const FloppyDisk = /*#__PURE__*/ (() => {
        function FloppyDiskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 0h-13c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h15c0.275 0 0.5-0.225 0.5-0.5v-13l-2.5-2.5zM4 0.5h8v4c0 0.275-0.225 0.5-0.5 0.5h-7c-0.275 0-0.5-0.225-0.5-0.5v-4zM14 15.5h-12v-6.5c0-0.552 0.448-1 1-1h10c0.552 0 1 0.448 1 1v6.5z" }),
_('path', { d: "M9 1h2v3h-2v-3z" }),
_('path', { d: "M4 9h8v1h-8v-1z" }),
_('path', { d: "M4 11h8v1h-8v-1z" }),
_('path', { d: "M4 13h8v1h-8v-1z" })
            );
        }
        function FloppyDisk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FloppyDiskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FloppyDisk.SVG = FloppyDiskSVG;
        return FloppyDisk;
    })();
export const FloppyDisks = /*#__PURE__*/ (() => {
        function FloppyDisksSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 6h1v2h-1v-2z" }),
_('path', { d: "M13.5 5h-2.5v-2.5l-2.5-2.5h-8c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v4.5c0 0.275 0.225 0.5 0.5 0.5h10c0.275 0 0.5-0.225 0.5-0.5v-8l-2.5-2.5zM13 5.5v3c0 0.275-0.225 0.5-0.5 0.5h-4c-0.275 0-0.5-0.225-0.5-0.5v-3h5zM5 10h-3v-2.5c0-0.276 0.224-0.5 0.5-0.5h2.5v3zM3.5 4c-0.275 0-0.5-0.225-0.5-0.5v-3h5v3c0 0.275-0.225 0.5-0.5 0.5h-4zM14 15h-7v-2.5c0-0.276 0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5v2.5z" }),
_('path', { d: "M6 1h1v2h-1v-2z" })
            );
        }
        function FloppyDisks({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FloppyDisksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FloppyDisks.SVG = FloppyDisksSVG;
        return FloppyDisks;
    })();
export const FloppyDisks2 = /*#__PURE__*/ (() => {
        function FloppyDisks2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 6h1v2h-1v-2z" }),
_('path', { d: "M13.5 5h-2.5v-2.5l-2.5-2.5h-8c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v4.5c0 0.275 0.225 0.5 0.5 0.5h10c0.275 0 0.5-0.225 0.5-0.5v-8l-2.5-2.5zM7.5 12h6c0.127 0 0.242 0.047 0.33 0.125h-6.66c0.088-0.078 0.203-0.125 0.33-0.125zM7 15v-0.125h7v0.125h-7zM7 14.625v-0.25h7v0.25h-7zM7 14.125v-0.25h7v0.25h-7zM7 13.625v-0.25h7v0.25h-7zM7 13.125v-0.25h7v0.25h-7zM7 12.625v-0.125c0-0.043 0.006-0.085 0.016-0.125h6.967c0.010 0.040 0.016 0.082 0.016 0.125v0.125h-7zM13 5.5v3c0 0.275-0.225 0.5-0.5 0.5h-4c-0.275 0-0.5-0.225-0.5-0.5v-3h5zM5 7.125h-2.83c0.088-0.078 0.203-0.125 0.33-0.125h2.5v0.125zM2 10v-0.125h3v0.125h-3zM2 9.625v-0.25h3v0.25h-3zM2 9.125v-0.25h3v0.25h-3zM2 8.625v-0.25h3v0.25h-3zM2 8.125v-0.25h3v0.25h-3zM2 7.625v-0.125c0-0.043 0.006-0.085 0.016-0.125h2.984v0.25h-3zM3.5 4c-0.275 0-0.5-0.225-0.5-0.5v-3h5v3c0 0.275-0.225 0.5-0.5 0.5h-4z" }),
_('path', { d: "M6 1h1v2h-1v-2z" })
            );
        }
        function FloppyDisks2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FloppyDisks2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FloppyDisks2.SVG = FloppyDisks2SVG;
        return FloppyDisks2;
    })();
export const FloppyDisk2 = /*#__PURE__*/ (() => {
    function FloppyDisk2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-14v16h16v-14l-2-2zM8 2h2v4h-2v-4zM14 14h-12v-12h1v5h9v-5h1.172l0.828 0.828v11.172z" })
        );
    }
    function FloppyDisk2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FloppyDisk2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FloppyDisk2.SVG = FloppyDisk2SVG;
    return FloppyDisk2;
})();
export const FloppyDisk3 = /*#__PURE__*/ (() => {
        function FloppyDisk3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M8 5.5h1v2h-1v-2z" }),
_('path', { d: "M10.5 4h-6c-0.275 0-0.5 0.225-0.5 0.5v7c0 0.275 0.225 0.5 0.5 0.5h7c0.275 0 0.5-0.225 0.5-0.5v-6l-1.5-1.5zM6 5h4v3h-4v-3zM11 11h-6v-1h6v1z" })
            );
        }
        function FloppyDisk3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FloppyDisk3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FloppyDisk3.SVG = FloppyDisk3SVG;
        return FloppyDisk3;
    })();
export const Disk = /*#__PURE__*/ (() => {
        function DiskSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 6.508c-0.823 0-1.492 0.669-1.492 1.492s0.669 1.492 1.492 1.492 1.492-0.669 1.492-1.492-0.669-1.492-1.492-1.492z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.609 8c0 1.439-1.171 2.609-2.609 2.609s-2.609-1.171-2.609-2.609 1.171-2.609 2.609-2.609 2.609 1.171 2.609 2.609zM2.064 11.71l3.3-2.063c0.25 0.399 0.589 0.738 0.988 0.988l-2.063 3.3c-0.9-0.564-1.662-1.326-2.226-2.226zM10.636 6.353c-0.251-0.399-0.589-0.738-0.988-0.988l2.063-3.3c0.9 0.564 1.662 1.326 2.226 2.226l-3.3 2.063z" })
            );
        }
        function Disk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DiskSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Disk.SVG = DiskSVG;
        return Disk;
    })();
export const Disk2 = /*#__PURE__*/ (() => {
    function Disk2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 6.508c-0.823 0-1.492 0.669-1.492 1.492s0.669 1.492 1.492 1.492c0.823 0 1.492-0.669 1.492-1.492s-0.669-1.492-1.492-1.492zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM13.733 3.874c-0.060-0.083-0.122-0.166-0.186-0.246 0.064 0.081 0.126 0.163 0.186 0.246zM13.336 3.374c-0.036-0.041-0.072-0.082-0.108-0.122 0.037 0.040 0.073 0.081 0.108 0.122zM13.217 3.24c-0.035-0.039-0.071-0.077-0.107-0.115 0.036 0.038 0.072 0.076 0.107 0.115zM3.141 13.125c0.044 0.041 0.088 0.082 0.132 0.122-0.044-0.040-0.089-0.081-0.132-0.122zM3.279 13.252c0.046 0.041 0.092 0.082 0.139 0.122-0.047-0.040-0.093-0.080-0.139-0.122zM4.256 13.99c-0.060-0.037-0.119-0.076-0.177-0.115h0.249l-0.072 0.115zM4.484 13.625h-0.755c0.056 0.043 0.113 0.085 0.17 0.126-0.165-0.118-0.325-0.243-0.48-0.376h1.222l-0.156 0.25zM4.078 13.875c-0.059-0.040-0.118-0.080-0.175-0.121 0.058 0.041 0.116 0.082 0.175 0.121zM4.797 13.125h-1.656c-0.045-0.043-0.090-0.087-0.135-0.131-0.076-0.076-0.15-0.155-0.223-0.234 0.035 0.039 0.071 0.077 0.107 0.115h2.063l-0.156 0.25zM2.663 12.625c0.036 0.041 0.072 0.082 0.109 0.123-0.037-0.040-0.073-0.081-0.109-0.123zM5.109 12.625h-2.446c-0.14-0.161-0.272-0.328-0.396-0.499 0.061 0.084 0.123 0.168 0.188 0.249h2.81l-0.156 0.25zM5.422 12.125h-3.155c-0.090-0.124-0.176-0.251-0.257-0.381 0.028 0.044 0.056 0.088 0.085 0.131h3.483l-0.156 0.25zM5.734 11.625h-3.534l0.4-0.25h3.291l-0.156 0.25zM6.047 11.125h-3.047l0.4-0.25h2.803l-0.156 0.25zM13.249 4.72l0.151-0.095h-3.291l-0.156 0.25h3.047l-0.4 0.25h-2.803l-0.156 0.25h2.559l-0.4 0.25h-2.236c0.115 0.076 0.223 0.159 0.325 0.25h1.51l-0.4 0.25h-0.862c0.070 0.080 0.135 0.163 0.196 0.25h0.266l-0.188 0.118c0.274 0.437 0.432 0.954 0.432 1.507 0 1.571-1.273 2.844-2.844 2.844-0.554 0-1.070-0.158-1.507-0.432l-0.133 0.213h-2.559l0.4-0.25h2.236c-0.115-0.076-0.223-0.159-0.325-0.25h-1.51l0.988-0.618c-0.274-0.437-0.432-0.954-0.432-1.507 0-1.571 1.273-2.844 2.844-2.844 0.554 0 1.070 0.158 1.507 0.432l2.236-3.578c0.12 0.075 0.238 0.154 0.354 0.237-0.058-0.042-0.117-0.082-0.176-0.122l-0.406 0.25h0.755c-0.056-0.043-0.113-0.085-0.171-0.126 0.165 0.118 0.326 0.244 0.481 0.376h-1.222l-0.156 0.25h1.656c-0.043-0.041-0.087-0.082-0.132-0.121 0.091 0.082 0.18 0.166 0.266 0.253 0.039 0.039 0.078 0.079 0.116 0.119h-2.063l-0.156 0.25h2.446c0.071 0.082 0.141 0.165 0.208 0.25h-2.81l-0.156 0.25h3.155c0.090 0.124 0.176 0.251 0.257 0.381l-0.741 0.463zM12.582 2.626c0.047 0.040 0.093 0.080 0.139 0.121-0.046-0.041-0.092-0.082-0.139-0.121zM10.422 4.125l-0.156 0.25h3.534l0.19-0.119c-0.028-0.044-0.056-0.088-0.085-0.131h-3.483zM5.4 9.625l-0.4 0.25h0.862c-0.070-0.080-0.135-0.163-0.196-0.25h-0.266z" })
        );
    }
    function Disk2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Disk2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Disk2.SVG = Disk2SVG;
    return Disk2;
})();
export const UsbStick = /*#__PURE__*/ (() => {
        function UsbStickSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 2c-0.276 0-0.5 0.224-0.5 0.5v1c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M8.5 2c-0.276 0-0.5 0.224-0.5 0.5v1c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M11.5 5h-0.5v-4.5c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276 0-0.5 0.224-0.5 0.5v4.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5v9.375c1 1.5 8 1.5 9 0v-9.375c0-0.276-0.224-0.5-0.5-0.5zM5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v6zM10 5h-5v-4h5v4z" })
            );
        }
        function UsbStick({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsbStickSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UsbStick.SVG = UsbStickSVG;
        return UsbStick;
    })();
export const Drive = /*#__PURE__*/ (() => {
    function DriveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 14h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 12h1v1h-1v-1zM15 2h-14l-1 8h16z" })
        );
    }
    function Drive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DriveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Drive.SVG = DriveSVG;
    return Drive;
})();
export const Server = /*#__PURE__*/ (() => {
        function ServerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 0h-10l-3 4h16l-3-4z" }),
_('path', { d: "M0 5v3h16v-3h-16zM15 7h-1v-1h1v1z" }),
_('path', { d: "M0 9v3h16v-3h-16zM15 11h-1v-1h1v1z" }),
_('path', { d: "M0 13v3h16v-3h-16zM15 15h-1v-1h1v1z" })
            );
        }
        function Server({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ServerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Server.SVG = ServerSVG;
        return Server;
    })();
export const Database = /*#__PURE__*/ (() => {
        function DatabaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 1.119-8 2.5v2c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-2c0-1.381-3.582-2.5-8-2.5z" }),
_('path', { d: "M8 8.5c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z" }),
_('path', { d: "M8 13c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z" })
            );
        }
        function Database({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Database.SVG = DatabaseSVG;
        return Database;
    })();
export const Database2 = /*#__PURE__*/ (() => {
    function Database2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 3.5c0-0.444-0.157-1.106-0.905-1.737-0.444-0.375-1.053-0.702-1.809-0.972-1.427-0.51-3.305-0.79-5.286-0.79s-3.859 0.281-5.286 0.79c-0.756 0.27-1.365 0.597-1.809 0.972-0.748 0.632-0.905 1.293-0.905 1.737h-0.003v9h0.003c0 0.444 0.157 1.106 0.905 1.737 0.444 0.375 1.053 0.702 1.809 0.972 1.427 0.51 3.305 0.79 5.286 0.79s3.859-0.281 5.286-0.79c0.756-0.27 1.365-0.597 1.809-0.972 0.748-0.632 0.905-1.293 0.905-1.737v-9zM3.612 2.597c1.192-0.385 2.75-0.597 4.388-0.597s3.196 0.212 4.388 0.597c1.165 0.377 1.546 0.781 1.607 0.903-0.061 0.121-0.442 0.526-1.607 0.903-1.192 0.385-2.75 0.597-4.388 0.597s-3.196-0.212-4.388-0.597c-1.165-0.377-1.546-0.781-1.607-0.903 0.061-0.121 0.442-0.526 1.607-0.903zM12.388 13.403c-1.192 0.385-2.75 0.597-4.388 0.597s-3.196-0.212-4.388-0.597c-1.165-0.376-1.546-0.781-1.607-0.903h-0.003v-2.082c0.22 0.103 0.457 0.201 0.711 0.291 1.427 0.51 3.305 0.79 5.286 0.79s3.859-0.281 5.286-0.79c0.253-0.090 0.489-0.187 0.709-0.29v2.081c-0.061 0.121-0.442 0.526-1.607 0.903zM12.388 8.903c-1.192 0.385-2.75 0.597-4.388 0.597s-3.196-0.212-4.388-0.597c-1.165-0.377-1.546-0.781-1.607-0.903h-0.003v-2.082c0.22 0.103 0.457 0.201 0.711 0.291 1.427 0.51 3.305 0.79 5.286 0.79s3.859-0.281 5.286-0.79c0.253-0.090 0.489-0.187 0.709-0.29v2.081c-0.061 0.121-0.442 0.526-1.607 0.903z" })
        );
    }
    function Database2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Database2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Database2.SVG = Database2SVG;
    return Database2;
})();
export const Database3 = /*#__PURE__*/ (() => {
    function Database3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 1.343-8 3v10c0 1.657 3.582 3 8 3s8-1.343 8-3v-10c0-1.657-3.582-3-8-3zM15 13c0 0.143-0.311 0.666-1.694 1.185-0.672 0.252-1.462 0.451-2.348 0.592-0.935 0.148-1.93 0.223-2.957 0.223s-2.023-0.075-2.957-0.223c-0.886-0.141-1.676-0.34-2.348-0.592-1.383-0.519-1.694-1.042-1.694-1.185v-3.547c1.365 0.922 3.988 1.547 7 1.547s5.635-0.624 7-1.547v3.547zM15 8c0 0.143-0.311 0.666-1.694 1.185-0.672 0.252-1.462 0.451-2.348 0.592-0.935 0.148-1.93 0.223-2.957 0.223s-2.023-0.075-2.957-0.223c-0.886-0.141-1.676-0.34-2.348-0.592-1.383-0.519-1.694-1.042-1.694-1.185v-3.547c1.365 0.922 3.988 1.547 7 1.547s5.635-0.624 7-1.547v3.547zM13.755 4c-0.136 0.061-0.285 0.123-0.45 0.185-0.672 0.252-1.462 0.451-2.348 0.592-0.935 0.148-1.93 0.223-2.957 0.223s-2.023-0.075-2.957-0.223c-0.886-0.141-1.676-0.34-2.348-0.592-0.165-0.062-0.314-0.124-0.45-0.185-1.003-0.453-1.245-0.874-1.245-1 0-0.143 0.311-0.666 1.694-1.185 0.672-0.252 1.462-0.451 2.348-0.592 0.935-0.148 1.93-0.223 2.957-0.223s2.023 0.075 2.957 0.223c0.886 0.141 1.677 0.34 2.348 0.592 1.383 0.519 1.694 1.042 1.694 1.185 0 0.126-0.242 0.547-1.245 1z" })
        );
    }
    function Database3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Database3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Database3.SVG = Database3SVG;
    return Database3;
})();
export const Database4 = /*#__PURE__*/ (() => {
    function Database4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 2c-3.038 0-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-8c0-1.381-2.462-2.5-5.5-2.5zM4.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.995-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677zM12 12.5c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v2.594zM12 8.469c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.763-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v2.531z" })
        );
    }
    function Database4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Database4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Database4.SVG = Database4SVG;
    return Database4;
})();
export const DatabaseMenu = /*#__PURE__*/ (() => {
        function DatabaseMenuSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 2c-2.761 0-5 1.119-5 2.5v8c0 1.381 2.239 2.5 5 2.5s5-1.119 5-2.5v-8c0-1.381-2.239-2.5-5-2.5zM9 8.576c-0.141 0.142-0.431 0.36-0.962 0.57-0.83 0.329-1.909 0.51-3.038 0.51s-2.208-0.181-3.038-0.51c-0.53-0.21-0.821-0.428-0.962-0.57v-2.576c0.912 0.607 2.364 1 4 1s3.088-0.393 4-1v2.576zM2.184 3.823c0.769-0.329 1.77-0.51 2.816-0.51s2.047 0.181 2.816 0.51c0.643 0.275 0.905 0.562 0.976 0.677-0.071 0.115-0.333 0.402-0.976 0.677-0.769 0.329-1.77 0.51-2.816 0.51s-2.047-0.181-2.816-0.51c-0.643-0.275-0.905-0.562-0.976-0.677 0.071-0.115 0.333-0.402 0.976-0.677zM8.038 13.177c-0.83 0.329-1.909 0.51-3.038 0.51s-2.208-0.181-3.038-0.51c-0.53-0.21-0.821-0.428-0.962-0.57v-2.638c0.912 0.607 2.364 1 4 1s3.088-0.393 4-1v2.638c-0.141 0.142-0.431 0.36-0.962 0.57z" }),
_('path', { d: "M11 5h5v2h-5v-2z" }),
_('path', { d: "M11 8h5v2h-5v-2z" }),
_('path', { d: "M11 11h5v2h-5v-2z" })
            );
        }
        function DatabaseMenu({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseMenuSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseMenu.SVG = DatabaseMenuSVG;
        return DatabaseMenu;
    })();
export const DatabaseAdd = /*#__PURE__*/ (() => {
        function DatabaseAddSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 9h-2v-2h-2v2h-2v2h2v2h2v-2h2z" }),
_('path', { d: "M10 12v0.5c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 1.33 0 2.549-0.215 3.5-0.572v-1.311c-0.050 0.020-0.103 0.040-0.158 0.060-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v2.062h1v-3.5c0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-0.5h-1zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseAdd.SVG = DatabaseAddSVG;
        return DatabaseAdd;
    })();
export const DatabaseRemove = /*#__PURE__*/ (() => {
        function DatabaseRemoveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8.414l-1.414-1.414-2.086 2.086-2.086-2.086-1.414 1.414 2.086 2.086-2.086 2.086 1.414 1.414 2.086-2.086 2.086 2.086 1.414-1.414-2.086-2.086z" }),
_('path', { d: "M8 13.421c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.9 0 1.75-0.098 2.5-0.273v-1.306c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062 3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.9 0 1.75-0.098 2.5-0.273v-1.306zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseRemove({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseRemoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseRemove.SVG = DatabaseRemoveSVG;
        return DatabaseRemove;
    })();
export const DatabaseInsert = /*#__PURE__*/ (() => {
        function DatabaseInsertSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 10l-3.5-3.5v2.5h-4v2h4v2.5z" }),
_('path', { d: "M10.5 2c-3.038 0-5.5 1.119-5.5 2.5s2.462 2.5 5.5 2.5c1.86 0 3.505-0.42 4.5-1.062v2.531c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51-0.889 0-1.748-0.093-2.5-0.266v1.306c0.75 0.174 1.6 0.273 2.5 0.273 1.86 0 3.505-0.42 4.5-1.062v2.594c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.055-0.020-0.108-0.040-0.158-0.060v1.311c0.951 0.357 2.17 0.571 3.5 0.571 3.038 0 5.5-1.119 5.5-2.5v-8c0-1.381-2.462-2.5-5.5-2.5zM13.598 5.177c-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.995-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677 0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677z" })
            );
        }
        function DatabaseInsert({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseInsertSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseInsert.SVG = DatabaseInsertSVG;
        return DatabaseInsert;
    })();
export const DatabaseExport = /*#__PURE__*/ (() => {
        function DatabaseExportSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 10l-3-3.5v2.5h-4v2h4v2.5z" }),
_('path', { d: "M10 12v0.5c-0.084 0.115-0.396 0.402-1.158 0.677-0.913 0.329-2.1 0.51-3.342 0.51s-2.429-0.181-3.342-0.51c-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.9 0 1.75-0.099 2.5-0.273v-1.306c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v2.062h1v-3.5c0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5s5.5-1.119 5.5-2.5v-0.5h-1zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseExport({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseExportSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseExport.SVG = DatabaseExportSVG;
        return DatabaseExport;
    })();
export const DatabaseUpload = /*#__PURE__*/ (() => {
        function DatabaseUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.813 13.187c-0.909 0.323-2.083 0.5-3.313 0.5-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.12 0 0.239-0.002 0.357-0.005l1.439-1.439c-0.567 0.087-1.175 0.132-1.796 0.132-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v0.883l1-1v-1.321c0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 1.244 0 2.391-0.188 3.313-0.504v-1.309zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" }),
_('path', { d: "M11 7.5l-3.5 3.5h2.5v4h2v-4h2.5z" })
            );
        }
        function DatabaseUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseUpload.SVG = DatabaseUploadSVG;
        return DatabaseUpload;
    })();
export const DatabaseRefresh = /*#__PURE__*/ (() => {
        function DatabaseRefreshSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.422 7.078c-0.786-0.672-1.807-1.078-2.922-1.078-2.202 0-4.035 1.582-4.424 3.672h1.54c0.36-1.253 1.517-2.172 2.884-2.172 0.7 0 1.344 0.241 1.855 0.645l-1.855 1.855h4.5v-4.5l-1.578 1.578z" }),
_('path', { d: "M11.5 13.5c-0.7 0-1.344-0.241-1.855-0.645l1.855-1.855h-4.5v4.5l1.578-1.578c0.786 0.672 1.807 1.078 2.922 1.078 2.202 0 4.035-1.582 4.424-3.672h-1.54c-0.36 1.253-1.517 2.172-2.884 2.172z" }),
_('path', { d: "M2.158 9.146c-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062 0.169 0 0.335-0.004 0.5-0.010v-1.314c-0.165 0.008-0.332 0.012-0.5 0.012-1.152 0-2.252-0.181-3.098-0.51-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677 0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.061 0.090-0.252 0.287-0.674 0.5h1.892c0.072-0.162 0.11-0.329 0.11-0.5 0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.169 0 0.335-0.004 0.5-0.010v-1.312c-0.165 0.007-0.332 0.010-0.5 0.010-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.169 0 0.335-0.004 0.5-0.010v-1.312c-0.165 0.007-0.332 0.010-0.5 0.010-1.242 0-2.429-0.181-3.342-0.51z" })
            );
        }
        function DatabaseRefresh({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseRefreshSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseRefresh.SVG = DatabaseRefreshSVG;
        return DatabaseRefresh;
    })();
export const DatabaseDiff = /*#__PURE__*/ (() => {
        function DatabaseDiffSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 14h6v2h-6v-2z" }),
_('path', { d: "M15 9h-2v-2h-2v2h-2v2h2v2h2v-2h2z" }),
_('path', { d: "M8 13.421c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.9 0 1.75-0.098 2.5-0.273v-1.306c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062 3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.9 0 1.75-0.098 2.5-0.273v-1.306zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseDiff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseDiffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseDiff.SVG = DatabaseDiffSVG;
        return DatabaseDiff;
    })();
export const DatabaseEdit = /*#__PURE__*/ (() => {
        function DatabaseEditSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.531 5.929l-1.696-1.060c-0.466-0.291-1.087-0.148-1.378 0.318l-0.48 0.769 3.392 2.12 0.48-0.769c0.291-0.466 0.148-1.087-0.318-1.378z" }),
_('path', { d: "M8.052 12.237l0.007 3.763 3.385-1.643 3.295-5.274-3.392-2.12z" }),
_('path', { d: "M5.5 7c3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.52 0 1.023-0.033 1.5-0.094v-1.31c-0.48 0.060-0.985 0.091-1.5 0.091-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.9 0 1.75-0.098 2.5-0.273v-1.306c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseEdit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseEditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseEdit.SVG = DatabaseEditSVG;
        return DatabaseEdit;
    })();
export const DatabaseEdit2 = /*#__PURE__*/ (() => {
        function DatabaseEdit2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.531 5.929l-1.696-1.060c-0.466-0.291-1.087-0.148-1.378 0.318l-4.405 7.049 0.007 3.763 3.385-1.643 4.405-7.049c0.291-0.466 0.148-1.087-0.318-1.378zM14.471 7.625l-3.444 5.512-1.696-1.060 3.444-5.512 1.696 1.060z" }),
_('path', { d: "M5.5 7c3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.52 0 1.023-0.033 1.5-0.094v-1.31c-0.48 0.060-0.985 0.091-1.5 0.091-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.9 0 1.75-0.099 2.5-0.273v-1.306c-0.752 0.173-1.611 0.266-2.5 0.266-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseEdit2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseEdit2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseEdit2.SVG = DatabaseEdit2SVG;
        return DatabaseEdit2;
    })();
export const DatabaseCheck = /*#__PURE__*/ (() => {
        function DatabaseCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 9l-1.5 1.5 4 4 7.5-8.5-1-1-6.5 6z" }),
_('path', { d: "M2.158 13.177c-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.717 0.463 1.771 0.81 3 0.968v-1.31c-0.679-0.085-1.307-0.226-1.842-0.419-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v2.062l1-0.923v-2.576c0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.169 0 0.335-0.004 0.5-0.010v-1.312c-0.165 0.007-0.332 0.010-0.5 0.010-1.242 0-2.429-0.181-3.342-0.51zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseCheck.SVG = DatabaseCheckSVG;
        return DatabaseCheck;
    })();
export const DatabaseArrow = /*#__PURE__*/ (() => {
        function DatabaseArrowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 1.5c2.123 0.449 3.5 2.853 3.5 5 0 2.406-1.993 4.246-4.5 4.369v-2.869l-3.5 4 3.5 4v-2.891c3.356-0.216 6-2.714 6-5.609 0-2.664-2.028-5.494-5-6z" }),
_('path', { d: "M6 13.677c-0.165 0.007-0.332 0.010-0.5 0.010-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.905 0.584 2.347 0.984 4 1.052v-1.312c-1.058-0.042-2.052-0.216-2.842-0.5-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062s3.505-0.42 4.5-1.062v3.062h1v-4.5c0-1.381-2.462-2.5-5.5-2.5s-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.169 0 0.335-0.004 0.5-0.010v-1.312zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseArrow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseArrowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseArrow.SVG = DatabaseArrowSVG;
        return DatabaseArrow;
    })();
export const DatabaseTime = /*#__PURE__*/ (() => {
        function DatabaseTimeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.5 7c3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.503 0 0.99-0.031 1.452-0.088-0.287-0.381-0.526-0.8-0.711-1.246-0.244 0.014-0.491 0.022-0.741 0.022-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.114 0 0.226-0.002 0.338-0.005 0.043-0.459 0.141-0.902 0.287-1.324-0.206 0.010-0.415 0.016-0.625 0.016-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" }),
_('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5zM14 12h-3v-3h1v2h2v1z" })
            );
        }
        function DatabaseTime({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseTimeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseTime.SVG = DatabaseTimeSVG;
        return DatabaseTime;
    })();
export const DatabaseTime2 = /*#__PURE__*/ (() => {
        function DatabaseTime2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM11.5 14.688c-1.758 0-3.188-1.43-3.188-3.188s1.43-3.188 3.188-3.188 3.188 1.43 3.188 3.188-1.43 3.188-3.188 3.188z" }),
_('path', { d: "M12 11v-2h-1v3h3v-1z" }),
_('path', { d: "M5.5 7c3.038 0 5.5-1.119 5.5-2.5s-2.462-2.5-5.5-2.5-5.5 1.119-5.5 2.5v8c0 1.381 2.462 2.5 5.5 2.5 0.503 0 0.99-0.031 1.452-0.088-0.287-0.381-0.526-0.8-0.711-1.246-0.244 0.014-0.491 0.022-0.741 0.022-1.242 0-2.429-0.181-3.342-0.51-0.763-0.275-1.074-0.562-1.158-0.677v-2.594c0.995 0.643 2.64 1.062 4.5 1.062 0.114 0 0.226-0.002 0.338-0.005 0.043-0.459 0.141-0.902 0.287-1.324-0.206 0.010-0.415 0.016-0.625 0.016-1.242 0-2.429-0.181-3.342-0.51-0.762-0.275-1.074-0.562-1.158-0.677v-2.531c0.995 0.643 2.64 1.062 4.5 1.062zM2.402 3.823c0.846-0.329 1.946-0.51 3.098-0.51s2.252 0.181 3.098 0.51c0.707 0.275 0.995 0.562 1.074 0.677-0.078 0.115-0.367 0.402-1.074 0.677-0.846 0.329-1.946 0.51-3.098 0.51s-2.252-0.181-3.098-0.51c-0.707-0.275-0.996-0.562-1.074-0.677 0.078-0.115 0.367-0.402 1.074-0.677z" })
            );
        }
        function DatabaseTime2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DatabaseTime2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DatabaseTime2.SVG = DatabaseTime2SVG;
        return DatabaseTime2;
    })();
export const Undo = /*#__PURE__*/ (() => {
    function UndoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1c-2.209 0-4.209 0.896-5.657 2.343l-2.343-2.343v6h6l-2.243-2.243c1.086-1.086 2.586-1.757 4.243-1.757 3.314 0 6 2.686 6 6 0 1.792-0.786 3.401-2.032 4.5l1.323 1.5c1.661-1.466 2.709-3.611 2.709-6 0-4.418-3.582-8-8-8z" })
        );
    }
    function Undo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UndoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Undo.SVG = UndoSVG;
    return Undo;
})();
export const Redo = /*#__PURE__*/ (() => {
    function RedoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 9c0 2.389 1.048 4.534 2.709 6l1.323-1.5c-1.246-1.099-2.031-2.708-2.031-4.5 0-3.314 2.686-6 6-6 1.657 0 3.157 0.672 4.243 1.757l-2.243 2.243h6v-6l-2.343 2.343c-1.448-1.448-3.448-2.343-5.657-2.343-4.418 0-8 3.582-8 8z" })
        );
    }
    function Redo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RedoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Redo.SVG = RedoSVG;
    return Redo;
})();
export const RotateCcw = /*#__PURE__*/ (() => {
        function RotateCcwSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 8h10v8h-10v-8z" }),
_('path', { d: "M8.5 4h-1.5v-2.5l-3 3 3 3v-2.5h1.5c3.033 0 5.5 2.467 5.5 5.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-3.584-2.916-6.5-6.5-6.5z" })
            );
        }
        function RotateCcw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RotateCcwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RotateCcw.SVG = RotateCcwSVG;
        return RotateCcw;
    })();
export const RotateCw = /*#__PURE__*/ (() => {
        function RotateCwSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 8h-10v8h10v-8z" }),
_('path', { d: "M7.5 4h1.5v-2.5l3 3-3 3v-2.5h-1.5c-3.033 0-5.5 2.467-5.5 5.5v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2c0-3.584 2.916-6.5 6.5-6.5z" })
            );
        }
        function RotateCw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RotateCwSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        RotateCw.SVG = RotateCwSVG;
        return RotateCw;
    })();
export const RotateCcw2 = /*#__PURE__*/ (() => {
    function RotateCcw2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 9c0-3.866 3.134-7 7-7s7 3.134 7 7c0 2.709-1.539 5.058-3.79 6.222 1.666-1.031 2.79-2.983 2.79-5.222 0-3.314-2.462-6-5.5-6-2.725 0-4.987 2.162-5.423 5h1.923l-3 3.5-3-3.5h2z" })
        );
    }
    function RotateCcw2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RotateCcw2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RotateCcw2.SVG = RotateCcw2SVG;
    return RotateCcw2;
})();
export const RotateCw2 = /*#__PURE__*/ (() => {
    function RotateCw2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9c0-3.866-3.134-7-7-7s-7 3.134-7 7c0 2.709 1.539 5.058 3.79 6.222-1.666-1.031-2.79-2.983-2.79-5.222 0-3.314 2.462-6 5.5-6 2.725 0 4.987 2.162 5.423 5h-1.923l3 3.5 3-3.5h-2z" })
        );
    }
    function RotateCw2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RotateCw2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RotateCw2.SVG = RotateCw2SVG;
    return RotateCw2;
})();
export const RotateCcw3 = /*#__PURE__*/ (() => {
    function RotateCcw3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 1c-3.866 0-7 3.134-7 7h-3.5l4.5 4.5 4.5-4.5h-3.5c0-2.761 2.239-5 5-5s5 2.239 5 5c0 2.761-2.239 5-5 5v2c3.866 0 7-3.134 7-7s-3.134-7-7-7z" })
        );
    }
    function RotateCcw3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RotateCcw3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RotateCcw3.SVG = RotateCcw3SVG;
    return RotateCcw3;
})();
export const RotateCw3 = /*#__PURE__*/ (() => {
    function RotateCw3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 1c3.866 0 7 3.134 7 7h3.5l-4.5 4.5-4.5-4.5h3.5c0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.761 2.239 5 5 5v2c-3.866 0-7-3.134-7-7s3.134-7 7-7z" })
        );
    }
    function RotateCw3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RotateCw3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RotateCw3.SVG = RotateCw3SVG;
    return RotateCw3;
})();
export const FlipVertical = /*#__PURE__*/ (() => {
    function FlipVerticalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 6h16v-6zM16 15v-6h-16z" })
        );
    }
    function FlipVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlipVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FlipVertical.SVG = FlipVerticalSVG;
    return FlipVertical;
})();
export const FlipVertical2 = /*#__PURE__*/ (() => {
        function FlipVertical2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 16l-16-7h16z" }),
_('path', { d: "M16 2.875v-0.25h-6l-0.571 0.25z" }),
_('path', { d: "M16 1.875v-0.25h-3.714l-0.571 0.25z" }),
_('path', { d: "M16 0.875v-0.25h-1.429l-0.571 0.25z" }),
_('path', { d: "M15.143 0.375h0.857v-0.25h-0.286z" }),
_('path', { d: "M16 1.375v-0.25h-2.571l-0.571 0.25z" }),
_('path', { d: "M16 3.375v-0.25h-7.143l-0.571 0.25z" }),
_('path', { d: "M16 2.375v-0.25h-4.857l-0.571 0.25z" }),
_('path', { d: "M16 6.375v-0.25h-14l-0.571 0.25z" }),
_('path', { d: "M16 6.875v-0.25h-15.143l-0.571 0.25z" }),
_('path', { d: "M16 5.875v-0.25h-12.857l-0.571 0.25z" }),
_('path', { d: "M16 4.875v-0.25h-10.571l-0.571 0.25z" }),
_('path', { d: "M16 4.375v-0.25h-9.429l-0.571 0.25z" }),
_('path', { d: "M16 5.375v-0.25h-11.714l-0.571 0.25z" }),
_('path', { d: "M16 3.875v-0.25h-8.286l-0.571 0.25z" })
            );
        }
        function FlipVertical2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipVertical2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipVertical2.SVG = FlipVertical2SVG;
        return FlipVertical2;
    })();
export const FlipHorizontal = /*#__PURE__*/ (() => {
    function FlipHorizontalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 0v16h6zM0 16h6v-16z" })
        );
    }
    function FlipHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlipHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FlipHorizontal.SVG = FlipHorizontalSVG;
    return FlipHorizontal;
})();
export const FlipHorizontal2 = /*#__PURE__*/ (() => {
        function FlipHorizontal2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 16l7-16v16z" }),
_('path', { d: "M9 12.125v0.25h5.414l-0.109-0.25z" }),
_('path', { d: "M9 11.625v0.25h5.195l-0.109-0.25z" }),
_('path', { d: "M9 8.125v0.25h3.664l-0.109-0.25z" }),
_('path', { d: "M9 10.625v0.25h4.758l-0.109-0.25z" }),
_('path', { d: "M9 8.625v0.25h3.883l-0.109-0.25z" }),
_('path', { d: "M9 9.125v0.25h4.102l-0.109-0.25z" }),
_('path', { d: "M9 9.625v0.25h4.32l-0.109-0.25z" }),
_('path', { d: "M9 10.125v0.25h4.539l-0.109-0.25z" }),
_('path', { d: "M9 15.125v0.25h6.727l-0.109-0.25z" }),
_('path', { d: "M15.836 15.625h-6.836v0.25h6.945z" }),
_('path', { d: "M9 12.625v0.25h5.633l-0.109-0.25z" }),
_('path', { d: "M9 14.625v0.25h6.508l-0.109-0.25z" }),
_('path', { d: "M9 13.125v0.25h5.852l-0.109-0.25z" }),
_('path', { d: "M9 13.625v0.25h6.070l-0.109-0.25z" }),
_('path', { d: "M9 14.125v0.25h6.289l-0.109-0.25z" }),
_('path', { d: "M9 11.125v0.25h4.977l-0.109-0.25z" }),
_('path', { d: "M9 1.625v0.25h0.82l-0.109-0.25z" }),
_('path', { d: "M9 2.625v0.25h1.258l-0.109-0.25z" }),
_('path', { d: "M9 2.125v0.25h1.039l-0.109-0.25z" }),
_('path', { d: "M9 3.125v0.25h1.477l-0.109-0.25z" }),
_('path', { d: "M9 1.125v0.25h0.602l-0.109-0.25z" }),
_('path', { d: "M9 7.625v0.25h3.445l-0.109-0.25z" }),
_('path', { d: "M9 0.625v0.25h0.383l-0.109-0.25z" }),
_('path', { d: "M9 3.625v0.25h1.695l-0.109-0.25z" }),
_('path', { d: "M9 0.125v0.25h0.164l-0.109-0.25z" }),
_('path', { d: "M9 6.125v0.25h2.789l-0.109-0.25z" }),
_('path', { d: "M9 4.125v0.25h1.914l-0.109-0.25z" }),
_('path', { d: "M9 7.125v0.25h3.227l-0.109-0.25z" }),
_('path', { d: "M9 6.625v0.25h3.008l-0.109-0.25z" }),
_('path', { d: "M9 4.625v0.25h2.133l-0.109-0.25z" }),
_('path', { d: "M9 5.625v0.25h2.57l-0.109-0.25z" }),
_('path', { d: "M9 5.125v0.25h2.352l-0.109-0.25z" })
            );
        }
        function FlipHorizontal2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipHorizontal2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipHorizontal2.SVG = FlipHorizontal2SVG;
        return FlipHorizontal2;
    })();
export const FlipVertical3 = /*#__PURE__*/ (() => {
        function FlipVertical3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.854 1.854c0.143-0.143 0.186-0.358 0.108-0.545s-0.26-0.309-0.462-0.309h-10c-0.202 0-0.385 0.122-0.462 0.309-0.026 0.062-0.038 0.127-0.038 0.191 0 0.13 0.051 0.258 0.146 0.354l5 5c0.195 0.195 0.512 0.195 0.707 0l5-5z" }),
_('path', { d: "M9 8.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M6 8.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M3 8.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M0 8.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M10.962 15.691c0.026-0.062 0.038-0.127 0.038-0.191 0-0.13-0.051-0.258-0.146-0.354l-5-5c-0.195-0.195-0.512-0.195-0.707 0l-5 5c-0.143 0.143-0.186 0.358-0.108 0.545s0.26 0.309 0.462 0.309h10c0.202 0 0.385-0.122 0.462-0.309zM2.009 14.875l3.491-3.491 3.491 3.491h-6.982z" }),
_('path', { d: "M13 12.5c1.257-0.943 2-2.419 2-4 0-1.672-0.831-3.226-2.222-4.158-0.229-0.154-0.54-0.092-0.694 0.137s-0.092 0.54 0.137 0.694c1.113 0.745 1.778 1.989 1.778 3.327 0 1.313-0.64 2.534-1.716 3.284l-1.284-1.284v3.5h3.5l-1.5-1.5z" })
            );
        }
        function FlipVertical3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipVertical3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipVertical3.SVG = FlipVertical3SVG;
        return FlipVertical3;
    })();
export const FlipVertical4 = /*#__PURE__*/ (() => {
        function FlipVertical4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.854 5.146c-0.143-0.143-0.358-0.186-0.545-0.108s-0.309 0.26-0.309 0.462v10c0 0.202 0.122 0.385 0.309 0.462 0.062 0.026 0.127 0.038 0.191 0.038 0.13 0 0.258-0.051 0.354-0.146l5-5c0.195-0.195 0.195-0.512 0-0.707l-5-5z" }),
_('path', { d: "M7.5 7c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 10c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 13c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 16c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.691 5.038c-0.062-0.026-0.127-0.038-0.191-0.038-0.13 0-0.258 0.051-0.354 0.146l-5 5c-0.195 0.195-0.195 0.512 0 0.707l5 5c0.143 0.143 0.358 0.186 0.545 0.108s0.309-0.26 0.309-0.462v-10c0-0.202-0.122-0.385-0.309-0.462zM13.875 13.991l-3.491-3.491 3.491-3.491v6.982z" }),
_('path', { d: "M11.5 3c-0.943-1.257-2.419-2-4-2-1.672 0-3.226 0.831-4.158 2.222-0.154 0.229-0.092 0.54 0.137 0.694s0.54 0.092 0.694-0.137c0.745-1.113 1.989-1.778 3.327-1.778 1.313 0 2.534 0.64 3.284 1.716l-1.284 1.284h3.5v-3.5l-1.5 1.5z" })
            );
        }
        function FlipVertical4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlipVertical4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FlipVertical4.SVG = FlipVertical4SVG;
        return FlipVertical4;
    })();
export const Angle = /*#__PURE__*/ (() => {
    function AngleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 13h-3.046c-0.101-1.132-0.375-2.232-0.819-3.282-0.554-1.31-1.347-2.486-2.357-3.496-0.022-0.022-0.045-0.044-0.068-0.067l1.929-2.357c0.35-0.427 0.287-1.057-0.141-1.407s-1.057-0.287-1.407 0.141l-8.863 10.832c-0 0-0.001 0.001-0.001 0.001l-0.002 0.002 0 0c-0.141 0.172-0.226 0.393-0.226 0.633 0 0.552 0.447 1 0.999 1v0c0 0 0.001-0 0.001-0h13.999c0.552 0 1-0.448 1-1s-0.448-1-1-1zM8.075 6.933c1.649 1.651 2.65 3.776 2.876 6.067h-7.84l4.964-6.067z" })
        );
    }
    function Angle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AngleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Angle.SVG = AngleSVG;
    return Angle;
})();
export const Shear = /*#__PURE__*/ (() => {
    function ShearSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 15h-8c-0.347 0-0.668-0.179-0.851-0.474s-0.199-0.663-0.044-0.973l6-12c0.169-0.339 0.516-0.553 0.894-0.553h8c0.347 0 0.668 0.179 0.851 0.474s0.199 0.663 0.044 0.973l-6 12c-0.169 0.339-0.516 0.553-0.894 0.553zM2.618 13h5.764l5-10h-5.764l-5 10z" })
        );
    }
    function Shear({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShearSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shear.SVG = ShearSVG;
    return Shear;
})();
export const Unite = /*#__PURE__*/ (() => {
    function UniteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 4v-4h-11v11h4v5h12v-12h-5zM10 5.125h-5v-0.125h5v0.125zM14 6.125h-3v-0.125h3v0.125zM5 9.875h5v0.125h-5v-0.125zM2 8.875h2v0.125h-2v-0.125zM4 5.875v0.25h-2v-0.25h2zM2 5.625v-0.25h2v0.25h-2zM4 6.375v0.25h-2v-0.25h2zM5 8.125v-0.25h5v0.25h-5zM10 8.375v0.25h-5v-0.25h5zM5 7.625v-0.25h5v0.25h-5zM5 7.125v-0.25h5v0.25h-5zM5 6.625v-0.25h5v0.25h-5zM4 6.875v0.25h-2v-0.25h2zM4 7.375v0.25h-2v-0.25h2zM4 7.875v0.25h-2v-0.25h2zM4 8.375v0.25h-2v-0.25h2zM5 8.875h5v0.25h-5v-0.25zM10 9.375v0.25h-5v-0.25h5zM6 14v-0.125h8v0.125h-8zM6 13.625v-0.25h8v0.25h-8zM6 13.125v-0.25h8v0.25h-8zM6 12.625v-0.25h8v0.25h-8zM6 12.125v-0.25h8v0.25h-8zM6 11.625v-0.25h8v0.25h-8zM6 11.125v-0.125h5v-0.125h3v0.25h-8zM11 10.625v-0.25h3v0.25h-3zM11 10.125v-0.25h3v0.25h-3zM11 9.625v-0.25h3v0.25h-3zM11 9.125v-0.25h3v0.25h-3zM11 8.625v-0.25h3v0.25h-3zM11 8.125v-0.25h3v0.25h-3zM11 7.625v-0.25h3v0.25h-3zM11 7.125v-0.25h3v0.25h-3zM11 6.625v-0.25h3v0.25h-3zM10 6.125h-5v-0.25h5v0.25zM5 5.625v-0.25h5v0.25h-5zM4 5.125h-2v-0.25h2v0.25zM9 2v0.125h-7v-0.125h7zM9 2.375v0.25h-7v-0.25h7zM9 2.875v0.25h-7v-0.25h7zM9 3.375v0.25h-7v-0.25h7zM9 3.875v0.125h-5v0.125h-2v-0.25h7zM4 4.375v0.25h-2v-0.25h2z" })
        );
    }
    function Unite({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UniteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Unite.SVG = UniteSVG;
    return Unite;
})();
export const Subtract = /*#__PURE__*/ (() => {
    function SubtractSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 5v-5h-11v11h5v5h11v-11h-5zM9 4h-5v0.125h-2v-0.25h7v0.125zM2 9v-0.125h2v0.125h-2zM2 8.625v-0.25h2v0.25h-2zM2 8.125v-0.25h2v0.25h-2zM2 7.625v-0.25h2v0.25h-2zM2 7.125v-0.25h2v0.25h-2zM2 6.625v-0.25h2v0.25h-2zM2 6.125v-0.25h2v0.25h-2zM2 5.625v-0.25h2v0.25h-2zM2 5.125v-0.25h2v0.25h-2zM2 4.625v-0.25h2v0.25h-2zM9 3.625h-7v-0.25h7v0.25zM9 3.125h-7v-0.25h7v0.25zM9 2.625h-7v-0.25h7v0.25zM9 2.125h-7v-0.125h7v0.125zM15 15h-9v-9h9v9z" })
        );
    }
    function Subtract({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SubtractSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Subtract.SVG = SubtractSVG;
    return Subtract;
})();
export const Interset = /*#__PURE__*/ (() => {
    function IntersetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 4v-4h-11v11h4v5h12v-12h-5zM10 6.125h-4v-0.125h4v0.125zM10 10h-4v-0.125h4v0.125zM10 9.625h-4v-0.25h4v0.25zM10 9.125h-4v-0.25h4v0.25zM10 8.625h-4v-0.25h4v0.25zM10 8.125h-4v-0.25h4v0.25zM10 7.625h-4v-0.25h4v0.25zM10 7.125h-4v-0.25h4v0.25zM10 6.625h-4v-0.25h4v0.25zM4 10h-3v-9h9v3h-6v6zM15 15h-10v-3h7v-7h3v10z" })
        );
    }
    function Interset({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IntersetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Interset.SVG = IntersetSVG;
    return Interset;
})();
export const Exclude = /*#__PURE__*/ (() => {
    function ExcludeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 4v-4h-11v11h4v5h12v-12h-5zM14 6.125h-3v-0.125h3v0.125zM6 14v-0.125h8v0.125h-8zM6 13.625v-0.25h8v0.25h-8zM6 13.125v-0.25h8v0.25h-8zM6 12.625v-0.25h8v0.25h-8zM6 12.125v-0.25h8v0.25h-8zM6 11.625v-0.25h8v0.25h-8zM6 11.125v-0.125h5v-0.125h3v0.25h-8zM11 10.625v-0.25h3v0.25h-3zM11 10.125v-0.25h3v0.25h-3zM11 9.625v-0.25h3v0.25h-3zM11 9.125v-0.25h3v0.25h-3zM11 8.625v-0.25h3v0.25h-3zM11 8.125v-0.25h3v0.25h-3zM11 7.625v-0.25h3v0.25h-3zM11 7.125v-0.25h3v0.25h-3zM11 6.625v-0.25h3v0.25h-3zM9 4h-5v0.125h-2v-0.25h7v0.125zM2 9v-0.125h2v0.125h-2zM2 8.625v-0.25h2v0.25h-2zM2 8.125v-0.25h2v0.25h-2zM2 7.625v-0.25h2v0.25h-2zM2 7.125v-0.25h2v0.25h-2zM2 6.625v-0.25h2v0.25h-2zM2 6.125v-0.25h2v0.25h-2zM2 5.625v-0.25h2v0.25h-2zM2 5.125v-0.25h2v0.25h-2zM2 4.625v-0.25h2v0.25h-2zM9 3.625h-7v-0.25h7v0.25zM9 3.125h-7v-0.25h7v0.25zM9 2.625h-7v-0.25h7v0.25zM9 2.125h-7v-0.125h7v0.125zM5 5h5v5h-5v-5z" })
        );
    }
    function Exclude({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ExcludeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Exclude.SVG = ExcludeSVG;
    return Exclude;
})();
export const AlignLeft = /*#__PURE__*/ (() => {
    function AlignLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 10h-9v2h9v-2zM15 9v0 4h-11v-4h11zM1 0h2v16h-2zM4 3h7v4h-7z" })
        );
    }
    function AlignLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignLeft.SVG = AlignLeftSVG;
    return AlignLeft;
})();
export const AlignCenterHorizontal = /*#__PURE__*/ (() => {
    function AlignCenterHorizontalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9h-5v-2h3v-4h-3v-3h-2v3h-3v4h3v2h-5v4h5v3h2v-3h5v-4zM13 12h-10v-2h10v2z" })
        );
    }
    function AlignCenterHorizontal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignCenterHorizontalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignCenterHorizontal.SVG = AlignCenterHorizontalSVG;
    return AlignCenterHorizontal;
})();
export const AlignRight = /*#__PURE__*/ (() => {
    function AlignRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 10h9v2h-9v-2zM1 9v0 4h11v-4h-11zM15 0h-2v16h2zM12 3h-7v4h7z" })
        );
    }
    function AlignRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignRight.SVG = AlignRightSVG;
    return AlignRight;
})();
export const AlignTop = /*#__PURE__*/ (() => {
    function AlignTopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 14v-9h-2v9h2zM7 15v0h-4v-11h4v11zM16 1v2h-16v-2zM13 4v7h-4v-7z" })
        );
    }
    function AlignTop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignTopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignTop.SVG = AlignTopSVG;
    return AlignTop;
})();
export const AlignCenterVertical = /*#__PURE__*/ (() => {
    function AlignCenterVerticalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 14v-5h2v3h4v-3h3v-2h-3v-3h-4v3h-2v-5h-4v5h-3v2h3v5h4zM4 13v-10h2v10h-2z" })
        );
    }
    function AlignCenterVertical({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignCenterVerticalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignCenterVertical.SVG = AlignCenterVerticalSVG;
    return AlignCenterVertical;
})();
export const AlignBottom = /*#__PURE__*/ (() => {
    function AlignBottomSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 2v9h-2v-9h2zM7 1v0h-4v11h4v-11zM16 15v-2h-16v2zM13 12v-7h-4v7z" })
        );
    }
    function AlignBottom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AlignBottomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AlignBottom.SVG = AlignBottomSVG;
    return AlignBottom;
})();
export const Undo2 = /*#__PURE__*/ (() => {
    function Undo2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.904 16c1.777-3.219 2.076-8.13-4.904-7.966v3.966l-6-6 6-6v3.881c8.359-0.218 9.29 7.378 4.904 12.119z" })
        );
    }
    function Undo2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Undo2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Undo2.SVG = Undo2SVG;
    return Undo2;
})();
export const Redo2 = /*#__PURE__*/ (() => {
    function Redo2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 3.881v-3.881l6 6-6 6v-3.966c-6.98-0.164-6.681 4.747-4.904 7.966-4.386-4.741-3.455-12.337 4.904-12.119z" })
        );
    }
    function Redo2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Redo2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Redo2.SVG = Redo2SVG;
    return Redo2;
})();
export const Forward = /*#__PURE__*/ (() => {
    function ForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.096 0c-1.777 3.219-2.076 8.13 4.904 7.966v-3.966l6 6-6 6v-3.881c-8.359 0.218-9.29-7.378-4.904-12.119z" })
        );
    }
    function Forward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Forward.SVG = ForwardSVG;
    return Forward;
})();
export const Reply = /*#__PURE__*/ (() => {
    function ReplySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z" })
        );
    }
    function Reply({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReplySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reply.SVG = ReplySVG;
    return Reply;
})();
export const ReplyAll = /*#__PURE__*/ (() => {
        function ReplyAllSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.184 0c1.777 3.219 2.297 8.13-4.684 7.966v-3.466l-5.5 5.5 5.5 5.5v-3.381c7 0 9.070-7.378 4.684-12.119z" }),
_('path', { d: "M6.5 5.5l-1-1-5.5 5.5 5 5 1-1-4-4z" })
            );
        }
        function ReplyAll({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ReplyAllSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ReplyAll.SVG = ReplyAllSVG;
        return ReplyAll;
    })();
export const Bubble = /*#__PURE__*/ (() => {
    function BubbleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z" })
        );
    }
    function Bubble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble.SVG = BubbleSVG;
    return Bubble;
})();
export const Bubbles = /*#__PURE__*/ (() => {
    function BubblesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM8 0c4.351 0 7.89 2.822 7.997 6.336-0.768-0.343-1.619-0.524-2.497-0.524-1.493 0-2.903 0.523-3.971 1.472-1.107 0.984-1.717 2.304-1.717 3.716 0 0.698 0.149 1.373 0.433 1.997-0.082 0.002-0.164 0.003-0.246 0.003-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z" })
        );
    }
    function Bubbles({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubblesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles.SVG = BubblesSVG;
    return Bubbles;
})();
export const Bubbles2 = /*#__PURE__*/ (() => {
    function Bubbles2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z" })
        );
    }
    function Bubbles2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles2.SVG = Bubbles2SVG;
    return Bubbles2;
})();
export const Bubble2 = /*#__PURE__*/ (() => {
    function Bubble2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3c-0.858 0-1.687 0.135-2.464 0.402-0.73 0.251-1.38 0.605-1.932 1.054-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.328 0.042 0.662 0.063 0.995 0.063 0.858 0 1.687-0.135 2.464-0.402 0.73-0.251 1.38-0.605 1.932-1.054 1.035-0.841 1.604-1.922 1.604-3.044s-0.57-2.203-1.604-3.044c-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402zM8 1v0c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z" })
        );
    }
    function Bubble2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble2.SVG = Bubble2SVG;
    return Bubble2;
})();
export const Bubbles3 = /*#__PURE__*/ (() => {
    function Bubbles3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM3.604 3.456c-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.327 0.042 0.662 0.063 0.994 0.063v2c-0.424-0-0.84-0.027-1.246-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336-0.642-0.286-1.341-0.46-2.067-0.509-0.18-0.876-0.709-1.7-1.535-2.371-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402s-1.687 0.135-2.464 0.402c-0.73 0.251-1.38 0.605-1.932 1.054z" })
        );
    }
    function Bubbles3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles3.SVG = Bubbles3SVG;
    return Bubbles3;
})();
export const Bubbles4 = /*#__PURE__*/ (() => {
    function Bubbles4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 2c-0.792 0-1.556 0.124-2.272 0.369-0.671 0.23-1.267 0.554-1.773 0.963-0.938 0.759-1.455 1.731-1.455 2.737 0 0.562 0.157 1.109 0.467 1.623 0.323 0.537 0.811 1.028 1.41 1.421 0.476 0.312 0.796 0.812 0.881 1.374 0.014 0.094 0.025 0.188 0.034 0.282 0.043-0.039 0.085-0.080 0.127-0.122 0.377-0.376 0.886-0.583 1.411-0.583 0.084 0 0.167 0.005 0.251 0.016 0.303 0.038 0.611 0.058 0.918 0.058 0.792 0 1.556-0.124 2.272-0.369 0.671-0.23 1.267-0.554 1.774-0.963 0.938-0.759 1.455-1.731 1.455-2.737s-0.517-1.978-1.455-2.737c-0.506-0.41-1.103-0.734-1.774-0.963-0.716-0.245-1.48-0.369-2.272-0.369zM7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z" })
        );
    }
    function Bubbles4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles4.SVG = Bubbles4SVG;
    return Bubbles4;
})();
export const BubbleNotification = /*#__PURE__*/ (() => {
    function BubbleNotificationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1c-4.418 0-8 2.91-8 6.5 0 2.040 1.157 3.86 2.966 5.052 0.022 0.146 0.034 0.296 0.034 0.448 0 1.092-0.929 2.048-2 2.572v0.421c1.983-0.045 4.034-0.353 5.753-2.072 0.406 0.052 0.823 0.079 1.247 0.079 4.418 0 8-2.91 8-6.5s-3.582-6.5-8-6.5zM9 11h-2v-2h2v2zM9 8h-2v-4h2v4z" })
        );
    }
    function BubbleNotification({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleNotificationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleNotification.SVG = BubbleNotificationSVG;
    return BubbleNotification;
})();
export const Bubbles5 = /*#__PURE__*/ (() => {
    function Bubbles5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 0c1.1 0 2 0.9 2 2v5c0 1.1-0.9 2-2 2h-9l-3 3v-10c0-1.1 0.9-2 2-2h10zM16 3c1.1 0 2 0.9 2 2v11l-3-3h-9c-1.1 0-2-0.9-2-2v-1h2v0.996c0.001 0.001 0.002 0.003 0.004 0.004h9.996v-5.996c-0.001-0.001-0.002-0.003-0.004-0.004h-0.996v-2h1z" })
        );
    }
    function Bubbles5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles5.SVG = Bubbles5SVG;
    return Bubbles5;
})();
export const Bubbles6 = /*#__PURE__*/ (() => {
    function Bubbles6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 3c1.1 0 2 0.9 2 2v11l-3-3h-9c-1.1 0-2-0.9-2-2v-1h2v0.996c0.001 0.001 0.002 0.003 0.004 0.004h9.996v-5.996c-0.001-0.001-0.002-0.003-0.004-0.004h-0.996v-2h1zM12 0h-10c-1.1 0-2 0.9-2 2v10l3-3h9c1.1 0 2-0.9 2-2v-5c0-1.1-0.9-2-2-2zM12 6.996c-0.001 0.001-0.002 0.003-0.004 0.004h-9.996v-4.996c0.001-0.001 0.002-0.003 0.004-0.004h9.993c0.001 0.001 0.003 0.002 0.004 0.004v4.993z" })
        );
    }
    function Bubbles6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles6.SVG = Bubbles6SVG;
    return Bubbles6;
})();
export const Bubble3 = /*#__PURE__*/ (() => {
    function Bubble3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1c1.616 0 2.938 1.322 2.938 2.938v5.125c0 1.616-1.322 2.938-2.938 2.938h-10.063l-3 3v-11.063c0-1.616 1.322-2.938 2.938-2.938h10.125z" })
        );
    }
    function Bubble3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble3.SVG = Bubble3SVG;
    return Bubble3;
})();
export const BubbleDots = /*#__PURE__*/ (() => {
    function BubbleDotsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM5 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM8 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function BubbleDots({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleDotsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleDots.SVG = BubbleDotsSVG;
    return BubbleDots;
})();
export const BubbleLines = /*#__PURE__*/ (() => {
    function BubbleLinesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM10 8h-6v-1h6v1zM12 6h-8v-1h8v1z" })
        );
    }
    function BubbleLines({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLinesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLines.SVG = BubbleLinesSVG;
    return BubbleLines;
})();
export const Bubble4 = /*#__PURE__*/ (() => {
    function Bubble4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM14 9.063c0 0.508-0.429 0.938-0.938 0.938h-11.063v-6.063c0-0.508 0.429-0.938 0.938-0.938h10.125c0.508 0 0.938 0.429 0.938 0.938v5.125z" })
        );
    }
    function Bubble4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble4.SVG = Bubble4SVG;
    return Bubble4;
})();
export const BubbleDots2 = /*#__PURE__*/ (() => {
    function BubbleDots2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM14 9.063c0 0.508-0.429 0.938-0.938 0.938h-11.063v-6.063c0-0.508 0.429-0.938 0.938-0.938h10.125c0.508 0 0.938 0.429 0.938 0.938v5.125zM4 7c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 7c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 7c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z" })
        );
    }
    function BubbleDots2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleDots2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleDots2.SVG = BubbleDots2SVG;
    return BubbleDots2;
})();
export const BubbleLines2 = /*#__PURE__*/ (() => {
    function BubbleLines2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM14 9.063c0 0.508-0.429 0.938-0.938 0.938h-11.063v-6.063c0-0.508 0.429-0.938 0.938-0.938h10.125c0.508 0 0.938 0.429 0.938 0.938v5.125zM4 5h8v1h-8zM4 7h6v1h-6z" })
        );
    }
    function BubbleLines2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLines2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLines2.SVG = BubbleLines2SVG;
    return BubbleLines2;
})();
export const Bubble5 = /*#__PURE__*/ (() => {
    function Bubble5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.063 1h-10.125c-1.616 0-2.938 1.322-2.938 2.938v11.063l3-3h10.063c1.616 0 2.938-1.322 2.938-2.938v-5.125c0-1.616-1.322-2.938-2.938-2.938zM14 3.938v0.188h-12v-0.188c0-0.021 0.001-0.042 0.002-0.063h11.995c0.001 0.021 0.002 0.042 0.002 0.063zM13.998 9.125h-11.998v-0.25h12v0.188c0 0.021-0.001 0.042-0.002 0.063zM2 10v-0.125h11.522c-0.137 0.079-0.294 0.125-0.46 0.125h-11.063zM2 9.625v-0.25h11.944c-0.033 0.090-0.080 0.174-0.138 0.25h-11.806zM2 8.625v-0.25h12v0.25h-12zM2 8.125v-0.25h12v0.25h-12zM2 7.625v-0.25h12v0.25h-12zM2 7.125v-0.25h12v0.25h-12zM2 6.625v-0.25h12v0.25h-12zM2 6.125v-0.25h12v0.25h-12zM2 5.625v-0.25h12v0.25h-12zM2 5.125v-0.25h12v0.25h-12zM2 4.625v-0.25h12v0.25h-12zM13.063 3c0.166 0 0.323 0.046 0.46 0.125h-11.044c0.137-0.079 0.294-0.125 0.46-0.125h10.125zM13.806 3.375c0.058 0.076 0.105 0.16 0.138 0.25h-11.888c0.033-0.090 0.080-0.174 0.138-0.25h11.613z" })
        );
    }
    function Bubble5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble5.SVG = Bubble5SVG;
    return Bubble5;
})();
export const Bubble6 = /*#__PURE__*/ (() => {
    function Bubble6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0c0.825 0 1.5 0.675 1.5 1.5v10c0 0.825-0.675 1.5-1.5 1.5h-4.429l-2.571 3-2.571-3h-3.429c-0.825 0-1.5-0.675-1.5-1.5v-10c0-0.825 0.675-1.5 1.5-1.5h13z" })
        );
    }
    function Bubble6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble6.SVG = Bubble6SVG;
    return Bubble6;
})();
export const Bubbles7 = /*#__PURE__*/ (() => {
    function Bubbles7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 3c0.825 0 1.5 0.675 1.5 1.5v7c0 0.825-0.675 1.5-1.5 1.5h-2.429l-2.571 3-2.571-3h-2.429c-0.825 0-1.5-0.675-1.5-1.5v-7c0-0.825 0.675-1.5 1.5-1.5h10zM2 2v8h-0.5c-0.825 0-1.5-0.675-1.5-1.5v-7c0-0.825 0.675-1.5 1.5-1.5h10c0.825 0 1.5 0.675 1.5 1.5v0.5h-11z" })
        );
    }
    function Bubbles7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles7.SVG = Bubbles7SVG;
    return Bubbles7;
})();
export const Bubble7 = /*#__PURE__*/ (() => {
    function Bubble7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h3.429l2.571 3 2.571-3h4.429c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM14 11h-4.348l-2.152 2.427-2.152-2.427h-3.348v-9h12v9z" })
        );
    }
    function Bubble7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble7.SVG = Bubble7SVG;
    return Bubble7;
})();
export const Bubbles8 = /*#__PURE__*/ (() => {
    function Bubbles8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 3h-10c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h2.429l2.571 3 2.571-3h2.429c0.825 0 1.5-0.675 1.5-1.5v-7c0-0.825-0.675-1.5-1.5-1.5zM14 11h-2.348l-2.152 2.427-2.152-2.427h-2.348v-6h9v6zM2 2v8h-0.5c-0.825 0-1.5-0.675-1.5-1.5v-7c0-0.825 0.675-1.5 1.5-1.5h10c0.825 0 1.5 0.675 1.5 1.5v0.5h-11z" })
        );
    }
    function Bubbles8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles8.SVG = Bubbles8SVG;
    return Bubbles8;
})();
export const Bubble8 = /*#__PURE__*/ (() => {
    function Bubble8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 1c0.825 0 1.5 0.675 1.5 1.5v8c0 0.825-0.675 1.5-1.5 1.5h-5.7l-4.8 4v-4h-2.5c-0.825 0-1.5-0.675-1.5-1.5v-8c0-0.825 0.675-1.5 1.5-1.5h13z" })
        );
    }
    function Bubble8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble8.SVG = Bubble8SVG;
    return Bubble8;
})();
export const BubbleDots3 = /*#__PURE__*/ (() => {
    function BubbleDots3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v8c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-8c0-0.825-0.675-1.5-1.5-1.5zM6 8h-2v-2h2v2zM9 8h-2v-2h2v2zM12 8h-2v-2h2v2z" })
        );
    }
    function BubbleDots3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleDots3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleDots3.SVG = BubbleDots3SVG;
    return BubbleDots3;
})();
export const BubbleLines3 = /*#__PURE__*/ (() => {
    function BubbleLines3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v8c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-8c0-0.825-0.675-1.5-1.5-1.5zM7 9h-4v-1h4v1zM11 7h-8v-1h8v1zM13 5h-10v-1h10v1z" })
        );
    }
    function BubbleLines3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLines3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLines3.SVG = BubbleLines3SVG;
    return BubbleLines3;
})();
export const Bubble9 = /*#__PURE__*/ (() => {
    function Bubble9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v8c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-8c0-0.825-0.675-1.5-1.5-1.5zM14 10h-5.924l-3.076 2.73v-2.73h-3v-7h12v7z" })
        );
    }
    function Bubble9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubble9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubble9.SVG = Bubble9SVG;
    return Bubble9;
})();
export const BubbleDots4 = /*#__PURE__*/ (() => {
    function BubbleDots4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 6h2v2h-2zM7 6h2v2h-2zM10 6h2v2h-2zM14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v8c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-8c0-0.825-0.675-1.5-1.5-1.5zM14 10h-5.924l-3.076 2.73v-2.73h-3v-7h12v7z" })
        );
    }
    function BubbleDots4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleDots4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleDots4.SVG = BubbleDots4SVG;
    return BubbleDots4;
})();
export const BubbleLines4 = /*#__PURE__*/ (() => {
    function BubbleLines4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 4h10v1h-10zM3 6h8v1h-8zM3 8h4v1h-4zM14.5 1h-13c-0.825 0-1.5 0.675-1.5 1.5v8c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-8c0-0.825-0.675-1.5-1.5-1.5zM14 10h-5.924l-3.076 2.73v-2.73h-3v-7h12v7z" })
        );
    }
    function BubbleLines4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLines4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLines4.SVG = BubbleLines4SVG;
    return BubbleLines4;
})();
export const Bubbles9 = /*#__PURE__*/ (() => {
    function Bubbles9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 0h-11c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h0.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5zM12 6h-5.924l-3.076 2.73v-2.73h-1v-4h10v4zM16.5 3c0.825 0 1.5 0.675 1.5 1.5v6c0 0.825-0.675 1.5-1.5 1.5h-2.5v4l-4.8-4h-3.2v-2h3.924l3.076 2.73v-2.73h3v-5h-1v-2h1.5z" })
        );
    }
    function Bubbles9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles9.SVG = Bubbles9SVG;
    return Bubbles9;
})();
export const Bubbles10 = /*#__PURE__*/ (() => {
    function Bubbles10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 0c0.825 0 1.5 0.675 1.5 1.5v5c0 0.825-0.675 1.5-1.5 1.5h-5.7l-4.8 4v-4h-0.5c-0.825 0-1.5-0.675-1.5-1.5v-5c0-0.825 0.675-1.5 1.5-1.5h11zM16.5 3c0.825 0 1.5 0.675 1.5 1.5v6c0 0.825-0.675 1.5-1.5 1.5h-2.5v4l-4.8-4h-3.2v-2h3.924l3.076 2.73v-2.73h3v-5h-1v-2h1.5z" })
        );
    }
    function Bubbles10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bubbles10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bubbles10.SVG = Bubbles10SVG;
    return Bubbles10;
})();
export const BubbleBlocked = /*#__PURE__*/ (() => {
    function BubbleBlockedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3.188c0.561 0 1.084 0.165 1.523 0.449l-3.887 3.887c-0.284-0.439-0.449-0.962-0.449-1.523 0-1.551 1.262-2.813 2.813-2.813zM6.477 8.363l3.887-3.887c0.284 0.439 0.449 0.962 0.449 1.523 0 1.551-1.262 2.812-2.813 2.812-0.561 0-1.084-0.165-1.523-0.449zM14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM8 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" })
        );
    }
    function BubbleBlocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleBlockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleBlocked.SVG = BubbleBlockedSVG;
    return BubbleBlocked;
})();
export const BubbleQuote = /*#__PURE__*/ (() => {
    function BubbleQuoteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM7 8.25c0 0.412-0.338 0.75-0.75 0.75h-2.5c-0.413 0-0.75-0.338-0.75-0.75v-5.25l2-1.5v3.5h1.25c0.412 0 0.75 0.338 0.75 0.75v2.5zM13 8.25c0 0.412-0.338 0.75-0.75 0.75h-2.5c-0.412 0-0.75-0.338-0.75-0.75v-5.25l2-1.5v3.5h1.25c0.412 0 0.75 0.338 0.75 0.75v2.5z" })
        );
    }
    function BubbleQuote({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleQuoteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleQuote.SVG = BubbleQuoteSVG;
    return BubbleQuote;
})();
export const BubbleUser = /*#__PURE__*/ (() => {
    function BubbleUserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM8 2.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995zM11 10h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z" })
        );
    }
    function BubbleUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleUser.SVG = BubbleUserSVG;
    return BubbleUser;
})();
export const BubbleSmiley = /*#__PURE__*/ (() => {
    function BubbleSmileySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM5 3c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 10c-1.864 0-3.43-1.275-3.874-3h7.748c-0.444 1.725-2.010 3-3.874 3zM11 5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function BubbleSmiley({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleSmileySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleSmiley.SVG = BubbleSmileySVG;
    return BubbleSmiley;
})();
export const BubbleCheck = /*#__PURE__*/ (() => {
    function BubbleCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM7 9.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914-5.207 5.707z" })
        );
    }
    function BubbleCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleCheck.SVG = BubbleCheckSVG;
    return BubbleCheck;
})();
export const BubbleVideo = /*#__PURE__*/ (() => {
    function BubbleVideoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM13 8c0 0.55-0.36 0.73-0.8 0.4l-2.2-2.4v2c0 0.55-0.45 1-1 1h-5c-0.55 0-1-0.45-1-1v-4c0-0.55 0.45-1 1-1h5c0.55 0 1 0.45 1 1v2l2.2-2.4c0.44-0.33 0.8-0.15 0.8 0.4v4z" })
        );
    }
    function BubbleVideo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleVideoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleVideo.SVG = BubbleVideoSVG;
    return BubbleVideo;
})();
export const BubbleLink = /*#__PURE__*/ (() => {
    function BubbleLinkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM7 9h-3c-1.1 0-2-0.9-2-2v-1c0-1.1 0.9-2 2-2h3v1h-3c-0.265 0-0.515 0.105-0.705 0.295s-0.295 0.441-0.295 0.705v1c0 0.265 0.105 0.515 0.295 0.705s0.441 0.295 0.705 0.295h3v1zM6 7v-1h4v1h-4zM14 7c0 1.1-0.9 2-2 2h-3v-1h3c0.265 0 0.515-0.105 0.705-0.295s0.295-0.441 0.295-0.705v-1c0-0.265-0.105-0.515-0.295-0.705s-0.44-0.295-0.705-0.295h-3v-1h3c1.1 0 2 0.9 2 2v1z" })
        );
    }
    function BubbleLink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLink.SVG = BubbleLinkSVG;
    return BubbleLink;
})();
export const BubbleLock = /*#__PURE__*/ (() => {
        function BubbleLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M9 3h-2c-0.551 0-1 0.449-1 1v1h4v-1c0-0.551-0.449-1-1-1z" }),
_('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM12 9.25c0 0.412-0.338 0.75-0.75 0.75h-6.5c-0.412 0-0.75-0.338-0.75-0.75v-3.5c0-0.412 0.338-0.75 0.75-0.75h0.25v-1c0-1.103 0.897-2 2-2h2c1.103 0 2 0.897 2 2v1h0.25c0.412 0 0.75 0.338 0.75 0.75v3.5z" })
            );
        }
        function BubbleLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BubbleLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BubbleLock.SVG = BubbleLockSVG;
        return BubbleLock;
    })();
export const BubbleStar = /*#__PURE__*/ (() => {
    function BubbleStarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM11.125 10.688l-3.125-2.566-3.125 2.566 1.137-3.666-3.012-2.025h3.771l1.229-3.907 1.229 3.907h3.771l-3.012 2.025 1.137 3.666z" })
        );
    }
    function BubbleStar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleStarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleStar.SVG = BubbleStarSVG;
    return BubbleStar;
})();
export const BubbleHeart = /*#__PURE__*/ (() => {
    function BubbleHeartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM11.5 6.494l-0.004 0.004c-0.075 0.088-3.496 3.502-3.496 3.502s-3.418-3.411-3.488-3.492l-0.006-0.006 0.001-0c-0.316-0.371-0.507-0.851-0.507-1.377 0-1.174 0.951-2.125 2.125-2.125 0.812 0 1.517 0.455 1.875 1.125 0.358-0.669 1.063-1.125 1.875-1.125 1.174 0 2.125 0.951 2.125 2.125 0 0.522-0.188 0.999-0.5 1.369l0 0z" })
        );
    }
    function BubbleHeart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleHeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleHeart.SVG = BubbleHeartSVG;
    return BubbleHeart;
})();
export const BubblePaperclip = /*#__PURE__*/ (() => {
    function BubblePaperclipSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM14 5c0 1.1-0.9 2-2 2h-7c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h5.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5.498c-0.001 0.001-0.001 0.001-0.002 0.002v0.996c0.001 0.001 0.001 0.001 0.002 0.002h6.998c0.265 0 0.515-0.105 0.705-0.295s0.295-0.44 0.295-0.705v-1c0-0.265-0.105-0.515-0.295-0.705s-0.44-0.295-0.705-0.295h-8c-0.265 0-0.515 0.105-0.705 0.295s-0.295 0.441-0.295 0.705v3c0 0.265 0.105 0.515 0.295 0.705s0.441 0.295 0.705 0.295h6.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-6.5c-1.1 0-2-0.9-2-2v-3c0-1.1 0.9-2 2-2h8c1.1 0 2 0.9 2 2v1z" })
        );
    }
    function BubblePaperclip({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubblePaperclipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubblePaperclip.SVG = BubblePaperclipSVG;
    return BubblePaperclip;
})();
export const BubbleCancel = /*#__PURE__*/ (() => {
    function BubbleCancelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM11 4.282l-1.718 1.718 1.718 1.718v1.282h-1.282l-1.718-1.718-1.718 1.718h-1.282v-1.282l1.718-1.718-1.718-1.718v-1.282h1.282l1.718 1.718 1.718-1.718h1.282v1.282z" })
        );
    }
    function BubbleCancel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleCancelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleCancel.SVG = BubbleCancelSVG;
    return BubbleCancel;
})();
export const BubblePlus = /*#__PURE__*/ (() => {
    function BubblePlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM12 7h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z" })
        );
    }
    function BubblePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubblePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubblePlus.SVG = BubblePlusSVG;
    return BubblePlus;
})();
export const BubbleMinus = /*#__PURE__*/ (() => {
    function BubbleMinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM12 7h-8v-2h8v2z" })
        );
    }
    function BubbleMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleMinus.SVG = BubbleMinusSVG;
    return BubbleMinus;
})();
export const BubbleNotification2 = /*#__PURE__*/ (() => {
    function BubbleNotification2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM9 10h-2v-2h2v2zM9 6h-2v-4h2v4z" })
        );
    }
    function BubbleNotification2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleNotification2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleNotification2.SVG = BubbleNotification2SVG;
    return BubbleNotification2;
})();
export const BubbleLeft = /*#__PURE__*/ (() => {
    function BubbleLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM13 7h-6v3.5l-4.5-4.5 4.5-4.5v3.5h6v2z" })
        );
    }
    function BubbleLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLeft.SVG = BubbleLeftSVG;
    return BubbleLeft;
})();
export const BubbleRight = /*#__PURE__*/ (() => {
    function BubbleRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM3 5h6v-3.5l4.5 4.5-4.5 4.5v-3.5h-6v-2z" })
        );
    }
    function BubbleRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleRight.SVG = BubbleRightSVG;
    return BubbleRight;
})();
export const BubbleFirst = /*#__PURE__*/ (() => {
    function BubbleFirstSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM3 10h-1v-8h1v8zM14 7h-6v3.5l-4.5-4.5 4.5-4.5v3.5h6v2z" })
        );
    }
    function BubbleFirst({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleFirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleFirst.SVG = BubbleFirstSVG;
    return BubbleFirst;
})();
export const BubbleLast = /*#__PURE__*/ (() => {
    function BubbleLastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM8 10.5v-3.5h-6v-2h6v-3.5l4.5 4.5-4.5 4.5zM14 10h-1v-8h1v8z" })
        );
    }
    function BubbleLast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleLastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleLast.SVG = BubbleLastSVG;
    return BubbleLast;
})();
export const BubbleReply = /*#__PURE__*/ (() => {
    function BubbleReplySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM12.864 9.918c-0.138-0.641-0.427-1.23-0.877-1.719-0.967-1.050-2.459-1.401-3.987-1.092v3.392l-4.5-4.5 4.5-4.5v3.5c2.759 0 4.996 1.791 4.996 4 0 0.316-0.046 0.623-0.133 0.918z" })
        );
    }
    function BubbleReply({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleReplySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleReply.SVG = BubbleReplySVG;
    return BubbleReply;
})();
export const BubbleForward = /*#__PURE__*/ (() => {
    function BubbleForwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM3 9c0-2.209 2.237-4 4.996-4v-3.5l4.5 4.5-4.5 4.5v-3.392c-1.528-0.309-3.020 0.042-3.987 1.092-0.45 0.488-0.739 1.078-0.877 1.719-0.087-0.295-0.132-0.602-0.132-0.918z" })
        );
    }
    function BubbleForward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleForwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleForward.SVG = BubbleForwardSVG;
    return BubbleForward;
})();
export const BubbleReply2 = /*#__PURE__*/ (() => {
    function BubbleReply2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM12.996 3c0 2.209-2.237 4-4.996 4v3.5l-4.5-4.5 4.5-4.5v3.392c1.528 0.309 3.020-0.042 3.987-1.092 0.45-0.488 0.739-1.078 0.877-1.719 0.087 0.295 0.133 0.602 0.133 0.918z" })
        );
    }
    function BubbleReply2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleReply2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleReply2.SVG = BubbleReply2SVG;
    return BubbleReply2;
})();
export const BubbleForward2 = /*#__PURE__*/ (() => {
    function BubbleForward2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h2.5v4l4.8-4h5.7c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM3.132 2.082c0.138 0.641 0.427 1.23 0.877 1.719 0.967 1.050 2.459 1.401 3.987 1.092v-3.392l4.5 4.5-4.5 4.5v-3.5c-2.759 0-4.996-1.791-4.996-4 0-0.316 0.046-0.623 0.132-0.918z" })
        );
    }
    function BubbleForward2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BubbleForward2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BubbleForward2.SVG = BubbleForward2SVG;
    return BubbleForward2;
})();
export const User = /*#__PURE__*/ (() => {
    function UserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z" })
        );
    }
    function User({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User.SVG = UserSVG;
    return User;
})();
export const Users = /*#__PURE__*/ (() => {
        function UsersSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z" }),
_('path', { d: "M5.112 12.427c0.864-0.565 1.939-0.994 3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344 0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3 0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202 0.478-0.393 0.753-0.573z" })
            );
        }
        function Users({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UsersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Users.SVG = UsersSVG;
        return Users;
    })();
export const UserPlus = /*#__PURE__*/ (() => {
        function UserPlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z" }),
_('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z" })
            );
        }
        function UserPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserPlus.SVG = UserPlusSVG;
        return UserPlus;
    })();
export const UserMinus = /*#__PURE__*/ (() => {
        function UserMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z" }),
_('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-5v-1h5v1z" })
            );
        }
        function UserMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserMinus.SVG = UserMinusSVG;
        return UserMinus;
    })();
export const UserCancel = /*#__PURE__*/ (() => {
        function UserCancelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z" }),
_('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM13.898 13.102c0.22 0.22 0.22 0.576 0 0.795-0.11 0.11-0.254 0.165-0.398 0.165s-0.288-0.055-0.398-0.165l-1.602-1.602-1.602 1.602c-0.11 0.11-0.254 0.165-0.398 0.165s-0.288-0.055-0.398-0.165c-0.22-0.22-0.22-0.576 0-0.795l1.602-1.602-1.602-1.602c-0.22-0.22-0.22-0.576 0-0.795s0.576-0.22 0.795 0l1.602 1.602 1.602-1.602c0.22-0.22 0.576-0.22 0.795 0s0.22 0.576 0 0.795l-1.602 1.602 1.602 1.602z" })
            );
        }
        function UserCancel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCancelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCancel.SVG = UserCancelSVG;
        return UserCancel;
    })();
export const UserBlock = /*#__PURE__*/ (() => {
        function UserBlockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z" }),
_('path', { d: "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM8 11.5c0-1.933 1.567-3.5 3.5-3.5 0.763 0 1.47 0.245 2.045 0.659l-4.885 4.886c-0.415-0.575-0.66-1.282-0.66-2.045zM11.5 15c-0.763 0-1.47-0.245-2.045-0.659l4.886-4.886c0.415 0.575 0.659 1.282 0.659 2.045 0 1.933-1.567 3.5-3.5 3.5z" })
            );
        }
        function UserBlock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserBlockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserBlock.SVG = UserBlockSVG;
        return UserBlock;
    })();
export const UserLock = /*#__PURE__*/ (() => {
        function UserLockSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.25 11h-0.25v-1c0-1.103-0.897-2-2-2s-2 0.897-2 2v1h-0.25c-0.412 0-0.75 0.338-0.75 0.75v3.5c0 0.412 0.338 0.75 0.75 0.75h4.5c0.412 0 0.75-0.338 0.75-0.75v-3.5c0-0.412-0.338-0.75-0.75-0.75zM12 10c0-0.551 0.449-1 1-1s1 0.449 1 1v1h-2v-1z" }),
_('path', { d: "M9 9.166c-0.324-0.055-0.658-0.097-1-0.125v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h9v-3.834z" })
            );
        }
        function UserLock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserLockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserLock.SVG = UserLockSVG;
        return UserLock;
    })();
export const UserCheck = /*#__PURE__*/ (() => {
        function UserCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 9.5l-4.5 4.5-1.5-1.5-1 1 2.5 2.5 5.5-5.5z" }),
_('path', { d: "M7 12h5v-1.799c-1.050-0.613-2.442-1.033-4-1.16v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h7v-1z" })
            );
        }
        function UserCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCheck.SVG = UserCheckSVG;
        return UserCheck;
    })();
export const Users2 = /*#__PURE__*/ (() => {
        function Users2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 12.041v-0.825c1.101-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z" }),
_('path', { d: "M3.242 9.625c-0.212 0.077-0.416 0.161-0.611 0.25h4.782c-0.038-0.083-0.075-0.166-0.109-0.25h-4.062z" }),
_('path', { d: "M0.425 11.625c-0.053 0.082-0.101 0.165-0.144 0.25h5.834c0.192-0.089 0.389-0.172 0.593-0.25h-6.284z" }),
_('path', { d: "M1.367 10.625c-0.105 0.081-0.204 0.164-0.299 0.25h6.933c-0.060-0.081-0.118-0.165-0.174-0.25h-6.461z" }),
_('path', { d: "M5.261 9.125c-0.424 0.062-0.833 0.146-1.222 0.25h3.17c-0.030-0.083-0.057-0.166-0.083-0.25h-1.864z" }),
_('path', { d: "M6 8.625v0.25h1.054c-0.022-0.083-0.041-0.166-0.059-0.25h-0.995z" }),
_('path', { d: "M5.851 8.125c0.049 0.032 0.099 0.063 0.149 0.091v0.159h0.947c-0.014-0.083-0.025-0.167-0.035-0.25h-1.062z" }),
_('path', { d: "M0.030 12.625c-0.013 0.083-0.022 0.166-0.027 0.25h4.501c0.102-0.085 0.209-0.169 0.321-0.25h-4.795z" }),
_('path', { d: "M1.719 10.375h5.955c-0.024-0.042-0.048-0.084-0.072-0.127-0.022-0.041-0.044-0.082-0.066-0.123h-5.402c-0.145 0.080-0.283 0.163-0.415 0.25z" }),
_('path', { d: "M4.005 3.625c-0.002 0.083-0.003 0.166-0.003 0.25h3.339c0.004-0.009 0.008-0.018 0.012-0.028 0.035-0.076 0.073-0.15 0.112-0.222h-3.46z" }),
_('path', { d: "M0.168 12.125c-0.032 0.082-0.060 0.166-0.083 0.25h5.109c0.136-0.087 0.277-0.17 0.423-0.25h-5.449z" }),
_('path', { d: "M4.643 0.875h4.713c-0.070-0.089-0.148-0.173-0.234-0.25h-4.245c-0.086 0.077-0.164 0.161-0.234 0.25z" }),
_('path', { d: "M0.602 11.375h6.845c0.256-0.076 0.519-0.145 0.787-0.204-0.013-0.015-0.025-0.030-0.038-0.046h-7.381c-0.076 0.082-0.147 0.165-0.213 0.25z" }),
_('path', { d: "M5.255 7.625c0.085 0.089 0.173 0.173 0.263 0.25h1.371c-0.006-0.083-0.010-0.167-0.012-0.25h-1.622z" }),
_('path', { d: "M4.848 7.125c0.060 0.086 0.123 0.17 0.188 0.25h1.84c0-0.084 0-0.167 0-0.25h-2.027z" }),
_('path', { d: "M4.255 1.625c-0.027 0.081-0.050 0.164-0.072 0.25h5.632c-0.021-0.086-0.045-0.169-0.072-0.25h-5.489z" }),
_('path', { d: "M4.13 2.125c-0.015 0.082-0.029 0.165-0.041 0.25h4.625c0.179-0.098 0.372-0.181 0.578-0.25h-5.162z" }),
_('path', { d: "M4.022 3.125c-0.004 0.082-0.008 0.166-0.010 0.25h3.605c0.058-0.087 0.12-0.17 0.185-0.25h-3.78z" }),
_('path', { d: "M4.059 2.625c-0.008 0.082-0.016 0.165-0.022 0.25h3.995c0.092-0.089 0.189-0.173 0.292-0.25h-4.265z" }),
_('path', { d: "M5.866 0.125c-0.243 0.062-0.455 0.146-0.638 0.25h3.544c-0.184-0.104-0.396-0.188-0.639-0.25h-2.266z" }),
_('path', { d: "M4.544 6.625c0.045 0.085 0.092 0.169 0.141 0.25h2.192c0.001-0.084 0.002-0.167 0.003-0.25h-2.336z" }),
_('path', { d: "M4.475 1.125c-0.046 0.080-0.088 0.163-0.125 0.25h5.3c-0.037-0.087-0.079-0.17-0.125-0.25h-5.050z" }),
_('path', { d: "M4.152 5.625c0.022 0.084 0.048 0.167 0.074 0.25h2.683c0.005-0.084 0.012-0.167 0.019-0.25h-2.777z" }),
_('path', { d: "M4.316 6.125c0.033 0.085 0.068 0.168 0.105 0.25h2.464c0.003-0.084 0.006-0.167 0.009-0.25h-2.579z" }),
_('path', { d: "M4 4.125c-0 0.083-0 0.166-0 0.25h3.155c0.025-0.085 0.053-0.168 0.084-0.25h-3.238z" }),
_('path', { d: "M4.002 4.625c0.003 0.083 0.008 0.167 0.016 0.25h3.014c0.016-0.084 0.035-0.168 0.055-0.25h-3.085z" }),
_('path', { d: "M4.048 5.125c0.013 0.084 0.027 0.167 0.045 0.25h2.862c0.010-0.084 0.021-0.167 0.034-0.25h-2.941z" })
            );
        }
        function Users2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Users2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Users2.SVG = Users2SVG;
        return Users2;
    })();
export const User2 = /*#__PURE__*/ (() => {
    function User2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.477 16h-10.954c-0.14 0-0.274-0.059-0.369-0.163s-0.142-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427s2.103 0.507 2.861 1.427c0.735 0.892 1.139 2.072 1.139 3.323 0 0.901-0.213 1.777-0.615 2.535-0.348 0.655-0.823 1.197-1.385 1.582l0 0.475c1.012 0.357 1.905 0.977 2.602 1.809 0.788 0.942 1.263 2.084 1.373 3.305 0.013 0.14-0.034 0.279-0.129 0.382s-0.229 0.163-0.369 0.163zM3.1 15h9.8c-0.164-0.81-0.527-1.565-1.064-2.208-0.649-0.776-1.504-1.33-2.471-1.604-0.215-0.061-0.364-0.257-0.364-0.481l-0-1.116c0-0.179 0.095-0.344 0.25-0.433 1.063-0.613 1.75-1.951 1.75-3.408 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.642-0.9 1.397-1.064 2.208z" })
        );
    }
    function User2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( User2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User2.SVG = User2SVG;
    return User2;
})();
export const Users3 = /*#__PURE__*/ (() => {
        function Users3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.477 16h-10.954c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427s2.103 0.507 2.861 1.427c0.735 0.892 1.139 2.072 1.139 3.323 0 0.901-0.213 1.777-0.615 2.535-0.348 0.655-0.823 1.197-1.385 1.582l0 0.475c1.012 0.357 1.905 0.977 2.602 1.809 0.788 0.942 1.263 2.084 1.373 3.305 0.013 0.14-0.034 0.279-0.129 0.382s-0.229 0.163-0.369 0.163zM5.1 15h9.8c-0.164-0.81-0.527-1.565-1.064-2.208-0.649-0.776-1.504-1.33-2.471-1.604-0.215-0.061-0.364-0.257-0.364-0.481l-0-1.116c0-0.179 0.095-0.344 0.25-0.433 1.063-0.613 1.75-1.951 1.75-3.408 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.642-0.9 1.397-1.064 2.208z" }),
_('path', { d: "M4.535 11.428c0.517-0.617 1.131-1.14 1.814-1.548-0.277-0.322-0.522-0.68-0.727-1.068-0.488-0.919-0.746-1.978-0.746-3.063 0-1.511 0.496-2.945 1.396-4.038 0.429-0.521 0.926-0.939 1.469-1.244-0.535-0.306-1.126-0.468-1.74-0.468-1.087 0-2.103 0.507-2.861 1.427-0.735 0.892-1.139 2.072-1.139 3.323 0 0.901 0.213 1.778 0.615 2.535 0.348 0.655 0.823 1.197 1.385 1.582l-0 0.475c-1.012 0.357-1.905 0.977-2.602 1.809-0.788 0.942-1.263 2.084-1.373 3.305-0.013 0.14 0.034 0.279 0.129 0.382s0.229 0.163 0.369 0.163h2.423c0.185-1.316 0.73-2.545 1.59-3.572z" })
            );
        }
        function Users3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Users3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Users3.SVG = Users3SVG;
        return Users3;
    })();
export const UserPlus2 = /*#__PURE__*/ (() => {
        function UserPlus2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 16h-6.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427 2.119 0 3.874 1.966 3.993 4.476 0.013 0.276-0.2 0.51-0.476 0.523s-0.51-0.2-0.523-0.476c-0.094-1.976-1.41-3.524-2.995-3.524-1.654 0-3 1.682-3 3.75 0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h6.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 16c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM11.5 8c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" }),
_('path', { d: "M13.5 11h-1.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function UserPlus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserPlus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserPlus2.SVG = UserPlus2SVG;
        return UserPlus2;
    })();
export const UserMinus2 = /*#__PURE__*/ (() => {
        function UserMinus2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 16h-6.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427 2.119 0 3.874 1.966 3.993 4.476 0.013 0.276-0.2 0.51-0.476 0.523s-0.51-0.2-0.523-0.476c-0.094-1.976-1.41-3.524-2.995-3.524-1.654 0-3 1.682-3 3.75 0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h6.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 16c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM11.5 8c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" }),
_('path', { d: "M13.5 11h-4c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function UserMinus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserMinus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserMinus2.SVG = UserMinus2SVG;
        return UserMinus2;
    })();
export const UserCancel2 = /*#__PURE__*/ (() => {
        function UserCancel2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 16h-6.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427 2.119 0 3.874 1.966 3.993 4.476 0.013 0.276-0.2 0.51-0.476 0.523s-0.51-0.2-0.523-0.476c-0.094-1.976-1.41-3.524-2.995-3.524-1.654 0-3 1.682-3 3.75 0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h6.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 16c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zM11.5 8c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" }),
_('path', { d: "M12.207 11.5l1.646-1.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-1.646 1.646-1.646-1.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l1.646 1.646-1.646 1.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l1.646-1.646 1.646 1.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-1.646-1.646z" })
            );
        }
        function UserCancel2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCancel2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCancel2.SVG = UserCancel2SVG;
        return UserCancel2;
    })();
export const UserBlock2 = /*#__PURE__*/ (() => {
        function UserBlock2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 16h-6.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427 2.119 0 3.874 1.966 3.993 4.476 0.013 0.276-0.2 0.51-0.476 0.523s-0.51-0.2-0.523-0.476c-0.094-1.976-1.41-3.524-2.995-3.524-1.654 0-3 1.682-3 3.75 0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h6.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 7c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5zM8 11.5c0-1.93 1.57-3.5 3.5-3.5 0.785 0 1.511 0.26 2.095 0.698l-4.897 4.897c-0.438-0.584-0.698-1.31-0.698-2.095zM11.5 15c-0.785 0-1.511-0.26-2.095-0.698l4.897-4.897c0.438 0.584 0.698 1.31 0.698 2.095 0 1.93-1.57 3.5-3.5 3.5z" })
            );
        }
        function UserBlock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserBlock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserBlock2.SVG = UserBlock2SVG;
        return UserBlock2;
    })();
export const UserLock2 = /*#__PURE__*/ (() => {
        function UserLock2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 16h-6.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427s2.103 0.507 2.861 1.427c0.735 0.892 1.139 2.072 1.139 3.323 0 0.276-0.020 0.553-0.060 0.823-0.040 0.273-0.294 0.462-0.567 0.422s-0.462-0.294-0.422-0.567c0.033-0.222 0.049-0.45 0.049-0.677 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h6.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M15.5 10h-0.5v-0.5c0-1.379-1.121-2.5-2.5-2.5s-2.5 1.121-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5zM11 9.5c0-0.827 0.673-1.5 1.5-1.5s1.5 0.673 1.5 1.5v0.5h-3v-0.5zM15 15h-5v-4h5v4z" }),
_('path', { d: "M12.5 14c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function UserLock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserLock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserLock2.SVG = UserLock2SVG;
        return UserLock2;
    })();
export const UserCheck2 = /*#__PURE__*/ (() => {
        function UserCheck2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 16h-5.977c-0.14 0-0.274-0.059-0.369-0.163s-0.141-0.242-0.129-0.382c0.11-1.22 0.585-2.363 1.373-3.305 0.697-0.832 1.59-1.452 2.602-1.809l0-0.475c-0.562-0.385-1.037-0.926-1.385-1.582-0.402-0.758-0.615-1.634-0.615-2.535 0-1.251 0.405-2.431 1.139-3.323 0.758-0.92 1.774-1.427 2.861-1.427s2.103 0.507 2.861 1.427c0.735 0.892 1.139 2.072 1.139 3.323 0 0.901-0.213 1.777-0.615 2.535-0.348 0.655-0.823 1.197-1.385 1.582l-0 0.634c-0 0.276-0.224 0.5-0.5 0.5-0 0 0 0-0 0-0.276-0-0.5-0.224-0.5-0.5l0-0.909c0-0.179 0.095-0.344 0.25-0.433 1.063-0.613 1.75-1.951 1.75-3.408 0-2.068-1.346-3.75-3-3.75s-3 1.682-3 3.75c0 1.457 0.687 2.795 1.75 3.408 0.155 0.089 0.25 0.254 0.25 0.433l-0 1.116c0 0.224-0.149 0.42-0.364 0.481-0.967 0.274-1.822 0.828-2.471 1.604-0.538 0.643-0.901 1.397-1.064 2.208h5.4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10 16c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1.646 1.646 4.646-4.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-5 5c-0.098 0.098-0.226 0.146-0.354 0.146z" })
            );
        }
        function UserCheck2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UserCheck2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        UserCheck2.SVG = UserCheck2SVG;
        return UserCheck2;
    })();
export const User3 = /*#__PURE__*/ (() => {
    function User3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 5c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM12 10h-8c-2.209 0-4 1.791-4 4v1h16v-1c0-2.209-1.791-4-4-4z" })
        );
    }
    function User3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( User3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User3.SVG = User3SVG;
    return User3;
})();
export const User4 = /*#__PURE__*/ (() => {
    function User4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zM8 1c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4v0zM12 11c1.654 0 3 1.346 3 3h-14c0-1.654 1.346-3 3-3h8zM12 10h-8c-2.209 0-4 1.791-4 4v1h16v-1c0-2.209-1.791-4-4-4v0z" })
        );
    }
    function User4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( User4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User4.SVG = User4SVG;
    return User4;
})();
export const User5 = /*#__PURE__*/ (() => {
    function User5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 9c2.209 0 4-1.791 4-4s-1.791-4-4-4-4 1.791-4 4 1.791 4 4 4zM5 5c0-0.042 0.001-0.084 0.003-0.125h5.994c0.002 0.041 0.003 0.083 0.003 0.125s-0.001 0.084-0.003 0.125h-5.994c-0.002-0.041-0.003-0.083-0.003-0.125zM5.884 2.875h4.231c0.079 0.079 0.154 0.163 0.225 0.25h-4.68c0.070-0.087 0.145-0.171 0.224-0.25zM6.169 2.625c0.12-0.092 0.247-0.176 0.38-0.25h2.902c0.133 0.074 0.26 0.158 0.38 0.25h-3.661zM10.521 3.375c0.052 0.081 0.101 0.164 0.145 0.25h-5.332c0.044-0.086 0.093-0.169 0.145-0.25h5.041zM10.781 3.875c0.033 0.082 0.063 0.165 0.089 0.25h-5.739c0.026-0.085 0.056-0.168 0.089-0.25h5.562zM10.934 4.375c0.018 0.082 0.032 0.166 0.042 0.25h-5.953c0.011-0.084 0.025-0.168 0.042-0.25h5.869zM10.977 5.375c-0.011 0.084-0.025 0.168-0.042 0.25h-5.869c-0.018-0.082-0.032-0.166-0.042-0.25h5.953zM10.87 5.875c-0.026 0.085-0.056 0.168-0.089 0.25h-5.562c-0.033-0.082-0.063-0.165-0.089-0.25h5.739zM10.666 6.375c-0.044 0.086-0.093 0.169-0.145 0.25h-5.041c-0.052-0.081-0.101-0.164-0.145-0.25h5.332zM10.116 7.125h-4.231c-0.079-0.079-0.154-0.163-0.224-0.25h4.68c-0.070 0.087-0.145 0.171-0.225 0.25zM9.831 7.375c-0.12 0.093-0.247 0.176-0.38 0.25h-2.902c-0.133-0.074-0.26-0.157-0.38-0.25h3.661zM7.143 7.875h1.714c-0.272 0.081-0.559 0.125-0.857 0.125s-0.585-0.044-0.857-0.125zM8.857 2.125h-1.714c0.272-0.081 0.559-0.125 0.857-0.125s0.585 0.044 0.857 0.125zM12 10h-8c-2.209 0-4 1.791-4 4v1h16v-1c0-2.209-1.791-4-4-4zM1.884 11.875h12.231c0.079 0.079 0.154 0.163 0.225 0.25h-12.68c0.070-0.087 0.145-0.171 0.224-0.25zM2.169 11.625c0.12-0.092 0.247-0.176 0.38-0.25h10.902c0.133 0.074 0.26 0.158 0.38 0.25h-11.661zM14.521 12.375c0.052 0.081 0.101 0.164 0.145 0.25h-13.332c0.044-0.086 0.093-0.169 0.145-0.25h13.041zM14.781 12.875c0.033 0.082 0.063 0.165 0.089 0.25h-13.739c0.026-0.085 0.056-0.168 0.089-0.25h13.562zM14.934 13.375c0.018 0.082 0.032 0.166 0.042 0.25h-13.953c0.011-0.084 0.025-0.168 0.042-0.25h13.869zM12 11c0.298 0 0.585 0.044 0.857 0.125h-9.714c0.272-0.081 0.559-0.125 0.857-0.125h8zM1 14c0-0.042 0.001-0.084 0.003-0.125h13.994c0.002 0.041 0.003 0.083 0.003 0.125h-14z" })
        );
    }
    function User5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( User5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User5.SVG = User5SVG;
    return User5;
})();
export const User6 = /*#__PURE__*/ (() => {
        function User6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 5.5c0 2.485-1.567 4.5-3.5 4.5s-3.5-2.015-3.5-4.5c0-2.485 1.567-4.5 3.5-4.5s3.5 2.015 3.5 4.5z" }),
_('path', { d: "M7 8.922h2v2.078h-2v-2.078z" }),
_('path', { d: "M1 12c0-1.105 3.134-2 7-2s7 0.895 7 2z" }),
_('path', { d: "M1 12h14v2h-14v-2z" })
            );
        }
        function User6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( User6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        User6.SVG = User6SVG;
        return User6;
    })();
export const Users4 = /*#__PURE__*/ (() => {
        function Users4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 11.020v-0.207c1.446-0.553 2.5-2.275 2.5-4.313 0-2.485-1.567-4.5-3.5-4.5s-3.5 2.015-3.5 4.5c0 2.038 1.054 3.76 2.5 4.313v0.207c-3.392 0.139-6 0.972-6 1.98v2h14v-2c0-1.008-2.608-1.841-6-1.98z" }),
_('path', { d: "M18 7.009v-0.079c1.141-0.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5s-2.5 1.567-2.5 3.5c0 1.693 0.859 3.106 2 3.43v0.079c-0.497 0.018-0.97 0.064-1.404 0.131-0.098 1.066-0.439 2.051-0.965 2.859h7.369v-1.5c0-0.772-1.75-1.408-4-1.491z" }),
_('path', { d: "M6.404 7.141c-0.435-0.068-0.907-0.113-1.404-0.131v-0.079c1.141-0.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5s-2.5 1.567-2.5 3.5c0 1.693 0.859 3.106 2 3.43v0.079c-2.25 0.083-4 0.719-4 1.491v1.5h7.369c-0.526-0.809-0.867-1.794-0.965-2.859z" })
            );
        }
        function Users4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Users4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Users4.SVG = Users4SVG;
        return Users4;
    })();
export const UserTie = /*#__PURE__*/ (() => {
    function UserTieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z" })
        );
    }
    function UserTie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UserTieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    UserTie.SVG = UserTieSVG;
    return UserTie;
})();
export const User7 = /*#__PURE__*/ (() => {
    function User7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 4c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM8 8c-3.314 0-6 3.134-6 7h2c0-2.761 1.791-5 4-5s4 2.239 4 5h2c0-3.866-2.686-7-6-7z" })
        );
    }
    function User7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( User7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    User7.SVG = User7SVG;
    return User7;
})();
export const Users5 = /*#__PURE__*/ (() => {
    function Users5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 6c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM9 3c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM5 9c-2.761 0-5 2.686-5 6h1.5c0-0.64 0.103-1.258 0.308-1.837 0.192-0.546 0.465-1.032 0.809-1.446 0.654-0.785 1.501-1.218 2.383-1.218s1.729 0.432 2.383 1.218c0.345 0.414 0.617 0.9 0.809 1.446 0.204 0.579 0.308 1.197 0.308 1.837h1.5c0-3.314-2.239-6-5-6zM11 6c-1.472 0-2.794 0.763-3.709 1.977 0.112 0.049 0.224 0.101 0.335 0.157 0.34 0.173 0.664 0.376 0.97 0.61 0.007-0.009 0.014-0.018 0.022-0.027 0.654-0.785 1.501-1.218 2.383-1.218s1.729 0.432 2.383 1.218c0.345 0.414 0.617 0.9 0.809 1.446 0.204 0.579 0.308 1.197 0.308 1.837h1.5c0-3.314-2.239-6-5-6z" })
        );
    }
    function Users5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Users5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Users5.SVG = Users5SVG;
    return Users5;
})();
export const Collaboration = /*#__PURE__*/ (() => {
        function CollaborationSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M2.5 5c-1.381 0-2.5 0.448-2.5 1v1h5v-1c0-0.552-1.119-1-2.5-1z" }),
_('path', { d: "M14 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M12.5 5c-1.381 0-2.5 0.448-2.5 1v1h5v-1c0-0.552-1.119-1-2.5-1z" }),
_('path', { d: "M9 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M7.5 13c-1.381 0-2.5 0.448-2.5 1v1h5v-1c0-0.552-1.119-1-2.5-1z" }),
_('path', { d: "M9.5 4h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 12c-0.095 0-0.192-0.027-0.277-0.084-0.23-0.153-0.292-0.464-0.139-0.693l2-3c0.153-0.23 0.464-0.292 0.693-0.139s0.292 0.464 0.139 0.693l-2 3c-0.096 0.145-0.255 0.223-0.416 0.223z" }),
_('path', { d: "M4.5 12c-0.162 0-0.32-0.078-0.417-0.223l-2-3c-0.153-0.23-0.091-0.54 0.139-0.693s0.54-0.091 0.693 0.139l2 3c0.153 0.23 0.091 0.54-0.139 0.693-0.085 0.057-0.182 0.084-0.277 0.084z" })
            );
        }
        function Collaboration({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CollaborationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Collaboration.SVG = CollaborationSVG;
        return Collaboration;
    })();
export const Vcard = /*#__PURE__*/ (() => {
    function VcardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 3h-12c-1.1 0-2 0.9-2 2v7c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-7c0-1.1-0.9-2-2-2zM2 12c0-2.209 1.119-4 2.5-4-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c1.381 0 2.5 1.791 2.5 4h-5zM14 12h-5v-1h5v1zM14 10h-5v-1h5v1zM14 8h-5v-1h5v1z" })
        );
    }
    function Vcard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VcardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vcard.SVG = VcardSVG;
    return Vcard;
})();
export const Hat = /*#__PURE__*/ (() => {
    function HatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 7.768v-3.268c0-0.828-2.239-1.5-5-1.5s-5 0.672-5 1.5v3.268c-1.829 0.641-3 1.627-3 2.732 0 1.933 3.582 3.5 8 3.5s8-1.567 8-3.5c0-1.105-1.171-2.091-3-2.732zM13 10.5c0 0.828-2.239 1.5-5 1.5s-5-0.672-5-1.5v-2c0 0.828 2.239 1.5 5 1.5s5-0.672 5-1.5v2z" })
        );
    }
    function Hat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hat.SVG = HatSVG;
    return Hat;
})();
export const Bowtie = /*#__PURE__*/ (() => {
    function BowtieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.331 2.783c-0.151-0.186-0.412-0.239-0.624-0.126l-4.394 2.344h-2.625l-4.394-2.344c-0.211-0.113-0.473-0.060-0.624 0.126-1.077 1.329-1.669 3.004-1.669 4.717s0.593 3.388 1.669 4.717c0.098 0.121 0.242 0.185 0.389 0.185 0.080 0 0.161-0.019 0.235-0.059l4.394-2.344h2.625l4.394 2.344c0.074 0.040 0.155 0.059 0.235 0.059 0.147 0 0.291-0.065 0.389-0.185 1.077-1.329 1.669-3.004 1.669-4.717s-0.593-3.388-1.669-4.717zM2.199 11.261c-0.679-0.958-1.088-2.089-1.179-3.261h2.481c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.481c0.091-1.171 0.5-2.303 1.179-3.261l3.801 2.027v3.467l-3.801 2.027zM13.801 11.261l-3.801-2.027v-3.467l3.801-2.027c0.679 0.958 1.088 2.089 1.179 3.261h-2.481c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.481c-0.091 1.171-0.5 2.303-1.179 3.261z" })
        );
    }
    function Bowtie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BowtieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bowtie.SVG = BowtieSVG;
    return Bowtie;
})();
export const Tie = /*#__PURE__*/ (() => {
    function TieSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16.043c-0.141 0-0.275-0.060-0.37-0.164l-2.457-2.707c-0.107-0.117-0.151-0.279-0.12-0.434l1.941-9.703-1.877-2.211c-0.126-0.149-0.154-0.357-0.073-0.534s0.259-0.29 0.454-0.29h5.006c0.195 0 0.372 0.113 0.454 0.29s0.053 0.385-0.073 0.534l-1.877 2.211 1.941 9.703c0.031 0.156-0.013 0.317-0.12 0.434l-2.457 2.707c-0.095 0.104-0.229 0.164-0.37 0.164z" })
        );
    }
    function Tie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TieSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tie.SVG = TieSVG;
    return Tie;
})();
export const Hanger = /*#__PURE__*/ (() => {
    function HangerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.77 13.579l-6.77-4.352v-0.495c0.61-0.353 1-1.010 1-1.732 0-1.103-0.897-2-2-2-0.846 0-1.604 0.536-1.886 1.333-0.092 0.26 0.044 0.546 0.305 0.638s0.546-0.044 0.638-0.305c0.141-0.399 0.52-0.667 0.943-0.667 0.551 0 1 0.449 1 1 0 0.423-0.268 0.802-0.667 0.943-0.2 0.071-0.333 0.259-0.333 0.471l-0 0.812-6.77 4.352c-0.143 0.092-0.23 0.25-0.23 0.421v0.5c0 0.827 0.673 1.5 1.5 1.5h12c0.827 0 1.5-0.673 1.5-1.5v-0.5c0-0.17-0.086-0.329-0.23-0.421zM14 14.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-0.227l6.5-4.179 6.5 4.179v0.227z" })
        );
    }
    function Hanger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HangerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hanger.SVG = HangerSVG;
    return Hanger;
})();
export const Tshirt = /*#__PURE__*/ (() => {
    function TshirtSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.905 2l5.095 1v4h-3v8h-10v-8h-3v-4l5.095-1c0.333 1.294 1.508 2.25 2.905 2.25s2.572-0.956 2.905-2.25z" })
        );
    }
    function Tshirt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TshirtSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tshirt.SVG = TshirtSVG;
    return Tshirt;
})();
export const Pants = /*#__PURE__*/ (() => {
    function PantsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.968 0h-10.936l-1.067 16h4.966l1.568-10.617 1.568 10.617h4.966l-1.067-16zM4 2h-1v-1h1v1zM7 2h-2v-1h2v1zM10 2h-2v-1h2v1zM12 2h-1v-1h1v1z" })
        );
    }
    function Pants({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PantsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pants.SVG = PantsSVG;
    return Pants;
})();
export const Shorts = /*#__PURE__*/ (() => {
    function ShortsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 3h-13l-1 11h6l1.5-5.972 1.5 5.972h6l-1-11zM4 5h-2v-1h2v1zM7 5h-2v-1h2v1zM10 5h-2v-1h2v1zM13 5h-2v-1h2v1z" })
        );
    }
    function Shorts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShortsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shorts.SVG = ShortsSVG;
    return Shorts;
})();
export const Sock = /*#__PURE__*/ (() => {
    function SockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.729 9.223l-4.229-1.586c-0.919-0.345-1.179-0.682-1.312-0.967-0.187-0.401-0.187-0.906-0.187-1.67v-4.5c0-0.276-0.224-0.5-0.5-0.5h-6c-0.276 0-0.5 0.224-0.5 0.5v9c0 1.451 0.913 2.768 2.271 3.277l8 3c0.396 0.149 0.809 0.224 1.228 0.224 1.451-0 2.768-0.913 3.278-2.272 0.678-1.807-0.241-3.828-2.048-4.506zM5 1h1v1h-1v-1zM3 1h1v1h-1v-1zM1 1h1v1h-1v-1zM4.803 12.659c0.127-0.363 0.197-0.752 0.197-1.159 0-1.933-1.567-3.5-3.5-3.5-0.17 0-0.337 0.012-0.5 0.036v-5.036h5v2c0 0.833 0 1.491 0.281 2.093 0.305 0.654 0.881 1.11 1.867 1.48l4.229 1.586c0.342 0.128 0.639 0.325 0.883 0.567-1.321 0.5-2.261 1.777-2.261 3.274 0 0.338 0.048 0.665 0.138 0.974-0.175-0.026-0.347-0.070-0.515-0.133l-5.819-2.182z" })
        );
    }
    function Sock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sock.SVG = SockSVG;
    return Sock;
})();
export const Laundry = /*#__PURE__*/ (() => {
        function LaundrySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 0h-12c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM10 1c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM2 1.5c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5zM8 14c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM13 3c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" }),
_('path', { d: "M8 10c-0.5-1.5-2.5-1.5-3 0 0 1.657 1.343 3 3 3s3-1.343 3-3c-0.5 1.5-2.5 1.5-3 0z" })
            );
        }
        function Laundry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LaundrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Laundry.SVG = LaundrySVG;
        return Laundry;
    })();
export const QuotesLeft = /*#__PURE__*/ (() => {
    function QuotesLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z" })
        );
    }
    function QuotesLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuotesLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QuotesLeft.SVG = QuotesLeftSVG;
    return QuotesLeft;
})();
export const QuotesRight = /*#__PURE__*/ (() => {
    function QuotesRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043zM3.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043z" })
        );
    }
    function QuotesRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuotesRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QuotesRight.SVG = QuotesRightSVG;
    return QuotesRight;
})();
export const QuotesLeft2 = /*#__PURE__*/ (() => {
    function QuotesLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 1v14h-6v-7zM15 1v14h-6v-7z" })
        );
    }
    function QuotesLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuotesLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QuotesLeft2.SVG = QuotesLeft2SVG;
    return QuotesLeft2;
})();
export const QuotesRight2 = /*#__PURE__*/ (() => {
    function QuotesRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 15v-14h6v7zM0 15v-14h6v7z" })
        );
    }
    function QuotesRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuotesRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    QuotesRight2.SVG = QuotesRight2SVG;
    return QuotesRight2;
})();
export const HourGlass = /*#__PURE__*/ (() => {
    function HourGlassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.39 8c2.152-1.365 3.61-3.988 3.61-7 0-0.339-0.019-0.672-0.054-1h-13.891c-0.036 0.328-0.054 0.661-0.054 1 0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 0.339 0.019 0.672 0.054 1h13.891c0.036-0.328 0.054-0.661 0.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214v-1.572c-2.247-0.817-3.5-3.294-3.5-6.214v0h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247 0.817 3.5 3.294 3.5 6.214h-11zM9.682 10.462c-1.12-0.635-1.181-1.459-1.182-1.959v-1.004c0-0.5 0.059-1.327 1.184-1.963 0.602-0.349 1.122-0.88 1.516-1.537h-6.4c0.395 0.657 0.916 1.188 1.518 1.538 1.12 0.635 1.181 1.459 1.182 1.959v1.004c0 0.5-0.059 1.327-1.184 1.963-1.135 0.659-1.98 1.964-2.236 3.537h7.839c-0.256-1.574-1.102-2.879-2.238-3.538z" })
        );
    }
    function HourGlass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HourGlassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HourGlass.SVG = HourGlassSVG;
    return HourGlass;
})();
export const HourGlass2 = /*#__PURE__*/ (() => {
    function HourGlass2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.838 9.824c-1.169-0.761-1.838-1.188-1.838-1.824s0.67-1.064 1.838-1.824c1.882-1.183 3.162-3.505 3.162-6.176h-12c0 2.671 1.28 4.993 3.162 6.176 1.169 0.761 1.838 1.188 1.838 1.824s-0.67 1.064-1.838 1.824c-1.882 1.183-3.162 3.505-3.162 6.176h12c0-2.671-1.279-4.993-3.162-6.176zM4.057 3.028c-0.274-0.525-0.474-1.097-0.593-1.695h9.072c-0.119 0.598-0.318 1.17-0.593 1.695-0.184 0.352-0.399 0.678-0.64 0.972h-6.607c-0.241-0.294-0.455-0.619-0.64-0.972zM7.75 11.963c0 0.681-2.75 1.704-2.75 2.704h-1.536c0.119-0.598 0.318-1.17 0.593-1.695 0.447-0.855 1.074-1.553 1.814-2.018l0.009-0.006 0.009-0.006 0.048-0.031c0.73-0.475 1.376-0.896 1.813-1.399v2.451zM12.536 14.667h-1.536c0-1-2.75-2.023-2.75-2.704v-2.451c0.437 0.503 1.083 0.924 1.813 1.399l0.057 0.037 0.009 0.006c0.74 0.465 1.367 1.163 1.814 2.018 0.274 0.525 0.474 1.097 0.593 1.695z" })
        );
    }
    function HourGlass2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HourGlass2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HourGlass2.SVG = HourGlass2SVG;
    return HourGlass2;
})();
export const HourGlass3 = /*#__PURE__*/ (() => {
    function HourGlass3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.939 9.532c-1.49 0.81-2.591 2.472-2.87 4.468h9.862c-0.279-1.996-1.379-3.658-2.87-4.468-1.061-0.754-1.061-1.116-1.061-1.532s0-0.778 1.061-1.532c1.49-0.81 2.591-2.472 2.87-4.468h-9.862c0.279 1.996 1.379 3.658 2.87 4.468 1.061 0.754 1.061 1.116 1.061 1.532s-0 0.778-1.061 1.532zM2 15h12v1h-12zM2 0h12v1h-12z" })
        );
    }
    function HourGlass3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HourGlass3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HourGlass3.SVG = HourGlass3SVG;
    return HourGlass3;
})();
export const Spinner = /*#__PURE__*/ (() => {
    function SpinnerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.243 3.757c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM13 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.243 12.243c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 14c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.757 12.243c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.257 3.757c0 0 0 0 0 0 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0.875 8c0-0.621 0.504-1.125 1.125-1.125s1.125 0.504 1.125 1.125c0 0.621-0.504 1.125-1.125 1.125s-1.125-0.504-1.125-1.125z" })
        );
    }
    function Spinner({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpinnerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner.SVG = SpinnerSVG;
    return Spinner;
})();
export const Spinner2 = /*#__PURE__*/ (() => {
    function Spinner2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z" })
        );
    }
    function Spinner2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner2.SVG = Spinner2SVG;
    return Spinner2;
})();
export const Spinner3 = /*#__PURE__*/ (() => {
        function Spinner3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 4.736c-0.515 0-0.933-0.418-0.933-0.933v-2.798c0-0.515 0.418-0.933 0.933-0.933s0.933 0.418 0.933 0.933v2.798c0 0.515-0.418 0.933-0.933 0.933z" }),
_('path', { d: "M8 15.577c-0.322 0-0.583-0.261-0.583-0.583v-2.798c0-0.322 0.261-0.583 0.583-0.583s0.583 0.261 0.583 0.583v2.798c0 0.322-0.261 0.583-0.583 0.583z" }),
_('path', { d: "M5.902 5.24c-0.302 0-0.596-0.157-0.758-0.437l-1.399-2.423c-0.241-0.418-0.098-0.953 0.32-1.194s0.953-0.098 1.194 0.32l1.399 2.423c0.241 0.418 0.098 0.953-0.32 1.194-0.138 0.079-0.288 0.117-0.436 0.117z" }),
_('path', { d: "M11.498 14.582c-0.181 0-0.358-0.094-0.455-0.262l-1.399-2.423c-0.145-0.251-0.059-0.572 0.192-0.717s0.572-0.059 0.717 0.192l1.399 2.423c0.145 0.251 0.059 0.572-0.192 0.717-0.083 0.048-0.173 0.070-0.262 0.070z" }),
_('path', { d: "M4.365 6.718c-0.138 0-0.279-0.035-0.407-0.109l-2.423-1.399c-0.39-0.225-0.524-0.724-0.299-1.115s0.724-0.524 1.115-0.299l2.423 1.399c0.39 0.225 0.524 0.724 0.299 1.115-0.151 0.262-0.425 0.408-0.707 0.408z" }),
_('path', { d: "M14.057 11.964c-0.079 0-0.159-0.020-0.233-0.063l-2.423-1.399c-0.223-0.129-0.299-0.414-0.171-0.637s0.414-0.299 0.637-0.171l2.423 1.399c0.223 0.129 0.299 0.414 0.171 0.637-0.086 0.15-0.243 0.233-0.404 0.233z" }),
_('path', { d: "M3.803 8.758h-2.798c-0.418 0-0.758-0.339-0.758-0.758s0.339-0.758 0.758-0.758h2.798c0.419 0 0.758 0.339 0.758 0.758s-0.339 0.758-0.758 0.758z" }),
_('path', { d: "M14.995 8.466c-0 0 0 0 0 0h-2.798c-0.258-0-0.466-0.209-0.466-0.466s0.209-0.466 0.466-0.466c0 0 0 0 0 0h2.798c0.258 0 0.466 0.209 0.466 0.466s-0.209 0.466-0.466 0.466z" }),
_('path', { d: "M1.943 12.197c-0.242 0-0.477-0.125-0.606-0.35-0.193-0.335-0.079-0.762 0.256-0.955l2.423-1.399c0.335-0.193 0.762-0.079 0.955 0.256s0.079 0.762-0.256 0.955l-2.423 1.399c-0.11 0.064-0.23 0.094-0.349 0.094z" }),
_('path', { d: "M11.635 6.368c-0.161 0-0.318-0.084-0.404-0.233-0.129-0.223-0.052-0.508 0.171-0.637l2.423-1.399c0.223-0.129 0.508-0.052 0.637 0.171s0.052 0.508-0.171 0.637l-2.423 1.399c-0.073 0.042-0.154 0.063-0.233 0.063z" }),
_('path', { d: "M4.502 14.699c-0.109 0-0.219-0.028-0.32-0.086-0.307-0.177-0.412-0.569-0.235-0.876l1.399-2.423c0.177-0.307 0.569-0.412 0.876-0.235s0.412 0.569 0.235 0.876l-1.399 2.423c-0.119 0.206-0.334 0.321-0.556 0.321z" }),
_('path', { d: "M10.098 4.832c-0.079 0-0.159-0.020-0.233-0.063-0.223-0.129-0.299-0.414-0.171-0.637l1.399-2.423c0.129-0.223 0.414-0.299 0.637-0.171s0.299 0.414 0.171 0.637l-1.399 2.423c-0.086 0.15-0.243 0.233-0.404 0.233z" })
            );
        }
        function Spinner3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Spinner3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spinner3.SVG = Spinner3SVG;
        return Spinner3;
    })();
export const Spinner4 = /*#__PURE__*/ (() => {
    function Spinner4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 8c0-0.19 0.011-0.378 0.032-0.563l-2.89-0.939c-0.092 0.487-0.141 0.989-0.141 1.502 0 2.3 0.971 4.374 2.526 5.833l1.786-2.458c-0.814-0.889-1.312-2.074-1.312-3.375zM13 8c0 1.301-0.497 2.486-1.312 3.375l1.786 2.458c1.555-1.459 2.526-3.533 2.526-5.833 0-0.513-0.049-1.015-0.141-1.502l-2.89 0.939c0.021 0.185 0.032 0.373 0.032 0.563zM9 3.1c1.436 0.292 2.649 1.199 3.351 2.435l2.89-0.939c-1.144-2.428-3.473-4.188-6.241-4.534v3.038zM3.649 5.535c0.702-1.236 1.914-2.143 3.351-2.435v-3.038c-2.769 0.345-5.097 2.105-6.241 4.534l2.89 0.939zM10.071 12.552c-0.631 0.288-1.332 0.448-2.071 0.448s-1.44-0.16-2.071-0.448l-1.786 2.458c1.144 0.631 2.458 0.99 3.857 0.99s2.713-0.359 3.857-0.99l-1.786-2.458z" })
        );
    }
    function Spinner4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner4.SVG = Spinner4SVG;
    return Spinner4;
})();
export const Spinner5 = /*#__PURE__*/ (() => {
    function Spinner5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 4c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zM12.773 12.773c-1.275 1.275-2.97 1.977-4.773 1.977s-3.498-0.702-4.773-1.977-1.977-2.97-1.977-4.773c0-1.803 0.702-3.498 1.977-4.773l1.061 1.061c0 0 0 0 0 0-2.047 2.047-2.047 5.378 0 7.425 0.992 0.992 2.31 1.538 3.712 1.538s2.721-0.546 3.712-1.538c2.047-2.047 2.047-5.378 0-7.425l1.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773z" })
        );
    }
    function Spinner5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner5.SVG = Spinner5SVG;
    return Spinner5;
})();
export const Spinner6 = /*#__PURE__*/ (() => {
    function Spinner6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12.359 8c0 0 0 0 0 0 0-0.906 0.735-1.641 1.641-1.641s1.641 0.735 1.641 1.641c0 0 0 0 0 0 0 0.906-0.735 1.641-1.641 1.641s-1.641-0.735-1.641-1.641zM10.757 12.243c0-0.821 0.665-1.486 1.486-1.486s1.486 0.665 1.486 1.486c0 0.821-0.665 1.486-1.486 1.486s-1.486-0.665-1.486-1.486zM6.654 14c0-0.743 0.603-1.346 1.346-1.346s1.346 0.603 1.346 1.346c0 0.743-0.603 1.346-1.346 1.346s-1.346-0.603-1.346-1.346zM2.538 12.243c0-0.673 0.546-1.219 1.219-1.219s1.219 0.546 1.219 1.219c0 0.673-0.546 1.219-1.219 1.219s-1.219-0.546-1.219-1.219zM0.896 8c0-0.61 0.494-1.104 1.104-1.104s1.104 0.494 1.104 1.104c0 0.61-0.494 1.104-1.104 1.104s-1.104-0.494-1.104-1.104zM2.757 3.757c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM14.054 3.757c0 1-0.811 1.811-1.812 1.811s-1.812-0.811-1.812-1.811c0-1.001 0.811-1.811 1.812-1.811s1.812 0.811 1.812 1.811z" })
        );
    }
    function Spinner6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner6.SVG = Spinner6SVG;
    return Spinner6;
})();
export const Spinner7 = /*#__PURE__*/ (() => {
    function Spinner7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM13 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" })
        );
    }
    function Spinner7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner7.SVG = Spinner7SVG;
    return Spinner7;
})();
export const Spinner8 = /*#__PURE__*/ (() => {
    function Spinner8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c-2.137 0-4.146-0.832-5.657-2.343s-2.343-3.52-2.343-5.657c0-1.513 0.425-2.986 1.228-4.261 0.781-1.239 1.885-2.24 3.193-2.895l0.672 1.341c-1.063 0.533-1.961 1.347-2.596 2.354-0.652 1.034-0.997 2.231-0.997 3.461 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-0.345-2.426-0.997-3.461-0.635-1.008-1.533-1.822-2.596-2.354l0.672-1.341c1.308 0.655 2.412 1.656 3.193 2.895 0.803 1.274 1.228 2.748 1.228 4.261 0 2.137-0.832 4.146-2.343 5.657s-3.52 2.343-5.657 2.343z" })
        );
    }
    function Spinner8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner8.SVG = Spinner8SVG;
    return Spinner8;
})();
export const Spinner9 = /*#__PURE__*/ (() => {
    function Spinner9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.355 0-7.898 3.481-7.998 7.812 0.092-3.779 2.966-6.812 6.498-6.812 3.59 0 6.5 3.134 6.5 7 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-4.418-3.582-8-8-8zM8 16c4.355 0 7.898-3.481 7.998-7.812-0.092 3.779-2.966 6.812-6.498 6.812-3.59 0-6.5-3.134-6.5-7 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 4.418 3.582 8 8 8z" })
        );
    }
    function Spinner9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner9.SVG = Spinner9SVG;
    return Spinner9;
})();
export const Spinner10 = /*#__PURE__*/ (() => {
    function Spinner10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.001 8.025l-0 0c0 0 0 0.001 0 0.003 0.002 0.061 0.009 0.12 0.021 0.177 0.003 0.027 0.007 0.057 0.011 0.090 0.003 0.029 0.007 0.061 0.011 0.095 0.006 0.040 0.012 0.083 0.019 0.128 0.013 0.090 0.028 0.189 0.045 0.296 0.021 0.101 0.044 0.21 0.068 0.326 0.011 0.058 0.028 0.117 0.044 0.178s0.032 0.123 0.049 0.188c0.009 0.032 0.016 0.065 0.027 0.097s0.021 0.065 0.031 0.098 0.043 0.134 0.065 0.203c0.006 0.017 0.011 0.035 0.017 0.052s0.013 0.034 0.019 0.052 0.026 0.070 0.039 0.105c0.027 0.070 0.053 0.142 0.081 0.215 0.031 0.071 0.062 0.144 0.094 0.218 0.016 0.037 0.032 0.074 0.048 0.111s0.035 0.073 0.053 0.111 0.073 0.148 0.11 0.224c0.039 0.075 0.081 0.149 0.123 0.224 0.021 0.037 0.042 0.075 0.063 0.113s0.045 0.074 0.068 0.112 0.093 0.149 0.14 0.224c0.198 0.295 0.417 0.587 0.66 0.864 0.245 0.275 0.511 0.535 0.792 0.775 0.284 0.236 0.582 0.452 0.886 0.642 0.306 0.188 0.619 0.349 0.928 0.487 0.078 0.032 0.156 0.063 0.232 0.095 0.038 0.015 0.076 0.032 0.115 0.046s0.077 0.027 0.115 0.041 0.151 0.054 0.226 0.078c0.075 0.022 0.15 0.044 0.224 0.066 0.037 0.011 0.073 0.022 0.109 0.031s0.073 0.018 0.109 0.027 0.143 0.035 0.213 0.052c0.070 0.014 0.139 0.027 0.207 0.040 0.034 0.006 0.067 0.013 0.101 0.019 0.017 0.003 0.033 0.006 0.049 0.009s0.033 0.005 0.049 0.007c0.066 0.009 0.13 0.018 0.192 0.027 0.031 0.004 0.062 0.009 0.093 0.013s0.061 0.006 0.091 0.009 0.118 0.010 0.174 0.015c0.056 0.005 0.111 0.011 0.164 0.012 0.004 0 0.007 0 0.011 0 0.010 0.544 0.453 0.982 1 0.982 0.008 0 0.017-0 0.025-0.001v0c0 0 0.001-0 0.004-0 0.061-0.002 0.12-0.009 0.177-0.021 0.027-0.003 0.057-0.007 0.090-0.011 0.029-0.003 0.061-0.007 0.095-0.011 0.040-0.006 0.083-0.012 0.128-0.019 0.090-0.013 0.189-0.028 0.296-0.045 0.101-0.021 0.21-0.044 0.326-0.068 0.058-0.011 0.117-0.028 0.178-0.044s0.123-0.033 0.188-0.049c0.032-0.009 0.065-0.016 0.097-0.027s0.065-0.021 0.098-0.031 0.134-0.043 0.203-0.065c0.017-0.006 0.035-0.011 0.052-0.017s0.034-0.013 0.052-0.019 0.070-0.026 0.105-0.039c0.070-0.027 0.142-0.053 0.215-0.081 0.071-0.031 0.144-0.062 0.218-0.094 0.037-0.016 0.074-0.032 0.111-0.048s0.073-0.035 0.111-0.053 0.148-0.073 0.224-0.11c0.075-0.039 0.149-0.081 0.224-0.123 0.037-0.021 0.075-0.042 0.113-0.063s0.074-0.045 0.112-0.068 0.149-0.093 0.224-0.14c0.295-0.197 0.587-0.417 0.864-0.66 0.275-0.245 0.535-0.511 0.775-0.792 0.236-0.284 0.452-0.582 0.642-0.886 0.188-0.306 0.349-0.619 0.487-0.928 0.032-0.078 0.063-0.156 0.095-0.232 0.015-0.038 0.032-0.076 0.046-0.115s0.027-0.077 0.040-0.115 0.054-0.151 0.078-0.226c0.022-0.075 0.044-0.15 0.066-0.224 0.011-0.037 0.022-0.073 0.031-0.109s0.018-0.073 0.027-0.109 0.035-0.143 0.052-0.213c0.014-0.070 0.027-0.139 0.040-0.207 0.006-0.034 0.013-0.067 0.019-0.101 0.003-0.017 0.006-0.033 0.009-0.049s0.005-0.033 0.007-0.050c0.009-0.065 0.018-0.13 0.027-0.192 0.004-0.031 0.009-0.062 0.013-0.093s0.006-0.061 0.009-0.091 0.010-0.118 0.015-0.174c0.005-0.056 0.011-0.111 0.012-0.165 0-0.008 0.001-0.016 0.001-0.025 0.55-0.002 0.996-0.449 0.996-1 0-0.008-0-0.017-0.001-0.025h0c0 0-0-0.001-0-0.003-0.002-0.061-0.009-0.12-0.021-0.177-0.003-0.027-0.007-0.057-0.011-0.090-0.003-0.029-0.007-0.061-0.011-0.095-0.006-0.040-0.012-0.083-0.019-0.128-0.013-0.090-0.028-0.189-0.045-0.296-0.021-0.101-0.044-0.21-0.068-0.326-0.011-0.058-0.028-0.117-0.044-0.178s-0.032-0.123-0.049-0.188c-0.009-0.032-0.016-0.065-0.027-0.097s-0.021-0.065-0.031-0.098-0.043-0.134-0.065-0.203c-0.005-0.017-0.011-0.035-0.017-0.052s-0.013-0.034-0.019-0.052-0.026-0.070-0.039-0.105c-0.027-0.070-0.053-0.142-0.081-0.215-0.031-0.071-0.062-0.144-0.094-0.218-0.016-0.037-0.032-0.074-0.048-0.111s-0.035-0.073-0.053-0.111-0.073-0.148-0.11-0.224c-0.039-0.075-0.081-0.149-0.123-0.224-0.021-0.037-0.042-0.075-0.063-0.113s-0.045-0.074-0.068-0.112-0.093-0.149-0.14-0.224c-0.197-0.295-0.417-0.587-0.66-0.864-0.245-0.275-0.511-0.535-0.792-0.775-0.284-0.236-0.582-0.452-0.886-0.642-0.306-0.188-0.619-0.349-0.928-0.487-0.078-0.032-0.156-0.063-0.232-0.095-0.038-0.015-0.076-0.032-0.115-0.046s-0.077-0.027-0.115-0.040-0.151-0.054-0.226-0.078c-0.075-0.022-0.15-0.044-0.224-0.066-0.037-0.010-0.073-0.022-0.109-0.031s-0.073-0.018-0.109-0.027-0.143-0.035-0.213-0.052c-0.070-0.014-0.139-0.027-0.207-0.040-0.034-0.006-0.067-0.013-0.101-0.019-0.017-0.003-0.033-0.006-0.049-0.009s-0.033-0.005-0.049-0.007c-0.066-0.009-0.13-0.018-0.192-0.027-0.031-0.004-0.062-0.009-0.093-0.013s-0.061-0.006-0.091-0.009-0.118-0.010-0.174-0.015c-0.056-0.005-0.111-0.011-0.164-0.012-0.013-0-0.026-0.001-0.039-0.001-0.010-0.543-0.454-0.981-0.999-0.981-0.008 0-0.017 0-0.025 0.001l-0-0c0 0-0.001 0-0.003 0-0.061 0.002-0.12 0.009-0.177 0.021-0.027 0.003-0.057 0.007-0.090 0.011-0.029 0.003-0.061 0.007-0.095 0.011-0.040 0.006-0.083 0.012-0.128 0.019-0.090 0.013-0.189 0.028-0.296 0.045-0.101 0.021-0.21 0.044-0.326 0.068-0.058 0.011-0.117 0.028-0.178 0.044s-0.123 0.033-0.188 0.049c-0.032 0.009-0.065 0.016-0.097 0.027s-0.065 0.021-0.098 0.031-0.134 0.043-0.203 0.065c-0.017 0.006-0.035 0.011-0.052 0.017s-0.034 0.013-0.052 0.019-0.070 0.026-0.105 0.039c-0.070 0.027-0.142 0.053-0.215 0.081-0.071 0.031-0.144 0.062-0.218 0.094-0.037 0.016-0.074 0.032-0.111 0.048s-0.073 0.035-0.111 0.053-0.148 0.073-0.224 0.11c-0.075 0.039-0.149 0.081-0.224 0.123-0.037 0.021-0.075 0.042-0.113 0.063s-0.074 0.045-0.112 0.068-0.149 0.093-0.224 0.14c-0.295 0.198-0.587 0.417-0.864 0.66-0.275 0.245-0.535 0.511-0.775 0.792-0.236 0.284-0.452 0.582-0.642 0.886-0.188 0.306-0.349 0.619-0.487 0.928-0.032 0.078-0.063 0.156-0.095 0.232-0.015 0.038-0.032 0.076-0.046 0.115s-0.027 0.077-0.040 0.115-0.054 0.151-0.078 0.226c-0.022 0.075-0.044 0.15-0.066 0.224-0.011 0.037-0.022 0.073-0.032 0.109s-0.018 0.073-0.027 0.109-0.035 0.143-0.052 0.213c-0.014 0.070-0.027 0.139-0.040 0.207-0.006 0.034-0.013 0.067-0.019 0.101-0.003 0.017-0.006 0.033-0.009 0.049s-0.005 0.033-0.007 0.050c-0.009 0.065-0.018 0.13-0.027 0.192-0.004 0.031-0.009 0.062-0.013 0.093s-0.006 0.061-0.009 0.091-0.010 0.118-0.015 0.174c-0.005 0.056-0.011 0.111-0.012 0.165-0 0.009-0.001 0.017-0.001 0.025-0.537 0.017-0.967 0.458-0.967 0.999 0 0.008 0 0.017 0.001 0.025zM1.149 7.011c0.001-0.003 0.001-0.006 0.002-0.009 0.010-0.051 0.026-0.102 0.040-0.155s0.030-0.107 0.045-0.163c0.008-0.028 0.015-0.056 0.024-0.084s0.019-0.057 0.028-0.086 0.038-0.116 0.058-0.176c0.005-0.015 0.010-0.030 0.015-0.045s0.012-0.030 0.017-0.045 0.023-0.060 0.035-0.091 0.048-0.123 0.073-0.186c0.028-0.062 0.056-0.125 0.084-0.189 0.014-0.032 0.028-0.064 0.043-0.096s0.032-0.064 0.048-0.096 0.065-0.128 0.098-0.194c0.034-0.065 0.073-0.128 0.109-0.194 0.018-0.032 0.037-0.065 0.056-0.098s0.040-0.064 0.061-0.096c0.041-0.064 0.082-0.129 0.124-0.194 0.176-0.255 0.369-0.506 0.583-0.744 0.217-0.236 0.451-0.459 0.697-0.665 0.25-0.202 0.511-0.385 0.776-0.547 0.268-0.159 0.541-0.294 0.808-0.41 0.068-0.027 0.135-0.053 0.202-0.079 0.033-0.013 0.066-0.027 0.099-0.038s0.067-0.022 0.1-0.033 0.131-0.045 0.196-0.065c0.065-0.018 0.13-0.036 0.194-0.054 0.032-0.009 0.063-0.019 0.095-0.026s0.063-0.014 0.094-0.021 0.123-0.028 0.184-0.042c0.061-0.011 0.12-0.021 0.179-0.032 0.029-0.005 0.058-0.010 0.087-0.015 0.014-0.003 0.029-0.005 0.043-0.008s0.029-0.003 0.043-0.005c0.056-0.007 0.112-0.014 0.166-0.020 0.027-0.003 0.053-0.007 0.080-0.010s0.053-0.004 0.078-0.006 0.102-0.007 0.15-0.011c0.049-0.003 0.095-0.008 0.142-0.008 0.091-0.002 0.177-0.004 0.256-0.006 0.073 0.003 0.14 0.005 0.2 0.007 0.030 0.001 0.058 0.002 0.085 0.002 0.033 0.002 0.064 0.004 0.093 0.006 0.033 0.002 0.063 0.004 0.091 0.006 0.051 0.008 0.103 0.012 0.156 0.012 0.007 0 0.015-0 0.022-0.001 0.002 0 0.004 0 0.004 0v-0c0.487-0.012 0.887-0.372 0.962-0.84 0.008 0.002 0.017 0.004 0.025 0.006 0.051 0.010 0.102 0.026 0.155 0.040s0.107 0.030 0.163 0.045c0.028 0.008 0.056 0.015 0.084 0.024s0.057 0.019 0.086 0.028 0.116 0.038 0.176 0.058c0.015 0.005 0.030 0.010 0.045 0.015s0.030 0.012 0.045 0.017 0.060 0.023 0.091 0.035 0.123 0.048 0.186 0.073c0.062 0.028 0.125 0.056 0.189 0.084 0.032 0.014 0.064 0.028 0.096 0.043s0.064 0.032 0.096 0.048 0.128 0.065 0.194 0.098c0.065 0.034 0.129 0.073 0.194 0.109 0.032 0.018 0.065 0.037 0.098 0.056s0.064 0.040 0.096 0.061 0.129 0.082 0.194 0.124c0.255 0.176 0.506 0.369 0.744 0.583 0.236 0.217 0.459 0.451 0.665 0.697 0.202 0.25 0.385 0.511 0.547 0.776 0.159 0.268 0.294 0.541 0.41 0.808 0.027 0.068 0.053 0.135 0.079 0.202 0.013 0.033 0.027 0.066 0.038 0.099s0.022 0.067 0.033 0.1 0.045 0.131 0.065 0.196c0.018 0.065 0.036 0.13 0.054 0.194 0.009 0.032 0.019 0.063 0.026 0.095s0.014 0.063 0.021 0.094 0.028 0.123 0.042 0.184c0.011 0.061 0.021 0.12 0.032 0.179 0.005 0.029 0.010 0.058 0.015 0.087 0.003 0.014 0.005 0.029 0.008 0.043s0.003 0.029 0.005 0.043c0.007 0.056 0.014 0.112 0.020 0.166 0.003 0.027 0.007 0.053 0.010 0.080s0.004 0.053 0.006 0.078 0.007 0.102 0.011 0.15c0.003 0.049 0.008 0.095 0.008 0.142 0.002 0.091 0.004 0.177 0.006 0.256-0.003 0.073-0.005 0.14-0.007 0.2-0.001 0.030-0.002 0.058-0.002 0.085-0.002 0.033-0.004 0.064-0.006 0.093-0.002 0.033-0.004 0.063-0.006 0.091-0.008 0.051-0.012 0.103-0.012 0.156 0 0.007 0 0.015 0.001 0.022-0 0.002-0 0.004-0 0.004h0c0.012 0.481 0.363 0.877 0.823 0.959-0.001 0.005-0.002 0.009-0.003 0.014-0.010 0.051-0.025 0.102-0.040 0.155s-0.030 0.107-0.045 0.163c-0.008 0.028-0.015 0.056-0.024 0.084s-0.019 0.057-0.028 0.086-0.039 0.116-0.058 0.176c-0.005 0.015-0.010 0.030-0.015 0.045s-0.012 0.030-0.017 0.045-0.023 0.060-0.035 0.091-0.048 0.123-0.073 0.186c-0.028 0.062-0.056 0.125-0.084 0.189-0.014 0.032-0.028 0.064-0.043 0.096s-0.032 0.064-0.048 0.096-0.065 0.128-0.098 0.194c-0.034 0.065-0.073 0.129-0.109 0.194-0.018 0.032-0.037 0.065-0.056 0.098s-0.040 0.064-0.061 0.096-0.082 0.129-0.124 0.194c-0.176 0.255-0.369 0.506-0.583 0.744-0.217 0.236-0.451 0.459-0.697 0.665-0.25 0.202-0.511 0.385-0.776 0.547-0.268 0.159-0.541 0.294-0.808 0.41-0.068 0.027-0.135 0.053-0.202 0.079-0.033 0.013-0.066 0.027-0.099 0.038s-0.067 0.022-0.1 0.033-0.131 0.045-0.196 0.065c-0.065 0.018-0.13 0.036-0.194 0.054-0.032 0.009-0.063 0.019-0.095 0.026s-0.063 0.014-0.094 0.021-0.123 0.028-0.184 0.042c-0.061 0.011-0.12 0.021-0.179 0.032-0.029 0.005-0.058 0.010-0.087 0.015-0.014 0.003-0.028 0.005-0.043 0.008s-0.029 0.003-0.043 0.005c-0.056 0.007-0.112 0.014-0.166 0.020-0.027 0.003-0.053 0.007-0.080 0.010s-0.053 0.004-0.078 0.006-0.102 0.007-0.15 0.011c-0.049 0.003-0.095 0.008-0.142 0.008-0.091 0.002-0.177 0.004-0.256 0.006-0.073-0.003-0.14-0.005-0.2-0.007-0.030-0.001-0.058-0.002-0.085-0.002-0.033-0.002-0.064-0.004-0.093-0.006-0.033-0.002-0.063-0.004-0.091-0.006-0.051-0.008-0.103-0.012-0.156-0.012-0.007 0-0.015 0-0.022 0.001-0.002-0-0.003-0-0.003-0v0c-0.484 0.012-0.883 0.369-0.961 0.834-0.050-0.010-0.101-0.025-0.153-0.039s-0.107-0.030-0.163-0.045c-0.028-0.008-0.056-0.015-0.084-0.024s-0.057-0.019-0.086-0.028-0.116-0.039-0.176-0.058c-0.015-0.005-0.030-0.010-0.045-0.015s-0.030-0.012-0.045-0.017-0.060-0.023-0.091-0.035-0.123-0.048-0.186-0.073c-0.062-0.028-0.125-0.056-0.189-0.084-0.032-0.014-0.064-0.028-0.096-0.043s-0.064-0.032-0.096-0.048-0.128-0.065-0.194-0.098c-0.065-0.034-0.129-0.073-0.194-0.109-0.032-0.018-0.065-0.037-0.098-0.056s-0.064-0.040-0.096-0.061c-0.064-0.041-0.129-0.082-0.194-0.124-0.255-0.175-0.506-0.369-0.744-0.583-0.236-0.217-0.459-0.451-0.665-0.697-0.202-0.25-0.385-0.511-0.547-0.776-0.159-0.268-0.294-0.541-0.41-0.808-0.027-0.068-0.053-0.135-0.079-0.202-0.013-0.033-0.027-0.066-0.038-0.099s-0.022-0.067-0.033-0.1-0.045-0.131-0.065-0.196c-0.018-0.065-0.036-0.13-0.054-0.194-0.009-0.032-0.019-0.063-0.026-0.095s-0.014-0.063-0.021-0.094-0.028-0.123-0.042-0.184c-0.011-0.061-0.021-0.12-0.032-0.179-0.005-0.029-0.010-0.058-0.015-0.087-0.003-0.014-0.005-0.028-0.008-0.043s-0.003-0.029-0.005-0.043c-0.007-0.056-0.014-0.112-0.020-0.166-0.003-0.027-0.007-0.053-0.010-0.080s-0.004-0.053-0.006-0.078-0.007-0.101-0.011-0.15c-0.003-0.049-0.008-0.095-0.008-0.142-0.002-0.091-0.004-0.177-0.006-0.256 0.003-0.073 0.005-0.14 0.007-0.2 0.001-0.030 0.002-0.058 0.002-0.085 0.002-0.033 0.004-0.064 0.006-0.093 0.002-0.033 0.004-0.063 0.006-0.091 0.008-0.051 0.012-0.103 0.012-0.156 0-0.007-0-0.015-0.001-0.022 0-0.002 0-0.003 0-0.003h-0c-0.012-0.49-0.377-0.893-0.851-0.964z" })
        );
    }
    function Spinner10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner10.SVG = Spinner10SVG;
    return Spinner10;
})();
export const Spinner11 = /*#__PURE__*/ (() => {
    function Spinner11SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z" })
        );
    }
    function Spinner11({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spinner11SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spinner11.SVG = Spinner11SVG;
    return Spinner11;
})();
export const Microscope = /*#__PURE__*/ (() => {
    function MicroscopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 14.5c-0.811 0-1.587-0.15-2.303-0.422-0.435 0.521-0.697 1.191-0.697 1.922h6c0-0.731-0.262-1.401-0.697-1.922-0.716 0.272-1.493 0.422-2.303 0.422zM10 9v2h1.354c-0.056 0.062-0.113 0.123-0.172 0.182-0.85 0.85-1.98 1.318-3.182 1.318s-2.332-0.468-3.182-1.318c-0.85-0.85-1.318-1.98-1.318-3.182 0-1.135 0.448-2.236 1.212-3.069l3.674 2.858 1.228-1.579-7.985-6.211-1.629 1.267 3.525 2.742c-0.93 1.057-1.525 2.474-1.525 3.992 0 3.314 2.686 6 6 6 2.221 0 4.16-1.207 5.197-3h2.803v-2h-6z" })
        );
    }
    function Microscope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MicroscopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Microscope.SVG = MicroscopeSVG;
    return Microscope;
})();
export const Binoculars = /*#__PURE__*/ (() => {
    function BinocularsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 0h6v1h-6zM9 0h6v1h-6zM14.875 5h-0.875v-4h-4v4h-4v-4h-4v4h-0.875c-0.619 0-1.125 0.506-1.125 1.125v8.75c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-5.875h2v5.875c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-8.75c0-0.619-0.506-1.125-1.125-1.125zM5.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5zM8.5 8h-1c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM14.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5z" })
        );
    }
    function Binoculars({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BinocularsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Binoculars.SVG = BinocularsSVG;
    return Binoculars;
})();
export const Binoculars2 = /*#__PURE__*/ (() => {
    function Binoculars2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 7h-1l-1-5h-1.25l0.25-2h-3l0.25 2h-2.5l0.25-2h-3l0.25 2h-1.25l-1 5h-1l-1 8v1h6v-9h1v-1h2v1h1v9h6v-1z" })
        );
    }
    function Binoculars2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Binoculars2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Binoculars2.SVG = Binoculars2SVG;
    return Binoculars2;
})();
export const Search = /*#__PURE__*/ (() => {
    function SearchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z" })
        );
    }
    function Search({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SearchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search.SVG = SearchSVG;
    return Search;
})();
export const ZoomIn = /*#__PURE__*/ (() => {
        function ZoomInSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z" }),
_('path', { d: "M9 5h-2v-2h-2v2h-2v2h2v2h2v-2h2z" })
            );
        }
        function ZoomIn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ZoomInSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ZoomIn.SVG = ZoomInSVG;
        return ZoomIn;
    })();
export const ZoomOut = /*#__PURE__*/ (() => {
        function ZoomOutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 13.5l-4.695-4.695c0.444-0.837 0.695-1.792 0.695-2.805 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.013 0 1.968-0.252 2.805-0.695l4.695 4.695 2.5-2.5zM2 6c0-2.209 1.791-4 4-4s4 1.791 4 4-1.791 4-4 4-4-1.791-4-4z" }),
_('path', { d: "M3 5h6v2h-6v-2z" })
            );
        }
        function ZoomOut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ZoomOutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ZoomOut.SVG = ZoomOutSVG;
        return ZoomOut;
    })();
export const Search2 = /*#__PURE__*/ (() => {
    function Search2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.962 8.716c0.653-0.905 1.038-2.015 1.038-3.216 0-3.038-2.462-5.5-5.5-5.5s-5.5 2.462-5.5 5.5 2.462 5.5 5.5 5.5c1.201 0 2.312-0.385 3.216-1.038l5.284 6.038 2-2-6.038-5.284zM5.5 9.5c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4z" })
        );
    }
    function Search2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Search2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search2.SVG = Search2SVG;
    return Search2;
})();
export const ZoomIn2 = /*#__PURE__*/ (() => {
    function ZoomIn2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 3h-1v2h-2v1h2v2h1v-2h2v-1h-2zM9.962 8.716c0.653-0.905 1.038-2.015 1.038-3.216 0-3.038-2.462-5.5-5.5-5.5s-5.5 2.462-5.5 5.5 2.462 5.5 5.5 5.5c1.201 0 2.312-0.385 3.216-1.038l5.284 6.038 2-2-6.038-5.284zM5.5 9.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" })
        );
    }
    function ZoomIn2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZoomIn2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZoomIn2.SVG = ZoomIn2SVG;
    return ZoomIn2;
})();
export const ZoomOut2 = /*#__PURE__*/ (() => {
    function ZoomOut2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 5h5v1h-5zM9.962 8.716c0.653-0.905 1.038-2.015 1.038-3.216 0-3.038-2.462-5.5-5.5-5.5s-5.5 2.462-5.5 5.5 2.462 5.5 5.5 5.5c1.201 0 2.312-0.385 3.216-1.038l5.284 6.038 2-2-6.038-5.284zM5.5 9.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" })
        );
    }
    function ZoomOut2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZoomOut2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZoomOut2.SVG = ZoomOut2SVG;
    return ZoomOut2;
})();
export const Search3 = /*#__PURE__*/ (() => {
    function Search3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" })
        );
    }
    function Search3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Search3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search3.SVG = Search3SVG;
    return Search3;
})();
export const Search4 = /*#__PURE__*/ (() => {
    function Search4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM8.977 9.125h-5.954c-0.084-0.080-0.165-0.164-0.243-0.25h6.439c-0.078 0.086-0.158 0.17-0.243 0.25zM4.736 10.125c-0.219-0.067-0.431-0.151-0.634-0.25h3.796c-0.203 0.099-0.415 0.183-0.634 0.25h-2.529zM3.659 9.625c-0.12-0.078-0.236-0.161-0.348-0.25h5.378c-0.112 0.089-0.228 0.172-0.348 0.25h-4.682zM2.573 8.625c-0.062-0.081-0.122-0.165-0.179-0.25h7.211c-0.057 0.085-0.116 0.169-0.179 0.25h-6.854zM2.241 8.125c-0.046-0.082-0.090-0.165-0.132-0.25h7.782c-0.041 0.085-0.085 0.168-0.132 0.25h-7.519zM1.998 7.625c-0.033-0.082-0.065-0.165-0.093-0.25h8.19c-0.028 0.085-0.060 0.168-0.093 0.25h-8.004zM1.829 7.125c-0.022-0.082-0.042-0.166-0.060-0.25h8.461c-0.017 0.084-0.037 0.168-0.060 0.25h-8.341zM1.681 6c0-0.042 0.001-0.083 0.002-0.125h8.635c0.001 0.042 0.002 0.083 0.002 0.125s-0.001 0.083-0.002 0.125h-8.635c-0.001-0.042-0.002-0.083-0.002-0.125zM3.023 2.875h5.954c0.084 0.080 0.165 0.163 0.243 0.25h-6.439c0.078-0.087 0.158-0.17 0.243-0.25zM7.264 1.875c0.219 0.067 0.431 0.151 0.634 0.25h-3.796c0.203-0.099 0.415-0.183 0.634-0.25h2.529zM8.341 2.375c0.12 0.078 0.236 0.161 0.348 0.25h-5.378c0.112-0.089 0.228-0.172 0.348-0.25h4.682zM9.427 3.375c0.062 0.081 0.122 0.164 0.179 0.25h-7.211c0.057-0.086 0.116-0.169 0.179-0.25h6.854zM9.759 3.875c0.046 0.082 0.090 0.165 0.132 0.25h-7.782c0.041-0.085 0.085-0.168 0.132-0.25h7.519zM10.002 4.375c0.034 0.082 0.065 0.165 0.093 0.25h-8.19c0.028-0.085 0.060-0.168 0.093-0.25h8.004zM10.171 4.875c0.022 0.082 0.042 0.166 0.060 0.25h-8.461c0.017-0.084 0.038-0.168 0.060-0.25h8.341zM10.274 5.375c0.012 0.083 0.022 0.166 0.029 0.25h-8.606c0.007-0.084 0.017-0.167 0.029-0.25h8.548zM10.303 6.375c-0.007 0.084-0.017 0.167-0.029 0.25h-8.548c-0.012-0.083-0.022-0.166-0.029-0.25h8.606z" })
        );
    }
    function Search4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Search4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search4.SVG = Search4SVG;
    return Search4;
})();
export const ZoomIn3 = /*#__PURE__*/ (() => {
    function ZoomIn3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z" })
        );
    }
    function ZoomIn3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZoomIn3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZoomIn3.SVG = ZoomIn3SVG;
    return ZoomIn3;
})();
export const ZoomOut3 = /*#__PURE__*/ (() => {
    function ZoomOut3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM3 5h6v2h-6z" })
        );
    }
    function ZoomOut3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ZoomOut3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ZoomOut3.SVG = ZoomOut3SVG;
    return ZoomOut3;
})();
export const Search5 = /*#__PURE__*/ (() => {
    function Search5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 0c2.761 0 5 2.239 5 5 0 1.019-0.305 1.967-0.829 2.758 0-0 0-0 0-0.001l1.099 1.099c0.545-0.3 1.058-0.357 1.319-0.095l4.243 4.243c0.391 0.391 0.074 1.34-0.707 2.121s-1.731 1.098-2.121 0.707l-4.243-4.243c-0.262-0.262-0.206-0.774 0.095-1.319l-1.099-1.099c0.001-0.001 0.001-0.001 0.002-0.001-0.791 0.524-1.739 0.83-2.759 0.83-2.761 0-5-2.239-5-5s2.239-5 5-5zM2.172 7.828c0.756 0.756 1.76 1.172 2.828 1.172s2.073-0.416 2.828-1.172c0.756-0.755 1.172-1.76 1.172-2.828s-0.416-2.073-1.172-2.828c-0.756-0.756-1.76-1.172-2.828-1.172s-2.073 0.416-2.828 1.172c-0.756 0.756-1.172 1.76-1.172 2.828s0.416 2.073 1.172 2.828zM8 5c0 0.45-0.099 0.877-0.277 1.26-0.227-2.093-1.889-3.756-3.983-3.983 0.383-0.177 0.81-0.277 1.26-0.277 1.657 0 3 1.343 3 3z" })
        );
    }
    function Search5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Search5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search5.SVG = Search5SVG;
    return Search5;
})();
export const Search6 = /*#__PURE__*/ (() => {
    function Search6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.772 14.748l-3.975-5.84c-0.104-0.154-0.32-0.201-0.479-0.106l-0.502 0.302c-0.159 0.095-0.219 0.308-0.132 0.472l3.29 6.252c0.086 0.164 0.287 0.221 0.446 0.125l1.253-0.753c0.159-0.095 0.204-0.299 0.099-0.452zM9.26 8.314c1.503-0.958 1.568-3.454 0.148-5.684-1.207-1.895-3.043-2.898-4.49-2.569-0.333 0.065-0.758 0.243-1.185 0.515s-0.769 0.583-0.968 0.857c-0.91 1.172-0.777 3.259 0.431 5.154 1.42 2.23 3.71 3.226 5.214 2.268l0.851-0.542zM8.718 7.463c-0.992 0.632-2.742-0.265-3.82-1.96s-1.153-3.658-0.161-4.29c0.991-0.632 2.741 0.266 3.82 1.96s1.152 3.658 0.161 4.29z" })
        );
    }
    function Search6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Search6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Search6.SVG = Search6SVG;
    return Search6;
})();
export const Enlarge = /*#__PURE__*/ (() => {
        function EnlargeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 5h-2v-4c0-0.552 0.448-1 1-1h4v2h-3v3z" }),
_('path', { d: "M16 5h-2v-3h-3v-2h4c0.552 0 1 0.448 1 1v4z" }),
_('path', { d: "M15 16h-4v-2h3v-3h2v4c0 0.552-0.448 1-1 1z" }),
_('path', { d: "M5 16h-4c-0.552 0-1-0.448-1-1v-4h2v3h3v2z" })
            );
        }
        function Enlarge({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnlargeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enlarge.SVG = EnlargeSVG;
        return Enlarge;
    })();
export const Shrink = /*#__PURE__*/ (() => {
        function ShrinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 0h2v4c0 0.552-0.448 1-1 1h-4v-2h3v-3z" }),
_('path', { d: "M11 0h2v3h3v2h-4c-0.552 0-1-0.448-1-1v-4z" }),
_('path', { d: "M12 11h4v2h-3v3h-2v-4c0-0.552 0.448-1 1-1z" }),
_('path', { d: "M0 11h4c0.552 0 1 0.448 1 1v4h-2v-3h-3v-2z" })
            );
        }
        function Shrink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShrinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink.SVG = ShrinkSVG;
        return Shrink;
    })();
export const Enlarge2 = /*#__PURE__*/ (() => {
        function Enlarge2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z" }),
_('path', { d: "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z" }),
_('path', { d: "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z" }),
_('path', { d: "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z" })
            );
        }
        function Enlarge2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Enlarge2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enlarge2.SVG = Enlarge2SVG;
        return Enlarge2;
    })();
export const Shrink2 = /*#__PURE__*/ (() => {
        function Shrink2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 7h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z" }),
_('path', { d: "M9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z" }),
_('path', { d: "M7 9h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z" }),
_('path', { d: "M7 7v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z" })
            );
        }
        function Shrink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shrink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink2.SVG = Shrink2SVG;
        return Shrink2;
    })();
export const Enlarge3 = /*#__PURE__*/ (() => {
    function Enlarge3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM15 15h-14v-14h14v14zM10.5 2.5l4.5-1.5-1.5 4.5zM5.25 4h0.5v1h-0.5zM6.25 4h0.5v1h-0.5zM7.25 4h0.5v1h-0.5zM8.25 4h0.5v1h-0.5zM9.25 4h0.5v1h-0.5zM10.25 4h0.5v1h-0.5zM5.25 11h0.5v1h-0.5zM6.25 11h0.5v1h-0.5zM7.25 11h0.5v1h-0.5zM8.25 11h0.5v1h-0.5zM9.25 11h0.5v1h-0.5zM10.25 11h0.5v1h-0.5zM4 10.25h1v0.5h-1zM4 9.25h1v0.5h-1zM4 8.25h1v0.5h-1zM4 7.25h1v0.5h-1zM4 6.25h1v0.5h-1zM4 5.25h1v0.5h-1zM11 10.25h1v0.5h-1zM11 9.25h1v0.5h-1zM11 8.25h1v0.5h-1zM11 7.25h1v0.5h-1zM11 6.25h1v0.5h-1zM11 5.25h1v0.5h-1zM2.5 5.5l-1.5-4.5 4.5 1.5zM5.5 13.5l-4.5 1.5 1.5-4.5zM13.5 10.5l1.5 4.5-4.5-1.5z" })
        );
    }
    function Enlarge3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enlarge3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enlarge3.SVG = Enlarge3SVG;
    return Enlarge3;
})();
export const Shrink3 = /*#__PURE__*/ (() => {
    function Shrink3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 4.5l-4.5 1.5 1.5-4.5zM8.25 0h0.5v1h-0.5zM9.25 0h0.5v1h-0.5zM10.25 0h0.5v1h-0.5zM11.25 0h0.5v1h-0.5zM12.25 0h0.5v1h-0.5zM13.25 0h0.5v1h-0.5zM14.281 0h0.5v1h-0.5zM2.25 0h0.5v1h-0.5zM3.25 0h0.5v1h-0.5zM4.25 0h0.5v1h-0.5zM5.25 0h0.5v1h-0.5zM6.25 0h0.5v1h-0.5zM7.25 0h0.5v1h-0.5zM4.5 1.5l1.5 4.5-4.5-1.5zM1.5 11.5l4.5-1.5-1.5 4.5zM11.5 14.5l-1.5-4.5 4.5 1.5zM1.25 0h0.5v1h-0.5zM8.25 15h0.5v1h-0.5zM9.25 15h0.5v1h-0.5zM10.25 15h0.5v1h-0.5zM11.25 15h0.5v1h-0.5zM12.25 15h0.5v1h-0.5zM13.25 15h0.5v1h-0.5zM14.281 15h0.5v1h-0.5zM2.25 15h0.5v1h-0.5zM3.25 15h0.5v1h-0.5zM4.25 15h0.5v1h-0.5zM5.25 15h0.5v1h-0.5zM6.25 15h0.5v1h-0.5zM7.25 15h0.5v1h-0.5zM1.25 15h0.5v1h-0.5zM0.016 7.266h1v0.5h-1zM0.016 6.266h1v0.5h-1zM0.016 5.266h1v0.5h-1zM0.016 4.266h1v0.5h-1zM0.016 3.266h1v0.5h-1zM0.016 2.266h1v0.5h-1zM0.016 1.234h1v0.5h-1zM0.016 13.266h1v0.5h-1zM0.016 12.266h1v0.5h-1zM0.016 11.266h1v0.5h-1zM0.016 10.266h1v0.5h-1zM0.016 9.266h1v0.5h-1zM0.016 8.266h1v0.5h-1zM0.016 14.266h1v0.5h-1zM15.016 7.266h1v0.5h-1zM15.016 6.266h1v0.5h-1zM15.016 5.266h1v0.5h-1zM15.016 4.266h1v0.5h-1zM15.016 3.266h1v0.5h-1zM15.016 2.266h1v0.5h-1zM15.016 1.234h1v0.5h-1zM15.016 13.266h1v0.5h-1zM15.016 12.266h1v0.5h-1zM15.016 11.266h1v0.5h-1zM15.016 10.266h1v0.5h-1zM15.016 9.266h1v0.5h-1zM15.016 8.266h1v0.5h-1zM15.016 14.266h1v0.5h-1zM10 6h-4v4h4v-4zM11 5v0 6h-6v-6h6z" })
        );
    }
    function Shrink3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shrink3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shrink3.SVG = Shrink3SVG;
    return Shrink3;
})();
export const Enlarge4 = /*#__PURE__*/ (() => {
        function Enlarge4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 5.5v-5.5h-5.5z" }),
_('path', { d: "M5.5 0h-5.5v5.5z" }),
_('path', { d: "M16 16v-5.5l-5.5 5.5z" }),
_('path', { d: "M0 16h5.5l-5.5-5.5z" })
            );
        }
        function Enlarge4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Enlarge4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enlarge4.SVG = Enlarge4SVG;
        return Enlarge4;
    })();
export const Shrink4 = /*#__PURE__*/ (() => {
        function Shrink4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 0.5v5.5h5.5z" }),
_('path', { d: "M0.5 6h5.5v-5.5z" }),
_('path', { d: "M10 10v5.5l5.5-5.5z" }),
_('path', { d: "M6 10h-5.5l5.5 5.5z" })
            );
        }
        function Shrink4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shrink4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink4.SVG = Shrink4SVG;
        return Shrink4;
    })();
export const Enlarge5 = /*#__PURE__*/ (() => {
    function Enlarge5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v15h15v-15h-15zM14 15h-13v-13h13v13zM12.75 3.25h-10.5v10.5h10.5v-10.5zM12.25 13.25h-9.5v-9.5h9.5v9.5zM7 9h-2v-1h2v-2h1v2h2v1h-2v2h-1z" })
        );
    }
    function Enlarge5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enlarge5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enlarge5.SVG = Enlarge5SVG;
    return Enlarge5;
})();
export const Shrink5 = /*#__PURE__*/ (() => {
    function Shrink5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 4h-9v9h9v-9zM11 12h-7v-7h7v7zM1.25 2.25v12.5h12.5v-12.5h-12.5zM13.25 14.25h-11.5v-11.5h11.5v11.5zM5 8h5v1h-5z" })
        );
    }
    function Shrink5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shrink5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shrink5.SVG = Shrink5SVG;
    return Shrink5;
})();
export const Enlarge6 = /*#__PURE__*/ (() => {
        function Enlarge6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0v16h16v-16h-16zM15 8v7h-14v-14h14v7z" }),
_('path', { d: "M14 2h-4.5l4.5 4.5z" }),
_('path', { d: "M2 14v-4.5l4.5 4.5z" })
            );
        }
        function Enlarge6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Enlarge6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enlarge6.SVG = Enlarge6SVG;
        return Enlarge6;
    })();
export const Shrink6 = /*#__PURE__*/ (() => {
        function Shrink6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0v16h16v-16h-16zM15 8v7h-14v-14h14v7z" }),
_('path', { d: "M10 6h4.5l-4.5-4.5z" }),
_('path', { d: "M6 10v4.5l-4.5-4.5z" })
            );
        }
        function Shrink6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shrink6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shrink6.SVG = Shrink6SVG;
        return Shrink6;
    })();
export const Enlarge7 = /*#__PURE__*/ (() => {
    function Enlarge7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 0v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM7 10.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z" })
        );
    }
    function Enlarge7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enlarge7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enlarge7.SVG = Enlarge7SVG;
    return Enlarge7;
})();
export const Shrink7 = /*#__PURE__*/ (() => {
    function Shrink7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 9v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM16 1.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z" })
        );
    }
    function Shrink7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shrink7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shrink7.SVG = Shrink7SVG;
    return Shrink7;
})();
export const Key = /*#__PURE__*/ (() => {
    function KeySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 0c-2.761 0-5 2.239-5 5 0 0.313 0.029 0.619 0.084 0.916l-6.084 6.084v3c0 0.552 0.448 1 1 1h1v-1h2v-2h2v-2h2l1.298-1.298c0.531 0.192 1.105 0.298 1.702 0.298 2.761 0 5-2.239 5-5s-2.239-5-5-5zM12.498 5.002c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function Key({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key.SVG = KeySVG;
    return Key;
})();
export const Key2 = /*#__PURE__*/ (() => {
    function Key2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.658 4.91l-1.58-1.58c-0.387-0.387-1.021-1.021-1.409-1.409l-1.58-1.58c-0.387-0.387-1.077-0.456-1.533-0.152l-4.319 2.88c-0.456 0.304-0.628 0.954-0.383 1.444l1.101 2.203c0.034 0.067 0.073 0.139 0.115 0.213l-5.571 5.571-0.5 3.5h3v-1h2v-2h2v-2h2v-1.112c0.1 0.060 0.196 0.113 0.284 0.157l2.203 1.101c0.49 0.245 1.14 0.072 1.444-0.383l2.88-4.319c0.304-0.456 0.236-1.146-0.152-1.533zM2.354 13.354l-0.707-0.707 4.868-4.868 0.707 0.707-4.868 4.868zM14.328 6.621l-0.707 0.707c-0.194 0.194-0.513 0.194-0.707 0l-4.243-4.243c-0.194-0.194-0.194-0.513 0-0.707l0.707-0.707c0.194-0.194 0.513-0.194 0.707 0l4.243 4.243c0.194 0.194 0.194 0.513 0 0.707z" })
        );
    }
    function Key2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Key2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key2.SVG = Key2SVG;
    return Key2;
})();
export const Key3 = /*#__PURE__*/ (() => {
    function Key3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.438 0c-2.516 0-4.563 2.047-4.563 4.563 0 1.056 0.36 2.029 0.965 2.802l-6.675 6.675c-0.22 0.22-0.22 0.576 0 0.795 0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165l2.040-2.040 1.205 1.204-1.040 1.040c-0.22 0.22-0.22 0.576 0 0.795 0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165l2.875-2.875c0.22-0.22 0.22-0.576 0-0.795s-0.576-0.22-0.795 0l-1.040 1.040-1.204-1.205 3.84-3.84c0.774 0.604 1.747 0.965 2.802 0.965 2.516 0 4.563-2.047 4.563-4.563s-2.047-4.563-4.563-4.563zM11.438 8c-1.895 0-3.438-1.542-3.438-3.438s1.542-3.438 3.438-3.438c1.895 0 3.438 1.542 3.438 3.438s-1.542 3.438-3.438 3.438z" })
        );
    }
    function Key3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Key3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key3.SVG = Key3SVG;
    return Key3;
})();
export const Key4 = /*#__PURE__*/ (() => {
    function Key4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.438 0c-2.516 0-4.563 2.047-4.563 4.563 0 1.056 0.36 2.029 0.965 2.802l-6.675 6.675c-0.22 0.22-0.22 0.576 0 0.795 0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165l0.54-0.54 1.54 1.54c0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165c0.22-0.22 0.22-0.576 0-0.795l-1.54-1.54 1.204-1.204 1.54 1.54c0.11 0.11 0.254 0.165 0.398 0.165s0.288-0.055 0.398-0.165c0.22-0.22 0.22-0.576 0-0.795l-1.54-1.54 3.34-3.34c0.774 0.604 1.747 0.965 2.802 0.965 2.516 0 4.562-2.047 4.562-4.563s-2.047-4.563-4.563-4.563zM11.438 8c-1.895 0-3.438-1.542-3.438-3.438s1.542-3.438 3.438-3.438 3.438 1.542 3.438 3.438-1.542 3.438-3.438 3.438z" })
        );
    }
    function Key4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Key4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key4.SVG = Key4SVG;
    return Key4;
})();
export const Key5 = /*#__PURE__*/ (() => {
    function Key5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 6h-7.535c-0.692-1.196-1.984-2-3.465-2-2.209 0-4 1.791-4 4s1.791 4 4 4c1.481 0 2.773-0.804 3.465-2h0.535l1-1h1v1h1l1-1h1v1h1l2-2-1-2zM3 9.414c-0.781 0-1.414-0.633-1.414-1.414s0.633-1.414 1.414-1.414 1.414 0.633 1.414 1.414c0 0.781-0.633 1.414-1.414 1.414zM8 7.5v-0.5h6l0.25 0.5h-6.25z" })
        );
    }
    function Key5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Key5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Key5.SVG = Key5SVG;
    return Key5;
})();
export const Keyhole = /*#__PURE__*/ (() => {
    function KeyholeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 4c0-2.209-1.791-4-4-4s-4 1.791-4 4c0 1.529 0.857 2.857 2.117 3.53l-2.118 8.47h8l-2.117-8.47c1.26-0.673 2.117-2.001 2.117-3.53z" })
        );
    }
    function Keyhole({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyholeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Keyhole.SVG = KeyholeSVG;
    return Keyhole;
})();
export const Lock = /*#__PURE__*/ (() => {
    function LockSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 6h-1v-5c0-0.55-0.45-1-1-1h-8c-0.55 0-1 0.45-1 1v5h-1c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM9 13h-2l0.435-2.175c-0.263-0.18-0.435-0.482-0.435-0.825 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.343-0.172 0.645-0.435 0.825l0.435 2.175zM11 6h-6v-4h6v4z" })
        );
    }
    function Lock({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LockSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock.SVG = LockSVG;
    return Lock;
})();
export const Lock2 = /*#__PURE__*/ (() => {
    function Lock2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 7h-1v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-1c-0.55 0-1 0.45-1 1v7c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-7c0-0.55-0.45-1-1-1zM8 13c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM10 7h-4v-3c0-1.103 0.897-2 2-2s2 0.897 2 2v3z" })
        );
    }
    function Lock2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lock2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock2.SVG = Lock2SVG;
    return Lock2;
})();
export const Lock3 = /*#__PURE__*/ (() => {
    function Lock3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 7h-1v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-1c-0.55 0-1 0.45-1 1v7c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-7c0-0.55-0.45-1-1-1zM6 4c0-1.103 0.897-2 2-2s2 0.897 2 2v3h-4v-3zM13 10l-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 5 0.5-5 0.5 4.998 0.5c-0 0-0 0-0 0h-9.996c-0-0-0-0-0-0l4.998-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-5-0.5 5-0.5-4.998-0.5c0-0 0-0 0-0h9.996c0 0 0 0 0 0l-4.998 0.5 5 0.5-5 0.5 5 0.5z" })
        );
    }
    function Lock3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lock3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock3.SVG = Lock3SVG;
    return Lock3;
})();
export const Lock4 = /*#__PURE__*/ (() => {
    function Lock4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z" })
        );
    }
    function Lock4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lock4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock4.SVG = Lock4SVG;
    return Lock4;
})();
export const Unlocked = /*#__PURE__*/ (() => {
    function UnlockedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z" })
        );
    }
    function Unlocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UnlockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Unlocked.SVG = UnlockedSVG;
    return Unlocked;
})();
export const Lock5 = /*#__PURE__*/ (() => {
    function Lock5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM6 14h-2l0.435-2.175c-0.263-0.18-0.435-0.482-0.435-0.825 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.343-0.172 0.645-0.435 0.825l0.435 2.175zM7 7h-4v-3c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3z" })
        );
    }
    function Lock5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lock5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lock5.SVG = Lock5SVG;
    return Lock5;
})();
export const Unlocked2 = /*#__PURE__*/ (() => {
    function Unlocked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 1h-2c-1.654 0-3 1.346-3 3v3h-6.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h2v-3c0-1.654-1.346-3-3-3zM6 14h-2l0.435-2.175c-0.263-0.18-0.435-0.482-0.435-0.825 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.343-0.172 0.645-0.435 0.825l0.435 2.175z" })
        );
    }
    function Unlocked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Unlocked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Unlocked2.SVG = Unlocked2SVG;
    return Unlocked2;
})();
export const Safe = /*#__PURE__*/ (() => {
        function SafeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 0h-13c-0.552 0-1 0.448-1 1v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h0.5v4h-0.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h0.5v1c0 0.552 0.448 1 1 1h13c0.552 0 1-0.448 1-1v-14c0-0.552-0.448-1-1-1zM14 14h-11v-12h11v12z" }),
_('path', { d: "M10 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M4 3v10h9v-10h-9zM8.5 11c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z" })
            );
        }
        function Safe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SafeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Safe.SVG = SafeSVG;
        return Safe;
    })();
export const Wrench = /*#__PURE__*/ (() => {
    function WrenchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.671 12.779l-7.196-6.168c0.335-0.63 0.525-1.348 0.525-2.111 0-2.485-2.015-4.5-4.5-4.5-0.455 0-0.893 0.068-1.307 0.193l2.6 2.6c0.389 0.389 0.389 1.025 0 1.414l-1.586 1.586c-0.389 0.389-1.025 0.389-1.414 0l-2.6-2.6c-0.125 0.414-0.193 0.852-0.193 1.307 0 2.485 2.015 4.5 4.5 4.5 0.763 0 1.482-0.19 2.111-0.525l6.168 7.196c0.358 0.418 0.969 0.441 1.358 0.052l1.586-1.586c0.389-0.389 0.365-1-0.052-1.358z" })
        );
    }
    function Wrench({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WrenchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wrench.SVG = WrenchSVG;
    return Wrench;
})();
export const Wrench2 = /*#__PURE__*/ (() => {
    function Wrench2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.139 16c0 0 0 0 0 0-0.396 0-0.774-0.176-1.038-0.483l-5.534-6.456c-0.582 0.247-1.213 0.377-1.849 0.377-2.602 0-4.719-2.117-4.719-4.719 0-0.466 0.068-0.927 0.202-1.37l0.242-0.799 3.027 3.027c0.082 0.082 0.192 0.127 0.309 0.127s0.227-0.045 0.309-0.127l1.487-1.487c0.171-0.171 0.171-0.448 0-0.619l-3.027-3.027 0.799-0.242c0.443-0.134 0.904-0.202 1.37-0.202 2.602 0 4.719 2.117 4.719 4.719 0 0.635-0.129 1.267-0.377 1.849l6.456 5.534c0.296 0.254 0.468 0.604 0.482 0.986s-0.129 0.744-0.405 1.020l-1.487 1.487c-0.262 0.262-0.606 0.406-0.968 0.406zM6.817 7.815l6.043 7.051c0.074 0.086 0.173 0.134 0.278 0.134 0.068 0 0.168-0.020 0.261-0.113l1.487-1.487c0.077-0.077 0.117-0.174 0.113-0.275s-0.051-0.195-0.134-0.265l-7.051-6.043 0.188-0.354c0.284-0.533 0.434-1.136 0.434-1.744 0-2.051-1.668-3.719-3.719-3.719-0.065 0-0.13 0.002-0.194 0.005l1.76 1.76c0.56 0.56 0.56 1.472 0 2.033l-1.487 1.487c-0.271 0.271-0.632 0.42-1.016 0.42s-0.746-0.149-1.016-0.42l-1.76-1.76c-0.003 0.065-0.005 0.129-0.005 0.194 0 2.051 1.668 3.719 3.719 3.719 0.608 0 1.211-0.15 1.744-0.434l0.354-0.188z" })
        );
    }
    function Wrench2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wrench2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wrench2.SVG = Wrench2SVG;
    return Wrench2;
})();
export const Wrench3 = /*#__PURE__*/ (() => {
    function Wrench3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.129 0.629l1.871 1.871-2 2-1.871-1.871c-0.084 0.276-0.129 0.568-0.129 0.871 0 1.657 1.343 3 3 3 0.303 0 0.596-0.045 0.871-0.129l5.757 5.757c-0.084 0.276-0.129 0.568-0.129 0.871 0 1.657 1.343 3 3 3 0.303 0 0.596-0.045 0.871-0.129l-1.871-1.871 2-2 1.871 1.871c0.084-0.276 0.129-0.568 0.129-0.871 0-1.657-1.343-3-3-3-0.303 0-0.596 0.045-0.871 0.129l-5.757-5.757c0.084-0.276 0.129-0.568 0.129-0.871 0-1.657-1.343-3-3-3-0.303 0-0.596 0.045-0.871 0.129z" })
        );
    }
    function Wrench3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wrench3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wrench3.SVG = Wrench3SVG;
    return Wrench3;
})();
export const Equalizer = /*#__PURE__*/ (() => {
    function EqualizerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 2v-0.25c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.337-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9zM4 4v-2h2v2h-2zM13 6.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-9v2h9v0.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h3v-2h-3v-0.25zM10 9v-2h2v2h-2zM7 11.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.338-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9v-0.25zM4 14v-2h2v2h-2z" })
        );
    }
    function Equalizer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EqualizerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Equalizer.SVG = EqualizerSVG;
    return Equalizer;
})();
export const Equalizer2 = /*#__PURE__*/ (() => {
    function Equalizer2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z" })
        );
    }
    function Equalizer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Equalizer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Equalizer2.SVG = Equalizer2SVG;
    return Equalizer2;
})();
export const Equalizer3 = /*#__PURE__*/ (() => {
    function Equalizer3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.5 5h-2c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5zM3 2h1v2.5h-1zM3 7.5h1v6.5h-1zM8.5 9h-2c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5zM7 2h1v6.5h-1zM7 11.5h1v2.5h-1zM12.5 6h-2c-0.275 0-0.5 0.225-0.5 0.5v1c0 0.275 0.225 0.5 0.5 0.5h2c0.275 0 0.5-0.225 0.5-0.5v-1c0-0.275-0.225-0.5-0.5-0.5zM11 2h1v3.5h-1zM11 8.5h1v5.5h-1zM13.75 0h-12.5c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h12.5c0.689 0 1.25-0.561 1.25-1.25v-13.5c0-0.689-0.561-1.25-1.25-1.25zM14 14.75c0 0.137-0.113 0.25-0.25 0.25h-12.5c-0.137 0-0.25-0.113-0.25-0.25v-13.5c0-0.137 0.113-0.25 0.25-0.25h12.5c0.137 0 0.25 0.113 0.25 0.25v13.5z" })
        );
    }
    function Equalizer3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Equalizer3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Equalizer3.SVG = Equalizer3SVG;
    return Equalizer3;
})();
export const Equalizer4 = /*#__PURE__*/ (() => {
    function Equalizer4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM15 13.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002l-0 11.996zM6.75 11h-0.75v-8h-2v8h-0.75c-0.138 0-0.25 0.113-0.25 0.25v1.5c0 0.137 0.112 0.25 0.25 0.25h3.5c0.138 0 0.25-0.113 0.25-0.25v-1.5c0-0.137-0.112-0.25-0.25-0.25zM9.25 5h0.75v8h2v-8h0.75c0.137 0 0.25-0.112 0.25-0.25v-1.5c0-0.138-0.113-0.25-0.25-0.25h-3.5c-0.137 0-0.25 0.112-0.25 0.25v1.5c0 0.138 0.113 0.25 0.25 0.25z" })
        );
    }
    function Equalizer4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Equalizer4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Equalizer4.SVG = Equalizer4SVG;
    return Equalizer4;
})();
export const Cog = /*#__PURE__*/ (() => {
    function CogSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z" })
        );
    }
    function Cog({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CogSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cog.SVG = CogSVG;
    return Cog;
})();
export const Cogs = /*#__PURE__*/ (() => {
    function CogsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.683 11.282l0.645-0.903-0.707-0.707-0.903 0.645c-0.168-0.094-0.347-0.168-0.535-0.222l-0.183-1.095h-1l-0.183 1.095c-0.188 0.053-0.368 0.128-0.535 0.222l-0.903-0.645-0.707 0.707 0.645 0.903c-0.094 0.168-0.168 0.347-0.222 0.535l-1.095 0.183v1l1.095 0.183c0.053 0.188 0.128 0.368 0.222 0.535l-0.645 0.903 0.707 0.707 0.903-0.645c0.168 0.094 0.347 0.168 0.535 0.222l0.183 1.095h1l0.183-1.095c0.188-0.053 0.368-0.128 0.535-0.222l0.903 0.645 0.707-0.707-0.645-0.903c0.094-0.168 0.168-0.347 0.222-0.535l1.095-0.182v-1l-1.095-0.183c-0.053-0.188-0.128-0.368-0.222-0.535zM3.5 13.5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM16 6v-1l-1.053-0.191c-0.019-0.126-0.044-0.25-0.074-0.372l0.899-0.58-0.383-0.924-1.046 0.226c-0.066-0.108-0.136-0.213-0.211-0.315l0.609-0.88-0.707-0.707-0.88 0.609c-0.102-0.074-0.207-0.145-0.315-0.211l0.226-1.046-0.924-0.383-0.58 0.899c-0.122-0.030-0.246-0.054-0.372-0.074l-0.191-1.053h-1l-0.191 1.053c-0.126 0.019-0.25 0.044-0.372 0.074l-0.58-0.899-0.924 0.383 0.226 1.046c-0.108 0.066-0.213 0.136-0.315 0.211l-0.88-0.609-0.707 0.707 0.609 0.88c-0.074 0.102-0.145 0.207-0.211 0.315l-1.046-0.226-0.383 0.924 0.899 0.58c-0.030 0.122-0.054 0.246-0.074 0.372l-1.053 0.191v1l1.053 0.191c0.019 0.126 0.044 0.25 0.074 0.372l-0.899 0.58 0.383 0.924 1.046-0.226c0.066 0.108 0.136 0.213 0.211 0.315l-0.609 0.88 0.707 0.707 0.88-0.609c0.102 0.074 0.207 0.145 0.315 0.211l-0.226 1.046 0.924 0.383 0.58-0.899c0.122 0.030 0.246 0.054 0.372 0.074l0.191 1.053h1l0.191-1.053c0.126-0.019 0.25-0.044 0.372-0.074l0.58 0.899 0.924-0.383-0.226-1.046c0.108-0.066 0.213-0.136 0.315-0.211l0.88 0.609 0.707-0.707-0.609-0.88c0.074-0.102 0.145-0.207 0.211-0.315l1.046 0.226 0.383-0.924-0.899-0.58c0.030-0.122 0.054-0.246 0.074-0.372l1.053-0.191zM10.5 7.675c-1.201 0-2.175-0.974-2.175-2.175s0.974-2.175 2.175-2.175 2.175 0.974 2.175 2.175c0 1.201-0.974 2.175-2.175 2.175z" })
        );
    }
    function Cogs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CogsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cogs.SVG = CogsSVG;
    return Cogs;
})();
export const Cog2 = /*#__PURE__*/ (() => {
    function Cog2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9.501v-3.003l-2.293-0.382c-0.093-0.283-0.207-0.557-0.339-0.82l1.351-1.891-2.123-2.123-1.888 1.349c-0.264-0.134-0.54-0.248-0.825-0.342l-0.381-2.288h-3.003l-0.381 2.288c-0.285 0.094-0.56 0.209-0.824 0.342l-1.888-1.349-2.123 2.123 1.351 1.891c-0.132 0.263-0.246 0.537-0.339 0.82l-2.293 0.382v3.003l2.299 0.383c0.093 0.281 0.206 0.552 0.338 0.813l-1.355 1.898 2.123 2.123 1.901-1.358c0.259 0.13 0.53 0.243 0.809 0.335l0.384 2.304h3.003l0.384-2.304c0.279-0.092 0.549-0.204 0.809-0.335l1.901 1.358 2.123-2.123-1.355-1.898c0.132-0.261 0.245-0.532 0.338-0.813l2.299-0.383zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z" })
        );
    }
    function Cog2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cog2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cog2.SVG = Cog2SVG;
    return Cog2;
})();
export const Cog3 = /*#__PURE__*/ (() => {
    function Cog3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.893 16h-3.786l-0.381-2.288c-0.052-0.021-0.105-0.043-0.157-0.065l-1.887 1.348-2.677-2.677 1.346-1.884c-0.023-0.053-0.045-0.107-0.067-0.161l-2.283-0.381v-3.786l2.277-0.38c0.022-0.056 0.045-0.112 0.069-0.167l-1.342-1.878 2.677-2.677 1.875 1.339c0.057-0.025 0.114-0.048 0.172-0.071l0.379-2.272h3.786l0.379 2.272c0.058 0.023 0.115 0.047 0.172 0.071l1.875-1.339 2.677 2.677-1.342 1.878c0.024 0.055 0.047 0.111 0.069 0.167l2.277 0.38v3.786l-2.283 0.381c-0.022 0.054-0.044 0.108-0.067 0.161l1.346 1.884-2.677 2.677-1.887-1.348c-0.052 0.022-0.104 0.044-0.157 0.065l-0.381 2.288zM7.113 14.813h1.774l0.332-1.991 0.34-0.113c0.228-0.075 0.453-0.169 0.668-0.277l0.32-0.161 1.642 1.173 1.254-1.254-1.171-1.64 0.162-0.321c0.109-0.216 0.203-0.442 0.279-0.672l0.113-0.34 1.985-0.331v-1.774l-1.981-0.33-0.112-0.341c-0.076-0.232-0.17-0.46-0.28-0.678l-0.161-0.32 1.167-1.633-1.254-1.254-1.631 1.165-0.321-0.162c-0.219-0.111-0.448-0.206-0.681-0.283l-0.341-0.112-0.329-1.976h-1.774l-0.329 1.976-0.341 0.112c-0.233 0.077-0.462 0.172-0.681 0.283l-0.321 0.162-1.631-1.165-1.255 1.255 1.167 1.633-0.161 0.32c-0.11 0.218-0.204 0.446-0.28 0.678l-0.112 0.341-1.981 0.33v1.774l1.985 0.331 0.113 0.34c0.076 0.23 0.17 0.456 0.279 0.672l0.162 0.321-1.171 1.64 1.255 1.254 1.642-1.173 0.32 0.161c0.215 0.108 0.44 0.201 0.668 0.277l0.34 0.113 0.332 1.991zM8.5 6h-1c-0.825 0-1.5 0.675-1.5 1.5v1c0 0.825 0.675 1.5 1.5 1.5h1c0.825 0 1.5-0.675 1.5-1.5v-1c0-0.825-0.675-1.5-1.5-1.5zM9 8.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.275 0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5v1z" })
        );
    }
    function Cog3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cog3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cog3.SVG = Cog3SVG;
    return Cog3;
})();
export const Cog4 = /*#__PURE__*/ (() => {
    function Cog4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.5l-3.527-0.353 2.245-2.743-2.121-2.121-2.743 2.245-0.353-3.527h-3l-0.353 3.527-2.743-2.245-2.121 2.121 2.245 2.743-3.527 0.353v3l3.527 0.353-2.245 2.743 2.121 2.121 2.743-2.245 0.353 3.527h3l0.353-3.527 2.743 2.245 2.121-2.121-2.245-2.743 3.527-0.353v-3zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" })
        );
    }
    function Cog4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cog4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cog4.SVG = Cog4SVG;
    return Cog4;
})();
export const Cog5 = /*#__PURE__*/ (() => {
        function Cog5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 6.5l-3.527-0.353 2.245-2.743-2.121-2.121-2.743 2.245-0.353-3.527h-3l-0.353 3.527-2.743-2.245-2.121 2.121 2.245 2.743-3.527 0.353v3l3.527 0.353-2.245 2.743 2.121 2.121 2.743-2.245 0.353 3.527h3l0.353-3.527 2.743 2.245 2.121-2.121-2.245-2.743 3.527-0.353v-3zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" }),
_('path', { d: "M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Cog5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cog5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cog5.SVG = Cog5SVG;
        return Cog5;
    })();
export const Cog6 = /*#__PURE__*/ (() => {
    function Cog6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 7l-3.767-0.753 2.131-3.196-1.414-1.414-3.196 2.131-0.753-3.767h-2l-0.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196-3.767 0.753v2l3.767 0.753-2.131 3.196 1.414 1.414 3.196-2.131 0.753 3.767h2l0.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196 3.767-0.753v-2zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" })
        );
    }
    function Cog6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cog6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cog6.SVG = Cog6SVG;
    return Cog6;
})();
export const Cog7 = /*#__PURE__*/ (() => {
        function Cog7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 7l-3.767-0.753 2.131-3.196-1.414-1.414-3.196 2.131-0.753-3.767h-2l-0.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196-3.767 0.753v2l3.767 0.753-2.131 3.196 1.414 1.414 3.196-2.131 0.753 3.767h2l0.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196 3.767-0.753v-2zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" }),
_('path', { d: "M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Cog7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cog7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cog7.SVG = Cog7SVG;
        return Cog7;
    })();
export const Factory = /*#__PURE__*/ (() => {
    function FactorySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 14v-9l-4 3v-3l-4 3v-4l-4 3v-6h-2v13h-1v1h16v-1z" })
        );
    }
    function Factory({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FactorySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Factory.SVG = FactorySVG;
    return Factory;
})();
export const Hammer = /*#__PURE__*/ (() => {
    function HammerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.781 12.953l-4.712-4.712c-0.292-0.292-0.769-0.292-1.061 0l-0.354 0.354-2.875-2.875 4.72-4.72h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-0.354 0.354c-0.292 0.292-0.292 0.769 0 1.061l4.712 4.712c0.292 0.292 0.769 0.292 1.061 0l1.768-1.768c0.292-0.292 0.292-0.769 0-1.061z" })
        );
    }
    function Hammer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HammerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hammer.SVG = HammerSVG;
    return Hammer;
})();
export const HammerWrench = /*#__PURE__*/ (() => {
    function HammerWrenchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 20 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 20 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.696 11.009l2.295 2.295-1.823 2.341c-0.334 0.437-0.926 0.476-1.315 0.087l-1.586-1.586c-0.389-0.389-0.35-0.98 0.087-1.315l2.341-1.823zM19.899 4.101l-2.399 2.399-3-3 2.399-2.399c-0.289-0.066-0.59-0.101-0.899-0.101-2.209 0-4 1.791-4 4 0 0.797 0.233 1.539 0.635 2.163l-2.233 1.739-3.402-3.402 4.5-4.5h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3-3 9 9 1.5-1.5-3.902-3.902 1.739-2.233c0.624 0.402 1.366 0.635 2.163 0.635 2.209 0 4-1.791 4-4 0-0.309-0.035-0.61-0.101-0.899z" })
        );
    }
    function HammerWrench({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HammerWrenchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HammerWrench.SVG = HammerWrenchSVG;
    return HammerWrench;
})();
export const Knife = /*#__PURE__*/ (() => {
        function KnifeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 10h-10c-1.657 0-3 1.343-3 3s1.343 3 3 3h10c1.657 0 3-1.343 3-3s-1.343-3-3-3zM3 14c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" }),
_('path', { d: "M3 9h2.78l2.927-4.212c0.946-1.361 0.609-3.23-0.752-4.176l-5.909 8.503c0.306-0.075 0.625-0.115 0.954-0.115z" }),
_('path', { d: "M13 8h-5.308l-0.692 0.996v0.004h6c1.144 0 2.177 0.483 2.907 1.255-0.331-1.296-1.507-2.255-2.907-2.255z" })
            );
        }
        function Knife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( KnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Knife.SVG = KnifeSVG;
        return Knife;
    })();
export const Screwdriver = /*#__PURE__*/ (() => {
    function ScrewdriverSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.852 12.352l-6.204-6.204c-0.345-0.345-1.2-0.067-2.043 0.617l-4.605-4.605-0.5-1.16-1.601-1-0.899 0.899 1 1.601 1.16 0.5 4.605 4.605c-0.685 0.843-0.962 1.698-0.617 2.043 0 0 0 0 0 0l6.203 6.203c0.405 0.405 1.518-0.049 2.484-1.016s1.421-2.079 1.016-2.484zM13.92 13.92c-0.116 0.116-0.268 0.174-0.42 0.174s-0.304-0.058-0.42-0.174l-5-5c-0.232-0.232-0.232-0.608 0-0.84s0.608-0.232 0.84 0l5 5c0.232 0.232 0.232 0.608 0 0.84z" })
        );
    }
    function Screwdriver({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScrewdriverSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Screwdriver.SVG = ScrewdriverSVG;
    return Screwdriver;
})();
export const Screwdriver2 = /*#__PURE__*/ (() => {
    function Screwdriver2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.852 12.352l-3.403-3.403c-0.649 0.149-1.358-0.029-1.863-0.535s-0.683-1.214-0.535-1.863l-0.403-0.403c-0.345-0.345-1.2-0.067-2.043 0.617l-4.605-4.605-0.5-1.16-1.601-1-0.899 0.899 1 1.601 1.16 0.5 4.605 4.605c-0.685 0.843-0.962 1.698-0.617 2.043 0 0 0 0 0 0l0.403 0.403c0.649-0.149 1.358 0.029 1.863 0.535s0.683 1.214 0.535 1.863l3.403 3.403c0.405 0.405 1.518-0.049 2.484-1.016s1.421-2.079 1.016-2.484zM13.92 13.92c-0.116 0.116-0.268 0.174-0.42 0.174s-0.304-0.058-0.42-0.174l-5-5c-0.232-0.232-0.232-0.608 0-0.84s0.608-0.232 0.84 0l5 5c0.232 0.232 0.232 0.608 0 0.84z" })
        );
    }
    function Screwdriver2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Screwdriver2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Screwdriver2.SVG = Screwdriver2SVG;
    return Screwdriver2;
})();
export const MagicWand = /*#__PURE__*/ (() => {
    function MagicWandSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 3l-2-2h-1v1l2 2zM5 0h1v2h-1zM9 5h2v1h-2zM10 2v-1h-1l-2 2 1 1zM0 5h2v1h-2zM5 9h1v2h-1zM1 9v1h1l2-2-1-1zM15.781 13.781l-9.939-9.939c-0.292-0.292-0.769-0.292-1.061 0l-0.939 0.939c-0.292 0.292-0.292 0.769 0 1.061l9.939 9.939c0.292 0.292 0.769 0.292 1.061 0l0.939-0.939c0.292-0.292 0.292-0.769 0-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z" })
        );
    }
    function MagicWand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MagicWandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MagicWand.SVG = MagicWandSVG;
    return MagicWand;
})();
export const MagicWand2 = /*#__PURE__*/ (() => {
    function MagicWand2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.068 7.060l2.95-0.917-3.018-2.134v-4.009l-3.233 2.329-3.767-1.329 1.329 3.767-2.329 3.233h4l2.143 3.018 0.917-2.95 6.94 7.932 2-2-7.932-6.94zM6.323 6.323l-0.612 1.968-1.19-1.657h-2.061l1.233-1.652-0.662-1.952 1.952 0.662 1.652-1.233v2.061l1.657 1.19-1.968 0.612z" })
        );
    }
    function MagicWand2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MagicWand2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MagicWand2.SVG = MagicWand2SVG;
    return MagicWand2;
})();
export const Pulse = /*#__PURE__*/ (() => {
        function PulseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.293 9l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v3.793l2.146-2.146c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v1.5h3.873c0.681-1.133 1.127-2.393 1.127-3.75 0-2.347-1.903-4.25-4.25-4.25-1.624 0-3.034 0.911-3.75 2.249-0.716-1.338-2.126-2.249-3.75-2.249-2.347 0-4.25 1.903-4.25 4.25 0 1.357 0.446 2.617 1.127 3.75h2.166z" }),
_('path', { d: "M10.5 10c-0.276 0-0.5-0.224-0.5-0.5v-0.793l-2.146 2.146c-0.096 0.096-0.224 0.146-0.354 0.146-0.064 0-0.129-0.012-0.191-0.038-0.187-0.077-0.309-0.26-0.309-0.462v-3.793l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.69c2.36 3.085 6.19 5 6.19 5s3.83-1.915 6.19-5h-3.69z" })
            );
        }
        function Pulse({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PulseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pulse.SVG = PulseSVG;
        return Pulse;
    })();
export const Pulse2 = /*#__PURE__*/ (() => {
    function Pulse2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 15c-0.017 0-0.034-0.001-0.052-0.003-0.226-0.023-0.408-0.197-0.443-0.421l-1.595-10.369-1.423 6.401c-0.051 0.229-0.254 0.392-0.488 0.392h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.599l1.913-8.608c0.052-0.235 0.264-0.399 0.505-0.391s0.441 0.186 0.478 0.424l1.709 11.11 2.328-6.209c0.074-0.198 0.266-0.328 0.477-0.324s0.398 0.141 0.465 0.342l1.526 4.577 0.526-1.577c0.068-0.204 0.259-0.342 0.474-0.342h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1.64l-0.886 2.658c-0.068 0.204-0.259 0.342-0.474 0.342s-0.406-0.138-0.474-0.342l-1.553-4.66-2.504 6.678c-0.074 0.197-0.261 0.324-0.468 0.324z" })
        );
    }
    function Pulse2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pulse2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pulse2.SVG = Pulse2SVG;
    return Pulse2;
})();
export const AidKit = /*#__PURE__*/ (() => {
    function AidKitSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z" })
        );
    }
    function AidKit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AidKitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    AidKit.SVG = AidKitSVG;
    return AidKit;
})();
export const AidKit2 = /*#__PURE__*/ (() => {
        function AidKit2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM15 14c0 0.551-0.449 1-1 1h-12c-0.551 0-1-0.449-1-1v-8c0-0.551 0.449-1 1-1h12c0.551 0 1 0.449 1 1v8z" }),
_('path', { d: "M12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3z" })
            );
        }
        function AidKit2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AidKit2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        AidKit2.SVG = AidKit2SVG;
        return AidKit2;
    })();
export const Stethoscope = /*#__PURE__*/ (() => {
    function StethoscopeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 6c-1.105 0-2 0.895-2 2 0 0.74 0.402 1.386 1 1.732v3.768c0 0.827-0.673 1.5-1.5 1.5h-4c-0.827 0-1.5-0.673-1.5-1.5v-1.5h0.5c0.276 0 0.5-0.224 0.5-0.5v-0.781c1.066-0.418 1.999-1.296 2.746-2.599 0.823-1.436 1.254-3.16 1.254-4.12v-1.5c0-0.827-0.673-1.5-1.5-1.5h-1.5c-0.552 0-1 0.448-1 1s0.448 1 1 1 1-0.448 1-1h0.5c0.276 0 0.5 0.224 0.5 0.5v1.5c0 1.082-0.578 2.674-1.121 3.623-1.126 1.965-2.459 2.377-3.379 2.377s-2.253-0.412-3.379-2.377c-0.728-1.271-1.121-2.815-1.121-3.623v-1.5c0-0.276 0.224-0.5 0.5-0.5h0.5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1h-1.5c-0.827 0-1.5 0.673-1.5 1.5v1.5c0 0.96 0.431 2.684 1.254 4.12 0.747 1.303 1.68 2.181 2.746 2.599v0.781c0 0.276 0.224 0.5 0.5 0.5h0.5v1.5c0 1.379 1.122 2.5 2.5 2.5h4c1.379 0 2.5-1.121 2.5-2.5v-3.5c1.105 0 2-0.895 2-2s-0.895-2-2-2zM14 9c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1c0 0.551-0.449 1-1 1z" })
        );
    }
    function Stethoscope({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StethoscopeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stethoscope.SVG = StethoscopeSVG;
    return Stethoscope;
})();
export const Ambulance = /*#__PURE__*/ (() => {
        function AmbulanceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.947 9.276l-2-4c-0.085-0.169-0.258-0.276-0.447-0.276h-2.5v-1.5c0-0.276-0.224-0.5-0.5-0.5h-1.5v-1h-3v1h-5.5c-0.276 0-0.5 0.224-0.5 0.5v9c0 0.276 0.224 0.5 0.5 0.5h1.769c-0.171 0.294-0.269 0.636-0.269 1 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.364-0.098-0.706-0.269-1h5.538c-0.171 0.294-0.269 0.636-0.269 1 0 1.103 0.897 2 2 2s2-0.897 2-2c0-0.364-0.098-0.706-0.269-1h0.769c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.078-0.018-0.154-0.053-0.224zM11 6h2.191l1 2h-3.191v-2zM15 12h-14v-8h9v4.5c0 0.276 0.224 0.5 0.5 0.5h4.191l0.309 0.618v2.382z" }),
_('path', { d: "M6 5h-2v2h-2v2h2v2h2v-2h2v-2h-2z" })
            );
        }
        function Ambulance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AmbulanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ambulance.SVG = AmbulanceSVG;
        return Ambulance;
    })();
export const Alarm2 = /*#__PURE__*/ (() => {
        function Alarm2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1z" }),
_('path', { d: "M12.5 11h-0.5v-3c0-2.209-1.791-4-4-4s-4 1.791-4 4v3h-0.5c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h9c0.276 0 0.5-0.224 0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M13.5 16h-11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M3 4c-0.256 0-0.512-0.098-0.707-0.293l-1-1c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l1 1c0.391 0.391 0.391 1.024 0 1.414-0.195 0.195-0.451 0.293-0.707 0.293z" }),
_('path', { d: "M2 9h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" }),
_('path', { d: "M13 4c-0.256 0-0.512-0.098-0.707-0.293-0.391-0.391-0.391-1.024 0-1.414l1-1c0.39-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-1 1c-0.195 0.195-0.451 0.293-0.707 0.293z" }),
_('path', { d: "M15 9h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
            );
        }
        function Alarm2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Alarm2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Alarm2.SVG = Alarm2SVG;
        return Alarm2;
    })();
export const Pandage = /*#__PURE__*/ (() => {
    function PandageSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.902 1.098c-1.464-1.464-3.839-1.464-5.303 0l-8.5 8.5c-1.464 1.464-1.464 3.839 0 5.303s3.839 1.464 5.303 0l8.5-8.5c1.464-1.464 1.464-3.839 0-5.303zM14.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM13.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM14 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM12.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM11.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM12 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM10.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM3.5 11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM4.5 12c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM2.5 10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM3 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM1.5 11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM1.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM2.5 15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM3.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM4.5 15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM5.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM7.854 11.854c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l3 3c0.195 0.195 0.195 0.512 0 0.707zM11.854 7.854c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l3 3c0.195 0.195 0.195 0.512 0 0.707zM12.5 5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.5 6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM14.5 5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z" })
        );
    }
    function Pandage({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PandageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pandage.SVG = PandageSVG;
    return Pandage;
})();
export const Pandage2 = /*#__PURE__*/ (() => {
        function Pandage2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.902 1.098c-1.464-1.464-3.839-1.464-5.303 0l-8.5 8.5c-1.464 1.464-1.464 3.839 0 5.303s3.839 1.464 5.303 0l8.5-8.5c1.464-1.464 1.464-3.839 0-5.303zM14.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM13.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM14 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM12.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM11.5 1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM12 3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM10.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM3.5 11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM4.5 12c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM2.5 10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM3 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM1.5 11c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM1.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM2.5 15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM3.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM4.5 15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM5.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM7.854 11.854c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l3 3c0.195 0.195 0.195 0.512 0 0.707zM11.854 7.854c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-3-3c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l3 3c0.195 0.195 0.195 0.512 0 0.707zM12.5 5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.5 6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM14.5 5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M1.99 7.293l5.303-5.303-0.891-0.891c-0.732-0.732-1.692-1.098-2.652-1.098s-1.919 0.366-2.652 1.098c-1.464 1.464-1.464 3.839 0 5.303l0.891 0.891z" }),
_('path', { d: "M14.010 8.707l-5.303 5.303 0.891 0.891c0.732 0.732 1.692 1.098 2.652 1.098s1.919-0.366 2.652-1.098c1.464-1.464 1.464-3.839 0-5.303l-0.891-0.891z" })
            );
        }
        function Pandage2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Pandage2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pandage2.SVG = Pandage2SVG;
        return Pandage2;
    })();
export const Bug = /*#__PURE__*/ (() => {
    function BugSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 5l1-2v-2l-1.5 3h-1.778c-0.134-0.147-0.33-0.287-0.617-0.447l-2.211-1.106c-0.492-0.246-1.344-0.447-1.894-0.447s-1.403 0.201-1.894 0.447l-2.211 1.106c-0.287 0.161-0.483 0.301-0.617 0.447h-1.778l-1.5-3v2l1 2h2v2l-3 1v1l3-1v3h-1l-2 5h1l1.6-4h0.522c0.139 0.39 0.383 0.771 0.659 0.992l3.438 2.751c0.215 0.172 0.498 0.258 0.781 0.258s0.566-0.086 0.781-0.258l3.438-2.751c0.276-0.221 0.52-0.602 0.659-0.992h0.522l1.6 4h1l-2-5h-1v-3l3 1v-1l-3-1v-2h2zM8.5 14h-1v-10h1v10zM10 1.944v-0.944c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v0.944c0.567-0.253 1.415-0.444 2-0.444s1.433 0.191 2 0.444z" })
        );
    }
    function Bug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bug.SVG = BugSVG;
    return Bug;
})();
export const Bug2 = /*#__PURE__*/ (() => {
    function Bug2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9v-1h-3.020c-0.092-1.136-0.497-2.172-1.12-3.004h2.53l1.095-4.379-0.97-0.243-0.905 3.621h-2.729c-0.014-0.011-0.028-0.021-0.042-0.032 0.105-0.305 0.162-0.632 0.162-0.972 0-1.653-1.343-2.992-3-2.992s-3 1.34-3 2.992c0 0.34 0.057 0.667 0.162 0.972-0.014 0.011-0.028 0.021-0.042 0.032h-2.729l-0.905-3.621-0.97 0.243 1.095 4.379h2.53c-0.623 0.832-1.028 1.868-1.12 3.004h-3.020v1h3.021c0.059 0.713 0.242 1.388 0.526 1.996h-1.937l-1.095 4.379 0.97 0.243 0.905-3.621h1.756c0.917 1.219 2.303 1.996 3.854 1.996s2.937-0.777 3.854-1.996h1.756l0.905 3.621 0.97-0.243-1.095-4.379h-1.937c0.283-0.608 0.466-1.283 0.526-1.996h3.021z" })
        );
    }
    function Bug2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bug2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bug2.SVG = Bug2SVG;
    return Bug2;
})();
export const Syringe = /*#__PURE__*/ (() => {
    function SyringeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 6l0.5-2-4-4-2 0.5 0.985 0.985-1.631 1.631-2.235-2.235-1.237 1.237 1.506 1.506c-0.033 0.025-0.064 0.053-0.094 0.083l-5.586 5.586c-0.389 0.389-0.389 1.025 0 1.414l0.293 0.293v1l0.646 0.646-2.646 2.646 0.707 0.707 2.646-2.646 0.646 0.646h1l0.293 0.293c0.194 0.194 0.451 0.292 0.707 0.292s0.513-0.097 0.707-0.292l5.586-5.586c0.030-0.030 0.057-0.062 0.083-0.094l1.506 1.506 1.237-1.237-2.235-2.235 1.631-1.631 0.985 0.985zM3.854 8.383l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM7.367 12.396l-0.471 0.471-3.541-3.984 0.029-0.029 3.984 3.541zM4.354 7.883l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM4.854 7.383l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM5.354 6.883l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM5.854 6.383l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM6.354 5.883l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM6.854 5.383l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM7.354 4.883l0.029-0.029 3.984 3.541-0.471 0.471-3.541-3.984zM6 13.71c-0.024 0-0.059-0.006-0.088-0.035l-3.586-3.586c-0.029-0.029-0.035-0.064-0.035-0.088s0.006-0.059 0.035-0.088l0.057-0.057 3.984 3.541-0.279 0.279c-0.029 0.029-0.064 0.035-0.088 0.035zM6.396 13.367l-3.541-3.984 0.029-0.029 3.984 3.541-0.471 0.471zM11.674 8.088l-0.279 0.279-3.541-3.984 0.057-0.057c0.029-0.029 0.064-0.035 0.088-0.035s0.059 0.006 0.088 0.035l3.586 3.586c0.047 0.047 0.047 0.13 0 0.177zM12.354 6.116l-2.47-2.47 1.631-1.631 2.47 2.47-1.631 1.631z" })
        );
    }
    function Syringe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SyringeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Syringe.SVG = SyringeSVG;
    return Syringe;
})();
export const Syringe2 = /*#__PURE__*/ (() => {
    function Syringe2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 6l0.5-2-4-4-2 0.5 0.985 0.985-1.631 1.631-2.235-2.235-1.237 1.237 1.506 1.506c-0.033 0.025-0.064 0.053-0.094 0.083l-5.586 5.586c-0.389 0.389-0.389 1.025 0 1.414l0.293 0.293v1l0.646 0.646-2.646 2.646 0.707 0.707 2.646-2.646 0.646 0.646h1l0.293 0.293c0.194 0.194 0.451 0.292 0.707 0.292s0.513-0.097 0.707-0.292l5.586-5.586c0.030-0.030 0.057-0.062 0.083-0.094l1.506 1.506 1.237-1.237-2.235-2.235 1.631-1.631 0.985 0.985zM11.674 8.088l-5.586 5.586c-0.029 0.029-0.064 0.035-0.088 0.035s-0.059-0.006-0.088-0.035l-3.586-3.586c-0.029-0.029-0.035-0.064-0.035-0.088s0.006-0.059 0.035-0.088l5.586-5.586c0.029-0.029 0.064-0.035 0.088-0.035s0.059 0.006 0.088 0.035l3.586 3.586c0.047 0.047 0.047 0.13 0 0.177zM12.354 6.116l-2.47-2.47 1.631-1.631 2.47 2.47-1.631 1.631zM6.235 11.765l-2-2 0.53-0.53 2 2zM9.235 8.765l-2-2 0.53-0.53 2 2zM7.735 10.265l-2-2 0.53-0.53 2 2z" })
        );
    }
    function Syringe2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Syringe2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Syringe2.SVG = Syringe2SVG;
    return Syringe2;
})();
export const Pill = /*#__PURE__*/ (() => {
    function PillSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.682 1.318c-0.879-0.879-2.030-1.318-3.182-1.318s-2.303 0.439-3.182 1.318l-7 7c-1.757 1.757-1.757 4.607 0 6.364 0.879 0.879 2.030 1.318 3.182 1.318s2.303-0.439 3.182-1.318l7-7c1.757-1.757 1.757-4.607 0-6.364zM7.146 4.146l2-2c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-2 2c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512 0-0.707zM6.754 13.754c-0.602 0.602-1.402 0.934-2.254 0.934s-1.652-0.332-2.254-0.934c-0.602-0.602-0.934-1.402-0.934-2.254s0.332-1.652 0.934-2.254l3.25-3.25 4.508 4.508-3.25 3.25z" })
        );
    }
    function Pill({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PillSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pill.SVG = PillSVG;
    return Pill;
})();
export const Construction = /*#__PURE__*/ (() => {
    function ConstructionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.5v-4c0-0.275-0.225-0.5-0.5-0.5h-15c-0.275 0-0.5 0.225-0.5 0.5v4c0 0.275 0.225 0.5 0.5 0.5h1.88l-2.38 7h3l1.020-3h7.96l1.020 3h3l-2.38-7h1.88c0.275 0 0.5-0.225 0.5-0.5zM13 3l-3 3h-3l3-3h3zM4 3h3l-3 3h-3l3-3zM11.64 10h-7.279l1.020-3h5.239l1.020 3zM15 6h-2l2-2v2z" })
        );
    }
    function Construction({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConstructionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Construction.SVG = ConstructionSVG;
    return Construction;
})();
export const TrafficCone = /*#__PURE__*/ (() => {
    function TrafficConeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 14l-4.194-13.048c-0.168-0.524-0.643-0.952-1.056-0.952s-1.088 0-1.5 0-0.888 0.428-1.056 0.952l-4.194 13.048h-2v2h16v-2h-2zM6.586 3h2.828l0.643 2h-4.114l0.643-2zM5.3 7h5.399l0.643 2h-6.685l0.643-2zM3.372 13l0.643-2h7.971l0.643 2h-9.256z" })
        );
    }
    function TrafficCone({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrafficConeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TrafficCone.SVG = TrafficConeSVG;
    return TrafficCone;
})();
export const TrafficLights = /*#__PURE__*/ (() => {
    function TrafficLightsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 10l1.5-3h-2.5v-1h1l1.5-3h-2.5v-1c0-0.55-0.45-1-1-1h-7c-0.55 0-1 0.45-1 1v1h-2.5l1.5 3h1v1h-2.5l1.5 3h1v1h-2.5l1.5 3h1v1c0 0.55 0.45 1 1 1h7c0.55 0 1-0.45 1-1v-1h1l1.5-3h-2.5v-1h1zM7.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM7.5 10c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM7.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
        );
    }
    function TrafficLights({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrafficLightsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TrafficLights.SVG = TrafficLightsSVG;
    return TrafficLights;
})();
export const PieChart = /*#__PURE__*/ (() => {
    function PieChartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 9v-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.126-0.266-2.189-0.738-3.131l-6.262 3.131zM14.262 3.869c-1.149-2.294-3.521-3.869-6.262-3.869v7l6.262-3.131z" })
        );
    }
    function PieChart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart.SVG = PieChartSVG;
    return PieChart;
})();
export const PieChart2 = /*#__PURE__*/ (() => {
    function PieChart2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7h-7v-7zM9 0v7h7c0-3.866-3.134-7-7-7z" })
        );
    }
    function PieChart2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart2.SVG = PieChart2SVG;
    return PieChart2;
})();
export const PieChart3 = /*#__PURE__*/ (() => {
    function PieChart3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.609 14.125c-0.142-0.079-0.28-0.162-0.416-0.25h7.613c-0.136 0.088-0.274 0.171-0.416 0.25h-6.781zM10.895 14.375c-0.205 0.093-0.415 0.177-0.63 0.25h-4.53c-0.215-0.073-0.425-0.157-0.63-0.25h5.789zM3.834 13.625c-0.108-0.080-0.215-0.164-0.318-0.25h8.968c-0.103 0.086-0.209 0.17-0.318 0.25h-8.333zM2.977 12.875h9.191l0.25 0.25h-9.185c-0.087-0.081-0.172-0.165-0.255-0.25zM9.168 9.875l0.25 0.25h-8.089c-0.026-0.083-0.051-0.166-0.074-0.25h7.913zM1.19 9.625c-0.020-0.083-0.037-0.166-0.054-0.25h7.532l0.25 0.25h-7.728zM9.668 10.375l0.25 0.25h-8.408c-0.033-0.083-0.066-0.166-0.096-0.25h8.254zM10.168 10.875l0.25 0.25h-8.683c-0.041-0.082-0.081-0.166-0.119-0.25h8.551zM10.668 11.375l0.25 0.25h-8.907c-0.050-0.082-0.098-0.166-0.145-0.25h8.801zM11.168 11.875l0.25 0.25h-9.073c-0.060-0.082-0.118-0.165-0.174-0.25h8.998zM11.668 12.375l0.25 0.25h-9.172c-0.072-0.082-0.142-0.165-0.21-0.25h9.132zM8.293 9l0.125 0.125h-7.327c-0.007-0.042-0.013-0.083-0.019-0.125h7.221zM8 1v7h-7c0-3.866 3.134-7 7-7zM6.678 14.875h2.644c-0.428 0.082-0.87 0.125-1.322 0.125s-0.894-0.043-1.322-0.125z" })
        );
    }
    function PieChart3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart3.SVG = PieChart3SVG;
    return PieChart3;
})();
export const PieChart4 = /*#__PURE__*/ (() => {
    function PieChart4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c4.418 0 8 3.582 8 8h-8v-8zM7 0.062c-3.946 0.492-7 3.858-7 7.938 0 4.418 3.582 8 8 8 4.080 0 7.446-3.054 7.938-7h-8.938v-8.938zM5.735 1.375h0.265v0.25h-0.894c0.206-0.093 0.416-0.177 0.63-0.25zM4.61 1.875h1.39v0.25h-1.806c0.136-0.088 0.275-0.172 0.416-0.25zM3.833 2.375h2.167v0.25h-2.484c0.104-0.086 0.209-0.17 0.317-0.25zM3.232 2.875h2.768v0.25h-3.023c0.083-0.086 0.168-0.169 0.255-0.25zM2.746 3.375h3.254v0.25h-3.464c0.068-0.085 0.138-0.168 0.21-0.25zM2.345 3.875h3.655v0.25h-3.83c0.056-0.085 0.114-0.168 0.174-0.25zM2.011 4.375h3.989v0.25h-4.133c0.046-0.084 0.094-0.168 0.144-0.25zM1.736 4.875h4.264v0.25h-4.383c0.038-0.084 0.077-0.167 0.119-0.25zM1.51 5.375h4.49v0.25h-4.585c0.030-0.084 0.062-0.167 0.095-0.25zM1.33 5.875h4.67v0.25h-4.745c0.023-0.084 0.048-0.167 0.075-0.25zM1.191 6.375h4.809v0.25h-4.864c0.017-0.084 0.035-0.167 0.055-0.25zM1.091 6.875h4.909v0.25h-4.945c0.010-0.084 0.022-0.167 0.036-0.25zM1.028 7.375h4.972v0.25h-4.99c0.004-0.084 0.010-0.167 0.018-0.25zM1 8c0-0.042 0.001-0.083 0.001-0.125h4.999v0.25h-4.998c-0.001-0.042-0.002-0.083-0.002-0.125zM1.010 8.375h4.99v0.25h-4.972c-0.007-0.083-0.013-0.166-0.018-0.25zM1.054 8.875h4.946v0.25h-4.91c-0.013-0.083-0.026-0.166-0.036-0.25zM1.135 9.375h4.865v0.25h-4.811c-0.020-0.083-0.038-0.166-0.055-0.25zM8 15c-0.449 0-0.891-0.042-1.324-0.125h2.641c-0.431 0.082-0.872 0.125-1.317 0.125zM10.261 14.625h-4.528c-0.154-0.053-0.307-0.111-0.458-0.175-0.058-0.024-0.115-0.050-0.171-0.075h5.788c-0.206 0.094-0.417 0.177-0.631 0.25zM11.39 14.125h-6.781c-0.142-0.079-0.281-0.162-0.416-0.25h7.614c-0.136 0.088-0.275 0.172-0.416 0.25zM12.167 13.625h-8.335c-0.108-0.080-0.213-0.164-0.317-0.25h8.968c-0.104 0.087-0.209 0.17-0.317 0.25zM12.768 13.125h-9.535c-0.062-0.057-0.123-0.116-0.182-0.175-0.025-0.025-0.049-0.050-0.073-0.075h10.046c-0.083 0.085-0.168 0.169-0.255 0.25zM13.255 12.625h-10.509c-0.072-0.082-0.142-0.165-0.21-0.25h10.929c-0.068 0.085-0.138 0.168-0.21 0.25zM13.656 12.125h-11.312c-0.060-0.082-0.118-0.165-0.175-0.25h11.661c-0.056 0.085-0.114 0.168-0.174 0.25zM13.989 11.625h-11.979c-0.050-0.082-0.098-0.166-0.144-0.25h12.268c-0.046 0.084-0.095 0.168-0.145 0.25zM14.265 11.125h-12.53c-0.041-0.082-0.081-0.166-0.119-0.25h12.768c-0.038 0.084-0.077 0.167-0.119 0.25zM14.491 10.625h-12.981c-0.034-0.083-0.066-0.166-0.096-0.25h13.173c-0.030 0.084-0.062 0.167-0.096 0.25zM14.71 10c-0.012 0.042-0.025 0.083-0.039 0.125h-13.343c-0.026-0.083-0.051-0.166-0.075-0.25h4.746v0.125h8.71z" })
        );
    }
    function PieChart4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart4.SVG = PieChart4SVG;
    return PieChart4;
})();
export const PieChart5 = /*#__PURE__*/ (() => {
    function PieChart5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 9v-8.938c-3.946 0.492-7 3.858-7 7.938 0 4.418 3.582 8 8 8 4.080 0 7.446-3.054 7.938-7h-8.938zM12.65 13.233c-1.281 1.14-2.933 1.767-4.65 1.767-0.945 0-1.862-0.185-2.724-0.55-0.833-0.352-1.582-0.857-2.225-1.501s-1.148-1.392-1.501-2.225c-0.365-0.862-0.55-1.779-0.55-2.724 0-1.717 0.628-3.368 1.767-4.65 0.873-0.982 1.994-1.691 3.233-2.060v8.71h8.71c-0.369 1.238-1.079 2.36-2.060 3.233zM8 0c4.418 0 8 3.582 8 8h-8v-8z" })
        );
    }
    function PieChart5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart5.SVG = PieChart5SVG;
    return PieChart5;
})();
export const PieChart6 = /*#__PURE__*/ (() => {
    function PieChart6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 0.062v8.938h8.938c-0.492 3.946-3.858 7-7.938 7-4.418 0-8-3.582-8-8 0-4.080 3.054-7.446 7-7.938zM8 0v8h8c0-4.418-3.582-8-8-8zM9 6.875h5.91c0.007 0.042 0.013 0.083 0.019 0.125h-5.93v-0.125zM10.267 1.375c0.154 0.053 0.307 0.111 0.457 0.175 0.058 0.024 0.115 0.050 0.171 0.075h-1.896v-0.25h1.267zM9 1.125v-0.055c0.109 0.016 0.218 0.034 0.327 0.055h-0.327zM11.392 1.875c0.142 0.079 0.281 0.162 0.416 0.25h-2.808v-0.25h2.392zM12.168 2.375c0.108 0.080 0.213 0.164 0.317 0.25h-3.485v-0.25h3.168zM12.767 2.875c0.062 0.057 0.123 0.115 0.182 0.175 0.025 0.025 0.049 0.050 0.073 0.075h-4.023v-0.25h3.767zM13.254 3.375c0.072 0.082 0.142 0.165 0.21 0.25h-4.465v-0.25h4.254zM13.656 3.875c0.060 0.082 0.118 0.165 0.175 0.25h-4.831v-0.25h4.656zM13.99 4.375c0.050 0.082 0.098 0.166 0.144 0.25h-5.134v-0.25h4.99zM14.265 4.875c0.041 0.082 0.081 0.166 0.119 0.25h-5.385v-0.25h5.265zM14.491 5.375c0.034 0.083 0.065 0.166 0.096 0.25h-5.587v-0.25h5.491zM14.672 5.875c0.026 0.083 0.051 0.166 0.075 0.25h-5.747v-0.25h5.672zM14.811 6.375c0.020 0.083 0.038 0.166 0.055 0.25h-5.865v-0.25h5.811z" })
        );
    }
    function PieChart6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart6.SVG = PieChart6SVG;
    return PieChart6;
})();
export const PieChart7 = /*#__PURE__*/ (() => {
        function PieChart7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 9v-8.938c-3.946 0.492-7 3.858-7 7.938 0 4.418 3.582 8 8 8 4.080 0 7.446-3.054 7.938-7h-8.938z" }),
_('path', { d: "M8 8h8c0-4.418-3.582-8-8-8v8z" })
            );
        }
        function PieChart7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PieChart7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PieChart7.SVG = PieChart7SVG;
        return PieChart7;
    })();
export const StatsDots = /*#__PURE__*/ (() => {
    function StatsDotsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z" })
        );
    }
    function StatsDots({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsDotsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsDots.SVG = StatsDotsSVG;
    return StatsDots;
})();
export const StatsBars = /*#__PURE__*/ (() => {
    function StatsBarsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 3c0.412 0 0.75-0.337 0.75-0.75v-1.5c0-0.412-0.338-0.75-0.75-0.75h-1.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-10v-0.25c0-0.412-0.337-0.75-0.75-0.75h-1.5c-0.412 0-0.75 0.338-0.75 0.75v1.5c0 0.413 0.338 0.75 0.75 0.75h0.25v10h-0.25c-0.412 0-0.75 0.338-0.75 0.75v1.5c0 0.412 0.338 0.75 0.75 0.75h1.5c0.413 0 0.75-0.338 0.75-0.75v-0.25h10v0.25c0 0.412 0.338 0.75 0.75 0.75h1.5c0.412 0 0.75-0.338 0.75-0.75v-1.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-10h0.25zM14 1h1v1h-1v-1zM1 1h1v1h-1v-1zM2 15h-1v-1h1v1zM15 15h-1v-1h1v1zM14 13h-0.25c-0.412 0-0.75 0.338-0.75 0.75v0.25h-10v-0.25c0-0.412-0.337-0.75-0.75-0.75h-0.25v-10h0.25c0.413 0 0.75-0.337 0.75-0.75v-0.25h10v0.25c0 0.413 0.338 0.75 0.75 0.75h0.25v10zM4 4h2v8h-2zM7 8h2v4h-2zM10 6h2v6h-2z" })
        );
    }
    function StatsBars({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBarsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars.SVG = StatsBarsSVG;
    return StatsBars;
})();
export const PieChart8 = /*#__PURE__*/ (() => {
    function PieChart8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 3c0.412 0 0.75-0.337 0.75-0.75v-1.5c0-0.412-0.338-0.75-0.75-0.75h-1.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-10v-0.25c0-0.412-0.337-0.75-0.75-0.75h-1.5c-0.412 0-0.75 0.338-0.75 0.75v1.5c0 0.413 0.338 0.75 0.75 0.75h0.25v10h-0.25c-0.412 0-0.75 0.338-0.75 0.75v1.5c0 0.412 0.338 0.75 0.75 0.75h1.5c0.413 0 0.75-0.338 0.75-0.75v-0.25h10v0.25c0 0.412 0.338 0.75 0.75 0.75h1.5c0.412 0 0.75-0.338 0.75-0.75v-1.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-10h0.25zM14 1h1v1h-1v-1zM1 1h1v1h-1v-1zM2 15h-1v-1h1v1zM15 15h-1v-1h1v1zM14 13h-0.25c-0.412 0-0.75 0.338-0.75 0.75v0.25h-10v-0.25c0-0.412-0.337-0.75-0.75-0.75h-0.25v-10h0.25c0.413 0 0.75-0.337 0.75-0.75v-0.25h10v0.25c0 0.413 0.338 0.75 0.75 0.75h0.25v10zM8 4v4h4c0-2.209-1.791-4-4-4zM7 9v-4.874c-1.725 0.444-3 2.010-3 3.874 0 2.209 1.791 4 4 4 1.864 0 3.43-1.275 3.874-3h-4.874z" })
        );
    }
    function PieChart8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PieChart8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PieChart8.SVG = PieChart8SVG;
    return PieChart8;
})();
export const StatsBars2 = /*#__PURE__*/ (() => {
    function StatsBars2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 13h16v2h-16zM2 9h2v3h-2zM5 5h2v7h-2zM8 8h2v4h-2zM11 2h2v10h-2z" })
        );
    }
    function StatsBars2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBars2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars2.SVG = StatsBars2SVG;
    return StatsBars2;
})();
export const StatsBars3 = /*#__PURE__*/ (() => {
    function StatsBars3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 4h-4v12h4v-12zM7 5.125v-0.125h2v0.125h-2zM7 5.625v-0.25h2v0.25h-2zM7 6.125v-0.25h2v0.25h-2zM7 6.625v-0.25h2v0.25h-2zM7 7.125v-0.25h2v0.25h-2zM7 7.625v-0.25h2v0.25h-2zM7 8.125v-0.25h2v0.25h-2zM7 8.625v-0.25h2v0.25h-2zM7 9.125v-0.25h2v0.25h-2zM7 9.625v-0.25h2v0.25h-2zM7 10.125v-0.25h2v0.25h-2zM7 10.625v-0.25h2v0.25h-2zM7 11.125v-0.25h2v0.25h-2zM7 11.625v-0.25h2v0.25h-2zM7 12.125v-0.25h2v0.25h-2zM7 12.625v-0.25h2v0.25h-2zM7 13.125v-0.25h2v0.25h-2zM7 13.625v-0.25h2v0.25h-2zM7 14.125v-0.25h2v0.25h-2zM7 14.625v-0.25h2v0.25h-2zM7 15v-0.125h2v0.125h-2zM0 9h4v7h-4zM12 0h4v16h-4z" })
        );
    }
    function StatsBars3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBars3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars3.SVG = StatsBars3SVG;
    return StatsBars3;
})();
export const StatsBars4 = /*#__PURE__*/ (() => {
    function StatsBars4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4h3v4zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5h3v5zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6h3v6z" })
        );
    }
    function StatsBars4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBars4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars4.SVG = StatsBars4SVG;
    return StatsBars4;
})();
export const StatsBars5 = /*#__PURE__*/ (() => {
    function StatsBars5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5.125h3v5.125zM9.5 9.625h-3v-0.25h3v0.25zM9.5 9.125h-3v-0.25h3v0.25zM9.5 8.625h-3v-0.25h3v0.25zM9.5 8.125h-3v-0.25h3v0.25zM9.5 7.625h-3v-0.25h3v0.25zM9.5 7.125h-3v-0.25h3v0.25zM9.5 6.625h-3v-0.25h3v0.25zM9.5 6.125h-3v-0.25h3v0.25zM9.5 5.625h-3v-0.25h3v0.25zM9.5 5.125h-3v-0.125h3v0.125zM4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4.125h3v4.125zM4.5 10.625h-3v-0.25h3v0.25zM4.5 10.125h-3v-0.25h3v0.25zM4.5 9.625h-3v-0.25h3v0.25zM4.5 9.125h-3v-0.25h3v0.25zM4.5 8.625h-3v-0.25h3v0.25zM4.5 8.125h-3v-0.25h3v0.25zM4.5 7.625h-3v-0.25h3v0.25zM4.5 7.125h-3v-0.125h3v0.125zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6.125h3v6.125zM14.5 8.625h-3v-0.25h3v0.25zM14.5 8.125h-3v-0.25h3v0.25zM14.5 7.625h-3v-0.25h3v0.25zM14.5 7.125h-3v-0.25h3v0.25zM14.5 6.625h-3v-0.25h3v0.25zM14.5 6.125h-3v-0.25h3v0.25zM14.5 5.625h-3v-0.25h3v0.25zM14.5 5.125h-3v-0.25h3v0.25zM14.5 4.625h-3v-0.25h3v0.25zM14.5 4.125h-3v-0.25h3v0.25zM14.5 3.625h-3v-0.25h3v0.25zM14.5 3.125h-3v-0.125h3v0.125z" })
        );
    }
    function StatsBars5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBars5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars5.SVG = StatsBars5SVG;
    return StatsBars5;
})();
export const StatsBars6 = /*#__PURE__*/ (() => {
    function StatsBars6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 11v0.125h-3v-0.125h3zM1.5 14.125v-0.25h3v0.25h-3zM4.5 14.375v0.25h-3v-0.25h3zM1.5 13.625v-0.25h3v0.25h-3zM1.5 13.125v-0.25h3v0.25h-3zM1.5 12.625v-0.25h3v0.25h-3zM1.5 12.125v-0.25h3v0.25h-3zM1.5 11.625v-0.25h3v0.25h-3zM1.5 15v-0.125h3v0.125h-3zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 10v0.125h-3v-0.125h3zM6.5 14.125v-0.25h3v0.25h-3zM9.5 14.375v0.25h-3v-0.25h3zM6.5 13.625v-0.25h3v0.25h-3zM6.5 13.125v-0.25h3v0.25h-3zM6.5 12.625v-0.25h3v0.25h-3zM6.5 12.125v-0.25h3v0.25h-3zM6.5 11.625v-0.25h3v0.25h-3zM6.5 11.125v-0.25h3v0.25h-3zM6.5 10.625v-0.25h3v0.25h-3zM6.5 15v-0.125h3v0.125h-3zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 9v0.125h-3v-0.125h3zM11.5 14.125v-0.25h3v0.25h-3zM14.5 14.375v0.25h-3v-0.25h3zM11.5 13.625v-0.25h3v0.25h-3zM11.5 13.125v-0.25h3v0.25h-3zM11.5 12.625v-0.25h3v0.25h-3zM11.5 12.125v-0.25h3v0.25h-3zM11.5 11.625v-0.25h3v0.25h-3zM11.5 11.125v-0.25h3v0.25h-3zM11.5 10.625v-0.25h3v0.25h-3zM11.5 10.125v-0.25h3v0.25h-3zM11.5 9.625v-0.25h3v0.25h-3zM11.5 15v-0.125h3v0.125h-3z" })
        );
    }
    function StatsBars6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsBars6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsBars6.SVG = StatsBars6SVG;
    return StatsBars6;
})();
export const Chart = /*#__PURE__*/ (() => {
    function ChartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 15h-3.5v-0.5h-0.5v0.5h-5v-0.5h-0.5v0.5h-3.5v-0.5h-0.5v0.5h-1v-4.5h0.5v-0.5h-0.5v-3.5h0.5v-0.5h-0.5v-3.5h0.5v-0.5h-0.5v-2h-1v16h16v-1.5h-0.5zM6.875 6.125l-0.25 0.25v3.939l0.25-0.25zM6.375 6.625l-0.25 0.25v3.939l0.25-0.25zM5.875 11.064v-4.127l-0.25-0.125v4.161l0.227 0.113zM8.375 4.625l-0.25 0.25v3.939l0.25-0.25zM7.375 5.625l-0.25 0.25v3.939l0.25-0.25zM5.375 6.688l-0.25-0.125v4.161l0.25 0.125zM7.875 5.125l-0.25 0.25v3.939l0.25-0.25zM3.875 5.938l-0.25-0.125v4.161l0.25 0.125zM2.875 5.438l-0.25-0.125v4.161l0.25 0.125zM4.875 6.438l-0.25-0.125v4.161l0.25 0.125zM3.375 5.688l-0.25-0.125v4.161l0.25 0.125zM2.375 5.188l-0.25-0.125v4.161l0.25 0.125zM8.875 4.125l-0.25 0.25v3.939l0.25-0.25zM4.375 6.188l-0.25-0.125v4.161l0.25 0.125zM12.875 5.125l-0.25 0.25v5.335l0.25-0.375zM13.375 4.625l-0.25 0.25v5.085l0.25-0.375zM13.875 4.125l-0.25 0.25v4.835l0.25-0.375zM14.875 3.125l-0.25 0.25v4.335l0.25-0.375zM14.375 3.625l-0.25 0.25v4.585l0.25-0.375zM15.875 2.125l-0.25 0.25v3.835l0.25-0.375zM15.375 2.625l-0.25 0.25v4.085l0.25-0.375zM10.875 5.25l-0.25-0.167v4.833l0.25 0.333zM10.375 4.917l-0.25-0.167v4.5l0.25 0.333zM9.375 4.25l-0.25-0.167v3.833l0.25 0.333zM9.875 4.583l-0.25-0.167v4.167l0.25 0.333zM11.375 5.583l-0.25-0.167v5.167l0.25 0.333zM12.375 5.625l-0.25 0.25v5.585l0.25-0.375zM11.875 5.917l-0.25-0.167v5.5l0.25 0.333zM12 13l-3-4-3 3-4-2v4h14v-7z" })
        );
    }
    function Chart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chart.SVG = ChartSVG;
    return Chart;
})();
export const StatsGrowth = /*#__PURE__*/ (() => {
        function StatsGrowthSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 0l1.72 1.72-4.22 4.22-3-3-5.5 5.5 1.061 1.061 4.439-4.439 3 3 5.28-5.28 1.72 1.72v-4.5z" }),
_('path', { d: "M13 6.561v9.439h2v-11.439z" }),
_('path', { d: "M10 9.561v6.439h2v-8.439z" }),
_('path', { d: "M7 16h2v-5.439l-2-2z" }),
_('path', { d: "M4 16h2v-8.439l-2 2z" }),
_('path', { d: "M1 12.561v3.439h2v-5.439z" })
            );
        }
        function StatsGrowth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StatsGrowthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StatsGrowth.SVG = StatsGrowthSVG;
        return StatsGrowth;
    })();
export const StatsDecline = /*#__PURE__*/ (() => {
        function StatsDeclineSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 6.561v9.439h-2v-11.439l2 2z" }),
_('path', { d: "M6 9.561v6.439h-2v-8.439l2 2z" }),
_('path', { d: "M9 16h-2v-5.439l2-2v7.439z" }),
_('path', { d: "M14.28 7.22l-4.28-4.28-3 3-4.22-4.22-1.061 1.061 5.28 5.28 3-3 3.22 3.22-1.72 1.72h4.5v-4.5z" }),
_('path', { d: "M13 11h2v5h-2v-5z" }),
_('path', { d: "M10 11h2v5h-2v-5z" })
            );
        }
        function StatsDecline({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StatsDeclineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        StatsDecline.SVG = StatsDeclineSVG;
        return StatsDecline;
    })();
export const StatsGrowth2 = /*#__PURE__*/ (() => {
    function StatsGrowth2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 4l1.75 1.75-3.75 3.75-3-3-6.5 6.5 1 1 5.5-5.5 3 3 4.75-4.75 1.75 1.75v-4.5z" })
        );
    }
    function StatsGrowth2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsGrowth2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsGrowth2.SVG = StatsGrowth2SVG;
    return StatsGrowth2;
})();
export const StatsDecline2 = /*#__PURE__*/ (() => {
    function StatsDecline2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 12l1.75-1.75-3.75-3.75-3 3-6.5-6.5 1-1 5.5 5.5 3-3 4.75 4.75 1.75-1.75v4.5z" })
        );
    }
    function StatsDecline2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StatsDecline2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StatsDecline2.SVG = StatsDecline2SVG;
    return StatsDecline2;
})();
export const StairsUp = /*#__PURE__*/ (() => {
    function StairsUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2v3h-3v3h-3v3h-3v3h-3v2h5v-3h3v-3h3v-3h3v-3h2v-2zM1 10l7.406-7.5 1.594 1.5v-4h-4l1.406 1.5-7.406 7.5z" })
        );
    }
    function StairsUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StairsUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StairsUp.SVG = StairsUpSVG;
    return StairsUp;
})();
export const StairsDown = /*#__PURE__*/ (() => {
    function StairsDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 2v3h3v3h3v3h3v3h3v2h-5v-3h-3v-3h-3v-3h-3v-3h-2v-2zM7 0l7.406 7.5 1.594-1.5v4h-4l1.406-1.5-7.406-7.5z" })
        );
    }
    function StairsDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StairsDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StairsDown.SVG = StairsDownSVG;
    return StairsDown;
})();
export const Stairs = /*#__PURE__*/ (() => {
    function StairsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 2l-1 1v2l-2 2v3l-2 2v3h11l1-1v-2h-11l2-2h10l1-1v-2h-11l2-2h10l1-1v-2z" })
        );
    }
    function Stairs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StairsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stairs.SVG = StairsSVG;
    return Stairs;
})();
export const Stairs2 = /*#__PURE__*/ (() => {
    function Stairs2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5v-3h-11l-1 1v2l-2 2v3l-2 2v3h11l1-1v-2h-11l0.125-0.125h11.089l0.237-0.25h-11.077l0.25-0.25h11.064l0.237-0.25h-11.051l0.25-0.25h11.038l0.237-0.25h-11.026l0.25-0.25h11.013l0.237-0.25h-11l0.125-0.125h11v-3h-11l0.125-0.125h11.024l0.247-0.25h-11.020l0.25-0.25h11.017l0.247-0.25h-11.014l0.25-0.25h11.010l0.247-0.25h-11.007l0.25-0.25h11.003l0.247-0.25h-11l0.125-0.125z" })
        );
    }
    function Stairs2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stairs2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stairs2.SVG = Stairs2SVG;
    return Stairs2;
})();
export const Ladder = /*#__PURE__*/ (() => {
    function LadderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 0c-0.552 0-1 0.448-1 1v2h-6v-2c0-0.552-0.448-1-1-1s-1 0.448-1 1v14c0 0.552 0.448 1 1 1s1-0.448 1-1v-2h6v2c0 0.552 0.448 1 1 1s1-0.448 1-1v-14c0-0.552-0.448-1-1-1zM11 11h-6v-2h6v2zM11 7h-6v-2h6v2z" })
        );
    }
    function Ladder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LadderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ladder.SVG = LadderSVG;
    return Ladder;
})();
export const Rating = /*#__PURE__*/ (() => {
    function RatingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 13v2l7-3.5 7 3.5v-2l-7-3.5z" })
        );
    }
    function Rating({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RatingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rating.SVG = RatingSVG;
    return Rating;
})();
export const Rating2 = /*#__PURE__*/ (() => {
    function Rating2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 13v2l7-3.5 7 3.5v-2l-7-3.5zM1 9v2l7-3.5 7 3.5v-2l-7-3.5z" })
        );
    }
    function Rating2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Rating2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rating2.SVG = Rating2SVG;
    return Rating2;
})();
export const Rating3 = /*#__PURE__*/ (() => {
    function Rating3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 13v2l7-3.5 7 3.5v-2l-7-3.5zM1 9v2l7-3.5 7 3.5v-2l-7-3.5zM8 1.5l-7 3.5v2l7-3.5 7 3.5v-2z" })
        );
    }
    function Rating3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Rating3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rating3.SVG = Rating3SVG;
    return Rating3;
})();
export const Cake = /*#__PURE__*/ (() => {
    function CakeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 5.019v-1.519c0-0.275-0.225-0.5-0.5-0.5h-1c-0.275 0-0.5 0.225-0.5 0.5v1.519c-3.946 0.154-7 1.206-7 2.481v6c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-6c0-1.275-3.054-2.327-7-2.481zM1.672 7.275c0.379-0.199 0.898-0.388 1.501-0.545 1.085-0.283 2.417-0.463 3.827-0.522v1.292c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-1.292c1.41 0.058 2.741 0.238 3.827 0.522 0.603 0.157 1.122 0.346 1.501 0.545 0.167 0.088 0.283 0.165 0.362 0.225-0.079 0.061-0.195 0.137-0.362 0.225-0.379 0.199-0.898 0.388-1.501 0.545-1.339 0.35-3.053 0.542-4.827 0.542s-3.488-0.193-4.827-0.542c-0.603-0.157-1.122-0.346-1.501-0.545-0.167-0.088-0.283-0.165-0.362-0.225 0.079-0.061 0.195-0.137 0.362-0.225zM15 11.93c-1.365 0.769-3.988 1.289-7 1.289s-5.635-0.52-7-1.289v-1.406c1.365 0.769 3.988 1.289 7 1.289s5.635-0.52 7-1.289v1.406zM8 2.5c-0.552 0-1-0.448-1-1 0-0.020 0.001-0.039 0.002-0.058 0.038-0.961 0.998-1.442 0.998-1.442s0.96 0.481 0.998 1.442c0.001 0.019 0.002 0.039 0.002 0.058 0 0.552-0.448 1-1 1z" })
        );
    }
    function Cake({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CakeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cake.SVG = CakeSVG;
    return Cake;
})();
export const Podium = /*#__PURE__*/ (() => {
    function PodiumSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 7v-4h-6v3h-5v8h16v-7h-5zM4 11h-2v1h2v1h-3v-3h2v-1h-2v-1h3v3zM9 10h-1v-4h-1v-1h2v5zM15 13h-3v-1h2v-1h-2v-1h2v-1h-2v-1h3v5z" })
        );
    }
    function Podium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PodiumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Podium.SVG = PodiumSVG;
    return Podium;
})();
export const Stars = /*#__PURE__*/ (() => {
        function StarsSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 7.152l0.926 2.851h2.997l-2.425 1.762 0.926 2.851-2.425-1.762-2.425 1.762 0.926-2.851-2.425-1.762h2.997z" }),
_('path', { d: "M8.5 0.152l0.926 2.851h2.997l-2.425 1.762 0.926 2.851-2.425-1.762-2.425 1.762 0.926-2.851-2.425-1.762h2.997z" }),
_('path', { d: "M12.5 7.152l0.926 2.851h2.997l-2.425 1.762 0.926 2.851-2.425-1.762-2.425 1.762 0.926-2.851-2.425-1.762h2.997z" })
            );
        }
        function Stars({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StarsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stars.SVG = StarsSVG;
        return Stars;
    })();
export const MedalStar = /*#__PURE__*/ (() => {
        function MedalStarSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.5 4.839l1.352 4.162h4.376l-3.541 2.572 1.352 4.162-3.541-2.572-3.541 2.572 1.352-4.162-3.541-2.572h4.377z" }),
_('path', { d: "M7 0h1v4h-1v-4z" }),
_('path', { d: "M9 0v6.214l2-1.714v-4.5z" }),
_('path', { d: "M6 0v6.214l-2-1.714v-4.5z" })
            );
        }
        function MedalStar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalStarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalStar.SVG = MedalStarSVG;
        return MedalStar;
    })();
export const Medal = /*#__PURE__*/ (() => {
    function MedalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 5c0-0.791-0.613-1.439-1.39-1.495 0.509-0.589 0.485-1.481-0.075-2.040s-1.451-0.584-2.040-0.075c-0.057-0.777-0.704-1.389-1.496-1.389s-1.439 0.613-1.495 1.389c-0.589-0.509-1.481-0.484-2.040 0.075s-0.584 1.451-0.075 2.040c-0.777 0.057-1.389 0.704-1.389 1.495s0.613 1.439 1.389 1.495c-0.509 0.589-0.485 1.481 0.075 2.040 0.415 0.415 1.014 0.536 1.536 0.362v6.603l2-2 2 2v-6.603c0.522 0.174 1.12 0.054 1.536-0.362 0.559-0.559 0.584-1.451 0.075-2.040 0.777-0.057 1.39-0.704 1.39-1.496zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3c1.657 0 3 1.343 3 3s-1.343 3-3 3z" })
        );
    }
    function Medal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MedalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Medal.SVG = MedalSVG;
    return Medal;
})();
export const Medal2 = /*#__PURE__*/ (() => {
        function Medal2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.321 6.116l2.819-6.116h-3.461l-2.311 5.013c-0.122-0.008-0.245-0.013-0.369-0.013s-0.247 0.005-0.369 0.013l-2.311-5.013h-3.461l2.819 6.116c-1.324 1.004-2.179 2.594-2.179 4.384 0 3.038 2.462 5.5 5.5 5.5s5.5-2.462 5.5-5.5c0-1.79-0.855-3.38-2.179-4.384zM11.319 1h1.258l-2.111 4.581-0.016-0.005c-0.334-0.167-0.688-0.301-1.057-0.397l1.925-4.178zM3.422 1h1.259l1.925 4.178c-0.369 0.096-0.723 0.23-1.057 0.397l-0.016 0.005-2.111-4.581zM8 14.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M8 9.125c0.758 0 1.375 0.617 1.375 1.375s-0.617 1.375-1.375 1.375c-0.758 0-1.375-0.617-1.375-1.375s0.617-1.375 1.375-1.375zM8 8c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5-1.119-2.5-2.5-2.5v0z" })
            );
        }
        function Medal2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Medal2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Medal2.SVG = Medal2SVG;
        return Medal2;
    })();
export const MedalFirst = /*#__PURE__*/ (() => {
        function MedalFirstSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.321 6.116l2.819-6.116h-3.461l-2.311 5.013c-0.122-0.008-0.245-0.013-0.369-0.013s-0.247 0.005-0.369 0.013l-2.311-5.013h-3.461l2.819 6.116c-1.324 1.004-2.179 2.594-2.179 4.384 0 3.038 2.462 5.5 5.5 5.5s5.5-2.462 5.5-5.5c0-1.79-0.855-3.38-2.179-4.384zM11.319 1h1.258l-2.111 4.581-0.016-0.005c-0.334-0.167-0.688-0.301-1.057-0.397l1.925-4.178zM3.422 1h1.259l1.925 4.178c-0.369 0.096-0.723 0.23-1.057 0.397l-0.016 0.005-2.111-4.581zM8 14.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M9.5 12h-0.5v-3.5c0-0.276-0.224-0.5-0.5-0.5h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function MedalFirst({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalFirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalFirst.SVG = MedalFirstSVG;
        return MedalFirst;
    })();
export const MedalSecond = /*#__PURE__*/ (() => {
        function MedalSecondSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.321 6.116l2.819-6.116h-3.461l-2.311 5.013c-0.122-0.008-0.245-0.013-0.369-0.013s-0.247 0.005-0.369 0.013l-2.311-5.013h-3.461l2.819 6.116c-1.324 1.004-2.179 2.594-2.179 4.384 0 3.038 2.462 5.5 5.5 5.5s5.5-2.462 5.5-5.5c0-1.79-0.855-3.38-2.179-4.384zM11.319 1h1.258l-2.111 4.581-0.016-0.005c-0.334-0.167-0.688-0.301-1.057-0.397l1.925-4.178zM3.422 1h1.259l1.925 4.178c-0.369 0.096-0.723 0.23-1.057 0.397l-0.016 0.005-2.111-4.581zM8 14.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M9.5 13h-3c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5h2.5v-1h-2.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5h-2.5v1h2.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function MedalSecond({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalSecondSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalSecond.SVG = MedalSecondSVG;
        return MedalSecond;
    })();
export const MedalThird = /*#__PURE__*/ (() => {
        function MedalThirdSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.321 6.116l2.819-6.116h-3.461l-2.311 5.013c-0.122-0.008-0.245-0.013-0.369-0.013s-0.247 0.005-0.369 0.013l-2.311-5.013h-3.461l2.819 6.116c-1.324 1.004-2.179 2.594-2.179 4.384 0 3.038 2.462 5.5 5.5 5.5s5.5-2.462 5.5-5.5c0-1.79-0.855-3.38-2.179-4.384zM11.319 1h1.258l-2.111 4.581-0.016-0.005c-0.334-0.167-0.688-0.301-1.057-0.397l1.925-4.178zM3.422 1h1.259l1.925 4.178c-0.369 0.096-0.723 0.23-1.057 0.397l-0.016 0.005-2.111-4.581zM8 14.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M9.5 8h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function MedalThird({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MedalThirdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MedalThird.SVG = MedalThirdSVG;
        return MedalThird;
    })();
export const Crown = /*#__PURE__*/ (() => {
    function CrownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 12h8v2h-8zM15 3c-0.552 0-1 0.448-1 1 0 0.205 0.062 0.396 0.168 0.555l-3.668 2.445-0.376-3.008c0.494-0.061 0.876-0.482 0.876-0.992 0-0.552-0.448-1-1-1s-1 0.448-1 1c0 0.392 0.225 0.73 0.553 0.894l-1.553 3.106-1.553-3.106c0.328-0.164 0.553-0.503 0.553-0.894 0-0.552-0.448-1-1-1s-1 0.448-1 1c0 0.51 0.382 0.931 0.876 0.992l-0.376 3.008-3.668-2.445c0.106-0.159 0.168-0.349 0.168-0.555 0-0.552-0.448-1-1-1s-1 0.448-1 1 0.448 1 1 1c0.14 0 0.273-0.029 0.394-0.081l2.606 6.081h8l2.606-6.081c0.121 0.052 0.254 0.081 0.394 0.081 0.552 0 1-0.448 1-1s-0.448-1-1-1z" })
        );
    }
    function Crown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CrownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Crown.SVG = CrownSVG;
    return Crown;
})();
export const Trophy = /*#__PURE__*/ (() => {
    function TrophySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 1c-1 0-5 0-5 0v2h-6v-2c0 0-4 0-5 0 0 5 4 10.85 7 11.75v1.25c-1 0-2 0.5-2 1h6c0-0.5-1-1-2-1v-1.25c3-0.9 7-6.75 7-11.75zM11.995 3.538l0.005-0.538v-1h2.945c-0.087 0.807-0.277 1.66-0.567 2.547-0.383 1.172-0.939 2.372-1.607 3.471-0.642 1.057-1.372 1.996-2.109 2.714-0.071 0.069-0.141 0.136-0.211 0.2 1.326-2.658 1.518-5.984 1.545-7.394zM5.339 10.732c-0.737-0.719-1.467-1.657-2.109-2.714-0.668-1.099-1.224-2.299-1.607-3.471-0.29-0.886-0.48-1.739-0.567-2.547h2.945v1l0.005 0.538c0.028 1.409 0.22 4.735 1.545 7.394-0.070-0.064-0.141-0.131-0.211-0.2z" })
        );
    }
    function Trophy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrophySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy.SVG = TrophySVG;
    return Trophy;
})();
export const Trophy2 = /*#__PURE__*/ (() => {
    function Trophy2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z" })
        );
    }
    function Trophy2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Trophy2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy2.SVG = Trophy2SVG;
    return Trophy2;
})();
export const Trophy3 = /*#__PURE__*/ (() => {
    function Trophy3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM9.522 5.8l0.953 2.913-2.476-1.807-2.476 1.807 0.953-2.913-2.483-1.796 3.065 0.007 0.941-2.917 0.941 2.917 3.065-0.007-2.483 1.796zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z" })
        );
    }
    function Trophy3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Trophy3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy3.SVG = Trophy3SVG;
    return Trophy3;
})();
export const Diamond = /*#__PURE__*/ (() => {
    function DiamondSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.172 4l2.081 2.081-5.252 5.909-5.252-5.909 2.081-2.081h6.343zM12 2h-8l-4 4 8 9 8-9-4-4z" })
        );
    }
    function Diamond({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DiamondSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamond.SVG = DiamondSVG;
    return Diamond;
})();
export const Diamond2 = /*#__PURE__*/ (() => {
    function Diamond2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2h-8l-4 4 8 9 8-9-4-4zM8 12.167v-0.042h-0.037l-0.222-0.25h0.259v-0.25h-0.481l-0.222-0.25h0.704v-0.25h-0.926l-0.222-0.25h1.148v-0.25h-1.37l-0.222-0.25h1.593v-0.25h-1.815l-0.222-0.25h2.037v-0.25h-2.259l-0.222-0.25h2.481v-0.25h-2.704l-0.222-0.25h2.926v-0.25h-3.148l-0.222-0.25h3.37v-0.25h-3.593l-0.222-0.25h3.815v-0.25h-4.037l-0.222-0.25h4.259v-0.25h-4.481l-0.222-0.25h4.704v-0.25h-4.926l-0.222-0.25h5.148v-0.25h-5.37l-0.115-0.129 2.173-2.173h3.312v0.052h3.364l0.25 0.25h-3.614v0.25h3.864l0.25 0.25h-4.114v0.25h4.364l0.25 0.25h-4.614v0.25h4.864l0.25 0.25h-5.114v0.25h5.364l0.121 0.121-5.485 6.171z" })
        );
    }
    function Diamond2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Diamond2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamond2.SVG = Diamond2SVG;
    return Diamond2;
})();
export const Trophy4 = /*#__PURE__*/ (() => {
    function Trophy4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 2h-10l-3 4 8 9-2.222-8h4.444l-2.222 8 8-9-3-4zM1.25 6l2.282-3.043 1.69 3.043h-3.972zM5.778 6l1.667-3h1.111l1.667 3h-4.444zM12.468 2.957l2.282 3.043h-3.972l1.69-3.043z" })
        );
    }
    function Trophy4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Trophy4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trophy4.SVG = Trophy4SVG;
    return Trophy4;
})();
export const Gift = /*#__PURE__*/ (() => {
    function GiftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z" })
        );
    }
    function Gift({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GiftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gift.SVG = GiftSVG;
    return Gift;
})();
export const Gift2 = /*#__PURE__*/ (() => {
    function Gift2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM4.081 3.386c-0.247-0.247-0.403-0.565-0.426-0.872-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26zM14 8.5h-5v6.5h-2v-6.5h-5v-0.5h5v-2h2v2h5v0.5z" })
        );
    }
    function Gift2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Gift2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gift2.SVG = Gift2SVG;
    return Gift2;
})();
export const Balloon = /*#__PURE__*/ (() => {
    function BalloonSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 7c0-3.866-2.686-7-6-7s-6 3.134-6 7c0 3.478 2.174 6.363 5.023 6.907l-0.523 2.093h3l-0.523-2.093c2.849-0.544 5.023-3.429 5.023-6.907zM4.417 8h-1.5c-0.048-0.325-0.073-0.659-0.073-1 0-0.703 0.107-1.376 0.302-2h1.5c-0.195 0.624-0.302 1.297-0.302 2 0 0.341 0.025 0.675 0.074 1z" })
        );
    }
    function Balloon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BalloonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Balloon.SVG = BalloonSVG;
    return Balloon;
})();
export const Pipe = /*#__PURE__*/ (() => {
        function PipeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 7c-2.367 0-3.76 1.56-4.989 2.936-0.989 1.108-1.843 2.064-3.011 2.064-0.928 0-1-1.148-1-1.5v-2c0-0.276-0.224-0.5-0.5-0.5h-5c-0.276 0-0.5 0.224-0.5 0.5v2c0 2.304 0.617 3.912 1.834 4.782 1.005 0.718 2.127 0.718 2.666 0.718 1.49 0 2.837-0.534 4.116-1.633 1.083-0.931 1.948-2.106 2.785-3.243 1.234-1.676 2.299-3.124 3.599-3.124h1v-1h-1z" }),
_('path', { d: "M1.344 7c-0.083 0-0.162-0.041-0.21-0.114-0.064-0.099-0.051-0.229 0.032-0.312 0.53-0.536 0.821-1.108 0.89-1.75 0.061-0.572-0.055-1.122-0.167-1.653-0.158-0.747-0.307-1.453 0.111-2.042 0.404-0.571 1.298-0.929 2.811-1.127 0.103-0.013 0.203 0.038 0.252 0.129s0.037 0.203-0.030 0.282c-1.075 1.253-1.070 2.298-1.065 3.221 0.003 0.634 0.006 1.233-0.324 1.805-0.357 0.618-1.060 1.109-2.212 1.546-0.029 0.011-0.059 0.016-0.088 0.016z" })
            );
        }
        function Pipe({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PipeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pipe.SVG = PipeSVG;
        return Pipe;
    })();
export const Mustache = /*#__PURE__*/ (() => {
    function MustacheSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.645 8.021c-0.211-0.064-0.439 0.018-0.561 0.201-0.327 0.491-0.734 0.761-1.146 0.761-0.408 0-0.793-0.271-0.982-0.689l-0.007-0.015c-0.229-0.509-0.466-1.035-0.815-1.462-0.442-0.542-0.992-0.817-1.634-0.817-0.817 0-1.544 0.394-2 1.002-0.456-0.608-1.183-1.002-2-1.002-0.642 0-1.192 0.275-1.634 0.817-0.348 0.427-0.586 0.953-0.815 1.462l-0.007 0.015c-0.189 0.419-0.574 0.689-0.982 0.689-0.412 0-0.819-0.27-1.146-0.761-0.122-0.183-0.35-0.265-0.561-0.201s-0.355 0.258-0.355 0.479c0 1.074 0.419 1.978 1.212 2.615 0.711 0.571 1.701 0.885 2.788 0.885 1.038 0 2.035-0.378 2.807-1.064 0.276-0.245 0.508-0.518 0.693-0.809 0.185 0.291 0.417 0.564 0.693 0.809 0.772 0.686 1.769 1.064 2.807 1.064 1.087 0 2.077-0.314 2.788-0.885 0.793-0.636 1.212-1.541 1.212-2.615 0-0.22-0.144-0.415-0.355-0.479z" })
        );
    }
    function Mustache({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MustacheSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mustache.SVG = MustacheSVG;
    return Mustache;
})();
export const Mustache2 = /*#__PURE__*/ (() => {
    function Mustache2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.645 8.021c-0.211-0.064-0.439 0.018-0.561 0.201-0.327 0.491-0.734 0.761-1.146 0.761-0.408 0-0.793-0.271-0.982-0.689l-0.007-0.015c-0.229-0.509-0.466-1.035-0.815-1.462-0.442-0.542-0.992-0.817-1.634-0.817-0.817 0-1.544 0.394-2 1.002-0.456-0.608-1.183-1.002-2-1.002-0.642 0-1.192 0.275-1.634 0.817-0.348 0.427-0.586 0.953-0.815 1.462l-0.007 0.015c-0.189 0.419-0.574 0.689-0.982 0.689-0.412 0-0.819-0.27-1.146-0.761-0.122-0.183-0.35-0.265-0.561-0.201s-0.355 0.258-0.355 0.479c0 1.074 0.419 1.978 1.212 2.615 0.711 0.571 1.701 0.885 2.788 0.885 1.038 0 2.035-0.378 2.807-1.064 0.276-0.245 0.508-0.518 0.693-0.809 0.185 0.291 0.417 0.564 0.693 0.809 0.772 0.686 1.769 1.064 2.807 1.064 1.087 0 2.077-0.314 2.788-0.885 0.793-0.636 1.212-1.541 1.212-2.615 0-0.22-0.144-0.415-0.355-0.479zM6.143 10.189c-0.589 0.523-1.35 0.811-2.143 0.811-1.331 0-2.146-0.486-2.584-1.125 0.254 0.086 0.479 0.109 0.646 0.109 0.8-0 1.543-0.502 1.894-1.278l0.007-0.015c0.474-1.051 0.814-1.69 1.537-1.69 0.827 0 1.5 0.673 1.5 1.5 0 0.589-0.312 1.205-0.857 1.689zM11 11c-0.793 0-1.554-0.288-2.143-0.811-0.545-0.484-0.857-1.099-0.857-1.689 0-0.827 0.673-1.5 1.5-1.5 0.723 0 1.063 0.638 1.537 1.69l0.007 0.015c0.35 0.777 1.093 1.278 1.894 1.278 0.171 0 0.404-0.024 0.666-0.116-0.565 0.815-1.641 1.132-2.604 1.132z" })
        );
    }
    function Mustache2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mustache2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mustache2.SVG = Mustache2SVG;
    return Mustache2;
})();
export const Glass = /*#__PURE__*/ (() => {
    function GlassSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM4.595 1h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 0.084-0.002 0.167-0.005 0.25h-7.991c-0.003-0.083-0.005-0.166-0.005-0.25-0-0.979 0.205-1.923 0.595-2.75z" })
        );
    }
    function Glass({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GlassSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glass.SVG = GlassSVG;
    return Glass;
})();
export const Glass2 = /*#__PURE__*/ (() => {
    function Glass2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM8 9c-2.206 0-4-2.355-4-5.25 0-0.979 0.205-1.923 0.595-2.75h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 2.895-1.794 5.25-4 5.25z" })
        );
    }
    function Glass2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Glass2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glass2.SVG = Glass2SVG;
    return Glass2;
})();
export const Glass3 = /*#__PURE__*/ (() => {
    function Glass3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-1.571 2h-5.8l-1.571-2h8.943z" })
        );
    }
    function Glass3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Glass3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glass3.SVG = Glass3SVG;
    return Glass3;
})();
export const Glass4 = /*#__PURE__*/ (() => {
    function Glass4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-4.471 5.691-4.471-5.691h8.943z" })
        );
    }
    function Glass4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Glass4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glass4.SVG = Glass4SVG;
    return Glass4;
})();
export const Bottle = /*#__PURE__*/ (() => {
    function BottleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 5v-4h0.25c0.137 0 0.25-0.113 0.25-0.25v-0.5c0-0.138-0.113-0.25-0.25-0.25h-2.5c-0.138 0-0.25 0.113-0.25 0.25v0.5c0 0.137 0.112 0.25 0.25 0.25h0.25v4c0 1.588-2 2-2 3.508v6.992c0 0.276 0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5v-6.992c0-1.508-2-1.92-2-3.508z" })
        );
    }
    function Bottle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BottleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bottle.SVG = BottleSVG;
    return Bottle;
})();
export const Bottle2 = /*#__PURE__*/ (() => {
    function Bottle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 5v-4h0.25c0.137 0 0.25-0.113 0.25-0.25v-0.5c0-0.138-0.113-0.25-0.25-0.25h-2.5c-0.138 0-0.25 0.113-0.25 0.25v0.5c0 0.137 0.112 0.25 0.25 0.25h0.25v4c0 1.588-2 2-2 3.508v6.992c0 0.276 0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5v-6.992c0-1.508-2-1.92-2-3.508zM10 14.745c-0.531 0.158-1.232 0.255-2 0.255s-1.469-0.096-2-0.255v-5c0.531 0.158 1.232 0.255 2 0.255s1.469-0.096 2-0.255v5z" })
        );
    }
    function Bottle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bottle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bottle2.SVG = Bottle2SVG;
    return Bottle2;
})();
export const Bottle3 = /*#__PURE__*/ (() => {
    function Bottle3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 4.5c0-0.827-0.673-1.5-1.5-1.5-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5-0.827 0-1.5 0.673-1.5 1.5v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.827 0.673 1.5 1.5 1.5h5c0.827 0 1.5-0.673 1.5-1.5v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1zM11 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5-0.224 0.5-0.5-0.224-0.5-0.5-0.5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5-0.224 0.5-0.5-0.224-0.5-0.5-0.5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5-0.224 0.5-0.5-0.224-0.5-0.5-0.5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5 0.827 0 1.5-0.673 1.5-1.5v-0.5h2v0.5c0 0.827 0.673 1.5 1.5 1.5 0.276 0 0.5 0.224 0.5 0.5v1z" })
        );
    }
    function Bottle3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bottle3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bottle3.SVG = Bottle3SVG;
    return Bottle3;
})();
export const Bottle4 = /*#__PURE__*/ (() => {
        function Bottle4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 4.5c0-0.827-0.673-1.5-1.5-1.5-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5-0.827 0-1.5 0.673-1.5 1.5v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.384 0.145 0.734 0.383 1-0.238 0.266-0.383 0.616-0.383 1v1c0 0.827 0.673 1.5 1.5 1.5h5c0.827 0 1.5-0.673 1.5-1.5v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1c0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1v-1zM10.25 15v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25h-0.25v-0.25h-0.25v0.25c-0.091 0-0.176-0.025-0.25-0.068v-0.182h-0.182c-0.043-0.074-0.068-0.159-0.068-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.182c0.044-0.076 0.107-0.139 0.182-0.182v0.182h0.25v-0.25h0.25v-0.067c0.076-0.044 0.139-0.107 0.183-0.183h0.067v-0.25c0-0.091-0.025-0.176-0.067-0.25h0.067v-0.25h-0.25v0.067c-0.074-0.043-0.159-0.067-0.25-0.067s-0.176-0.025-0.25-0.068v-0.182h-0.182c-0.043-0.074-0.068-0.159-0.068-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.182c0.044-0.076 0.107-0.139 0.182-0.182v0.182h0.25v-0.25h0.25v-0.067c0.076-0.044 0.139-0.107 0.183-0.183h0.067v-0.25c0-0.091-0.025-0.176-0.067-0.25h0.067v-0.25h-0.25v0.067c-0.074-0.043-0.159-0.067-0.25-0.067s-0.176-0.025-0.25-0.068v-0.182h-0.182c-0.043-0.074-0.068-0.159-0.068-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.25v-0.25h0.25v-0.25h-0.182c0.044-0.076 0.107-0.138 0.182-0.182v0.182h0.25v-0.25h0.25v-0.067c0.076-0.044 0.139-0.107 0.183-0.183h0.067v-0.25c0-0.091-0.025-0.176-0.067-0.25h0.067v-0.25h-0.25v0.067c-0.074-0.043-0.159-0.067-0.25-0.067s-0.176-0.025-0.25-0.068v-0.182h-0.182c-0.043-0.074-0.068-0.159-0.068-0.25h0.25v-0.25h-0.25v-0.75c0-0.276 0.224-0.5 0.5-0.5 0.827 0 1.5-0.673 1.5-1.5v-0.5h2v0.5c0 0.827 0.673 1.5 1.5 1.5 0.276 0 0.5 0.224 0.5 0.5v0.5h-0.25v0.25h0.25v0.25h-0.25v0.25h0.182c-0.044 0.076-0.107 0.138-0.182 0.182v-0.182h-0.25v0.25h-0.25v0.067c-0.076 0.044-0.139 0.107-0.183 0.183h-0.067v0.25c0 0.091 0.025 0.176 0.067 0.25h-0.067v0.25h0.25v-0.067c0.074 0.043 0.159 0.067 0.25 0.067s0.176 0.025 0.25 0.068v0.182h0.182c0.043 0.074 0.068 0.159 0.068 0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.182c-0.044 0.076-0.107 0.139-0.182 0.182v-0.182h-0.25v0.25h-0.25v0.067c-0.076 0.044-0.139 0.107-0.183 0.183h-0.067v0.25c0 0.091 0.025 0.176 0.067 0.25h-0.067v0.25h0.25v-0.067c0.074 0.043 0.159 0.067 0.25 0.067s0.176 0.025 0.25 0.068v0.182h0.182c0.043 0.074 0.068 0.159 0.068 0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.182c-0.044 0.076-0.107 0.139-0.182 0.182v-0.182h-0.25v0.25h-0.25v0.067c-0.076 0.044-0.139 0.107-0.183 0.183h-0.067v0.25c0 0.091 0.025 0.176 0.067 0.25h-0.067v0.25h0.25v-0.067c0.074 0.043 0.159 0.067 0.25 0.067s0.176 0.025 0.25 0.068v0.182h0.182c0.043 0.074 0.068 0.159 0.068 0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.25v0.25h-0.25v0.25h0.182c-0.044 0.076-0.107 0.139-0.182 0.182v-0.182h-0.25v0.25h-0.25z" }),
_('path', { d: "M5.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 9.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 9h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 9.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 9.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 8h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 8.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 8.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 8.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 10h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 10.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 10.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 10.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 11h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 11.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 11.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 11.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 12.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 12h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 12.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 12.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 13h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 13.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 13.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 13.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 14h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 14.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 14.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.5 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M5.75 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.5 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M6.75 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.5 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M7.75 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 5.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 5.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 5.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 6.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 6h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 6.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 6.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.5 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M8.75 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.5 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M9.75 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 7h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 7.25h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10 7.75h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.25 7.5h0.25v0.25h-0.25v-0.25z" }),
_('path', { d: "M10.5 7.75h0.25v0.25h-0.25v-0.25z" })
            );
        }
        function Bottle4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bottle4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bottle4.SVG = Bottle4SVG;
        return Bottle4;
    })();
export const Mug = /*#__PURE__*/ (() => {
    function MugSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 5h-3v-1.5c0-1.381-2.686-2.5-6-2.5s-6 1.119-6 2.5v10c0 1.381 2.686 2.5 6 2.5s6-1.119 6-2.5v-1.5h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM2.751 4.037c-0.578-0.19-0.928-0.394-1.116-0.537 0.188-0.143 0.538-0.347 1.116-0.537 0.905-0.298 2.059-0.463 3.249-0.463s2.344 0.164 3.249 0.463c0.578 0.19 0.928 0.394 1.116 0.537-0.188 0.143-0.538 0.347-1.116 0.537-0.905 0.298-2.059 0.463-3.249 0.463s-2.344-0.164-3.249-0.463zM14 10h-2v-3h2v3z" })
        );
    }
    function Mug({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MugSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mug.SVG = MugSVG;
    return Mug;
})();
export const ForkKnife = /*#__PURE__*/ (() => {
        function ForkKnifeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 0c-0.276 0-0.5 0.224-0.5 0.5v4.5c0 0.296-0.051 0.493-0.15 0.585-0.094 0.086-0.277 0.132-0.471 0.18-0.114 0.028-0.244 0.061-0.379 0.11v-5.375c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v5.375c-0.134-0.049-0.265-0.081-0.379-0.11-0.194-0.048-0.377-0.094-0.471-0.18-0.1-0.091-0.15-0.288-0.15-0.585v-4.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v4.5c0 1.39 0.863 1.606 1.379 1.735 0.194 0.048 0.377 0.094 0.471 0.18 0.1 0.091 0.15 0.288 0.15 0.585v2.586c-0.583 0.206-1 0.761-1 1.414v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.653-0.417-1.208-1-1.414v-2.586c0-0.296 0.051-0.493 0.15-0.585 0.094-0.086 0.277-0.132 0.471-0.18 0.516-0.129 1.379-0.345 1.379-1.735v-4.5c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M13 10.086v-9.586c0-0.276-0.224-0.5-0.5-0.5-1.078 0-1.767 0.72-2.155 1.323-0.406 0.631-0.729 1.497-0.959 2.572-0.382 1.781-0.386 3.531-0.386 3.605 0 0.276 0.224 0.5 0.5 0.5h2.5v2.086c-0.583 0.206-1 0.761-1 1.414v3c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-3c0-0.653-0.417-1.208-1-1.414zM10.367 4.092c0.259-1.202 0.745-2.6 1.633-2.988v5.896h-1.986c0.028-0.633 0.109-1.778 0.353-2.908z" })
            );
        }
        function ForkKnife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ForkKnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ForkKnife.SVG = ForkKnifeSVG;
        return ForkKnife;
    })();
export const SpoonKnife = /*#__PURE__*/ (() => {
    function SpoonKnifeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655 0.985 3.042 2.308 3.406l-0.497 8.096c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.497-8.096c1.323-0.365 2.308-1.751 2.308-3.406 0-1.933-1.343-3.5-3-3.5zM13.583 0l-0.833 5h-0.625l-0.417-5h-0.417l-0.417 5h-0.625l-0.833-5h-0.417v6.5c0 0.276 0.224 0.5 0.5 0.5h1.302l-0.491 8.002c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.491-8.002h1.302c0.276 0 0.5-0.224 0.5-0.5v-6.5h-0.417z" })
        );
    }
    function SpoonKnife({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpoonKnifeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SpoonKnife.SVG = SpoonKnifeSVG;
    return SpoonKnife;
})();
export const Cook = /*#__PURE__*/ (() => {
    function CookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2c-0.526 0-1.046 0.104-1.528 0.303-0.541-0.786-1.448-1.303-2.472-1.303s-1.931 0.517-2.472 1.303c-0.482-0.199-1.002-0.303-1.528-0.303-2.206 0-4 1.794-4 4 0 1.957 0.875 2.832 1.646 3.604 0.726 0.726 1.354 1.354 1.354 2.896v3c0 0.276 0.224 0.5 0.5 0.5h9c0.276 0 0.5-0.224 0.5-0.5v-3c0-1.543 0.627-2.17 1.354-2.896 0.772-0.772 1.646-1.646 1.646-3.604 0-2.206-1.794-4-4-4zM12 15h-8v-2h8v2zM13.646 8.896c-0.703 0.703-1.491 1.491-1.626 3.104h-8.041c-0.135-1.613-0.923-2.401-1.626-3.104-0.726-0.726-1.354-1.354-1.354-2.896 0-1.654 1.346-3 3-3 0.039 0 0.177 0.006 0.179 0.006 0.821 0.058 0.821 0.526 0.821 0.994v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-1.103 0.897-2 2-2s2 0.897 2 2v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.468 0-0.936 0.821-0.994 0.002-0 0.14-0.006 0.179-0.006 1.654 0 3 1.346 3 3 0 1.543-0.627 2.17-1.354 2.896z" })
        );
    }
    function Cook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cook.SVG = CookSVG;
    return Cook;
})();
export const Plate = /*#__PURE__*/ (() => {
        function PlateSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.517 13h14.966c0.276 0 0.5-0.224 0.5-0.5v-1c0-0.011-0-0.022-0.001-0.033-0.133-2.023-1.023-3.905-2.504-5.297-1.243-1.169-2.806-1.899-4.478-2.107v-1.063h0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1.063c-1.672 0.209-3.234 0.939-4.478 2.107-1.482 1.393-2.371 3.274-2.504 5.297-0.001 0.011-0.001 0.022-0.001 0.033v1c0 0.276 0.224 0.5 0.5 0.5z" }),
_('path', { d: "M15.5 14h-15c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Plate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Plate.SVG = PlateSVG;
        return Plate;
    })();
export const Steak = /*#__PURE__*/ (() => {
        function SteakSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 7c0-2.757-2.243-5-5-5-0.957 0-1.896 0.263-2.715 0.76-0.821 0.499-1.466 1.198-1.863 2.023-0.356 0.739-1.307 1.217-2.422 1.217h-1c-1.654 0-3 1.346-3 3v1c0 1.491 0.869 2.812 2.448 3.719 1.438 0.826 3.41 1.281 5.552 1.281 2.175 0 4.171-0.662 5.622-1.865 0.75-0.621 1.335-1.367 1.74-2.217 0.423-0.889 0.638-1.871 0.638-2.918 0-0.152-0.007-0.302-0.021-0.45 0.013-0.181 0.021-0.364 0.021-0.55zM12.984 11.365c-1.272 1.054-3.042 1.635-4.984 1.635-1.971 0-3.766-0.408-5.054-1.148-0.888-0.51-1.946-1.419-1.946-2.852 0-1.103 0.897-2 2-2h1c0.689 0 1.354-0.147 1.922-0.426 0.64-0.314 1.125-0.783 1.401-1.357 0.639-1.326 2.117-2.217 3.677-2.217 2.206 0 4 1.794 4 4 0 1.763-0.697 3.272-2.016 4.365z" }),
_('path', { d: "M11 4.125c-1.12 0-2.215 0.65-2.664 1.581-0.387 0.802-1.050 1.452-1.919 1.878-0.721 0.354-1.557 0.541-2.418 0.541h-1c-0.482 0-0.875 0.393-0.875 0.875 0 0.719 0.465 1.35 1.381 1.877 1.121 0.644 2.716 0.998 4.494 0.998 1.681 0 3.196-0.489 4.266-1.376 1.067-0.885 1.609-2.062 1.609-3.499 0-1.585-1.29-2.875-2.875-2.875zM11 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
            );
        }
        function Steak({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SteakSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Steak.SVG = SteakSVG;
        return Steak;
    })();
export const Fish = /*#__PURE__*/ (() => {
    function FishSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.927 7.24c-0.781-1.28-1.808-2.343-2.97-3.074-1.213-0.763-2.581-1.166-3.957-1.166-1.973 0-3.869 0.814-5.395 2.304-0.867-1.024-1.862-1.8-2.903-2.261-0.193-0.085-0.419-0.041-0.564 0.112s-0.18 0.38-0.085 0.569l1.889 3.776-1.889 3.776c-0.094 0.189-0.060 0.416 0.085 0.569 0.096 0.101 0.228 0.155 0.362 0.155 0.068-0 0.137-0.014 0.202-0.043 1.042-0.461 2.037-1.238 2.903-2.261 1.526 1.49 3.422 2.304 5.395 2.304 1.376 0 2.744-0.403 3.957-1.166 1.161-0.73 2.188-1.793 2.97-3.074 0.098-0.16 0.098-0.361 0-0.521zM13 8c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Fish({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FishSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fish.SVG = FishSVG;
    return Fish;
})();
export const Chicken = /*#__PURE__*/ (() => {
        function ChickenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 12c-2.5 0-3.75-2.25-3.75-2.25-1 0-1.5 0.5-1.5 1.5 0 0 2.25 1.25 2.25 3.75 0 0.552 0.448 1 1 1s1-0.448 1-1v-0.5c0-0.276 0.224-0.5 0.5-0.5h0.5c0.552 0 1-0.448 1-1s-0.448-1-1-1z" }),
_('path', { d: "M9 10.5c0-0.828 0.672-1.5 1.5-1.5 0.171 0 0.335 0.029 0.488 0.081 0.144-0.498 0.151-1.047-0.014-1.486l-0.447-1.191c-0.29-0.772-0.721-2.051-0.958-2.841-0-0-1.069-3.563-5.069-3.563-2.485 0-4.5 2.015-4.5 4.5 0 4 3.563 5.069 3.563 5.069 0.79 0.237 1.437 0.431 1.437 0.431s0.632 0.237 1.404 0.527l1.191 0.447c0.439 0.165 0.987 0.158 1.486 0.014-0.053-0.153-0.081-0.317-0.081-0.488z" })
            );
        }
        function Chicken({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ChickenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Chicken.SVG = ChickenSVG;
        return Chicken;
    })();
export const Hamburger = /*#__PURE__*/ (() => {
    function HamburgerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 15c4.418 0 8-1.343 8-3h-16c0 1.657 3.582 3 8 3zM14.5 6h-13c-0.825 0-1.5 0.675-1.5 1.5s0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5s-0.675-1.5-1.5-1.5zM8 1c-4.418 0-8 1.656-8 3.313v0.688h16v-0.688c0-1.657-3.582-3.313-8-3.313zM2.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM4.5 3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM11.5 3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM0 10h16v1h-16z" })
        );
    }
    function Hamburger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HamburgerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hamburger.SVG = HamburgerSVG;
    return Hamburger;
})();
export const Pizza = /*#__PURE__*/ (() => {
        function PizzaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.626 5.604l-14.846-5.567c-0.212-0.079-0.451-0.028-0.611 0.132s-0.212 0.399-0.132 0.611l5.567 14.846c0.085 0.226 0.301 0.374 0.54 0.374 0.008 0 0.016-0 0.023-0.001 2.579-0.103 5.006-1.168 6.835-2.997s2.894-4.257 2.997-6.835c0.010-0.249-0.141-0.476-0.374-0.564zM3.951 7.93c0.608-0.191 1.049-0.759 1.049-1.43 0-0.828-0.672-1.5-1.5-1.5-0.214 0-0.417 0.045-0.601 0.126l-1.336-3.562 12.357 4.634c-0.533 4.013-3.71 7.189-7.723 7.723l-2.246-5.99z" }),
_('path', { d: "M10 10c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" }),
_('path', { d: "M9 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Pizza({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PizzaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pizza.SVG = PizzaSVG;
        return Pizza;
    })();
export const Cheese = /*#__PURE__*/ (() => {
        function CheeseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.743 7.063l-11.075-6.155c-0.145-0.081-0.321-0.084-0.469-0.009-2.59 1.313-4.199 3.843-4.199 6.601v6c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-5.998c0.001-0.179-0.095-0.349-0.257-0.439zM7.969 5.094c0.518 0 0.938 0.392 0.938 0.875s-0.42 0.875-0.938 0.875-0.938-0.392-0.938-0.875c0-0.483 0.42-0.875 0.938-0.875zM4 4.067c0.552 0 1 0.418 1 0.933s-0.448 0.933-1 0.933-1-0.418-1-0.933c0-0.515 0.448-0.933 1-0.933zM12 13c0-0.552-0.448-1-1-1s-1 0.448-1 1h-9v-5h14v1h-0.5c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5h0.5v1h-3z" }),
_('path', { d: "M4 10c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M8 10.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M11 10c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Cheese({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheeseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cheese.SVG = CheeseSVG;
        return Cheese;
    })();
export const Bread = /*#__PURE__*/ (() => {
        function BreadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 2h-9c-0.816 0-1.556 0.327-2.097 0.857l-0-0-1.070 1.071c-0.516 0.539-0.833 1.269-0.833 2.072 0 0.874 0.382 1.678 1 2.233v7.267c0 0.276 0.224 0.5 0.5 0.5h12c0 0 0 0 0 0 0.138 0 0.263-0.056 0.354-0.147l0.999-0.999c0.091-0.091 0.147-0.216 0.147-0.354v-7.267c0.618-0.555 1-1.359 1-2.233 0-1.654-1.346-3-3-3zM12.401 7.96c-0.271 0.055-0.445 0.319-0.391 0.589 0.048 0.237 0.257 0.401 0.489 0.401 0.033 0 0.066-0.003 0.1-0.010 0.137-0.028 0.271-0.066 0.401-0.111v6.171h-11v-6.172c0.128 0.045 0.26 0.083 0.396 0.111 0.271 0.055 0.535-0.119 0.59-0.39s-0.119-0.535-0.39-0.59c-0.214-0.044-0.415-0.122-0.596-0.227v-0c-0.603-0.35-1-1.005-1-1.732 0-1.103 0.897-2 2-2h9c1.103 0 2 0.897 2 2 0 0.948-0.673 1.772-1.599 1.96z" }),
_('path', { d: "M4 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M4 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M7 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M8 9.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 10.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M8 12.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 5.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Bread({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BreadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bread.SVG = BreadSVG;
        return Bread;
    })();
export const Icecream = /*#__PURE__*/ (() => {
    function IcecreamSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 6.5c0-1.361-0.792-2.591-2.004-3.164-0.086-1.854-1.621-3.336-3.496-3.336s-3.41 1.482-3.496 3.336c-1.184 0.562-2.004 1.769-2.004 3.164 0 1.446 0.882 2.69 2.136 3.223l2.915 5.996c0.084 0.172 0.258 0.281 0.45 0.281s0.366-0.109 0.45-0.281l2.915-5.996c1.254-0.533 2.136-1.777 2.136-3.223zM9.5 9h-4c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5c0.286 0 0.567 0.048 0.833 0.142 0.26 0.092 0.546-0.044 0.638-0.305s-0.044-0.546-0.305-0.638c-0.374-0.132-0.767-0.199-1.167-0.199-0.154 0-0.306 0.010-0.455 0.030 0.221-1.154 1.237-2.030 2.455-2.030 1.379 0 2.5 1.121 2.5 2.5 0 0.616-0.226 1.208-0.637 1.667-0.184 0.206-0.167 0.522 0.039 0.706 0.095 0.085 0.215 0.127 0.333 0.127 0.137 0 0.274-0.056 0.373-0.167 0.367-0.41 0.629-0.897 0.77-1.419 0.688 0.456 1.121 1.235 1.121 2.086 0 1.378-1.121 2.5-2.5 2.5z" })
        );
    }
    function Icecream({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IcecreamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Icecream.SVG = IcecreamSVG;
    return Icecream;
})();
export const Milk = /*#__PURE__*/ (() => {
        function MilkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 6.502v-0.002h-0c0-0.095-0.027-0.192-0.084-0.277l-1.916-2.874v-2.849c0-0.276-0.224-0.5-0.5-0.5h-8c-0.276 0-0.5 0.224-0.5 0.5v2.849l-1.914 2.871c-0 0-0.001 0.001-0.001 0.001l-0.001 0.001 0 0c-0.053 0.079-0.084 0.175-0.084 0.277v9c0 0.276 0.224 0.5 0.5 0.5h12c0.276 0 0.5-0.224 0.5-0.5v-8.997c0-0.001 0-0.001 0-0.002zM4 1h7v2h-7v-2zM3.768 4h6.798l-1.333 2h-6.798l1.333-2zM2 7h7v8h-7v-8zM10 15v-8.349l1.5-2.25 1.5 2.25v8.349h-3z" }),
_('path', { d: "M4 9h3v4h-3v-4z" })
            );
        }
        function Milk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MilkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Milk.SVG = MilkSVG;
        return Milk;
    })();
export const Cup = /*#__PURE__*/ (() => {
        function CupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.063 7h-13.563c-0.276 0-0.5 0.224-0.5 0.5 0 1.525 0.311 3.020 0.899 4.324 0.578 1.282 1.407 2.346 2.397 3.078 0.086 0.064 0.19 0.098 0.297 0.098h-2.094c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.094c0.107 0 0.211-0.034 0.297-0.098 0.911-0.674 1.686-1.63 2.254-2.777h0.105c1.584 0 2.539-0.553 3.061-1.017 0.627-0.557 1.001-1.322 1.001-2.045 0-1.137-0.925-2.063-2.063-2.063zM11.361 11h-9.723c-0.357-0.918-0.574-1.937-0.627-3h10.976c-0.052 1.063-0.27 2.082-0.627 3zM14.376 10.267c-0.337 0.299-0.939 0.65-1.945 0.72 0.309-0.902 0.496-1.871 0.551-2.862h1.080c0.517 0 0.938 0.421 0.938 0.938 0 0.314-0.164 0.796-0.624 1.205z" }),
_('path', { d: "M4.5 6c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M6.5 6c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8.5 6c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Cup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cup.SVG = CupSVG;
        return Cup;
    })();
export const Cup2 = /*#__PURE__*/ (() => {
        function Cup2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.063 7h-13.563c-0.276 0-0.5 0.224-0.5 0.5 0 1.525 0.311 3.020 0.899 4.324 0.578 1.282 1.407 2.346 2.397 3.078 0.086 0.064 0.19 0.098 0.297 0.098h-2.094c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.094c0.107 0 0.211-0.034 0.297-0.098 0.911-0.674 1.686-1.63 2.254-2.777h0.105c1.584 0 2.539-0.553 3.061-1.017 0.627-0.557 1.001-1.322 1.001-2.045 0-1.137-0.925-2.063-2.063-2.063zM14.376 10.267c-0.337 0.299-0.939 0.65-1.945 0.72 0.309-0.902 0.496-1.871 0.551-2.862h1.080c0.517 0 0.938 0.421 0.938 0.938 0 0.314-0.164 0.796-0.624 1.205z" }),
_('path', { d: "M4.5 6c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M6.5 6c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8.5 6c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Cup2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Cup2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Cup2.SVG = Cup2SVG;
        return Cup2;
    })();
export const CoffeeBean = /*#__PURE__*/ (() => {
        function CoffeeBeanSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7.834 10.231c-1.008-3.7-1.893-6.601 0.286-10.229-0.040-0.001-0.080-0.002-0.12-0.002-4.5 0-6 3.582-6 8 0 4.064 1.269 7.42 4.975 7.932 0.916-1.643 1.354-3.881 0.859-5.701z" }),
_('path', { d: "M9.019 0.067c-0.877 1.358-1.318 3.35-0.89 4.902 1.109 4.017 1.814 7.013-0.3 11.029 0.056 0.001 0.113 0.002 0.171 0.002 4.5 0 6-3.582 6-8 0-4.066-1.271-7.424-4.981-7.933z" })
            );
        }
        function CoffeeBean({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CoffeeBeanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CoffeeBean.SVG = CoffeeBeanSVG;
        return CoffeeBean;
    })();
export const Coffee = /*#__PURE__*/ (() => {
    function CoffeeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 2h-0.691l-0.862-1.724c-0.085-0.169-0.258-0.276-0.447-0.276h-7c-0.189 0-0.363 0.107-0.447 0.276l-0.862 1.724h-0.691c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h0.5c0 0.017 0.001 0.035 0.003 0.052l1 9.5c0.027 0.254 0.241 0.448 0.497 0.448h7c0.256 0 0.47-0.193 0.497-0.448l1-9.5c0.002-0.018 0.003-0.035 0.003-0.052h0.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5zM4.809 1h6.382l0.5 1h-7.382l0.5-1zM4.95 15l-0.316-3h6.731l-0.316 3h-6.1zM7 10c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.552 0-1-0.448-1-1zM11.787 8h-7.573l-0.211-2h7.995l-0.211 2zM13 5h-10v-2h9.497c0.001 0 0.002 0 0.003 0s0.001-0 0.002-0h0.498v2z" })
        );
    }
    function Coffee({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoffeeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Coffee.SVG = CoffeeSVG;
    return Coffee;
})();
export const Teapot = /*#__PURE__*/ (() => {
        function TeapotSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 19 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 19 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.25 6c-0.763 0-1.455 0.313-1.953 0.817-1.091-1.12-2.614-1.817-4.297-1.817-1.502 0-2.943 0.563-4.060 1.585-0.758 0.694-1.32 1.556-1.644 2.505-0.026-0.029-0.053-0.058-0.081-0.087-0.646-0.666-1.559-1.004-2.715-1.004h-1c-0.276 0-0.5 0.224-0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5 0.735 0 1.298 0.283 1.773 0.892 0.453 0.58 0.756 1.358 1.050 2.11 0.236 0.604 0.458 1.175 0.751 1.619 0.385 0.584 0.865 0.88 1.426 0.88h9c0.133 0 0.26-0.053 0.354-0.146 0.555-0.555 0.841-1.255 0.989-1.936 0.628-0.165 1.299-0.573 1.858-1.143 0.838-0.856 1.3-1.93 1.3-3.025 0-1.516-1.234-2.75-2.75-2.75zM16.628 10.725c-0.205 0.209-0.422 0.377-0.629 0.503 0.001-0.080 0.001-0.157 0.001-0.228 0-1.074-0.284-2.083-0.78-2.956 0.225-0.328 0.603-0.544 1.030-0.544 0.689 0 1.25 0.561 1.25 1.25 0 0.944-0.546 1.643-0.872 1.975z" }),
_('path', { d: "M11 4c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Teapot({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TeapotSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Teapot.SVG = TeapotSVG;
        return Teapot;
    })();
export const Leaf = /*#__PURE__*/ (() => {
    function LeafSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.054 1.148 0.139 2.418 0.573 3.784 1.482-4.444 5.622-7.923 10.395-7.923 0 0-4.466 1.175-7.274 4.816-0.002 0.002-0.039 0.048-0.103 0.136-0.564 0.754-1.055 1.612-1.423 2.583-0.623 1.482-1.2 3.515-1.2 5.965h2c0 0-0.304-1.91 0.224-4.106 0.873 0.118 1.654 0.177 2.357 0.177 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431z" })
        );
    }
    function Leaf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LeafSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Leaf.SVG = LeafSVG;
    return Leaf;
})();
export const Leaf2 = /*#__PURE__*/ (() => {
    function Leaf2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.065 1.375 0.225 2.925 0.859 4.606-0.586 1.428-0.904 2.898-0.904 4.254 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-1.198 0.293-2.535 0.818-3.835 1.472 0.272 2.712 0.405 3.776 0.405 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431zM10.644 7.515c-0.481 1.034-0.897 1.927-1.608 2.554-0.776 0.684-1.873 1.002-3.454 1.002-0.945 0-2.047-0.113-3.351-0.345 0.238-0.476 0.507-0.941 0.804-1.386 0.692-1.036 1.505-1.931 2.417-2.661 0.984-0.788 2.059-1.36 3.193-1.7 0.264-0.079 0.415-0.358 0.335-0.623s-0.358-0.415-0.623-0.335c-1.257 0.377-2.445 1.009-3.53 1.878-0.991 0.794-1.874 1.765-2.623 2.886-0.252 0.378-0.485 0.767-0.698 1.163-0.36-1.185-0.52-2.279-0.474-3.261 0.052-1.099 0.361-2.067 0.921-2.876 0.636-0.92 1.583-1.633 2.816-2.119 1.134-0.447 2.487-0.684 3.911-0.684 2.172 0 4.357 0.555 5.9 1.475-2.314 1.551-3.206 3.467-3.935 5.032z" })
        );
    }
    function Leaf2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Leaf2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Leaf2.SVG = Leaf2SVG;
    return Leaf2;
})();
export const Apple = /*#__PURE__*/ (() => {
    function AppleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4.958c-1.321-1.351-7-2.22-7 4.193 0 3.962 5.016 8.348 6.999 6.35h0.002c1.983 1.998 6.999-2.388 6.999-6.35 0-6.413-5.679-5.544-7-4.193zM13.017 10.664c-0.376 1.45-1.622 2.798-3.086 3.751 1.53-1.821 2.473-4.905 1.561-7.296-0.271-0.712-0.583-1.315-0.923-1.822 1.797 0.603 3.279 2.166 2.448 5.368zM7.505 3.188c0.213-0.051 0.415-0.117 0.608-0.196-0.070 0.323-0.113 0.663-0.113 1.007h0.333c0.29-1.355 1.381-2.938 2.835-2.938 0-0.745-0.505-1.063-1.074-1.063-0.541 0.268-1.013 0.749-1.394 1.429-0.206 0.367-0.421 0.87-0.557 1.433-0.027-0.159-0.068-0.318-0.124-0.477-0.617-1.735-2.768-2.748-4.803-2.262-0.231 0.055-0.449 0.128-0.656 0.214 0.026 0.196 0.072 0.393 0.142 0.59 0.617 1.735 2.767 2.748 4.803 2.262z" })
        );
    }
    function Apple({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AppleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Apple.SVG = AppleSVG;
    return Apple;
})();
export const Grapes = /*#__PURE__*/ (() => {
        function GrapesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M7 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M11 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M5 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M9 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M13 11.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M7 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M11 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M15.5 7c-0.041 0-0.084-0-0.128-0-0.586-0.003-1.417-0.007-2.411 0.495 0.030-0.286 0.039-0.495 0.039-0.495 0-3.5-1.5-5-5-5 0 3.142 1.209 4.672 3.988 4.952-0.034 0.718-0.161 1.201-0.602 1.71-0.148 0.146-0.297 0.304-0.449 0.476-0.182 0.207-0.162 0.523 0.045 0.706 0.095 0.084 0.213 0.125 0.33 0.125 0.128 0 0.255-0.050 0.352-0.145 0.001-0.001 0.002-0.001 0.003-0.002 0.166-0.166 0.316-0.324 0.45-0.477 1.383-1.355 2.451-1.349 3.25-1.345 0.045 0 0.090 0 0.133 0 0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function Grapes({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GrapesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Grapes.SVG = GrapesSVG;
        return Grapes;
    })();
export const Cherry = /*#__PURE__*/ (() => {
    function CherrySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 6c-1.111 0-2.080 0.604-2.599 1.501-1.043-0.305-2.026-0.688-2.939-1.149-1.219-0.616-2.317-1.369-3.264-2.238-1.212-1.113-1.939-2.219-2.198-2.728v-0.385c0-0.552-0.448-1-1-1s-1 0.448-1 1 0.448 1 1 1c0.006 0 0.013-0 0.019-0 0.117 1.618 0.765 3.819 1.719 5.781 0.587 1.208 1.248 2.255 1.965 3.11 0.026 0.031 0.051 0.061 0.077 0.091-0.484 0.533-0.78 1.241-0.78 2.018 0 1.657 1.343 3 3 3s3-1.343 3-3-1.343-3-3-3c-0.52 0-1.009 0.132-1.435 0.365-0.689-0.796-1.342-1.816-1.928-3.021-0.599-1.233-1.077-2.59-1.359-3.797 0.325 0.391 0.722 0.82 1.2 1.263 1.015 0.94 2.191 1.752 3.497 2.416 0.958 0.486 1.987 0.892 3.077 1.215-0.034 0.181-0.052 0.368-0.052 0.56 0 1.657 1.343 3 3 3s3-1.343 3-3-1.343-3-3-3z" })
        );
    }
    function Cherry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CherrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cherry.SVG = CherrySVG;
    return Cherry;
})();
export const Tree = /*#__PURE__*/ (() => {
    function TreeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.887 13.182l-2.387-3.182h1c0 0 0.001 0 0.001 0 0.276 0 0.5-0.224 0.5-0.5 0-0.121-0.043-0.231-0.114-0.318l-2.387-3.182h1c0.192 0 0.367-0.11 0.451-0.283s0.060-0.379-0.060-0.529l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188s-0.296 0.069-0.39 0.188l-4 5c-0.12 0.15-0.143 0.356-0.060 0.529s0.258 0.283 0.451 0.283h1l-2.4 3.2c-0.114 0.152-0.132 0.354-0.047 0.524s0.258 0.276 0.447 0.276h1l-2.4 3.2c-0.114 0.152-0.132 0.354-0.047 0.524s0.258 0.276 0.447 0.276h4.5v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5h4.5c0 0 0 0 0.001 0 0.276 0 0.5-0.224 0.5-0.5 0-0.121-0.043-0.231-0.114-0.318z" })
        );
    }
    function Tree({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TreeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree.SVG = TreeSVG;
    return Tree;
})();
export const Tree2 = /*#__PURE__*/ (() => {
    function Tree2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.887 13.182l-2.387-3.182h1c0 0 0.001 0 0.001 0 0.276 0 0.5-0.224 0.5-0.5 0-0.121-0.043-0.231-0.114-0.318l-2.387-3.182h1c0.192 0 0.367-0.11 0.451-0.283s0.060-0.379-0.060-0.529l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188s-0.296 0.069-0.39 0.188l-4 5c-0.12 0.15-0.143 0.356-0.060 0.529s0.258 0.283 0.451 0.283h1l-2.4 3.2c-0.114 0.152-0.132 0.354-0.047 0.524s0.258 0.276 0.447 0.276h1l-2.4 3.2c-0.114 0.152-0.132 0.354-0.047 0.524s0.258 0.276 0.447 0.276h4.5v1.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-1.5h4.5c0 0 0 0 0.001 0 0.276 0 0.5-0.224 0.5-0.5 0-0.121-0.043-0.231-0.114-0.318zM8 15h-1v-1h1v1zM2.5 13l2.4-3.2c0.114-0.152 0.132-0.354 0.047-0.524s-0.258-0.276-0.447-0.276h-1l2.4-3.2c0.114-0.152 0.132-0.354 0.047-0.524s-0.258-0.276-0.447-0.276h-0.96l2.96-3.7 2.96 3.7h-0.96c-0.189 0-0.363 0.107-0.447 0.276s-0.066 0.372 0.047 0.524l2.4 3.2h-1c-0.189 0-0.363 0.107-0.447 0.276s-0.066 0.372 0.047 0.524l2.4 3.2h-10z" })
        );
    }
    function Tree2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree2.SVG = Tree2SVG;
    return Tree2;
})();
export const Tree3 = /*#__PURE__*/ (() => {
    function Tree3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.852 3.354c-0.508-1.928-2.266-3.354-4.352-3.354s-3.844 1.426-4.352 3.354c-1.891 0.754-3.148 2.596-3.148 4.646 0 2.757 2.243 5 5 5 0.34 0 0.674-0.035 1-0.101v2.601c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-2.601c0.327 0.066 0.661 0.101 1 0.101 2.757 0 5-2.243 5-5 0-2.060-1.254-3.892-3.148-4.646z" })
        );
    }
    function Tree3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree3.SVG = Tree3SVG;
    return Tree3;
})();
export const Tree4 = /*#__PURE__*/ (() => {
    function Tree4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.852 3.354c-0.508-1.928-2.266-3.354-4.352-3.354s-3.844 1.426-4.352 3.354c-1.891 0.754-3.148 2.596-3.148 4.646 0 2.757 2.243 5 5 5h1v2.5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-2.5h1c2.757 0 5-2.243 5-5 0-2.060-1.254-3.892-3.148-4.646zM8 15h-1v-2h1v2zM10 12h-5c-2.206 0-4-1.794-4-4 0-1.444 0.781-2.76 2.001-3.465 0.003 0.369 0.050 0.735 0.141 1.090 0.058 0.226 0.261 0.375 0.484 0.375 0.041 0 0.083-0.005 0.125-0.016 0.267-0.069 0.428-0.341 0.36-0.609-0.073-0.284-0.11-0.579-0.11-0.875 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 0.297-0.037 0.591-0.11 0.875-0.069 0.267 0.092 0.54 0.36 0.609s0.54-0.092 0.609-0.36c0.091-0.355 0.139-0.722 0.141-1.091 1.222 0.704 2.001 2.014 2.001 3.466 0 2.206-1.794 4-4 4z" })
        );
    }
    function Tree4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree4.SVG = Tree4SVG;
    return Tree4;
})();
export const Cactus = /*#__PURE__*/ (() => {
    function CactusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 5h-0.5v-1.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v3c0 0.271-0.229 0.5-0.5 0.5h-1.5v-5.5c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v1.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v5h-1.5c-0.271 0-0.5-0.229-0.5-0.5v-1c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v1c0 1.93 1.57 3.5 3.5 3.5h1.5v4h3v-3h0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.5v-2h1.5c1.93 0 3.5-1.57 3.5-3.5v-0.5h0.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
        );
    }
    function Cactus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CactusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cactus.SVG = CactusSVG;
    return Cactus;
})();
export const Mountains = /*#__PURE__*/ (() => {
    function MountainsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M17.81 15.213l-4.9-7c-0.094-0.134-0.246-0.213-0.41-0.213s-0.316 0.080-0.41 0.213l-1.040 1.486-3.14-4.486c-0.094-0.134-0.246-0.213-0.41-0.213s-0.316 0.080-0.41 0.213l-7 10c-0.107 0.153-0.12 0.352-0.034 0.518s0.257 0.269 0.444 0.269h16.9c0.186 0 0.357-0.104 0.443-0.269s0.073-0.365-0.034-0.518zM7.5 6.372l2.54 3.628h-1.333l-0.854-0.854c-0.195-0.195-0.512-0.195-0.707 0l-0.854 0.854h-1.333l2.54-3.628zM14.76 15l-3.128-4.468 0.037 0.026 0.83-1.186 3.94 5.628h-1.679z" })
        );
    }
    function Mountains({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MountainsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mountains.SVG = MountainsSVG;
    return Mountains;
})();
export const Paw = /*#__PURE__*/ (() => {
    function PawSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.349 8.625c-1.958 0-3.833 0.876-5.043 4.402s1.46 3.245 3.145 2.516c1.631-0.705 2.252-0.813 4.217 0.121 1.85 0.879 3.431-0.038 2.771-1.965s-2.882-5.075-5.090-5.075zM4.645 0.681c-1.116 0.267-1.706 1.784-1.318 3.388s1.608 2.689 2.724 2.422c0.005-0.001 0.010-0.003 0.015-0.004 1.116-0.267 1.706-1.784 1.318-3.388-0.167-0.691-0.488-1.285-0.889-1.716-0.53-0.571-1.199-0.857-1.835-0.706-0.005 0.001-0.010 0.002-0.015 0.004zM11.111 0.625c-1.123-0.235-2.305 0.885-2.64 2.502-0.192 0.929-0.063 1.82 0.296 2.454 0.265 0.469 0.655 0.798 1.133 0.898 0.004 0.001 0.008 0.002 0.012 0.003 1.123 0.235 2.305-0.885 2.64-2.502s-0.305-3.118-1.429-3.353c-0.004-0.001-0.008-0.002-0.012-0.002zM0.322 8.964c0.617 1.427 1.918 2.239 2.905 1.812 0.565-0.244 0.905-0.841 0.977-1.574 0.054-0.548-0.043-1.173-0.307-1.783-0-0.001-0.001-0.002-0.001-0.002-0.617-1.427-1.918-2.239-2.905-1.812s-1.287 1.929-0.67 3.357c0 0.001 0.001 0.002 0.001 0.002zM12.774 10.525c0.562 0.247 1.227 0.090 1.81-0.354 0.439-0.335 0.831-0.832 1.098-1.445 0.621-1.426 0.326-2.932-0.658-3.364-0.004-0.002-0.008-0.004-0.013-0.006-0.985-0.432-2.287 0.373-2.908 1.799s-0.326 2.932 0.658 3.364c0.004 0.002 0.009 0.004 0.013 0.006z" })
        );
    }
    function Paw({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PawSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paw.SVG = PawSVG;
    return Paw;
})();
export const Footprint = /*#__PURE__*/ (() => {
    function FootprintSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.531 3.654c1.923 1.387 2.112 5.737 2.49 7.061l-3.58 1.419c-0.365-2.396-3.45-4.193-3.576-6.841s2.743-3.026 4.666-1.639zM14.707 15.822c-2.858 1.039-3.026-2.806-3.026-2.806l3.72-1.513c0 0 1.734 3.436-0.694 4.319zM0.034 2.985c0.379-2.341 2.675-4.101 4.458-2.14s0.872 5.414 2.308 7.365l-3.534 1.528c-0.669-1.204-3.611-4.413-3.232-6.754zM7.1 13.127c-2.34 1.092-3.544-2.564-3.544-2.564l3.7-1.56c0 0 2.599 2.838-0.156 4.124z" })
        );
    }
    function Footprint({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FootprintSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Footprint.SVG = FootprintSVG;
    return Footprint;
})();
export const Tent = /*#__PURE__*/ (() => {
    function TentSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 14c0-0.205-0.063-0.408-0.186-0.581l-6.585-8.219 2.585-3.619c0.321-0.449 0.217-1.074-0.232-1.395s-1.074-0.217-1.395 0.233l-2.186 3.061-2.186-3.061c-0.321-0.449-0.946-0.553-1.395-0.233s-0.554 0.946-0.232 1.395l2.585 3.619-6.585 8.219c-0.123 0.173-0.186 0.377-0.186 0.581h-0v2h8v-8l4 8h4v-2h-0z" })
        );
    }
    function Tent({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tent.SVG = TentSVG;
    return Tent;
})();
export const Flower = /*#__PURE__*/ (() => {
    function FlowerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.801 5.902c-0.835-2.568-3.368-2.828-5.323-0.876 1.252-2.463 0.222-4.792-2.478-4.792s-3.73 2.329-2.478 4.792c-1.955-1.951-4.488-1.692-5.323 0.876s1.062 4.267 3.791 3.838c-2.46 1.257-2.996 3.746-0.811 5.333s4.386 0.308 4.821-2.42c0.435 2.728 2.637 4.007 4.822 2.42s1.648-4.077-0.812-5.333c2.729 0.429 4.626-1.27 3.792-3.838zM8 10.717c-1.277 0-2.313-1.035-2.313-2.313s1.035-2.313 2.313-2.313c1.277 0 2.313 1.035 2.313 2.313s-1.036 2.313-2.313 2.313z" })
        );
    }
    function Flower({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlowerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flower.SVG = FlowerSVG;
    return Flower;
})();
export const Flower2 = /*#__PURE__*/ (() => {
        function Flower2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.723 15.749c-0.791 0-1.544-0.334-2.119-0.939-0.234-0.247-0.437-0.534-0.605-0.854-0.168 0.321-0.37 0.608-0.605 0.854-0.575 0.606-1.328 0.939-2.119 0.939-0.696 0-1.419-0.256-2.090-0.742-0.977-0.707-1.47-1.677-1.388-2.73 0.064-0.82 0.466-1.61 1.128-2.265-1.026-0.15-1.873-0.614-2.388-1.323-0.553-0.762-0.67-1.758-0.329-2.804 0.457-1.4 1.422-2.204 2.648-2.204 0.555 0 1.136 0.166 1.708 0.481-0.103-0.847 0.056-1.671 0.477-2.359 0.605-0.988 1.683-1.555 2.956-1.555s2.351 0.567 2.956 1.555c0.421 0.687 0.58 1.511 0.477 2.358 0.572-0.315 1.153-0.481 1.708-0.481 1.226 0 2.191 0.803 2.649 2.204 0.341 1.046 0.225 2.042-0.329 2.804-0.514 0.709-1.362 1.172-2.388 1.322 0.662 0.655 1.064 1.444 1.128 2.264 0.082 1.054-0.411 2.023-1.388 2.73-0.671 0.485-1.393 0.742-2.090 0.742zM8 11.844c0.246 0 0.455 0.178 0.494 0.421 0.242 1.509 1.117 2.485 2.23 2.485 0.492 0 0.997-0.186 1.504-0.552 0.694-0.502 1.032-1.139 0.977-1.842-0.072-0.917-0.811-1.84-1.931-2.409-0.219-0.111-0.325-0.366-0.249-0.6s0.31-0.378 0.553-0.34c0.253 0.040 0.506 0.060 0.75 0.060 0 0 0 0 0 0 1.033 0 1.88-0.351 2.324-0.963 0.365-0.503 0.43-1.163 0.187-1.906-0.225-0.691-0.703-1.514-1.698-1.514-0.705 0-1.539 0.427-2.288 1.172-0.174 0.173-0.449 0.194-0.647 0.049s-0.262-0.412-0.151-0.631c0.527-1.033 0.545-2.133 0.049-2.945-0.425-0.695-1.172-1.077-2.104-1.077s-1.678 0.383-2.103 1.077c-0.497 0.811-0.479 1.912 0.049 2.945 0.112 0.219 0.048 0.486-0.151 0.631s-0.473 0.124-0.647-0.049c-0.749-0.745-1.583-1.172-2.288-1.172-0.995 0-1.472 0.823-1.698 1.514-0.243 0.744-0.178 1.403 0.187 1.906 0.444 0.612 1.291 0.963 2.324 0.963 0.244 0 0.496-0.020 0.75-0.060 0.243-0.038 0.477 0.106 0.553 0.34s-0.030 0.488-0.249 0.6c-1.12 0.569-1.859 1.493-1.931 2.41-0.055 0.703 0.283 1.34 0.977 1.842 0.499 0.361 1.019 0.552 1.503 0.552 1.113 0 1.988-0.975 2.23-2.485 0.039-0.243 0.248-0.421 0.494-0.421z" }),
_('path', { d: "M8 10.717c-1.275 0-2.313-1.037-2.313-2.313s1.037-2.313 2.313-2.313c1.275 0 2.313 1.038 2.313 2.313s-1.038 2.313-2.313 2.313zM8 7.092c-0.724 0-1.313 0.589-1.313 1.313s0.589 1.313 1.313 1.313c0.724 0 1.313-0.589 1.313-1.313s-0.589-1.313-1.313-1.313z" })
            );
        }
        function Flower2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flower2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flower2.SVG = Flower2SVG;
        return Flower2;
    })();
export const Rocket = /*#__PURE__*/ (() => {
    function RocketSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 1l-5 5h-3l-3 4c0 0 3.178-0.885 5.032-0.47l-5.032 6.47 6.592-5.127c0.919 2.104-0.592 5.127-0.592 5.127l4-3v-3l5-5 1-5-5 1z" })
        );
    }
    function Rocket({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RocketSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rocket.SVG = RocketSVG;
    return Rocket;
})();
export const Meter = /*#__PURE__*/ (() => {
    function MeterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1c4.418 0 8 3.582 8 8 0 3.012-1.665 5.635-4.125 7h-7.75c-2.46-1.365-4.125-3.988-4.125-7 0-4.418 3.582-8 8-8zM12.53 13.53c1.21-1.21 1.876-2.819 1.876-4.53h-1.406v-1h1.329c-0.11-0.703-0.334-1.377-0.665-2h-1.664v-1h1.004c-0.147-0.184-0.306-0.361-0.475-0.53-0.722-0.722-1.587-1.251-2.53-1.559v1.089h-1v-1.329c-0.328-0.051-0.662-0.078-1-0.078s-0.672 0.026-1 0.078v1.329h-1v-1.089c-0.943 0.309-1.808 0.837-2.53 1.559-0.169 0.169-0.327 0.346-0.475 0.53h1.004v1h-1.664c-0.331 0.623-0.555 1.297-0.665 2h1.329v1h-1.406c0 1.711 0.666 3.32 1.876 4.53 0.167 0.167 0.343 0.324 0.524 0.47h3.006l0.571-8h0.857l0.571 8h3.006c0.182-0.146 0.357-0.303 0.524-0.47z" })
        );
    }
    function Meter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MeterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Meter.SVG = MeterSVG;
    return Meter;
})();
export const Meter2 = /*#__PURE__*/ (() => {
    function Meter2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.732 13.034c0.174-0.479 0.268-0.995 0.268-1.534 0-1.943-1.231-3.598-2.956-4.228 0.16-1.327 0.754-2.555 1.714-3.514 1.133-1.133 2.64-1.757 4.243-1.757s3.109 0.624 4.243 1.757c0.96 0.96 1.554 2.188 1.714 3.514-1.725 0.63-2.956 2.285-2.956 4.228 0 0.539 0.095 1.055 0.268 1.534-0.964 0.629-2.090 0.966-3.268 0.966s-2.304-0.338-3.268-0.966zM8.621 10.016c0.217 0.055 0.379 0.251 0.379 0.484v1c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.233 0.162-0.43 0.379-0.484l0.371-7.016h0.5l0.371 7.016z" })
        );
    }
    function Meter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Meter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Meter2.SVG = Meter2SVG;
    return Meter2;
})();
export const MeterSlow = /*#__PURE__*/ (() => {
    function MeterSlowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4c-4.418 0-8 3.582-8 8h1c0-1.819 0.809-3.449 2.088-4.549l3.052 3.815c-0.090 0.227-0.14 0.475-0.14 0.734 0 1.105 0.895 2 2 2s2-0.895 2-2-0.895-2-2-2c-0.259 0-0.507 0.050-0.734 0.14l-3.766-3.013c0.985-0.709 2.194-1.127 3.501-1.127 3.314 0 6 2.686 6 6h3c0-4.418-3.582-8-8-8z" })
        );
    }
    function MeterSlow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MeterSlowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MeterSlow.SVG = MeterSlowSVG;
    return MeterSlow;
})();
export const MeterMedium = /*#__PURE__*/ (() => {
    function MeterMediumSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4c-4.418 0-8 3.582-8 8h1c0-3.314 2.686-6 6-6 0.15 0 0.299 0.006 0.446 0.017l-0.446 4.251h0.001c-0.598 0.346-1.001 0.992-1.001 1.732 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.741-0.403-1.387-1.001-1.732h0.001l-0.426-4.059c2.55 0.692 4.426 3.022 4.426 5.791h3c0-4.418-3.582-8-8-8z" })
        );
    }
    function MeterMedium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MeterMediumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MeterMedium.SVG = MeterMediumSVG;
    return MeterMedium;
})();
export const MeterFast = /*#__PURE__*/ (() => {
    function MeterFastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4c-4.418 0-8 3.582-8 8h1c0-3.314 2.686-6 6-6 1.763 0 3.348 0.76 4.446 1.971l-2.711 2.169c-0.227-0.090-0.475-0.14-0.734-0.14-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2 0-0.259-0.050-0.507-0.14-0.734l2.106-2.633c0.652 0.96 1.033 2.119 1.033 3.367h3c0-4.418-3.582-8-8-8z" })
        );
    }
    function MeterFast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MeterFastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MeterFast.SVG = MeterFastSVG;
    return MeterFast;
})();
export const Meter3 = /*#__PURE__*/ (() => {
        function Meter3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6zM7 4c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z" }),
_('path', { d: "M8.25 6h-0.5l-0.75 5v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1l-0.75-5z" })
            );
        }
        function Meter3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Meter3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Meter3.SVG = Meter3SVG;
        return Meter3;
    })();
export const Hammer2 = /*#__PURE__*/ (() => {
    function Hammer2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.784 14.309l-8.572-7.804 0.399-0.4c0.326-0.327 0.503-0.75 0.53-1.181 0.016-0.007 0.031-0.014 0.046-0.023l1.609-1.006c0.218-0.256 0.202-0.66-0.036-0.898l-2.799-2.806c-0.237-0.238-0.641-0.254-0.896-0.036l-1.004 1.614c-0.008 0.015-0.015 0.031-0.022 0.046-0.43 0.027-0.852 0.204-1.178 0.531l-1.522 1.527c-0.327 0.327-0.503 0.75-0.53 1.181-0.016 0.007-0.031 0.014-0.046 0.023l-1.609 1.006c-0.218 0.256-0.202 0.66 0.036 0.898l2.799 2.806c0.237 0.238 0.641 0.254 0.896 0.036l1.004-1.614c0.008-0.015 0.015-0.031 0.023-0.046 0.43-0.027 0.852-0.204 1.178-0.531l0.442-0.443 7.783 8.596c0.226 0.249 0.573 0.289 0.773 0.089l0.787-0.789c0.199-0.2 0.159-0.549-0.089-0.775z" })
        );
    }
    function Hammer2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Hammer2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hammer2.SVG = Hammer2SVG;
    return Hammer2;
})();
export const Balance = /*#__PURE__*/ (() => {
        function BalanceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 7.5v-0.5h-6v0.5c0 0.828 0.672 1.5 1.5 1.5h3c0.828 0 1.5-0.672 1.5-1.5z" }),
_('path', { d: "M10 7.5c0 0.828 0.672 1.5 1.5 1.5h3c0.828 0 1.5-0.672 1.5-1.5v-0.5h-6v0.5z" }),
_('path', { d: "M9 2h3.15l-2.087 3.757c-0.134 0.241-0.047 0.546 0.194 0.68s0.546 0.047 0.68-0.194l2.063-3.713 2.063 3.713c0.091 0.164 0.262 0.257 0.438 0.257 0.082 0 0.165-0.020 0.242-0.063 0.241-0.134 0.328-0.439 0.194-0.68l-2.5-4.5c-0.088-0.159-0.255-0.257-0.437-0.257h-4c0-0.552-0.448-1-1-1s-1 0.448-1 1h-4c-0.182 0-0.349 0.098-0.437 0.257l-2.5 4.5c-0.134 0.241-0.047 0.546 0.194 0.68s0.546 0.047 0.68-0.194l2.063-3.713 2.063 3.713c0.091 0.164 0.262 0.257 0.438 0.257 0.082 0 0.165-0.020 0.242-0.063 0.241-0.134 0.328-0.439 0.194-0.68l-2.087-3.757h3.15v12l-3 1v1h8v-1l-3-1v-12z" })
            );
        }
        function Balance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BalanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Balance.SVG = BalanceSVG;
        return Balance;
    })();
export const Scale = /*#__PURE__*/ (() => {
    function ScaleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 1h-12c-0.825 0-1.5 0.675-1.5 1.5v12c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-12c0-0.825-0.675-1.5-1.5-1.5zM10.5 8h-2.5v-3.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v3.5h-2.5l-1.933-1.933c0.898-1.817 2.769-3.067 4.933-3.067s4.035 1.25 4.933 3.067l-1.933 1.933z" })
        );
    }
    function Scale({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Scale.SVG = ScaleSVG;
    return Scale;
})();
export const Bomb = /*#__PURE__*/ (() => {
    function BombSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 1v0.414l-0.586 0.586 0.586 0.586v0.414h-1v1h-0.414l-0.586-0.586-0.586 0.586h-0.414v-1h-1v-0.012c-0.203-0.007-0.397-0.048-0.583-0.124-0.463-0.189-0.78-0.548-1.087-0.895-0.302-0.342-0.588-0.665-0.988-0.799-0.505-0.168-1.207-0.298-1.677 0.041-0.223 0.16-0.391 0.427-0.503 0.788h0.088c0.412 0 0.75 0.337 0.75 0.75v0.424c2.867 0.677 5 3.252 5 6.326 0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5c0-3.074 2.133-5.649 5-6.326v-0.424c0-0.413 0.338-0.75 0.75-0.75h0.378c0.163-0.724 0.481-1.259 0.952-1.599 0.644-0.464 1.536-0.526 2.578-0.179 0.656 0.218 1.062 0.679 1.421 1.085 0.474 0.537 0.742 0.839 1.414 0.6l-0.494-0.494v-0.414h1v-1h0.414l0.586 0.586 0.586-0.586h0.414v1h1z" })
        );
    }
    function Bomb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BombSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bomb.SVG = BombSVG;
    return Bomb;
})();
export const Fire = /*#__PURE__*/ (() => {
    function FireSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.016 16c-1.066-2.219-0.498-3.49 0.321-4.688 0.897-1.312 1.129-2.61 1.129-2.61s0.706 0.917 0.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013 0.376 0.823 0.448 2.216-0.313 2.893-1.287-4.879-4.468-5.879-4.468-5.879 0.376 2.516-1.364 5.268-3.042 7.324-0.059-1.003-0.122-1.696-0.649-2.656-0.118 1.823-1.511 3.309-1.889 5.135-0.511 2.473 0.383 4.284 3.777 6.197z" })
        );
    }
    function Fire({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FireSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fire.SVG = FireSVG;
    return Fire;
})();
export const Fire2 = /*#__PURE__*/ (() => {
    function Fire2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c0 0-6 6-6 10 0 3.314 2.686 6 6 6s6-2.686 6-6c0-4-6-10-6-10zM8 14c-1.381 0-2.5-1.119-2.5-2.5 0-1.667 2.5-4.167 2.5-4.167s2.5 2.5 2.5 4.167c0 1.381-1.119 2.5-2.5 2.5z" })
        );
    }
    function Fire2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Fire2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fire2.SVG = Fire2SVG;
    return Fire2;
})();
export const Lab = /*#__PURE__*/ (() => {
    function LabSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.942 12.57l-4.942-8.235v-3.335h0.5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h0.5v3.335l-4.942 8.235c-1.132 1.886-0.258 3.43 1.942 3.43h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10l3.234-5.39v-3.61h2v3.61l3.234 5.39h-8.468z" })
        );
    }
    function Lab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lab.SVG = LabSVG;
    return Lab;
})();
export const Atom = /*#__PURE__*/ (() => {
    function AtomSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.999 3.23v0 0zM13.032 8c1.631-1.56 2.423-3.087 1.896-4-0.301-0.521-0.99-0.77-1.929-0.77v0.75c0.659 0 1.137 0.148 1.28 0.395 0.113 0.195 0.050 0.496-0.023 0.713-0.139 0.417-0.442 0.917-0.876 1.444-0.263 0.32-0.567 0.643-0.904 0.963-0.465-0.402-0.982-0.801-1.544-1.188-0.055-0.679-0.142-1.327-0.257-1.93 0.878-0.26 1.675-0.397 2.323-0.397l0-0.75c-0 0-0 0-0 0-0.706 0-1.553 0.141-2.482 0.413-0.535-2.192-1.462-3.642-2.516-3.642s-1.981 1.45-2.516 3.642c-0.929-0.271-1.777-0.412-2.482-0.412-0.939 0-1.629 0.249-1.93 0.77-0.527 0.913 0.265 2.44 1.896 4-1.631 1.56-2.423 3.087-1.896 4 0.301 0.521 0.99 0.77 1.93 0.77 0.706 0 1.553-0.141 2.482-0.412 0.535 2.192 1.462 3.642 2.516 3.642s1.981-1.45 2.516-3.642c0.929 0.271 1.777 0.412 2.482 0.412 0.939 0 1.629-0.249 1.93-0.77 0.527-0.913-0.265-2.44-1.896-4zM11.915 8c-0.291 0.248-0.601 0.493-0.927 0.734 0.008-0.242 0.013-0.487 0.013-0.734s-0.004-0.492-0.013-0.734c0.327 0.241 0.637 0.486 0.927 0.734zM9.958 11.389c-0.36-0.128-0.728-0.274-1.098-0.435 0.213-0.113 0.426-0.232 0.64-0.355s0.424-0.25 0.63-0.378c-0.045 0.403-0.103 0.793-0.172 1.169zM9.125 9.949c-0.372 0.214-0.748 0.416-1.125 0.603-0.377-0.187-0.753-0.389-1.125-0.603-0.375-0.216-0.737-0.441-1.086-0.672-0.026-0.417-0.039-0.844-0.039-1.276s0.013-0.859 0.039-1.276c0.349-0.231 0.711-0.456 1.086-0.672 0.372-0.215 0.748-0.416 1.125-0.603 0.377 0.187 0.753 0.389 1.125 0.603 0.375 0.216 0.737 0.441 1.086 0.672 0.026 0.417 0.039 0.844 0.039 1.276s-0.013 0.859-0.039 1.276c-0.349 0.231-0.711 0.456-1.086 0.672zM5.87 10.22c0.205 0.128 0.415 0.254 0.63 0.378s0.427 0.242 0.64 0.355c-0.37 0.162-0.738 0.307-1.098 0.435-0.069-0.375-0.127-0.766-0.172-1.168zM5.013 8.734c-0.327-0.241-0.637-0.486-0.927-0.734 0.291-0.248 0.601-0.494 0.927-0.734-0.008 0.242-0.013 0.487-0.013 0.734s0.004 0.492 0.013 0.734zM6.042 4.612c0.36 0.128 0.728 0.274 1.098 0.435-0.213 0.113-0.426 0.232-0.64 0.355s-0.424 0.25-0.63 0.378c0.045-0.403 0.103-0.793 0.172-1.168zM9.5 5.402c-0.214-0.123-0.427-0.242-0.64-0.355 0.37-0.162 0.738-0.307 1.098-0.435 0.069 0.375 0.127 0.766 0.172 1.168-0.205-0.128-0.415-0.254-0.63-0.378zM6.581 2.607c0.24-0.639 0.521-1.151 0.813-1.48 0.152-0.172 0.381-0.376 0.607-0.376s0.454 0.205 0.607 0.376c0.292 0.329 0.573 0.841 0.813 1.48 0.146 0.388 0.273 0.812 0.382 1.265-0.58 0.202-1.185 0.45-1.801 0.743-0.616-0.292-1.221-0.541-1.801-0.743 0.109-0.453 0.237-0.877 0.382-1.265zM2.62 6.532c-0.434-0.527-0.736-1.026-0.876-1.444-0.073-0.218-0.135-0.518-0.023-0.713 0.143-0.247 0.621-0.395 1.28-0.395h0c0.648 0 1.445 0.137 2.323 0.397-0.115 0.603-0.202 1.251-0.257 1.93-0.561 0.387-1.079 0.787-1.544 1.188-0.338-0.321-0.641-0.643-0.904-0.963zM3.002 12.020c-0.659 0-1.137-0.148-1.28-0.395-0.113-0.195-0.050-0.496 0.023-0.713 0.139-0.417 0.442-0.917 0.876-1.444 0.263-0.32 0.567-0.643 0.904-0.963 0.465 0.402 0.982 0.801 1.544 1.188 0.055 0.679 0.142 1.327 0.257 1.93-0.878 0.26-1.675 0.397-2.323 0.397zM9.419 13.393c-0.24 0.639-0.521 1.151-0.813 1.48-0.152 0.172-0.381 0.376-0.607 0.376s-0.454-0.205-0.607-0.376c-0.292-0.329-0.573-0.841-0.813-1.48-0.146-0.388-0.273-0.812-0.382-1.265 0.58-0.202 1.185-0.45 1.801-0.743 0.616 0.292 1.221 0.541 1.801 0.743-0.109 0.453-0.236 0.877-0.382 1.265zM14.256 10.912c0.073 0.218 0.135 0.518 0.023 0.713-0.143 0.248-0.622 0.395-1.28 0.395-0.648 0-1.445-0.137-2.323-0.397 0.115-0.603 0.202-1.251 0.257-1.93 0.561-0.387 1.079-0.787 1.544-1.188 0.338 0.321 0.641 0.643 0.904 0.963 0.434 0.527 0.736 1.026 0.876 1.444z" })
        );
    }
    function Atom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AtomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Atom.SVG = AtomSVG;
    return Atom;
})();
export const Atom2 = /*#__PURE__*/ (() => {
    function Atom2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.999 3.23v0 0zM13.032 8c1.631-1.56 2.423-3.087 1.896-4-0.301-0.521-0.99-0.77-1.929-0.77v0.75c0.659 0 1.137 0.148 1.28 0.395 0.113 0.195 0.050 0.496-0.023 0.713-0.139 0.417-0.442 0.917-0.876 1.444-0.263 0.32-0.567 0.643-0.904 0.963-0.465-0.402-0.982-0.801-1.544-1.188-0.055-0.679-0.142-1.327-0.257-1.93 0.878-0.26 1.675-0.397 2.323-0.397l0-0.75c-0 0-0 0-0 0-0.706 0-1.553 0.141-2.482 0.413-0.535-2.192-1.462-3.642-2.516-3.642s-1.981 1.45-2.516 3.642c-0.929-0.271-1.777-0.412-2.482-0.412-0.939 0-1.629 0.249-1.93 0.77-0.527 0.913 0.265 2.44 1.896 4-1.631 1.559-2.423 3.087-1.896 4 0.301 0.521 0.99 0.77 1.93 0.77 0.706 0 1.553-0.141 2.482-0.412 0.535 2.192 1.462 3.642 2.516 3.642s1.981-1.45 2.516-3.642c0.929 0.271 1.777 0.412 2.482 0.412 0.939 0 1.629-0.249 1.93-0.77 0.527-0.913-0.265-2.441-1.896-4zM11.915 8c-0.291 0.248-0.601 0.493-0.927 0.734 0.008-0.242 0.013-0.487 0.013-0.734s-0.004-0.492-0.013-0.734c0.327 0.241 0.637 0.486 0.927 0.734zM9.958 11.389c-0.36-0.128-0.728-0.274-1.098-0.435 0.213-0.113 0.426-0.232 0.64-0.355s0.424-0.25 0.63-0.378c-0.045 0.403-0.103 0.793-0.172 1.169zM9.125 9.949c-0.372 0.214-0.748 0.416-1.125 0.603-0.377-0.187-0.753-0.389-1.125-0.603-0.375-0.216-0.737-0.441-1.086-0.672-0.026-0.417-0.039-0.844-0.039-1.277s0.013-0.859 0.039-1.276c0.349-0.231 0.711-0.456 1.086-0.672 0.372-0.215 0.748-0.416 1.125-0.603 0.377 0.187 0.753 0.389 1.125 0.603 0.375 0.216 0.737 0.441 1.086 0.672 0.026 0.417 0.039 0.844 0.039 1.276s-0.013 0.859-0.039 1.277c-0.349 0.231-0.711 0.456-1.086 0.672zM5.87 10.22c0.205 0.128 0.415 0.254 0.63 0.378s0.427 0.242 0.64 0.355c-0.37 0.162-0.738 0.307-1.098 0.435-0.069-0.375-0.127-0.766-0.172-1.168zM5.013 8.734c-0.327-0.241-0.637-0.486-0.927-0.734 0.291-0.248 0.601-0.494 0.927-0.734-0.008 0.242-0.013 0.487-0.013 0.734s0.004 0.492 0.013 0.734zM6.042 4.612c0.36 0.128 0.728 0.274 1.098 0.435-0.213 0.113-0.426 0.232-0.64 0.355s-0.424 0.25-0.63 0.378c0.045-0.403 0.103-0.793 0.172-1.168zM9.5 5.402c-0.214-0.123-0.427-0.242-0.64-0.355 0.37-0.162 0.738-0.307 1.098-0.435 0.069 0.375 0.127 0.766 0.172 1.168-0.205-0.128-0.415-0.254-0.63-0.378zM6.581 2.607c0.24-0.639 0.521-1.151 0.813-1.48 0.152-0.172 0.381-0.376 0.607-0.376s0.454 0.205 0.607 0.376c0.292 0.329 0.573 0.841 0.813 1.48 0.146 0.388 0.273 0.812 0.382 1.265-0.58 0.202-1.185 0.45-1.801 0.743-0.616-0.292-1.221-0.541-1.801-0.743 0.109-0.453 0.237-0.877 0.382-1.265zM2.62 6.532c-0.434-0.527-0.736-1.026-0.876-1.444-0.073-0.218-0.135-0.518-0.023-0.713 0.143-0.247 0.621-0.395 1.28-0.395h0c0.648 0 1.445 0.137 2.323 0.397-0.115 0.603-0.202 1.251-0.257 1.93-0.561 0.387-1.079 0.787-1.544 1.188-0.338-0.321-0.641-0.643-0.904-0.963zM3.002 12.020c-0.659 0-1.137-0.148-1.28-0.395-0.113-0.195-0.050-0.496 0.023-0.713 0.139-0.417 0.442-0.917 0.876-1.444 0.263-0.32 0.567-0.643 0.904-0.963 0.465 0.402 0.982 0.801 1.544 1.188 0.055 0.679 0.142 1.327 0.257 1.93-0.878 0.26-1.675 0.397-2.323 0.397zM9.419 13.393c-0.24 0.639-0.521 1.151-0.813 1.48-0.152 0.172-0.381 0.376-0.607 0.376s-0.454-0.205-0.607-0.376c-0.292-0.329-0.573-0.841-0.813-1.48-0.146-0.388-0.273-0.812-0.382-1.265 0.58-0.202 1.185-0.45 1.801-0.743 0.616 0.292 1.221 0.541 1.801 0.743-0.109 0.453-0.236 0.877-0.382 1.265zM14.256 10.912c0.073 0.218 0.135 0.518 0.023 0.713-0.143 0.248-0.622 0.395-1.28 0.395-0.648 0-1.445-0.137-2.323-0.397 0.115-0.603 0.202-1.251 0.257-1.93 0.561-0.387 1.079-0.787 1.544-1.188 0.338 0.321 0.641 0.643 0.904 0.963 0.434 0.527 0.736 1.027 0.876 1.444zM6.75 8c0-0.69 0.56-1.25 1.25-1.25s1.25 0.56 1.25 1.25c0 0.69-0.56 1.25-1.25 1.25s-1.25-0.56-1.25-1.25z" })
        );
    }
    function Atom2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Atom2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Atom2.SVG = Atom2SVG;
    return Atom2;
})();
export const Magnet = /*#__PURE__*/ (() => {
        function MagnetSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6v4c0 1.103 0.897 2 2 2s2-0.897 2-2v-4h4v4c0 3.314-2.686 6-6 6s-6-2.686-6-6v-4h4z" }),
_('path', { d: "M14 2.75v2.25h-4v-2.25c0-0.413 0.338-0.75 0.75-0.75h2.5c0.412 0 0.75 0.337 0.75 0.75z" }),
_('path', { d: "M6 2.75v2.25h-4v-2.25c0-0.413 0.337-0.75 0.75-0.75h2.5c0.412 0 0.75 0.337 0.75 0.75z" })
            );
        }
        function Magnet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MagnetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Magnet.SVG = MagnetSVG;
        return Magnet;
    })();
export const Magnet2 = /*#__PURE__*/ (() => {
    function Magnet2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-4l1 9c0 1.657-1.343 3-3 3s-3-1.343-3-3l1-9h-4l-1 9c0 3.866 3.134 7 7 7s7-3.134 7-7l-1-9zM12.154 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-0.611-4.154-1.721c-1.096-1.096-1.705-2.548-1.72-4.095l0.564-5.075h1.736l-0.55 4.953v0.062c0 1.102 0.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-0.429 2.917-1.208c0.779-0.779 1.208-1.815 1.208-2.917v-0.062l-0.007-0.062-0.543-4.891h1.736l0.564 5.075c-0.015 1.547-0.625 2.999-1.72 4.095z" })
        );
    }
    function Magnet2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Magnet2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Magnet2.SVG = Magnet2SVG;
    return Magnet2;
})();
export const Dumbbell = /*#__PURE__*/ (() => {
    function DumbbellSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.25 4h-0.5c-0.137 0-0.25 0.112-0.25 0.25v7.5c0 0.137 0.113 0.25 0.25 0.25h0.5c0.138 0 0.25-0.113 0.25-0.25v-7.5c0-0.138-0.112-0.25-0.25-0.25zM0.75 6h-0.5c-0.138 0-0.25 0.075-0.25 0.167v3.667c0 0.092 0.113 0.167 0.25 0.167h0.5c0.137 0 0.25-0.075 0.25-0.167v-3.667c0-0.092-0.113-0.167-0.25-0.167zM12.5 3h-1c-0.275 0-0.5 0.225-0.5 0.5v3.5h-6v-3.5c0-0.275-0.225-0.5-0.5-0.5h-1c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-3.5h6v3.5c0 0.275 0.225 0.5 0.5 0.5h1c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM14.25 4h-0.5c-0.137 0-0.25 0.112-0.25 0.25v7.5c0 0.137 0.113 0.25 0.25 0.25h0.5c0.137 0 0.25-0.113 0.25-0.25v-7.5c0-0.138-0.113-0.25-0.25-0.25zM15.75 6h-0.5c-0.137 0-0.25 0.075-0.25 0.167v3.667c0 0.092 0.113 0.167 0.25 0.167h0.5c0.137 0 0.25-0.075 0.25-0.167v-3.667c0-0.092-0.113-0.167-0.25-0.167z" })
        );
    }
    function Dumbbell({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DumbbellSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dumbbell.SVG = DumbbellSVG;
    return Dumbbell;
})();
export const Skull = /*#__PURE__*/ (() => {
    function SkullSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.803 3.197c-1.417-1.417-3.3-2.197-5.303-2.197s-3.887 0.78-5.303 2.197-2.197 3.3-2.197 5.303c0 0.276 0.224 0.5 0.5 0.5 1.93 0 3.5 1.57 3.5 3.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2c0-1.93 1.57-3.5 3.5-3.5 0.276 0 0.5-0.224 0.5-0.5 0-2.003-0.78-3.887-2.197-5.303zM6 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1zM12 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1z" })
        );
    }
    function Skull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SkullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Skull.SVG = SkullSVG;
    return Skull;
})();
export const Skull2 = /*#__PURE__*/ (() => {
        function Skull2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 16c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8.5 16c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 15c-0.276 0-0.5-0.224-0.5-0.5v-2c0-2.307 1.744-4.213 3.983-4.471-0.242-3.365-3.057-6.029-6.483-6.029s-6.241 2.664-6.483 6.029c2.239 0.257 3.983 2.164 3.983 4.471v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2c0-1.93-1.57-3.5-3.5-3.5-0.276 0-0.5-0.224-0.5-0.5 0-2.003 0.78-3.887 2.197-5.303s3.3-2.197 5.303-2.197 3.887 0.78 5.303 2.197 2.197 3.3 2.197 5.303c0 0.276-0.224 0.5-0.5 0.5-1.93 0-3.5 1.57-3.5 3.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M6 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1z" }),
_('path', { d: "M12 7c0 0.55-0.45 1-1 1h-1c-0.55 0-1-0.45-1-1v-1c0-0.55 0.45-1 1-1h1c0.55 0 1 0.45 1 1v1z" })
            );
        }
        function Skull2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Skull2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Skull2.SVG = Skull2SVG;
        return Skull2;
    })();
export const Lamp = /*#__PURE__*/ (() => {
    function LampSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.907 7.209l-5-7c-0.094-0.131-0.245-0.209-0.407-0.209h-4c-0.161 0-0.313 0.078-0.407 0.209l-5 7c-0.109 0.152-0.123 0.353-0.038 0.519s0.257 0.271 0.445 0.271h5.5v1.5c0 0.388-0.414 0.646-1.089 1.036-0.429 0.248-0.872 0.504-1.234 0.867-0.449 0.45-0.677 0.988-0.677 1.597 0 0.875 0.070 1.856 0.91 2.416 0.729 0.486 1.914 0.584 3.59 0.584s2.86-0.098 3.59-0.584c0.84-0.56 0.91-1.541 0.91-2.416 0-0.61-0.228-1.147-0.677-1.597-0.362-0.363-0.806-0.619-1.234-0.867-0.675-0.39-1.089-0.648-1.089-1.036v-1.5h5.5c0.187 0 0.359-0.105 0.445-0.271s0.071-0.367-0.038-0.519zM1.472 7l0.714-1h10.628l0.714 1h-12.057z" })
        );
    }
    function Lamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp.SVG = LampSVG;
    return Lamp;
})();
export const Lamp2 = /*#__PURE__*/ (() => {
    function Lamp2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.907 7.209l-5-7c-0.094-0.131-0.245-0.209-0.407-0.209h-4c-0.161 0-0.313 0.078-0.407 0.209l-5 7c-0.109 0.152-0.123 0.353-0.038 0.519s0.257 0.271 0.445 0.271h5.5v1.5c0 0.388-0.414 0.646-1.089 1.036-0.429 0.248-0.872 0.504-1.234 0.867-0.449 0.45-0.677 0.988-0.677 1.597 0 0.875 0.070 1.856 0.91 2.416 0.729 0.486 1.914 0.584 3.59 0.584s2.86-0.098 3.59-0.584c0.84-0.56 0.91-1.541 0.91-2.416 0-0.61-0.228-1.147-0.677-1.597-0.362-0.363-0.806-0.619-1.234-0.867-0.675-0.39-1.089-0.648-1.089-1.036v-1.5h5.5c0.187 0 0.359-0.105 0.445-0.271s0.071-0.367-0.038-0.519zM5.757 1h3.485l2.857 4h-9.2l2.857-4zM9.589 11.402c0.878 0.507 1.411 0.867 1.411 1.598 0 0.953-0.117 1.352-0.465 1.584-0.437 0.292-1.345 0.416-3.035 0.416s-2.598-0.124-3.035-0.416c-0.348-0.232-0.465-0.631-0.465-1.584 0-0.73 0.533-1.091 1.411-1.598 0.745-0.43 1.589-0.917 1.589-1.902v-1.5h1v1.5c0 0.985 0.844 1.472 1.589 1.902zM1.472 7l0.714-1h10.628l0.714 1h-12.057z" })
        );
    }
    function Lamp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lamp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp2.SVG = Lamp2SVG;
    return Lamp2;
})();
export const Lamp3 = /*#__PURE__*/ (() => {
    function Lamp3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9v-6c0-0.552-0.448-1-1-1h-11c-0.552 0-1 0.448-1 1v6h5v5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.5v-5h2v3c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1v-2h2zM12 3h1v5h-1v-5zM3 8h-1v-5h1v5zM5 8h-1v-5h1v5zM7 8h-1v-5h1v5zM9 8h-1v-5h1v5zM11 8h-1v-5h1v5z" })
        );
    }
    function Lamp3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lamp3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp3.SVG = Lamp3SVG;
    return Lamp3;
})();
export const Spotlight = /*#__PURE__*/ (() => {
        function SpotlightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 0h11v1h-11v-1z" }),
_('path', { d: "M5 5v11h5v-11l2.625-3.5h-10.25l2.625 3.5zM9 10.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-2c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5v2z" }),
_('path', { d: "M7.5 11c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Spotlight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpotlightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Spotlight.SVG = SpotlightSVG;
        return Spotlight;
    })();
export const Lamp4 = /*#__PURE__*/ (() => {
    function Lamp4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-3.314 0-6 2.686-6 6 0 2.221 1.207 4.16 3 5.197v3.803l1 1h4l1-1v-3.803c1.793-1.037 3-2.976 3-5.197 0-3.314-2.686-6-6-6zM5 5c0-0.552 0.448-1 1-1s1 0.448 1 1v4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.5c-0.552 0-1-0.448-1-1zM9.5 13h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM10 6v3.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-4.5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1zM9.5 15h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function Lamp4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lamp4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp4.SVG = Lamp4SVG;
    return Lamp4;
})();
export const Lamp5 = /*#__PURE__*/ (() => {
    function Lamp5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 6c0-3.314-2.686-6-6-6s-6 2.686-6 6c0 2.221 1.207 4.16 3 5.197v3.803l1 1h4l1-1v-3.803c1.793-1.037 3-2.976 3-5.197zM9.5 13h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM10 10.585v-4.585c0.552 0 1-0.448 1-1s-0.448-1-1-1-1 0.448-1 1v5.9c-0.326 0.066-0.66 0.1-1 0.1s-0.674-0.034-1-0.1v-5.9c0-0.552-0.448-1-1-1s-1 0.448-1 1 0.448 1 1 1v4.585c-0.566-0.247-1.086-0.6-1.536-1.050-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536 2.2-1.464 3.536-1.464c1.335 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536-0.52 2.591-1.464 3.536c-0.45 0.45-0.97 0.803-1.536 1.050zM9.5 15h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function Lamp5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lamp5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp5.SVG = Lamp5SVG;
    return Lamp5;
})();
export const Lamp6 = /*#__PURE__*/ (() => {
    function Lamp6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-3.314 0-6 2.686-6 6 0 2.221 1.207 4.16 3 5.197v3.803l1 1h4l1-1v-3.803c1.793-1.037 3-2.976 3-5.197 0-3.314-2.686-6-6-6zM7 10.625v-0.25h2v0.25h-2zM9 10.875v0.025c-0.326 0.066-0.66 0.1-1 0.1s-0.674-0.034-1-0.1v-0.025h2zM7 10.125v-0.25h2v0.25h-2zM7 9.625v-0.25h2v0.25h-2zM7 9.125v-0.25h2v0.25h-2zM7 8.625v-0.25h2v0.25h-2zM7 8.125v-0.25h2v0.25h-2zM7 7.625v-0.25h2v0.25h-2zM7 7.125v-0.25h2v0.25h-2zM7 6.625v-0.25h2v0.25h-2zM7 6.125v-0.25h2v0.25h-2zM7 5.625v-0.25h2v0.25h-2zM7 5.125v-0.125c0-0.042-0.003-0.084-0.008-0.125h2.016c-0.005 0.041-0.008 0.083-0.008 0.125v0.125h-2zM9.073 4.625h-2.146c0 0 0 0 0 0-0.037-0.091-0.086-0.175-0.147-0.25 0 0 0 0 0 0h2.439c-0.060 0.075-0.11 0.159-0.147 0.25zM9.051 4.684c-0 0-0 0.001-0 0.001s0-0.001 0-0.001zM6.949 4.686c-0-0-0-0.001-0-0.001s0 0.001 0 0.001zM6.484 4.125c0 0 0 0 0 0-0.144-0.080-0.309-0.125-0.484-0.125s-0.341 0.046-0.484 0.125c0-0 0-0 0-0h-2.154c0.069-0.171 0.147-0.338 0.235-0.5-0.044 0.082-0.087 0.165-0.126 0.25h9.057c0.039 0.082 0.075 0.166 0.109 0.25h-2.154c0 0 0 0 0 0-0.144-0.080-0.309-0.125-0.485-0.125s-0.341 0.046-0.485 0.125c0-0 0-0 0-0h-3.032zM9.474 4.15c-0 0-0.001 0.001-0.001 0.001s0.001-0.001 0.001-0.001zM9.433 4.176c-0.001 0-0.001 0.001-0.001 0.001 0.001-0 0.001-0.001 0.001-0.001zM9.394 4.205c-0 0-0.001 0.001-0.001 0.001s0.001-0.001 0.001-0.001zM9.355 4.236c-0 0-0 0-0.001 0.001s0-0 0.001-0.001zM9.319 4.268c-0 0-0 0-0 0s0-0 0-0zM6.749 4.338c0 0 0-0 0 0s0 0 0 0zM6.716 4.302c-0-0-0-0-0-0s0 0 0 0zM6.681 4.268c-0-0-0-0-0-0s0 0 0 0zM6.645 4.236c-0-0-0.001-0.001-0.001-0.001s0.001 0.001 0.001 0.001zM6.608 4.206c-0-0-0.001-0.001-0.002-0.001s0.001 0.001 0.002 0.001zM6.568 4.177c-0-0-0.001-0.001-0.002-0.001 0.001 0 0.001 0.001 0.002 0.001zM6.527 4.15c-0-0-0.001-0-0.001-0.001s0.001 0 0.001 0.001zM5.008 5.125h-1.932c-0.007 0.041-0.014 0.082-0.020 0.124 0.019-0.126 0.043-0.251 0.071-0.374h1.881c-0.005 0.041-0.008 0.083-0.008 0.125s0.003 0.084 0.008 0.125zM3.191 4.625c-0.012 0.041-0.023 0.082-0.033 0.123 0.043-0.169 0.096-0.335 0.156-0.498-0.015 0.041-0.030 0.083-0.045 0.125h1.951c0-0 0-0 0-0-0.060 0.075-0.11 0.159-0.147 0.25 0-0 0-0 0-0h-1.882zM5.051 4.684c-0 0-0 0.001-0 0.001s0-0.001 0-0.001zM3.127 4.874c0.010-0.041 0.020-0.083 0.030-0.124-0.011 0.041-0.021 0.082-0.030 0.124zM5.474 4.15c-0 0-0.001 0-0.001 0.001s0.001-0 0.001-0.001zM5.433 4.176c-0 0-0.001 0.001-0.002 0.001 0.001-0 0.001-0.001 0.002-0.001zM5.394 4.205c-0.001 0-0.001 0.001-0.002 0.001s0.001-0.001 0.002-0.001zM5.356 4.236c-0 0-0.001 0.001-0.001 0.001s0.001-0.001 0.001-0.001zM5.319 4.268c-0 0-0 0-0 0s0-0 0-0zM5.284 4.302c-0 0-0 0-0 0s0-0 0-0zM5.251 4.338c-0 0-0 0 0 0s-0 0 0 0zM3.314 4.248c0.015-0.041 0.031-0.082 0.048-0.123-0.017 0.041-0.033 0.082-0.048 0.123zM10.949 5.315c-0 0-0 0.001-0 0.001s0-0.001 0-0.001zM10.949 4.684c0 0 0 0.001 0 0.001s-0-0.001-0-0.001zM10.927 5.375h2.034c-0.010-0.084-0.023-0.167-0.037-0.25 0.029 0.165 0.050 0.331 0.062 0.5h-2.206c0.060-0.075 0.11-0.159 0.147-0.25v0zM10.992 5.125c0.005-0.041 0.008-0.083 0.008-0.125s-0.003-0.084-0.008-0.125h1.882c0.019 0.083 0.036 0.166 0.051 0.25h-1.932zM10.927 4.625c-0.037-0.091-0.086-0.175-0.147-0.25h1.951c0.028 0.083 0.054 0.166 0.078 0.25h-1.882zM12.809 4.625c0.012 0.041 0.023 0.082 0.033 0.124-0.011-0.041-0.022-0.083-0.033-0.124zM12.843 4.75c0.011 0.042 0.021 0.083 0.030 0.125-0.010-0.042-0.020-0.084-0.030-0.125zM12.638 4.125c0.016 0.041 0.032 0.082 0.048 0.123-0.015-0.041-0.031-0.082-0.048-0.123zM12.687 4.251c0.015 0.041 0.030 0.082 0.044 0.123-0.014-0.041-0.029-0.082-0.044-0.123zM10.681 4.268c-0-0-0-0-0-0s0 0 0 0zM10.645 4.236c-0-0-0.001-0-0.001-0.001s0 0 0.001 0.001zM10.608 4.206c-0-0-0.001-0.001-0.001-0.001s0.001 0.001 0.001 0.001zM10.568 4.177c-0.001-0-0.001-0.001-0.002-0.001 0.001 0 0.001 0.001 0.002 0.001zM10.527 4.15c-0-0-0.001-0.001-0.001-0.001s0.001 0.001 0.001 0.001zM10 8.875h2.092c-0.060 0.085-0.123 0.168-0.189 0.25h-1.903v-0.25zM10 8.375h2.402c0.044-0.082 0.087-0.165 0.126-0.25-0.081 0.171-0.171 0.338-0.271 0.5h-2.257v-0.25zM10 8.125v-0.25h2.638c-0.034 0.084-0.070 0.168-0.109 0.25h-2.529zM10 7.625v-0.25h2.809c-0.024 0.084-0.050 0.167-0.078 0.25h-2.731zM12.731 7.626c-0.014 0.041-0.029 0.082-0.044 0.123 0.015-0.041 0.030-0.082 0.044-0.123zM12.685 7.752c-0.015 0.041-0.031 0.082-0.048 0.123 0.016-0.041 0.032-0.082 0.048-0.123zM10 7.125v-0.25h2.924c-0.022 0.126-0.049 0.252-0.081 0.375 0.011-0.042 0.021-0.083 0.030-0.125h-2.873zM12.843 7.251c-0.011 0.041-0.022 0.083-0.033 0.124 0.012-0.041 0.023-0.082 0.033-0.124zM10 6.625v-0.25h2.986c-0.012 0.168-0.033 0.335-0.062 0.5 0.014-0.083 0.027-0.166 0.037-0.25h-2.961zM10 6.125v-0.125c0.176 0 0.341-0.046 0.485-0.125-0 0-0 0-0 0h2.514c-0.001-0.042-0.003-0.084-0.005-0.125 0.004 0.083 0.006 0.167 0.006 0.25s-0.002 0.167-0.006 0.25c0.002-0.042 0.004-0.083 0.005-0.125h-2.998zM12.994 6.254c-0.002 0.040-0.004 0.081-0.007 0.121 0.003-0.040 0.005-0.080 0.007-0.121zM10.681 5.732c-0 0-0 0-0 0s0-0 0-0zM10.645 5.764c-0 0-0.001 0-0.001 0.001s0-0 0.001-0.001zM10.608 5.794c-0 0-0.001 0.001-0.001 0.001s0.001-0.001 0.001-0.001zM10.568 5.823c-0.001 0-0.001 0.001-0.002 0.001 0.001-0 0.001-0.001 0.002-0.001zM10.527 5.85c-0 0-0.001 0.001-0.001 0.001s0.001-0.001 0.001-0.001zM12.986 5.626c0.003 0.040 0.005 0.080 0.007 0.121-0.002-0.040-0.004-0.081-0.007-0.121zM12.257 3.374c-0.025-0.041-0.051-0.081-0.077-0.121 0.026 0.040 0.052 0.080 0.077 0.121zM10.827 1.875c-0.065-0.045-0.131-0.088-0.198-0.13 0.233 0.144 0.454 0.308 0.663 0.492-0.043-0.038-0.087-0.076-0.132-0.112h-6.321c0.108-0.088 0.219-0.172 0.333-0.25h5.655zM5.173 1.875c0.033-0.022 0.065-0.044 0.099-0.066-0.033 0.022-0.066 0.044-0.099 0.066zM5.271 1.809c0.033-0.022 0.066-0.043 0.1-0.063-0.033 0.021-0.067 0.042-0.1 0.063zM5.372 1.745c0.033-0.021 0.067-0.041 0.1-0.061-0.034 0.020-0.067 0.040-0.1 0.061zM5.474 1.683c0.202-0.118 0.411-0.222 0.626-0.311-0.002 0.001-0.004 0.002-0.007 0.003h3.813c0.213 0.088 0.42 0.191 0.62 0.308-0.034-0.020-0.068-0.039-0.102-0.058h-4.849c-0.034 0.019-0.068 0.038-0.102 0.058zM10.528 1.684c0.034 0.020 0.067 0.040 0.1 0.061-0.033-0.021-0.067-0.041-0.1-0.061zM11.443 2.374c-0.041-0.039-0.083-0.077-0.125-0.115 0.042 0.038 0.084 0.076 0.125 0.115zM9.81 1.336c-0.019-0.007-0.038-0.014-0.056-0.021 0.019 0.007 0.038 0.014 0.056 0.021zM9.705 1.297c-0.020-0.007-0.039-0.014-0.059-0.021 0.020 0.007 0.039 0.014 0.059 0.021zM9.6 1.261c-0.020-0.007-0.041-0.014-0.061-0.020 0.020 0.007 0.041 0.013 0.061 0.020zM9.495 1.227c-0.021-0.007-0.043-0.013-0.064-0.020 0.021 0.006 0.043 0.013 0.064 0.020zM9.391 1.196c-0.023-0.007-0.046-0.013-0.069-0.020 0.023 0.006 0.046 0.013 0.069 0.020zM9.299 1.17c-0.059-0.016-0.118-0.031-0.178-0.044 0.060 0.014 0.119 0.028 0.178 0.044zM9.118 1.125h-2.237c0.363-0.082 0.737-0.125 1.118-0.125s0.756 0.043 1.118 0.125zM6.19 1.336c0.019-0.007 0.038-0.014 0.057-0.021-0.019 0.007-0.038 0.014-0.057 0.021zM6.295 1.297c0.020-0.007 0.040-0.014 0.059-0.021-0.020 0.007-0.040 0.014-0.059 0.021zM6.4 1.261c0.020-0.007 0.041-0.014 0.062-0.020-0.021 0.007-0.041 0.013-0.062 0.020zM6.505 1.227c0.021-0.007 0.043-0.013 0.064-0.020-0.022 0.006-0.043 0.013-0.064 0.020zM6.608 1.196c0.023-0.007 0.046-0.013 0.069-0.020-0.023 0.006-0.046 0.013-0.069 0.020zM6.701 1.17c0.060-0.016 0.12-0.031 0.18-0.045-0.060 0.014-0.12 0.029-0.18 0.045zM4.683 2.259c-0.043 0.038-0.085 0.076-0.126 0.116h6.888c0.031 0.029 0.062 0.059 0.092 0.089 0.053 0.053 0.104 0.106 0.153 0.161h-7.378c-0.075 0.081-0.146 0.165-0.215 0.25h7.807c-0.068-0.085-0.14-0.168-0.214-0.25 0.18 0.196 0.342 0.404 0.486 0.622-0.027-0.041-0.055-0.082-0.083-0.122h-8.185c-0.028 0.040-0.056 0.081-0.083 0.122 0.184-0.279 0.398-0.541 0.64-0.782 0.071-0.071 0.144-0.139 0.218-0.205v0zM4.839 2.125c-0.044 0.036-0.088 0.074-0.132 0.112 0.043-0.038 0.087-0.076 0.132-0.112zM3.82 3.254c-0.026 0.040-0.052 0.080-0.077 0.121h8.515c0.1 0.162 0.191 0.328 0.271 0.5-0.040-0.084-0.082-0.168-0.126-0.25h-8.805c0.068-0.127 0.143-0.25 0.222-0.371v0zM3.056 5.25c-0.006 0.041-0.012 0.083-0.017 0.125 0.005-0.042 0.011-0.083 0.017-0.125zM3.038 5.375h2.034c0-0-0-0-0-0 0.037 0.091 0.086 0.175 0.147 0.25 0-0-0-0-0-0h-2.206c-0.006 0.083-0.010 0.166-0.012 0.25h2.514c-0-0-0-0-0-0 0.144 0.080 0.309 0.125 0.484 0.125v0.125h-2.998c0.002 0.084 0.006 0.167 0.012 0.25h2.986v0.25h-2.962c0.010 0.084 0.023 0.167 0.037 0.25h2.924v0.25h-2.873c-0.083-0.365-0.127-0.742-0.127-1.125 0-0.211 0.013-0.419 0.038-0.625zM5.051 5.314c0 0 0 0.001 0 0.001s-0-0.001-0-0.001zM5.251 5.662c0 0 0 0 0 0s0 0 0 0zM5.284 5.698c0 0 0 0 0 0s-0-0-0-0zM5.319 5.732c0 0 0 0 0 0s-0-0-0-0zM5.355 5.764c0 0 0.001 0.001 0.001 0.001s-0.001-0.001-0.001-0.001zM5.392 5.794c0 0 0.001 0.001 0.002 0.001s-0.001-0.001-0.002-0.001zM5.432 5.823c0 0 0.001 0.001 0.002 0.001-0.001-0-0.001-0.001-0.002-0.001zM5.473 5.85c0 0 0.001 0 0.001 0.001s-0.001-0-0.001-0.001zM6 7.375v0.25h-2.731c-0.028-0.083-0.054-0.166-0.078-0.25h2.809zM3.191 7.375c-0.012-0.041-0.023-0.082-0.033-0.123 0.011 0.041 0.022 0.082 0.033 0.123zM3.157 7.25c-0.011-0.041-0.021-0.083-0.030-0.124 0.010 0.042 0.020 0.083 0.030 0.124zM3.314 7.751c0.015 0.041 0.031 0.083 0.048 0.124h2.638v0.25h-2.529c0.040 0.084 0.082 0.168 0.126 0.25h2.402v0.25h-2.257c0.025 0.041 0.051 0.081 0.077 0.121-0.206-0.313-0.375-0.646-0.505-0.994v0zM3.269 7.625c0.014 0.042 0.029 0.083 0.045 0.125-0.015-0.041-0.030-0.083-0.045-0.125zM6 8.875v0.25h-1.904c-0.097-0.12-0.187-0.244-0.272-0.372 0.027 0.041 0.055 0.081 0.083 0.122h2.092zM4.097 9.125c0.069 0.085 0.14 0.169 0.214 0.25h1.689v0.25h-1.444c0.044 0.042 0.089 0.083 0.134 0.122-0.077-0.068-0.152-0.139-0.226-0.212-0.131-0.131-0.253-0.268-0.368-0.41zM4.7 9.756c0.046 0.041 0.093 0.080 0.14 0.119h1.16v0.25h-0.828c0.098 0.067 0.197 0.131 0.299 0.19-0.272-0.16-0.53-0.347-0.771-0.559zM6 10.375v0.21c-0.181-0.079-0.357-0.169-0.527-0.269 0.034 0.020 0.068 0.040 0.103 0.059l0.425-0zM9.5 13h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM10 10.375h0.425c0.034-0.019 0.069-0.039 0.102-0.059-0.171 0.1-0.346 0.19-0.527 0.269v-0.21zM10.529 10.315c0.101-0.060 0.201-0.123 0.298-0.19h-0.828v-0.25h1.16c-0.2 0.164-0.411 0.311-0.631 0.44zM11.16 9.875c0.047-0.039 0.094-0.078 0.14-0.119-0.046 0.041-0.093 0.080-0.14 0.119zM11.31 9.748c0.045-0.040 0.089-0.080 0.133-0.122-0.044 0.042-0.088 0.082-0.133 0.122zM11.444 9.625h-1.444v-0.25h1.689c-0.050 0.054-0.101 0.108-0.153 0.161-0.030 0.030-0.061 0.060-0.092 0.089zM11.903 9.125c-0.068 0.085-0.14 0.168-0.214 0.25 0.074-0.081 0.146-0.164 0.214-0.25zM12.18 8.745c0.026-0.040 0.052-0.080 0.077-0.12-0.025 0.040-0.051 0.080-0.077 0.12zM12.093 8.875c0.028-0.040 0.056-0.080 0.083-0.121-0.027 0.041-0.054 0.081-0.083 0.121zM9.5 15h-3c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5z" })
        );
    }
    function Lamp6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lamp6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lamp6.SVG = Lamp6SVG;
    return Lamp6;
})();
export const Lamp7 = /*#__PURE__*/ (() => {
        function Lamp7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 10c-0.004 1.657 1.343 2 3 2s2.996-0.343 3-2 1.996-2.239 2-5-2.239-5-5-5c-2.761 0-4.996 2.239-5 5s2.004 3.343 2 5z" }),
_('path', { d: "M8 13c-1.234 0-2.259-0.274-2.463-1.516-0.024 0.168-0.037 0.34-0.037 0.516 0 1.657 1.119 2 2.5 2s2.5-0.343 2.5-2c0-0.176-0.013-0.348-0.037-0.516-0.204 1.241-1.229 1.516-2.463 1.516z" }),
_('path', { d: "M8 15c-0.987 0-1.807-0.274-1.97-1.516-0.019 0.168-0.030 0.34-0.030 0.516 0 1.657 0.895 2 2 2s2-0.343 2-2c0-0.176-0.010-0.348-0.030-0.516-0.163 1.241-0.983 1.516-1.97 1.516z" })
            );
        }
        function Lamp7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Lamp7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lamp7.SVG = Lamp7SVG;
        return Lamp7;
    })();
export const Lamp8 = /*#__PURE__*/ (() => {
        function Lamp8SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 1c1.070 0 2.076 0.417 2.833 1.175 0.754 0.755 1.169 1.758 1.167 2.824-0.002 1.23-0.485 1.888-0.996 2.585-0.47 0.64-1.002 1.365-1.004 2.414-0.001 0.51-0.176 0.647-0.355 0.744-0.318 0.172-0.871 0.259-1.645 0.259-1.189 0-1.645-0.208-1.819-0.382-0.045-0.045-0.182-0.182-0.181-0.616 0.003-1.053-0.533-1.78-1.005-2.422-0.512-0.696-0.996-1.353-0.995-2.579 0.002-1.070 0.418-2.075 1.173-2.83s1.759-1.171 2.827-1.171zM8 0c-2.761 0-4.996 2.239-5 5s2.004 3.343 2 5 1.343 2 3 2c1.657 0 2.996-0.343 3-2s1.996-2.239 2-5-2.239-5-5-5v0z" }),
_('path', { d: "M8 13c-1.234 0-2.259-0.274-2.463-1.516-0.024 0.168-0.037 0.34-0.037 0.516 0 1.657 1.119 2 2.5 2s2.5-0.343 2.5-2c0-0.176-0.013-0.348-0.037-0.516-0.204 1.241-1.229 1.516-2.463 1.516z" }),
_('path', { d: "M8 15c-0.987 0-1.807-0.274-1.97-1.516-0.019 0.168-0.030 0.34-0.030 0.516 0 1.657 0.895 2 2 2s2-0.343 2-2c0-0.176-0.010-0.348-0.030-0.516-0.163 1.241-0.983 1.516-1.97 1.516z" })
            );
        }
        function Lamp8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Lamp8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lamp8.SVG = Lamp8SVG;
        return Lamp8;
    })();
export const Broom = /*#__PURE__*/ (() => {
    function BroomSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.707 0.293c-0.39-0.391-1.024-0.391-1.414 0l-3.75 3.75-1.043-1.043-2 1.738-7.101 2.161c-0.237 0.072-0.399 0.291-0.399 0.538v0.5c0 2.154 0.839 4.178 2.361 5.701s3.547 2.361 5.701 2.361h0.5c0.248 0 0.466-0.162 0.538-0.399l2.161-7.101 1.738-2-1.043-1.043 3.75-3.75c0.391-0.391 0.391-1.024 0-1.414zM8.146 14.875h-0.083c-0.832 0-1.641-0.146-2.398-0.424l2.336-5.451-3.876 4.651c-0.343-0.237-0.667-0.507-0.967-0.808s-0.57-0.625-0.808-0.967l4.651-3.876-5.451 2.336c-0.279-0.758-0.424-1.567-0.424-2.398v-0.083l7.277-2.215 1.959 1.959-2.215 7.277z" })
        );
    }
    function Broom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BroomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Broom.SVG = BroomSVG;
    return Broom;
})();
export const Toiletpaper = /*#__PURE__*/ (() => {
        function ToiletpaperSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.215 2.741c-0.561-1.123-1.348-1.741-2.215-1.741h-10c-0.867 0-1.654 0.618-2.215 1.741-0.506 1.012-0.785 2.347-0.785 3.759s0.279 2.747 0.785 3.759c0.561 1.123 1.348 1.741 2.215 1.741h2v3.5c0 0.202 0.122 0.385 0.309 0.462s0.402 0.035 0.545-0.108l0.646-0.646 0.646 0.646c0.195 0.195 0.512 0.195 0.707 0l0.646-0.646 0.646 0.646c0.195 0.195 0.512 0.195 0.707 0l0.646-0.646 0.646 0.646c0.195 0.195 0.512 0.195 0.707 0l0.646-0.646 0.646 0.646c0.195 0.195 0.512 0.195 0.707 0l0.646-0.646 0.646 0.646c0.096 0.096 0.223 0.147 0.354 0.147 0.064-0 0.129-0.012 0.191-0.038 0.187-0.077 0.309-0.26 0.309-0.462v-9c0-1.412-0.279-2.747-0.785-3.759zM1 6.5c0-2.652 1.054-4.5 2-4.5s2 1.848 2 4.5-1.054 4.5-2 4.5-2-1.848-2-4.5zM15 14.293l-0.146-0.146c-0.195-0.195-0.512-0.195-0.707 0l-0.646 0.646-0.646-0.646c-0.195-0.195-0.512-0.195-0.707 0l-0.646 0.646-0.646-0.646c-0.195-0.195-0.512-0.195-0.707 0l-0.646 0.646-0.646-0.646c-0.195-0.195-0.512-0.195-0.707 0l-0.646 0.646-0.646-0.646c-0.195-0.195-0.512-0.195-0.707 0l-0.146 0.146v-7.793c0-1.412-0.279-2.747-0.785-3.759-0.139-0.279-0.293-0.526-0.457-0.741h8.242c0.946 0 2 1.848 2 4.5v7.793z" }),
_('path', { d: "M4 6.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5z" }),
_('path', { d: "M8 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M12 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M14 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" })
            );
        }
        function Toiletpaper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToiletpaperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Toiletpaper.SVG = ToiletpaperSVG;
        return Toiletpaper;
    })();
export const Bin = /*#__PURE__*/ (() => {
        function BinSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z" }),
_('path', { d: "M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z" })
            );
        }
        function Bin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bin.SVG = BinSVG;
        return Bin;
    })();
export const Bin2 = /*#__PURE__*/ (() => {
    function Bin2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z" })
        );
    }
    function Bin2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bin2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bin2.SVG = Bin2SVG;
    return Bin2;
})();
export const Bin3 = /*#__PURE__*/ (() => {
    function Bin3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 2.5c0-1.381-3.358-2.5-7.5-2.5s-7.5 1.119-7.5 2.5c0 0.098 0.017 0.194 0.050 0.288l1.943 11.212c0 1.105 2.464 2 5.504 2s5.504-0.895 5.504-2l1.95-11.21c0.033-0.095 0.050-0.192 0.050-0.29zM2.944 1.679c1.257-0.357 2.875-0.554 4.556-0.554s3.299 0.197 4.556 0.554c1.078 0.306 1.584 0.645 1.763 0.821-0.179 0.176-0.686 0.515-1.763 0.821-1.257 0.357-2.875 0.554-4.556 0.554s-3.299-0.197-4.556-0.554c-1.078-0.306-1.584-0.645-1.763-0.821 0.179-0.176 0.686-0.515 1.763-0.821z" })
        );
    }
    function Bin3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bin3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bin3.SVG = Bin3SVG;
    return Bin3;
})();
export const Bin4 = /*#__PURE__*/ (() => {
    function Bin4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 0c-4.142 0-7.5 1.119-7.5 2.5 0 0.098 0.017 0.194 0.050 0.288l1.943 11.212c0 1.105 2.464 2 5.504 2s5.504-0.895 5.504-2l1.95-11.21c0.033-0.095 0.050-0.192 0.050-0.29 0-1.381-3.358-2.5-7.5-2.5zM13.575 4.125h-0.376c0.143-0.056 0.278-0.113 0.406-0.173l-0.030 0.173zM11.492 12.625c-0.24-0.092-0.504-0.176-0.788-0.25h1.436l-0.043 0.25h-0.605zM2.896 12.625l-0.043-0.25h1.435c-0.284 0.074-0.548 0.158-0.788 0.25h-0.605zM9.414 12.125c-0.597-0.081-1.243-0.125-1.918-0.125s-1.32 0.044-1.918 0.125h-2.769l-0.043-0.25h9.461l-0.043 0.25h-2.77zM2.723 11.625l-0.043-0.25h9.635l-0.043 0.25h-9.548zM2.636 11.125l-0.043-0.25h9.808l-0.043 0.25h-9.722zM2.55 10.625l-0.043-0.25h9.982l-0.043 0.25h-9.895zM2.463 10.125l-0.043-0.25h10.156l-0.043 0.25h-10.069zM2.377 9.625l-0.043-0.25h10.329l-0.043 0.25h-10.242zM2.29 9.125l-0.043-0.25h10.503l-0.043 0.25h-10.416zM2.203 8.625l-0.043-0.25h10.676l-0.043 0.25h-10.59zM2.117 8.125l-0.043-0.25h10.85l-0.043 0.25h-10.763zM2.030 7.625l-0.043-0.25h11.024l-0.043 0.25h-10.937zM1.943 7.125l-0.043-0.25h11.197l-0.043 0.25h-11.111zM1.857 6.625l-0.043-0.25h11.371l-0.043 0.25h-11.284zM1.77 6.125l-0.043-0.25h11.544l-0.043 0.25h-11.458zM1.683 5.625l-0.043-0.25h11.718l-0.043 0.25h-11.631zM1.597 5.125l-0.043-0.25h3.601c0.738 0.081 1.526 0.125 2.346 0.125s1.608-0.044 2.346-0.125h3.599l-0.043 0.25h-11.805zM1.393 3.952c0.128 0.060 0.264 0.118 0.407 0.173h-0.377l-0.030-0.173zM2.54 4.375c0.314 0.092 0.651 0.176 1.009 0.25h-2.039l-0.043-0.25h1.073zM11.451 4.625c0.357-0.074 0.695-0.158 1.009-0.25h1.072l-0.043 0.25h-2.037zM2.944 1.679c1.257-0.357 2.875-0.554 4.556-0.554s3.299 0.197 4.556 0.554c1.078 0.306 1.584 0.645 1.763 0.821-0.179 0.176-0.686 0.515-1.763 0.821-1.257 0.357-2.875 0.554-4.556 0.554s-3.299-0.197-4.556-0.554c-1.078-0.306-1.584-0.645-1.763-0.821 0.179-0.176 0.686-0.515 1.763-0.821z" })
        );
    }
    function Bin4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bin4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bin4.SVG = Bin4SVG;
    return Bin4;
})();
export const Bin5 = /*#__PURE__*/ (() => {
        function Bin5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 7h1v1h-1v-1z" }),
_('path', { d: "M8 7h1v1h-1v-1z" }),
_('path', { d: "M9 10h1v1h-1v-1z" }),
_('path', { d: "M9 8h1v1h-1v-1z" }),
_('path', { d: "M10 7h1v1h-1v-1z" }),
_('path', { d: "M4 9h1v1h-1v-1z" }),
_('path', { d: "M3 6h1v1h-1v-1z" }),
_('path', { d: "M3 8h1v1h-1v-1z" }),
_('path', { d: "M5 10h1v1h-1v-1z" }),
_('path', { d: "M7 10h1v1h-1v-1z" }),
_('path', { d: "M8 9h1v1h-1v-1z" }),
_('path', { d: "M6 9h1v1h-1v-1z" }),
_('path', { d: "M7 8h1v1h-1v-1z" }),
_('path', { d: "M5 8h1v1h-1v-1z" }),
_('path', { d: "M7 12h1v1h-1v-1z" }),
_('path', { d: "M8 11h1v1h-1v-1z" }),
_('path', { d: "M6 11h1v1h-1v-1z" }),
_('path', { d: "M4 11h1v1h-1v-1z" }),
_('path', { d: "M4 7h1v1h-1v-1z" }),
_('path', { d: "M10 11h1v1h-1v-1z" }),
_('path', { d: "M9 12h1v1h-1v-1z" }),
_('path', { d: "M8 13h1v1h-1v-1z" }),
_('path', { d: "M7.5 0c-4.142 0-7.5 1.119-7.5 2.5 0 0.098 0.017 0.194 0.050 0.288l1.943 11.212c0 1.105 2.464 2 5.504 2s5.504-0.895 5.504-2l1.95-11.21c0.033-0.095 0.050-0.192 0.050-0.29 0-1.381-3.358-2.5-7.5-2.5zM13 7h-1v1h1v1h-1v1h-1v1h1v1h-1v1h1v1h-1v-1h-1v1h-1v1h-1v-1h-1v1h-1v-1h-1v-1h-1v1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h-1v-1h1v-1h-1v-1h1v-1h1v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h1v1h1v1zM12.056 3.321c-1.257 0.357-2.875 0.554-4.556 0.554s-3.299-0.197-4.556-0.554c-1.078-0.306-1.584-0.645-1.763-0.821 0.179-0.176 0.686-0.515 1.763-0.821 1.257-0.357 2.875-0.554 4.556-0.554s3.299 0.197 4.556 0.554c1.078 0.306 1.584 0.645 1.763 0.821-0.179 0.176-0.685 0.515-1.763 0.821z" }),
_('path', { d: "M6 13h1v1h-1v-1z" }),
_('path', { d: "M11 8h1v1h-1v-1z" }),
_('path', { d: "M10 9h1v1h-1v-1z" }),
_('path', { d: "M11 6h1v1h-1v-1z" }),
_('path', { d: "M5 12h1v1h-1v-1z" })
            );
        }
        function Bin5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Bin5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bin5.SVG = Bin5SVG;
        return Bin5;
    })();
export const Briefcase = /*#__PURE__*/ (() => {
    function BriefcaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.414 10h3.586v-1h2v1h3.586l3.414-3.414v-1.586c0-0.55-0.45-1-1-1h-3l-2-2h-4l-2 2h-3c-0.55 0-1 0.45-1 1v1.586l3.414 3.414zM6.414 3h3.172l1 1h-5.172l1-1zM13 11h-4v1h-2v-1h-4l-3-3v6c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-6l-3 3z" })
        );
    }
    function Briefcase({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BriefcaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Briefcase.SVG = BriefcaseSVG;
    return Briefcase;
})();
export const Briefcase2 = /*#__PURE__*/ (() => {
    function Briefcase2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 5h-3.5v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3.5c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-7c0-0.825-0.675-1.5-1.5-1.5zM6 3.002c0-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v1.998h-4v-1.998z" })
        );
    }
    function Briefcase2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Briefcase2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Briefcase2.SVG = Briefcase2SVG;
    return Briefcase2;
})();
export const Briefcase3 = /*#__PURE__*/ (() => {
    function Briefcase3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 4h-4v-1c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v1h-4c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM6 3.002c0.001-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-4v-0.998zM15 8h-2v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-6v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-2v-1h14v1z" })
        );
    }
    function Briefcase3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Briefcase3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Briefcase3.SVG = Briefcase3SVG;
    return Briefcase3;
})();
export const Airplane = /*#__PURE__*/ (() => {
    function AirplaneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 9.999l-2.857-2.857 6.857-5.143-2-2-8.571 3.429-2.698-2.699c-0.778-0.778-1.864-0.964-2.414-0.414s-0.364 1.636 0.414 2.414l2.698 2.698-3.429 8.572 2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2l-4 0z" })
        );
    }
    function Airplane({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AirplaneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Airplane.SVG = AirplaneSVG;
    return Airplane;
})();
export const Airplane2 = /*#__PURE__*/ (() => {
    function Airplane2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 7h-2.1l-4.4-6h-2.5l3.2 6h-3.7l-2-2h-1.5l2 3.5-2 3.5h1.5l2-2h3.7l-3.2 6h2.5l4.4-6h2.1c1.65 0 3-0.675 3-1.5s-1.35-1.5-3-1.5z" })
        );
    }
    function Airplane2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Airplane2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Airplane2.SVG = Airplane2SVG;
    return Airplane2;
})();
export const Airplane3 = /*#__PURE__*/ (() => {
    function Airplane3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.658 8.060l-3.289 1.197-8.331-3.885-2.349 0.855 6.452 4.569-3.289 1.197-2.563-1.195-1.292 0.47 3.13 3.117 12.216-4.446c0.519-0.189 0.787-0.763 0.598-1.282s-0.763-0.787-1.282-0.598z" })
        );
    }
    function Airplane3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Airplane3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Airplane3.SVG = Airplane3SVG;
    return Airplane3;
})();
export const Airplane4 = /*#__PURE__*/ (() => {
    function Airplane4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.342 13.060l-3.289-1.197-3.885-8.331-2.349-0.855 2.005 7.647-3.289-1.197-1.195-2.563-1.292-0.47 0.394 4.4 12.216 4.446c0.519 0.189 1.093-0.079 1.282-0.598s-0.079-1.093-0.598-1.282z" })
        );
    }
    function Airplane4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Airplane4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Airplane4.SVG = Airplane4SVG;
    return Airplane4;
})();
export const Paperplane = /*#__PURE__*/ (() => {
    function PaperplaneSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 11l6.151 2.195 2.849-12.459zM5 10.311l11-9.575-16 7.913zM7 12.062v3.938l2.902-2.902z" })
        );
    }
    function Paperplane({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PaperplaneSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Paperplane.SVG = PaperplaneSVG;
    return Paperplane;
})();
export const Car = /*#__PURE__*/ (() => {
    function CarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 8h-1c0-0.082-0.010-0.163-0.030-0.243l-1-4c-0.111-0.445-0.511-0.757-0.97-0.757h-8c-0.459 0-0.859 0.312-0.97 0.757l-1 4c-0.020 0.079-0.030 0.161-0.030 0.243h-1c-0.552 0-1 0.448-1 1v4c0 0.552 0.448 1 1 1h1v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h8v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h1c0.552 0 1-0.448 1-1v-4c0-0.552-0.448-1-1-1zM3 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM4.031 8l0.75-3h6.438l0.75 3h-7.938zM13 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Car({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Car.SVG = CarSVG;
    return Car;
})();
export const SteeringWheel = /*#__PURE__*/ (() => {
    function SteeringWheelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 2c2.973 0 5.44 2.162 5.917 5h-3.088c-0.412-1.165-1.522-2-2.828-2s-2.417 0.835-2.828 2h-3.088c0.476-2.838 2.944-5 5.917-5zM7 13.917c-2.512-0.422-4.495-2.404-4.917-4.917h2.917c1.105 0 2 0.895 2 2v2.917zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 13.917v-2.917c0-1.105 0.895-2 2-2h2.917c-0.422 2.512-2.404 4.495-4.917 4.917z" })
        );
    }
    function SteeringWheel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SteeringWheelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SteeringWheel.SVG = SteeringWheelSVG;
    return SteeringWheel;
})();
export const Car2 = /*#__PURE__*/ (() => {
        function Car2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 8h-1c0-0.082-0.010-0.163-0.030-0.243l-1-4c-0.111-0.445-0.511-0.757-0.97-0.757h-8c-0.459 0-0.859 0.312-0.97 0.757l-1 4c-0.020 0.079-0.030 0.161-0.030 0.243h-1c-0.552 0-1 0.448-1 1v4c0 0.552 0.448 1 1 1h1v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h8v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h1c0.552 0 1-0.448 1-1v-4c0-0.552-0.448-1-1-1zM3 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM4.031 8l0.75-3h6.438l0.75 3h-7.938zM13 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" }),
_('path', { d: "M10.5 2l-0.515-1.621c-0.056-0.223-0.256-0.379-0.485-0.379h-3c-0.229 0-0.429 0.156-0.485 0.379l-0.515 1.621h5z" })
            );
        }
        function Car2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Car2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Car2.SVG = Car2SVG;
        return Car2;
    })();
export const Gas = /*#__PURE__*/ (() => {
    function GasSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.854 4.146l-2-2c-0.094-0.094-0.221-0.146-0.354-0.146h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.543l1 1h-0.543c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.276 0.224 0.5 0.5 0.5h1.5v4c0 0.551-0.449 1-1 1s-1-0.449-1-1v-2.5c0-0.276-0.224-0.5-0.5-0.5h-1.5v-5.5c0-0.825-0.675-1.5-1.5-1.5h-6c-0.825 0-1.5 0.675-1.5 1.5v12.5h-1v1h11v-1h-1v-6h1v2c0 1.103 0.897 2 2 2s2-0.897 2-2v-6.5c0-0.133-0.053-0.26-0.146-0.354zM2 5.5v-3c0-0.275 0.225-0.5 0.5-0.5h6c0.275 0 0.5 0.225 0.5 0.5v3c0 0.275-0.225 0.5-0.5 0.5h-6c-0.275 0-0.5-0.225-0.5-0.5zM13 6v-1h1v1h-1z" })
        );
    }
    function Gas({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GasSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gas.SVG = GasSVG;
    return Gas;
})();
export const Bus = /*#__PURE__*/ (() => {
    function BusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.985 7.379l-1.25-6c-0.056-0.223-0.256-0.379-0.485-0.379h-10.5c-0.229 0-0.429 0.156-0.485 0.379l-1.25 6c-0.010 0.040-0.015 0.080-0.015 0.121v6c0 0.276 0.224 0.5 0.5 0.5h1.5v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h6v1c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h1.5c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.041-0.005-0.082-0.015-0.121zM5.5 2h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM4 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM3.5 8c-0.147 0-0.287-0.065-0.381-0.177s-0.136-0.26-0.112-0.405l0.5-3c0.040-0.241 0.249-0.418 0.493-0.418h8c0.244 0 0.453 0.177 0.493 0.418l0.5 3c0.024 0.145-0.017 0.293-0.112 0.405s-0.235 0.177-0.382 0.177h-9zM12 12c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Bus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bus.SVG = BusSVG;
    return Bus;
})();
export const Truck = /*#__PURE__*/ (() => {
    function TruckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 9l-2-4h-3v-2c0-0.55-0.45-1-1-1h-9c-0.55 0-1 0.45-1 1v8l1 1h1.268c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h5.536c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h1.268v-3zM11 9v-3h2.073l1.5 3h-3.573z" })
        );
    }
    function Truck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TruckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Truck.SVG = TruckSVG;
    return Truck;
})();
export const Bike = /*#__PURE__*/ (() => {
    function BikeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 19 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 19 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 7c-0.453 0-0.887 0.087-1.285 0.244l-2.853-4.992c-0.089-0.156-0.255-0.252-0.434-0.252l-1.429-0c-0 0 0 0-0 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5l1.139 0 1.143 2h-4.848l-0.571-1h0.138c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.71l0.784 1.372-1.14 1.901c-0.417-0.175-0.874-0.272-1.353-0.272-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5c1.76 0 3.221-1.306 3.464-3h1.122c0.206 0.583 0.761 1 1.414 1 0.828 0 1.5-0.672 1.5-1.5 0-0.363-0.129-0.696-0.344-0.955l1.906-3.177 0.785 1.374c-0.82 0.641-1.348 1.639-1.348 2.758 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zM3.5 13c-1.378 0-2.5-1.121-2.5-2.5s1.122-2.5 2.5-2.5c0.291 0 0.571 0.051 0.831 0.143l-1.26 2.1c-0.093 0.154-0.095 0.347-0.006 0.504s0.255 0.254 0.435 0.254h2.45c-0.232 1.14-1.242 2-2.45 2zM4.383 10l0.805-1.342c0.381 0.35 0.654 0.816 0.761 1.342h-1.567zM8.086 10h-1.122c-0.128-0.888-0.59-1.669-1.254-2.212l0.853-1.421 1.802 3.153c-0.121 0.14-0.216 0.302-0.279 0.479zM9.5 11c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM9.799 9.030c-0.097-0.020-0.197-0.030-0.299-0.030-0.091 0-0.181 0.009-0.267 0.024l-1.728-3.024h4.112l-1.818 3.030zM15.5 13c-1.379 0-2.5-1.121-2.5-2.5 0-0.747 0.33-1.419 0.851-1.877l1.214 2.125c0.092 0.162 0.261 0.252 0.435 0.252 0.084 0 0.169-0.021 0.248-0.066 0.24-0.137 0.323-0.442 0.186-0.682l-1.215-2.126c0.246-0.081 0.508-0.126 0.781-0.126 1.379 0 2.5 1.121 2.5 2.5s-1.122 2.5-2.5 2.5z" })
        );
    }
    function Bike({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BikeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bike.SVG = BikeSVG;
    return Bike;
})();
export const Road = /*#__PURE__*/ (() => {
    function RoadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 16h5l-4-16h-3l0.5 4h-3l0.5-4h-3l-4 16h5l0.5-4h5l0.5 4zM5.75 10l0.5-4h3.5l0.5 4h-4.5z" })
        );
    }
    function Road({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RoadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Road.SVG = RoadSVG;
    return Road;
})();
export const Train = /*#__PURE__*/ (() => {
    function TrainSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 8.5v-1.313c0-0.656-0.5-1.188-1.125-1.188h-0.875v-3l1-2h-4l1 2v3h-5v-2h-4v9h1c0 1.105 0.895 2 2 2s2-0.895 2-2c0 1.105 0.895 2 2 2s2-0.895 2-2c0 1.105 0.895 2 2 2s2-0.895 2-2h3l-3-4.5zM3 14c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM7 14c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Train({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Train.SVG = TrainSVG;
    return Train;
})();
export const Train2 = /*#__PURE__*/ (() => {
    function Train2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 11v-10c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h1.5l-2.4 3.201c-0.063 0.084-0.1 0.187-0.1 0.299 0 0.276 0.224 0.5 0.5 0.5l0 0c0 0 0-0 0.001-0h12c0 0 0 0 0.001 0 0.104 0 0.21-0.033 0.3-0.1 0.221-0.166 0.266-0.479 0.1-0.7l-2.4-3.2h1.5c0.55 0 1-0.45 1-1zM13 3.5v4c0 0.276-0.224 0.5-0.5 0.5h-4.5v-5h4.5c0.276 0 0.5 0.224 0.5 0.5zM5 1h5v1h-5v-1zM2 3.5c0-0.276 0.224-0.5 0.5-0.5h4.5v5h-4.5c-0.276 0-0.5-0.224-0.5-0.5v-4zM2 10c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM12.5 15h-10l0.75-1h8.5l0.75 1zM11 13h-7l0.75-1h5.5l0.75 1zM12 11c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Train2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Train2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Train2.SVG = Train2SVG;
    return Train2;
})();
export const Ship = /*#__PURE__*/ (() => {
        function ShipSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.26 12.656c0.28-0.41 0.743-0.655 1.239-0.655h0.004c0.497 0.001 0.959 0.247 1.237 0.657 0.156 0.222 0.716 0.842 1.259 0.842 0.545 0 1.105-0.623 1.26-0.844 0.28-0.41 0.743-0.655 1.239-0.655h0.004c0.497 0.001 0.959 0.247 1.237 0.657 0.144 0.205 0.632 0.749 1.133 0.832 0.961-1.607 2.126-5.489 2.126-5.489l-2.057-0.881-0.827-4.961c-0.108-0.649-0.708-1.158-1.367-1.158h-5.5c-0.658 0-1.258 0.508-1.367 1.158l-0.827 4.961-2.057 0.881c0 0 1.165 3.882 2.126 5.489 0.503-0.083 0.991-0.629 1.135-0.833zM9 2h1.75c0.168 0 0.352 0.156 0.38 0.322l0.721 4.329-3.313-1.42 0.462-3.231zM4.87 2.322c0.028-0.166 0.212-0.322 0.38-0.322h1.75l0.462 3.231-3.313 1.42 0.721-4.329z" }),
_('path', { d: "M13 16c-1.143 0-2.018-0.707-2.5-1.216-0.482 0.509-1.357 1.216-2.5 1.216s-2.018-0.707-2.5-1.216c-0.482 0.509-1.357 1.216-2.5 1.216-1.748 0-2.869-1.652-2.916-1.723-0.153-0.23-0.091-0.54 0.139-0.693s0.539-0.091 0.693 0.138c0.012 0.017 0.879 1.278 2.085 1.278 1.208 0 2.076-1.266 2.085-1.279 0.093-0.138 0.249-0.221 0.415-0.221 0 0 0.001 0 0.001 0 0.167 0.001 0.323 0.083 0.415 0.222 0.008 0.012 0.876 1.277 2.084 1.277s2.076-1.266 2.085-1.279c0.093-0.138 0.249-0.221 0.415-0.221 0.001 0 0.001 0 0.001 0 0.167 0.001 0.323 0.083 0.415 0.222 0.008 0.012 0.876 1.277 2.084 1.277s2.076-1.266 2.085-1.279c0.154-0.228 0.465-0.29 0.693-0.136s0.291 0.463 0.138 0.692c-0.047 0.070-1.169 1.723-2.916 1.723z" })
            );
        }
        function Ship({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShipSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ship.SVG = ShipSVG;
        return Ship;
    })();
export const Boat = /*#__PURE__*/ (() => {
    function BoatSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 11v4h11c2 0 5-1.828 5-4h-16zM8 1l-8 9h8zM9 3v7h5c0-5-5-7-5-7z" })
        );
    }
    function Boat({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoatSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Boat.SVG = BoatSVG;
    return Boat;
})();
export const Chopper = /*#__PURE__*/ (() => {
    function ChopperSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 5c-0.276 0-0.5 0.224-0.5 0.5v0.764l-5 1.532v-0.796c0-1.103-0.897-2-2-2h-2v-1h5.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-11c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4.5v1c-1.058 0-2.086 0.58-2.896 1.633-0.681 0.885-1.104 1.984-1.104 2.867v0.938c0 0.074 0.016 0.144 0.045 0.207 0.18 0.775 0.876 1.355 1.705 1.355h0.25v1h-1.5c-0.276 0-0.5-0.224-0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5c0 0.827 0.673 1.5 1.5 1.5h8c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1.111c0.437-0.099 0.845-0.26 1.21-0.473 0.015-0.007 0.030-0.015 0.045-0.024l6.744-3.689v0.797c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5zM2.058 9c0.122-0.571 0.429-1.225 0.838-1.758 0.357-0.464 1.105-1.242 2.104-1.242h1v2.5c0 0.276-0.224 0.5-0.5 0.5h-3.442zM4 13v-1h2v1h-2z" })
        );
    }
    function Chopper({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChopperSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chopper.SVG = ChopperSVG;
    return Chopper;
})();
export const Chopper2 = /*#__PURE__*/ (() => {
    function Chopper2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 5c-0.276 0-0.5 0.224-0.5 0.5v0.875l-5 1.458v-0.833c0-1.103-0.897-2-2-2h-2v-1h5.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-11c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4.5v1c-1.058 0-2.086 0.58-2.896 1.633-0.681 0.885-1.104 1.984-1.104 2.867v0.938c0 0.074 0.016 0.144 0.045 0.207 0.18 0.775 0.876 1.355 1.705 1.355h0.25v1h-1.5c-0.276 0-0.5-0.224-0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5c0 0.827 0.673 1.5 1.5 1.5h8c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1.11c0.441-0.099 0.861-0.264 1.244-0.491 0-0 0.001-0 0.001-0.001l6.755-3.794v0.896c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5zM2.896 7.242c0.357-0.464 1.105-1.242 2.104-1.242h1v2.5c0 0.276-0.224 0.5-0.5 0.5h-3.442c0.122-0.571 0.429-1.225 0.838-1.758zM2 10.25v-0.25h3.5c0.827 0 1.5-0.673 1.5-1.5v-2.5h1c0.551 0 1 0.449 1 1v1.49c-0 0.001 0 0.002 0 0.003v0.007c0 0.803-0.47 1.563-1.257 2.033-0.511 0.305-1.114 0.467-1.743 0.467h-3.25c-0.414 0-0.75-0.336-0.75-0.75zM6 13h-2v-1h2v1z" })
        );
    }
    function Chopper2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Chopper2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chopper2.SVG = Chopper2SVG;
    return Chopper2;
})();
export const Cube = /*#__PURE__*/ (() => {
    function CubeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1l-7.5 3v7l7.5 4 7.5-4v-7l-7.5-3zM7 13.6l-6-3.2v-4.867l6 3.2v4.867zM1.297 4.558l6.203-2.481 6.203 2.481-6.203 3.308-6.203-3.308z" })
        );
    }
    function Cube({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CubeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cube.SVG = CubeSVG;
    return Cube;
})();
export const Cube2 = /*#__PURE__*/ (() => {
    function Cube2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1l-7.5 3v7l7.5 4 7.5-4v-7l-7.5-3zM7 13.6l-6-3.2v-4.867l6 3.2v4.867zM1.297 4.558l6.203-2.481 6.203 2.481-6.203 3.308-6.203-3.308zM14 10.4l-6 3.2v-4.867l6-3.2v4.867z" })
        );
    }
    function Cube2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cube2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cube2.SVG = Cube2SVG;
    return Cube2;
})();
export const Cube3 = /*#__PURE__*/ (() => {
    function Cube3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.625 0h-0.251l-7.375 3.951v7.129l7.348 4.921h0.304l7.348-4.921v-7.129l-7.375-3.951zM13.441 4.25l-2.391 1.281-2.657-1.423 2.391-1.281 2.657 1.423zM7.5 1.067l2.391 1.281-2.391 1.281-2.391-1.281 2.391-1.281zM4.215 2.827l2.391 1.281-2.657 1.423-2.391-1.281 2.657-1.423zM3.079 11.938l-2.079-1.393v-2.424l2.079 1.3v2.517zM3.079 8.426l-2.079-1.3v-2.042l2.079 1.114v2.227zM7 14.563l-3.077-2.060v-2.554l3.077 1.923v2.692zM7 10.877l-3.077-1.923v-2.303l3.077 1.648v2.577zM7.5 7.433l-2.657-1.423 2.657-1.423 2.657 1.423-2.657 1.423zM11.077 12.503l-3.077 2.060v-2.692l3.077-1.923v2.554zM11.077 8.954l-3.077 1.923v-2.577l3.077-1.648v2.303zM14 10.546l-2.079 1.392v-2.517l2.079-1.3v2.424zM14 7.127l-2.079 1.3v-2.227l2.079-1.114v2.042z" })
        );
    }
    function Cube3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cube3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cube3.SVG = Cube3SVG;
    return Cube3;
})();
export const Cube4 = /*#__PURE__*/ (() => {
    function Cube4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.625 0h-0.251l-7.375 3.951v7.129l7.348 4.921h0.304l7.348-4.921v-7.129l-7.375-3.951zM6.345 14.125l-0.373-0.25h1.028v0.25h-0.655zM7 14.375v0.188l-0.281-0.188h0.281zM5.599 13.625l-0.373-0.25h1.775v0.25h-1.401zM4.852 13.125l-0.373-0.25h2.521v0.25h-2.148zM4.105 12.625l-0.373-0.25h3.268v0.25h-2.895zM3.359 12.125l-0.373-0.25h4.015v0.25h-3.641zM2.612 11.625l-0.373-0.25h4.761v0.25h-4.388zM1.865 11.125l-0.373-0.25h5.508v0.25h-5.135zM1.119 10.625l-0.119-0.079v-0.171h6v0.25h-5.881zM1 10.125v-0.25h6v0.25h-6zM1 9.625v-0.25h6v0.25h-6zM1 9.125v-0.25h6v0.25h-6zM1 8.625v-0.25h6v0.25h-6zM1 8.125v-0.25h5.208l0.467 0.25h-5.675zM1 7.625v-0.25h4.274l0.467 0.25h-4.741zM1 7.125v-0.25h3.341l0.467 0.25h-3.808zM1 6.625v-0.25h2.408l0.467 0.25h-2.874zM1 6.125v-0.25h1.474l0.467 0.25h-1.941zM1 5.625v-0.25h0.541l0.467 0.25h-1.008zM1 5.125v-0.040l0.074 0.040h-0.074zM7.5 7.433l-5.941-3.183 5.941-3.183 5.941 3.183-5.941 3.183z" })
        );
    }
    function Cube4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cube4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cube4.SVG = Cube4SVG;
    return Cube4;
})();
export const Pyramid = /*#__PURE__*/ (() => {
    function PyramidSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1.001l-7.239 10.656 7.239 4.343 7.239-4.343-7.239-10.656zM1.683 11.343l5.317-7.827v11.017l-5.317-3.19zM8 3.516l5.317 7.827-5.317 3.19v-11.017z" })
        );
    }
    function Pyramid({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PyramidSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pyramid.SVG = PyramidSVG;
    return Pyramid;
})();
export const Pyramid2 = /*#__PURE__*/ (() => {
    function Pyramid2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1.001l-7.239 10.656 7.239 4.343 7.239-4.343-7.239-10.656zM1.683 11.343l5.317-7.827v11.017l-5.317-3.19zM8 14.375h0.265l-0.265 0.159v-0.159zM8 14.125v-0.25h1.098l-0.417 0.25h-0.681zM8 13.625v-0.25h1.931l-0.417 0.25h-1.515zM8 13.125v-0.25h2.765l-0.417 0.25h-2.348zM8 12.625v-0.25h3.598l-0.417 0.25h-3.181zM8 12.125v-0.25h4.431l-0.417 0.25h-4.015zM8 11.625v-0.25h5.265l-0.417 0.25h-4.848zM8.244 3.875l0.17 0.25h-0.413v-0.25h0.244zM8.583 4.375l0.17 0.25h-0.753v-0.25h0.583zM8.923 4.875l0.17 0.25h-1.093v-0.25h0.923zM9.263 5.375l0.17 0.25h-1.433v-0.25h1.263zM9.602 5.875l0.17 0.25h-1.772v-0.25h1.602zM9.942 6.375l0.17 0.25h-2.112v-0.25h1.942zM10.282 6.875l0.17 0.25h-2.452v-0.25h2.282zM10.621 7.375l0.17 0.25h-2.791v-0.25h2.621zM10.961 7.875l0.17 0.25h-3.131v-0.25h2.961zM11.301 8.375l0.17 0.25h-3.471v-0.25h3.301zM11.64 8.875l0.17 0.25h-3.81v-0.25h3.64zM11.98 9.375l0.17 0.25h-4.15v-0.25h3.98zM12.32 9.875l0.17 0.25h-4.49v-0.25h4.32zM12.659 10.375l0.17 0.25h-4.829v-0.25h4.659zM12.999 10.875l0.17 0.25h-5.169v-0.25h4.999z" })
        );
    }
    function Pyramid2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pyramid2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pyramid2.SVG = Pyramid2SVG;
    return Pyramid2;
})();
export const Package = /*#__PURE__*/ (() => {
    function PackageSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 0l-10 2v11l3 3 10-2v-11l-3-3zM10.753 0.814l2.363 2.363-8.232 1.646-2.363-2.363 8.232-1.646zM5 5.565l0.125-0.025v9.47l-0.125 0.025v-9.47zM5.375 5.49l0.25-0.050v9.47l-0.25 0.050v-9.47zM5.875 5.39l0.25-0.050v9.47l-0.25 0.050v-9.47zM6.375 5.29l0.25-0.050v9.47l-0.25 0.050v-9.47zM6.875 5.19l0.25-0.050v9.47l-0.25 0.050v-9.47zM7.375 5.090l0.25-0.050v9.47l-0.25 0.050v-9.47zM7.875 4.99l0.25-0.050v9.47l-0.25 0.050v-9.47zM8.375 4.89l0.25-0.050v9.47l-0.25 0.050v-9.47zM8.875 4.79l0.25-0.050v9.47l-0.25 0.050v-9.47zM9.375 4.69l0.25-0.050v9.47l-0.25 0.050v-9.47zM9.875 4.59l0.25-0.050v9.47l-0.25 0.050v-9.47zM10.375 4.49l0.25-0.050v9.47l-0.25 0.050v-9.47zM10.875 4.39l0.25-0.050v9.47l-0.25 0.050v-9.47zM11.375 4.29l0.25-0.050v9.47l-0.25 0.050v-9.47zM11.875 4.19l0.25-0.050v9.47l-0.25 0.050v-9.47zM12.375 4.090l0.25-0.050v9.47l-0.25 0.050v-9.47zM12.875 3.99l0.125-0.025v9.47l-0.125 0.025v-9.47z" })
        );
    }
    function Package({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PackageSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Package.SVG = PackageSVG;
    return Package;
})();
export const Puzzle = /*#__PURE__*/ (() => {
    function PuzzleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.974 4.004h-2.632c-0.679-0.001-1.355-0.047-0.695-1.21 0.661-1.166 1.127-2.798-1.525-2.798s-2.185 1.632-1.525 2.798c0.659 1.163-0.017 1.209-0.695 1.21h-2.873c-0.564 0-1.026 0.462-1.026 1.026v3.193c0 0.68 0.184 1.36-0.981 0.699s-3.021-1.127-3.021 1.525c0 2.652 1.855 2.185 3.021 1.525s0.981 0.019 0.981 0.699v2.306c0 0.564 0.462 1.026 1.026 1.026h2.869c0.68 0 1.36-0.272 0.699-1.438s-1.127-2.797 1.525-2.797 2.186 1.632 1.525 2.797c-0.66 1.166 0.019 1.438 0.699 1.438h2.628c0.564 0 1.026-0.462 1.026-1.026v-9.948c0-0.564-0.462-1.026-1.026-1.026z" })
        );
    }
    function Puzzle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PuzzleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Puzzle.SVG = PuzzleSVG;
    return Puzzle;
})();
export const Puzzle2 = /*#__PURE__*/ (() => {
    function Puzzle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.543 16h-2.452c-0.772 0-1.115-0.309-1.267-0.569-0.23-0.394-0.17-0.906 0.178-1.524 0.379-0.672 0.506-1.212 0.348-1.483-0.148-0.253-0.622-0.393-1.335-0.393s-1.188 0.139-1.335 0.393c-0.158 0.271-0.031 0.811 0.348 1.483 0.348 0.617 0.408 1.13 0.178 1.524-0.152 0.26-0.494 0.569-1.267 0.569h-2.477c-0.804 0-1.457-0.656-1.457-1.462v-2.161c0-0.087 0.003-0.171 0.005-0.251 0.001-0.020 0.001-0.041 0.002-0.063-0.049 0.024-0.108 0.055-0.176 0.094-0.438 0.249-1.369 0.546-2.029 0.546-0.544 0-0.997-0.206-1.31-0.595-0.335-0.415-0.497-1.009-0.497-1.815s0.163-1.4 0.497-1.815c0.313-0.389 0.766-0.595 1.31-0.595 0.66 0 1.591 0.297 2.029 0.546 0.068 0.039 0.126 0.069 0.176 0.094-0.001-0.022-0.001-0.044-0.002-0.064-0.003-0.080-0.005-0.164-0.005-0.251l-0.013-2.74c0-0.808 0.654-1.464 1.457-1.464h2.481c0.073-0 0.261-0 0.383-0.018-0.021-0.071-0.067-0.19-0.169-0.37-0.583-1.033-0.698-2.117-0.341-2.729 0.344-0.59 1.084-0.889 2.199-0.889s1.855 0.299 2.199 0.889c0.357 0.611 0.242 1.695-0.341 2.729-0.102 0.18-0.148 0.299-0.169 0.37 0.122 0.018 0.31 0.018 0.383 0.018h2.455c0.804 0 1.457 0.656 1.457 1.461l0.012 9.071c0 0.807-0.654 1.462-1.457 1.462zM11.688 14.926c0.029 0.023 0.147 0.074 0.402 0.074h2.452c0.252 0 0.457-0.207 0.457-0.462l-0.012-9.071c0-0.255-0.205-0.462-0.457-0.462h-2.456c-0.401-0.001-1.005-0.002-1.284-0.481-0.268-0.46-0.014-1.019 0.2-1.399 0.379-0.672 0.506-1.462 0.348-1.733-0.148-0.253-0.622-0.393-1.336-0.393s-1.188 0.139-1.335 0.393c-0.158 0.271-0.031 1.061 0.348 1.733 0.214 0.38 0.468 0.938 0.2 1.399-0.279 0.479-0.884 0.48-1.284 0.481h-2.482c-0.252 0-0.457 0.207-0.457 0.461l0.013 2.74c0 0.073 0.003 0.148 0.005 0.22 0.012 0.35 0.024 0.712-0.229 0.974-0.095 0.099-0.265 0.216-0.531 0.216-0 0-0 0-0 0-0.241 0-0.521-0.098-0.907-0.318-0.464-0.264-1.195-0.415-1.534-0.415-0.221 0-0.807 0-0.807 1.41s0.587 1.41 0.807 1.41c0.34 0 1.071-0.151 1.534-0.415 0.386-0.22 0.666-0.318 0.907-0.318 0.266 0 0.436 0.118 0.531 0.216 0.253 0.261 0.241 0.623 0.229 0.974-0.002 0.072-0.005 0.147-0.005 0.218v2.161c0 0.254 0.205 0.462 0.457 0.462h2.477c0.255 0 0.373-0.051 0.402-0.074 0.004-0.028 0.014-0.176-0.185-0.527-0.583-1.033-0.698-1.867-0.341-2.479 0.344-0.59 1.084-0.889 2.199-0.889s1.855 0.299 2.199 0.889c0.357 0.611 0.242 1.445-0.341 2.479-0.198 0.351-0.189 0.499-0.185 0.527z" })
        );
    }
    function Puzzle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Puzzle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Puzzle2.SVG = Puzzle2SVG;
    return Puzzle2;
})();
export const Puzzle3 = /*#__PURE__*/ (() => {
    function Puzzle3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.692 7.254l-1.694-1.694c-1.304-1.305 0.365-1.201 1.335-2.070 0.005-0.004 0.010-0.009 0.014-0.013 0.022-0.021 0.045-0.041 0.066-0.063 0.781-0.781 0.781-2.047 0-2.828s-2.047-0.781-2.828 0c-0.022 0.022-0.043 0.044-0.063 0.066-0.004 0.005-0.009 0.010-0.013 0.014-0.87 0.969-0.765 2.639-2.071 1.334l-1.693-1.693c-0.41-0.41-1.081-0.41-1.492 0l-1.692 1.692c-0 0-0 0-0 0-1.306 1.306-1.202-0.364-2.071-1.333-0.004-0.005-0.009-0.010-0.013-0.014-0.021-0.022-0.041-0.045-0.063-0.066-0.781-0.781-2.047-0.781-2.828 0s-0.781 2.047 0 2.828c0.022 0.022 0.044 0.043 0.066 0.063 0.005 0.004 0.010 0.009 0.014 0.013 0.97 0.87 2.64 0.765 1.333 2.071-0 0-0 0-0 0l-1.692 1.692c-0.41 0.41-0.41 1.081 0 1.492l1.692 1.692c0 0 0 0 0 0 1.306 1.306-0.364 1.202-1.333 2.071-0.005 0.004-0.010 0.009-0.014 0.013-0.022 0.021-0.045 0.041-0.066 0.063-0.781 0.781-0.781 2.047 0 2.828s2.047 0.781 2.828 0c0.022-0.022 0.043-0.044 0.063-0.066 0.004-0.005 0.009-0.010 0.013-0.014 0.87-0.969 0.765-2.639 2.071-1.334l1.693 1.693c0.41 0.41 1.081 0.41 1.492 0l1.966-1.966c0.783-1.007-0.701-0.983-1.592-1.783-0.005-0.004-0.010-0.009-0.014-0.013-0.023-0.021-0.045-0.041-0.066-0.063-0.781-0.781-0.781-2.047 0-2.828s2.047-0.781 2.828 0c0.022 0.022 0.043 0.044 0.063 0.066 0.004 0.005 0.009 0.010 0.013 0.014 0.8 0.892 0.776 2.376 1.783 1.592l1.966-1.966c0.41-0.41 0.41-1.081 0-1.492z" })
        );
    }
    function Puzzle3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Puzzle3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Puzzle3.SVG = Puzzle3SVG;
    return Puzzle3;
})();
export const Puzzle4 = /*#__PURE__*/ (() => {
    function Puzzle4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c0.42 0 0.815-0.163 1.11-0.459l1.846-1.846 0.023-0.029c0.104-0.134 0.422-0.543 0.304-1.037-0.123-0.513-0.596-0.736-1.054-0.952-0.283-0.133-0.576-0.271-0.795-0.467l-0.011-0.010c-0.014-0.013-0.028-0.026-0.042-0.040-0.49-0.49-0.49-1.288 0-1.779 0.238-0.238 0.553-0.368 0.889-0.368s0.652 0.131 0.889 0.368c0.014 0.014 0.027 0.028 0.043 0.045l0.006 0.007c0.197 0.22 0.335 0.513 0.469 0.797 0.226 0.481 0.508 1.079 1.17 1.079 0 0 0 0 0 0 0.265 0 0.533-0.108 0.818-0.33l0.029-0.023 1.846-1.846c0.612-0.612 0.612-1.608-0-2.221l-1.568-1.568c-0.1-0.1-0.164-0.176-0.205-0.23 0.095-0.053 0.227-0.115 0.333-0.165 0.327-0.154 0.735-0.346 1.082-0.658 0.006-0.005 0.012-0.011 0.018-0.017 0.030-0.028 0.057-0.053 0.081-0.077 0.462-0.462 0.716-1.076 0.716-1.729s-0.254-1.267-0.716-1.729c-0.462-0.462-1.076-0.716-1.729-0.716s-1.267 0.254-1.729 0.716c-0.024 0.024-0.048 0.050-0.074 0.078l-0.018 0.020c-0.313 0.349-0.505 0.756-0.659 1.084-0.050 0.106-0.112 0.238-0.165 0.333-0.055-0.041-0.131-0.105-0.231-0.206l-1.567-1.567c-0.296-0.296-0.69-0.459-1.11-0.459s-0.814 0.163-1.11 0.459l-1.567 1.567c-0.1 0.1-0.177 0.165-0.231 0.206-0.053-0.095-0.115-0.227-0.165-0.333-0.154-0.327-0.346-0.735-0.659-1.084-0.006-0.006-0.011-0.013-0.016-0.017-0.028-0.031-0.053-0.057-0.077-0.081-0.462-0.462-1.076-0.716-1.729-0.716s-1.267 0.254-1.729 0.716c-0.953 0.953-0.953 2.505-0 3.458 0.024 0.024 0.049 0.048 0.079 0.076 0.006 0.006 0.012 0.011 0.019 0.018 0.349 0.313 0.756 0.505 1.084 0.659 0.106 0.050 0.238 0.112 0.333 0.165-0.041 0.055-0.106 0.131-0.206 0.231l-1.567 1.567c-0.296 0.296-0.459 0.69-0.459 1.11s0.163 0.815 0.459 1.11l1.567 1.567c0.1 0.1 0.165 0.177 0.206 0.231-0.095 0.053-0.227 0.115-0.333 0.165-0.327 0.154-0.735 0.346-1.084 0.659l-0.018 0.016c-0.031 0.028-0.057 0.053-0.080 0.077-0.953 0.953-0.953 2.505 0 3.458 0.462 0.462 1.076 0.716 1.729 0.716s1.267-0.254 1.729-0.716c0.024-0.024 0.048-0.049 0.075-0.079 0.005-0.005 0.010-0.010 0.016-0.017l0.002-0.002c0.313-0.349 0.505-0.756 0.659-1.084 0.050-0.106 0.112-0.238 0.165-0.333 0.055 0.041 0.131 0.105 0.231 0.206l1.567 1.567c0.296 0.296 0.69 0.459 1.11 0.459zM5.022 12.517c-0.662 0-0.944 0.599-1.17 1.079-0.133 0.283-0.271 0.576-0.468 0.796l-0.009 0.010c-0.013 0.014-0.026 0.028-0.040 0.042-0.238 0.238-0.553 0.368-0.889 0.368s-0.652-0.131-0.889-0.368c-0.49-0.49-0.49-1.288 0-1.779 0.014-0.014 0.028-0.027 0.041-0.039l0.012-0.011c0.219-0.196 0.512-0.334 0.795-0.467 0.454-0.214 0.969-0.456 1.065-1.008 0.092-0.527-0.275-0.973-0.604-1.303l-1.567-1.567c-0.072-0.072-0.111-0.168-0.111-0.271s0.039-0.199 0.111-0.271l1.526-1.526 0.026-0.017 0.037-0.046c0.324-0.327 0.672-0.765 0.582-1.281-0.096-0.552-0.611-0.794-1.065-1.008-0.284-0.134-0.577-0.272-0.796-0.468l-0.010-0.009c-0.014-0.013-0.028-0.026-0.042-0.040-0.49-0.49-0.49-1.288-0-1.779 0.238-0.238 0.553-0.368 0.889-0.368s0.652 0.131 0.889 0.369c0.014 0.014 0.027 0.028 0.041 0.044l0.007 0.008c0.197 0.22 0.335 0.513 0.469 0.797 0.226 0.481 0.508 1.079 1.17 1.079 0 0 0 0 0 0 0.359-0 0.708-0.188 1.131-0.609l1.576-1.576c0.072-0.072 0.168-0.111 0.271-0.111s0.199 0.039 0.271 0.111l1.567 1.567c0.427 0.427 0.779 0.618 1.14 0.618 0 0 0 0 0 0 0.662-0 0.944-0.599 1.17-1.079 0.134-0.284 0.272-0.577 0.467-0.795l0.010-0.011c0.013-0.014 0.027-0.029 0.040-0.042 0.238-0.238 0.553-0.368 0.889-0.368s0.652 0.131 0.889 0.368c0.238 0.238 0.368 0.553 0.368 0.889s-0.131 0.652-0.369 0.89c-0.013 0.014-0.027 0.026-0.041 0.039l-0.010 0.009c-0.22 0.197-0.513 0.335-0.797 0.469-0.454 0.214-0.969 0.456-1.065 1.008-0.092 0.527 0.274 0.972 0.603 1.302l1.568 1.568c0.147 0.147 0.147 0.395 0 0.541l-1.785 1.785c-0.053-0.095-0.115-0.226-0.165-0.332-0.154-0.327-0.346-0.734-0.661-1.085l-0.014-0.016c-0.027-0.030-0.052-0.056-0.077-0.081-0.462-0.462-1.076-0.716-1.729-0.716s-1.267 0.254-1.729 0.716c-0.953 0.953-0.953 2.505-0.001 3.457 0.024 0.025 0.050 0.049 0.082 0.078l0.017 0.016c0.349 0.313 0.756 0.505 1.084 0.659 0.106 0.050 0.237 0.112 0.332 0.165l-1.785 1.785c-0.072 0.072-0.168 0.111-0.271 0.111s-0.199-0.039-0.271-0.111l-1.567-1.567c-0.427-0.427-0.779-0.618-1.14-0.618z" })
        );
    }
    function Puzzle4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Puzzle4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Puzzle4.SVG = Puzzle4SVG;
    return Puzzle4;
})();
export const Glasses3D = /*#__PURE__*/ (() => {
        function Glasses3DSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 5v6h-5.086l-2.207-2.207c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293l-2.207 2.207h-5.086v-6h16zM18 4h-18v8h6.5l2.5-2.5 2.5 2.5h6.5v-8z" }),
_('path', { d: "M2 6v4h3.5l2.5-2.5v-1.5h-6zM5 9h-2v-2h4l-2 2z" }),
_('path', { d: "M10 6v1.5l2.5 2.5h3.5v-4z" })
            );
        }
        function Glasses3D({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Glasses3DSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Glasses3D.SVG = Glasses3DSVG;
        return Glasses3D;
    })();
export const Glasses3D2 = /*#__PURE__*/ (() => {
        function Glasses3D2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 18 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 18 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 10.5v-1.5h-6v4h3.5l2.5-2.5zM3 12v-2h4l-2 2h-2z" }),
_('path', { d: "M16 13v-4h-6v1.5l2.5 2.5z" }),
_('path', { d: "M10.376 0.098c-0.207-0.181-0.376-0.104-0.376 0.171v1.125c0 0.275 0.016 0.426 0.187 0.64l3.813 4.966h-10l3.813-4.966c0.172-0.215 0.187-0.365 0.187-0.64v-1.125c0-0.275-0.169-0.352-0.376-0.171l-7.624 6.902v8h6.5l2.5-2.5 2.5 2.5h6.5v-8l-7.624-6.902zM17 14h-5.086l-2.207-2.207c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293l-2.207 2.207h-5.086v-6h16v6z" })
            );
        }
        function Glasses3D2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Glasses3D2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Glasses3D2.SVG = Glasses3D2SVG;
        return Glasses3D2;
    })();
export const Glasses = /*#__PURE__*/ (() => {
    function GlassesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.392 10.927c-0.517 0-1.257-0.036-1.705-0.345-0.561-0.387-1.008-1.943-1.224-2.837-0.038-0.158-0.146-0.23-0.262-0.26l-0.201-0.017-0.204 0.018c-0.115 0.030-0.221 0.103-0.259 0.26-0.217 0.893-0.664 2.45-1.224 2.837-0.448 0.309-1.187 0.345-1.705 0.345-0.116 0-0.222-0.002-0.317-0.003-0.072-0.001-0.136-0.002-0.19-0.002-2.155 0-2.871-0.73-3.092-1.342-0.171-0.472-0.279-0.973-0.375-1.414-0.126-0.58-0.255-1.179-0.466-1.303l-0.071-0.042-0.031-0.076c-0.131-0.325-0.036-1.127-0.016-1.284l0.024-0.188 0.188-0.022c0.94-0.11 2.347-0.177 2.943-0.177 0.023 0 2.328 0.015 3.005 0.343 0.093 0.045 0.187 0.094 0.277 0.141 0.426 0.222 0.867 0.452 1.512 0.456 0.642-0.004 1.083-0.234 1.509-0.456 0.091-0.047 0.184-0.096 0.277-0.141 0.677-0.328 2.982-0.343 3.005-0.343 0.596 0 2.004 0.067 2.943 0.177l0.188 0.022 0.024 0.188c0.020 0.157 0.115 0.96-0.015 1.284l-0.031 0.076-0.071 0.042c-0.21 0.124-0.34 0.724-0.466 1.303-0.096 0.441-0.204 0.942-0.375 1.414-0.221 0.612-0.937 1.342-3.092 1.342-0.054 0-0.118 0.001-0.19 0.002-0.094 0.002-0.201 0.003-0.316 0.003zM12.935 6.109c-1.578 0-2.664 0.211-3.006 0.408-0.396 0.228-0.471 0.459-0.471 0.805 0 0.278 0.31 1.505 0.543 1.971 0.205 0.411 0.465 0.608 0.843 0.64 0.146 0.012 0.365 0.020 0.599 0.020 0.923 0 1.716-0.094 2.020-0.238 0.396-0.189 0.806-0.385 0.939-2.18 0.006-0.080 0.014-0.161 0.021-0.239 0.037-0.38 0.068-0.708-0.105-0.903-0.154-0.173-0.49-0.267-0.998-0.278-0.128-0.003-0.258-0.004-0.386-0.004zM3.065 6.109c-0.127 0-0.257 0.001-0.386 0.004-0.508 0.011-0.844 0.105-0.998 0.278-0.173 0.195-0.142 0.524-0.105 0.904 0.008 0.078 0.015 0.158 0.021 0.238 0.133 1.796 0.542 1.991 0.939 2.18 0.304 0.145 1.096 0.238 2.020 0.238 0.235 0 0.453-0.007 0.599-0.020 0.378-0.032 0.638-0.23 0.843-0.64 0.17-0.341 0.543-1.591 0.543-1.971 0-0.347-0.075-0.578-0.471-0.805-0.341-0.196-1.428-0.407-3.006-0.407z" })
        );
    }
    function Glasses({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GlassesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glasses.SVG = GlassesSVG;
    return Glasses;
})();
export const Glasses2 = /*#__PURE__*/ (() => {
    function Glasses2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.948 5.412c-0.986-0.115-2.431-0.181-3.006-0.181s-2.447 0.066-2.99 0.328c-0.538 0.261-1.077 0.635-1.952 0.64-0.876-0.005-1.414-0.379-1.953-0.64-0.542-0.263-2.415-0.328-2.989-0.328s-2.020 0.066-3.006 0.181c0 0-0.117 0.908 0 1.199 0.506 0.3 0.534 1.714 0.974 2.933s2.496 1.218 2.953 1.218c0.457 0 1.587 0.075 2.138-0.305s1.030-2.236 1.162-2.778c0.112-0.461 0.568-0.482 0.702-0.478 0 0.001 0 0.002 0 0.002s0.007-0.001 0.019-0.001c0.012 0.001 0.019 0.001 0.019 0.001s0-0.001 0-0.002c0.134-0.004 0.59 0.017 0.702 0.478 0.131 0.542 0.61 2.398 1.162 2.778s1.681 0.305 2.138 0.305c0.457 0 2.513 0 2.953-1.218s0.468-2.633 0.974-2.933c0.117-0.291-0-1.199-0-1.199z" })
        );
    }
    function Glasses2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Glasses2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Glasses2.SVG = Glasses2SVG;
    return Glasses2;
})();
export const Brain = /*#__PURE__*/ (() => {
        function BrainSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.5 16c-0.276 0-0.5-0.224-0.5-0.5v-0.5c0-3.074 0.921-4.141 1.734-5.083 0.679-0.787 1.266-1.466 1.266-3.417 0-3.033-2.692-5.5-6-5.5s-6 2.467-6 5.5v0.5c0 0.046-0.006 0.093-0.019 0.137l-0.818 2.863h1.337c0.276 0 0.5 0.224 0.5 0.5v2c0 0.224 0.276 0.5 0.5 0.5h2c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.5h-1.5c-0.771 0-1.5-0.729-1.5-1.5v-1.5h-1.5c-0.157 0-0.305-0.074-0.399-0.199s-0.125-0.288-0.082-0.438l0.981-3.433v-0.43c0-1.744 0.733-3.381 2.065-4.61 1.32-1.219 3.073-1.89 4.935-1.89s3.615 0.671 4.935 1.89c1.331 1.229 2.065 2.866 2.065 4.61 0 2.323-0.767 3.212-1.509 4.071-0.767 0.888-1.491 1.727-1.491 4.429v0.5c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M9 2.5c-2.209 0-4 1.231-4 2.75v0.25c0 1.381 1.119 2.5 2.5 2.5h1.768c0.346 0.598 0.992 1 1.732 1 1.105 0 2-0.895 2-2v-1.75c0-1.519-1.791-2.75-4-2.75z" })
            );
        }
        function Brain({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BrainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Brain.SVG = BrainSVG;
        return Brain;
    })();
export const Accessibility = /*#__PURE__*/ (() => {
        function AccessibilitySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" }),
_('path', { d: "M10 5l5.15-2.221-0.371-0.929-6.279 2.15h-1l-6.279-2.15-0.371 0.929 5.15 2.221v4l-2.051 6.634 0.935 0.355 2.902-6.489h0.429l2.902 6.489 0.935-0.355-2.051-6.634z" })
            );
        }
        function Accessibility({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AccessibilitySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Accessibility.SVG = AccessibilitySVG;
        return Accessibility;
    })();
export const Accessibility2 = /*#__PURE__*/ (() => {
        function Accessibility2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 10.985l-1.545 1.030-2.955-4.015h-4.5v-1h4v-2h-4v-1l-2-0.5v6.5h5.5l3.268 4.357 3.119-2.079z" }),
_('path', { d: "M8 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M10.609 12.349c-0.903 1.3-2.407 2.151-4.109 2.151-2.761 0-5-2.239-5-5 0-1.937 1.101-3.616 2.711-4.446l-0.978-1.174c-1.933 1.126-3.233 3.221-3.233 5.62 0 3.59 2.91 6.5 6.5 6.5 2.096 0 3.96-0.992 5.148-2.532l-1.039-1.119z" })
            );
        }
        function Accessibility2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Accessibility2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Accessibility2.SVG = Accessibility2SVG;
        return Accessibility2;
    })();
export const Strategy = /*#__PURE__*/ (() => {
        function StrategySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.5 7c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zM3.5 1c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5z" }),
_('path', { d: "M12.078 3h2.422l-3-3-3 3h2.422c0 0.891-0.25 1.842-0.724 2.748-0.485 0.929-1.207 1.814-2.087 2.562-1.984 1.685-4.654 2.613-7.516 2.613-0.319 0-0.578 0.259-0.578 0.578s0.259 0.578 0.578 0.578c3.136 0 6.072-1.025 8.265-2.887 0.993-0.843 1.81-1.848 2.364-2.907 0.56-1.071 0.856-2.206 0.856-3.284z" }),
_('path', { d: "M13.707 13l2.146-2.146c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-2.146 2.146-2.146-2.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.146 2.146-2.146 2.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.146-2.146 2.146 2.146c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2.146-2.146z" })
            );
        }
        function Strategy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StrategySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Strategy.SVG = StrategySVG;
        return Strategy;
    })();
export const Target = /*#__PURE__*/ (() => {
    function TargetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.411 0-8 3.589-8 8s3.589 8 8 8c4.411 0 8-3.589 8-8s-3.589-8-8-8zM8 14.222c-3.431 0-6.222-2.791-6.222-6.222s2.791-6.222 6.222-6.222 6.222 2.791 6.222 6.222c0 3.431-2.791 6.222-6.222 6.222zM8 3.556c-2.451 0-4.444 1.994-4.444 4.444s1.994 4.444 4.444 4.444 4.444-1.994 4.444-4.444c0-2.451-1.994-4.444-4.444-4.444zM8 10.667c-1.471 0-2.667-1.196-2.667-2.667s1.196-2.667 2.667-2.667c1.47 0 2.667 1.196 2.667 2.667s-1.196 2.667-2.667 2.667zM7 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z" })
        );
    }
    function Target({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TargetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Target.SVG = TargetSVG;
    return Target;
})();
export const Target2 = /*#__PURE__*/ (() => {
    function Target2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z" })
        );
    }
    function Target2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Target2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Target2.SVG = Target2SVG;
    return Target2;
})();
export const Target3 = /*#__PURE__*/ (() => {
    function Target3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.243 12.243c-0.894 0.894-2.020 1.471-3.243 1.675v-2.917h-2v2.917c-1.222-0.204-2.349-0.781-3.243-1.675s-1.471-2.020-1.675-3.243h2.917v-2h-2.917c0.204-1.222 0.781-2.349 1.675-3.243s2.020-1.471 3.243-1.675v2.917h2v-2.917c1.222 0.204 2.349 0.781 3.243 1.675s1.471 2.020 1.675 3.243h-2.917v2h2.917c-0.204 1.222-0.781 2.349-1.675 3.243z" })
        );
    }
    function Target3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Target3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Target3.SVG = Target3SVG;
    return Target3;
})();
export const Ammo = /*#__PURE__*/ (() => {
        function AmmoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.871 3.504l-0 0c-0.044-0.077-0.098-0.15-0.164-0.215-0.391-0.391-1.024-0.391-1.414 0-0.066 0.066-0.12 0.138-0.164 0.215l-0-0c-0.793 1.215-1.129 3.516-1.129 5.508v0 6.492c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6.492c-0-1.992-0.336-4.293-1.129-5.508zM3 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.504c0 0 0.003 0.003 0.008 0.008h-0.008v5.488z" }),
_('path', { d: "M8.871 3.504l-0 0c-0.044-0.077-0.098-0.15-0.164-0.215-0.39-0.391-1.024-0.391-1.414 0-0.066 0.066-0.12 0.138-0.164 0.215l-0-0c-0.793 1.215-1.129 3.516-1.129 5.508v0 6.492c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6.492c-0-1.992-0.336-4.293-1.129-5.508zM8 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.504c0 0 0.003 0.003 0.008 0.008h-0.008v5.488z" }),
_('path', { d: "M13.871 3.504l-0 0c-0.044-0.077-0.098-0.15-0.164-0.215-0.39-0.391-1.024-0.391-1.414 0-0.066 0.066-0.12 0.138-0.164 0.215l-0-0c-0.793 1.215-1.129 3.516-1.129 5.508v0 6.492c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6.492c0-1.992-0.336-4.293-1.129-5.508zM13 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.504c0 0 0.003 0.003 0.008 0.008h-0.008v5.488z" })
            );
        }
        function Ammo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AmmoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ammo.SVG = AmmoSVG;
        return Ammo;
    })();
export const Gun = /*#__PURE__*/ (() => {
    function GunSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3v2h0.875l0.25 2h4.875v1.5c0 0.825 0.675 1.5 1.5 1.5h2.857l0.921 3.222-0.071 0.071c-0.389 0.389-0.257 0.707 0.293 0.707h4.5v-2l-1.6-4c-0.53-1.325 1.1-2 1.6-2v-2c0-0.55-0.45-1-1-1zM7.5 9c-0.271 0-0.5-0.229-0.5-0.5v-1.5h1v1h1.786l0.286 1h-2.571z" })
        );
    }
    function Gun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Gun.SVG = GunSVG;
    return Gun;
})();
export const GunForbidden = /*#__PURE__*/ (() => {
    function GunForbiddenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.219 7h-5.094l-0.25-2h-0.875v-2h9.219zM16 6v-2c0-0.55-0.45-1-1-1h-2.313l2.25-3h-1.875l-10.5 14h1.875l3.001-4.001c0.020 0.001 0.041 0.001 0.061 0.001h2.857l0.921 3.222-0.071 0.071c-0.389 0.389-0.257 0.707 0.293 0.707h4.5v-2l-1.6-4c-0.53-1.325 1.1-2 1.6-2zM8.188 9l0.75-1h0.848l0.286 1h-1.884z" })
        );
    }
    function GunForbidden({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GunForbiddenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GunForbidden.SVG = GunForbiddenSVG;
    return GunForbidden;
})();
export const Shield = /*#__PURE__*/ (() => {
    function ShieldSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.739 3.061l-5.5-3c-0.075-0.041-0.157-0.061-0.239-0.061s-0.165 0.020-0.239 0.061l-5.5 3c-0.161 0.088-0.261 0.256-0.261 0.439v4c0 2.2 0.567 3.978 1.735 5.437 0.912 1.14 2.159 2.068 4.042 3.010 0.070 0.035 0.147 0.053 0.224 0.053s0.153-0.018 0.224-0.053c1.883-0.942 3.13-1.87 4.042-3.010 1.167-1.459 1.735-3.238 1.735-5.437l0-4c0-0.183-0.1-0.351-0.261-0.439zM12.5 7.5c0 0.953-0.117 1.784-0.359 2.541-0.232 0.728-0.575 1.369-1.047 1.96-0.699 0.874-1.664 1.617-3.094 2.375 0 0-0-0-0-0v-12.736l0-0 4.5 2.455-0 3.406z" })
        );
    }
    function Shield({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShieldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shield.SVG = ShieldSVG;
    return Shield;
})();
export const ShieldCheck = /*#__PURE__*/ (() => {
    function ShieldCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.739 3.061l-5.5-3c-0.075-0.041-0.157-0.061-0.239-0.061s-0.165 0.020-0.239 0.061l-5.5 3c-0.161 0.088-0.261 0.256-0.261 0.439v4c0 2.2 0.567 3.978 1.735 5.437 0.912 1.14 2.159 2.068 4.042 3.010 0.070 0.035 0.147 0.053 0.224 0.053s0.153-0.018 0.224-0.053c1.883-0.942 3.13-1.87 4.042-3.010 1.167-1.459 1.735-3.238 1.735-5.437l0-4c0-0.183-0.1-0.351-0.261-0.439zM6.5 11.296l-2.796-2.796 0.796-0.795 2 2 5-5 0.796 0.795-5.795 5.795z" })
        );
    }
    function ShieldCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShieldCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ShieldCheck.SVG = ShieldCheckSVG;
    return ShieldCheck;
})();
export const ShieldNotice = /*#__PURE__*/ (() => {
    function ShieldNoticeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.739 3.061l-5.5-3c-0.075-0.041-0.157-0.061-0.239-0.061s-0.165 0.020-0.239 0.061l-5.5 3c-0.161 0.088-0.261 0.256-0.261 0.439v4c0 2.2 0.567 3.978 1.735 5.437 0.912 1.14 2.159 2.068 4.042 3.010 0.070 0.035 0.147 0.053 0.224 0.053s0.153-0.018 0.224-0.053c1.883-0.942 3.13-1.87 4.042-3.010 1.167-1.459 1.735-3.238 1.735-5.437l0-4c0-0.183-0.1-0.351-0.261-0.439zM9 13h-2v-2h2v2zM9 10h-2v-7h2v7z" })
        );
    }
    function ShieldNotice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShieldNoticeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ShieldNotice.SVG = ShieldNoticeSVG;
    return ShieldNotice;
})();
export const Shield2 = /*#__PURE__*/ (() => {
        function Shield2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 1.639l4.5 2.455-0 3.406c0 0.953-0.117 1.784-0.359 2.541-0.232 0.728-0.575 1.369-1.047 1.96-0.699 0.874-1.664 1.617-3.094 2.375-1.43-0.758-2.395-1.501-3.094-2.375-0.472-0.591-0.815-1.232-1.047-1.96-0.241-0.756-0.359-1.588-0.359-2.541v-3.406l4.5-2.455zM8 0c-0.082 0-0.165 0.020-0.239 0.061l-5.5 3c-0.161 0.088-0.261 0.256-0.261 0.439v4c0 2.2 0.567 3.978 1.735 5.437 0.912 1.14 2.159 2.068 4.042 3.010 0.070 0.035 0.147 0.053 0.224 0.053s0.153-0.018 0.224-0.053c1.883-0.942 3.13-1.87 4.042-3.010 1.167-1.459 1.735-3.238 1.735-5.437l0-4c0-0.183-0.1-0.351-0.261-0.439l-5.5-3c-0.075-0.041-0.157-0.061-0.239-0.061v0z" }),
_('path', { d: "M5 4.984v2.516c0 0.796 0.094 1.478 0.288 2.085 0.176 0.55 0.434 1.034 0.79 1.479 0.456 0.57 1.064 1.075 1.923 1.591 0.859-0.516 1.467-1.021 1.923-1.591 0.356-0.445 0.614-0.928 0.789-1.479 0.194-0.607 0.288-1.289 0.288-2.085l0-2.516-3-1.636-3 1.636z" })
            );
        }
        function Shield2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Shield2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Shield2.SVG = Shield2SVG;
        return Shield2;
    })();
export const Shield3 = /*#__PURE__*/ (() => {
    function Shield3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584z" })
        );
    }
    function Shield3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shield3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shield3.SVG = Shield3SVG;
    return Shield3;
})();
export const Shield4 = /*#__PURE__*/ (() => {
    function Shield4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584zM7.648 6.568l0.151 0.057h-5.073c-0.020-0.084-0.039-0.167-0.058-0.25h4.467l0.514 0.193zM3.144 4.875l0.665 0.25h-1.393c-0.015-0.084-0.029-0.167-0.043-0.25h0.771zM4.474 5.375l0.665 0.25h-2.63c-0.016-0.084-0.032-0.167-0.047-0.25h2.013zM5.804 5.875l0.665 0.25h-3.857c-0.018-0.084-0.036-0.167-0.053-0.25h3.245zM13.676 4.567c-0.238 1.549-0.656 3.388-1.389 5.119-1.029 2.431-2.47 4.174-4.287 5.189v-0.249h-0.415c-0.124-0.080-0.247-0.163-0.368-0.25h0.782v-0.25h-1.111c-0.101-0.081-0.2-0.164-0.298-0.25h1.41v-0.25h-1.682c-0.085-0.081-0.169-0.165-0.252-0.25h1.934v-0.25h-2.168c-0.073-0.081-0.145-0.165-0.217-0.25h2.385v-0.25h-2.588c-0.064-0.082-0.128-0.165-0.191-0.25h2.779v-0.25h-2.959c-0.057-0.082-0.113-0.166-0.169-0.25h3.128v-0.25h-3.288c-0.051-0.082-0.102-0.165-0.152-0.25h3.441v-0.25h-3.584c-0.046-0.082-0.092-0.166-0.137-0.25h3.721v-0.25h-3.851c-0.042-0.082-0.083-0.166-0.124-0.25h3.975v-0.25h-4.093c-0.038-0.082-0.075-0.166-0.112-0.25h4.205v-0.25h-4.312c-0.035-0.083-0.069-0.166-0.102-0.25h4.414v-0.25h-4.512c-0.032-0.083-0.063-0.167-0.093-0.25h4.605v-0.25h-4.694c-0.029-0.083-0.057-0.167-0.085-0.25h4.779v-0.25h-4.859c-0.026-0.083-0.052-0.167-0.078-0.25h4.937v-0.25h-5.011c-0.024-0.083-0.048-0.167-0.071-0.25h5.082v-0.25h-5.149c-0.022-0.084-0.043-0.167-0.064-0.25h5.213v-0.174l5.676-2.134z" })
        );
    }
    function Shield4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shield4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shield4.SVG = Shield4SVG;
    return Shield4;
})();
export const Soccer = /*#__PURE__*/ (() => {
    function SoccerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 13.5c-0.429 0-0.85-0.049-1.258-0.144l-0.965-1.871 1.063-1.463h2.32l1.063 1.463-0.964 1.871c-0.408 0.095-0.829 0.144-1.258 0.144zM5.869 2.927l1.881 0.947v1.808l-1.878 1.365-1.718-0.558-0.319-2.080c0.088-0.102 0.18-0.201 0.277-0.297 0.513-0.513 1.109-0.911 1.758-1.184zM11.889 4.111c0.096 0.096 0.188 0.195 0.277 0.297l-0.319 2.080-1.718 0.558-1.878-1.365v-1.808l1.881-0.947c0.649 0.273 1.245 0.671 1.758 1.184zM3.998 6.963l1.72 0.559 0.717 2.207-1.062 1.462-2.078-0.339c-0.44-0.723-0.706-1.539-0.776-2.395l1.479-1.494zM12.705 10.852l-2.078 0.339-1.062-1.462 0.717-2.207 1.72-0.559 1.479 1.494c-0.070 0.856-0.336 1.671-0.776 2.395zM13.303 2.697c0.427 0.427 0.798 0.898 1.107 1.408l-1.828 0.024c-0.62-0.734-1.414-1.316-2.317-1.685l-0.542-1.744c0.407 0.096 0.806 0.226 1.195 0.39 0.893 0.378 1.695 0.919 2.384 1.608zM2.697 2.697c0.689-0.689 1.491-1.23 2.384-1.607 0.389-0.164 0.788-0.294 1.195-0.39l-0.542 1.744c-0.903 0.369-1.697 0.951-2.317 1.685l-1.828-0.024c0.31-0.509 0.68-0.98 1.107-1.408zM0.5 8c0-0.207 0.009-0.412 0.025-0.615l1.491 1.054c0.072 0.995 0.387 1.923 0.885 2.724l-0.587 1.729c-0.509-0.591-0.92-1.252-1.225-1.972-0.391-0.924-0.589-1.906-0.589-2.919zM5.103 14.92l1.464-1.093c0.459 0.113 0.939 0.173 1.433 0.173s0.974-0.060 1.433-0.173l1.464 1.093c-0.918 0.385-1.892 0.58-2.897 0.58s-1.979-0.195-2.897-0.58zM14.911 10.919c-0.305 0.721-0.716 1.382-1.225 1.972l-0.587-1.729c0.498-0.802 0.813-1.729 0.885-2.724l1.491-1.054c0.017 0.204 0.025 0.409 0.025 0.615 0 1.013-0.198 1.995-0.589 2.919z" })
        );
    }
    function Soccer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SoccerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Soccer.SVG = SoccerSVG;
    return Soccer;
})();
export const Football = /*#__PURE__*/ (() => {
    function FootballSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.908 2.485c-0.131-1.19-1.202-2.261-2.393-2.393-3.233-0.356-7.424 0.246-10.301 3.122s-3.479 7.068-3.123 10.3c0.131 1.19 1.202 2.261 2.393 2.393 3.233 0.356 7.424-0.246 10.3-3.122s3.479-7.068 3.123-10.301zM5.080 9.080c0.232-0.232 0.608-0.232 0.84 0l1 1c0.232 0.232 0.232 0.608 0 0.84-0.116 0.116-0.268 0.174-0.42 0.174s-0.304-0.058-0.42-0.174l-1-1c-0.232-0.232-0.232-0.608 0-0.84zM5.341 14.951c-0.907-0.461-1.745-1.067-2.485-1.807s-1.347-1.58-1.808-2.488c0.056-0.685 0.168-1.419 0.362-2.176 0.066-0.258 0.14-0.51 0.221-0.756 0.295 1.642 1.081 3.154 2.285 4.359s2.714 1.989 4.355 2.285c-1.048 0.345-2.067 0.511-2.931 0.583zM8.92 8.92c-0.116 0.116-0.268 0.174-0.42 0.174s-0.304-0.058-0.42-0.174l-1-1c-0.232-0.232-0.232-0.608 0-0.84s0.608-0.232 0.84 0l1 1c0.232 0.232 0.232 0.608 0 0.84zM10.92 6.92c-0.116 0.116-0.268 0.174-0.42 0.174s-0.304-0.058-0.42-0.174l-1-1c-0.232-0.232-0.232-0.608 0-0.84s0.608-0.232 0.84 0l1 1c0.232 0.232 0.232 0.608 0 0.84zM14.59 7.52c-0.066 0.258-0.14 0.51-0.221 0.756-0.295-1.642-1.081-3.154-2.285-4.359s-2.714-1.989-4.355-2.285c1.048-0.345 2.067-0.511 2.931-0.583 0.907 0.461 1.745 1.067 2.485 1.807s1.347 1.58 1.808 2.488c-0.056 0.684-0.168 1.419-0.362 2.176z" })
        );
    }
    function Football({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FootballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Football.SVG = FootballSVG;
    return Football;
})();
export const Archery = /*#__PURE__*/ (() => {
        function ArcherySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 3h-1.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.793l-0.549 0.549c-0.678-0.527-1.528-0.841-2.451-0.841-2.206 0-4 1.794-4 4s1.794 4 4 4c2.206 0 4-1.794 4-4 0-0.923-0.314-1.774-0.841-2.451l0.549-0.549h1.793c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM10 8c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3c0.647 0 1.247 0.206 1.737 0.556l-1.478 1.478c-0.083-0.022-0.169-0.034-0.259-0.034-0.552 0-1 0.448-1 1s0.448 1 1 1 1-0.448 1-1c0-0.090-0.012-0.176-0.034-0.259l1.478-1.478c0.35 0.491 0.556 1.090 0.556 1.737z" }),
_('path', { d: "M13.063 8c0-0.561-0.077-1.118-0.228-1.653-0.085-0.299-0.395-0.473-0.694-0.388s-0.473 0.395-0.388 0.694c0.123 0.436 0.186 0.889 0.186 1.347 0 2.723-2.215 4.938-4.938 4.938s-4.938-2.215-4.938-4.938c0-2.723 2.215-4.938 4.938-4.938 0.458 0 0.911 0.063 1.347 0.186 0.299 0.085 0.61-0.089 0.694-0.388s-0.089-0.61-0.388-0.694c-0.536-0.151-1.092-0.228-1.653-0.228-3.343 0-6.063 2.72-6.063 6.063 0 1.746 0.742 3.321 1.927 4.428l-1.718 1.718c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l1.801-1.801c0.96 0.637 2.11 1.010 3.346 1.010s2.386-0.372 3.346-1.010l1.801 1.801c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-1.718-1.718c1.185-1.107 1.927-2.683 1.927-4.428z" })
            );
        }
        function Archery({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ArcherySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Archery.SVG = ArcherySVG;
        return Archery;
    })();
export const Bow = /*#__PURE__*/ (() => {
    function BowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.853 0.854c0.091-0.091 0.147-0.216 0.147-0.354 0-0.276-0.224-0.5-0.5-0.5-2.356 0-4.47 0.275-6.284 0.818-1.94 0.58-3.598 1.484-4.926 2.686-0.014 0.012-0.027 0.025-0.041 0.037l-2.542-2.542h0.793c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.793l2.542 2.542c-1.038 1.139-1.854 2.512-2.434 4.095-0.736 2.011-1.109 4.418-1.109 7.156 0 0.276 0.224 0.5 0.5 0.5 0.138 0 0.263-0.056 0.354-0.147l7.146-7.146 3 3v2l2 2v-2.707h2.707l-2-2h-2l-3-3 7.146-7.146zM10.204 2.242c1.336-0.624 2.682-1.015 4.015-1.168l-6.219 6.219-2.1-2.1c1.295-1.222 2.774-2.237 4.304-2.951zM1.074 14.219c0.153-1.333 0.544-2.679 1.168-4.015 0.714-1.53 1.729-3.008 2.951-4.304l2.1 2.1-6.219 6.219z" })
        );
    }
    function Bow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bow.SVG = BowSVG;
    return Bow;
})();
export const Sword = /*#__PURE__*/ (() => {
    function SwordSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.707 14.293l-3.146-3.146 2.293-2.293c0.195-0.195 0.195-0.512 0-0.707l-1-1c-0.195-0.195-0.512-0.195-0.707 0l-1.646 1.646-8.646-8.646c-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.133 0.053 0.26 0.146 0.354l8.646 8.646-1.646 1.646c-0.195 0.195-0.195 0.512 0 0.707l1 1c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.293-2.293 3.146 3.146c0.39 0.391 1.024 0.391 1.414 0s0.39-1.024 0-1.414zM9.5 11l-8.75-8.75 0.5-0.5 8.75 8.75-0.5 0.5z" })
        );
    }
    function Sword({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sword.SVG = SwordSVG;
    return Sword;
})();
export const Tennis = /*#__PURE__*/ (() => {
        function TennisSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 11.5c-1-1-1-2.5-1-4.5l-0 0c0.001-1.682-0.72-3.472-2.124-4.876-1.403-1.403-3.191-2.125-4.872-2.124-1.35 0-2.631 0.466-3.584 1.42-2.14 2.14-1.825 5.926 0.705 8.456 1.403 1.403 3.191 2.124 4.872 2.124 2.004 0 3.504 0 4.504 1l3 3c1 0 1.5-0.5 1.5-1.5l-3-3zM8 2.048c0.383 0.246 0.746 0.538 1.080 0.872s0.625 0.695 0.872 1.080h-1.952v-1.952zM4 9.952c-0.383-0.246-0.746-0.538-1.080-0.871s-0.625-0.695-0.872-1.080h1.952v1.952zM4 7h-2.471c-0.212-0.522-0.342-1.056-0.387-1.592-0.011-0.138-0.017-0.274-0.017-0.408h2.875v2zM4 4h-2.762c0.161-0.688 0.492-1.299 0.978-1.785 0.355-0.355 0.777-0.629 1.255-0.814 0.171-0.066 0.348-0.121 0.53-0.163v2.762zM7 10.875c-0.001 0-0.003 0-0.004 0-0.67 0-1.348-0.14-1.996-0.403v-2.472h2v2.875zM7 7h-2v-2h2v2zM7 4h-2v-2.875c0.001 0 0.003-0 0.004-0h0c0.67 0 1.348 0.14 1.996 0.403v2.472zM9.785 9.785c-0.355 0.355-0.777 0.629-1.255 0.814-0.171 0.066-0.348 0.121-0.53 0.163v-2.762h2.762c-0.161 0.688-0.492 1.299-0.978 1.785zM8 7v-2h2.471c0.212 0.522 0.342 1.056 0.387 1.592 0.011 0.138 0.017 0.274 0.017 0.408h-2.875z" }),
_('path', { d: "M3 13.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function Tennis({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TennisSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tennis.SVG = TennisSVG;
        return Tennis;
    })();
export const Pingpong = /*#__PURE__*/ (() => {
        function PingpongSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z" }),
_('path', { d: "M15.16 13.287l-2.979-2.787c-0.496-0.39-0.343-0.5-0.146-1 0.001-0.001 0.001-0.002 0.001-0.003 0.95-2.098 0.466-4.772-1.392-6.63-1.238-1.238-2.839-1.866-4.39-1.866-1.384 0-2.729 0.5-3.742 1.513-2.148 2.148-1.99 5.789 0.354 8.132 1.238 1.238 2.839 1.866 4.39 1.866 0.776 0 1.54-0.157 2.239-0.474 0.002-0.001 0.003-0.001 0.005-0.002 0.249-0.098 0.404-0.181 0.543-0.181 0.141 0 0.266 0.085 0.457 0.327l2.787 2.979c0.136 0.174 0.328 0.262 0.521 0.262 0.168 0 0.337-0.067 0.473-0.202l0.939-0.939c0.292-0.292 0.265-0.739-0.059-0.994v0zM5.114 10.886l5.771-5.771c0.172 0.356 0.301 0.729 0.386 1.114l-5.045 5.045c-0.287-0.063-0.572-0.153-0.851-0.269-0.088-0.037-0.176-0.076-0.262-0.118v0z" })
            );
        }
        function Pingpong({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PingpongSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Pingpong.SVG = PingpongSVG;
        return Pingpong;
    })();
export const Baseball = /*#__PURE__*/ (() => {
    function BaseballSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.012 13.737c0-0-0-0-0-0-0.001-0.001-0.002-0.002-0.004-0.004-0-0-0-0-0-0-0.004-0.004-0.007-0.008-0.011-0.012-0-0-0-0-0-0-0.001-0.001-0.002-0.002-0.003-0.004-0-0-0-0-0-0-0.003-0.003-0.005-0.005-0.007-0.008-0-0-0-0-0.001-0.001s-0.002-0.002-0.003-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.003-0.003c-0-0-0-0-0-0-0.001-0.001-0.002-0.003-0.004-0.004-0-0-0-0-0.001-0.001s-0.002-0.002-0.003-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.003-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.003-0.004-0.004h-0c-0.001-0.001-0.002-0.003-0.003-0.004s-0.001-0.001-0.001-0.001c-0.001-0.001-0.002-0.002-0.003-0.003s-0.001-0.001-0.001-0.001-0.002-0.002-0.003-0.003c-0-0-0.001-0.001-0.001-0.001-0.001-0.001-0.002-0.002-0.003-0.004-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.002-0.003c-0-0.001-0.001-0.001-0.001-0.002s-0.001-0.002-0.002-0.002c-0.001-0.001-0.001-0.001-0.001-0.002s-0.002-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.003-0.003c-0.001-0.001-0.001-0.001-0.002-0.002s-0.001-0.001-0.002-0.002-0.001-0.001-0.002-0.002-0.001-0.001-0.002-0.002-0.001-0.001-0.002-0.002-0.001-0.001-0.002-0.002-0.002-0.002-0.003-0.004c-0-0-0.001-0.001-0.001-0.001s-0.001-0.002-0.002-0.002c-0-0-0.001-0.001-0.001-0.001s-0.001-0.002-0.002-0.002c-0-0-0.001-0.001-0.001-0.001-0.002-0.003-0.005-0.005-0.007-0.008-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.002-0.002-0.003-0.004-0.004-0.006-0.006l-0-0c-0.001-0.001-0.002-0.002-0.003-0.003s-0-0.001-0.001-0.001c-0.001-0.001-0.002-0.002-0.003-0.003l-0-0c-0.003-0.003-0.006-0.006-0.008-0.010-0-0-0-0-0-0s-0.002-0.002-0.003-0.003c-0-0-0-0-0-0.001-0.004-0.004-0.008-0.009-0.011-0.013l-0-0c-0.034-0.038-0.067-0.077-0.1-0.117l0.208-0.175c-0.194-0.234-0.374-0.48-0.538-0.737l-0.253 0.17c-0.053-0.079-0.104-0.158-0.154-0.239l-0-0c-0.001-0.001-0.001-0.002-0.002-0.003s-0-0-0-0.001c-0.003-0.005-0.006-0.009-0.009-0.014-0-0-0-0.001-0.001-0.001s-0.001-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001-0.001-0.002-0.002-0.004-0.004-0.006-0-0-0-0-0-0s-0.001-0.002-0.002-0.003c-0-0.001-0.001-0.001-0.001-0.002s-0.001-0.002-0.001-0.002c-0-0.001-0.001-0.001-0.001-0.002s-0.001-0.002-0.001-0.002-0.001-0.002-0.002-0.002-0.001-0.002-0.002-0.003c-0-0.001-0.001-0.002-0.001-0.002s-0.001-0.001-0.001-0.002-0.001-0.002-0.001-0.002-0.001-0.001-0.001-0.002-0.001-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001s-0.002-0.003-0.003-0.004c-0-0.001-0.001-0.001-0.001-0.002s-0.001-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001s-0.001-0.002-0.002-0.003c-0-0-0.001-0.001-0.001-0.001-0.001-0.001-0.002-0.003-0.003-0.005 0-0-0-0-0-0-0.001-0.001-0.002-0.003-0.003-0.004-0-0-0-0.001-0.001-0.001s-0.002-0.002-0.002-0.004c-0-0-0-0.001-0.001-0.001-0.001-0.001-0.002-0.003-0.003-0.005s-0.002-0.003-0.003-0.005c-0-0-0-0-0-0-0.001-0.001-0.002-0.003-0.003-0.004-0-0-0-0-0-0.001-0.003-0.005-0.006-0.010-0.008-0.014-0-0-0-0-0-0-0.001-0.002-0.002-0.003-0.003-0.005-0-0-0-0-0-0-0.003-0.005-0.006-0.010-0.008-0.014-0-0-0-0-0-0-0.115-0.195-0.221-0.395-0.318-0.6l0.294-0.139c-0.111-0.243-0.208-0.494-0.293-0.751l-0.308 0.107c-0.067-0.193-0.126-0.389-0.177-0.589 0-0 0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017 0-0 0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017-0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017 0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017 0-0-0-0-0-0-0.001-0.002-0.001-0.003-0.001-0.005 0-0 0-0-0-0-0.001-0.004-0.002-0.007-0.003-0.011 0-0-0-0-0-0-0-0.002-0.001-0.004-0.001-0.005-0-0-0-0-0-0-0.001-0.004-0.002-0.007-0.003-0.011 0-0-0-0-0-0-0-0.002-0.001-0.003-0.001-0.005-0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017-0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017 0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017-0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017-0-0-0-0-0-0-0.001-0.006-0.003-0.011-0.004-0.017-0-0-0-0-0-0-0.023-0.101-0.044-0.203-0.063-0.306l0.333-0.061c-0.044-0.252-0.076-0.509-0.094-0.769l-0.269 0.020v-1.111l0.269 0.020c0.018-0.26 0.050-0.517 0.094-0.769l-0.333-0.061c0.019-0.103 0.040-0.205 0.063-0.306 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.002 0.001-0.003 0.001-0.005 0-0 0-0 0-0 0.001-0.004 0.002-0.007 0.003-0.011 0-0 0-0 0-0 0-0.002 0.001-0.004 0.001-0.005 0 0 0-0 0-0 0.001-0.004 0.002-0.007 0.003-0.011 0-0 0-0 0-0 0.001-0.002 0.001-0.003 0.001-0.005 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0 0 0-0 0-0 0.001-0.006 0.003-0.011 0.004-0.017 0-0 0-0 0-0 0.051-0.2 0.11-0.396 0.177-0.589l0.308 0.107c0.084-0.257 0.182-0.507 0.293-0.751l-0.294-0.139c0.097-0.205 0.203-0.406 0.318-0.6 0-0 0-0 0-0 0.003-0.005 0.006-0.010 0.008-0.014 0-0 0-0 0-0 0.001-0.002 0.002-0.003 0.003-0.005 0-0 0-0 0-0 0.003-0.005 0.006-0.010 0.008-0.014 0-0 0-0 0-0.001 0.001-0.001 0.002-0.003 0.003-0.004 0-0 0-0 0-0 0.001-0.002 0.002-0.003 0.003-0.005v0c0.001-0.001 0.002-0.003 0.003-0.005 0-0 0-0.001 0.001-0.001s0.002-0.003 0.002-0.004c0-0 0-0.001 0.001-0.001 0.001-0.001 0.002-0.003 0.003-0.004 0-0 0-0 0-0 0.001-0.001 0.002-0.003 0.003-0.004 0-0 0-0.001 0.001-0.001s0.001-0.002 0.002-0.003c0-0 0.001-0.001 0.001-0.001s0.001-0.002 0.002-0.003c0-0 0.001-0.001 0.001-0.001s0.002-0.003 0.003-0.004c0-0 0.001-0.001 0.001-0.001s0.001-0.002 0.002-0.003c0-0.001 0.001-0.001 0.001-0.002s0.001-0.002 0.001-0.002c0-0.001 0.001-0.001 0.001-0.002s0.001-0.002 0.001-0.002 0.001-0.002 0.002-0.003 0.001-0.002 0.002-0.003 0.001-0.002 0.001-0.002 0.001-0.001 0.001-0.002 0.001-0.002 0.001-0.002c0-0.001 0.001-0.001 0.001-0.002s0.001-0.002 0.002-0.003c0-0 0-0 0-0 0.001-0.002 0.002-0.004 0.004-0.006 0-0 0.001-0.001 0.001-0.001s0.001-0.002 0.002-0.003c0-0 0-0.001 0.001-0.001 0.003-0.005 0.006-0.009 0.009-0.014 0-0 0-0 0-0.001s0.001-0.002 0.002-0.003l0-0c0.050-0.081 0.102-0.16 0.154-0.239l0.253 0.17c0.165-0.257 0.345-0.503 0.538-0.737l-0.208-0.175c0.033-0.039 0.066-0.078 0.1-0.117l0-0c0.004-0.004 0.008-0.009 0.011-0.013 0-0 0-0 0-0s0.002-0.002 0.003-0.003c0-0 0-0 0-0 0.003-0.003 0.006-0.006 0.008-0.010l0-0c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.001 0.002-0.002 0.003-0.003l0-0c0.002-0.002 0.004-0.004 0.006-0.006 0.001-0.001 0.002-0.002 0.002-0.003s0.001-0.001 0.001-0.001 0.002-0.002 0.002-0.003c0-0 0.001-0.001 0.001-0.001 0.002-0.003 0.005-0.006 0.007-0.008 0-0 0.001-0.001 0.001-0.001s0.001-0.002 0.002-0.002c0-0 0.001-0.001 0.001-0.001s0.001-0.002 0.002-0.002c0-0 0.001-0.001 0.001-0.001s0.002-0.002 0.003-0.004c0.001-0.001 0.001-0.001 0.002-0.002s0.001-0.001 0.002-0.002 0.001-0.001 0.002-0.002 0.001-0.001 0.002-0.002 0.001-0.001 0.002-0.002 0.001-0.001 0.002-0.002 0.002-0.002 0.003-0.003c0-0 0.001-0.001 0.001-0.001s0.002-0.002 0.002-0.003c0.001-0.001 0.001-0.001 0.001-0.002s0.001-0.002 0.002-0.002c0-0.001 0.001-0.001 0.001-0.002s0.002-0.002 0.002-0.003c0-0 0.001-0.001 0.001-0.001 0.001-0.001 0.002-0.002 0.003-0.004 0-0 0.001-0.001 0.001-0.001s0.002-0.002 0.003-0.003c0-0 0.001-0.001 0.001-0.001s0.002-0.002 0.003-0.003c0-0 0.001-0.001 0.001-0.001s0.002-0.003 0.003-0.004h0c0.001-0.001 0.002-0.003 0.004-0.004s0.001-0.001 0.001-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0.001-0.001 0.001-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0 0.001-0.001c0.001-0.001 0.002-0.003 0.004-0.004 0-0 0-0 0-0s0.002-0.002 0.003-0.003c0-0 0.001-0.001 0.001-0.001s0.002-0.002 0.003-0.003c0-0 0-0 0.001-0.001 0.003-0.003 0.005-0.005 0.007-0.008 0-0 0-0 0-0 0.001-0.001 0.002-0.002 0.003-0.004 0-0 0-0 0-0 0.004-0.004 0.007-0.008 0.011-0.012 0-0 0-0 0-0 0.001-0.001 0.002-0.002 0.004-0.004 0-0 0-0 0-0 0.134-0.144 0.273-0.282 0.418-0.415-1.318-1.151-3.043-1.848-4.93-1.848s-3.612 0.697-4.93 1.848c0.145 0.133 0.284 0.271 0.418 0.415 0 0 0 0 0 0 0.001 0.001 0.002 0.002 0.004 0.004 0 0 0 0 0 0 0.004 0.004 0.007 0.008 0.011 0.012 0 0 0 0 0 0 0.001 0.001 0.002 0.002 0.003 0.004 0 0 0 0 0 0 0.003 0.003 0.005 0.005 0.007 0.008 0 0 0 0 0.001 0.001s0.002 0.002 0.003 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.003 0.003c0 0 0 0 0 0 0.001 0.001 0.002 0.003 0.004 0.004 0 0 0 0 0.001 0.001s0.002 0.002 0.003 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.003 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.003 0.003 0.004v0c0.001 0.001 0.002 0.003 0.003 0.004s0.001 0.001 0.001 0.001c0.001 0.001 0.002 0.002 0.003 0.003s0.001 0.001 0.001 0.001 0.002 0.002 0.003 0.003c0 0 0.001 0.001 0.001 0.001 0.001 0.001 0.002 0.002 0.003 0.004 0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.002 0.003c0 0.001 0.001 0.001 0.001 0.002s0.001 0.002 0.002 0.002c0.001 0.001 0.001 0.001 0.001 0.002s0.002 0.002 0.002 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.003 0.003c0.001 0.001 0.001 0.001 0.002 0.002s0.001 0.001 0.002 0.002 0.001 0.001 0.002 0.002 0.001 0.001 0.002 0.002 0.001 0.001 0.002 0.002 0.001 0.001 0.002 0.002 0.002 0.002 0.003 0.004c0 0 0.001 0.001 0.001 0.001s0.001 0.002 0.002 0.002c0 0 0.001 0.001 0.001 0.001s0.001 0.002 0.002 0.002c0 0 0.001 0.001 0.001 0.001 0.002 0.003 0.005 0.006 0.007 0.008 0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.002 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.002 0.002 0.003v0c0.002 0.002 0.004 0.004 0.006 0.006l0 0c0.001 0.001 0.002 0.002 0.003 0.003s0 0 0.001 0.001c0.001 0.001 0.002 0.002 0.003 0.003l0 0c0.003 0.003 0.006 0.006 0.008 0.010 0 0 0 0 0 0s0.002 0.002 0.003 0.003c0 0 0 0 0 0 0.004 0.004 0.008 0.009 0.011 0.013l0 0c0.034 0.038 0.067 0.077 0.1 0.117l-0.208 0.175c0.194 0.234 0.374 0.48 0.538 0.737l0.253-0.17c0.053 0.079 0.104 0.158 0.154 0.239l0 0c0.001 0.001 0.001 0.002 0.002 0.003s0 0 0 0.001c0.003 0.005 0.006 0.009 0.009 0.014 0 0 0 0.001 0.001 0.001s0.001 0.002 0.002 0.003c0 0 0.001 0.001 0.001 0.001 0.001 0.002 0.002 0.004 0.004 0.006 0 0 0 0 0 0s0.001 0.002 0.002 0.003c0 0.001 0.001 0.001 0.001 0.002s0.001 0.002 0.002 0.002c0 0.001 0.001 0.001 0.001 0.002s0.001 0.002 0.001 0.002 0.001 0.002 0.002 0.003 0.001 0.002 0.002 0.003c0 0.001 0.001 0.002 0.001 0.002s0.001 0.001 0.001 0.002 0.001 0.002 0.001 0.002 0.001 0.001 0.001 0.002 0.001 0.002 0.002 0.003c0 0 0.001 0.001 0.001 0.001s0.002 0.003 0.003 0.004c0 0 0.001 0.001 0.001 0.001s0.001 0.002 0.002 0.003c0 0 0.001 0.001 0.001 0.001s0.001 0.002 0.002 0.003c0 0 0 0.001 0.001 0.001s0.002 0.003 0.003 0.004c0 0 0 0 0 0 0.001 0.001 0.002 0.003 0.003 0.004 0 0 0 0.001 0.001 0.001s0.002 0.003 0.002 0.004c0 0 0 0.001 0.001 0.001 0.001 0.001 0.002 0.003 0.003 0.005v0c0.001 0.002 0.002 0.003 0.003 0.005 0 0 0 0 0 0 0.001 0.001 0.002 0.003 0.003 0.004 0 0 0 0 0 0.001 0.003 0.005 0.006 0.010 0.008 0.014 0 0 0 0 0 0 0.001 0.002 0.002 0.003 0.003 0.005 0 0 0 0 0 0 0.003 0.005 0.006 0.010 0.009 0.014 0 0 0 0 0 0 0.115 0.195 0.221 0.395 0.318 0.6l-0.294 0.139c0.111 0.244 0.208 0.494 0.293 0.751l0.308-0.107c0.067 0.193 0.126 0.389 0.177 0.589 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0 0.002 0.001 0.003 0.001 0.005 0 0 0 0 0 0 0.001 0.004 0.002 0.007 0.003 0.011 0 0 0 0 0 0 0 0.002 0.001 0.004 0.001 0.005 0 0 0 0 0 0 0.001 0.004 0.002 0.007 0.003 0.011 0 0 0 0 0 0 0 0.002 0.001 0.003 0.001 0.005 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.001 0.006 0.003 0.011 0.004 0.017 0 0 0 0 0 0 0.023 0.101 0.044 0.203 0.063 0.306l-0.333 0.061c0.044 0.252 0.076 0.509 0.094 0.769l0.269-0.020v1.111l-0.269-0.020c-0.018 0.26-0.050 0.517-0.094 0.769l0.333 0.061c-0.019 0.103-0.040 0.205-0.063 0.306 0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017-0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017-0 0-0 0-0 0-0 0.002-0.001 0.003-0.001 0.005-0 0-0 0-0 0-0.001 0.004-0.002 0.007-0.003 0.011-0 0-0 0-0 0-0 0.002-0.001 0.004-0.001 0.005 0 0 0 0 0 0-0.001 0.004-0.002 0.007-0.003 0.011 0 0-0 0-0 0-0 0.002-0.001 0.003-0.001 0.005-0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017-0 0-0 0-0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0 0 0 0 0-0.001 0.006-0.003 0.011-0.004 0.017 0 0-0 0-0 0-0.051 0.2-0.11 0.396-0.177 0.589l-0.308-0.107c-0.084 0.257-0.182 0.507-0.293 0.751l0.294 0.139c-0.097 0.206-0.203 0.406-0.318 0.6-0 0-0 0-0 0-0.003 0.005-0.006 0.010-0.009 0.014-0 0-0 0-0 0-0.001 0.002-0.002 0.003-0.003 0.005-0 0-0 0-0 0-0.003 0.005-0.006 0.010-0.008 0.014-0 0-0 0-0 0.001-0.001 0.001-0.002 0.003-0.003 0.004-0 0-0 0-0 0-0.001 0.002-0.002 0.003-0.003 0.005s-0.002 0.003-0.003 0.005c-0 0-0 0.001-0.001 0.001s-0.002 0.003-0.002 0.004c-0 0-0 0.001-0.001 0.001-0.001 0.001-0.002 0.003-0.003 0.004 0 0-0 0-0 0-0.001 0.001-0.002 0.003-0.003 0.005-0 0-0 0.001-0.001 0.001s-0.001 0.002-0.002 0.003c-0 0.001-0.001 0.001-0.001 0.001s-0.001 0.002-0.002 0.003c-0 0.001-0.001 0.001-0.001 0.002s-0.002 0.003-0.003 0.004c-0 0-0.001 0.001-0.001 0.001s-0.001 0.002-0.002 0.003c-0 0.001-0.001 0.001-0.001 0.002s-0.001 0.002-0.001 0.002-0.001 0.001-0.001 0.002-0.001 0.002-0.001 0.002-0.001 0.002-0.002 0.003-0.001 0.002-0.002 0.002-0.001 0.002-0.001 0.002-0.001 0.001-0.001 0.002-0.001 0.002-0.002 0.002-0.001 0.001-0.001 0.002-0.001 0.002-0.002 0.003c-0 0-0 0-0 0-0.001 0.002-0.002 0.004-0.004 0.006-0 0-0.001 0.001-0.001 0.001s-0.001 0.002-0.002 0.003c-0 0-0 0.001-0.001 0.001-0.003 0.005-0.006 0.009-0.009 0.014-0 0-0 0-0 0.001s-0.001 0.002-0.002 0.003l-0 0c-0.050 0.081-0.102 0.161-0.154 0.239l-0.253-0.17c-0.165 0.257-0.345 0.503-0.538 0.737l0.208 0.175c-0.033 0.039-0.066 0.078-0.1 0.117l-0 0c-0.004 0.004-0.008 0.009-0.011 0.013-0 0-0 0-0 0.001s-0.002 0.002-0.003 0.003c-0 0-0 0-0 0-0.003 0.003-0.006 0.006-0.008 0.010l-0 0c-0.001 0.001-0.002 0.002-0.003 0.003s-0 0.001-0.001 0.001c-0.001 0.001-0.002 0.002-0.003 0.003l-0 0c-0.002 0.002-0.004 0.004-0.006 0.006v0c-0.001 0.001-0.002 0.002-0.002 0.003s-0.001 0.001-0.001 0.001-0.002 0.002-0.002 0.003c-0 0-0.001 0.001-0.001 0.001-0.002 0.003-0.005 0.005-0.007 0.008-0 0-0.001 0.001-0.001 0.001s-0.001 0.002-0.002 0.002c-0 0-0.001 0.001-0.001 0.001s-0.001 0.002-0.002 0.002c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.003 0.004c-0.001 0.001-0.001 0.001-0.002 0.002s-0.001 0.001-0.002 0.002-0.001 0.001-0.002 0.002-0.001 0.001-0.002 0.002-0.001 0.001-0.002 0.002-0.001 0.001-0.002 0.002-0.002 0.002-0.003 0.003c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.002 0.003c-0.001 0.001-0.001 0.001-0.001 0.002s-0.001 0.002-0.002 0.002c-0 0.001-0.001 0.001-0.001 0.002s-0.002 0.002-0.002 0.003c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.003 0.004c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.003 0.003c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.003 0.003c-0 0-0.001 0.001-0.001 0.001s-0.002 0.003-0.003 0.004v0c-0.001 0.001-0.002 0.003-0.003 0.004s-0.001 0.001-0.001 0.001c-0.001 0.001-0.002 0.002-0.003 0.003s-0.001 0.001-0.001 0.001c-0.001 0.001-0.002 0.002-0.003 0.003s-0 0-0.001 0.001c-0.001 0.001-0.002 0.003-0.004 0.004-0 0-0 0-0 0s-0.002 0.002-0.003 0.003c-0 0-0.001 0.001-0.001 0.001s-0.002 0.002-0.003 0.003c-0 0-0 0-0.001 0.001-0.003 0.003-0.005 0.005-0.007 0.008-0 0-0 0-0 0-0.001 0.001-0.002 0.002-0.003 0.004-0 0-0 0-0 0-0.004 0.004-0.007 0.008-0.011 0.012-0 0-0 0-0 0-0.001 0.001-0.002 0.002-0.004 0.004-0 0-0 0-0 0-0.134 0.144-0.273 0.282-0.418 0.415 1.318 1.151 3.043 1.848 4.93 1.848s3.612-0.697 4.93-1.848c-0.145-0.133-0.284-0.271-0.418-0.415zM3.153 12.264l-0.266-0.179c0.178-0.264 0.337-0.543 0.472-0.83l0.271 0.128c0.024-0.053 0.047-0.105 0.069-0.159 0.075-0.178 0.143-0.359 0.203-0.541l-0.283-0.098c0.104-0.3 0.186-0.61 0.243-0.923l0.282 0.052c0.041-0.236 0.070-0.475 0.087-0.716l-0.281-0.021c0.012-0.158 0.017-0.318 0.017-0.478s-0.005-0.32-0.017-0.478l0.281-0.021c-0.017-0.241-0.046-0.48-0.087-0.716l-0.282 0.052c-0.058-0.312-0.139-0.623-0.243-0.923l0.283-0.098c-0.060-0.183-0.127-0.363-0.203-0.542-0.023-0.053-0.046-0.106-0.070-0.159l-0.271 0.128c-0.136-0.287-0.295-0.566-0.472-0.83l0.266-0.179c-0.154-0.241-0.323-0.472-0.506-0.694l-0.27 0.228c-0.184-0.219-0.385-0.427-0.598-0.619-1.11 1.308-1.78 3-1.78 4.85s0.67 3.542 1.78 4.85c0.212-0.193 0.413-0.401 0.598-0.62l0.27 0.228c0.183-0.221 0.352-0.453 0.506-0.694zM13.22 3.65c-0.212 0.193-0.413 0.401-0.598 0.62l-0.27-0.228c-0.183 0.221-0.352 0.453-0.506 0.694l0.266 0.179c-0.178 0.264-0.337 0.543-0.472 0.83l-0.271-0.128c-0.024 0.053-0.047 0.105-0.069 0.159-0.075 0.178-0.143 0.359-0.203 0.542l0.283 0.098c-0.104 0.3-0.186 0.61-0.243 0.923l-0.282-0.052c-0.041 0.236-0.070 0.475-0.087 0.716l0.281 0.021c-0.012 0.158-0.017 0.318-0.017 0.478s0.005 0.32 0.017 0.478l-0.281 0.021c0.017 0.241 0.046 0.48 0.087 0.716l0.282-0.052c0.057 0.312 0.139 0.623 0.243 0.923l-0.283 0.098c0.060 0.183 0.127 0.363 0.203 0.541 0.023 0.053 0.046 0.106 0.069 0.159l0.271-0.128c0.136 0.287 0.295 0.566 0.472 0.83l-0.266 0.179c0.154 0.241 0.323 0.472 0.506 0.694l0.27-0.228c0.184 0.219 0.385 0.427 0.598 0.62 1.11-1.308 1.78-3 1.78-4.85s-0.67-3.542-1.78-4.85z" })
        );
    }
    function Baseball({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BaseballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Baseball.SVG = BaseballSVG;
    return Baseball;
})();
export const Basketball = /*#__PURE__*/ (() => {
    function BasketballSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.983 8c-0.108-1.643-0.745-3.141-1.743-4.326-0.117 0.101-0.231 0.208-0.342 0.318-1.085 1.085-1.731 2.493-1.848 4.008h3.932zM12.453 2.869c-1.204-1.060-2.751-1.74-4.453-1.852v6.983h1.923c0.134-2.041 1.085-3.86 2.53-5.131zM2.102 3.992c-0.111-0.111-0.225-0.217-0.342-0.318-0.997 1.185-1.634 2.683-1.743 4.326h3.932c-0.117-1.514-0.762-2.922-1.848-4.008zM5.077 8h1.923v-6.983c-1.702 0.112-3.249 0.792-4.453 1.852 1.444 1.271 2.395 3.090 2.53 5.131zM12.898 13.008c0.111 0.111 0.225 0.217 0.342 0.318 0.997-1.185 1.634-2.683 1.743-4.326h-3.932c0.117 1.514 0.762 2.922 1.848 4.008zM9.923 9h-1.923v6.983c1.702-0.112 3.249-0.792 4.453-1.852-1.444-1.271-2.395-3.090-2.53-5.131zM0.017 9c0.108 1.643 0.745 3.141 1.743 4.326 0.117-0.101 0.231-0.207 0.342-0.318 1.085-1.085 1.731-2.493 1.848-4.008h-3.932zM2.547 14.131c1.204 1.060 2.751 1.74 4.453 1.852v-6.983h-1.923c-0.134 2.041-1.085 3.86-2.53 5.131z" })
        );
    }
    function Basketball({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BasketballSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Basketball.SVG = BasketballSVG;
    return Basketball;
})();
export const Golf = /*#__PURE__*/ (() => {
    function GolfSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.527 12.106l0.848 2.394v1.5h1.25v-1.5l0.848-2.394c-0.473 0.114-0.966 0.175-1.473 0.175s-1.001-0.061-1.473-0.175zM3 6c0-2.761 2.239-5 5-5s5 2.239 5 5c0 2.761-2.239 5-5 5s-5-2.239-5-5z" })
        );
    }
    function Golf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GolfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Golf.SVG = GolfSVG;
    return Golf;
})();
export const Golf2 = /*#__PURE__*/ (() => {
        function Golf2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z" }),
_('path', { d: "M4 1v6l7-3-7-3z" }),
_('path', { d: "M6 9c-0.701 0-1.374 0.070-2 0.199v3.801h-1v-12.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v9.392c-1.227 0.641-2 1.572-2 2.608 0 1.933 2.686 3.5 6 3.5s6-1.567 6-3.5-2.686-3.5-6-3.5zM7 14c-1.105 0-2-0.672-2-1.5s0.895-1.5 2-1.5c1.105 0 2 0.672 2 1.5s-0.895 1.5-2 1.5z" })
            );
        }
        function Golf2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Golf2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Golf2.SVG = Golf2SVG;
        return Golf2;
    })();
export const Hockey = /*#__PURE__*/ (() => {
    function HockeySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 13.201v0.486c0 0.552 1.343 1 3 1s3-0.448 3-1v-0.486c-0.518 0.485-1.765 0.736-3 0.736s-2.482-0.251-3-0.736zM10 12.625c0-0.552 1.343-1 3-1s3 0.448 3 1c0 0.552-1.343 1-3 1s-3-0.448-3-1zM14.2 3l-7.184 9.031c-0.49 0.563-3.949 0.403-5.78 0.122-0 0-0.001 0-0.001-0-0.833-0.092-1.055-0.428-1.19 0.318h-0c-0.154 1.178 0.135 2.198 0.135 2.198 0.611 0.64 6.238 0.263 6.836-0.358l8.984-11.311h-1.8z" })
        );
    }
    function Hockey({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HockeySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hockey.SVG = HockeySVG;
    return Hockey;
})();
export const Racing = /*#__PURE__*/ (() => {
        function RacingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 3h2v2h-2v-2zM8 5v2c1 0 1 1 2 1v-2c-1 0-1-1-2-1zM10 4h2v2h-2v-2zM10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5zM14 6h-2v2h2v2h-2v-2h-2v2c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5v-2h-2v2h-2v-2h2v-2h-2v-2h2v-2h2v2c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5v-2h2v2h2v2z" }),
_('path', { d: "M0 0h2v16h-2v-16z" })
            );
        }
        function Racing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RacingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Racing.SVG = RacingSVG;
        return Racing;
    })();
export const Finish = /*#__PURE__*/ (() => {
        function FinishSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 6h2v2h-2v-2z" }),
_('path', { d: "M9 6h2v2h-2v-2z" }),
_('path', { d: "M15 1c-0.552 0-1 0.448-1 1v1h-12v-1c0-0.552-0.448-1-1-1s-1 0.448-1 1v13c0 0.552 0.448 1 1 1s1-0.448 1-1v-4h12v4c0 0.552 0.448 1 1 1s1-0.448 1-1v-13c0-0.552-0.448-1-1-1zM13 10v-2h-2v2h-2v-2h-2v2h-2v-2h-2v2h-1v-2h1v-2h-1v-2h1v2h2v-2h2v2h2v-2h2v2h2v-2h1v2h-1v2h1v2h-1z" })
            );
        }
        function Finish({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FinishSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Finish.SVG = FinishSVG;
        return Finish;
    })();
export const EightBall = /*#__PURE__*/ (() => {
        function EightBallSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 11.5c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z" }),
_('path', { d: "M9.502 7.5c0.311-0.264 0.498-0.612 0.498-1 0-0.841-0.879-1.5-2-1.5s-2 0.659-2 1.5c0 0.388 0.187 0.736 0.498 1-0.311 0.264-0.498 0.612-0.498 1 0 0.841 0.878 1.5 2 1.5s2-0.659 2-1.5c0-0.388-0.187-0.736-0.498-1zM7 6.5c0-0.204 0.39-0.5 1-0.5s1 0.296 1 0.5c0 0.204-0.389 0.5-1 0.5-0 0-0 0-0 0s-0 0-0 0c-0.61-0-1-0.296-1-0.5zM8 9c-0.61 0-1-0.296-1-0.5s0.389-0.5 1-0.5c0 0 0 0 0 0s0 0 0 0c0.61 0 1 0.296 1 0.5s-0.39 0.5-1 0.5z" })
            );
        }
        function EightBall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EightBallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EightBall.SVG = EightBallSVG;
        return EightBall;
    })();
export const Bowling = /*#__PURE__*/ (() => {
    function BowlingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10 9c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM10 5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM13 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
        );
    }
    function Bowling({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BowlingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bowling.SVG = BowlingSVG;
    return Bowling;
})();
export const Bowling2 = /*#__PURE__*/ (() => {
    function Bowling2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.373 6.654c-0.328-0.693-0.668-1.41-0.668-2.32 0-0.362 0.055-0.782 0.113-1.228 0.132-1.012 0.268-2.059-0.245-2.663-0.165-0.195-0.382-0.326-0.646-0.392v-0.051h-0.383c-0.010 0-0.019 0-0.029 0.001h-0c-0.009-0-0.019-0.001-0.029-0.001l-0.383 0.001v0.050c-0.264 0.066-0.481 0.198-0.646 0.392-0.513 0.604-0.377 1.651-0.245 2.663 0.058 0.445 0.113 0.866 0.113 1.228 0 0.91-0.339 1.627-0.668 2.32-0.272 0.574-0.551 1.164-0.633 1.849-0.121-0.308-0.262-0.605-0.401-0.898-0.375-0.792-0.763-1.611-0.763-2.651 0-0.413 0.063-0.894 0.129-1.403 0.151-1.157 0.306-2.354-0.28-3.043-0.189-0.222-0.436-0.372-0.739-0.448v-0.058h-0.438c-0.011 0-0.022 0-0.033 0.001h-0c-0.011-0-0.022-0.001-0.033-0.001l-0.438 0.001v0.057c-0.302 0.076-0.55 0.226-0.739 0.448-0.586 0.69-0.43 1.886-0.28 3.043 0.066 0.509 0.129 0.99 0.129 1.403 0 1.040-0.388 1.859-0.763 2.651-0.13 0.275-0.262 0.552-0.378 0.84-0.090-0.66-0.362-1.233-0.626-1.791-0.328-0.693-0.668-1.41-0.668-2.32 0-0.362 0.055-0.782 0.113-1.228 0.132-1.012 0.268-2.059-0.245-2.663-0.165-0.195-0.382-0.326-0.646-0.392v-0.051h-0.383c-0.010 0-0.019 0-0.029 0.001h-0c-0.010-0-0.019-0.001-0.029-0.001l-0.383 0.001v0.050c-0.264 0.066-0.481 0.198-0.646 0.392-0.513 0.604-0.377 1.651-0.245 2.663 0.058 0.445 0.113 0.866 0.113 1.228 0 0.91-0.339 1.627-0.668 2.32-0.323 0.682-0.657 1.388-0.657 2.247 0 1.666 0.705 3.824 0.895 4.254 0.183 0.416 0.645 0.714 1.224 0.811v0.034h0.383c0.004 0 0.009-0 0.013-0s0.009 0 0.013 0l0.383-0.001v-0.033c0.579-0.096 1.041-0.395 1.224-0.811 0.102-0.233 0.355-0.97 0.566-1.861 0.207 1.643 0.77 3.341 0.946 3.74 0.209 0.475 0.737 0.817 1.399 0.927v0.039h0.438c0.005 0 0.010-0 0.015-0s0.010 0 0.015 0l0.438-0.001v-0.038c0.662-0.11 1.19-0.451 1.399-0.927 0.179-0.406 0.759-2.157 0.956-3.827 0.215 0.93 0.481 1.707 0.587 1.947 0.183 0.416 0.645 0.714 1.224 0.811v0.034h0.383c0.004 0 0.009-0 0.013-0s0.009 0 0.013 0l0.383-0.001v-0.033c0.58-0.096 1.041-0.395 1.224-0.811 0.19-0.431 0.895-2.589 0.895-4.254 0-0.859-0.334-1.565-0.658-2.247zM6.958 1.073c0.068-0.079 0.195-0.186 0.524-0.197l0.014-0 0.005 0 0.004-0 0.015 0c0.328 0.011 0.456 0.118 0.524 0.197 0.283 0.333 0.23 1.131 0.134 1.927h-1.354c-0.096-0.796-0.149-1.594 0.134-1.927zM7.986 5h-0.971c0-0.016 0.001-0.031 0.001-0.047 0-0.3-0.028-0.624-0.066-0.953h1.102c-0.038 0.329-0.066 0.654-0.066 0.953-0 0.016 0 0.031 0.001 0.047zM8.551 14.682c-0.092 0.209-0.488 0.435-1.042 0.442l-0.010 0-0.010-0c-0.553-0.007-0.95-0.233-1.042-0.442-0.193-0.439-0.949-2.77-0.949-4.509 0-0.785 0.324-1.469 0.667-2.194 0.277-0.585 0.58-1.225 0.738-1.979h1.189c0.158 0.754 0.461 1.394 0.738 1.979 0.343 0.724 0.667 1.409 0.667 2.194 0 1.739-0.756 4.071-0.949 4.509z" })
        );
    }
    function Bowling2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bowling2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bowling2.SVG = Bowling2SVG;
    return Bowling2;
})();
export const Power = /*#__PURE__*/ (() => {
    function PowerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 0l-6 8h6l-4 8 14-10h-8l6-6z" })
        );
    }
    function Power({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PowerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Power.SVG = PowerSVG;
    return Power;
})();
export const Power2 = /*#__PURE__*/ (() => {
    function Power2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 0l-9 9h5.5l-2.5 7 9-9h-5.5z" })
        );
    }
    function Power2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Power2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Power2.SVG = Power2SVG;
    return Power2;
})();
export const Power3 = /*#__PURE__*/ (() => {
    function Power3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 11l5-8 5 5 6-4-5 9-5-5z" })
        );
    }
    function Power3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Power3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Power3.SVG = Power3SVG;
    return Power3;
})();
export const Switch = /*#__PURE__*/ (() => {
    function SwitchSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 2.29v2.124c0.566 0.247 1.086 0.6 1.536 1.050 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.45-0.45 0.97-0.803 1.536-1.050v-2.124c-2.891 0.861-5 3.539-5 6.71 0 3.866 3.134 7 7 7s7-3.134 7-7c0-3.171-2.109-5.849-5-6.71zM7 0h2v8h-2z" })
        );
    }
    function Switch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SwitchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Switch.SVG = SwitchSVG;
    return Switch;
})();
export const Switch2 = /*#__PURE__*/ (() => {
        function Switch2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 7.5c0 0.275-0.225 0.5-0.5 0.5h-3c-0.275 0-0.5-0.225-0.5-0.5v-3c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v3z" }),
_('path', { d: "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM2 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM2 3c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 12.5c0 0.276-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5-0.224-0.5-0.5v-9c0-0.276 0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5v9zM14 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM14 3c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
            );
        }
        function Switch2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Switch2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Switch2.SVG = Switch2SVG;
        return Switch2;
    })();
export const PowerCord = /*#__PURE__*/ (() => {
        function PowerCordSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z" }),
_('path', { d: "M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z" })
            );
        }
        function PowerCord({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PowerCordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PowerCord.SVG = PowerCordSVG;
        return PowerCord;
    })();
export const PowerCord2 = /*#__PURE__*/ (() => {
    function PowerCord2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.25 9.25l2.75-2.75-1-1-2.75 2.75-2.5-2.5 2.75-2.75-1-1-2.75 2.75-1.72-1.72c-0.292-0.292-0.755-0.305-1.030-0.030s-0.261 0.739 0.030 1.030l1.141 1.141-2 2c-1.318 1.318-1.524 3.327-0.618 4.861l-2.261 2.261c-0.391 0.39-0.391 1.024 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l2.261-2.261c1.534 0.906 3.543 0.7 4.861-0.618l2-2 1.141 1.141c0.292 0.292 0.755 0.305 1.030 0.030s0.261-0.739-0.030-1.030l-1.72-1.72z" })
        );
    }
    function PowerCord2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PowerCord2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PowerCord2.SVG = PowerCord2SVG;
    return PowerCord2;
})();
export const Outlet = /*#__PURE__*/ (() => {
    function OutletSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 5h1v4h-1zM11 5h1v3h-1zM11.875 1h-7.75c-2.46 1.365-4.125 3.988-4.125 7s1.665 5.635 4.125 7h7.75c2.46-1.365 4.125-3.988 4.125-7s-1.665-5.635-4.125-7zM11.607 14h-7.214c-0.98-0.591-1.805-1.415-2.396-2.398-0.652-1.084-0.997-2.33-0.997-3.602s0.345-2.518 0.997-3.602c0.591-0.982 1.416-1.807 2.396-2.398h7.214c0.98 0.591 1.805 1.415 2.396 2.398 0.652 1.084 0.997 2.33 0.997 3.602s-0.345 2.518-0.997 3.602c-0.591 0.982-1.416 1.807-2.396 2.398zM8 10c-1.105 0-2 0.448-2 1v2h4v-2c0-0.552-0.895-1-2-1z" })
        );
    }
    function Outlet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( OutletSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Outlet.SVG = OutletSVG;
    return Outlet;
})();
export const Clipboard = /*#__PURE__*/ (() => {
    function ClipboardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z" })
        );
    }
    function Clipboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClipboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Clipboard.SVG = ClipboardSVG;
    return Clipboard;
})();
export const Clipboard2 = /*#__PURE__*/ (() => {
        function Clipboard2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z" }),
_('path', { d: "M7 13.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914z" })
            );
        }
        function Clipboard2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clipboard2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clipboard2.SVG = Clipboard2SVG;
        return Clipboard2;
    })();
export const Clipboard3 = /*#__PURE__*/ (() => {
        function Clipboard3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z" }),
_('path', { d: "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Clipboard3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clipboard3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clipboard3.SVG = Clipboard3SVG;
        return Clipboard3;
    })();
export const Clipboard4 = /*#__PURE__*/ (() => {
        function Clipboard4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 4h8v-2h-2c0-1.105-0.895-2-2-2s-2 0.895-2 2h-2v2zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1z" }),
_('path', { d: "M14.5 2h-1.5v2.5c0 0.276-0.224 0.5-0.5 0.5h-9c-0.276 0-0.5-0.224-0.5-0.5v-2.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Clipboard4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clipboard4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clipboard4.SVG = Clipboard4SVG;
        return Clipboard4;
    })();
export const Clipboard5 = /*#__PURE__*/ (() => {
        function Clipboard5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 4h8v-2h-2c0-1.105-0.895-2-2-2s-2 0.895-2 2h-2v2zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1z" }),
_('path', { d: "M14.5 2h-1.5v2.5c0 0.276-0.224 0.5-0.5 0.5h-9c-0.276 0-0.5-0.224-0.5-0.5v-2.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM7 14.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914-5.207 5.707z" })
            );
        }
        function Clipboard5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clipboard5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clipboard5.SVG = Clipboard5SVG;
        return Clipboard5;
    })();
export const Clipboard6 = /*#__PURE__*/ (() => {
        function Clipboard6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 4h8v-2h-2c0-1.105-0.895-2-2-2s-2 0.895-2 2h-2v2zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1z" }),
_('path', { d: "M14.5 2h-1.5v2.5c0 0.276-0.224 0.5-0.5 0.5h-9c-0.276 0-0.5-0.224-0.5-0.5v-2.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Clipboard6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Clipboard6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Clipboard6.SVG = Clipboard6SVG;
        return Clipboard6;
    })();
export const Playlist = /*#__PURE__*/ (() => {
        function PlaylistSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 0h-2v11.142c-0.313-0.092-0.649-0.142-1-0.142-1.657 0-3 1.119-3 2.5s1.343 2.5 3 2.5c1.657 0 3-1.119 3-2.5v-10.5l3 1v-2l-3-2z" }),
_('path', { d: "M5.031 14h-5.031v2h5.839c-0.44-0.596-0.718-1.283-0.807-2z" }),
_('path', { d: "M5.839 11h-5.839v2h5.031c0.089-0.717 0.368-1.404 0.807-2z" }),
_('path', { d: "M9 9.090v-1.090h-9v2h6.85c0.627-0.457 1.364-0.768 2.15-0.91z" }),
_('path', { d: "M0 5h9v2h-9v-2z" }),
_('path', { d: "M0 2h9v2h-9v-2z" })
            );
        }
        function Playlist({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlaylistSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Playlist.SVG = PlaylistSVG;
        return Playlist;
    })();
export const PlaylistAdd = /*#__PURE__*/ (() => {
        function PlaylistAddSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 0h-2v11.142c-0.313-0.092-0.649-0.142-1-0.142-1.657 0-3 1.119-3 2.5s1.343 2.5 3 2.5c1.657 0 3-1.119 3-2.5v-10.5l3 1v-2l-3-2z" }),
_('path', { d: "M5.031 14h-5.031v2h5.839c-0.44-0.596-0.718-1.283-0.807-2z" }),
_('path', { d: "M5.839 11h-5.839v2h5.031c0.089-0.717 0.368-1.404 0.807-2z" }),
_('path', { d: "M9 9.090v-1.090h-9v2h6.85c0.627-0.457 1.364-0.768 2.15-0.91z" }),
_('path', { d: "M7.031 3h-2.031v-2h-2v2h-2.031v2h2.031v2h2v-2h2.031z" })
            );
        }
        function PlaylistAdd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PlaylistAddSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PlaylistAdd.SVG = PlaylistAddSVG;
        return PlaylistAdd;
    })();
export const ListNumbered = /*#__PURE__*/ (() => {
    function ListNumberedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z" })
        );
    }
    function ListNumbered({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ListNumberedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ListNumbered.SVG = ListNumberedSVG;
    return ListNumbered;
})();
export const List = /*#__PURE__*/ (() => {
    function ListSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z" })
        );
    }
    function List({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ListSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    List.SVG = ListSVG;
    return List;
})();
export const List2 = /*#__PURE__*/ (() => {
    function List2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 1h10v2h-10v-2zM6 7h10v2h-10v-2zM6 13h10v2h-10v-2zM0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z" })
        );
    }
    function List2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( List2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    List2.SVG = List2SVG;
    return List2;
})();
export const More = /*#__PURE__*/ (() => {
    function MoreSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 1h4v4h-4zM6 6h4v4h-4zM6 11h4v4h-4z" })
        );
    }
    function More({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoreSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    More.SVG = MoreSVG;
    return More;
})();
export const More2 = /*#__PURE__*/ (() => {
    function More2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 3c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM6 13c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z" })
        );
    }
    function More2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( More2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    More2.SVG = More2SVG;
    return More2;
})();
export const Grid = /*#__PURE__*/ (() => {
    function GridSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0h4v4h-4zM6 0h4v4h-4zM12 0h4v4h-4zM0 6h4v4h-4zM6 6h4v4h-4zM12 6h4v4h-4zM0 12h4v4h-4zM6 12h4v4h-4zM12 12h4v4h-4z" })
        );
    }
    function Grid({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GridSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid.SVG = GridSVG;
    return Grid;
})();
export const Grid2 = /*#__PURE__*/ (() => {
    function Grid2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM6 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z" })
        );
    }
    function Grid2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grid2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid2.SVG = Grid2SVG;
    return Grid2;
})();
export const Grid3 = /*#__PURE__*/ (() => {
    function Grid3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 1h4v4h-4zM6 1h4v4h-4zM11 1h4v4h-4zM1 6h4v4h-4zM6 6h4v4h-4zM11 6h4v4h-4zM1 11h4v4h-4zM6 11h4v4h-4zM11 11h4v4h-4z" })
        );
    }
    function Grid3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grid3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid3.SVG = Grid3SVG;
    return Grid3;
})();
export const Grid4 = /*#__PURE__*/ (() => {
    function Grid4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 1v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM8 1v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM13 1v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM3 6v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM8 6v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM13 6v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM3 11v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM8 11v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM13 11v0c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2z" })
        );
    }
    function Grid4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grid4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid4.SVG = Grid4SVG;
    return Grid4;
})();
export const Grid5 = /*#__PURE__*/ (() => {
        function Grid5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 6h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM14 9h-2v-2h2v2z" }),
_('path', { d: "M9 6h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM9 9h-2v-2h2v2z" }),
_('path', { d: "M4 6h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM4 9h-2v-2h2v2z" }),
_('path', { d: "M14 1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM14 4h-2v-2h2v2z" }),
_('path', { d: "M9 1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM9 4h-2v-2h2v2z" }),
_('path', { d: "M4 1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM4 4h-2v-2h2v2z" }),
_('path', { d: "M14 11h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM14 14h-2v-2h2v2z" }),
_('path', { d: "M9 11h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM9 14h-2v-2h2v2z" }),
_('path', { d: "M4 11h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM4 14h-2v-2h2v2z" })
            );
        }
        function Grid5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Grid5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Grid5.SVG = Grid5SVG;
        return Grid5;
    })();
export const Grid6 = /*#__PURE__*/ (() => {
    function Grid6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0h7v7h-7zM9 0h7v7h-7zM0 9h7v7h-7zM9 9h7v7h-7z" })
        );
    }
    function Grid6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grid6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid6.SVG = Grid6SVG;
    return Grid6;
})();
export const Grid7 = /*#__PURE__*/ (() => {
    function Grid7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM15 5h-4v-4h4v4zM6 10v-4h4v4h-4zM10 11v4h-4v-4h4zM5 10h-4v-4h4v4zM6 5v-4h4v4h-4zM11 6h4v4h-4v-4zM5 1v4h-4v-4h4zM1 11h4v4h-4v-4zM11 15v-4h4v4h-4z" })
        );
    }
    function Grid7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grid7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grid7.SVG = Grid7SVG;
    return Grid7;
})();
export const Tree5 = /*#__PURE__*/ (() => {
    function Tree5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 11h-1.575l-3.675-6.124v-3.126c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v3.126l-3.675 6.124h-1.575c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-3.126l3.675-6.124h0.651l3.675 6.124v3.126c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75z" })
        );
    }
    function Tree5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree5.SVG = Tree5SVG;
    return Tree5;
})();
export const Tree6 = /*#__PURE__*/ (() => {
    function Tree6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75z" })
        );
    }
    function Tree6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree6.SVG = Tree6SVG;
    return Tree6;
})();
export const Tree7 = /*#__PURE__*/ (() => {
    function Tree7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75zM3 15h-2v-2h2v2zM9 15h-2v-2h2v2zM7 4v-2h2v2h-2zM15 15h-2v-2h2v2z" })
        );
    }
    function Tree7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tree7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tree7.SVG = Tree7SVG;
    return Tree7;
})();
export const Lan = /*#__PURE__*/ (() => {
    function LanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 14v-6h-4v-4h-4v-3h-8v6h3v1h-1v1h4v-1h-1v-1h3v-2h3v3h-3v6h3v1h-1v1h4v-1h-1v-1h3zM7 6h-6v-4h6v4zM9 13v-4h6v4h-6z" })
        );
    }
    function Lan({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lan.SVG = LanSVG;
    return Lan;
})();
export const Lan2 = /*#__PURE__*/ (() => {
    function Lan2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 8h-6.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5h-4c-0.276 0-0.5 0.224-0.5 0.5v4c0 0.276 0.224 0.5 0.5 0.5h1.5v2h-6.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v2h-1.5c-0.276 0-0.5 0.224-0.5 0.5v4c0 0.276 0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5h-1.5v-2h7v2h-1.5c-0.276 0-0.5 0.224-0.5 0.5v4c0 0.276 0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5v-4c0-0.276-0.224-0.5-0.5-0.5h-1.5v-2h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM6 2h3v3h-3v-3zM5 15h-3v-3h3v3zM13 15h-3v-3h3v3z" })
        );
    }
    function Lan2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lan2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lan2.SVG = Lan2SVG;
    return Lan2;
})();
export const Lan3 = /*#__PURE__*/ (() => {
        function Lan3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5-3.5 3.5z" }),
_('path', { d: "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5 3.5-3.5z" }),
_('path', { d: "M8 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M11 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M14 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Lan3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Lan3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lan3.SVG = Lan3SVG;
        return Lan3;
    })();
export const Menu = /*#__PURE__*/ (() => {
    function MenuSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 7c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM8 7c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2zM3 7c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2s0.895-2 2-2z" })
        );
    }
    function Menu({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MenuSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Menu.SVG = MenuSVG;
    return Menu;
})();
export const CircleSmall = /*#__PURE__*/ (() => {
    function CircleSmallSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z" })
        );
    }
    function CircleSmall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleSmallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleSmall.SVG = CircleSmallSVG;
    return CircleSmall;
})();
export const Menu2 = /*#__PURE__*/ (() => {
    function Menu2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 17 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 17 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 0h-15c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h2v10c0 0.55 0.45 1 1 1h12c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM15 14h-10v-2h10v2zM15 11h-10v-2h10v2zM15 8h-10v-2h10v2zM13 5l-2.5-3h5l-2.5 3z" })
        );
    }
    function Menu2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Menu2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Menu2.SVG = Menu2SVG;
    return Menu2;
})();
export const Menu3 = /*#__PURE__*/ (() => {
    function Menu3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 3h14v3h-14zM1 7h14v3h-14zM1 11h14v3h-14z" })
        );
    }
    function Menu3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Menu3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Menu3.SVG = Menu3SVG;
    return Menu3;
})();
export const Menu4 = /*#__PURE__*/ (() => {
        function Menu4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z" }),
_('path', { d: "M15.5 9l3 3 3-3z" }),
_('path', { d: "M21.5 8l-3-3-3 3z" })
            );
        }
        function Menu4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu4.SVG = Menu4SVG;
        return Menu4;
    })();
export const Menu5 = /*#__PURE__*/ (() => {
        function Menu5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z" }),
_('path', { d: "M15.5 7l3 3 3-3z" })
            );
        }
        function Menu5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu5.SVG = Menu5SVG;
        return Menu5;
    })();
export const Menu6 = /*#__PURE__*/ (() => {
        function Menu6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z" }),
_('path', { d: "M15.5 10l3-3 3 3z" })
            );
        }
        function Menu6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu6.SVG = Menu6SVG;
        return Menu6;
    })();
export const Menu7 = /*#__PURE__*/ (() => {
        function Menu7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1 3h14v2h-14v-2z" }),
_('path', { d: "M1 7h14v2h-14v-2z" }),
_('path', { d: "M1 11h14v2h-14v-2z" })
            );
        }
        function Menu7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu7.SVG = Menu7SVG;
        return Menu7;
    })();
export const Menu8 = /*#__PURE__*/ (() => {
        function Menu8SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v2h-14v-2z" }),
_('path', { d: "M0 7h14v2h-14v-2z" }),
_('path', { d: "M0 11h14v2h-14v-2z" }),
_('path', { d: "M15.5 9l3 3 3-3h-6z" }),
_('path', { d: "M21.5 7l-3-3-3 3h6z" })
            );
        }
        function Menu8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu8.SVG = Menu8SVG;
        return Menu8;
    })();
export const Menu9 = /*#__PURE__*/ (() => {
        function Menu9SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v2h-14v-2z" }),
_('path', { d: "M0 7h14v2h-14v-2z" }),
_('path', { d: "M0 11h14v2h-14v-2z" }),
_('path', { d: "M15.5 7l3 3 3-3h-6z" })
            );
        }
        function Menu9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu9.SVG = Menu9SVG;
        return Menu9;
    })();
export const Menu10 = /*#__PURE__*/ (() => {
        function Menu10SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 22 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 22 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 3h14v2h-14v-2z" }),
_('path', { d: "M0 7h14v2h-14v-2z" }),
_('path', { d: "M0 11h14v2h-14v-2z" }),
_('path', { d: "M21.5 9l-3-3-3 3h6z" })
            );
        }
        function Menu10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Menu10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Menu10.SVG = Menu10SVG;
        return Menu10;
    })();
export const Cloud = /*#__PURE__*/ (() => {
    function CloudSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.941 8.040c0.039-0.176 0.059-0.357 0.059-0.54 0-1.378-1.121-2.5-2.5-2.5-0.218 0-0.434 0.029-0.643 0.084-0.388-1.208-1.522-2.084-2.857-2.084-1.354 0-2.514 0.907-2.88 2.158-0.359-0.104-0.735-0.158-1.12-0.158-2.206 0-4 1.794-4 4s1.794 4 4 4h9.5c1.379 0 2.5-1.121 2.5-2.5 0-1.228-0.89-2.251-2.059-2.46zM13.5 12h-9.5c-1.654 0-3-1.346-3-3s1.346-3 3-3c0.813 0 1.574 0.32 2.143 0.9 0.193 0.197 0.51 0.2 0.707 0.007s0.2-0.51 0.007-0.707c-0.245-0.25-0.517-0.463-0.809-0.638 0.201-0.897 1.005-1.562 1.952-1.562 1.103 0 2 0.897 2 2 0 0.136-0.014 0.272-0.041 0.404-0.055 0.271 0.119 0.535 0.39 0.59 0.034 0.007 0.068 0.010 0.101 0.010 0.233 0 0.441-0.163 0.489-0.4 0.035-0.17 0.055-0.343 0.060-0.518 0.16-0.057 0.33-0.086 0.501-0.086 0.827 0 1.5 0.673 1.5 1.5 0 0.171-0.029 0.34-0.086 0.5h-0.414c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5z" })
        );
    }
    function Cloud({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cloud.SVG = CloudSVG;
    return Cloud;
})();
export const CloudDownload = /*#__PURE__*/ (() => {
        function CloudDownloadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 9h-2v3h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M13.941 8.040c0.039-0.176 0.059-0.357 0.059-0.54 0-1.378-1.121-2.5-2.5-2.5-0.218 0-0.434 0.029-0.643 0.084-0.388-1.208-1.522-2.084-2.857-2.084-1.354 0-2.514 0.907-2.88 2.158-0.359-0.104-0.735-0.158-1.12-0.158-2.206 0-4 1.794-4 4 0 0.969 0.351 1.903 0.988 2.632 0.631 0.721 1.498 1.193 2.442 1.328 0.024 0.003 0.048 0.005 0.071 0.005 0.245 0 0.459-0.18 0.494-0.429 0.039-0.273-0.151-0.527-0.424-0.566-0.707-0.101-1.357-0.455-1.83-0.996-0.477-0.546-0.74-1.247-0.74-1.973 0-1.654 1.346-3 3-3 0.813 0 1.574 0.32 2.143 0.9 0.193 0.197 0.51 0.2 0.707 0.007s0.2-0.51 0.007-0.707c-0.245-0.25-0.517-0.463-0.809-0.638 0.201-0.897 1.005-1.562 1.952-1.562 1.103 0 2 0.897 2 2 0 0.136-0.014 0.272-0.041 0.404-0.055 0.271 0.119 0.535 0.39 0.59 0.034 0.007 0.068 0.010 0.101 0.010 0.233 0 0.441-0.163 0.489-0.4 0.035-0.17 0.055-0.343 0.060-0.518 0.16-0.057 0.33-0.086 0.501-0.086 0.827 0 1.5 0.673 1.5 1.5 0 0.171-0.029 0.34-0.086 0.5h-0.414c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c1.379 0 2.5-1.121 2.5-2.5 0-1.228-0.89-2.251-2.059-2.46z" })
            );
        }
        function CloudDownload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudDownloadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudDownload.SVG = CloudDownloadSVG;
        return CloudDownload;
    })();
export const CloudUpload = /*#__PURE__*/ (() => {
        function CloudUploadSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 8.5l-3.5 3.5h2.5v3h2v-3h2.5l-3.5-3.5z" }),
_('path', { d: "M13.941 8.040c0.039-0.176 0.059-0.357 0.059-0.54 0-1.378-1.121-2.5-2.5-2.5-0.218 0-0.434 0.029-0.643 0.084-0.388-1.208-1.522-2.084-2.857-2.084-1.354 0-2.514 0.907-2.88 2.158-0.359-0.104-0.735-0.158-1.12-0.158-2.206 0-4 1.794-4 4 0 0.969 0.351 1.903 0.988 2.632 0.631 0.721 1.498 1.193 2.442 1.328 0.024 0.003 0.048 0.005 0.071 0.005 0.245 0 0.459-0.18 0.494-0.429 0.039-0.273-0.151-0.527-0.424-0.566-0.707-0.101-1.357-0.455-1.83-0.996-0.477-0.546-0.74-1.247-0.74-1.973 0-1.654 1.346-3 3-3 0.813 0 1.574 0.32 2.143 0.9 0.193 0.197 0.51 0.2 0.707 0.007s0.2-0.51 0.007-0.707c-0.245-0.25-0.517-0.463-0.809-0.638 0.201-0.897 1.005-1.562 1.952-1.562 1.103 0 2 0.897 2 2 0 0.136-0.014 0.272-0.041 0.404-0.055 0.271 0.119 0.535 0.39 0.59 0.034 0.007 0.068 0.010 0.101 0.010 0.233 0 0.441-0.163 0.489-0.4 0.035-0.17 0.055-0.343 0.060-0.518 0.16-0.057 0.33-0.086 0.501-0.086 0.827 0 1.5 0.673 1.5 1.5 0 0.171-0.029 0.34-0.086 0.5h-0.414c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c1.379 0 2.5-1.121 2.5-2.5 0-1.228-0.89-2.251-2.059-2.46z" })
            );
        }
        function CloudUpload({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudUploadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudUpload.SVG = CloudUploadSVG;
        return CloudUpload;
    })();
export const CloudCheck = /*#__PURE__*/ (() => {
        function CloudCheckSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.5 9l-4 4-2-2-1.5 1.5 3.5 3.5 5.5-5.5z" }),
_('path', { d: "M4 5c-2.206 0-4 1.794-4 4 0 1.068 0.416 2.073 1.172 2.828 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512-0-0.707-0.567-0.567-0.879-1.32-0.879-2.121 0-1.654 1.346-3 3-3 0.813 0 1.574 0.32 2.143 0.901 0.193 0.197 0.51 0.2 0.707 0.007s0.2-0.51 0.007-0.707c-0.245-0.25-0.517-0.463-0.809-0.638 0.201-0.897 1.005-1.562 1.952-1.562 1.103 0 2 0.897 2 2 0 0.136-0.014 0.272-0.041 0.404-0.055 0.271 0.119 0.535 0.39 0.59 0.034 0.007 0.068 0.010 0.101 0.010 0.233 0 0.441-0.163 0.489-0.4 0.035-0.17 0.055-0.343 0.060-0.518 0.16-0.057 0.33-0.086 0.501-0.086 0.827 0 1.5 0.673 1.5 1.5 0 0.171-0.029 0.34-0.086 0.5h-0.414c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5h-1c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1c1.379 0 2.5-1.122 2.5-2.5 0-1.228-0.89-2.251-2.059-2.46 0.039-0.176 0.059-0.357 0.059-0.54 0-1.378-1.121-2.5-2.5-2.5-0.218 0-0.434 0.029-0.643 0.084-0.388-1.208-1.522-2.084-2.857-2.084-1.354 0-2.514 0.907-2.88 2.158-0.359-0.104-0.735-0.158-1.12-0.158v0z" })
            );
        }
        function CloudCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CloudCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CloudCheck.SVG = CloudCheckSVG;
        return CloudCheck;
    })();
export const Cloud2 = /*#__PURE__*/ (() => {
    function Cloud2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 10.274c0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029l10.254-0c1.502-0.003 2.719-1.222 2.719-2.726z" })
        );
    }
    function Cloud2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cloud2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cloud2.SVG = Cloud2SVG;
    return Cloud2;
})();
export const CloudDownload2 = /*#__PURE__*/ (() => {
    function CloudDownload2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.922 5.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h1.434l3.539 3.664 3.539-3.664 1.742-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM8 13l-3-3h2v-3h2v3h2l-3 3z" })
        );
    }
    function CloudDownload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudDownload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloudDownload2.SVG = CloudDownload2SVG;
    return CloudDownload2;
})();
export const CloudUpload2 = /*#__PURE__*/ (() => {
    function CloudUpload2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.942 6.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h2v3h4v-3h3.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.253-2.058-2.461zM9 10v3h-2v-3h-2.5l3.5-3.5 3.5 3.5h-2.5z" })
        );
    }
    function CloudUpload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudUpload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloudUpload2.SVG = CloudUpload2SVG;
    return CloudUpload2;
})();
export const CloudCheck2 = /*#__PURE__*/ (() => {
    function CloudCheck2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.942 8.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h9.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.252-2.058-2.461zM6.5 12l-2.5-2.5 1-1 1.5 1.5 3.5-3.5 1 1-4.5 4.5z" })
        );
    }
    function CloudCheck2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CloudCheck2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CloudCheck2.SVG = CloudCheck2SVG;
    return CloudCheck2;
})();
export const Download2 = /*#__PURE__*/ (() => {
        function Download2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 7l5.5 5.5 5.5-5.5h-3.5v-6h-4v6z" }),
_('path', { d: "M14 8v6h-12v-6h-2v6.5c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-6.5h-2z" })
            );
        }
        function Download2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Download2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Download2.SVG = Download2SVG;
        return Download2;
    })();
export const Download3 = /*#__PURE__*/ (() => {
        function Download3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 7l5.5 5.5 5.5-5.5h-3.5v-6h-4v6z" }),
_('path', { d: "M0.284 15.375h15.432c0.056-0.078 0.106-0.162 0.146-0.25h-15.725c0.041 0.088 0.090 0.172 0.146 0.25z" }),
_('path', { d: "M0.903 15.875h14.194c0.144-0.063 0.276-0.148 0.392-0.25h-14.978c0.116 0.102 0.248 0.187 0.392 0.25z" }),
_('path', { d: "M0.048 14.875h15.904c0.021-0.081 0.035-0.165 0.042-0.25h-15.989c0.007 0.085 0.021 0.169 0.042 0.25z" }),
_('path', { d: "M15.875 14.125v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-12.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.125v0.25h16v-0.25z" })
            );
        }
        function Download3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Download3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Download3.SVG = Download3SVG;
        return Download3;
    })();
export const Upload2 = /*#__PURE__*/ (() => {
        function Upload2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.5 6l5.5-5.5 5.5 5.5h-3.5v6h-4v-6z" }),
_('path', { d: "M14 8v6h-12v-6h-2v6.5c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-6.5h-2z" })
            );
        }
        function Upload2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Upload2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload2.SVG = Upload2SVG;
        return Upload2;
    })();
export const Upload3 = /*#__PURE__*/ (() => {
        function Upload3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 6l-5.5-5.5-5.5 5.5h3.5v6h4v-6z" }),
_('path', { d: "M0.284 15.375h15.432c0.056-0.078 0.106-0.162 0.146-0.25h-15.725c0.041 0.088 0.090 0.172 0.146 0.25z" }),
_('path', { d: "M0.903 15.875h14.194c0.144-0.063 0.276-0.148 0.392-0.25h-14.978c0.116 0.102 0.248 0.187 0.392 0.25z" }),
_('path', { d: "M0.048 14.875h15.904c0.021-0.081 0.035-0.165 0.042-0.25h-15.989c0.007 0.085 0.021 0.169 0.042 0.25z" }),
_('path', { d: "M15.875 14.125v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-12.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.125v0.25h16v-0.25z" })
            );
        }
        function Upload3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Upload3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload3.SVG = Upload3SVG;
        return Upload3;
    })();
export const Import = /*#__PURE__*/ (() => {
        function ImportSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 11h2v-3h3v-2h-3v-3h-2v3h-3v2h3v3z" }),
_('path', { d: "M14 8v6h-12v-6h-2v6.5c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-6.5h-2z" })
            );
        }
        function Import({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ImportSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Import.SVG = ImportSVG;
        return Import;
    })();
export const Import2 = /*#__PURE__*/ (() => {
        function Import2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 11h2v-3h3v-2h-3v-3h-2v3h-3v2h3z" }),
_('path', { d: "M0.284 15.375h15.432c0.056-0.078 0.106-0.162 0.146-0.25h-15.725c0.041 0.088 0.090 0.172 0.146 0.25z" }),
_('path', { d: "M0.903 15.875h14.194c0.144-0.063 0.276-0.148 0.392-0.25h-14.978c0.116 0.102 0.248 0.187 0.392 0.25z" }),
_('path', { d: "M0.048 14.875h15.904c0.021-0.081 0.035-0.165 0.042-0.25h-15.989c0.007 0.085 0.021 0.169 0.042 0.25z" }),
_('path', { d: "M15.875 14.125v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-12.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.25v-6.125h-0.25v6.125h-0.125v0.25h16v-0.25z" })
            );
        }
        function Import2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Import2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Import2.SVG = Import2SVG;
        return Import2;
    })();
export const Download4 = /*#__PURE__*/ (() => {
    function Download4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 11v2h-12v-2h-2v4h16v-4zM12 6h-3v-5h-2v5h-3l4 6z" })
        );
    }
    function Download4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Download4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download4.SVG = Download4SVG;
    return Download4;
})();
export const Upload4 = /*#__PURE__*/ (() => {
    function Upload4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 11v2h-12v-2h-2v4h16v-4zM4 7h3v5h2v-5h3l-4-6z" })
        );
    }
    function Upload4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Upload4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload4.SVG = Upload4SVG;
    return Upload4;
})();
export const Download5 = /*#__PURE__*/ (() => {
        function Download5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 12h12v3h-12v-3z" }),
_('path', { d: "M10 6v-5h-4v5h-3.5l5.5 5.5 5.5-5.5z" })
            );
        }
        function Download5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Download5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Download5.SVG = Download5SVG;
        return Download5;
    })();
export const Upload5 = /*#__PURE__*/ (() => {
        function Upload5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 12h12v3h-12v-3z" }),
_('path', { d: "M6 6v5h4v-5h3.5l-5.5-5.5-5.5 5.5z" })
            );
        }
        function Upload5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Upload5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload5.SVG = Upload5SVG;
        return Upload5;
    })();
export const Download6 = /*#__PURE__*/ (() => {
    function Download6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 16h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 14h1v1h-1v-1zM12.5 4l-4.5 4.5-4.5-4.5h3.5v-4h2v4zM15.981 11.519c0.077 0.264-0.089 0.481-0.368 0.481h-15.226c-0.279 0-0.445-0.216-0.368-0.481l1.751-5.038c0.077-0.264 0.368-0.481 0.647-0.481h1.083l4 4h1l4-4h1.083c0.279 0 0.57 0.216 0.647 0.481l1.751 5.038z" })
        );
    }
    function Download6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Download6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download6.SVG = Download6SVG;
    return Download6;
})();
export const Upload6 = /*#__PURE__*/ (() => {
    function Upload6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 16h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 14h1v1h-1v-1zM3.5 5l4.5-4.5 4.5 4.5h-3.5v3h-2v-3zM15.981 11.519c0.077 0.264-0.089 0.481-0.368 0.481h-15.226c-0.279 0-0.445-0.216-0.368-0.481l1.751-5.038c0.077-0.264 0.368-0.481 0.647-0.481h3.583v3h4v-3h3.583c0.279 0 0.57 0.216 0.647 0.481l1.751 5.038z" })
        );
    }
    function Upload6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Upload6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload6.SVG = Upload6SVG;
    return Upload6;
})();
export const Download7 = /*#__PURE__*/ (() => {
    function Download7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 8h-2.5l-3.5 3.5-3.5-3.5h-2.5l-2 4v1h16v-1l-2-4zM0 14h16v1h-16v-1zM9 5v-4h-2v4h-3.5l4.5 4.5 4.5-4.5h-3.5z" })
        );
    }
    function Download7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Download7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download7.SVG = Download7SVG;
    return Download7;
})();
export const Upload7 = /*#__PURE__*/ (() => {
    function Upload7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 14h16v1h-16zM16 12v1h-16v-1l2-4h4v2h4v-2h4zM3.5 5l4.5-4.5 4.5 4.5h-3.5v4h-2v-4z" })
        );
    }
    function Upload7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Upload7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload7.SVG = Upload7SVG;
    return Upload7;
})();
export const Download8 = /*#__PURE__*/ (() => {
    function Download8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 7l-4 4-4-4h2.5v-6h3v6zM7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1z" })
        );
    }
    function Download8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Download8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download8.SVG = Download8SVG;
    return Download8;
})();
export const Upload8 = /*#__PURE__*/ (() => {
    function Upload8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1zM3.5 5l4-4 4 4h-2.5v5h-3v-5z" })
        );
    }
    function Upload8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Upload8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload8.SVG = Upload8SVG;
    return Upload8;
})();
export const Download9 = /*#__PURE__*/ (() => {
    function Download9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 6h-3.5v-4h-2v4h-3.5l4.5 4zM11.611 8.322l-0.525 0.462c1.746 0.35 2.914 0.987 2.914 1.716 0 1.105-2.686 2-6 2s-6-0.895-6-2c0-0.728 1.168-1.366 2.914-1.716l-0.525-0.462c-2.604 0.495-4.389 1.508-4.389 2.678 0 1.657 3.582 3 8 3s8-1.343 8-3c0-1.17-1.785-2.183-4.389-2.678z" })
        );
    }
    function Download9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Download9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Download9.SVG = Download9SVG;
    return Download9;
})();
export const Upload9 = /*#__PURE__*/ (() => {
    function Upload9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 10h2v-4h3.5l-4.5-4-4.5 4h3.5zM10 8.095v0.519c2.33 0.275 4 1.015 4 1.886 0 1.105-2.686 2-6 2s-6-0.895-6-2c0-0.871 1.67-1.611 4-1.886v-0.519c-3.45 0.333-6 1.508-6 2.905 0 1.657 3.582 3 8 3s8-1.343 8-3c0-1.398-2.55-2.572-6-2.905z" })
        );
    }
    function Upload9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Upload9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Upload9.SVG = Upload9SVG;
    return Upload9;
})();
export const Download10 = /*#__PURE__*/ (() => {
        function Download10SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 5v-5h-1v5h-2.5l3 3 3-3z" }),
_('path', { d: "M11 5.4v1.077l2.703 1.081-6.203 3.308-6.203-3.308 2.703-1.081v-1.077l-4 1.6v5l7.5 4 7.5-4v-5l-4-1.6zM7 14.6l-6-3.2v-2.867l6 3.2v2.867zM14 11.4l-6 3.2v-2.867l6-3.2v2.867z" })
            );
        }
        function Download10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Download10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Download10.SVG = Download10SVG;
        return Download10;
    })();
export const Upload10 = /*#__PURE__*/ (() => {
        function Upload10SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 3v5h1v-5h2.5l-3-3-3 3z" }),
_('path', { d: "M9 4.6v1.077l4.703 1.881-6.203 3.308-6.203-3.308 4.703-1.881v-1.077l-6 2.4v5l7.5 4 7.5-4v-5l-6-2.4zM7 14.6l-6-3.2v-2.867l6 3.2v2.867zM14 11.4l-6 3.2v-2.867l6-3.2v2.867z" })
            );
        }
        function Upload10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Upload10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Upload10.SVG = Upload10SVG;
        return Upload10;
    })();
export const Sphere = /*#__PURE__*/ (() => {
    function SphereSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM3.256 6c-0.134 0.632-0.219 1.303-0.246 2h-1.991c0.052-0.691 0.213-1.361 0.479-2h1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289h-2.426zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM1.498 11c-0.266-0.639-0.427-1.309-0.479-2h1.991c0.028 0.697 0.112 1.368 0.246 2h-1.758zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM2.904 3.904c0.526-0.526 1.128-0.952 1.792-1.27-0.483 0.643-0.886 1.448-1.177 2.366h-1.498c0.252-0.394 0.547-0.761 0.883-1.096zM2.021 12h1.498c0.291 0.918 0.693 1.723 1.177 2.366-0.665-0.318-1.267-0.744-1.792-1.27-0.336-0.336-0.631-0.702-0.883-1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z" })
        );
    }
    function Sphere({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SphereSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sphere.SVG = SphereSVG;
    return Sphere;
})();
export const Sphere2 = /*#__PURE__*/ (() => {
    function Sphere2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289l-2.426-0zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z" })
        );
    }
    function Sphere2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sphere2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sphere2.SVG = Sphere2SVG;
    return Sphere2;
})();
export const Sphere3 = /*#__PURE__*/ (() => {
    function Sphere3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8.282 14.698c-0.118 0.26-0.217 0.406-0.282 0.485-0.066-0.079-0.165-0.225-0.282-0.485-0.181-0.4-0.351-0.954-0.493-1.602-0.009-0.040-0.017-0.080-0.026-0.121 0.263 0.016 0.531 0.025 0.801 0.025s0.537-0.008 0.801-0.025c-0.008 0.041-0.017 0.081-0.026 0.121-0.141 0.648-0.312 1.202-0.493 1.602zM8 12.25c-0.317 0-0.631-0.012-0.941-0.036-0.111-0.688-0.194-1.443-0.246-2.236 0.387 0.014 0.783 0.022 1.186 0.022s0.799-0.008 1.186-0.022c-0.052 0.793-0.135 1.547-0.246 2.236-0.31 0.024-0.624 0.036-0.941 0.036zM8 9.25c-0.413 0-0.823-0.008-1.226-0.024-0.016-0.403-0.024-0.813-0.024-1.226s0.008-0.823 0.024-1.226c0.403-0.016 0.813-0.024 1.226-0.024s0.823 0.008 1.226 0.024c0.016 0.403 0.024 0.813 0.024 1.226s-0.008 0.823-0.024 1.226c-0.403 0.016-0.813 0.024-1.226 0.024zM3.75 8c0-0.317 0.012-0.631 0.036-0.941 0.688-0.111 1.443-0.194 2.236-0.246-0.014 0.387-0.022 0.783-0.022 1.186s0.008 0.799 0.022 1.186c-0.793-0.052-1.547-0.135-2.236-0.246-0.024-0.31-0.036-0.624-0.036-0.941zM3.025 8.801c-0.041-0.008-0.081-0.017-0.121-0.026-0.648-0.141-1.202-0.312-1.602-0.493-0.26-0.118-0.406-0.217-0.485-0.282 0.079-0.066 0.224-0.165 0.485-0.282 0.4-0.181 0.954-0.351 1.602-0.493 0.040-0.009 0.080-0.017 0.121-0.026-0.016 0.263-0.025 0.531-0.025 0.801s0.009 0.537 0.025 0.801zM7.718 1.302c0.118-0.26 0.217-0.406 0.282-0.485 0.066 0.079 0.165 0.224 0.282 0.485 0.181 0.4 0.351 0.954 0.493 1.602 0.009 0.040 0.017 0.080 0.026 0.121-0.263-0.016-0.531-0.025-0.801-0.025s-0.537 0.009-0.801 0.025c0.008-0.041 0.017-0.081 0.026-0.121 0.141-0.648 0.312-1.202 0.493-1.602zM8 3.75c0.317 0 0.631 0.012 0.941 0.036 0.111 0.688 0.194 1.443 0.246 2.236-0.387-0.014-0.783-0.022-1.186-0.022s-0.799 0.008-1.186 0.022c0.052-0.793 0.135-1.547 0.246-2.236 0.31-0.024 0.624-0.036 0.941-0.036zM9.978 6.814c0.793 0.052 1.547 0.135 2.236 0.246 0.024 0.31 0.036 0.624 0.036 0.941s-0.012 0.631-0.036 0.941c-0.688 0.111-1.443 0.194-2.236 0.246 0.014-0.387 0.022-0.783 0.022-1.186s-0.008-0.799-0.022-1.186zM12.975 7.199c0.041 0.008 0.081 0.017 0.121 0.026 0.648 0.141 1.202 0.312 1.602 0.493 0.26 0.118 0.406 0.217 0.485 0.282-0.079 0.066-0.225 0.165-0.485 0.282-0.4 0.181-0.954 0.351-1.602 0.493-0.040 0.009-0.080 0.017-0.121 0.026 0.016-0.263 0.025-0.531 0.025-0.801s-0.008-0.537-0.025-0.801zM12.902 6.42c-0.074-0.594-0.19-1.165-0.342-1.703 0.245 0.118 0.478 0.246 0.699 0.384 0.645 0.403 1.147 0.866 1.491 1.374 0.13 0.192 0.235 0.388 0.314 0.587-0.533-0.25-1.273-0.469-2.162-0.641zM11.882 5.078c0.104 0.393 0.186 0.797 0.246 1.209-0.671-0.101-1.406-0.178-2.187-0.227-0.049-0.781-0.126-1.516-0.227-2.187 0.412 0.060 0.816 0.142 1.209 0.246 0.253 0.067 0.498 0.142 0.735 0.225 0.083 0.237 0.158 0.482 0.225 0.735zM9.581 3.098c-0.173-0.889-0.391-1.629-0.641-2.162 0.199 0.079 0.395 0.184 0.587 0.314 0.508 0.344 0.97 0.845 1.374 1.491 0.138 0.221 0.266 0.454 0.384 0.699-0.539-0.152-1.109-0.267-1.703-0.342zM6.474 1.25c0.192-0.13 0.388-0.235 0.587-0.314-0.25 0.533-0.469 1.273-0.641 2.162-0.594 0.074-1.165 0.19-1.703 0.342 0.118-0.245 0.246-0.478 0.384-0.699 0.403-0.645 0.866-1.147 1.374-1.491zM5.078 4.118c0.393-0.104 0.797-0.186 1.209-0.246-0.101 0.671-0.178 1.406-0.227 2.187-0.781 0.049-1.516 0.126-2.187 0.227 0.060-0.412 0.142-0.816 0.246-1.209 0.067-0.253 0.142-0.498 0.225-0.735 0.237-0.083 0.482-0.158 0.735-0.225zM3.098 6.42c-0.889 0.173-1.629 0.391-2.162 0.641 0.079-0.199 0.184-0.394 0.314-0.587 0.344-0.508 0.845-0.97 1.491-1.374 0.221-0.138 0.454-0.266 0.699-0.384-0.152 0.539-0.267 1.109-0.342 1.703zM0.936 8.939c0.533 0.25 1.273 0.469 2.162 0.641 0.074 0.594 0.19 1.165 0.342 1.703-0.245-0.118-0.478-0.246-0.699-0.384-0.645-0.403-1.147-0.866-1.491-1.374-0.13-0.192-0.235-0.388-0.314-0.587zM4.118 10.922c-0.104-0.393-0.186-0.797-0.246-1.209 0.671 0.101 1.406 0.178 2.187 0.227 0.049 0.781 0.126 1.516 0.227 2.187-0.412-0.060-0.816-0.142-1.209-0.246-0.253-0.067-0.498-0.142-0.735-0.225-0.083-0.237-0.158-0.482-0.225-0.735zM6.42 12.902c0.173 0.889 0.391 1.629 0.641 2.162-0.199-0.079-0.394-0.184-0.587-0.314-0.508-0.344-0.97-0.845-1.374-1.491-0.138-0.221-0.266-0.454-0.384-0.699 0.539 0.152 1.109 0.267 1.703 0.342zM9.526 14.75c-0.192 0.13-0.388 0.235-0.587 0.314 0.25-0.533 0.469-1.273 0.641-2.162 0.594-0.074 1.165-0.19 1.703-0.342-0.118 0.245-0.246 0.478-0.384 0.699-0.403 0.645-0.866 1.147-1.374 1.491zM10.922 11.882c-0.393 0.104-0.797 0.186-1.209 0.246 0.101-0.671 0.178-1.406 0.227-2.187 0.781-0.049 1.516-0.126 2.187-0.227-0.060 0.412-0.142 0.816-0.246 1.209-0.067 0.253-0.142 0.498-0.225 0.735-0.237 0.083-0.482 0.158-0.735 0.225zM12.902 9.581c0.889-0.173 1.629-0.391 2.162-0.641-0.080 0.199-0.184 0.395-0.314 0.587-0.344 0.508-0.845 0.97-1.491 1.374-0.221 0.138-0.454 0.266-0.699 0.384 0.152-0.539 0.267-1.109 0.342-1.703zM13.127 2.873c0.666 0.666 1.189 1.442 1.554 2.305 0.016 0.038 0.032 0.077 0.047 0.116-0.638-0.619-1.489-1.143-2.487-1.534-0.391-0.999-0.915-1.849-1.534-2.487 0.039 0.016 0.077 0.031 0.116 0.047 0.863 0.365 1.639 0.888 2.305 1.554zM2.873 2.873c0.666-0.666 1.442-1.189 2.305-1.554 0.038-0.016 0.077-0.032 0.115-0.047-0.618 0.638-1.143 1.489-1.534 2.487-0.999 0.391-1.849 0.915-2.487 1.534 0.016-0.039 0.031-0.077 0.047-0.115 0.365-0.863 0.888-1.639 1.554-2.305zM2.873 13.127c-0.666-0.666-1.189-1.441-1.554-2.305-0.016-0.038-0.032-0.077-0.047-0.115 0.638 0.618 1.489 1.143 2.487 1.534 0.391 0.998 0.915 1.849 1.534 2.487-0.039-0.015-0.077-0.031-0.115-0.047-0.863-0.365-1.639-0.888-2.305-1.554zM13.127 13.127c-0.666 0.666-1.441 1.189-2.305 1.554-0.038 0.016-0.077 0.032-0.116 0.047 0.619-0.638 1.143-1.489 1.534-2.487 0.999-0.391 1.849-0.915 2.487-1.534-0.016 0.039-0.031 0.077-0.047 0.116-0.365 0.863-0.888 1.639-1.554 2.305z" })
        );
    }
    function Sphere3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sphere3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sphere3.SVG = Sphere3SVG;
    return Sphere3;
})();
export const Planet = /*#__PURE__*/ (() => {
    function PlanetSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.779 3.509c-0.312-0.541-0.943-0.815-1.876-0.815-0.672 0-1.501 0.146-2.425 0.417-0.981-0.699-2.181-1.111-3.478-1.111-3.314 0-6 2.686-6 6 0 0.19 0.009 0.378 0.027 0.563-0.17 0.162-0.331 0.323-0.482 0.483-0.597 0.63-1.023 1.217-1.268 1.743-0.213 0.458-0.396 1.127-0.062 1.706 0.312 0.541 0.943 0.815 1.876 0.815 0.674 0 1.506-0.147 2.433-0.419 0.981 0.699 2.18 1.11 3.476 1.11 3.314 0 6-2.686 6-6 0-0.191-0.009-0.379-0.027-0.565 0.167-0.16 0.326-0.319 0.476-0.477 0.597-0.63 1.024-1.217 1.268-1.743 0.213-0.458 0.396-1.126 0.062-1.705zM13.609 6.163c-1.102 1.163-2.754 2.408-4.652 3.503-2.617 1.511-5.312 2.487-6.866 2.487-0.544 0-0.809-0.122-0.875-0.237-0.119-0.206 0.081-0.904 1.097-1.999 0.123 0.366 0.281 0.715 0.469 1.046 1.269-0.21 3.301-0.935 5.614-2.271 1.806-1.043 3.368-2.216 4.397-3.303 0.148-0.157 0.274-0.3 0.38-0.43-0.194-0.329-0.419-0.638-0.67-0.923 0.527-0.121 1.001-0.185 1.399-0.185 0.544 0 0.809 0.122 0.875 0.237 0.121 0.21-0.089 0.937-1.168 2.076z" })
        );
    }
    function Planet({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlanetSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Planet.SVG = PlanetSVG;
    return Planet;
})();
export const Planet2 = /*#__PURE__*/ (() => {
    function Planet2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.793 3.501c-0.31-0.537-0.938-0.809-1.867-0.809-0.677 0-1.513 0.148-2.446 0.423-0.982-0.701-2.183-1.115-3.48-1.115-3.308 0-6 2.692-6 6 0 0.192 0.010 0.383 0.027 0.571-0.172 0.164-0.335 0.327-0.488 0.489-0.598 0.631-1.025 1.218-1.269 1.744-0.212 0.456-0.394 1.121-0.063 1.695 0.31 0.537 0.938 0.809 1.867 0.809 0.677 0 1.513-0.149 2.445-0.423 0.982 0.702 2.184 1.115 3.48 1.115 3.308 0 6-2.692 6-6 0-0.192-0.009-0.383-0.027-0.571 0.172-0.164 0.335-0.327 0.488-0.489 0.598-0.631 1.025-1.218 1.269-1.744 0.212-0.456 0.394-1.121 0.063-1.695zM8 3c2.382 0 4.381 1.675 4.88 3.909-1.047 0.943-2.4 1.906-3.907 2.776-1.502 0.867-3.031 1.559-4.356 1.993-0.993-0.914-1.617-2.225-1.617-3.678 0-2.757 2.243-5 5-5zM1.182 11.937c-0.106-0.183-0.002-0.844 1.123-2.049 0.26 0.784 0.679 1.496 1.216 2.1-0.546 0.127-1.036 0.195-1.446 0.195-0.554 0-0.824-0.127-0.893-0.246zM8 13c-0.806 0-1.567-0.192-2.242-0.532 1.195-0.45 2.489-1.065 3.778-1.809 1.283-0.741 2.463-1.55 3.456-2.365-0.153 2.62-2.333 4.705-4.991 4.705zM13.695 6.112c-0.26-0.784-0.678-1.496-1.216-2.1 0.546-0.127 1.036-0.195 1.446-0.195 0.554 0 0.824 0.127 0.893 0.246 0.106 0.183 0.002 0.844-1.123 2.049z" })
        );
    }
    function Planet2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Planet2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Planet2.SVG = Planet2SVG;
    return Planet2;
})();
export const Earth = /*#__PURE__*/ (() => {
    function EarthSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z" })
        );
    }
    function Earth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EarthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Earth.SVG = EarthSVG;
    return Earth;
})();
export const Earth2 = /*#__PURE__*/ (() => {
    function Earth2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5.5 1.46v0.54l-2.5 2.5h-1.063c0.799-1.381 2.056-2.463 3.563-3.040zM8 10l-3.573 4.020c-0.146-0.087-0.288-0.178-0.427-0.275v-3.245l-2-1.5v-2.5c0-0.276 0.224-0.5 0.5-0.5h1.5c0 0 1.5 2 4 2.5v1.5zM14.049 7.668c-0.247-0.832-0.461-0.913-1.549-1.283v-0c-0.372-0.117-0.723-0.322-1.018-0.617-0.976-0.976-0.976-2.559 0-3.536 0.066-0.066 0.134-0.126 0.205-0.183 1.988 1.235 3.313 3.438 3.313 5.951 0 1.296-0.353 2.51-0.967 3.551 0.257-1.664 0.162-2.997 0.016-3.883z" })
        );
    }
    function Earth2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Earth2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Earth2.SVG = Earth2SVG;
    return Earth2;
})();
export const Earth3 = /*#__PURE__*/ (() => {
    function Earth3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM15 8c0 1.035-0.225 2.017-0.628 2.901 0.291-2.803-0.372-4.545-0.407-4.634-0.089-0.226-0.327-0.356-0.565-0.307-0.66 0.134-1.339-0.070-1.815-0.546-0.378-0.378-0.586-0.88-0.586-1.414s0.208-1.036 0.586-1.414c0.128-0.128 0.27-0.236 0.424-0.324 1.808 1.266 2.99 3.364 2.99 5.738zM5 1.674v0.619l-1.707 1.707h-1.038c0.694-0.995 1.64-1.801 2.745-2.326zM4.724 10.053l-1.724-0.862v-2.191h1.301c0.483 0.444 2.017 1.737 3.699 1.965v0.844l-3 3.375v-2.685c0-0.189-0.107-0.363-0.276-0.447zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z" })
        );
    }
    function Earth3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Earth3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Earth3.SVG = Earth3SVG;
    return Earth3;
})();
export const Link = /*#__PURE__*/ (() => {
        function LinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z" }),
_('path', { d: "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z" })
            );
        }
        function Link({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( LinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link.SVG = LinkSVG;
        return Link;
    })();
export const Unlink = /*#__PURE__*/ (() => {
        function UnlinkSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z" }),
_('path', { d: "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z" }),
_('path', { d: "M14.5 13c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2 2c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M15.5 10h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 14c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M2.5 7h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M3.5 6c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2 2c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M4.5 5c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Unlink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnlinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink.SVG = UnlinkSVG;
        return Unlink;
    })();
export const Link2 = /*#__PURE__*/ (() => {
    function Link2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 11c0.275 0.275 0.739 0.261 1.030-0.030l4.939-4.939c0.292-0.292 0.305-0.755 0.030-1.030s-0.739-0.261-1.030 0.030l-4.939 4.939c-0.292 0.292-0.305 0.755-0.030 1.030zM7.451 10.549c0.071 0.141 0.109 0.299 0.109 0.464 0 0.275-0.105 0.532-0.297 0.724l-2.553 2.553c-0.191 0.191-0.448 0.297-0.724 0.297s-0.532-0.105-0.724-0.297l-1.553-1.553c-0.191-0.191-0.297-0.448-0.297-0.724s0.105-0.532 0.297-0.724l2.553-2.553c0.191-0.191 0.448-0.297 0.724-0.297 0.165 0 0.323 0.038 0.464 0.109l1.021-1.021c-0.435-0.335-0.96-0.502-1.485-0.502-0.625 0-1.25 0.237-1.724 0.711l-2.553 2.553c-0.948 0.948-0.948 2.499 0 3.447l1.553 1.553c0.474 0.474 1.099 0.711 1.724 0.711s1.25-0.237 1.724-0.711l2.553-2.553c0.872-0.872 0.941-2.255 0.209-3.209l-1.021 1.021zM15.289 2.264l-1.553-1.553c-0.474-0.474-1.099-0.711-1.724-0.711s-1.25 0.237-1.724 0.711l-2.553 2.553c-0.872 0.872-0.941 2.255-0.208 3.208l1.021-1.021c-0.071-0.141-0.109-0.299-0.109-0.464 0-0.275 0.105-0.532 0.297-0.724l2.553-2.553c0.191-0.191 0.448-0.297 0.724-0.297s0.532 0.105 0.724 0.297l1.553 1.553c0.191 0.191 0.297 0.448 0.297 0.724s-0.105 0.532-0.297 0.724l-2.553 2.553c-0.191 0.191-0.448 0.297-0.724 0.297-0.165 0-0.323-0.038-0.464-0.109l-1.021 1.021c0.435 0.335 0.96 0.502 1.485 0.502 0.625 0 1.25-0.237 1.724-0.711l2.553-2.553c0.948-0.948 0.948-2.499 0-3.447z" })
        );
    }
    function Link2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Link2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Link2.SVG = Link2SVG;
    return Link2;
})();
export const Unlink2 = /*#__PURE__*/ (() => {
    function Unlink2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.451 10.549c0.071 0.141 0.109 0.299 0.109 0.464 0 0.275-0.105 0.532-0.297 0.724l-2.553 2.553c-0.191 0.191-0.448 0.297-0.724 0.297s-0.532-0.105-0.724-0.297l-1.553-1.553c-0.191-0.191-0.297-0.448-0.297-0.724s0.105-0.532 0.297-0.724l2.553-2.553c0.191-0.191 0.448-0.297 0.724-0.297 0.165 0 0.323 0.038 0.464 0.109l1.021-1.021c-0.435-0.335-0.96-0.502-1.485-0.502-0.625 0-1.25 0.237-1.724 0.711l-2.553 2.553c-0.948 0.948-0.948 2.499 0 3.447l1.553 1.553c0.474 0.474 1.099 0.711 1.724 0.711s1.25-0.237 1.724-0.711l2.553-2.553c0.872-0.872 0.941-2.255 0.209-3.209l-1.021 1.021zM15.289 2.264l-1.553-1.553c-0.474-0.474-1.099-0.711-1.724-0.711s-1.25 0.237-1.724 0.711l-2.553 2.553c-0.872 0.872-0.941 2.255-0.208 3.208l1.021-1.021c-0.071-0.141-0.109-0.299-0.109-0.464 0-0.275 0.105-0.532 0.297-0.724l2.553-2.553c0.191-0.191 0.448-0.297 0.724-0.297s0.532 0.105 0.724 0.297l1.553 1.553c0.191 0.191 0.297 0.448 0.297 0.724s-0.105 0.532-0.297 0.724l-2.553 2.553c-0.191 0.191-0.448 0.297-0.724 0.297-0.165 0-0.323-0.038-0.464-0.109l-1.021 1.021c0.435 0.335 0.96 0.502 1.485 0.502 0.625 0 1.25-0.237 1.724-0.711l2.553-2.553c0.948-0.948 0.948-2.499 0-3.447zM3.646 4.354l-3-3 0.707-0.707 3 3zM6 0h1v3h-1zM0 6h3v1h-3zM12.354 11.646l3 3-0.707 0.707-3-3zM9 13h1v3h-1zM13 9h3v1h-3z" })
        );
    }
    function Unlink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Unlink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Unlink2.SVG = Unlink2SVG;
    return Unlink2;
})();
export const Link3 = /*#__PURE__*/ (() => {
        function Link3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 16c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5c0.552 0 1 0.448 1 1s-0.448 1-1 1c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 2.481-2.019 4.5-4.5 4.5z" }),
_('path', { d: "M11.5 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5-2.5 1.122-2.5 2.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5z" }),
_('path', { d: "M6 11c-0.256 0-0.512-0.098-0.707-0.293-0.391-0.39-0.391-1.024 0-1.414l4-4c0.39-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-4 4c-0.195 0.195-0.451 0.293-0.707 0.293z" })
            );
        }
        function Link3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Link3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link3.SVG = Link3SVG;
        return Link3;
    })();
export const Unlink3 = /*#__PURE__*/ (() => {
        function Unlink3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.5 16c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5c0.552 0 1 0.448 1 1s-0.448 1-1 1c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 2.481-2.019 4.5-4.5 4.5z" }),
_('path', { d: "M11.5 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5-2.5 1.122-2.5 2.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5z" }),
_('path', { d: "M3.5 4c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2 2c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M5.5 3c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M2.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 15c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2 2c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M15.5 11h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 16c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Unlink3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlink3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink3.SVG = Unlink3SVG;
        return Unlink3;
    })();
export const Link4 = /*#__PURE__*/ (() => {
        function Link4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.586 10.086l-3.365 3.365c-0.354 0.354-0.829 0.549-1.337 0.549s-0.982-0.195-1.335-0.548c-0.354-0.354-0.548-0.828-0.548-1.336s0.195-0.983 0.549-1.337l3.365-3.365-1.414-1.414-3.365 3.365c-1.513 1.513-1.514 3.989-0.001 5.501 0.756 0.756 1.753 1.134 2.75 1.134s1.995-0.378 2.752-1.135l3.365-3.365-1.414-1.414z" }),
_('path', { d: "M10.086 8.586l3.365-3.365c0.354-0.354 0.549-0.829 0.549-1.337s-0.195-0.982-0.548-1.335c-0.354-0.354-0.828-0.548-1.336-0.548s-0.983 0.195-1.337 0.549l-3.365 3.365-1.414-1.414 3.365-3.365c1.513-1.513 3.989-1.514 5.501-0.001 0.756 0.756 1.134 1.753 1.134 2.75s-0.378 1.995-1.135 2.752l-3.365 3.365-1.414-1.414z" }),
_('path', { d: "M6.5 10.5l-1-1 4-4 1 1-4 4z" })
            );
        }
        function Link4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Link4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link4.SVG = Link4SVG;
        return Link4;
    })();
export const Unlink4 = /*#__PURE__*/ (() => {
        function Unlink4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.086 10.586l-2.865 2.865c-0.354 0.354-0.829 0.549-1.337 0.549s-0.982-0.195-1.335-0.548c-0.354-0.354-0.548-0.828-0.548-1.336s0.195-0.983 0.549-1.337l2.865-2.865-1.414-1.414-2.865 2.865c-1.513 1.513-1.514 3.989-0.001 5.501 0.756 0.756 1.753 1.134 2.75 1.134s1.995-0.378 2.752-1.135l2.865-2.865-1.414-1.414z" }),
_('path', { d: "M10.586 8.086l2.865-2.865c0.354-0.354 0.549-0.829 0.549-1.337s-0.195-0.982-0.548-1.335c-0.354-0.354-0.828-0.548-1.336-0.548s-0.983 0.195-1.337 0.549l-2.865 2.865-1.414-1.414 2.865-2.865c1.513-1.513 3.989-1.514 5.501-0.001 0.756 0.756 1.134 1.753 1.134 2.75s-0.378 1.995-1.135 2.752l-2.865 2.865-1.414-1.414z" }),
_('path', { d: "M13 10h3v1h-3v-1z" }),
_('path', { d: "M10 13h1v3h-1v-3z" }),
_('path', { d: "M5 0h1v3h-1v-3z" }),
_('path', { d: "M0 5h3v1h-3v-1z" }),
_('path', { d: "M12.604 11.896l2.75 2.75-0.707 0.707-2.75-2.75 0.707-0.707z" }),
_('path', { d: "M1.354 0.646l2.75 2.75-0.707 0.707-2.75-2.75 0.707-0.707z" })
            );
        }
        function Unlink4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlink4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink4.SVG = Unlink4SVG;
        return Unlink4;
    })();
export const Link5 = /*#__PURE__*/ (() => {
        function Link5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 12h-3c-2.206 0-4-1.794-4-4s1.794-4 4-4h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-3c-1.103 0-2 0.897-2 2s0.897 2 2 2h3c0.552 0 1 0.448 1 1s-0.448 1-1 1z" }),
_('path', { d: "M13 12h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3c1.103 0 2-0.897 2-2s-0.897-2-2-2h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M11 9h-5c-0.552 0-1-0.448-1-1s0.448-1 1-1h5c0.552 0 1 0.448 1 1s-0.448 1-1 1z" })
            );
        }
        function Link5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Link5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Link5.SVG = Link5SVG;
        return Link5;
    })();
export const Unlink5 = /*#__PURE__*/ (() => {
        function Unlink5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 12h-3c-2.206 0-4-1.794-4-4s1.794-4 4-4h3c0.552 0 1 0.448 1 1s-0.448 1-1 1h-3c-1.103 0-2 0.897-2 2s0.897 2 2 2h3c0.552 0 1 0.448 1 1s-0.448 1-1 1z" }),
_('path', { d: "M13 12h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3c1.103 0 2-0.897 2-2s-0.897-2-2-2h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3c2.206 0 4 1.794 4 4s-1.794 4-4 4z" }),
_('path', { d: "M8.5 3c-0.276 0-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 3c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l2-2c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-2 2c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M5.5 3c-0.128 0-0.256-0.049-0.354-0.146l-2-2c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l2 2c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M8.5 13c0.276 0 0.5 0.224 0.5 0.5v2c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2c0-0.276 0.224-0.5 0.5-0.5z" }),
_('path', { d: "M5.5 13c0.128 0 0.256 0.049 0.354 0.146 0.195 0.195 0.195 0.512 0 0.707l-2 2c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l2-2c0.098-0.098 0.226-0.146 0.354-0.146z" }),
_('path', { d: "M11.5 13c0.128 0 0.256 0.049 0.354 0.146l2 2c0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0l-2-2c-0.195-0.195-0.195-0.512 0-0.707 0.098-0.098 0.226-0.146 0.354-0.146z" })
            );
        }
        function Unlink5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Unlink5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unlink5.SVG = Unlink5SVG;
        return Unlink5;
    })();
export const Anchor = /*#__PURE__*/ (() => {
    function AnchorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9v2.066c-1.258 1.285-3.016 2.526-5 2.852v-5.917h3v-1l-3-1.171c1.165-0.412 2-1.523 2-2.829 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.306 0.835 2.417 2 2.829v0l-3 1.171v1h3v5.917c-1.984-0.326-3.742-1.567-5-2.852v-2.066h-2v1c0 2 4 6 8 6s8-4 8-6v-1h-2zM9 3c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1c0.552 0 1 0.448 1 1z" })
        );
    }
    function Anchor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AnchorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Anchor.SVG = AnchorSVG;
    return Anchor;
})();
export const Flag = /*#__PURE__*/ (() => {
        function FlagSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M13 10.047c1.291 0 2.415-0.312 3-0.773v-8c-0.585 0.461-1.709 0.773-3 0.773s-2.415-0.312-3-0.773v8c0.585 0.461 1.709 0.773 3 0.773z" }),
_('path', { d: "M9.5 0.508c-0.733-0.312-1.805-0.508-3-0.508-1.506 0-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 1.195 0 2.267 0.197 3 0.508v-8z" })
            );
        }
        function Flag({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FlagSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag.SVG = FlagSVG;
        return Flag;
    })();
export const Flag2 = /*#__PURE__*/ (() => {
        function Flag2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M12.5 2.047c-0.946 0-1.815-0.123-2.5-0.329v-0.944c-0.682-0.461-1.994-0.773-3.5-0.773s-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 0.946 0 1.815 0.123 2.5 0.329v0.944c0.682 0.461 1.994 0.773 3.5 0.773s2.818-0.312 3.5-0.773v-8c-0.682 0.461-1.994 0.773-3.5 0.773zM9.5 6.359v1.076l-0.212-0.064c-0.808-0.243-1.772-0.372-2.788-0.372-0.903 0-1.763 0.104-2.5 0.293v-5.964c0.685-0.206 1.554-0.329 2.5-0.329 1.195 0 2.267 0.197 3 0.508v4.851zM15 8.663c-0.557 0.213-1.434 0.384-2.5 0.384s-1.943-0.172-2.5-0.384v-5.907c0.745 0.191 1.602 0.292 2.5 0.292 0.903 0 1.763-0.104 2.5-0.293v5.909z" })
            );
        }
        function Flag2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flag2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag2.SVG = Flag2SVG;
        return Flag2;
    })();
export const Flag3 = /*#__PURE__*/ (() => {
        function Flag3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5z" })
            );
        }
        function Flag3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flag3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag3.SVG = Flag3SVG;
        return Flag3;
    })();
export const Flag4 = /*#__PURE__*/ (() => {
        function Flag4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M10 1c-0.5 0-0.75-0.25-1-0.5s-0.5-0.5-1-0.5h-5v10h5c0.5 0 0.75 0.25 1 0.5s0.5 0.5 1 0.5h5v-10h-5zM4 9v-8h4c0.078 0 0.086 0 0.293 0.207 0.056 0.056 0.12 0.119 0.191 0.185v7.658c-0.147-0.032-0.308-0.051-0.484-0.051h-4zM14 10h-4c-0.078 0-0.086 0-0.293-0.207-0.163-0.163-0.387-0.386-0.707-0.555v-7.476c0.262 0.138 0.589 0.238 1 0.238h4v8z" })
            );
        }
        function Flag4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flag4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag4.SVG = Flag4SVG;
        return Flag4;
    })();
export const Flag5 = /*#__PURE__*/ (() => {
    function Flag5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.939 1.907c-1.506-1.789-2.647-1.907-4.939-1.907v8c4.008-2 4.457 0.26 6.985 0.032 2.492-0.226 4.61-2.143 6.015-4.032-3.98 0.92-5.983 0.376-8.061-2.093zM0 0h2v16h-2z" })
        );
    }
    function Flag5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flag5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag5.SVG = Flag5SVG;
    return Flag5;
})();
export const Flag6 = /*#__PURE__*/ (() => {
    function Flag6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1.016c0.606 0.025 1.053 0.084 1.449 0.216 0.599 0.199 1.115 0.594 1.725 1.319 1.693 2.011 3.404 2.87 5.722 2.87 0.242 0 0.493-0.010 0.755-0.029-0.315 0.371-0.647 0.733-0.992 1.064-0.483 0.464-0.953 0.829-1.398 1.084-0.468 0.269-0.923 0.425-1.352 0.464-0.057 0.005-0.11 0.008-0.165 0.008-0.526 0-0.93-0.244-1.545-0.643-0.705-0.457-1.583-1.025-2.861-1.025-0.428 0-0.872 0.064-1.339 0.193v-5.52zM3 0v8c0.956-0.477 1.711-0.657 2.339-0.657 1.917 0 2.668 1.668 4.406 1.668 0.083 0 0.167-0.004 0.255-0.012 2.492-0.226 4.595-3.111 6-5-1.194 0.276-2.21 0.42-3.104 0.42-2.085 0-3.503-0.785-4.957-2.513-1.506-1.789-2.647-1.907-4.939-1.907v0zM0 0h2v16h-2z" })
        );
    }
    function Flag6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flag6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flag6.SVG = Flag6SVG;
    return Flag6;
})();
export const Flag7 = /*#__PURE__*/ (() => {
        function Flag7SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M3 1v8h12.5l-4-4 4-4z" })
            );
        }
        function Flag7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flag7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag7.SVG = Flag7SVG;
        return Flag7;
    })();
export const Flag8 = /*#__PURE__*/ (() => {
        function Flag8SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0h2v16h-2v-16z" }),
_('path', { d: "M14.512 9c-0-0-0-0-0.001 0h-11.012c-0.276 0-0.5-0.224-0.5-0.5v-7c0-0.276 0.224-0.5 0.5-0.5h11.012c0.202 0 0.385 0.122 0.462 0.309s0.035 0.402-0.108 0.545l-3.146 3.146 3.132 3.132c0.099 0.091 0.162 0.223 0.162 0.368 0 0.276-0.224 0.5-0.5 0.5zM4 8h9.305l-2.646-2.646c-0.195-0.195-0.195-0.512 0-0.707l2.646-2.646h-9.305v6z" })
            );
        }
        function Flag8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Flag8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Flag8.SVG = Flag8SVG;
        return Flag8;
    })();
export const Attachment = /*#__PURE__*/ (() => {
    function AttachmentSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z" })
        );
    }
    function Attachment({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AttachmentSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Attachment.SVG = AttachmentSVG;
    return Attachment;
})();
export const Attachment2 = /*#__PURE__*/ (() => {
    function Attachment2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 4h-9c-2.209 0-4 1.791-4 4s1.791 4 4 4h9v-1h-9c-1.657 0-3-1.343-3-3s1.343-3 3-3h9c1.105 0 2 0.895 2 2s-0.895 2-2 2h-7c-0.552 0-1-0.448-1-1s0.448-1 1-1h7v-1h-7c-1.105 0-2 0.895-2 2s0.895 2 2 2h7c1.657 0 3-1.343 3-3s-1.343-3-3-3z" })
        );
    }
    function Attachment2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Attachment2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Attachment2.SVG = Attachment2SVG;
    return Attachment2;
})();
export const Eye = /*#__PURE__*/ (() => {
    function EyeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z" })
        );
    }
    function Eye({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye.SVG = EyeSVG;
    return Eye;
})();
export const EyePlus = /*#__PURE__*/ (() => {
        function EyePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z" }),
_('path', { d: "M13.498 6.969c0.288 0.32 0.55 0.665 0.782 1.031-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.011-0-0.022-0-0.032-1.708-0.44-2.973-1.979-2.999-3.817-0.329-0.037-0.662-0.057-1.001-0.057-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.276-0.55-0.604-1.069-0.979-1.548-0.457 0.268-0.973 0.449-1.523 0.517zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z" })
            );
        }
        function EyePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyePlus.SVG = EyePlusSVG;
        return EyePlus;
    })();
export const EyeMinus = /*#__PURE__*/ (() => {
        function EyeMinusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 2h6v2h-6v-2z" }),
_('path', { d: "M13.599 5h-4.599v-1.944c-0.328-0.037-0.662-0.056-1-0.056-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.584-1.167-1.407-2.189-2.401-3zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM11.944 10.348c-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348z" })
            );
        }
        function EyeMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeMinus.SVG = EyeMinusSVG;
        return EyeMinus;
    })();
export const EyeBlocked = /*#__PURE__*/ (() => {
        function EyeBlockedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z" }),
_('path', { d: "M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z" }),
_('path', { d: "M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z" })
            );
        }
        function EyeBlocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EyeBlockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        EyeBlocked.SVG = EyeBlockedSVG;
        return EyeBlocked;
    })();
export const Eye2 = /*#__PURE__*/ (() => {
    function Eye2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3.5c-4 0-8 3.5-8 4.5v0c0 1 4 4.5 8 4.5s8-3.5 8-4.5v0c-0-1-4-4.5-8-4.5zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3c1.657 0 3 1.343 3 3s-1.343 3-3 3zM6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z" })
        );
    }
    function Eye2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eye2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye2.SVG = Eye2SVG;
    return Eye2;
})();
export const EyeBlocked2 = /*#__PURE__*/ (() => {
    function EyeBlocked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 10c1.105 0 2-0.895 2-2 0-0.426-0.133-0.82-0.36-1.145l4.74-5.53-0.759-0.651-4.74 5.53c-0.266-0.131-0.565-0.204-0.881-0.204-1.105 0-2 0.895-2 2 0 0.426 0.133 0.82 0.36 1.145l-4.74 5.53 0.759 0.651 4.74-5.53c0.266 0.131 0.565 0.204 0.881 0.204zM5.17 8.997c-0.11-0.312-0.17-0.647-0.17-0.997 0-1.657 1.343-3 3-3 0.189 0 0.373 0.018 0.552 0.051l1.159-1.352c-0.562-0.127-1.137-0.199-1.711-0.199-4 0-8 3.5-8 4.5 0 0.588 1.383 2.040 3.336 3.137l1.834-2.14zM12.664 4.863l-1.834 2.14c0.11 0.312 0.17 0.647 0.17 0.997 0 1.657-1.343 3-3 3-0.189 0-0.373-0.018-0.552-0.051l-1.159 1.352c0.562 0.127 1.137 0.199 1.711 0.199 4 0 8-3.5 8-4.5-0-0.588-1.383-2.040-3.336-3.137z" })
        );
    }
    function EyeBlocked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyeBlocked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    EyeBlocked2.SVG = EyeBlocked2SVG;
    return EyeBlocked2;
})();
export const Eye3 = /*#__PURE__*/ (() => {
    function Eye3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 12.797c-2.315 0-4.376-1.134-5.398-1.811-0.685-0.453-1.315-0.972-1.775-1.461-0.556-0.591-0.827-1.090-0.827-1.526s0.27-0.934 0.827-1.526c0.46-0.489 1.090-1.007 1.775-1.461 1.022-0.676 3.083-1.811 5.398-1.811s4.376 1.134 5.398 1.811c0.685 0.453 1.315 0.972 1.775 1.461 0.556 0.591 0.827 1.090 0.827 1.525s-0.27 0.934-0.827 1.526c-0.46 0.489-1.090 1.007-1.775 1.461-1.022 0.676-3.083 1.811-5.398 1.811zM1.526 8c0.172 0.317 0.883 1.093 2.095 1.858 0.85 0.537 2.549 1.438 4.38 1.438s3.53-0.901 4.38-1.438c1.212-0.766 1.922-1.541 2.095-1.858-0.172-0.317-0.883-1.093-2.095-1.858-0.85-0.537-2.549-1.438-4.38-1.438s-3.53 0.901-4.38 1.438c-1.212 0.766-1.922 1.541-2.095 1.858zM6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z" })
        );
    }
    function Eye3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eye3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye3.SVG = Eye3SVG;
    return Eye3;
})();
export const EyeBlocked3 = /*#__PURE__*/ (() => {
    function EyeBlocked3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.905 11.18c-0.109-0.068-0.211-0.133-0.303-0.194-0.685-0.453-1.315-0.972-1.775-1.461-0.556-0.591-0.827-1.090-0.827-1.526s0.27-0.934 0.827-1.526c0.46-0.489 1.090-1.007 1.775-1.461 1.022-0.676 3.083-1.811 5.398-1.811 0.197 0 0.392 0.009 0.586 0.024l-1.069 1.496c-1.642 0.137-3.122 0.928-3.897 1.418-1.212 0.766-1.922 1.542-2.095 1.858 0.172 0.317 0.883 1.093 2.095 1.858 0.050 0.032 0.103 0.065 0.159 0.098l-0.874 1.223zM15.173 6.474c-0.46-0.489-1.090-1.007-1.775-1.461-0.51-0.338-1.279-0.789-2.209-1.156l1.794-2.512-0.966-0.69-10 14 0.966 0.69 2.19-3.066c0.85 0.301 1.814 0.518 2.827 0.518 2.315 0 4.376-1.134 5.398-1.811 0.685-0.453 1.315-0.972 1.775-1.461 0.556-0.591 0.827-1.090 0.827-1.526s-0.27-0.934-0.827-1.526zM12.38 9.858c-0.85 0.537-2.549 1.438-4.38 1.438-0.667 0-1.316-0.12-1.913-0.298l0.907-1.27c0.295 0.172 0.639 0.271 1.005 0.271 1.105 0 2-0.895 2-2 0-0.604-0.268-1.145-0.691-1.511l0.977-1.367c0.88 0.307 1.619 0.72 2.094 1.020 1.212 0.766 1.922 1.541 2.095 1.858-0.172 0.317-0.883 1.093-2.095 1.858z" })
        );
    }
    function EyeBlocked3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EyeBlocked3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    EyeBlocked3.SVG = EyeBlocked3SVG;
    return EyeBlocked3;
})();
export const Eye4 = /*#__PURE__*/ (() => {
    function Eye4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 5c-3.271 0-6.176 1.571-8 4 1.824 2.429 4.729 4 8 4s6.176-1.571 8-4c-1.824-2.429-4.729-4-8-4zM7 7c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12.088 11.020c-0.62 0.317-1.276 0.56-1.951 0.725-0.695 0.169-1.414 0.255-2.137 0.255s-1.442-0.086-2.137-0.255c-0.675-0.164-1.331-0.408-1.951-0.725-0.985-0.503-1.878-1.194-2.619-2.020 0.741-0.826 1.635-1.517 2.619-2.020 0.505-0.258 1.035-0.468 1.579-0.626-0.311 0.473-0.492 1.038-0.492 1.646 0 1.657 1.343 3 3 3s3-1.343 3-3c0-0.608-0.181-1.173-0.492-1.646 0.544 0.158 1.074 0.367 1.579 0.626 0.985 0.503 1.878 1.194 2.619 2.020-0.741 0.826-1.635 1.517-2.619 2.020zM13.452 3.808c-1.699-0.868-3.533-1.308-5.452-1.308s-3.753 0.44-5.452 1.308c-0.918 0.469-1.777 1.061-2.548 1.751v1.706c0.865-0.915 1.886-1.684 3.003-2.255 1.557-0.795 3.238-1.199 4.997-1.199s3.44 0.403 4.997 1.199c1.117 0.571 2.138 1.339 3.003 2.255v-1.706c-0.771-0.69-1.63-1.282-2.548-1.751z" })
        );
    }
    function Eye4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Eye4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eye4.SVG = Eye4SVG;
    return Eye4;
})();
export const Bookmark2 = /*#__PURE__*/ (() => {
    function Bookmark2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 0v16l5-5 5 5v-16z" })
        );
    }
    function Bookmark2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bookmark2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bookmark2.SVG = Bookmark2SVG;
    return Bookmark2;
})();
export const Bookmark3 = /*#__PURE__*/ (() => {
    function Bookmark3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 0v16l5-5 5 5v-16h-10zM12 13.586l-4-4-4 4v-12.586h8v12.586z" })
        );
    }
    function Bookmark3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bookmark3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bookmark3.SVG = Bookmark3SVG;
    return Bookmark3;
})();
export const Bookmarks = /*#__PURE__*/ (() => {
    function BookmarksSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 2v14l5-5 5 5v-14zM12 0h-10v14l1-1v-12h9z" })
        );
    }
    function Bookmarks({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BookmarksSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bookmarks.SVG = BookmarksSVG;
    return Bookmarks;
})();
export const Bookmark4 = /*#__PURE__*/ (() => {
    function Bookmark4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.059 0h-12.059v14l1 2h12v-14.118l-0.941-1.882zM12.441 1l0.5 1h-2.941l-0.5-1h2.941zM2 1h3.5l0.5 1h-3.5l-0.5-1zM13 15h-10v-12h3v6l2-2 2 2v-6h3v12z" })
        );
    }
    function Bookmark4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bookmark4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bookmark4.SVG = Bookmark4SVG;
    return Bookmark4;
})();
export const Spotlight2 = /*#__PURE__*/ (() => {
    function Spotlight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.582 13.736c0 0 0 0 0 0l-0.11-0.111h-0.035c-0.132-0.092-0.284-0.175-0.453-0.25h0.241l-0.247-0.25h-0.777c-0.368-0.080-0.774-0.125-1.2-0.125s-0.833 0.045-1.201 0.125c0-0 0-0 0-0h-2.652l0.136 0.25h1.732c0 0 0-0 0-0-0.169 0.075-0.321 0.158-0.453 0.25 0 0 0-0 0-0h-1.143l0.136 0.25h0.716c0-0 0-0 0-0-0.073 0.080-0.133 0.164-0.178 0.25 0-0 0-0 0-0h-0.402l0.136 0.25h0.182c0-0 0-0 0-0-0.007 0.041-0.011 0.083-0.011 0.125s0.004 0.084 0.010 0.125h-0.045l0.094 0.173 0-0c0.276 0.686 1.488 1.202 2.941 1.202 1.657 0 3-0.672 3-1.5 0-0.279-0.153-0.541-0.418-0.764zM10.336 13.81c0 0-0 0-0 0s0-0 0-0zM10.043 14.246c-0.001 0.002-0.001 0.004-0.002 0.006 0.001-0.002 0.001-0.004 0.002-0.006zM10.068 14.181c-0.001 0.003-0.002 0.006-0.004 0.008 0.001-0.003 0.002-0.006 0.004-0.008zM10.043 14.752c0.001 0.001 0.001 0.003 0.001 0.004-0-0.001-0.001-0.003-0.001-0.004zM10.019 14.669c0 0 0 0.001 0 0.001s-0-0-0-0.001zM10.029 14.71c0 0.001 0.001 0.002 0.001 0.004-0-0.001-0.001-0.002-0.001-0.004zM5.6 13.125c-0.49-0.080-1.031-0.125-1.6-0.125s-1.11 0.045-1.6 0.125h-1.246l-0.264 0.25h0.465c0.001-0 0.001-0 0.002-0.001-0.226 0.075-0.429 0.159-0.605 0.251h-0.125l-0.264 0.25h0.001c-0.233 0.19-0.363 0.402-0.363 0.625 0 0.828 1.791 1.5 4 1.5 2.034 0 3.713-0.569 3.967-1.306l0.001 0 0.033-0.069h-0.014c0.009-0.041 0.014-0.083 0.014-0.125s-0.005-0.084-0.014-0.125c0 0 0 0 0 0h0.134l0.12-0.25h-0.366c-0.059-0.087-0.139-0.17-0.237-0.25h0.722l0.12-0.25h-1.23c0 0 0 0 0 0-0.176-0.092-0.378-0.175-0.604-0.25h1.953l0.12-0.25h-3.118c-0 0 0 0 0 0zM7.914 14.189c-0.002-0.003-0.003-0.006-0.005-0.008 0.002 0.003 0.003 0.006 0.005 0.008zM7.945 14.252c-0.001-0.002-0.002-0.004-0.003-0.006 0.001 0.002 0.002 0.004 0.003 0.006zM7.304 13.655v0 0zM13.504 3.125h-1.801l-0.264 0.25h1.945zM13.265 3.625h-2.089l-0.264 0.25h2.233zM13.983 2.125h-1.225l-0.264 0.25h1.369zM13.744 2.625h-1.513l-0.264 0.25h1.657zM14.222 1.625h-0.937l-0.264 0.25h1.081zM14.462 1.125h-0.648l-0.264 0.25h0.793zM14.94 0.125h-0.072l-0.264 0.25h0.216zM14.701 0.625h-0.36l-0.264 0.25h0.504zM12.786 4.625h-2.666l-0.264 0.25h2.81zM13.026 4.125h-2.378l-0.264 0.25h2.522zM12.308 5.625h-3.242l-0.264 0.25h3.386zM12.547 5.125h-2.954l-0.264 0.25h3.098zM14.731 12.875l-0.247-0.25h-5.526l0.12-0.25h5.159l-0.247-0.25h-4.792l0.12-0.25h4.425l-0.247-0.25h-4.058l0.12-0.25h3.691l-0.247-0.25h-3.325l0.12-0.25h2.958l-0.247-0.25h-2.591l0.12-0.25h2.224l-0.247-0.25h-1.857l0.12-0.25h1.49l-0.247-0.25h-1.124l0.12-0.25h0.757l-0.247-0.25h-0.39l0.12-0.25h0.023l-0.016-0.016 0.112-0.234h-0.344l-0.247-0.25h0.711l0.12-0.25h-1.077l-0.247-0.25h1.444l0.12-0.25h-1.811l-0.247-0.25h2.178l0.12-0.25h-2.545l-0.247-0.25h2.912l0.12-0.25h-3.279l-0.247-0.25h3.645l0.12-0.25h-3.53l-0.249 0.236-0.233-0.236h-2.721l0.136 0.25h2.803l-0.264 0.25h-2.403l0.136 0.25h2.003l-0.264 0.25h-1.603l0.136 0.25h1.203l-0.264 0.25h-0.803l0.136 0.25h0.403l-0.264 0.25h-0.003l0.001 0.002-0.262 0.248h0.397l0.136 0.25h-0.796l-0.264 0.25h1.196l0.136 0.25h-1.596l-0.264 0.25h1.996l0.136 0.25h-2.396l-0.264 0.25h2.796l0.136 0.25h-3.196l-0.264 0.25h3.596l0.136 0.25h-3.996l-0.264 0.25h4.396l0.136 0.25h-4.795l-0.264 0.25h5.195l0.136 0.25h-5.595l-0.264 0.25h5.995l0.136 0.25h-6.395l-0.264 0.25h6.795l0.136 0.25h-7.195l-0.264 0.25h7.421l0.081-0.17 0.093 0.17zM3.566 2.875h1.277l-0.247-0.25h-1.166zM3.021 1.875h0.833l-0.247-0.25h-0.722zM3.293 2.375h1.055l-0.247-0.25h-0.944zM2.749 1.375h0.611l-0.247-0.25h-0.5zM2.371 0.375l-0.247-0.25h-0.055l0.136 0.25zM4.11 3.875h1.721l-0.247-0.25h-1.61zM2.477 0.875h0.389l-0.247-0.25h-0.278zM3.838 3.375h1.499l-0.247-0.25h-1.388zM4.655 4.875h2.165l-0.247-0.25h-2.054zM4.383 4.375h1.943l-0.247-0.25h-1.832zM4.927 5.375h2.387l-0.247-0.25h-2.276zM5.2 5.875h2.609l-0.247-0.25h-2.498z" })
        );
    }
    function Spotlight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Spotlight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spotlight2.SVG = Spotlight2SVG;
    return Spotlight2;
})();
export const Starburst = /*#__PURE__*/ (() => {
    function StarburstSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1.25l1.267-1.25 0.819 1.581 1.591-0.798 0.29 1.756 1.76-0.267-0.267 1.76 1.756 0.29-0.797 1.591 1.581 0.819-1.25 1.267 1.25 1.267-1.581 0.819 0.797 1.591-1.756 0.29 0.267 1.76-1.76-0.267-0.29 1.756-1.591-0.798-0.819 1.581-1.267-1.25-1.267 1.25-0.819-1.581-1.591 0.798-0.29-1.756-1.76 0.267 0.267-1.76-1.756-0.29 0.797-1.591-1.581-0.819 1.25-1.267-1.25-1.267 1.581-0.819-0.797-1.591 1.756-0.29-0.267-1.76 1.76 0.267 0.29-1.756 1.591 0.798 0.819-1.581z" })
        );
    }
    function Starburst({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarburstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Starburst.SVG = StarburstSVG;
    return Starburst;
})();
export const Snowflake = /*#__PURE__*/ (() => {
    function SnowflakeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.31 11.339l-1.727-0.997 1.499-0.863-0.757-1.315-2.261 1.301-2.547-1.47 2.537-1.465 2.271 1.307 0.757-1.315-1.509-0.868 1.732-1-0.759-1.314-1.727 0.997 0.002-1.73-1.518-0.002-0.004 2.609-2.547 1.47v-2.929l2.267-1.313-0.761-1.313-1.507 0.873v-2h-1.518v1.994l-1.497-0.867-0.761 1.313 2.257 1.308v2.941l-2.537-1.465-0.004-2.62-1.518 0.002 0.002 1.741-1.732-1-0.759 1.314 1.727 0.997-1.499 0.863 0.757 1.315 2.261-1.301 2.547 1.47-2.537 1.465-2.271-1.307-0.757 1.315 1.509 0.868-1.732 1 0.759 1.314 1.727-0.997-0.002 1.73 1.518 0.002 0.004-2.609 2.547-1.47v2.929l-2.267 1.313 0.761 1.313 1.507-0.873v2h1.518v-1.994l1.497 0.867 0.761-1.313-2.257-1.308v-2.941l2.537 1.465 0.004 2.62 1.518-0.002-0.002-1.741 1.732 1z" })
        );
    }
    function Snowflake({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SnowflakeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Snowflake.SVG = SnowflakeSVG;
    return Snowflake;
})();
export const Temperature = /*#__PURE__*/ (() => {
        function TemperatureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 10.268v-6.268c0-0.552-0.448-1-1-1s-1 0.448-1 1v6.268c-0.598 0.346-1 0.992-1 1.732 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.74-0.402-1.386-1-1.732z" }),
_('path', { d: "M5 16c-2.206 0-4-1.794-4-4 0-0.983 0.354-1.915 1-2.646v-6.354c0-1.654 1.346-3 3-3s3 1.346 3 3l0 6.354c0.646 0.731 1 1.663 1 2.646 0 2.206-1.794 4-4 4zM5 1c-1.103 0-2 0.897-2 2v6.551c0 0.131-0.051 0.257-0.143 0.35-0.553 0.564-0.857 1.31-0.857 2.1 0 1.654 1.346 3 3 3s3-1.346 3-3c0-0.79-0.304-1.535-0.857-2.1-0.092-0.093-0.143-0.219-0.143-0.35l-0-6.551c0-1.103-0.897-2-2-2z" }),
_('path', { d: "M14.5 2h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M13.5 4h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 6h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M13.5 8h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 10h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Temperature({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TemperatureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Temperature.SVG = TemperatureSVG;
        return Temperature;
    })();
export const Temperature2 = /*#__PURE__*/ (() => {
        function Temperature2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.5 2h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 4h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 6h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 8h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 10h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.143 9.9c-0.092-0.093-0.143-0.219-0.143-0.35l-0-7.551c0-1.103-0.897-2-2-2s-2 0.897-2 2v7.551c0 0.131-0.051 0.257-0.143 0.35-0.553 0.564-0.857 1.31-0.857 2.1 0 1.654 1.346 3 3 3s3-1.346 3-3c0-0.79-0.304-1.535-0.857-2.1zM5 1c0.551 0 1 0.449 1 1v3h-2v-3c0-0.551 0.449-1 1-1z" })
            );
        }
        function Temperature2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Temperature2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Temperature2.SVG = Temperature2SVG;
        return Temperature2;
    })();
export const WeatherLightning = /*#__PURE__*/ (() => {
    function WeatherLightningSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.922 4.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h2.586l0.667-2h5.339l-1 2 2.663-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM10 9h-3l-1 3h2l-1 3 4-4h-2z" })
        );
    }
    function WeatherLightning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeatherLightningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeatherLightning.SVG = WeatherLightningSVG;
    return WeatherLightning;
})();
export const WeatherLightning2 = /*#__PURE__*/ (() => {
        function WeatherLightning2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 3c-0.385 0-0.761 0.054-1.12 0.158-0.366-1.251-1.526-2.158-2.88-2.158-1.335 0-2.469 0.876-2.857 2.084-0.209-0.055-0.425-0.084-0.643-0.084-1.378 0-2.5 1.122-2.5 2.5 0 0.182 0.020 0.363 0.059 0.54-1.169 0.209-2.059 1.232-2.059 2.46 0 1.379 1.121 2.5 2.5 2.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-3c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.414c-0.056-0.16-0.086-0.329-0.086-0.5 0-0.827 0.673-1.5 1.5-1.5 0.172 0 0.341 0.030 0.501 0.086 0.005 0.174 0.025 0.348 0.060 0.518 0.048 0.237 0.257 0.4 0.489 0.4 0.033 0 0.067-0.003 0.101-0.010 0.271-0.055 0.445-0.32 0.39-0.59-0.027-0.132-0.041-0.268-0.041-0.404 0-1.103 0.897-2 2-2 0.947 0 1.751 0.665 1.952 1.562-0.292 0.175-0.564 0.388-0.809 0.638-0.193 0.197-0.19 0.514 0.007 0.707s0.514 0.19 0.707-0.007c0.569-0.581 1.33-0.9 2.143-0.9 1.654 0 3 1.346 3 3 0 0.801-0.312 1.555-0.879 2.121s-1.32 0.879-2.121 0.879h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c1.068 0 2.073-0.416 2.828-1.172s1.172-1.76 1.172-2.828c0-2.206-1.794-4-4-4z" }),
_('path', { d: "M8.5 15c-0.052 0-0.106-0.008-0.158-0.026-0.262-0.087-0.404-0.37-0.316-0.632l0.781-2.342h-1.306c-0.161 0-0.312-0.077-0.406-0.208s-0.12-0.298-0.069-0.45l1-3c0.087-0.262 0.37-0.404 0.632-0.316s0.404 0.37 0.316 0.632l-0.781 2.342h1.306c0.161 0 0.312 0.077 0.406 0.208s0.12 0.298 0.069 0.45l-1 3c-0.070 0.21-0.265 0.342-0.474 0.342z" })
            );
        }
        function WeatherLightning2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherLightning2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherLightning2.SVG = WeatherLightning2SVG;
        return WeatherLightning2;
    })();
export const WeatherRain = /*#__PURE__*/ (() => {
        function WeatherRainSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.922 4.626c1.192 0.29 2.078 1.365 2.078 2.648 0 1.504-1.217 2.723-2.719 2.726v0h-10.254c-1.672 0-3.027-1.356-3.027-3.029s1.355-3.029 3.027-3.029c0.184 0 0.365 0.017 0.54 0.049-0.014-0.097-0.021-0.196-0.021-0.296 0-1.154 0.935-2.089 2.088-2.089 0.672 0 1.27 0.318 1.652 0.812 0.681-0.863 1.735-1.418 2.92-1.418 2.022 0 3.666 1.615 3.717 3.626v0z" }),
_('path', { d: "M13.999 14.449c-0.004-0.13-0.025-0.255-0.060-0.374-0.282-1.147-1.438-3.075-1.438-3.075s-1.157 1.928-1.438 3.075c-0.035 0.119-0.056 0.244-0.060 0.374-0.001 0.017-0.001 0.035-0.001 0.051 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.017-0-0.034-0.001-0.051z" }),
_('path', { d: "M9.499 13.449c-0.004-0.13-0.025-0.255-0.060-0.374-0.282-1.147-1.438-3.075-1.438-3.075s-1.157 1.928-1.438 3.075c-0.035 0.119-0.056 0.244-0.060 0.374-0.001 0.017-0.001 0.035-0.001 0.051 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.017-0-0.034-0.001-0.051z" }),
_('path', { d: "M4.999 14.449c-0.004-0.13-0.025-0.255-0.060-0.374-0.282-1.147-1.438-3.075-1.438-3.075s-1.157 1.928-1.438 3.075c-0.035 0.119-0.056 0.244-0.060 0.374-0.001 0.017-0.001 0.035-0.001 0.051 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.017-0-0.034-0.001-0.051z" })
            );
        }
        function WeatherRain({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherRainSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherRain.SVG = WeatherRainSVG;
        return WeatherRain;
    })();
export const WeatherRain2 = /*#__PURE__*/ (() => {
        function WeatherRain2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 8.5c0 1.379 1.121 2.5 2.5 2.5h9.5c1.068 0 2.073-0.416 2.828-1.172s1.172-1.76 1.172-2.828c0-2.206-1.794-4-4-4-0.385 0-0.761 0.054-1.12 0.158-0.366-1.251-1.526-2.158-2.88-2.158-1.335 0-2.469 0.876-2.857 2.084-0.209-0.055-0.425-0.084-0.643-0.084-1.378 0-2.5 1.122-2.5 2.5 0 0.182 0.020 0.363 0.059 0.54-1.169 0.209-2.059 1.232-2.059 2.46zM1 8.5c0-0.827 0.673-1.5 1.5-1.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.414c-0.056-0.16-0.086-0.329-0.086-0.5 0-0.827 0.673-1.5 1.5-1.5 0.172 0 0.341 0.030 0.501 0.086 0.005 0.174 0.025 0.348 0.060 0.518 0.048 0.237 0.257 0.4 0.489 0.4 0.033 0 0.067-0.003 0.101-0.010 0.271-0.055 0.445-0.32 0.39-0.59-0.027-0.132-0.041-0.268-0.041-0.404 0-1.103 0.897-2 2-2 0.947 0 1.751 0.665 1.952 1.562-0.292 0.175-0.564 0.388-0.809 0.638-0.193 0.197-0.19 0.514 0.007 0.707s0.514 0.19 0.707-0.007c0.569-0.581 1.33-0.9 2.143-0.9 1.654 0 3 1.346 3 3 0 0.801-0.312 1.555-0.879 2.121s-1.32 0.879-2.121 0.879h-9.5c-0.827 0-1.5-0.673-1.5-1.5z" }),
_('path', { d: "M3.5 16c-0.827 0-1.5-0.673-1.5-1.5 0-0.264 0.070-0.523 0.201-0.751l0.866-1.499c0.089-0.155 0.254-0.25 0.433-0.25s0.344 0.095 0.433 0.25l0.866 1.5c0.131 0.227 0.201 0.486 0.201 0.75 0 0.827-0.673 1.5-1.5 1.5zM3.5 13.5l-0.433 0.75c-0.044 0.077-0.067 0.161-0.067 0.25 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.089-0.022-0.173-0.067-0.25l-0.433-0.75z" }),
_('path', { d: "M13.5 16c-0.827 0-1.5-0.673-1.5-1.5 0-0.264 0.070-0.523 0.201-0.751l0.866-1.499c0.089-0.155 0.254-0.25 0.433-0.25s0.344 0.095 0.433 0.25l0.866 1.5c0.131 0.227 0.201 0.486 0.201 0.75 0 0.827-0.673 1.5-1.5 1.5zM13.5 13.5l-0.433 0.75c-0.044 0.077-0.067 0.161-0.067 0.25 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.089-0.022-0.173-0.067-0.25l-0.433-0.75z" }),
_('path', { d: "M8.5 15c-0.827 0-1.5-0.673-1.5-1.5 0-0.264 0.070-0.523 0.201-0.751l0.866-1.499c0.089-0.155 0.254-0.25 0.433-0.25s0.344 0.095 0.433 0.25l0.866 1.5c0.131 0.227 0.201 0.486 0.201 0.75 0 0.827-0.673 1.5-1.5 1.5zM8.5 12.5l-0.433 0.75c-0.044 0.077-0.067 0.161-0.067 0.25 0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.089-0.022-0.173-0.067-0.25l-0.433-0.75z" })
            );
        }
        function WeatherRain2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherRain2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherRain2.SVG = WeatherRain2SVG;
        return WeatherRain2;
    })();
export const WeatherSnow = /*#__PURE__*/ (() => {
    function WeatherSnowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.922 4.626c1.192 0.29 2.078 1.365 2.078 2.648 0 1.504-1.217 2.723-2.719 2.726v0h-10.254c-1.672 0-3.027-1.356-3.027-3.029s1.355-3.029 3.027-3.029c0.184 0 0.365 0.017 0.54 0.049-0.014-0.097-0.021-0.196-0.021-0.296 0-1.154 0.935-2.089 2.088-2.089 0.672 0 1.27 0.318 1.652 0.812 0.681-0.863 1.735-1.418 2.92-1.418 2.022 0 3.666 1.615 3.717 3.626zM13.999 12.628c0.005 0.078-0.026 0.133-0.094 0.164l-1.732 0.709 1.732 0.715c0.067 0.027 0.098 0.079 0.094 0.157s-0.062 0.204-0.173 0.378c-0.11 0.178-0.2 0.287-0.27 0.328s-0.133 0.040-0.19 0l-1.531-1.036 0.201 1.751c0.014 0.067-0.017 0.118-0.094 0.154s-0.225 0.054-0.446 0.054c-0.22 0-0.369-0.018-0.445-0.054s-0.108-0.087-0.094-0.154l0.201-1.751-1.524 1.036c-0.057 0.040-0.122 0.040-0.194 0s-0.163-0.149-0.273-0.328c-0.111-0.174-0.167-0.3-0.169-0.378s0.030-0.13 0.097-0.157l1.732-0.715-1.732-0.709c-0.067-0.031-0.1-0.086-0.097-0.164s0.058-0.204 0.169-0.378c0.11-0.174 0.201-0.28 0.273-0.321s0.136-0.040 0.194 0l1.524 1.029-0.201-1.745c-0.014-0.071 0.017-0.125 0.094-0.16s0.225-0.054 0.445-0.054c0.22 0 0.369 0.018 0.446 0.054s0.108 0.089 0.094 0.16l-0.201 1.745 1.531-1.029c0.057-0.040 0.121-0.040 0.19 0s0.159 0.149 0.27 0.327c0.111 0.169 0.168 0.293 0.173 0.371zM7 12.628c0.005 0.078-0.026 0.133-0.093 0.164l-1.732 0.709 1.732 0.715c0.067 0.027 0.098 0.079 0.093 0.157s-0.062 0.204-0.173 0.378c-0.11 0.178-0.2 0.287-0.27 0.328s-0.133 0.040-0.19 0l-1.531-1.036 0.201 1.751c0.014 0.067-0.017 0.118-0.094 0.154s-0.225 0.054-0.446 0.054c-0.22 0-0.369-0.018-0.445-0.054s-0.108-0.087-0.094-0.154l0.201-1.751-1.524 1.036c-0.058 0.040-0.122 0.040-0.194 0s-0.163-0.149-0.273-0.328c-0.111-0.174-0.167-0.3-0.169-0.378s0.030-0.13 0.097-0.157l1.732-0.715-1.732-0.709c-0.067-0.031-0.1-0.086-0.097-0.164s0.058-0.204 0.169-0.378c0.11-0.174 0.201-0.28 0.273-0.321s0.136-0.040 0.194 0l1.524 1.029-0.201-1.745c-0.014-0.071 0.017-0.125 0.094-0.16s0.225-0.054 0.445-0.054c0.221 0 0.369 0.018 0.446 0.054s0.108 0.089 0.094 0.16l-0.201 1.745 1.531-1.029c0.058-0.040 0.121-0.040 0.19 0s0.159 0.149 0.27 0.327c0.111 0.169 0.168 0.293 0.173 0.371z" })
        );
    }
    function WeatherSnow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeatherSnowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeatherSnow.SVG = WeatherSnowSVG;
    return WeatherSnow;
})();
export const WeatherSnow2 = /*#__PURE__*/ (() => {
        function WeatherSnow2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 7.5c0 1.378 1.121 2.5 2.5 2.5h9.5c1.068 0 2.073-0.416 2.828-1.172s1.172-1.76 1.172-2.828c0-2.206-1.794-4-4-4-0.385 0-0.761 0.054-1.12 0.158-0.366-1.251-1.526-2.158-2.88-2.158-1.335 0-2.469 0.876-2.857 2.084-0.209-0.055-0.425-0.084-0.643-0.084-1.378 0-2.5 1.121-2.5 2.5 0 0.182 0.020 0.363 0.059 0.54-1.169 0.209-2.059 1.232-2.059 2.46zM1 7.5c0-0.827 0.673-1.5 1.5-1.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.414c-0.056-0.16-0.086-0.329-0.086-0.5 0-0.827 0.673-1.5 1.5-1.5 0.172 0 0.341 0.030 0.501 0.086 0.005 0.174 0.025 0.348 0.060 0.518 0.048 0.237 0.257 0.4 0.489 0.4 0.033 0 0.067-0.003 0.101-0.010 0.271-0.055 0.445-0.32 0.39-0.59-0.027-0.132-0.041-0.268-0.041-0.404 0-1.103 0.897-2 2-2 0.947 0 1.751 0.665 1.952 1.562-0.292 0.175-0.564 0.388-0.809 0.638-0.193 0.197-0.19 0.514 0.007 0.707s0.514 0.19 0.707-0.007c0.569-0.581 1.33-0.9 2.143-0.9 1.654 0 3 1.346 3 3 0 0.801-0.312 1.555-0.879 2.121s-1.32 0.879-2.121 0.879h-9.5c-0.827 0-1.5-0.673-1.5-1.5z" }),
_('path', { d: "M13.999 12.628c0.005 0.078-0.026 0.133-0.094 0.164l-1.732 0.709 1.732 0.715c0.067 0.027 0.098 0.079 0.094 0.157s-0.062 0.204-0.173 0.378c-0.11 0.178-0.2 0.287-0.27 0.328s-0.133 0.040-0.19 0l-1.531-1.036 0.201 1.751c0.014 0.067-0.017 0.118-0.094 0.154s-0.225 0.054-0.446 0.054c-0.22 0-0.369-0.018-0.445-0.054s-0.108-0.087-0.094-0.154l0.201-1.751-1.524 1.036c-0.057 0.040-0.122 0.040-0.194 0s-0.163-0.149-0.273-0.327c-0.111-0.174-0.167-0.3-0.169-0.378s0.030-0.13 0.097-0.157l1.732-0.715-1.732-0.709c-0.067-0.031-0.1-0.086-0.097-0.164s0.058-0.204 0.169-0.378c0.11-0.174 0.201-0.28 0.273-0.321s0.136-0.040 0.194 0l1.524 1.029-0.201-1.745c-0.014-0.071 0.017-0.125 0.094-0.16s0.225-0.054 0.445-0.054c0.22 0 0.369 0.018 0.446 0.054s0.108 0.089 0.094 0.16l-0.201 1.745 1.531-1.029c0.057-0.040 0.121-0.040 0.19 0s0.159 0.149 0.27 0.327c0.111 0.169 0.168 0.293 0.173 0.371v0zM7 12.628c0.005 0.078-0.026 0.133-0.093 0.164l-1.732 0.709 1.732 0.715c0.067 0.027 0.098 0.079 0.093 0.157s-0.062 0.204-0.173 0.378c-0.11 0.178-0.2 0.287-0.27 0.328s-0.133 0.040-0.19 0l-1.531-1.036 0.201 1.751c0.014 0.067-0.017 0.118-0.094 0.154s-0.225 0.054-0.446 0.054c-0.22 0-0.369-0.018-0.445-0.054s-0.108-0.087-0.094-0.154l0.201-1.751-1.524 1.036c-0.058 0.040-0.122 0.040-0.194 0s-0.163-0.149-0.273-0.327c-0.111-0.174-0.167-0.3-0.169-0.378s0.030-0.13 0.097-0.157l1.732-0.715-1.732-0.709c-0.067-0.031-0.1-0.086-0.097-0.164s0.058-0.204 0.169-0.378c0.11-0.174 0.201-0.28 0.273-0.321s0.136-0.040 0.194 0l1.524 1.029-0.201-1.745c-0.014-0.071 0.017-0.125 0.094-0.16s0.225-0.054 0.445-0.054c0.221 0 0.369 0.018 0.446 0.054s0.108 0.089 0.094 0.16l-0.201 1.745 1.531-1.029c0.058-0.040 0.121-0.040 0.19 0s0.159 0.149 0.27 0.327c0.111 0.169 0.168 0.293 0.173 0.371v0z" })
            );
        }
        function WeatherSnow2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherSnow2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherSnow2.SVG = WeatherSnow2SVG;
        return WeatherSnow2;
    })();
export const WeatherCloudWind = /*#__PURE__*/ (() => {
        function WeatherCloudWindSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.253 12.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M4.253 15.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M13.922 3.626c1.192 0.29 2.078 1.365 2.078 2.648 0 1.504-1.217 2.723-2.719 2.726v0h-10.254c-1.672 0-3.027-1.356-3.027-3.029s1.355-3.029 3.027-3.029c0.184 0 0.365 0.017 0.54 0.049-0.014-0.097-0.021-0.196-0.021-0.296 0-1.154 0.935-2.089 2.088-2.089 0.672 0 1.27 0.318 1.652 0.812 0.681-0.863 1.735-1.418 2.92-1.418 2.022 0 3.666 1.615 3.717 3.626v0z" })
            );
        }
        function WeatherCloudWind({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherCloudWindSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherCloudWind.SVG = WeatherCloudWindSVG;
        return WeatherCloudWind;
    })();
export const WeatherCloudWind2 = /*#__PURE__*/ (() => {
        function WeatherCloudWind2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 2c-0.385 0-0.761 0.054-1.12 0.158-0.366-1.251-1.526-2.158-2.88-2.158-1.335 0-2.469 0.876-2.857 2.084-0.209-0.055-0.425-0.084-0.643-0.084-1.378 0-2.5 1.121-2.5 2.5 0 0.182 0.020 0.363 0.059 0.54-1.169 0.209-2.059 1.232-2.059 2.46 0 1.379 1.121 2.5 2.5 2.5h3c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-3c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.414c-0.056-0.16-0.086-0.329-0.086-0.5 0-0.827 0.673-1.5 1.5-1.5 0.172 0 0.341 0.030 0.501 0.086 0.005 0.174 0.025 0.348 0.060 0.518 0.048 0.237 0.257 0.4 0.489 0.4 0.033 0 0.067-0.003 0.101-0.010 0.271-0.055 0.445-0.32 0.39-0.59-0.027-0.132-0.041-0.268-0.041-0.404 0-1.103 0.897-2 2-2 0.947 0 1.751 0.665 1.952 1.562-0.292 0.175-0.564 0.388-0.809 0.638-0.193 0.197-0.19 0.514 0.007 0.707s0.514 0.19 0.707-0.007c0.569-0.581 1.33-0.901 2.143-0.901 1.654 0 3 1.346 3 3 0 0.801-0.312 1.555-0.879 2.121-0.195 0.195-0.195 0.512-0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.756-0.755 1.172-1.76 1.172-2.828 0-2.206-1.794-4-4-4z" }),
_('path', { d: "M4.253 12.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M4.253 15.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" })
            );
        }
        function WeatherCloudWind2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherCloudWind2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherCloudWind2.SVG = WeatherCloudWind2SVG;
        return WeatherCloudWind2;
    })();
export const WeatherCloudSun = /*#__PURE__*/ (() => {
        function WeatherCloudSunSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.922 10.626c1.192 0.29 2.078 1.365 2.078 2.648 0 1.504-1.217 2.723-2.719 2.726v0h-10.254c-1.672 0-3.027-1.356-3.027-3.029s1.355-3.029 3.027-3.029c0.184 0 0.365 0.017 0.54 0.049-0.014-0.097-0.021-0.196-0.021-0.296 0-1.154 0.935-2.089 2.088-2.089 0.672 0 1.27 0.318 1.652 0.812 0.681-0.863 1.735-1.418 2.92-1.418 2.022 0 3.666 1.615 3.717 3.626v0z" }),
_('path', { d: "M5.634 6.856c0.591 0 1.152 0.179 1.621 0.507 0.756-0.668 1.715-1.060 2.737-1.108-0.126-1.819-1.641-3.255-3.491-3.255-1.933 0-3.5 1.567-3.5 3.5 0 0.544 0.124 1.059 0.346 1.519 0.517-0.704 1.35-1.163 2.288-1.163z" }),
_('path', { d: "M6.5 0c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5z" }),
_('path', { d: "M0 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M10.5 3c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-1 1c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M2.5 3c-0.128 0-0.256-0.049-0.354-0.146l-1-1c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1 1c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" })
            );
        }
        function WeatherCloudSun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherCloudSunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherCloudSun.SVG = WeatherCloudSunSVG;
        return WeatherCloudSun;
    })();
export const WeatherCloudSun2 = /*#__PURE__*/ (() => {
        function WeatherCloudSun2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 0c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5z" }),
_('path', { d: "M0 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M10.5 3c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-1 1c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M2.5 3c-0.128 0-0.256-0.049-0.354-0.146l-1-1c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1 1c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M12 8c-0.385 0-0.761 0.054-1.12 0.158-0.161-0.549-0.474-1.032-0.89-1.4 0.006-0.086 0.010-0.172 0.010-0.258 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 0.612 0.159 1.206 0.457 1.729-0.859 0.396-1.457 1.265-1.457 2.271 0 0.182 0.020 0.363 0.059 0.54-1.169 0.209-2.059 1.232-2.059 2.46 0 1.379 1.121 2.5 2.5 2.5h9.5c1.068 0 2.073-0.416 2.828-1.172s1.172-1.76 1.172-2.828c0-2.206-1.794-4-4-4zM4 6.5c0-1.378 1.122-2.5 2.5-2.5 1.264 0 2.312 0.944 2.477 2.164-0.307-0.106-0.636-0.164-0.977-0.164-1.335 0-2.469 0.876-2.857 2.084-0.209-0.055-0.425-0.084-0.643-0.084-0 0-0 0-0 0-0.324-0.431-0.5-0.956-0.5-1.5zM14.121 14.121c-0.567 0.567-1.32 0.879-2.121 0.879h-9.5c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h1c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-0.414c-0.056-0.16-0.086-0.329-0.086-0.5 0-0.827 0.673-1.5 1.5-1.5 0.172 0 0.341 0.030 0.501 0.086 0.005 0.174 0.025 0.348 0.060 0.518 0.048 0.237 0.257 0.4 0.489 0.4 0.033 0 0.067-0.003 0.101-0.010 0.271-0.055 0.445-0.32 0.39-0.59-0.027-0.132-0.041-0.268-0.041-0.404 0-1.103 0.897-2 2-2 0.947 0 1.751 0.665 1.952 1.562-0.292 0.175-0.564 0.388-0.809 0.638-0.193 0.197-0.19 0.514 0.007 0.707s0.514 0.19 0.707-0.007c0.245-0.251 0.527-0.452 0.832-0.601 0.014-0.006 0.027-0.012 0.040-0.019 0.392-0.183 0.823-0.28 1.27-0.28 1.654 0 3 1.346 3 3 0 0.801-0.312 1.555-0.879 2.121z" })
            );
        }
        function WeatherCloudSun2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherCloudSun2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherCloudSun2.SVG = WeatherCloudSun2SVG;
        return WeatherCloudSun2;
    })();
export const WeatherCloudy = /*#__PURE__*/ (() => {
        function WeatherCloudySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.634 7.961c0.33-1.35 1.55-2.356 3-2.356 0.576 0 1.126 0.157 1.601 0.446 0.832-0.677 1.872-1.052 2.97-1.052 1.239 0 2.41 0.477 3.297 1.344 0.714 0.699 1.181 1.588 1.35 2.555 0.144 0.068 0.284 0.145 0.419 0.231 0.452-0.487 0.729-1.139 0.729-1.856 0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029 0 0.672 0.219 1.293 0.589 1.795 0.579-0.442 1.281-0.731 2.045-0.805z" }),
_('path', { d: "M13.922 9.626c1.192 0.29 2.078 1.365 2.078 2.648 0 1.504-1.217 2.723-2.719 2.726v0h-10.254c-1.672 0-3.027-1.356-3.027-3.029s1.355-3.029 3.027-3.029c0.184 0 0.365 0.017 0.54 0.049-0.014-0.097-0.021-0.196-0.021-0.296 0-1.154 0.935-2.089 2.088-2.089 0.672 0 1.27 0.318 1.652 0.812 0.681-0.863 1.735-1.418 2.92-1.418 2.022 0 3.666 1.615 3.717 3.626v0z" })
            );
        }
        function WeatherCloudy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherCloudySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherCloudy.SVG = WeatherCloudySVG;
        return WeatherCloudy;
    })();
export const WeatherCloudy2 = /*#__PURE__*/ (() => {
    function WeatherCloudy2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.059 11.040c-0.006-0.027-0.012-0.055-0.017-0.082-1.161-0.216-2.042-1.235-2.042-2.457 0-1.228 0.89-2.251 2.059-2.46-0.039-0.176-0.059-0.357-0.059-0.54 0-1.378 1.122-2.5 2.5-2.5 0.218 0 0.434 0.029 0.643 0.084 0.388-1.208 1.522-2.084 2.857-2.084 1.354 0 2.514 0.907 2.88 2.158 0.359-0.104 0.735-0.158 1.12-0.158 2.206 0 4 1.794 4 4 0 0.921-0.309 1.794-0.879 2.502 0.549 0.685 0.879 1.554 0.879 2.498 0 2.206-1.794 4-4 4h-9.5c-1.379 0-2.5-1.121-2.5-2.5 0-1.228 0.89-2.251 2.059-2.46zM12 4c-0.813 0-1.574 0.32-2.143 0.9-0.193 0.197-0.51 0.2-0.707 0.007s-0.2-0.51-0.007-0.707c0.245-0.25 0.517-0.463 0.809-0.638-0.201-0.897-1.005-1.562-1.952-1.562-1.103 0-2 0.897-2 2 0 0.136 0.014 0.272 0.041 0.404 0.055 0.271-0.119 0.535-0.39 0.59-0.034 0.007-0.067 0.010-0.101 0.010-0.233 0-0.441-0.163-0.489-0.4-0.035-0.17-0.055-0.343-0.060-0.518-0.16-0.057-0.33-0.086-0.501-0.086-0.827 0-1.5 0.673-1.5 1.5 0 0.171 0.029 0.34 0.086 0.5h0.414c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.827 0-1.5 0.673-1.5 1.5 0 0.676 0.449 1.249 1.065 1.435 0.257-1.107 1.251-1.936 2.435-1.936 0.218 0 0.434 0.029 0.643 0.084 0.388-1.208 1.522-2.084 2.857-2.084 1.354 0 2.514 0.907 2.88 2.158 0.359-0.104 0.735-0.158 1.12-0.158 0.899 0 1.73 0.298 2.399 0.801 0.39-0.517 0.601-1.143 0.601-1.801 0-1.654-1.346-3-3-3zM2.5 15h9.5c1.654 0 3-1.346 3-3s-1.346-3-3-3c-0.813 0-1.574 0.32-2.143 0.9-0.193 0.197-0.51 0.2-0.707 0.007s-0.2-0.51-0.007-0.707c0.245-0.25 0.517-0.463 0.809-0.638-0.201-0.897-1.005-1.562-1.952-1.562-1.103 0-2 0.897-2 2 0 0.136 0.014 0.272 0.041 0.404 0.055 0.271-0.119 0.535-0.39 0.59-0.034 0.007-0.067 0.010-0.101 0.010-0.233 0-0.441-0.163-0.489-0.4-0.035-0.17-0.055-0.343-0.060-0.518-0.16-0.057-0.33-0.086-0.501-0.086-0.827 0-1.5 0.673-1.5 1.5 0 0.171 0.029 0.34 0.086 0.5h0.414c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5z" })
        );
    }
    function WeatherCloudy2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeatherCloudy2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeatherCloudy2.SVG = WeatherCloudy2SVG;
    return WeatherCloudy2;
})();
export const WeatherSunWind = /*#__PURE__*/ (() => {
        function WeatherSunWindSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 10c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5v0z" }),
_('path', { d: "M6.5 0c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5z" }),
_('path', { d: "M11 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M0 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M4.253 12.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M4.253 15.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M10.5 3c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-1 1c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M2.5 3c-0.128 0-0.256-0.049-0.354-0.146l-1-1c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1 1c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" })
            );
        }
        function WeatherSunWind({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherSunWindSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherSunWind.SVG = WeatherSunWindSVG;
        return WeatherSunWind;
    })();
export const WeatherSunWind2 = /*#__PURE__*/ (() => {
        function WeatherSunWind2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 9c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5c1.378 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM6.5 10c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5v0z" }),
_('path', { d: "M6.5 0c0.276 0 0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5z" }),
_('path', { d: "M11 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M0 6.5c0-0.276 0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5z" }),
_('path', { d: "M4.253 12.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M4.253 15.936c-1.328 0-2.656-0.33-3.976-0.989-0.247-0.123-0.347-0.424-0.224-0.671s0.424-0.347 0.671-0.224c1.176 0.587 2.364 0.885 3.53 0.885s2.351-0.298 3.523-0.885c2.641-1.319 5.315-1.318 7.948 0 0.247 0.124 0.347 0.424 0.223 0.671s-0.424 0.347-0.671 0.223c-1.172-0.587-2.357-0.885-3.523-0.885s-2.354 0.298-3.53 0.885c-1.316 0.659-2.643 0.989-3.97 0.989z" }),
_('path', { d: "M10.5 3c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-1 1c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M2.5 3c-0.128 0-0.256-0.049-0.354-0.146l-1-1c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1 1c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" })
            );
        }
        function WeatherSunWind2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WeatherSunWind2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        WeatherSunWind2.SVG = WeatherSunWind2SVG;
        return WeatherSunWind2;
    })();
export const Sun = /*#__PURE__*/ (() => {
    function SunSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z" })
        );
    }
    function Sun({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SunSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sun.SVG = SunSVG;
    return Sun;
})();
export const Sun2 = /*#__PURE__*/ (() => {
        function Sun2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z" }),
_('path', { d: "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z" })
            );
        }
        function Sun2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Sun2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sun2.SVG = Sun2SVG;
        return Sun2;
    })();
export const Moon = /*#__PURE__*/ (() => {
    function MoonSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.185 1.008c-0.941-0.543-1.947-0.874-2.962-1.008 1.921 2.501 2.262 6.012 0.587 8.913s-4.886 4.361-8.012 3.948c0.623 0.812 1.412 1.518 2.354 2.061 3.842 2.218 8.756 0.902 10.974-2.941s0.902-8.756-2.94-10.974z" })
        );
    }
    function Moon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Moon.SVG = MoonSVG;
    return Moon;
})();
export const DayNight = /*#__PURE__*/ (() => {
        function DayNightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 7c1.378 0 2.5 1.121 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5zM6.5 6c-1.933 0-3.5 1.567-3.5 3.5s1.567 3.5 3.5 3.5c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5v0z" }),
_('path', { d: "M6.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M6.5 16c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M2 9.5c0 0.276-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5z" }),
_('path', { d: "M13 9.5c0 0.276-0.224 0.5-0.5 0.5h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5z" }),
_('path', { d: "M3.318 6.318c-0.195 0.195-0.512 0.195-0.707 0l-0.707-0.707c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l0.707 0.707c0.195 0.195 0.195 0.512 0 0.707z" }),
_('path', { d: "M11.096 14.096c-0.195 0.195-0.512 0.195-0.707 0l-0.707-0.707c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l0.707 0.707c0.195 0.195 0.195 0.512 0 0.707z" }),
_('path', { d: "M3.318 12.682c0.195 0.195 0.195 0.512 0 0.707l-0.707 0.707c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l0.707-0.707c0.195-0.195 0.512-0.195 0.707 0z" }),
_('path', { d: "M12.702 4.798c-0.997-0.997-1.308-2.402-0.912-3.583-1.336 0.493-2.29 1.777-2.29 3.285 0 1.933 1.567 3.5 3.5 3.5 1.507 0 2.792-0.953 3.285-2.29-1.181 0.396-2.586 0.084-3.583-0.912z" })
            );
        }
        function DayNight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DayNightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DayNight.SVG = DayNightSVG;
        return DayNight;
    })();
export const DayNight2 = /*#__PURE__*/ (() => {
        function DayNight2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 4c-0.278 0-0.55 0.025-0.815 0.074 1.374 0.99 2.268 2.604 2.268 4.426s-0.894 3.436-2.268 4.426c0.264 0.048 0.537 0.074 0.815 0.074 2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5z" }),
_('path', { d: "M7.5 16c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 3c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M2.5 14c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l1-1c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-1 1c-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M3.5 5c-0.128 0-0.256-0.049-0.354-0.146l-1-1c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l1 1c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M1.5 9h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M7.5 13c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5zM7.5 5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z" })
            );
        }
        function DayNight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DayNight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DayNight2.SVG = DayNight2SVG;
        return DayNight2;
    })();
export const WeatherWindy = /*#__PURE__*/ (() => {
    function WeatherWindySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 5c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5c0 0.072-0.005 0.143-0.015 0.212l0.99 0.141c0.016-0.116 0.025-0.233 0.025-0.354 0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5h5.5v-1h-5.5zM2 12c0 1.657 1.343 3 3 3s3-1.343 3-3c0-0.251-0.031-0.495-0.089-0.728l-0.971 0.243c0.039 0.155 0.060 0.318 0.060 0.485 0 1.105-0.895 2-2 2s-2-0.895-2-2 0.895-2 2-2h11v-1h-11c-1.657 0-3 1.343-3 3zM1 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 0.369-0.081 0.719-0.224 1.034l0.911 0.414c0.201-0.441 0.313-0.932 0.313-1.449 0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.933 1.567 3.5 3.5 3.5h12.5v-1h-12.5c-1.381 0-2.5-1.119-2.5-2.5z" })
        );
    }
    function WeatherWindy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WeatherWindySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    WeatherWindy.SVG = WeatherWindySVG;
    return WeatherWindy;
})();
export const Fan = /*#__PURE__*/ (() => {
    function FanSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.389 7.884c-0.793-0.793-1.769-1.293-2.792-1.501l3.205-3.205c0.681-0.681 1.060-1.55-0.223-2.411-2.11-1.253-4.879-0.972-6.694 0.843-0.793 0.793-1.293 1.769-1.501 2.792l-3.205-3.205c-0.681-0.681-1.55-1.060-2.411 0.223-1.253 2.11-0.972 4.879 0.843 6.694 0.793 0.793 1.769 1.293 2.792 1.501l-3.205 3.205c-0.681 0.681-1.060 1.55 0.223 2.411 2.11 1.253 4.879 0.972 6.694-0.843 0.793-0.794 1.293-1.769 1.501-2.792l3.205 3.205c0.681 0.681 1.55 1.060 2.411-0.223 1.253-2.11 0.972-4.879-0.843-6.694zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z" })
        );
    }
    function Fan({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fan.SVG = FanSVG;
    return Fan;
})();
export const Umbrella = /*#__PURE__*/ (() => {
    function UmbrellaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.998 1.062c3.947 0.491 7.002 3.858 7.002 7.938h-0.268c-0.346-0.598-0.992-1-1.732-1s-1.386 0.402-1.732 1h-0.537c-0.346-0.598-0.992-1-1.732-1-0.364 0-0.706 0.098-1 0.268v5.232c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5.232c-0.294-0.17-0.636-0.268-1-0.268-0.74 0-1.386 0.402-1.732 1h-0.536c-0.346-0.598-0.992-1-1.732-1s-1.386 0.402-1.732 1h-0.268c0-4.080 3.055-7.447 7.002-7.938-0.001-0.020-0.002-0.041-0.002-0.062 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.021-0.001 0.041-0.002 0.062z" })
        );
    }
    function Umbrella({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UmbrellaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Umbrella.SVG = UmbrellaSVG;
    return Umbrella;
})();
export const Sun3 = /*#__PURE__*/ (() => {
    function Sun3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.374 8l1.425-1.78-2.056-0.986 0.512-2.222-2.28 0.004-0.503-2.224-2.053 0.993-1.418-1.786-1.418 1.786-2.053-0.993-0.503 2.224-2.28-0.004 0.512 2.222-2.056 0.986 1.425 1.78-1.425 1.78 2.056 0.986-0.512 2.222 2.28-0.004 0.503 2.224 2.053-0.993 1.418 1.786 1.418-1.786 2.053 0.993 0.503-2.224 2.28 0.004-0.512-2.222 2.056-0.986-1.425-1.78zM8 13.141c-2.743 0-4.966-2.302-4.966-5.141s2.223-5.141 4.966-5.141c2.743 0 4.966 2.302 4.966 5.141s-2.223 5.141-4.966 5.141zM4 8c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4z" })
        );
    }
    function Sun3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sun3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sun3.SVG = Sun3SVG;
    return Sun3;
})();
export const Contrast = /*#__PURE__*/ (() => {
    function ContrastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM2 8c0-3.314 2.686-6 6-6v12c-3.314 0-6-2.686-6-6z" })
        );
    }
    function Contrast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ContrastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Contrast.SVG = ContrastSVG;
    return Contrast;
})();
export const BrightnessContrast = /*#__PURE__*/ (() => {
    function BrightnessContrastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zM8 10.5v-5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z" })
        );
    }
    function BrightnessContrast({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BrightnessContrastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BrightnessContrast.SVG = BrightnessContrastSVG;
    return BrightnessContrast;
})();
export const BrightnessHigh = /*#__PURE__*/ (() => {
    function BrightnessHighSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 6.594c-0.775 0-1.406 0.631-1.406 1.406s0.631 1.406 1.406 1.406c0.775 0 1.406-0.631 1.406-1.406s-0.631-1.406-1.406-1.406zM8 5v0c1.657 0 3 1.343 3 3s-1.343 3-3 3c-1.657 0-3-1.343-3-3s1.343-3 3-3zM14.707 13.293c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0l-2-2c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l2 2zM4.707 3.293c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0l-2-2c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l2 2zM13.293 1.293c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-2 2c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l2-2zM3.293 11.293c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-2 2c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l2-2zM8 0c0.552 0 1 0.448 1 1v2c0 0.552-0.448 1-1 1s-1-0.448-1-1v-2c0-0.552 0.448-1 1-1zM8 12c0.552 0 1 0.448 1 1v2c0 0.552-0.448 1-1 1s-1-0.448-1-1v-2c0-0.552 0.448-1 1-1zM0 8c0-0.552 0.448-1 1-1h2c0.552 0 1 0.448 1 1s-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1zM12 8c0-0.552 0.448-1 1-1h2c0.552 0 1 0.448 1 1s-0.448 1-1 1h-2c-0.552 0-1-0.448-1-1z" })
        );
    }
    function BrightnessHigh({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BrightnessHighSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BrightnessHigh.SVG = BrightnessHighSVG;
    return BrightnessHigh;
})();
export const BrightnessMedium = /*#__PURE__*/ (() => {
    function BrightnessMediumSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 6.594c-0.775 0-1.406 0.631-1.406 1.406s0.631 1.406 1.406 1.406c0.775 0 1.406-0.631 1.406-1.406s-0.631-1.406-1.406-1.406zM8 5v0c1.657 0 3 1.343 3 3s-1.343 3-3 3c-1.657 0-3-1.343-3-3s1.343-3 3-3zM13.707 12.293c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0l-1-1c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l1 1zM4.707 3.293c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0l-1-1c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l1 1zM12.293 2.293c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-1 1c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l1-1zM3.293 11.293c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-1 1c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l1-1zM8 1c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 12c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM1 8c0-0.552 0.448-1 1-1h1c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1zM12 8c0-0.552 0.448-1 1-1h1c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1z" })
        );
    }
    function BrightnessMedium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BrightnessMediumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BrightnessMedium.SVG = BrightnessMediumSVG;
    return BrightnessMedium;
})();
export const BrightnessLow = /*#__PURE__*/ (() => {
    function BrightnessLowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 3c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM3 4c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 13c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11 12c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM2 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11 4c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM3 12c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM8 5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zM8 9.406c-0.775 0-1.406-0.631-1.406-1.406s0.631-1.406 1.406-1.406c0.775 0 1.406 0.631 1.406 1.406s-0.631 1.406-1.406 1.406z" })
        );
    }
    function BrightnessLow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BrightnessLowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    BrightnessLow.SVG = BrightnessLowSVG;
    return BrightnessLow;
})();
export const Bed = /*#__PURE__*/ (() => {
        function BedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 5c-0.552 0-1 0.448-1 1v3h-10.5c-0.828 0-1.5-0.672-1.5-1.5v-4.5c0-0.552-0.448-1-1-1s-1 0.448-1 1v10h2v-2h12v2h2v-7c0-0.552-0.448-1-1-1z" }),
_('path', { d: "M5.5 6.75c0 0.966-0.784 1.75-1.75 1.75s-1.75-0.784-1.75-1.75c0-0.966 0.784-1.75 1.75-1.75s1.75 0.784 1.75 1.75z" }),
_('path', { d: "M12.5 6h-5c-0.828 0-1.5 0.672-1.5 1.5v1h8v-1c0-0.828-0.672-1.5-1.5-1.5z" })
            );
        }
        function Bed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Bed.SVG = BedSVG;
        return Bed;
    })();
export const Bed2 = /*#__PURE__*/ (() => {
    function Bed2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 14h2v2h2v-2h8v2h2v-2h2v-1h-16zM13 5h-10l-3 7h16zM5.5 4c1.381 0 2.5 0.448 2.5 1 0-0.552 1.119-1 2.5-1s2.5 0.448 2.5 1v-4c0-0.552-0.448-1-1-1h-8c-0.552 0-1 0.448-1 1v4c0-0.552 1.119-1 2.5-1z" })
        );
    }
    function Bed2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bed2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bed2.SVG = Bed2SVG;
    return Bed2;
})();
export const Furniture = /*#__PURE__*/ (() => {
        function FurnitureSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 6c-1.105 0-2 0.895-2 2v2h-8v-2c0-1.105-0.895-2-2-2s-2 0.895-2 2v4c0 1.105 0.895 2 2 2v2h1l0.5-2h9l0.5 2h1v-2c1.105 0 2-0.895 2-2v-4c0-1.105-0.895-2-2-2z" }),
_('path', { d: "M5 7.688v1.313h6v-1.313c0-1.642 1-2.688 2.964-2.687-0.243-1.694-1.704-3-3.464-3h-5c-1.76 0-3.221 1.306-3.464 3 1.964-0 2.964 1.045 2.964 2.687z" })
            );
        }
        function Furniture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FurnitureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Furniture.SVG = FurnitureSVG;
        return Furniture;
    })();
export const Chair = /*#__PURE__*/ (() => {
    function ChairSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9h-2v-7c0-0.552-0.448-1-1-1s-1 0.448-1 1v1h-5v-1c0-0.552-0.448-1-1-1s-1 0.448-1 1v7h-2v2h1v5h2v-2h7v2h2v-5h1v-2zM5 6h5v1h-5v-1zM10 4v1h-5v-1h5zM5 8h5v1h-5v-1zM11 13h-7v-2h7v2z" })
        );
    }
    function Chair({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChairSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chair.SVG = ChairSVG;
    return Chair;
})();
export const StarEmpty = /*#__PURE__*/ (() => {
    function StarEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.635 15.777c-0.103 0-0.206-0.032-0.293-0.095l-4.342-3.141-4.342 3.141c-0.175 0.127-0.413 0.126-0.588-0.001s-0.248-0.353-0.181-0.559l1.657-5.079-4.34-3.139c-0.176-0.127-0.249-0.353-0.183-0.559s0.259-0.346 0.476-0.346l5.367-0 1.658-5.080c0.067-0.206 0.259-0.345 0.475-0.345s0.408 0.139 0.475 0.345l1.658 5.080 5.367 0c0.217 0 0.409 0.14 0.476 0.346s-0.007 0.432-0.183 0.559l-4.34 3.139 1.657 5.079c0.067 0.206-0.006 0.432-0.181 0.559-0.088 0.064-0.191 0.096-0.295 0.096zM2.044 6.998l3.384 2.448c0.176 0.127 0.25 0.354 0.182 0.56l-1.294 3.964 3.39-2.452c0.175-0.127 0.411-0.127 0.586 0l3.39 2.452-1.294-3.964c-0.067-0.206 0.006-0.433 0.182-0.56l3.384-2.448-4.185-0c-0.216 0-0.408-0.139-0.475-0.345l-1.295-3.969-1.295 3.969c-0.067 0.206-0.259 0.345-0.475 0.345l-4.185 0z" })
        );
    }
    function StarEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarEmpty.SVG = StarEmptySVG;
    return StarEmpty;
})();
export const StarEmpty2 = /*#__PURE__*/ (() => {
    function StarEmpty2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.976 6.345c-0.067-0.206-0.259-0.346-0.476-0.346l-5.367-0-1.658-5.080c-0.067-0.206-0.259-0.345-0.475-0.345s-0.408 0.139-0.475 0.345l-1.658 5.080-5.367 0c-0.217 0-0.409 0.14-0.476 0.346s0.007 0.432 0.183 0.559l4.34 3.139-1.657 5.079c-0.067 0.206 0.006 0.432 0.181 0.559s0.412 0.128 0.588 0.001l4.342-3.141 4.342 3.141c0.087 0.063 0.19 0.095 0.293 0.095s0.207-0.032 0.295-0.096c0.175-0.128 0.248-0.353 0.181-0.559l-1.657-5.079 4.34-3.139c0.176-0.127 0.249-0.353 0.183-0.559zM10.572 9.447c-0.176 0.127-0.25 0.354-0.182 0.56l1.294 3.964-3.39-2.452c-0.087-0.063-0.19-0.095-0.293-0.095v-8.739l1.295 3.969c0.067 0.206 0.259 0.345 0.475 0.345l4.185 0-3.384 2.448z" })
        );
    }
    function StarEmpty2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarEmpty2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarEmpty2.SVG = StarEmpty2SVG;
    return StarEmpty2;
})();
export const StarFull = /*#__PURE__*/ (() => {
    function StarFullSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.976 6.345c-0.067-0.206-0.259-0.346-0.476-0.346l-5.367-0-1.658-5.080c-0.067-0.206-0.259-0.345-0.475-0.345s-0.408 0.139-0.475 0.345l-1.658 5.080-5.367 0c-0.217 0-0.409 0.14-0.476 0.346s0.007 0.432 0.183 0.559l4.34 3.139-1.657 5.079c-0.067 0.206 0.006 0.432 0.181 0.559s0.412 0.128 0.588 0.001l4.342-3.141 4.342 3.141c0.087 0.063 0.19 0.095 0.293 0.095s0.207-0.032 0.295-0.096c0.175-0.128 0.248-0.353 0.181-0.559l-1.657-5.079 4.34-3.139c0.176-0.127 0.249-0.353 0.183-0.559z" })
        );
    }
    function StarFull({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarFullSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarFull.SVG = StarFullSVG;
    return StarFull;
})();
export const StarEmpty3 = /*#__PURE__*/ (() => {
    function StarEmpty3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z" })
        );
    }
    function StarEmpty3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarEmpty3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarEmpty3.SVG = StarEmpty3SVG;
    return StarEmpty3;
})();
export const StarHalf = /*#__PURE__*/ (() => {
    function StarHalfSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z" })
        );
    }
    function StarHalf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarHalfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarHalf.SVG = StarHalfSVG;
    return StarHalf;
})();
export const StarFull2 = /*#__PURE__*/ (() => {
    function StarFull2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z" })
        );
    }
    function StarFull2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarFull2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StarFull2.SVG = StarFull2SVG;
    return StarFull2;
})();
export const Star = /*#__PURE__*/ (() => {
    function StarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11.233 12.975l-3.233-2.2-3.233 2.2 1.093-3.754-3.091-2.395 3.908-0.121 1.323-3.68 1.322 3.68 3.908 0.121-3.091 2.395 1.093 3.754z" })
        );
    }
    function Star({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Star.SVG = StarSVG;
    return Star;
})();
export const Heart = /*#__PURE__*/ (() => {
    function HeartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2.5l5 5-8 8-8-8 5-5 3 3 3-3z" })
        );
    }
    function Heart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart.SVG = HeartSVG;
    return Heart;
})();
export const Heart2 = /*#__PURE__*/ (() => {
    function Heart2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2.5l-3 3-3-3-5 5 8 8 8-8-5-5zM2.828 7.5l2.172-2.172 3 3 3-3 2.172 2.172-5.172 5.172-5.172-5.172z" })
        );
    }
    function Heart2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart2.SVG = Heart2SVG;
    return Heart2;
})();
export const Heart3 = /*#__PURE__*/ (() => {
    function Heart3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.596c0 1.349-0.582 2.563-1.508 3.404h0.008l-5 5c-0.5 0.5-1 1-1.5 1s-1-0.5-1.5-1l-4.992-5c-0.926-0.841-1.508-2.054-1.508-3.404 0-2.538 2.058-4.596 4.596-4.596 1.349 0 2.563 0.582 3.404 1.508 0.841-0.926 2.054-1.508 3.404-1.508 2.538 0 4.596 2.058 4.596 4.596z" })
        );
    }
    function Heart3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart3.SVG = Heart3SVG;
    return Heart3;
})();
export const Heart4 = /*#__PURE__*/ (() => {
    function Heart4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.596c0-2.538-2.058-4.596-4.596-4.596-1.349 0-2.563 0.582-3.404 1.508-0.841-0.926-2.054-1.508-3.404-1.508-2.538 0-4.596 2.058-4.596 4.596 0 1.349 0.582 2.563 1.508 3.404h-0.008l5 5c0.5 0.5 1 1 1.5 1s1-0.5 1.5-1l4.992-5c0.926-0.841 1.508-2.054 1.508-3.404zM13.148 7.519l-5.062 5.067c-0.026 0.026-0.055 0.055-0.086 0.086-0.031-0.030-0.060-0.059-0.086-0.086l-5.062-5.066c-0.549-0.499-0.852-1.182-0.852-1.923 0-1.432 1.165-2.596 2.596-2.596 0.741 0 1.424 0.303 1.923 0.852l1.481 1.631 1.481-1.631c0.499-0.55 1.182-0.852 1.923-0.852 1.432 0 2.596 1.165 2.596 2.596 0 0.741-0.303 1.424-0.852 1.923z" })
        );
    }
    function Heart4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart4.SVG = Heart4SVG;
    return Heart4;
})();
export const HeartBroken = /*#__PURE__*/ (() => {
    function HeartBrokenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.596c0 1.349-0.582 2.563-1.508 3.404h0.008l-5 5c-0.5 0.5-1 1-1.5 1s-1-0.5-1.5-1l-4.992-5c-0.926-0.841-1.508-2.054-1.508-3.404 0-2.538 2.058-4.596 4.596-4.596 0.866 0 1.677 0.24 2.368 0.657l-1.465 2.343 3.5 2-2 5 5.5-6-3.5-2 1.233-1.849c0.374-0.098 0.766-0.151 1.171-0.151 2.538 0 4.596 2.058 4.596 4.596z" })
        );
    }
    function HeartBroken({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartBrokenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HeartBroken.SVG = HeartBrokenSVG;
    return HeartBroken;
})();
export const Heart5 = /*#__PURE__*/ (() => {
    function Heart5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z" })
        );
    }
    function Heart5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart5.SVG = Heart5SVG;
    return Heart5;
})();
export const Heart6 = /*#__PURE__*/ (() => {
    function Heart6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.021 16l-0.827-1.126c-1.015-1.382-2.212-2.376-3.37-3.338-0.973-0.808-1.892-1.571-2.592-2.485-0.829-1.084-1.232-2.252-1.232-3.569 0-2.471 2.097-4.482 4.675-4.482 0.901 0 1.798 0.317 2.595 0.916 0.26 0.195 0.505 0.418 0.73 0.662 0.225-0.244 0.47-0.467 0.73-0.662 0.797-0.599 1.694-0.916 2.595-0.916 2.578 0 4.675 2.011 4.675 4.482 0 1.266-0.404 2.405-1.234 3.482-0.695 0.901-1.602 1.662-2.562 2.469-1.182 0.993-2.405 2.019-3.383 3.421l-0.8 1.145zM4.675 3c-1.475 0-2.675 1.113-2.675 2.482 0 1.941 1.301 3.021 3.101 4.515 0.92 0.764 1.935 1.606 2.883 2.677 0.946-1.104 1.988-1.979 2.933-2.772 0.875-0.735 1.702-1.429 2.265-2.159 0.566-0.733 0.818-1.431 0.818-2.261 0-1.369-1.2-2.482-2.675-2.482-0.749 0-1.829 0.551-2.428 1.762l-0.896 1.809-0.896-1.808c-0.6-1.211-1.68-1.763-2.429-1.763z" })
        );
    }
    function Heart6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart6.SVG = Heart6SVG;
    return Heart6;
})();
export const HeartBroken2 = /*#__PURE__*/ (() => {
    function HeartBroken2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.8 1c2.318 0 4.2 1.882 4.2 4.2 0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616 0-2.319 1.882-4.2 4.2-4.2 0.943 0 1.812 0.43 2.512 1.060l-1.213 1.94 3.5 2-2 5 5.5-6-3.5-2 0.967-1.451c0.553-0.34 1.175-0.549 1.833-0.549z" })
        );
    }
    function HeartBroken2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartBroken2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HeartBroken2.SVG = HeartBroken2SVG;
    return HeartBroken2;
})();
export const Heart7 = /*#__PURE__*/ (() => {
    function Heart7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.75 1c-1.624 0-3.034 0.911-3.75 2.249-0.716-1.338-2.126-2.249-3.75-2.249-2.347 0-4.25 1.903-4.25 4.25 0 5.75 8 9.75 8 9.75s8-4 8-9.75c0-2.347-1.903-4.25-4.25-4.25z" })
        );
    }
    function Heart7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart7.SVG = Heart7SVG;
    return Heart7;
})();
export const Heart8 = /*#__PURE__*/ (() => {
    function Heart8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 15l-0.437-0.212c-0.309-0.15-7.563-3.733-7.563-9.179 0-2.541 2.117-4.609 4.719-4.609 1.245 0 2.414 0.476 3.281 1.296 0.867-0.82 2.037-1.296 3.281-1.296 2.602 0 4.719 2.068 4.719 4.609 0 5.446-7.255 9.029-7.563 9.179l-0.437 0.212zM4.719 3c-1.499 0-2.719 1.17-2.719 2.609 0 2.124 1.691 3.988 3.11 5.178 1.133 0.95 2.283 1.636 2.89 1.971 0.607-0.335 1.757-1.022 2.89-1.971 1.419-1.189 3.11-3.053 3.11-5.178 0-1.439-1.22-2.609-2.719-2.609-1.011 0-1.932 0.533-2.405 1.392l-0.876 1.589-0.876-1.589c-0.473-0.859-1.395-1.392-2.405-1.392z" })
        );
    }
    function Heart8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Heart8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Heart8.SVG = Heart8SVG;
    return Heart8;
})();
export const HeartBroken3 = /*#__PURE__*/ (() => {
    function HeartBroken3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.75 1c2.347 0 4.25 1.903 4.25 4.25 0 5.75-8 9.75-8 9.75s-8-4-8-9.75c0-2.347 1.903-4.25 4.25-4.25 0.97 0 1.864 0.325 2.58 0.873l-1.33 2.127 3.5 2-2 5 5.5-6-3.5-2 1.116-1.674c0.503-0.21 1.055-0.326 1.634-0.326z" })
        );
    }
    function HeartBroken3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HeartBroken3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HeartBroken3.SVG = HeartBroken3SVG;
    return HeartBroken3;
})();
export const Lips = /*#__PURE__*/ (() => {
    function LipsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 6.877l-0.157-0.005c-1.935-0.112-3.646-2.091-5.593-2.091-2 0-2.25 0.75-2.25 0.75s-0.25-0.75-2.25-0.75c-1.948 0-3.658 1.979-5.593 2.091l-0.157 0.005c0 0 5 0.904 8 0.904s8-0.904 8-0.904zM8 9.219c-2.637 0-7-1.531-7.793-2.138 2.25 1.722 3.894 4.794 7.793 4.794s5.543-3.073 7.793-4.794c-0.793 0.607-5.156 2.138-7.793 2.138z" })
        );
    }
    function Lips({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LipsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lips.SVG = LipsSVG;
    return Lips;
})();
export const Lips2 = /*#__PURE__*/ (() => {
    function Lips2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.071 5.799c-0.456 0-2.015-0.834-2.015-0.834-0.888-0.495-1.895-1.057-3.031-1.057-0.84 0-1.52 0.133-2.025 0.396-0.505-0.263-1.185-0.396-2.025-0.396-1.136 0-2.143 0.562-3.031 1.057 0 0-1.558 0.834-2.015 0.834-0.697 0-1.416 0.927-0.49 1.793 0.497 0.38 0.972 0.855 1.475 1.357 0.734 0.733 1.494 1.492 2.445 2.090 1.126 0.708 2.317 1.053 3.64 1.053s2.514-0.344 3.64-1.053c0.952-0.599 1.711-1.357 2.445-2.090 0.503-0.502 0.978-0.977 1.475-1.357 0.926-0.867 0.206-1.793-0.49-1.793zM8 11.192c-3.509 0-4.989-2.765-7.014-4.315 0.714 0.546 4.64 2.081 7.014 2.081s6.3-1.534 7.014-2.081c-2.025 1.55-3.505 4.315-7.014 4.315zM8 7.508c-2.7 0-7.2-0.813-7.2-0.813l0.141-0.004c1.742-0.101 3.281-1.882 5.034-1.882 1.8 0 2.025 0.675 2.025 0.675s0.225-0.675 2.025-0.675c1.753 0 3.292 1.782 5.034 1.882l0.141 0.004c-0 0-4.5 0.813-7.2 0.813z" })
        );
    }
    function Lips2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lips2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lips2.SVG = Lips2SVG;
    return Lips2;
})();
export const ThumbsUp = /*#__PURE__*/ (() => {
    function ThumbsUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 10.5c0-0.514-0.281-0.968-0.708-1.238 0.132-0.223 0.208-0.484 0.208-0.762 0-0.828-0.672-1.5-1.5-1.5h-2.934c0.351-1.264 0.528-2.572 0.528-3.906 0-1.155-0.939-2.094-2.094-2.094s-2.094 0.939-2.094 2.094c0 1.625-0.605 2.874-1.798 3.714-0.328 0.231-0.699 0.429-1.108 0.595v-1.403h-4v10h4v-0.984c0.936 0.061 1.39 0.296 1.831 0.523 0.439 0.227 0.893 0.461 1.669 0.461h5c0.828 0 1.5-0.672 1.5-1.5 0-0.195-0.038-0.382-0.106-0.553 0.637-0.173 1.106-0.755 1.106-1.447 0-0.278-0.076-0.538-0.208-0.762 0.427-0.27 0.708-0.724 0.708-1.238zM10.5 8h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM8.705 11.229c-0.423 0.265-0.705 0.735-0.705 1.271 0 0.531 0.276 0.998 0.693 1.264-0.123 0.217-0.193 0.468-0.193 0.736 0 0.175 0.030 0.344 0.086 0.5h-1.086c-0.533 0-0.817-0.147-1.21-0.35-0.496-0.256-1.1-0.568-2.29-0.636v-5.347c0.671-0.225 1.272-0.522 1.792-0.888 1.506-1.060 2.302-2.68 2.302-4.685 0-0.5 0.407-0.906 0.906-0.906s0.906 0.407 0.906 0.906c0 1.338-0.194 2.647-0.578 3.906-0.104 0.387-0.202 0.769-0.264 1.062-0.040 0.13-0.062 0.268-0.064 0.411-0 0.009-0.001 0.018-0.001 0.027 0 0.278 0.076 0.538 0.208 0.762-0.427 0.27-0.708 0.724-0.708 1.238 0 0.264 0.074 0.513 0.205 0.729zM12.5 15h-2.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM13.5 13h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM13.875 11h-3.75c-0.339 0-0.625-0.229-0.625-0.5s0.286-0.5 0.625-0.5h3.75c0.339 0 0.625 0.229 0.625 0.5s-0.286 0.5-0.625 0.5zM2 14.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z" })
        );
    }
    function ThumbsUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsUp.SVG = ThumbsUpSVG;
    return ThumbsUp;
})();
export const ThumbsUp2 = /*#__PURE__*/ (() => {
    function ThumbsUp2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 10.5c0-0.514-0.281-0.968-0.708-1.238 0.132-0.223 0.208-0.484 0.208-0.762 0-0.828-0.672-1.5-1.5-1.5h-2.934c0.351-1.264 0.528-2.572 0.528-3.906 0-1.155-0.939-2.094-2.094-2.094s-2.094 0.939-2.094 2.094c0 1.625-0.605 2.874-1.798 3.714-0.328 0.231-0.699 0.429-1.108 0.595v-1.403h-4v10h4v-0.984c0.936 0.061 1.39 0.296 1.831 0.523 0.439 0.227 0.893 0.461 1.669 0.461h5c0.828 0 1.5-0.672 1.5-1.5 0-0.195-0.038-0.382-0.106-0.553 0.637-0.173 1.106-0.755 1.106-1.447 0-0.278-0.076-0.538-0.208-0.762 0.427-0.27 0.708-0.724 0.708-1.238zM1.5 15c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.875 11h-0.875v1h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-1v1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.533 0-0.817-0.147-1.21-0.35-0.496-0.256-1.1-0.568-2.29-0.636v-5.347c0.671-0.225 1.272-0.522 1.792-0.888 1.506-1.060 2.302-2.68 2.302-4.685 0-0.5 0.407-0.906 0.906-0.906s0.906 0.407 0.906 0.906c0 1.338-0.194 2.647-0.578 3.906-0.097 0.36-0.189 0.716-0.25 1h4.422c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5v1h0.875c0.339 0 0.625 0.229 0.625 0.5s-0.286 0.5-0.625 0.5z" })
        );
    }
    function ThumbsUp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsUp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsUp2.SVG = ThumbsUp2SVG;
    return ThumbsUp2;
})();
export const ThumbsDown = /*#__PURE__*/ (() => {
    function ThumbsDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.5 6.5c0 0.514 0.281 0.968 0.708 1.238-0.132 0.223-0.208 0.484-0.208 0.762 0 0.828 0.672 1.5 1.5 1.5h2.934c-0.351 1.264-0.528 2.572-0.528 3.906 0 1.155 0.939 2.094 2.094 2.094s2.094-0.939 2.094-2.094c0-1.625 0.605-2.874 1.798-3.714 0.328-0.231 0.699-0.429 1.108-0.595v1.403h4v-10h-4v0.984c-0.936-0.061-1.39-0.296-1.831-0.523-0.439-0.227-0.893-0.461-1.669-0.461h-5c-0.828 0-1.5 0.672-1.5 1.5 0 0.195 0.038 0.382 0.106 0.553-0.637 0.173-1.106 0.755-1.106 1.447 0 0.278 0.076 0.538 0.208 0.762-0.427 0.27-0.708 0.724-0.708 1.238zM5.5 9h-3c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM7.295 5.771c0.423-0.265 0.705-0.735 0.705-1.271 0-0.531-0.276-0.998-0.693-1.264 0.123-0.217 0.193-0.468 0.193-0.736 0-0.175-0.030-0.344-0.086-0.5h1.086c0.533 0 0.817 0.147 1.21 0.35 0.496 0.256 1.1 0.567 2.29 0.636v5.347c-0.671 0.225-1.272 0.522-1.792 0.888-1.506 1.060-2.302 2.68-2.302 4.685 0 0.5-0.407 0.906-0.906 0.906s-0.906-0.407-0.906-0.906c0-1.338 0.194-2.647 0.577-3.906 0.104-0.387 0.202-0.769 0.264-1.062 0.040-0.13 0.062-0.268 0.064-0.411 0-0.009 0.001-0.018 0.001-0.027 0-0.278-0.076-0.538-0.208-0.762 0.427-0.27 0.708-0.724 0.708-1.238 0-0.264-0.074-0.513-0.205-0.729zM3.5 2h2.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM2.5 4h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5zM2.125 6h3.75c0.339 0 0.625 0.229 0.625 0.5s-0.286 0.5-0.625 0.5h-3.75c-0.339 0-0.625-0.229-0.625-0.5s0.286-0.5 0.625-0.5zM14 2.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5z" })
        );
    }
    function ThumbsDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsDown.SVG = ThumbsDownSVG;
    return ThumbsDown;
})();
export const ThumbsDown2 = /*#__PURE__*/ (() => {
    function ThumbsDown2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.5 6.5c0 0.514 0.281 0.968 0.708 1.238-0.132 0.223-0.208 0.484-0.208 0.762 0 0.828 0.672 1.5 1.5 1.5h2.934c-0.351 1.264-0.528 2.572-0.528 3.906 0 1.155 0.939 2.094 2.094 2.094s2.094-0.939 2.094-2.094c0-1.625 0.605-2.874 1.798-3.714 0.328-0.231 0.699-0.429 1.108-0.595v1.403h4v-10h-4v0.984c-0.936-0.061-1.39-0.296-1.831-0.523-0.439-0.227-0.893-0.461-1.669-0.461h-5c-0.828 0-1.5 0.672-1.5 1.5 0 0.195 0.038 0.382 0.106 0.553-0.637 0.173-1.106 0.755-1.106 1.447 0 0.278 0.076 0.538 0.208 0.762-0.427 0.27-0.708 0.724-0.708 1.238zM14.5 2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5zM2.125 6h0.875v-1h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1v-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.533 0 0.817 0.147 1.21 0.35 0.496 0.256 1.1 0.567 2.29 0.636v5.347c-0.671 0.225-1.272 0.522-1.792 0.888-1.506 1.060-2.302 2.68-2.302 4.685 0 0.5-0.407 0.906-0.906 0.906s-0.906-0.407-0.906-0.906c0-1.338 0.194-2.647 0.577-3.906 0.097-0.36 0.189-0.716 0.25-1h-4.422c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h0.5v-1h-0.875c-0.339 0-0.625-0.229-0.625-0.5s0.286-0.5 0.625-0.5z" })
        );
    }
    function ThumbsDown2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsDown2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsDown2.SVG = ThumbsDown2SVG;
    return ThumbsDown2;
})();
export const ThumbsUp3 = /*#__PURE__*/ (() => {
    function ThumbsUp3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 9c1.141 0 0.5 3-0.5 3 0.5 0 0 2.5-1 2.5 0 1-1 1.5-2 1.5-4.224 0-2.739-1.057-7-1.5v-8c3.764-1.129 7.5-3.96 7.5-6.5 0.828 0 3 1 0 6 0 0 2.5 0 3 0 1.5 0 1 3 0 3zM3 6.5v8h1v0.5h-2c-0.55 0-1-0.675-1-1.5v-6c0-0.825 0.45-1.5 1-1.5h2v0.5h-1z" })
        );
    }
    function ThumbsUp3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsUp3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsUp3.SVG = ThumbsUp3SVG;
    return ThumbsUp3;
})();
export const ThumbsDown3 = /*#__PURE__*/ (() => {
    function ThumbsDown3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1.5 7c-1.141 0-0.5-3 0.5-3-0.5 0 0-2.5 1-2.5 0-1 1-1.5 2-1.5 4.224 0 2.739 1.057 7 1.5v8c-3.764 1.129-7.5 3.96-7.5 6.5-0.828 0-3-1 0-6 0 0-2.5 0-3 0-1.5 0-1-3 0-3zM13 9.5v-8h-1v-0.5h2c0.55 0 1 0.675 1 1.5v6c0 0.825-0.45 1.5-1 1.5h-2v-0.5h1z" })
        );
    }
    function ThumbsDown3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ThumbsDown3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ThumbsDown3.SVG = ThumbsDown3SVG;
    return ThumbsDown3;
})();
export const Height = /*#__PURE__*/ (() => {
        function HeightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M12 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z" }),
_('path', { d: "M6 1v-1h-5v16h5v-1h-4v-2h2v-1h-2v-2h2v-1h-2v-2h2v-1h-2v-2h2v-1h-2v-2z" })
            );
        }
        function Height({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HeightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Height.SVG = HeightSVG;
        return Height;
    })();
export const Man = /*#__PURE__*/ (() => {
        function ManSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M9 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z" })
            );
        }
        function Man({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ManSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Man.SVG = ManSVG;
        return Man;
    })();
export const Woman = /*#__PURE__*/ (() => {
        function WomanSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M11.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z" })
            );
        }
        function Woman({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WomanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Woman.SVG = WomanSVG;
        return Woman;
    })();
export const ManWoman = /*#__PURE__*/ (() => {
        function ManWomanSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M13 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M4 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z" }),
_('path', { d: "M15.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z" })
            );
        }
        function ManWoman({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ManWomanSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ManWoman.SVG = ManWomanSVG;
        return ManWoman;
    })();
export const Male = /*#__PURE__*/ (() => {
    function MaleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 0v2h2.586l-3.829 3.829c-0.79-0.524-1.738-0.829-2.757-0.829-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5c0-1.019-0.305-1.967-0.829-2.757l3.829-3.829v2.586h2v-6h-6zM6 13.3c-1.823 0-3.3-1.477-3.3-3.3s1.477-3.3 3.3-3.3c1.822 0 3.3 1.477 3.3 3.3s-1.477 3.3-3.3 3.3z" })
        );
    }
    function Male({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Male.SVG = MaleSVG;
    return Male;
})();
export const Female = /*#__PURE__*/ (() => {
    function FemaleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 9.9c2.282-0.463 4-2.481 4-4.9 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.419 1.718 4.437 4 4.9v2.1h-3v2h3v2h2v-2h3v-2h-3v-2.1zM4.7 5c0-1.823 1.477-3.3 3.3-3.3s3.3 1.478 3.3 3.3c0 1.822-1.477 3.3-3.3 3.3s-3.3-1.478-3.3-3.3z" })
        );
    }
    function Female({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FemaleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Female.SVG = FemaleSVG;
    return Female;
})();
export const Peace = /*#__PURE__*/ (() => {
    function PeaceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM14.5 8c0 1.484-0.494 2.891-1.404 4.035l-4.346-4.346v-6.146c1.452 0.166 2.797 0.812 3.846 1.861 1.228 1.228 1.904 2.86 1.904 4.596zM7.25 14.457c-1.205-0.138-2.336-0.606-3.285-1.361l3.285-3.285v4.646zM8.75 9.811l3.285 3.285c-0.95 0.755-2.080 1.223-3.285 1.361v-4.646zM3.404 3.404c1.049-1.049 2.394-1.695 3.846-1.861v6.146l-4.346 4.346c-0.91-1.144-1.404-2.552-1.404-4.035 0-1.736 0.676-3.369 1.904-4.596z" })
        );
    }
    function Peace({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PeaceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Peace.SVG = PeaceSVG;
    return Peace;
})();
export const YinYang = /*#__PURE__*/ (() => {
    function YinYangSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 4c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 13c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM8 8c-1.795 0-3.25 1.455-3.25 3.25s1.455 3.25 3.25 3.25c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5c1.795 0 3.25 1.455 3.25 3.25s-1.455 3.25-3.25 3.25z" })
        );
    }
    function YinYang({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YinYangSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    YinYang.SVG = YinYangSVG;
    return YinYang;
})();
export const Happy = /*#__PURE__*/ (() => {
    function HappySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8 9.356c1.812 0 3.535-0.481 5-1.327-0.228 2.788-2.393 4.971-5 4.971s-4.772-2.186-5-4.973c1.465 0.845 3.188 1.329 5 1.329zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z" })
        );
    }
    function Happy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HappySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Happy.SVG = HappySVG;
    return Happy;
})();
export const Happy2 = /*#__PURE__*/ (() => {
    function Happy2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM8 14c-2.607 0-4.772-2.186-5-4.973 1.465 0.846 3.188 1.329 5 1.329s3.535-0.481 5-1.327c-0.228 2.788-2.393 4.971-5 4.971z" })
        );
    }
    function Happy2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Happy2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Happy2.SVG = Happy2SVG;
    return Happy2;
})();
export const Smile = /*#__PURE__*/ (() => {
    function SmileSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.002 9.801l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699z" })
        );
    }
    function Smile({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SmileSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Smile.SVG = SmileSVG;
    return Smile;
})();
export const Smile2 = /*#__PURE__*/ (() => {
    function Smile2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z" })
        );
    }
    function Smile2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Smile2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Smile2.SVG = Smile2SVG;
    return Smile2;
})();
export const Tongue = /*#__PURE__*/ (() => {
    function TongueSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 9v1h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8z" })
        );
    }
    function Tongue({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TongueSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tongue.SVG = TongueSVG;
    return Tongue;
})();
export const Tongue2 = /*#__PURE__*/ (() => {
    function Tongue2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12 10h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8v1zM11 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z" })
        );
    }
    function Tongue2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tongue2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tongue2.SVG = Tongue2SVG;
    return Tongue2;
})();
export const Sad = /*#__PURE__*/ (() => {
    function SadSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM4.998 12.199l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.413 0.973 4.288 2.427l-1.286 0.772c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699z" })
        );
    }
    function Sad({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SadSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sad.SVG = SadSVG;
    return Sad;
})();
export const Sad2 = /*#__PURE__*/ (() => {
    function Sad2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z" })
        );
    }
    function Sad2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sad2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sad2.SVG = Sad2SVG;
    return Sad2;
})();
export const Wink = /*#__PURE__*/ (() => {
    function WinkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8.48 11.11c2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM5.5 5.805c-0.653 0-1.208 0.245-1.414 0.586-0.055-0.092-0.086-0.503-0.086-0.605 0-0.485 0.672-0.879 1.5-0.879s1.5 0.394 1.5 0.879c0 0.103-0.030 0.514-0.086 0.605-0.206-0.341-0.761-0.586-1.414-0.586z" })
        );
    }
    function Wink({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WinkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wink.SVG = WinkSVG;
    return Wink;
})();
export const Wink2 = /*#__PURE__*/ (() => {
    function Wink2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5.5 4.876c0.932 0 1.594 0.349 1.594 0.895 0 0.116 0.060 0.672-0.003 0.775-0.232-0.384-0.856-0.659-1.591-0.659s-1.359 0.275-1.591 0.659c-0.062-0.103-0.003-0.659-0.003-0.775 0-0.546 0.662-0.895 1.594-0.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625 2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649z" })
        );
    }
    function Wink2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wink2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wink2.SVG = Wink2SVG;
    return Wink2;
})();
export const Grin = /*#__PURE__*/ (() => {
    function GrinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-1h-10zM6 11.828c-0.415-0.148-0.796-0.388-1.118-0.71-0.569-0.569-0.882-1.321-0.882-2.118h2v2.828zM9 12h-2v-3h2v3zM11.118 11.118c-0.322 0.322-0.703 0.562-1.118 0.71v-2.828h2c0 0.797-0.313 1.549-0.882 2.118zM3.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.009 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261zM9.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.008 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261z" })
        );
    }
    function Grin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GrinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grin.SVG = GrinSVG;
    return Grin;
})();
export const Grin2 = /*#__PURE__*/ (() => {
    function Grin2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261-0 0 0 0-0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM5 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261 0 0 0 0 0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM3 9h3v3.873c-1.72-0.447-3-2.018-3-3.873zM7 13v-4h2v4h-2zM10 12.873v-3.873h3c0 1.855-1.28 3.426-3 3.873z" })
        );
    }
    function Grin2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Grin2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grin2.SVG = Grin2SVG;
    return Grin2;
})();
export const Cool = /*#__PURE__*/ (() => {
    function CoolSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM12.5 4c0.275 0 0.5 0.225 0.5 0.5v1.5c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3zM8 12c1.456 0 2.731-0.778 3.43-1.942l0.857 0.515c-0.874 1.454-2.467 2.427-4.288 2.427-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334z" })
        );
    }
    function Cool({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CoolSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cool.SVG = CoolSVG;
    return Cool;
})();
export const Cool2 = /*#__PURE__*/ (() => {
    function Cool2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 13c-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334 1.456 0 2.731-0.778 3.43-1.942l0.858 0.515c-0.874 1.454-2.467 2.427-4.288 2.427zM13 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v1.5z" })
        );
    }
    function Cool2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cool2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cool2.SVG = Cool2SVG;
    return Cool2;
})();
export const Angry = /*#__PURE__*/ (() => {
    function AngrySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772zM11.985 4.379c0.067 0.268-0.096 0.539-0.364 0.606-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606z" })
        );
    }
    function Angry({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AngrySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Angry.SVG = AngrySVG;
    return Angry;
})();
export const Angry2 = /*#__PURE__*/ (() => {
    function Angry2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z" })
        );
    }
    function Angry2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Angry2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Angry2.SVG = Angry2SVG;
    return Angry2;
})();
export const Evil = /*#__PURE__*/ (() => {
    function EvilSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 7c-0.552 0-1-0.448-1-1 0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1zM4.379 4.985c-0.268-0.067-0.431-0.338-0.364-0.606s0.338-0.431 0.606-0.364c0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334zM8 11.5c1.274 0 2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699zM16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" })
        );
    }
    function Evil({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EvilSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Evil.SVG = EvilSVG;
    return Evil;
})();
export const Evil2 = /*#__PURE__*/ (() => {
    function Evil2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z" })
        );
    }
    function Evil2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Evil2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Evil2.SVG = Evil2SVG;
    return Evil2;
})();
export const Shocked = /*#__PURE__*/ (() => {
    function ShockedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM6 11c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z" })
        );
    }
    function Shocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shocked.SVG = ShockedSVG;
    return Shocked;
})();
export const Shocked2 = /*#__PURE__*/ (() => {
    function Shocked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2zM11 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5z" })
        );
    }
    function Shocked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shocked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shocked2.SVG = Shocked2SVG;
    return Shocked2;
})();
export const Baffled = /*#__PURE__*/ (() => {
        function BaffledSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z" }),
_('path', { d: "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M5.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM5.5 4c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5v0z" }),
_('path', { d: "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z" }),
_('path', { d: "M10.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM10.5 4c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.121-2.5-2.5-2.5v0z" }),
_('path', { d: "M6 11h4v1h-4v-1z" })
            );
        }
        function Baffled({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BaffledSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baffled.SVG = BaffledSVG;
        return Baffled;
    })();
export const Baffled2 = /*#__PURE__*/ (() => {
        function Baffled2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z" }),
_('path', { d: "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM10 12h-4v-1h4v1zM10.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z" })
            );
        }
        function Baffled2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Baffled2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Baffled2.SVG = Baffled2SVG;
        return Baffled2;
    })();
export const Confused = /*#__PURE__*/ (() => {
    function ConfusedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.345 10h1.014c0.144 1.133-0.507 2.258-1.624 2.665-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725z" })
        );
    }
    function Confused({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ConfusedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Confused.SVG = ConfusedSVG;
    return Confused;
})();
export const Confused2 = /*#__PURE__*/ (() => {
    function Confused2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM10.735 12.665c-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725h1.014c0.144 1.133-0.507 2.258-1.624 2.665z" })
        );
    }
    function Confused2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Confused2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Confused2.SVG = Confused2SVG;
    return Confused2;
})();
export const Neutral = /*#__PURE__*/ (() => {
    function NeutralSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM10 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM6 11h4v1h-4v-1z" })
        );
    }
    function Neutral({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NeutralSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Neutral.SVG = NeutralSVG;
    return Neutral;
})();
export const Neutral2 = /*#__PURE__*/ (() => {
    function Neutral2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM10 12h-4v-1h4v1zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1z" })
        );
    }
    function Neutral2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Neutral2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Neutral2.SVG = Neutral2SVG;
    return Neutral2;
})();
export const Hipster = /*#__PURE__*/ (() => {
        function HipsterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z" }),
_('path', { d: "M10.561 8.439c-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.019 0.019 0.038 0.037 0.058 0.055 1.352 1.227 4.503-0.029 4.503-1.615-0.969 0.625-1.726 0.153-2.439-0.561z" }),
_('path', { d: "M5.439 8.439c0.586-0.586 1.536-0.586 2.121 0s0.586 1.536 0 2.121c-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561z" })
            );
        }
        function Hipster({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HipsterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Hipster.SVG = HipsterSVG;
        return Hipster;
    })();
export const Hipster2 = /*#__PURE__*/ (() => {
    function Hipster2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8.497 10.615c-0.020-0.018-0.039-0.036-0.058-0.055-0.293-0.293-0.439-0.677-0.439-1.060-0 0.384-0.146 0.768-0.439 1.060-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561 0.586-0.586 1.536-0.586 2.121 0 0.293 0.293 0.439 0.677 0.439 1.060 0-0.384 0.146-0.768 0.439-1.060 0.586-0.586 1.536-0.586 2.121 0 0.713 0.714 1.471 1.186 2.439 0.561 0 1.586-3.151 2.842-4.503 1.615z" })
        );
    }
    function Hipster2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Hipster2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hipster2.SVG = Hipster2SVG;
    return Hipster2;
})();
export const Wondering = /*#__PURE__*/ (() => {
    function WonderingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.652 9.4l0.351 1.2-6.828 2-0.351-1.2zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z" })
        );
    }
    function Wondering({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WonderingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wondering.SVG = WonderingSVG;
    return Wondering;
})();
export const Wondering2 = /*#__PURE__*/ (() => {
    function Wondering2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5.176 12.6l-0.351-1.2 6.828-2 0.351 1.2-6.828 2z" })
        );
    }
    function Wondering2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wondering2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wondering2.SVG = Wondering2SVG;
    return Wondering2;
})();
export const Sleepy = /*#__PURE__*/ (() => {
        function SleepySVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z" }),
_('path', { d: "M10 10.5c0 1.381-0.895 2.5-2 2.5s-2-1.119-2-2.5c0-1.381 0.895-2.5 2-2.5s2 1.119 2 2.5z" }),
_('path', { d: "M6.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M11.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" })
            );
        }
        function Sleepy({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SleepySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Sleepy.SVG = SleepySVG;
        return Sleepy;
    })();
export const Sleepy2 = /*#__PURE__*/ (() => {
    function Sleepy2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.854 5.166c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5s0.895-2.5 2-2.5 2 1.119 2 2.5-0.895 2.5-2 2.5zM11.854 5.166c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707z" })
        );
    }
    function Sleepy2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sleepy2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sleepy2.SVG = Sleepy2SVG;
    return Sleepy2;
})();
export const Frustrated = /*#__PURE__*/ (() => {
        function FrustratedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.724 4.428c-0.543-0.271-1.080-0.407-1.102-0.413-0.268-0.067-0.539 0.096-0.606 0.364s0.096 0.539 0.364 0.606c0.275 0.070 0.602 0.189 0.89 0.334-0.166 0.179-0.268 0.418-0.268 0.681 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.018-0.001-0.036-0.002-0.054-0.032-0.741-0.706-1.234-1.275-1.518z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM3.695 12.87c0.167 0.083 0.356 0.13 0.555 0.13h7.5c0.199 0 0.387-0.047 0.555-0.13-1.147 1.014-2.654 1.63-4.305 1.63s-3.158-0.616-4.305-1.63zM4 11.75v-1.5c0-0.136 0.114-0.25 0.25-0.25h1.75v2h-1.75c-0.136 0-0.25-0.114-0.25-0.25zM7 12v-2h2v2h-2zM10 12v-2h1.75c0.136 0 0.25 0.114 0.25 0.25v1.5c0 0.136-0.114 0.25-0.25 0.25h-1.75zM12.87 12.305c0.083-0.167 0.13-0.356 0.13-0.555v-1.5c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v1.5c0 0.199 0.047 0.387 0.13 0.555-1.014-1.147-1.63-2.654-1.63-4.305 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 1.651-0.616 3.158-1.63 4.305z" }),
_('path', { d: "M11.379 4.015c-0.023 0.006-0.559 0.141-1.102 0.413-0.568 0.284-1.243 0.776-1.275 1.518-0.001 0.018-0.002 0.036-0.002 0.054 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.263-0.102-0.503-0.268-0.681 0.288-0.144 0.614-0.264 0.89-0.334 0.268-0.067 0.431-0.338 0.364-0.606s-0.338-0.431-0.606-0.364z" })
            );
        }
        function Frustrated({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FrustratedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Frustrated.SVG = FrustratedSVG;
        return Frustrated;
    })();
export const Frustrated2 = /*#__PURE__*/ (() => {
        function Frustrated2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 10.25v1.5c0 0.136 0.114 0.25 0.25 0.25h1.75v-2h-1.75c-0.136 0-0.25 0.114-0.25 0.25z" }),
_('path', { d: "M7 10h2v2h-2v-2z" }),
_('path', { d: "M11.75 10h-1.75v2h1.75c0.136 0 0.25-0.114 0.25-0.25v-1.5c0-0.136-0.114-0.25-0.25-0.25z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.002 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM13 11.75c0 0.689-0.561 1.25-1.25 1.25h-7.5c-0.689 0-1.25-0.561-1.25-1.25v-1.5c0-0.689 0.561-1.25 1.25-1.25h7.5c0.689 0 1.25 0.561 1.25 1.25v1.5z" })
            );
        }
        function Frustrated2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Frustrated2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Frustrated2.SVG = Frustrated2SVG;
        return Frustrated2;
    })();
export const Crying = /*#__PURE__*/ (() => {
        function CryingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z" }),
_('path', { d: "M12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M9.5 13.375c-0.128 0-0.256-0.049-0.354-0.146-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z" }),
_('path', { d: "M11.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M11.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M4.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M4.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function Crying({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CryingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Crying.SVG = CryingSVG;
        return Crying;
    })();
export const Crying2 = /*#__PURE__*/ (() => {
    function Crying2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM9.854 13.229c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707zM12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
        );
    }
    function Crying2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Crying2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Crying2.SVG = Crying2SVG;
    return Crying2;
})();
export const Cursor = /*#__PURE__*/ (() => {
    function CursorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.119 7.589l-10.119-7.589v12.649l3.158-2.978 3.158 6.329 2.683-1.342-3.158-6.329z" })
        );
    }
    function Cursor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CursorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cursor.SVG = CursorSVG;
    return Cursor;
})();
export const Cursor2 = /*#__PURE__*/ (() => {
    function Cursor2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.819 16.018l-2.694-5.509-3.124 3.006v-13.515l10.59 8.104-4.221 0.745 2.696 5.513-3.246 1.656zM3.42 8.837l2.85 5.828 1.464-0.747-2.848-5.823 3.288-0.58-7.174-5.49v9.141l2.42-2.328z" })
        );
    }
    function Cursor2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cursor2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cursor2.SVG = Cursor2SVG;
    return Cursor2;
})();
export const Lasso = /*#__PURE__*/ (() => {
    function LassoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.894 5.157c-0.676-2.524-3.276-4.22-6.469-4.22-0.801 0-1.61 0.108-2.405 0.321-1.927 0.516-3.585 1.597-4.669 3.043-1.114 1.487-1.493 3.181-1.067 4.77 0.278 1.037 0.881 1.934 1.716 2.632v3.797c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.586c0.156 0.055 0.325 0.086 0.5 0.086 0.218 0 0.425-0.047 0.612-0.13 0.806 0.274 1.697 0.422 2.641 0.422 0.801 0 1.61-0.108 2.405-0.321 1.927-0.516 3.585-1.597 4.669-3.043 1.114-1.487 1.493-3.181 1.067-4.77zM3.5 12c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM8.867 11.884c-0.7 0.188-1.412 0.283-2.114 0.283-0.641 0-1.252-0.078-1.819-0.225 0.043-0.14 0.066-0.288 0.066-0.442 0-0.828-0.672-1.5-1.5-1.5-0.451 0-0.855 0.199-1.13 0.515-0.478-0.493-0.823-1.078-0.999-1.734-0.335-1.249-0.022-2.6 0.881-3.804 0.933-1.245 2.375-2.18 4.060-2.631 0.7-0.188 1.411-0.283 2.114-0.283 2.677 0 4.84 1.361 5.382 3.386 0.705 2.63-1.512 5.517-4.94 6.435z" })
        );
    }
    function Lasso({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LassoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lasso.SVG = LassoSVG;
    return Lasso;
})();
export const Lasso2 = /*#__PURE__*/ (() => {
        function Lasso2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 12.163c-0.082 0.003-0.165 0.004-0.247 0.004-0.641 0-1.252-0.078-1.819-0.225 0.043-0.14 0.066-0.288 0.066-0.442 0-0.828-0.672-1.5-1.5-1.5-0.451 0-0.855 0.199-1.13 0.515-0.478-0.493-0.823-1.078-0.999-1.734-0.335-1.249-0.022-2.6 0.881-3.804 0.933-1.245 2.375-2.18 4.060-2.631 0.7-0.188 1.412-0.283 2.114-0.283 2.677 0 4.84 1.361 5.382 3.386 0.226 0.845 0.151 1.716-0.169 2.54l0.927 0.697c0.52-1.151 0.639-2.367 0.328-3.528-0.676-2.524-3.276-4.22-6.469-4.22-0.801 0-1.61 0.108-2.405 0.321-1.927 0.516-3.585 1.597-4.669 3.043-1.114 1.487-1.493 3.181-1.067 4.77 0.278 1.037 0.881 1.934 1.716 2.632v3.797c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.586c0.156 0.055 0.325 0.086 0.5 0.086 0.218 0 0.425-0.047 0.612-0.13 0.806 0.274 1.697 0.422 2.641 0.422 0.082 0 0.165-0.001 0.247-0.004v-1.125zM3.5 12c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8 5v9.978l3.554-2.871 4.427-1.107z" }),
_('path', { d: "M12.453 11.659l-1.79 0.893 1.719 3.447 0.001-0.002 1.788-0.892z" })
            );
        }
        function Lasso2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Lasso2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Lasso2.SVG = Lasso2SVG;
        return Lasso2;
    })();
export const Select = /*#__PURE__*/ (() => {
        function SelectSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.048 10.875h2.952v-0.25h-2.994c0.007 0.085 0.021 0.169 0.042 0.25z" }),
_('path', { d: "M0.284 11.375h2.716v-0.25h-2.862c0.041 0.088 0.090 0.172 0.146 0.25z" }),
_('path', { d: "M0.903 11.875h2.097v-0.25h-2.489c0.116 0.102 0.248 0.187 0.392 0.25z" }),
_('path', { d: "M13.097 0.125h-12.194c-0.144 0.063-0.276 0.148-0.392 0.25h12.978c-0.116-0.102-0.248-0.187-0.392-0.25z" }),
_('path', { d: "M13.716 0.625h-13.432c-0.056 0.078-0.106 0.162-0.146 0.25h13.725c-0.041-0.088-0.090-0.172-0.146-0.25z" }),
_('path', { d: "M13.952 1.125h-13.904c-0.021 0.081-0.035 0.165-0.042 0.25h13.989c-0.007-0.085-0.021-0.169-0.042-0.25z" }),
_('path', { d: "M14 6.375v-0.25h-0.5l0.333 0.25z" }),
_('path', { d: "M14 5.625h-1.167l0.333 0.25h0.833z" }),
_('path', { d: "M15.119 9.589l-10.119-7.589v12.649l3.158-2.978 2.16 4.329 2.683-1.342-2.16-4.329z" }),
_('path', { d: "M1.875 1.875h10.25v3.25l0.062 0.016 0.313 0.234h1.5v-0.25h-0.125v-3.25h0.125v-0.25h-14v0.25h0.125v8.25h-0.125v0.25h3v-0.25h-1.125v-8.25zM1.625 10.125h-0.25v-8.25h0.25v8.25zM1.125 10.125h-0.25v-8.25h0.25v8.25zM12.375 5.125v-3.25h0.25v3.25h-0.25zM12.875 1.875h0.25v3.25h-0.25v-3.25zM13.625 5.125h-0.25v-3.25h0.25v3.25zM0.375 1.875h0.25v8.25h-0.25v-8.25z" })
            );
        }
        function Select({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SelectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Select.SVG = SelectSVG;
        return Select;
    })();
export const Select2 = /*#__PURE__*/ (() => {
        function Select2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.002 14.658v0l-2.16-4.329 4.278-0.74-10.119-7.589v12.649l3.158-2.978 2.16 4.329z" }),
_('path', { d: "M1 10.5v-9c0-0.271 0.229-0.5 0.5-0.5h11c0.271 0 0.5 0.229 0.5 0.5v4l1 0.75v-4.75c0-0.825-0.675-1.5-1.5-1.5h-11c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h1.5v-1h-1.5c-0.271 0-0.5-0.229-0.5-0.5z" })
            );
        }
        function Select2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Select2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Select2.SVG = Select2SVG;
        return Select2;
    })();
export const PointUp = /*#__PURE__*/ (() => {
    function PointUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 9.5v-2.5c0-0.827-0.673-1.5-1.5-1.5-0.267 0-0.518 0.070-0.736 0.193-0.267-0.417-0.734-0.693-1.264-0.693-0.384 0-0.734 0.145-1 0.383-0.266-0.238-0.616-0.383-1-0.383-0.175 0-0.344 0.030-0.5 0.086v-3.586c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v6.167l-2.75-1.466c-0.227-0.131-0.486-0.201-0.75-0.201-0.827 0-1.5 0.673-1.5 1.5 0 0.412 0.164 0.796 0.461 1.082 0.004 0.004 0.008 0.007 0.012 0.011l3.737 3.407h-0.71c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-0.691l1.138-2.276c0.035-0.069 0.053-0.146 0.053-0.224zM14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM14 9.382l-1.309 2.618h-5.997l-4.544-4.143c-0.097-0.095-0.15-0.221-0.15-0.357 0-0.276 0.224-0.5 0.5-0.5 0.085 0 0.166 0.020 0.239 0.061 0.008 0.005 0.017 0.010 0.025 0.014l3.5 1.866c0.155 0.083 0.342 0.078 0.492-0.012s0.243-0.253 0.243-0.429v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2.382z" })
        );
    }
    function PointUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointUp.SVG = PointUpSVG;
    return PointUp;
})();
export const PointRight = /*#__PURE__*/ (() => {
    function PointRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 15h2.5c0.827 0 1.5-0.673 1.5-1.5 0-0.267-0.070-0.518-0.193-0.736 0.417-0.267 0.693-0.734 0.693-1.264 0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1 0-0.175-0.030-0.344-0.086-0.5h3.586c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-6.167l1.466-2.75c0.131-0.227 0.201-0.486 0.201-0.75 0-0.827-0.673-1.5-1.5-1.5-0.412 0-0.796 0.164-1.082 0.461-0.004 0.004-0.007 0.008-0.011 0.012l-3.407 3.737v-0.71c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-0.691l2.276 1.138c0.069 0.035 0.146 0.053 0.224 0.053zM2.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.618 14l-2.618-1.309v-5.997l4.143-4.544c0.095-0.097 0.221-0.15 0.357-0.15 0.276 0 0.5 0.224 0.5 0.5 0 0.085-0.020 0.166-0.061 0.239-0.005 0.008-0.010 0.017-0.014 0.025l-1.866 3.5c-0.083 0.155-0.078 0.342 0.013 0.492s0.253 0.243 0.429 0.243h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.382z" })
        );
    }
    function PointRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointRight.SVG = PointRightSVG;
    return PointRight;
})();
export const PointDown = /*#__PURE__*/ (() => {
    function PointDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 6.5v2.5c0 0.827-0.673 1.5-1.5 1.5-0.267 0-0.518-0.070-0.736-0.193-0.267 0.417-0.734 0.693-1.264 0.693-0.384 0-0.734-0.145-1-0.383-0.266 0.238-0.616 0.383-1 0.383-0.175 0-0.344-0.030-0.5-0.086v3.586c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-6.167l-2.75 1.466c-0.227 0.131-0.486 0.201-0.75 0.201-0.827 0-1.5-0.673-1.5-1.5 0-0.412 0.164-0.796 0.461-1.082 0.004-0.004 0.008-0.007 0.012-0.011l3.737-3.407h-0.71c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-0.691l1.138 2.276c0.035 0.069 0.053 0.146 0.053 0.224zM14 2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.224 0.5-0.5zM14 6.618l-1.309-2.618h-5.997l-4.544 4.143c-0.097 0.095-0.15 0.221-0.15 0.357 0 0.276 0.224 0.5 0.5 0.5 0.085 0 0.166-0.020 0.239-0.061 0.008-0.005 0.017-0.010 0.025-0.014l3.5-1.866c0.155-0.083 0.342-0.078 0.492 0.013s0.243 0.253 0.243 0.429v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.382z" })
        );
    }
    function PointDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointDown.SVG = PointDownSVG;
    return PointDown;
})();
export const PointLeft = /*#__PURE__*/ (() => {
    function PointLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.5 15h-2.5c-0.827 0-1.5-0.673-1.5-1.5 0-0.267 0.070-0.518 0.193-0.736-0.417-0.267-0.693-0.734-0.693-1.264 0-0.384 0.145-0.734 0.383-1-0.238-0.266-0.383-0.616-0.383-1 0-0.175 0.030-0.344 0.086-0.5h-3.586c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h6.167l-1.466-2.75c-0.131-0.227-0.201-0.486-0.201-0.75 0-0.827 0.673-1.5 1.5-1.5 0.412 0 0.796 0.164 1.082 0.461 0.004 0.004 0.007 0.008 0.011 0.012l3.407 3.737v-0.71c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v-0.691l-2.276 1.138c-0.069 0.035-0.146 0.053-0.224 0.053zM13.5 14c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5zM9.382 14l2.618-1.309v-5.997l-4.143-4.544c-0.095-0.097-0.221-0.15-0.357-0.15-0.276 0-0.5 0.224-0.5 0.5 0 0.085 0.020 0.166 0.061 0.239 0.005 0.008 0.010 0.017 0.014 0.025l1.866 3.5c0.083 0.155 0.078 0.342-0.012 0.492s-0.253 0.243-0.429 0.243h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.382z" })
        );
    }
    function PointLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PointLeft.SVG = PointLeftSVG;
    return PointLeft;
})();
export const Pointer = /*#__PURE__*/ (() => {
    function PointerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 16h-5c-0.133 0-0.26-0.053-0.354-0.146l-3-3c-0.027-0.027-0.050-0.056-0.070-0.089l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.11l5.621 1.405c0.223 0.056 0.379 0.256 0.379 0.485v6c0 0.078-0.018 0.154-0.053 0.224l-1.5 3c-0.085 0.169-0.258 0.276-0.447 0.276zM7.207 15h4.484l1.309-2.618v-5.492l-1-0.25v2.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.11l-1-0.25v2.36c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.61l-1-0.25v3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.213 3.54 2.813 2.813z" })
        );
    }
    function Pointer({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PointerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pointer.SVG = PointerSVG;
    return Pointer;
})();
export const Reminder = /*#__PURE__*/ (() => {
    function ReminderSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.621 7.015l-5.621-1.405v-1.49c1.012 0.585 1.852 0.881 2.5 0.881 1.379 0 2.5-1.122 2.5-2.5s-1.121-2.5-2.5-2.5c-0.708 0-1.644 0.353-2.784 1.050-0.065-0.031-0.138-0.050-0.216-0.050h-2c-0.077 0-0.15 0.018-0.216 0.050-1.14-0.696-2.076-1.050-2.784-1.050-1.379 0-2.5 1.121-2.5 2.5s1.121 2.5 2.5 2.5c0.648 0 1.488-0.296 2.5-0.881v5l-1.616-1.939c-0.164-0.196-0.449-0.238-0.661-0.096l-1.5 1c-0.225 0.15-0.29 0.452-0.147 0.681l2.5 4c0.020 0.032 0.044 0.062 0.070 0.088l3 3c0.094 0.094 0.221 0.146 0.354 0.146h5c0.189 0 0.363-0.107 0.447-0.276l1.5-3c0.035-0.069 0.053-0.146 0.053-0.224v-5c0-0.229-0.156-0.429-0.379-0.485zM12 2.5c0 0.827-0.673 1.5-1.5 1.5-0.673 0-1.677-0.526-2.5-1.050v-0.9c0.823-0.525 1.827-1.050 2.5-1.050 0.827 0 1.5 0.673 1.5 1.5zM2.5 4c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5c0.673 0 1.677 0.526 2.5 1.050v0.9c-0.823 0.525-1.827 1.050-2.5 1.050zM13 12.382l-1.309 2.618h-4.484l-2.813-2.813-2.212-3.54 0.722-0.481 2.212 2.655c0.135 0.162 0.356 0.222 0.554 0.15s0.33-0.26 0.33-0.47v-7.014c0.197-0.135 0.367-0.258 0.5-0.357 0.133 0.098 0.303 0.221 0.5 0.357v6.014c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.86l1 0.25v2.61c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.36l1 0.25v3.11c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.86l1 0.25v4.492z" })
        );
    }
    function Reminder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ReminderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reminder.SVG = ReminderSVG;
    return Reminder;
})();
export const DragLeftRight = /*#__PURE__*/ (() => {
        function DragLeftRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 21 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 21 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 3v-2.5l-3.5 3.5 3.5 3.5v-2.5h4v-2z" }),
_('path', { d: "M17 3v-2.5l3.5 3.5-3.5 3.5v-2.5h-4v-2z" }),
_('path', { d: "M17.5 16h-9.5c-0.172 0-0.333-0.089-0.424-0.235l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.11l5.621 1.405c0.223 0.056 0.379 0.256 0.379 0.485v6c0 0.276-0.224 0.5-0.5 0.5v0zM8.277 15h8.723v-5.11l-1-0.25v2.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.11l-1-0.25v2.36c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.61l-1-0.25v3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.096 3.353z" })
            );
        }
        function DragLeftRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DragLeftRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DragLeftRight.SVG = DragLeftRightSVG;
        return DragLeftRight;
    })();
export const DragLeft = /*#__PURE__*/ (() => {
        function DragLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 21 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 21 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.5 16h9.5c0.172 0 0.333-0.089 0.424-0.235l2.5-4c0.143-0.229 0.078-0.531-0.147-0.681l-1.5-1c-0.213-0.142-0.498-0.1-0.661 0.096l-1.616 1.939v-7.619c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v3.11l-5.621 1.405c-0.223 0.056-0.379 0.256-0.379 0.485v6c0 0.276 0.224 0.5 0.5 0.5zM17.723 15h-8.723v-5.11l1-0.25v2.86c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.11l1-0.25v2.36c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.61l1-0.25v3.86c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-7.5h1v8.5c0 0.21 0.132 0.398 0.33 0.47s0.42 0.012 0.554-0.15l2.212-2.655 0.722 0.481-2.096 3.353z" }),
_('path', { d: "M12 6.938c0.082 0 0.165-0.020 0.242-0.063 0.242-0.134 0.329-0.438 0.195-0.68-0.286-0.515-0.437-1.102-0.437-1.695 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 0.594-0.151 1.18-0.437 1.695-0.134 0.241-0.047 0.546 0.195 0.68s0.546 0.047 0.68-0.195c0.368-0.663 0.563-1.417 0.563-2.18 0-2.481-2.019-4.5-4.5-4.5s-4.5 2.019-4.5 4.5c0 0.763 0.195 1.517 0.563 2.181 0.091 0.165 0.262 0.258 0.438 0.258z" }),
_('path', { d: "M0.5 4l3.5-3.5v2.5h6v2h-6v2.5z" })
            );
        }
        function DragLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DragLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DragLeft.SVG = DragLeftSVG;
        return DragLeft;
    })();
export const DragRight = /*#__PURE__*/ (() => {
        function DragRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 21 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 21 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12.5 16h-9.5c-0.172 0-0.333-0.089-0.424-0.235l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.11l5.621 1.405c0.223 0.056 0.379 0.256 0.379 0.485v6c0 0.276-0.224 0.5-0.5 0.5zM3.277 15h8.723v-5.11l-1-0.25v2.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.11l-1-0.25v2.36c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.61l-1-0.25v3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.096 3.353z" }),
_('path', { d: "M9 6.938c-0.082 0-0.165-0.020-0.242-0.063-0.242-0.134-0.329-0.438-0.195-0.68 0.286-0.515 0.437-1.102 0.437-1.695 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 0.594 0.151 1.18 0.437 1.695 0.134 0.241 0.047 0.546-0.195 0.68s-0.546 0.047-0.68-0.195c-0.368-0.663-0.563-1.417-0.563-2.18 0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 0.763-0.195 1.517-0.563 2.181-0.091 0.165-0.262 0.258-0.438 0.258z" }),
_('path', { d: "M20.5 4l-3.5-3.5v2.5h-6v2h6v2.5z" })
            );
        }
        function DragRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DragRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        DragRight.SVG = DragRightSVG;
        return DragRight;
    })();
export const Touch = /*#__PURE__*/ (() => {
        function TouchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.5 16h-9.5c-0.172 0-0.333-0.089-0.424-0.235l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.11l5.621 1.405c0.223 0.056 0.379 0.256 0.379 0.485v6c0 0.276-0.224 0.5-0.5 0.5zM4.277 15h8.723v-5.11l-1-0.25v2.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.11l-1-0.25v2.36c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.61l-1-0.25v3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.096 3.353z" }),
_('path', { d: "M10 6.938c-0.082 0-0.165-0.020-0.242-0.063-0.242-0.134-0.329-0.438-0.195-0.68 0.286-0.515 0.437-1.102 0.437-1.695 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 0.594 0.151 1.18 0.437 1.695 0.134 0.241 0.047 0.546-0.195 0.68s-0.546 0.047-0.68-0.195c-0.368-0.663-0.563-1.417-0.563-2.18 0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 0.763-0.195 1.517-0.563 2.181-0.091 0.165-0.262 0.258-0.438 0.258z" })
            );
        }
        function Touch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TouchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Touch.SVG = TouchSVG;
        return Touch;
    })();
export const Multitouch = /*#__PURE__*/ (() => {
        function MultitouchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.5 16h-9.5c-0.172 0-0.333-0.089-0.424-0.235l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v3.11l5.621 1.405c0.223 0.056 0.379 0.256 0.379 0.485v6c0 0.276-0.224 0.5-0.5 0.5v0zM6.277 15h8.723v-5.11l-1-0.25v2.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-3.11l-1-0.25v2.36c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.61l-1-0.25v3.86c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.096 3.353z" }),
_('path', { d: "M11.5 5c-0.276 0-0.5-0.224-0.5-0.5 0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M2.5 14.663c-0.072 0-0.145-0.016-0.214-0.049-0.674-0.32-1.244-0.821-1.649-1.449-0.416-0.645-0.636-1.394-0.636-2.165 0-2.206 1.794-4 4-4 0.6 0 1.177 0.13 1.715 0.385 0.249 0.119 0.356 0.417 0.237 0.666s-0.417 0.356-0.666 0.237c-0.403-0.191-0.835-0.288-1.285-0.288-1.654 0-3 1.346-3 3 0 1.152 0.673 2.217 1.715 2.712 0.249 0.118 0.356 0.417 0.237 0.666-0.086 0.18-0.265 0.286-0.452 0.286z" })
            );
        }
        function Multitouch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MultitouchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Multitouch.SVG = MultitouchSVG;
        return Multitouch;
    })();
export const TouchZoom = /*#__PURE__*/ (() => {
        function TouchZoomSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.621 9.015l-5.621-1.405v-3.11c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v8.133l-3.25-1.879c-0.218-0.126-0.495-0.070-0.648 0.13l-1 1.313c-0.161 0.211-0.129 0.51 0.072 0.683l3.5 3c0.091 0.078 0.206 0.12 0.325 0.12h9.5c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.229-0.156-0.429-0.379-0.485zM15 15h-8.815l-3.001-2.572 0.447-0.587 3.619 2.092c0.155 0.089 0.345 0.089 0.5 0s0.25-0.254 0.25-0.433v-8.5h1v7.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.86l1 0.25v2.61c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.36l1 0.25v3.11c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.86l1 0.25v5.11z" }),
_('path', { d: "M5.5 4h-2c-0.202 0-0.385 0.122-0.462 0.309s-0.035 0.402 0.108 0.545l0.75 0.75-2.293 2.293-0.75-0.75c-0.143-0.143-0.358-0.186-0.545-0.108s-0.309 0.26-0.309 0.462v2c0 0.276 0.224 0.5 0.5 0.5h2c0.202 0 0.385-0.122 0.462-0.309s0.035-0.402-0.108-0.545l-0.75-0.75 2.293-2.293 0.75 0.75c0.143 0.143 0.358 0.186 0.545 0.108s0.309-0.26 0.309-0.462v-2c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function TouchZoom({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TouchZoomSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TouchZoom.SVG = TouchZoomSVG;
        return TouchZoom;
    })();
export const TouchPinch = /*#__PURE__*/ (() => {
        function TouchPinchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.621 9.015l-5.621-1.405v-3.11c0-0.276-0.224-0.5-0.5-0.5h-2c-0.276 0-0.5 0.224-0.5 0.5v8.133l-3.25-1.879c-0.218-0.126-0.495-0.070-0.648 0.13l-1 1.313c-0.161 0.211-0.129 0.51 0.072 0.683l3.5 3c0.091 0.078 0.206 0.12 0.325 0.12h9.5c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.229-0.156-0.429-0.379-0.485zM15 15h-8.815l-3.001-2.572 0.447-0.587 3.619 2.092c0.155 0.089 0.345 0.089 0.5 0s0.25-0.254 0.25-0.433v-8.5h1v7.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.86l1 0.25v2.61c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.36l1 0.25v3.11c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.86l1 0.25v5.11z" }),
_('path', { d: "M5.854 6.146l-0.75-0.75 0.792-0.792c0.138-0.138 0.138-0.363 0-0.501s-0.363-0.138-0.501 0c-0.007 0.007-0.013 0.014-0.019 0.021l-0.772 0.772-0.75-0.75c-0.143-0.143-0.358-0.186-0.545-0.108s-0.309 0.26-0.309 0.462v2c0 0.276 0.224 0.5 0.5 0.5h2c0.202 0 0.385-0.122 0.462-0.309s0.035-0.402-0.108-0.545z" }),
_('path', { d: "M0.146 7.854l0.75 0.75-0.792 0.792c-0.138 0.138-0.138 0.363 0 0.501s0.363 0.138 0.501 0c0.007-0.007 0.013-0.014 0.019-0.021l0.772-0.773 0.75 0.75c0.143 0.143 0.358 0.186 0.545 0.108s0.309-0.26 0.309-0.462v-2c0-0.276-0.224-0.5-0.5-0.5h-2c-0.202 0-0.385 0.122-0.462 0.309s-0.035 0.402 0.108 0.545z" })
            );
        }
        function TouchPinch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TouchPinchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        TouchPinch.SVG = TouchPinchSVG;
        return TouchPinch;
    })();
export const Hand = /*#__PURE__*/ (() => {
    function HandSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 16h-5c-0.133 0-0.26-0.053-0.354-0.146l-3-3c-0.027-0.027-0.050-0.056-0.070-0.089l-2.5-4c-0.143-0.229-0.078-0.531 0.147-0.681l1.5-1c0.213-0.142 0.498-0.1 0.661 0.096l1.616 1.939v-7.619c0-0.276 0.224-0.5 0.5-0.5h1.5v-0.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h1.5c0.276 0 0.5 0.224 0.5 0.5v1.5h1.5c0.276 0 0.5 0.224 0.5 0.5v9c0 0.078-0.018 0.154-0.053 0.224l-1.5 3c-0.085 0.169-0.258 0.276-0.447 0.276zM7.207 15h4.484l1.309-2.618v-8.382h-1v4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6.5h-1v6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-7.5h-1v7.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-6.5h-1v8.5c0 0.21-0.132 0.398-0.33 0.47s-0.42 0.012-0.554-0.15l-2.212-2.655-0.722 0.481 2.213 3.54 2.813 2.813z" })
        );
    }
    function Hand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hand.SVG = HandSVG;
    return Hand;
})();
export const Grab = /*#__PURE__*/ (() => {
    function GrabSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 16h-5c-0.119 0-0.235-0.043-0.325-0.12l-3.5-3c-0.111-0.095-0.175-0.234-0.175-0.38v-4c0-0.276 0.224-0.5 0.5-0.5h1.5v-2.5c0-0.276 0.224-0.5 0.5-0.5h2c0 0 0 0 0 0h4c0.276 0 0.5 0.224 0.5 0.5v0.5h1.5c0.276 0 0.5 0.224 0.5 0.5v6c0 0.078-0.018 0.154-0.053 0.224l-1.5 3c-0.085 0.169-0.258 0.276-0.447 0.276zM7.185 15h4.506l1.309-2.618v-5.382h-1v1.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.5h-1v2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.5h-1v2.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-2.5h-1v4.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1.5h-1v3.27l3.185 2.73z" })
        );
    }
    function Grab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GrabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Grab.SVG = GrabSVG;
    return Grab;
})();
export const StackEmpty = /*#__PURE__*/ (() => {
    function StackEmptySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-12h-11v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945zM6 2h9v10h-9v-10zM5 3.070v9.93h2.543l-2.721 0.382-1.418-10.088 1.595-0.224zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894z" })
        );
    }
    function StackEmpty({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackEmptySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackEmpty.SVG = StackEmptySVG;
    return StackEmpty;
})();
export const StackPlus = /*#__PURE__*/ (() => {
    function StackPlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM13 8h-2v2h-1v-2h-2v-1h2v-2h1v2h2z" })
        );
    }
    function StackPlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackPlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackPlus.SVG = StackPlusSVG;
    return StackPlus;
})();
export const StackMinus = /*#__PURE__*/ (() => {
    function StackMinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM8 7h5v1h-5z" })
        );
    }
    function StackMinus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackMinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackMinus.SVG = StackMinusSVG;
    return StackMinus;
})();
export const StackStar = /*#__PURE__*/ (() => {
    function StackStarSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM10.5 3.814l0.715 2.202h2.315l-1.873 1.361 0.715 2.201-1.873-1.361-1.873 1.361 0.715-2.201-1.873-1.361h2.315z" })
        );
    }
    function StackStar({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackStarSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackStar.SVG = StackStarSVG;
    return StackStar;
})();
export const StackPicture = /*#__PURE__*/ (() => {
    function StackPictureSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM10 11h-3l1-4h1l2.333 2.333 0.667-1.333h1l1 3zM11 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z" })
        );
    }
    function StackPicture({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackPictureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackPicture.SVG = StackPictureSVG;
    return StackPicture;
})();
export const StackDown = /*#__PURE__*/ (() => {
    function StackDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-12h-11v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945zM6 2h9v10h-9v-10zM5 3.070v9.93h2.543l-2.721 0.382-1.418-10.088 1.595-0.224zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM14.5 7l-4 4-4-4h2.5v-3h3v3z" })
        );
    }
    function StackDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackDown.SVG = StackDownSVG;
    return StackDown;
})();
export const StackUp = /*#__PURE__*/ (() => {
    function StackUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-12h-11v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945zM6 2h9v10h-9v-10zM5 3.070v9.93h2.543l-2.721 0.382-1.418-10.088 1.595-0.224zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM6.5 7l4-4 4 4h-2.5v3h-3v-3z" })
        );
    }
    function StackUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackUp.SVG = StackUpSVG;
    return StackUp;
})();
export const StackCancel = /*#__PURE__*/ (() => {
    function StackCancelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM13 8.939v1.061h-1.061l-1.439-1.439-1.439 1.439h-1.061v-1.061l1.439-1.439-1.439-1.439v-1.061h1.061l1.439 1.439 1.439-1.439h1.061v1.061l-1.439 1.439z" })
        );
    }
    function StackCancel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackCancelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackCancel.SVG = StackCancelSVG;
    return StackCancel;
})();
export const StackCheck = /*#__PURE__*/ (() => {
    function StackCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM6 12v-10h9v2.5l-0.707-0.707-4.293 3.793-2.293-1.793-0.914 0.914 3.207 3.707 5-5.48v7.066h-9z" })
        );
    }
    function StackCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackCheck.SVG = StackCheckSVG;
    return StackCheck;
})();
export const StackText = /*#__PURE__*/ (() => {
    function StackTextSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 13v-12h-11v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945zM6 2h9v10h-9v-10zM5 3.070v9.93h2.543l-2.721 0.382-1.418-10.088 1.595-0.224zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM7 3h7v1h-7zM7 5h7v1h-7zM7 7h7v1h-7zM7 9h5v1h-5z" })
        );
    }
    function StackText({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackTextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackText.SVG = StackTextSVG;
    return StackText;
})();
export const StackClubs = /*#__PURE__*/ (() => {
    function StackClubsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM7 7.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11 7.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM12 4.844c0 0.466-0.212 0.881-0.545 1.156-0.455 0.484-0.455 1-0.455 1.5v1c0 1 0 2 1 2v0.5h-3v-0.5c1 0 1-1 1-2v-1c0-0.5 0-1.016-0.455-1.5-0.333-0.275-0.545-0.691-0.545-1.156 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
        );
    }
    function StackClubs({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackClubsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackClubs.SVG = StackClubsSVG;
    return StackClubs;
})();
export const StackSpades = /*#__PURE__*/ (() => {
    function StackSpadesSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM10.5 2.063c0 2.828 3.5 2.938 3.5 5.438 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v1c0 1 0 2 1 2v0.5h-3v-0.5c1 0 1-1 1-2v-1c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-2.5 3.5-2.609 3.5-5.438z" })
        );
    }
    function StackSpades({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackSpadesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackSpades.SVG = StackSpadesSVG;
    return StackSpades;
})();
export const StackHearts = /*#__PURE__*/ (() => {
    function StackHeartsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM13.926 5.416c0.048 0.133 0.074 0.305 0.074 0.521 0 2.5-3.5 2.5-3.5 5 0-2.5-3.5-2.5-3.5-5 0-0.216 0.026-0.388 0.074-0.521 0.226-0.782 0.821-1.354 1.676-1.354 0.695 0 1.426 0.597 1.75 1.159 0.324-0.562 1.055-1.159 1.75-1.159 0.855 0 1.45 0.572 1.676 1.354z" })
        );
    }
    function StackHearts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackHeartsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackHearts.SVG = StackHeartsSVG;
    return StackHearts;
})();
export const StackDiamonds = /*#__PURE__*/ (() => {
    function StackDiamondsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM10.5 11l-2.5-4 2.5-4 2.5 4z" })
        );
    }
    function StackDiamonds({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackDiamondsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackDiamonds.SVG = StackDiamondsSVG;
    return StackDiamonds;
})();
export const StackUser = /*#__PURE__*/ (() => {
    function StackUserSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM13 9v1h-5v-1c0-0.55 0.45-1 1-1h3c0.55 0 1 0.45 1 1zM9 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z" })
        );
    }
    function StackUser({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackUserSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackUser.SVG = StackUserSVG;
    return StackUser;
})();
export const Stack4 = /*#__PURE__*/ (() => {
    function Stack4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM7 7.125h7v0.25h-7zM7 7.625h7v0.25h-7zM7 8.625h7v0.25h-7zM7 8.125h7v0.25h-7zM7 9.125h7v0.25h-7zM7 10.625h7v0.25h-7zM7 9.625h7v0.25h-7zM7 10.125h7v0.25h-7zM7 4.625h7v0.25h-7zM7 3.625h7v0.25h-7zM7 4.125h7v0.25h-7zM7 3.125h7v0.25h-7zM7 6.625h7v0.25h-7zM7 6.125h7v0.25h-7zM7 5.125h7v0.25h-7zM7 5.625h7v0.25h-7z" })
        );
    }
    function Stack4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stack4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stack4.SVG = Stack4SVG;
    return Stack4;
})();
export const StackMusic = /*#__PURE__*/ (() => {
    function StackMusicSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM8.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.175 0 0.344 0.030 0.5 0.086v-4.086l5-1v5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5 0.175 0 0.344 0.030 0.5 0.086v-1.886l-3 0.6v3.7c0 0.828-0.672 1.5-1.5 1.5z" })
        );
    }
    function StackMusic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackMusicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackMusic.SVG = StackMusicSVG;
    return StackMusic;
})();
export const StackPlay = /*#__PURE__*/ (() => {
    function StackPlaySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 1v1.155l-2.619 0.368 0.17 1.211-2.551 0.732 3.308 11.535 10.189-2.921 0.558-0.079h1.945v-12h-11zM3.929 14.879l-2.808-9.793 1.558-0.447 1.373 9.766 2.997-0.421-3.119 0.894zM4.822 13.382l-1.418-10.088 1.595-0.224v9.93h2.543l-2.721 0.382zM15 12h-9v-10h9v10zM9 4l5 3-5 3z" })
        );
    }
    function StackPlay({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackPlaySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    StackPlay.SVG = StackPlaySVG;
    return StackPlay;
})();
export const Move = /*#__PURE__*/ (() => {
    function MoveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8l-4-3v2h-3v-3h2l-3-4-3 4h2v3h-3v-2l-4 3 4 3v-2h3v3h-2l3 4 3-4h-2v-3h3v2z" })
        );
    }
    function Move({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MoveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Move.SVG = MoveSVG;
    return Move;
})();
export const Dots = /*#__PURE__*/ (() => {
    function DotsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1h2v2h-2zM13 5h2v2h-2zM9 5h2v2h-2zM13 9h2v2h-2zM9 9h2v2h-2zM5 9h2v2h-2zM9 13h2v2h-2zM5 13h2v2h-2zM1 13h2v2h-2zM13 13h2v2h-2z" })
        );
    }
    function Dots({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DotsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dots.SVG = DotsSVG;
    return Dots;
})();
export const Warning = /*#__PURE__*/ (() => {
        function WarningSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z" }),
_('path', { d: "M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" }),
_('path', { d: "M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z" })
            );
        }
        function Warning({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WarningSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Warning.SVG = WarningSVG;
        return Warning;
    })();
export const Warning2 = /*#__PURE__*/ (() => {
    function Warning2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.781 14.309v0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698s-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691zM8 14c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 10c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3z" })
        );
    }
    function Warning2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Warning2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Warning2.SVG = Warning2SVG;
    return Warning2;
})();
export const Notification = /*#__PURE__*/ (() => {
    function NotificationSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8zM7 11h2v2h-2zM7 3h2v6h-2z" })
        );
    }
    function Notification({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NotificationSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Notification.SVG = NotificationSVG;
    return Notification;
})();
export const Notification2 = /*#__PURE__*/ (() => {
    function Notification2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z" })
        );
    }
    function Notification2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Notification2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Notification2.SVG = Notification2SVG;
    return Notification2;
})();
export const Question = /*#__PURE__*/ (() => {
    function QuestionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 11h2v2h-2zM11 4c0.552 0 1 0.448 1 1v3l-3 2h-2v-1l3-2v-1h-5v-2h6zM8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8z" })
        );
    }
    function Question({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( QuestionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Question.SVG = QuestionSVG;
    return Question;
})();
export const Question2 = /*#__PURE__*/ (() => {
    function Question2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM9 13h-2v-2h2v2zM12 8l-3 2h-2v-1l3-2v-1h-5v-2h6c0.552 0 1 0.448 1 1v3z" })
        );
    }
    function Question2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Question2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Question2.SVG = Question2SVG;
    return Question2;
})();
export const Question3 = /*#__PURE__*/ (() => {
        function Question3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 12c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1 1 0.448 1 1z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M8 10.004c-0.414 0-0.75-0.336-0.75-0.75v-0.5c0-0.525 0.203-0.998 0.602-1.404 0.295-0.3 0.653-0.525 0.999-0.742 0.712-0.447 1.024-0.687 1.024-1.107 0-0.457-0.264-0.762-0.485-0.938-0.355-0.282-0.849-0.437-1.39-0.437-0.821 0-1.559 0.548-1.796 1.333-0.12 0.397-0.538 0.621-0.934 0.502s-0.621-0.538-0.502-0.934c0.205-0.68 0.631-1.291 1.2-1.721 0.589-0.445 1.292-0.68 2.031-0.68 0.878 0 1.703 0.271 2.322 0.762 0.679 0.539 1.053 1.289 1.053 2.113 0 1.293-0.998 1.92-1.726 2.377-0.611 0.384-0.899 0.596-0.899 0.876v0.5c0 0.414-0.336 0.75-0.75 0.75z" })
            );
        }
        function Question3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Question3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Question3.SVG = Question3SVG;
        return Question3;
    })();
export const Question4 = /*#__PURE__*/ (() => {
    function Question4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 13c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM9.649 7.877c-0.611 0.384-0.899 0.596-0.899 0.876v0.5c0 0.414-0.336 0.75-0.75 0.75s-0.75-0.336-0.75-0.75v-0.5c0-0.525 0.203-0.998 0.602-1.404 0.295-0.3 0.653-0.525 0.999-0.742 0.712-0.447 1.024-0.687 1.024-1.107 0-0.457-0.264-0.762-0.485-0.938-0.355-0.282-0.849-0.437-1.39-0.437-0.821 0-1.559 0.548-1.796 1.333-0.12 0.397-0.538 0.621-0.934 0.502s-0.621-0.538-0.502-0.934c0.205-0.68 0.631-1.291 1.2-1.721 0.589-0.445 1.292-0.68 2.031-0.68 0.878 0 1.703 0.271 2.322 0.762 0.679 0.539 1.053 1.289 1.053 2.113 0 1.293-0.998 1.92-1.726 2.377z" })
        );
    }
    function Question4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Question4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Question4.SVG = Question4SVG;
    return Question4;
})();
export const Question5 = /*#__PURE__*/ (() => {
    function Question5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 13h3v3h-3zM12.5 1c0.828 0 1.5 0.672 1.5 1.5v4.5l-5 3v2h-3v-3l5-3v-2h-8v-3h9.5z" })
        );
    }
    function Question5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Question5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Question5.SVG = Question5SVG;
    return Question5;
})();
export const Question6 = /*#__PURE__*/ (() => {
        function Question6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 13c-0.552 0-1-0.448-1-1v-1.027c0-1.41 1.124-2.477 2.212-3.509 0.879-0.834 1.788-1.697 1.788-2.464 0-1.493-1.082-3-3.5-3-1.787 0-3.283 1.337-3.479 3.11-0.061 0.549-0.555 0.945-1.104 0.884s-0.945-0.555-0.884-1.104c0.148-1.338 0.782-2.572 1.785-3.477 1.011-0.911 2.319-1.413 3.681-1.413 1.475 0 2.834 0.463 3.828 1.305 1.078 0.913 1.672 2.225 1.672 3.695 0 1.626-1.281 2.842-2.411 3.915-0.745 0.707-1.589 1.508-1.589 2.058l0 1.027c0 0.552-0.448 1-1 1z" }),
_('path', { d: "M9 15c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
            );
        }
        function Question6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Question6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Question6.SVG = Question6SVG;
        return Question6;
    })();
export const Plus = /*#__PURE__*/ (() => {
    function PlusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5h-5v-5h-6v5h-5v6h5v5h6v-5h5z" })
        );
    }
    function Plus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plus.SVG = PlusSVG;
    return Plus;
})();
export const Minus = /*#__PURE__*/ (() => {
    function MinusSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h16v6h-16z" })
        );
    }
    function Minus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Minus.SVG = MinusSVG;
    return Minus;
})();
export const Plus2 = /*#__PURE__*/ (() => {
    function Plus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
        );
    }
    function Plus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Plus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plus2.SVG = Plus2SVG;
    return Plus2;
})();
export const Minus2 = /*#__PURE__*/ (() => {
    function Minus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z" })
        );
    }
    function Minus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Minus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Minus2.SVG = Minus2SVG;
    return Minus2;
})();
export const Plus3 = /*#__PURE__*/ (() => {
    function Plus3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 7h-6v-6h-2v6h-6v2h6v6h2v-6h6z" })
        );
    }
    function Plus3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Plus3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Plus3.SVG = Plus3SVG;
    return Plus3;
})();
export const Minus3 = /*#__PURE__*/ (() => {
    function Minus3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 7h14v2h-14v-2z" })
        );
    }
    function Minus3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Minus3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Minus3.SVG = Minus3SVG;
    return Minus3;
})();
export const PlusCircle = /*#__PURE__*/ (() => {
    function PlusCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM12 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3z" })
        );
    }
    function PlusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlusCircle.SVG = PlusCircleSVG;
    return PlusCircle;
})();
export const MinusCircle = /*#__PURE__*/ (() => {
    function MinusCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM4 7h8v2h-8z" })
        );
    }
    function MinusCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MinusCircle.SVG = MinusCircleSVG;
    return MinusCircle;
})();
export const PlusCircle2 = /*#__PURE__*/ (() => {
    function PlusCircle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 9v4h-2v-4h-4v-2h4v-4h2v4h4v2h-4z" })
        );
    }
    function PlusCircle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PlusCircle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PlusCircle2.SVG = PlusCircle2SVG;
    return PlusCircle2;
})();
export const MinusCircle2 = /*#__PURE__*/ (() => {
    function MinusCircle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM13 9h-10v-2h10v2z" })
        );
    }
    function MinusCircle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MinusCircle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MinusCircle2.SVG = MinusCircle2SVG;
    return MinusCircle2;
})();
export const Info = /*#__PURE__*/ (() => {
        function InfoSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z" }),
_('path', { d: "M10 12h-4v-1h1v-3h-1v-1h3v4h1z" }),
_('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" })
            );
        }
        function Info({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Info.SVG = InfoSVG;
        return Info;
    })();
export const Info2 = /*#__PURE__*/ (() => {
    function Info2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM7 3.75c0-0.413 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.337 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5zM10 13h-4v-1h1v-4h-1v-1h3v5h1v1z" })
        );
    }
    function Info2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Info2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Info2.SVG = Info2SVG;
    return Info2;
})();
export const CancelCircle = /*#__PURE__*/ (() => {
        function CancelCircleSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z" })
            );
        }
        function CancelCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CancelCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CancelCircle.SVG = CancelCircleSVG;
        return CancelCircle;
    })();
export const CancelCircle2 = /*#__PURE__*/ (() => {
    function CancelCircle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12 10.5l-1.5 1.5-2.5-2.5-2.5 2.5-1.5-1.5 2.5-2.5-2.5-2.5 1.5-1.5 2.5 2.5 2.5-2.5 1.5 1.5-2.5 2.5 2.5 2.5z" })
        );
    }
    function CancelCircle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CancelCircle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CancelCircle2.SVG = CancelCircle2SVG;
    return CancelCircle2;
})();
export const Blocked = /*#__PURE__*/ (() => {
    function BlockedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z" })
        );
    }
    function Blocked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BlockedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Blocked.SVG = BlockedSVG;
    return Blocked;
})();
export const CancelSquare = /*#__PURE__*/ (() => {
        function CancelSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.996 2c0.001 0.001 0.003 0.002 0.004 0.004v11.993c-0.001 0.001-0.002 0.003-0.004 0.004h-11.993c-0.001-0.001-0.003-0.002-0.004-0.004v-11.993c0.001-0.001 0.002-0.003 0.004-0.004h11.993zM14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2v0z" }),
_('path', { d: "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z" })
            );
        }
        function CancelSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CancelSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CancelSquare.SVG = CancelSquareSVG;
        return CancelSquare;
    })();
export const CancelSquare2 = /*#__PURE__*/ (() => {
    function CancelSquare2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM12.457 11.043l-1.414 1.414-3.043-3.043-3.043 3.043-1.414-1.414 3.043-3.043-3.043-3.043 1.414-1.414 3.043 3.043 3.043-3.043 1.414 1.414-3.043 3.043 3.043 3.043z" })
        );
    }
    function CancelSquare2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CancelSquare2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CancelSquare2.SVG = CancelSquare2SVG;
    return CancelSquare2;
})();
export const Cancel = /*#__PURE__*/ (() => {
    function CancelSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 0h-7l-4.5 4.5v7l4.5 4.5h7l4.5-4.5v-7l-4.5-4.5zM12.5 11l-1.5 1.5-3-3-3 3-1.5-1.5 3-3-3-3 1.5-1.5 3 3 3-3 1.5 1.5-3 3 3 3z" })
        );
    }
    function Cancel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CancelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cancel.SVG = CancelSVG;
    return Cancel;
})();
export const Spam = /*#__PURE__*/ (() => {
    function SpamSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 11.5l-4.5-11.5h-7l-4.5 4.5v7l4.5 4.5h7l4.5-4.5v-7l-4.5-4.5zM9 13h-2v-2h2v2zM9 9h-2v-6h2v6z" })
        );
    }
    function Spam({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spam.SVG = SpamSVG;
    return Spam;
})();
export const Cross = /*#__PURE__*/ (() => {
    function CrossSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z" })
        );
    }
    function Cross({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CrossSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cross.SVG = CrossSVG;
    return Cross;
})();
export const Cross2 = /*#__PURE__*/ (() => {
    function Cross2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.957 3.457l-1.414-1.414-4.543 4.543-4.543-4.543-1.414 1.414 4.543 4.543-4.543 4.543 1.414 1.414 4.543-4.543 4.543 4.543 1.414-1.414-4.543-4.543z" })
        );
    }
    function Cross2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cross2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cross2.SVG = Cross2SVG;
    return Cross2;
})();
export const Cross3 = /*#__PURE__*/ (() => {
    function Cross3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.207 10.793l-1.414 1.414-2.793-2.793-2.793 2.793-1.414-1.414 2.793-2.793-2.793-2.793 1.414-1.414 2.793 2.793 2.793-2.793 1.414 1.414-2.793 2.793 2.793 2.793z" })
        );
    }
    function Cross3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Cross3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Cross3.SVG = Cross3SVG;
    return Cross3;
})();
export const Checkmark = /*#__PURE__*/ (() => {
    function CheckmarkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z" })
        );
    }
    function Checkmark({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckmarkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Checkmark.SVG = CheckmarkSVG;
    return Checkmark;
})();
export const Checkmark2 = /*#__PURE__*/ (() => {
    function Checkmark2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.21 14.339l-6.217-6.119 3.084-3.035 3.133 3.083 6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369-6.713 6.607-3.133-3.083-1.391 1.369z" })
        );
    }
    function Checkmark2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Checkmark2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Checkmark2.SVG = Checkmark2SVG;
    return Checkmark2;
})();
export const Checkmark3 = /*#__PURE__*/ (() => {
    function Checkmark3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 2.5l-8.5 8.5-3.5-3.5-1.5 1.5 5 5 10-10z" })
        );
    }
    function Checkmark3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Checkmark3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Checkmark3.SVG = Checkmark3SVG;
    return Checkmark3;
})();
export const Checkmark4 = /*#__PURE__*/ (() => {
    function Checkmark4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.36 1c-5.227 3.956-10.239 9.247-10.239 9.247l-3.612-3.247-1.509 1.537c1.485 1.395 4.924 5.081 6.088 6.463 3.275-5.472 6.679-9.552 9.912-13.284l-0.64-0.716z" })
        );
    }
    function Checkmark4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Checkmark4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Checkmark4.SVG = Checkmark4SVG;
    return Checkmark4;
})();
export const Checkmark5 = /*#__PURE__*/ (() => {
    function Checkmark5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.718 3.368l-7.594 6.55-3.798-2.808-0.679 0.67 4.442 4.744 8.252-8.541-0.623-0.614zM13.772 1.754v0l2.24 2.208-9.937 10.284-6.087-6.5 2.227-2.195 3.852 2.848 7.704-6.645z" })
        );
    }
    function Checkmark5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Checkmark5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Checkmark5.SVG = Checkmark5SVG;
    return Checkmark5;
})();
export const SpellCheck = /*#__PURE__*/ (() => {
    function SpellCheckSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 4h2v3h1v-6c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v6h1v-3zM2 1h2v2h-2v-2zM15 1v-1h-3c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v-1h-3v-5h3zM10 2.5v-1.5c0-0.55-0.45-1-1-1h-3v7h3c0.55 0 1-0.45 1-1v-1.5c0-0.55-0.137-1-0.688-1 0.55 0 0.688-0.45 0.688-1zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM13 9l-6.5 7-3.5-4.5 1.281-1.094 2.219 2.313 5.5-4.719z" })
        );
    }
    function SpellCheck({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpellCheckSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SpellCheck.SVG = SpellCheckSVG;
    return SpellCheck;
})();
export const SpellCheck2 = /*#__PURE__*/ (() => {
        function SpellCheck2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.032 10l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM4.432 2h1.137l0.9 3h-2.937l0.9-3z" }),
_('path', { d: "M14 7.5l-5.5 5.5-2-2-1.5 1.5 3.5 3.5 7-7z" })
            );
        }
        function SpellCheck2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpellCheck2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpellCheck2.SVG = SpellCheck2SVG;
        return SpellCheck2;
    })();
export const Enter = /*#__PURE__*/ (() => {
        function EnterSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 13l4.5-4.5-4.5-4.5v3h-7v3h7v3z" }),
_('path', { d: "M15 16h-11v-2h10v-11h-10v-2h11c0.552 0 1 0.448 1 1v13c0 0.552-0.448 1-1 1z" })
            );
        }
        function Enter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EnterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enter.SVG = EnterSVG;
        return Enter;
    })();
export const Exit = /*#__PURE__*/ (() => {
        function ExitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 13l4.5-4.5-4.5-4.5v3h-7v3h7v3z" }),
_('path', { d: "M1 1h11v2h-10v11h10v2h-11c-0.552 0-1-0.448-1-1v-13c0-0.552 0.448-1 1-1z" })
            );
        }
        function Exit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ExitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Exit.SVG = ExitSVG;
        return Exit;
    })();
export const Enter2 = /*#__PURE__*/ (() => {
    function Enter2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0v16h-12v-5h1v3h7v-12h-7v3h-1v-5zM6 9h-6v-2h6v-3l4 4-4 4z" })
        );
    }
    function Enter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enter2.SVG = Enter2SVG;
    return Enter2;
})();
export const Exit2 = /*#__PURE__*/ (() => {
    function Exit2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 9h-7v-2h7v-3l4 4-4 4zM10 10v6h-10v-16h10v6h-1v-4h-5v12h5v-4z" })
        );
    }
    function Exit2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Exit2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Exit2.SVG = Exit2SVG;
    return Exit2;
})();
export const Enter3 = /*#__PURE__*/ (() => {
    function Enter3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 8h-5v-2h5v-2l3 3-3 3zM16 0v13l-6 3v-3h-6v-4h1v3h5v-9l4-2h-9v4h-1v-5z" })
        );
    }
    function Enter3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enter3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enter3.SVG = Enter3SVG;
    return Enter3;
})();
export const Exit3 = /*#__PURE__*/ (() => {
    function Exit3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z" })
        );
    }
    function Exit3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Exit3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Exit3.SVG = Exit3SVG;
    return Exit3;
})();
export const Wall = /*#__PURE__*/ (() => {
        function WallSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 13h4v2h-4v-2z" }),
_('path', { d: "M5 13h4v2h-4v-2z" }),
_('path', { d: "M10 13h6v2h-6v-2z" }),
_('path', { d: "M0 10h6v2h-6v-2z" }),
_('path', { d: "M7 10h4v2h-4v-2z" }),
_('path', { d: "M12 10h4v2h-4v-2z" }),
_('path', { d: "M0 7h4v2h-4v-2z" }),
_('path', { d: "M5 7h4v2h-4v-2z" }),
_('path', { d: "M10 7h6v2h-6v-2z" }),
_('path', { d: "M0 4h6v2h-6v-2z" }),
_('path', { d: "M7 4h4v2h-4v-2z" }),
_('path', { d: "M12 4h4v2h-4v-2z" }),
_('path', { d: "M0 1h4v2h-4v-2z" }),
_('path', { d: "M5 1h4v2h-4v-2z" }),
_('path', { d: "M10 1h6v2h-6v-2z" })
            );
        }
        function Wall({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( WallSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Wall.SVG = WallSVG;
        return Wall;
    })();
export const Fence = /*#__PURE__*/ (() => {
    function FenceSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 1l-1.5 1.5v2.5h-2v-2.5l-1.5-1.5-1.5 1.5v2.5h-2v-2.5l-1.5-1.5-1.5 1.5v13.5h3v-3h2v3h3v-3h2v3h3v-13.5l-1.5-1.5zM4 12v-6h2v6h-2zM9 12v-6h2v6h-2z" })
        );
    }
    function Fence({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FenceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Fence.SVG = FenceSVG;
    return Fence;
})();
export const Play3 = /*#__PURE__*/ (() => {
    function Play3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z" })
        );
    }
    function Play3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Play3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Play3.SVG = Play3SVG;
    return Play3;
})();
export const Pause = /*#__PURE__*/ (() => {
    function PauseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z" })
        );
    }
    function Pause({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PauseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pause.SVG = PauseSVG;
    return Pause;
})();
export const Stop = /*#__PURE__*/ (() => {
    function StopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h6v6h-6z" })
        );
    }
    function Stop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stop.SVG = StopSVG;
    return Stop;
})();
export const Previous = /*#__PURE__*/ (() => {
        function PreviousSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M7 8l4-3v6z" }),
_('path', { d: "M5 5h2v6h-2v-6z" })
            );
        }
        function Previous({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PreviousSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Previous.SVG = PreviousSVG;
        return Previous;
    })();
export const Next = /*#__PURE__*/ (() => {
        function NextSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14.5c3.59 0 6.5-2.91 6.5-6.5s-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5z" }),
_('path', { d: "M9 8l-4-3v6z" }),
_('path', { d: "M11 5h-2v6h2v-6z" })
            );
        }
        function Next({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NextSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Next.SVG = NextSVG;
        return Next;
    })();
export const Backward = /*#__PURE__*/ (() => {
    function BackwardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11 10.5l-3.5-2.5 3.5-2.5zM7 10.5l-3.5-2.5 3.5-2.5z" })
        );
    }
    function Backward({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BackwardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Backward.SVG = BackwardSVG;
    return Backward;
})();
export const Forward2 = /*#__PURE__*/ (() => {
    function Forward2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5.5l3.5 2.5-3.5 2.5zM9 5.5l3.5 2.5-3.5 2.5z" })
        );
    }
    function Forward2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Forward2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Forward2.SVG = Forward2SVG;
    return Forward2;
})();
export const Play4 = /*#__PURE__*/ (() => {
    function Play4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 2l10 6-10 6z" })
        );
    }
    function Play4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Play4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Play4.SVG = Play4SVG;
    return Play4;
})();
export const Pause2 = /*#__PURE__*/ (() => {
    function Pause2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 2h5v12h-5zM9 2h5v12h-5z" })
        );
    }
    function Pause2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pause2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pause2.SVG = Pause2SVG;
    return Pause2;
})();
export const Stop2 = /*#__PURE__*/ (() => {
    function Stop2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 2h12v12h-12z" })
        );
    }
    function Stop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stop2.SVG = Stop2SVG;
    return Stop2;
})();
export const Backward2 = /*#__PURE__*/ (() => {
    function Backward2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 2.5v5l5-5v11l-5-5v5l-5.5-5.5z" })
        );
    }
    function Backward2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Backward2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Backward2.SVG = Backward2SVG;
    return Backward2;
})();
export const Forward3 = /*#__PURE__*/ (() => {
    function Forward3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 13.5v-5l-5 5v-11l5 5v-5l5.5 5.5z" })
        );
    }
    function Forward3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Forward3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Forward3.SVG = Forward3SVG;
    return Forward3;
})();
export const First = /*#__PURE__*/ (() => {
    function FirstSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 14v-12h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5v5.5z" })
        );
    }
    function First({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FirstSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    First.SVG = FirstSVG;
    return First;
})();
export const Last = /*#__PURE__*/ (() => {
    function LastSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 2v12h-2v-5.5l-5 5v-5l-5 5v-11l5 5v-5l5 5v-5.5z" })
        );
    }
    function Last({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LastSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Last.SVG = LastSVG;
    return Last;
})();
export const Previous2 = /*#__PURE__*/ (() => {
    function Previous2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 14v-12h2v5.5l5-5v11l-5-5v5.5z" })
        );
    }
    function Previous2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Previous2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Previous2.SVG = Previous2SVG;
    return Previous2;
})();
export const Next2 = /*#__PURE__*/ (() => {
    function Next2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 2v12h-2v-5.5l-5 5v-11l5 5v-5.5z" })
        );
    }
    function Next2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Next2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Next2.SVG = Next2SVG;
    return Next2;
})();
export const Eject = /*#__PURE__*/ (() => {
    function EjectSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 12h16v2h-16zM8 2l8 8h-16z" })
        );
    }
    function Eject({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EjectSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Eject.SVG = EjectSVG;
    return Eject;
})();
export const VolumeHigh = /*#__PURE__*/ (() => {
        function VolumeHighSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.907 14.407c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.369-1.369 2.123-3.19 2.123-5.127s-0.754-3.757-2.123-5.127c-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.653 1.653 2.563 3.85 2.563 6.187s-0.91 4.534-2.563 6.187c-0.146 0.146-0.338 0.22-0.53 0.22zM11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeHigh({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeHighSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeHigh.SVG = VolumeHighSVG;
        return VolumeHigh;
    })();
export const VolumeMedium = /*#__PURE__*/ (() => {
        function VolumeMediumSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeMedium({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeMediumSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeMedium.SVG = VolumeMediumSVG;
        return VolumeMedium;
    })();
export const VolumeLow = /*#__PURE__*/ (() => {
        function VolumeLowSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeLow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeLowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeLow.SVG = VolumeLowSVG;
        return VolumeLow;
    })();
export const VolumeMute = /*#__PURE__*/ (() => {
    function VolumeMuteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
        );
    }
    function VolumeMute({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VolumeMuteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VolumeMute.SVG = VolumeMuteSVG;
    return VolumeMute;
})();
export const SpeakerLeft = /*#__PURE__*/ (() => {
        function SpeakerLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" }),
_('path', { d: "M14.5 12h-5c-0.276 0-0.5-0.224-0.5-0.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v6.5h4.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function SpeakerLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeakerLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpeakerLeft.SVG = SpeakerLeftSVG;
        return SpeakerLeft;
    })();
export const SpeakerRight = /*#__PURE__*/ (() => {
        function SpeakerRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" }),
_('path', { d: "M14.854 11.146l-2.155-2.155c1.286-0.102 2.301-1.18 2.301-2.491 0-1.378-1.121-2.5-2.5-2.5h-3c-0.276 0-0.5 0.224-0.5 0.5v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h1.293l2.854 2.854c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707zM10 5h2.5c0.827 0 1.5 0.673 1.5 1.5s-0.673 1.5-1.5 1.5h-2.5v-3z" })
            );
        }
        function SpeakerRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SpeakerRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SpeakerRight.SVG = SpeakerRightSVG;
        return SpeakerRight;
    })();
export const VolumeMute2 = /*#__PURE__*/ (() => {
        function VolumeMute2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 9.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674 1.674 1.674z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeMute2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeMute2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeMute2.SVG = VolumeMute2SVG;
        return VolumeMute2;
    })();
export const VolumeIncrease = /*#__PURE__*/ (() => {
        function VolumeIncreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeIncrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeIncreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeIncrease.SVG = VolumeIncreaseSVG;
        return VolumeIncrease;
    })();
export const VolumeDecrease = /*#__PURE__*/ (() => {
        function VolumeDecreaseSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 7h8v2h-8v-2z" }),
_('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z" })
            );
        }
        function VolumeDecrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeDecreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeDecrease.SVG = VolumeDecreaseSVG;
        return VolumeDecrease;
    })();
export const VolumeHigh2 = /*#__PURE__*/ (() => {
        function VolumeHigh2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M8.5 10c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 12c-0.276 0-0.5-0.224-0.5-0.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 14c-0.276 0-0.5-0.224-0.5-0.5v-11c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v11c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 16c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function VolumeHigh2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeHigh2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeHigh2.SVG = VolumeHigh2SVG;
        return VolumeHigh2;
    })();
export const VolumeMedium2 = /*#__PURE__*/ (() => {
        function VolumeMedium2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M8.5 10c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 12c-0.276 0-0.5-0.224-0.5-0.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M12.5 14c-0.276 0-0.5-0.224-0.5-0.5v-11c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v11c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function VolumeMedium2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeMedium2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeMedium2.SVG = VolumeMedium2SVG;
        return VolumeMedium2;
    })();
export const VolumeMedium3 = /*#__PURE__*/ (() => {
        function VolumeMedium3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M8.5 10c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M10.5 12c-0.276 0-0.5-0.224-0.5-0.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function VolumeMedium3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeMedium3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeMedium3.SVG = VolumeMedium3SVG;
        return VolumeMedium3;
    })();
export const VolumeLow2 = /*#__PURE__*/ (() => {
        function VolumeLow2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M8.5 10c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5z" })
            );
        }
        function VolumeLow2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeLow2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeLow2.SVG = VolumeLow2SVG;
        return VolumeLow2;
    })();
export const VolumeMute3 = /*#__PURE__*/ (() => {
    function VolumeMute3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" })
        );
    }
    function VolumeMute3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VolumeMute3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VolumeMute3.SVG = VolumeMute3SVG;
    return VolumeMute3;
})();
export const VolumeIncrease2 = /*#__PURE__*/ (() => {
        function VolumeIncrease2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M14.5 8h-2.5v-2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2.5h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v2.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.5h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z" })
            );
        }
        function VolumeIncrease2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeIncrease2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeIncrease2.SVG = VolumeIncrease2SVG;
        return VolumeIncrease2;
    })();
export const VolumeDecrease2 = /*#__PURE__*/ (() => {
        function VolumeDecrease2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038zM1 10h1.5c0.133 0 0.26 0.053 0.354 0.146l3.146 3.146v-10.586l-3.146 3.146c-0.094 0.094-0.221 0.146-0.354 0.146h-1.5v4z" }),
_('path', { d: "M14.5 9h-6c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h6c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function VolumeDecrease2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VolumeDecrease2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        VolumeDecrease2.SVG = VolumeDecrease2SVG;
        return VolumeDecrease2;
    })();
export const VolumeDecrease3 = /*#__PURE__*/ (() => {
    function VolumeDecrease3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.854 1.146c-0.195-0.195-0.512-0.195-0.707 0l-4.146 4.146v-3.793c0-0.202-0.122-0.385-0.309-0.462s-0.402-0.035-0.545 0.108l-3.854 3.854h-1.793c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h0.793l-3.146 3.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3.646-3.646 3.646 3.646c0.096 0.096 0.224 0.146 0.354 0.146 0.064 0 0.129-0.012 0.191-0.038 0.187-0.077 0.309-0.26 0.309-0.462v-7.793l4.854-4.854c0.195-0.195 0.195-0.512 0-0.707zM5 10v-4h1.5c0.133 0 0.26-0.053 0.354-0.146l3.146-3.146v3.586l-3.707 3.707h-1.293zM10 13.293l-2.793-2.793 2.793-2.793v5.586z" })
        );
    }
    function VolumeDecrease3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VolumeDecrease3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VolumeDecrease3.SVG = VolumeDecrease3SVG;
    return VolumeDecrease3;
})();
export const Volume5 = /*#__PURE__*/ (() => {
    function Volume5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 1h7v2h-7zM9 4h7v2h-7zM9 7h7v2h-7zM9 10h7v2h-7zM9 13h7v2h-7zM0 5v6h3l5 5v-16l-5 5z" })
        );
    }
    function Volume5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume5.SVG = Volume5SVG;
    return Volume5;
})();
export const Volume4 = /*#__PURE__*/ (() => {
    function Volume4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 4h7v2h-7zM9 7h7v2h-7zM9 10h7v2h-7zM9 13h7v2h-7zM0 5v6h3l5 5v-16l-5 5z" })
        );
    }
    function Volume4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume4.SVG = Volume4SVG;
    return Volume4;
})();
export const Volume3 = /*#__PURE__*/ (() => {
    function Volume3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 7h7v2h-7zM9 10h7v2h-7zM9 13h7v2h-7zM0 5v6h3l5 5v-16l-5 5z" })
        );
    }
    function Volume3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume3.SVG = Volume3SVG;
    return Volume3;
})();
export const Volume2 = /*#__PURE__*/ (() => {
    function Volume2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 10h7v2h-7zM9 13h7v2h-7zM0 5v6h3l5 5v-16l-5 5z" })
        );
    }
    function Volume2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume2.SVG = Volume2SVG;
    return Volume2;
})();
export const Volume1 = /*#__PURE__*/ (() => {
    function Volume1SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 13h7v2h-7zM0 5v6h3l5 5v-16l-5 5z" })
        );
    }
    function Volume1({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume1SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume1.SVG = Volume1SVG;
    return Volume1;
})();
export const Volume0 = /*#__PURE__*/ (() => {
    function Volume0SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h3l5-5v16l-5-5h-3v-6z" })
        );
    }
    function Volume0({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Volume0SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Volume0.SVG = Volume0SVG;
    return Volume0;
})();
export const VolumeMute4 = /*#__PURE__*/ (() => {
    function VolumeMute4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h3l5-5v16l-5-5h-3v-6zM14.326 8l1.674 1.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674z" })
        );
    }
    function VolumeMute4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VolumeMute4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VolumeMute4.SVG = VolumeMute4SVG;
    return VolumeMute4;
})();
export const VolumeMute5 = /*#__PURE__*/ (() => {
    function VolumeMute5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 0l-5 5h-3v6l8-8zM14.909 1.091l-13.818 13.818 1.091 1.091 4.409-4.409 4.409 4.409v-8.818l5-5z" })
        );
    }
    function VolumeMute5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VolumeMute5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    VolumeMute5.SVG = VolumeMute5SVG;
    return VolumeMute5;
})();
export const Loop = /*#__PURE__*/ (() => {
    function LoopSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 5h10v3l4-4-4-4v3h-12v6h2zM14 11h-10v-3l-4 4 4 4v-3h12v-6h-2z" })
        );
    }
    function Loop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LoopSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Loop.SVG = LoopSVG;
    return Loop;
})();
export const Loop2 = /*#__PURE__*/ (() => {
    function Loop2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 3.25c-1.566 0-2.962 0.731-3.849 1.863l-1.2-0.9c1.161-1.496 2.992-2.464 5.048-2.464v-1.75l2.5 2.5-2.5 2.5v-1.75zM8 12.75c1.566 0 2.962-0.731 3.849-1.863l1.2 0.9c-1.161 1.496-2.992 2.464-5.048 2.464v1.75l-2.5-2.5 2.5-2.5v1.75zM3.15 8c0 1.568 0.78 2.961 1.98 3.827l-0.9 1.2c-1.564-1.139-2.58-2.968-2.58-5.026h-1.65l2.5-2.5 2.5 2.5h-1.85zM14.35 8h1.65l-2.5 2.5-2.5-2.5h1.85c0-1.568-0.78-2.961-1.98-3.827l0.9-1.2c1.564 1.139 2.58 2.968 2.58 5.026z" })
        );
    }
    function Loop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Loop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Loop2.SVG = Loop2SVG;
    return Loop2;
})();
export const Loop3 = /*#__PURE__*/ (() => {
        function Loop3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z" }),
_('path', { d: "M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z" })
            );
        }
        function Loop3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Loop3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Loop3.SVG = Loop3SVG;
        return Loop3;
    })();
export const InfiniteSquare = /*#__PURE__*/ (() => {
        function InfiniteSquareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.281 6.023c-0.528 0-1.025 0.206-1.398 0.579s-0.579 0.87-0.579 1.398 0.206 1.025 0.579 1.398c0.373 0.373 0.87 0.579 1.398 0.579s1.025-0.206 1.398-0.579l1.398-1.398-1.398-1.398c-0.373-0.373-0.87-0.579-1.398-0.579z" }),
_('path', { d: "M11.719 6.023c-0.528 0-1.025 0.206-1.398 0.579l-1.398 1.398 1.398 1.398c0.374 0.373 0.87 0.579 1.398 0.579s1.025-0.206 1.398-0.579c0.373-0.374 0.579-0.87 0.579-1.398s-0.206-1.025-0.579-1.398c-0.373-0.373-0.87-0.579-1.398-0.579z" }),
_('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14.039 10.32c-0.62 0.62-1.444 0.961-2.32 0.961s-1.7-0.341-2.32-0.961l-1.399-1.398-1.398 1.398c-0.62 0.62-1.444 0.961-2.32 0.961s-1.701-0.341-2.32-0.961c-0.62-0.62-0.961-1.444-0.961-2.32s0.341-1.7 0.961-2.32c0.62-0.62 1.444-0.961 2.32-0.961s1.701 0.341 2.32 0.961l1.398 1.398 1.398-1.398c0.62-0.62 1.444-0.961 2.32-0.961s1.701 0.341 2.32 0.961c0.62 0.62 0.961 1.444 0.961 2.32s-0.341 1.701-0.961 2.32z" })
            );
        }
        function InfiniteSquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( InfiniteSquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        InfiniteSquare.SVG = InfiniteSquareSVG;
        return InfiniteSquare;
    })();
export const Infinite = /*#__PURE__*/ (() => {
    function InfiniteSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.25 11.75c-1.002 0-1.943-0.39-2.652-1.098l-1.598-1.598-1.598 1.598c-0.708 0.708-1.65 1.098-2.652 1.098s-1.944-0.39-2.652-1.098c-0.708-0.708-1.098-1.65-1.098-2.652s0.39-1.943 1.098-2.652c0.708-0.708 1.65-1.098 2.652-1.098s1.943 0.39 2.652 1.098l1.598 1.598 1.598-1.598c0.708-0.708 1.65-1.098 2.652-1.098s1.944 0.39 2.652 1.098c0.708 0.708 1.098 1.65 1.098 2.652s-0.39 1.943-1.098 2.652c-0.708 0.708-1.65 1.098-2.652 1.098zM10.652 9.598c0.427 0.427 0.994 0.662 1.598 0.662s1.171-0.235 1.598-0.662c0.427-0.427 0.662-0.994 0.662-1.598s-0.235-1.171-0.662-1.598c-0.427-0.427-0.994-0.662-1.598-0.662s-1.171 0.235-1.598 0.662l-1.598 1.598 1.598 1.598zM3.75 5.74c-0.604 0-1.171 0.235-1.598 0.662s-0.662 0.994-0.662 1.598c0 0.604 0.235 1.171 0.662 1.598s0.994 0.662 1.598 0.662c0.604 0 1.171-0.235 1.598-0.662l1.598-1.598-1.598-1.598c-0.427-0.427-0.994-0.662-1.598-0.662v0z" })
        );
    }
    function Infinite({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InfiniteSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Infinite.SVG = InfiniteSVG;
    return Infinite;
})();
export const Infinite2 = /*#__PURE__*/ (() => {
    function Infinite2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 0c-2.485 0-4.5 2.015-4.5 4.5v2.5h-2.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5v-2.5h2.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM7 11.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5 1.119-2.5 2.5-2.5h2.5v2.5zM11.5 7h-2.5v-2.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z" })
        );
    }
    function Infinite2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Infinite2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Infinite2.SVG = Infinite2SVG;
    return Infinite2;
})();
export const Loop4 = /*#__PURE__*/ (() => {
    function Loop4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 10v-3h3l-4-4-4 4h3v5h6l-2-2zM13 9v-5h-6l2 2h2v3h-3l4 4 4-4z" })
        );
    }
    function Loop4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Loop4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Loop4.SVG = Loop4SVG;
    return Loop4;
})();
export const Shuffle = /*#__PURE__*/ (() => {
    function ShuffleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 11h-1.586l-2.5-2.5 2.5-2.5h1.586v2.5l3.5-3.5-3.5-3.5v2.5h-2c-0.265 0-0.52 0.105-0.707 0.293l-2.793 2.793-2.793-2.793c-0.188-0.188-0.442-0.293-0.707-0.293h-3v2h2.586l2.5 2.5-2.5 2.5h-2.586v2h3c0.265 0 0.52-0.105 0.707-0.293l2.793-2.793 2.793 2.793c0.188 0.188 0.442 0.293 0.707 0.293h2v2.5l3.5-3.5-3.5-3.5v2.5z" })
        );
    }
    function Shuffle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShuffleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shuffle.SVG = ShuffleSVG;
    return Shuffle;
})();
export const Shuffle2 = /*#__PURE__*/ (() => {
    function Shuffle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.854 10.146c-0.143-0.143-0.358-0.186-0.545-0.108s-0.309 0.26-0.309 0.462v1.5h-1.793l-3.5-3.5 3.5-3.5h1.793v1.5c0 0.202 0.122 0.385 0.309 0.462 0.062 0.026 0.127 0.038 0.191 0.038 0.13 0 0.258-0.051 0.354-0.146l2-2c0.195-0.195 0.195-0.512 0-0.707l-2-2c-0.143-0.143-0.358-0.186-0.545-0.108s-0.309 0.26-0.309 0.462v1.5h-2c-0.133 0-0.26 0.053-0.354 0.146l-3.646 3.646-3.646-3.646c-0.094-0.094-0.221-0.146-0.354-0.146h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.293l3.5 3.5-3.5 3.5h-2.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5c0.133 0 0.26-0.053 0.354-0.146l3.646-3.646 3.646 3.646c0.094 0.094 0.221 0.146 0.354 0.146h2v1.5c0 0.202 0.122 0.385 0.309 0.462 0.062 0.026 0.127 0.038 0.191 0.038 0.13 0 0.258-0.051 0.354-0.146l2-2c0.195-0.195 0.195-0.512 0-0.707l-2-2z" })
        );
    }
    function Shuffle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Shuffle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shuffle2.SVG = Shuffle2SVG;
    return Shuffle2;
})();
export const Wave = /*#__PURE__*/ (() => {
    function WaveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 5h2v6c0 0.539-0.106 1.063-0.315 1.558-0.202 0.477-0.49 0.904-0.856 1.271s-0.794 0.655-1.271 0.856c-0.494 0.209-1.018 0.315-1.558 0.315s-1.063-0.106-1.558-0.315c-0.477-0.202-0.904-0.49-1.271-0.856s-0.655-0.794-0.856-1.271c-0.209-0.494-0.315-1.018-0.315-1.558v-6c0-1.105-0.895-2-2-2s-2 0.895-2 2v6h-2v-6c0-0.539 0.106-1.063 0.315-1.558 0.202-0.477 0.49-0.904 0.856-1.271s0.794-0.655 1.271-0.856c0.494-0.209 1.019-0.315 1.558-0.315s1.063 0.106 1.558 0.315c0.477 0.202 0.904 0.49 1.271 0.856s0.655 0.794 0.856 1.271c0.209 0.494 0.315 1.018 0.315 1.558v6c0 1.105 0.895 2 2 2s2-0.895 2-2v-6z" })
        );
    }
    function Wave({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WaveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wave.SVG = WaveSVG;
    return Wave;
})();
export const Wave2 = /*#__PURE__*/ (() => {
    function Wave2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 18 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 18 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 4h2v8c0 1.654-1.346 3-3 3s-3-1.346-3-3v-8c0-0.551-0.449-1-1-1s-1 0.449-1 1v8c0 1.654-1.346 3-3 3s-3-1.346-3-3v-8c0-0.551-0.449-1-1-1s-1 0.449-1 1v8h-2v-8c0-1.654 1.346-3 3-3s3 1.346 3 3v8c0 0.551 0.449 1 1 1s1-0.449 1-1v-8c0-1.654 1.346-3 3-3s3 1.346 3 3v8c0 0.551 0.449 1 1 1s1-0.449 1-1v-8z" })
        );
    }
    function Wave2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Wave2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wave2.SVG = Wave2SVG;
    return Wave2;
})();
export const Split = /*#__PURE__*/ (() => {
        function SplitSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.5 0h-5.5v5.5l2.043-2.043 4.957 4.957v7.586h2v-8.414l-5.543-5.543z" }),
_('path', { d: "M15 0h-5.5l2.043 2.043-3 3 1.414 1.414 3-3 2.043 2.043z" })
            );
        }
        function Split({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SplitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Split.SVG = SplitSVG;
        return Split;
    })();
export const Merge = /*#__PURE__*/ (() => {
        function MergeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 5h3.5l-4.5-4.5-4.5 4.5h3.5v3.586l-5.957 5.957 1.414 1.414 6.543-6.543z" }),
_('path', { d: "M8.543 11.957l1.414-1.414 4 4-1.414 1.414-4-4z" })
            );
        }
        function Merge({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MergeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Merge.SVG = MergeSVG;
        return Merge;
    })();
export const First2 = /*#__PURE__*/ (() => {
    function First2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 3l-3-3-8 8 8 8 3-3-5-5zM0 0v16h2v-16z" })
        );
    }
    function First2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( First2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    First2.SVG = First2SVG;
    return First2;
})();
export const Last2 = /*#__PURE__*/ (() => {
    function Last2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 13l3 3 8-8-8-8-3 3 5 5zM16 16v-16h-2v16z" })
        );
    }
    function Last2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Last2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Last2.SVG = Last2SVG;
    return Last2;
})();
export const ArrowUp = /*#__PURE__*/ (() => {
    function ArrowUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 10.5l3 3 5-5 5 5 3-3-8-8z" })
        );
    }
    function ArrowUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp.SVG = ArrowUpSVG;
    return ArrowUp;
})();
export const ArrowUp2 = /*#__PURE__*/ (() => {
    function ArrowUp2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 10.5l2 2 6-6 6 6 2-2-8-8-8 8z" })
        );
    }
    function ArrowUp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp2.SVG = ArrowUp2SVG;
    return ArrowUp2;
})();
export const ArrowUp3 = /*#__PURE__*/ (() => {
    function ArrowUp3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 10.5l1.5 1.5 6.5-6.5 6.5 6.5 1.5-1.5-8-8-8 8z" })
        );
    }
    function ArrowUp3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp3.SVG = ArrowUp3SVG;
    return ArrowUp3;
})();
export const ArrowUp4 = /*#__PURE__*/ (() => {
    function ArrowUp4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 10.5l1 1 7-7 7 7 1-1-8-8-8 8z" })
        );
    }
    function ArrowUp4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp4.SVG = ArrowUp4SVG;
    return ArrowUp4;
})();
export const ArrowRight = /*#__PURE__*/ (() => {
    function ArrowRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 0l-3 3 5 5-5 5 3 3 8-8z" })
        );
    }
    function ArrowRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight.SVG = ArrowRightSVG;
    return ArrowRight;
})();
export const ArrowRight2 = /*#__PURE__*/ (() => {
    function ArrowRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 0l-2 2 6 6-6 6 2 2 8-8-8-8z" })
        );
    }
    function ArrowRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight2.SVG = ArrowRight2SVG;
    return ArrowRight2;
})();
export const ArrowRight3 = /*#__PURE__*/ (() => {
    function ArrowRight3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 0l-1.5 1.5 6.5 6.5-6.5 6.5 1.5 1.5 8-8-8-8z" })
        );
    }
    function ArrowRight3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight3.SVG = ArrowRight3SVG;
    return ArrowRight3;
})();
export const ArrowRight4 = /*#__PURE__*/ (() => {
    function ArrowRight4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.5 0l-1 1 7 7-7 7 1 1 8-8-8-8z" })
        );
    }
    function ArrowRight4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight4.SVG = ArrowRight4SVG;
    return ArrowRight4;
})();
export const ArrowDown = /*#__PURE__*/ (() => {
    function ArrowDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.5l-3-3-5 5-5-5-3 3 8 8z" })
        );
    }
    function ArrowDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown.SVG = ArrowDownSVG;
    return ArrowDown;
})();
export const ArrowDown2 = /*#__PURE__*/ (() => {
    function ArrowDown2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.5l-2-2-6 6-6-6-2 2 8 8 8-8z" })
        );
    }
    function ArrowDown2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown2.SVG = ArrowDown2SVG;
    return ArrowDown2;
})();
export const ArrowDown3 = /*#__PURE__*/ (() => {
    function ArrowDown3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.5l-1.5-1.5-6.5 6.5-6.5-6.5-1.5 1.5 8 8 8-8z" })
        );
    }
    function ArrowDown3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown3.SVG = ArrowDown3SVG;
    return ArrowDown3;
})();
export const ArrowDown4 = /*#__PURE__*/ (() => {
    function ArrowDown4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 5.5l-1-1-7 7-7-7-1 1 8 8 8-8z" })
        );
    }
    function ArrowDown4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown4.SVG = ArrowDown4SVG;
    return ArrowDown4;
})();
export const ArrowLeft = /*#__PURE__*/ (() => {
    function ArrowLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 16l3-3-5-5 5-5-3-3-8 8z" })
        );
    }
    function ArrowLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft.SVG = ArrowLeftSVG;
    return ArrowLeft;
})();
export const ArrowLeft2 = /*#__PURE__*/ (() => {
    function ArrowLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 16l2-2-6-6 6-6-2-2-8 8 8 8z" })
        );
    }
    function ArrowLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft2.SVG = ArrowLeft2SVG;
    return ArrowLeft2;
})();
export const ArrowLeft3 = /*#__PURE__*/ (() => {
    function ArrowLeft3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 16l1.5-1.5-6.5-6.5 6.5-6.5-1.5-1.5-8 8 8 8z" })
        );
    }
    function ArrowLeft3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft3.SVG = ArrowLeft3SVG;
    return ArrowLeft3;
})();
export const ArrowLeft4 = /*#__PURE__*/ (() => {
    function ArrowLeft4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 16l1-1-7-7 7-7-1-1-8 8 8 8z" })
        );
    }
    function ArrowLeft4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft4.SVG = ArrowLeft4SVG;
    return ArrowLeft4;
})();
export const ArrowUp5 = /*#__PURE__*/ (() => {
    function ArrowUp5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 10l-4.5-4.5-4.5 4.5h9z" })
        );
    }
    function ArrowUp5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp5.SVG = ArrowUp5SVG;
    return ArrowUp5;
})();
export const ArrowRight5 = /*#__PURE__*/ (() => {
    function ArrowRight5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 12.5l4.5-4.5-4.5-4.5v9z" })
        );
    }
    function ArrowRight5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight5.SVG = ArrowRight5SVG;
    return ArrowRight5;
})();
export const ArrowDown5 = /*#__PURE__*/ (() => {
    function ArrowDown5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.5 6l4.5 4.5 4.5-4.5h-9z" })
        );
    }
    function ArrowDown5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown5.SVG = ArrowDown5SVG;
    return ArrowDown5;
})();
export const ArrowLeft5 = /*#__PURE__*/ (() => {
    function ArrowLeft5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 3.5l-4.5 4.5 4.5 4.5v-9z" })
        );
    }
    function ArrowLeft5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft5.SVG = ArrowLeft5SVG;
    return ArrowLeft5;
})();
export const ArrowUpLeft = /*#__PURE__*/ (() => {
    function ArrowUpLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 11.5l4-4 8.5 8.5 3.5-3.5-8.5-8.5 4-4h-11.5v11.5z" })
        );
    }
    function ArrowUpLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpLeft.SVG = ArrowUpLeftSVG;
    return ArrowUpLeft;
})();
export const ArrowUp6 = /*#__PURE__*/ (() => {
    function ArrowUp6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l-7.5 7.5h4.5v8h6v-8h4.5z" })
        );
    }
    function ArrowUp6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp6.SVG = ArrowUp6SVG;
    return ArrowUp6;
})();
export const ArrowUpRight = /*#__PURE__*/ (() => {
    function ArrowUpRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.5 0l4 4-8.5 8.5 3.5 3.5 8.5-8.5 4 4v-11.5h-11.5z" })
        );
    }
    function ArrowUpRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpRight.SVG = ArrowUpRightSVG;
    return ArrowUpRight;
})();
export const ArrowRight6 = /*#__PURE__*/ (() => {
    function ArrowRight6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 8l-7.5-7.5v4.5h-8v6h8v4.5z" })
        );
    }
    function ArrowRight6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight6.SVG = ArrowRight6SVG;
    return ArrowRight6;
})();
export const ArrowDownRight = /*#__PURE__*/ (() => {
    function ArrowDownRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 4.5l-4 4-8.5-8.5-3.5 3.5 8.5 8.5-4 4h11.5v-11.5z" })
        );
    }
    function ArrowDownRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownRight.SVG = ArrowDownRightSVG;
    return ArrowDownRight;
})();
export const ArrowDown6 = /*#__PURE__*/ (() => {
    function ArrowDown6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 15.5l7.5-7.5h-4.5v-8h-6v8h-4.5z" })
        );
    }
    function ArrowDown6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown6.SVG = ArrowDown6SVG;
    return ArrowDown6;
})();
export const ArrowDownLeft = /*#__PURE__*/ (() => {
    function ArrowDownLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 16l-4-4 8.5-8.5-3.5-3.5-8.5 8.5-4-4v11.5h11.5z" })
        );
    }
    function ArrowDownLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownLeft.SVG = ArrowDownLeftSVG;
    return ArrowDownLeft;
})();
export const ArrowLeft6 = /*#__PURE__*/ (() => {
    function ArrowLeft6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.5 8l7.5 7.5v-4.5h8v-6h-8v-4.5z" })
        );
    }
    function ArrowLeft6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft6.SVG = ArrowLeft6SVG;
    return ArrowLeft6;
})();
export const ArrowUpLeft2 = /*#__PURE__*/ (() => {
    function ArrowUpLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.414 13l-7.957-7.957 3.043-3.043h-7.5v7.5l3.043-3.043 7.957 7.957z" })
        );
    }
    function ArrowUpLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpLeft2.SVG = ArrowUpLeft2SVG;
    return ArrowUpLeft2;
})();
export const ArrowUp7 = /*#__PURE__*/ (() => {
    function ArrowUp7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 6l-5.5-5.5-5.5 5.5h4.5v9h2v-9z" })
        );
    }
    function ArrowUp7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp7.SVG = ArrowUp7SVG;
    return ArrowUp7;
})();
export const ArrowUpRight2 = /*#__PURE__*/ (() => {
    function ArrowUpRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3 14.414l7.957-7.957 3.043 3.043v-7.5h-7.5l3.043 3.043-7.957 7.957z" })
        );
    }
    function ArrowUpRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpRight2.SVG = ArrowUpRight2SVG;
    return ArrowUpRight2;
})();
export const ArrowRight7 = /*#__PURE__*/ (() => {
    function ArrowRight7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10 13.5l5.5-5.5-5.5-5.5v4.5h-9v2h9z" })
        );
    }
    function ArrowRight7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight7.SVG = ArrowRight7SVG;
    return ArrowRight7;
})();
export const ArrowDownRight2 = /*#__PURE__*/ (() => {
    function ArrowDownRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1.586 3l7.957 7.957-3.043 3.043h7.5v-7.5l-3.043 3.043-7.957-7.957z" })
        );
    }
    function ArrowDownRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownRight2.SVG = ArrowDownRight2SVG;
    return ArrowDownRight2;
})();
export const ArrowDown7 = /*#__PURE__*/ (() => {
    function ArrowDown7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.5 10l5.5 5.5 5.5-5.5h-4.5v-9h-2v9z" })
        );
    }
    function ArrowDown7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown7.SVG = ArrowDown7SVG;
    return ArrowDown7;
})();
export const ArrowDownLeft2 = /*#__PURE__*/ (() => {
    function ArrowDownLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1.586l-7.957 7.957-3.043-3.043v7.5h7.5l-3.043-3.043 7.957-7.957z" })
        );
    }
    function ArrowDownLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownLeft2.SVG = ArrowDownLeft2SVG;
    return ArrowDownLeft2;
})();
export const ArrowLeft7 = /*#__PURE__*/ (() => {
    function ArrowLeft7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 2.5l-5.5 5.5 5.5 5.5v-4.5h9v-2h-9z" })
        );
    }
    function ArrowLeft7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft7.SVG = ArrowLeft7SVG;
    return ArrowLeft7;
})();
export const ArrowUpLeft3 = /*#__PURE__*/ (() => {
    function ArrowUpLeft3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.707 12.293l-8.293-8.293h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.404 0-0.769 0.244-0.924 0.617-0.051 0.124-0.076 0.254-0.076 0.383h-0.001v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l8.293 8.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.39 0.391-1.024 0-1.414z" })
        );
    }
    function ArrowUpLeft3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpLeft3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpLeft3.SVG = ArrowUpLeft3SVG;
    return ArrowUpLeft3;
})();
export const ArrowUp8 = /*#__PURE__*/ (() => {
    function ArrowUp8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z" })
        );
    }
    function ArrowUp8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp8.SVG = ArrowUp8SVG;
    return ArrowUp8;
})();
export const ArrowUpRight3 = /*#__PURE__*/ (() => {
    function ArrowUpRight3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.707 13.707l8.293-8.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.404-0.244-0.769-0.617-0.924-0.124-0.051-0.254-0.076-0.383-0.076v-0.001h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-8.293 8.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.39 0.391 1.024 0.391 1.414 0z" })
        );
    }
    function ArrowUpRight3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpRight3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpRight3.SVG = ArrowUpRight3SVG;
    return ArrowUpRight3;
})();
export const ArrowRight8 = /*#__PURE__*/ (() => {
    function ArrowRight8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z" })
        );
    }
    function ArrowRight8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight8.SVG = ArrowRight8SVG;
    return ArrowRight8;
})();
export const ArrowDownRight3 = /*#__PURE__*/ (() => {
    function ArrowDownRight3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.293 3.707l8.293 8.293h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.404 0 0.769-0.244 0.924-0.617 0.051-0.124 0.076-0.254 0.076-0.383h0.001v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-8.293-8.293c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293c-0.391 0.39-0.391 1.024 0 1.414z" })
        );
    }
    function ArrowDownRight3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownRight3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownRight3.SVG = ArrowDownRight3SVG;
    return ArrowDownRight3;
})();
export const ArrowDown8 = /*#__PURE__*/ (() => {
    function ArrowDown8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.707 9.707l-5 5c-0.39 0.391-1.024 0.391-1.414 0l-5-5c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l3.293 3.293v-9.586c0-0.552 0.448-1 1-1s1 0.448 1 1v9.586l3.293-3.293c0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293c0.391 0.391 0.391 1.024 0 1.414z" })
        );
    }
    function ArrowDown8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown8.SVG = ArrowDown8SVG;
    return ArrowDown8;
})();
export const ArrowDownLeft3 = /*#__PURE__*/ (() => {
    function ArrowDownLeft3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.293 2.293l-8.293 8.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.383 0.076v0.001l6-0c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l8.293-8.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.39-0.391-1.024-0.391-1.414 0v0z" })
        );
    }
    function ArrowDownLeft3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownLeft3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownLeft3.SVG = ArrowDownLeft3SVG;
    return ArrowDownLeft3;
})();
export const ArrowLeft8 = /*#__PURE__*/ (() => {
    function ArrowLeft8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z" })
        );
    }
    function ArrowLeft8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft8.SVG = ArrowLeft8SVG;
    return ArrowLeft8;
})();
export const CircleUp = /*#__PURE__*/ (() => {
        function CircleUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.125 15.367c0.084-0.036 0.167-0.073 0.25-0.112v-1.699c-0.082 0.050-0.166 0.098-0.25 0.144v1.666z" }),
_('path', { d: "M11.625 15.133c0.084-0.043 0.167-0.088 0.25-0.133v-1.781c-0.082 0.061-0.165 0.12-0.25 0.177v1.737z" }),
_('path', { d: "M12.125 14.856c0.084-0.051 0.168-0.104 0.25-0.157v-1.891c-0.081 0.074-0.165 0.146-0.25 0.216v1.832z" }),
_('path', { d: "M14.625 12.485c0.087-0.128 0.17-0.26 0.25-0.393v-8.184c-0.080-0.134-0.163-0.265-0.25-0.393v8.971z" }),
_('path', { d: "M8.875 14.441c-0.083 0.011-0.166 0.021-0.25 0.029v1.493h-0.25v-1.474c-0.083 0.005-0.166 0.008-0.25 0.009v1.464h-0.25v-1.464c-0.084-0.002-0.167-0.005-0.25-0.009v1.474h-0.25v-1.493c-0.084-0.008-0.167-0.018-0.25-0.029v1.511c0.287 0.031 0.579 0.048 0.875 0.048s0.588-0.017 0.875-0.048v-1.511z" }),
_('path', { d: "M13.125 14.143c0.085-0.071 0.168-0.143 0.25-0.217v-2.27c-0.080 0.117-0.163 0.231-0.25 0.342v2.144z" }),
_('path', { d: "M13.625 13.688c0.085-0.084 0.169-0.171 0.25-0.259v-2.645c-0.077 0.162-0.16 0.321-0.25 0.475v2.429z" }),
_('path', { d: "M10.625 15.559c0.084-0.029 0.167-0.060 0.25-0.092v-1.637c-0.082 0.041-0.166 0.080-0.25 0.117v1.611z" }),
_('path', { d: "M15.625 5.574v4.852c0.104-0.328 0.188-0.665 0.25-1.010v-2.833c-0.062-0.345-0.146-0.682-0.25-1.010z" }),
_('path', { d: "M15.125 11.642c0.090-0.175 0.173-0.354 0.25-0.537v-6.21c-0.077-0.182-0.16-0.361-0.25-0.537v7.283z" }),
_('path', { d: "M9.125 15.921c0.084-0.012 0.167-0.025 0.25-0.039v-1.528c-0.083 0.018-0.166 0.034-0.25 0.049v1.518z" }),
_('path', { d: "M10.125 15.714c0.084-0.023 0.167-0.047 0.25-0.073v-1.589c-0.082 0.032-0.166 0.063-0.25 0.092v1.57z" }),
_('path', { d: "M9.625 15.835c0.084-0.017 0.167-0.036 0.25-0.056v-1.553c-0.083 0.025-0.166 0.049-0.25 0.070v1.539z" }),
_('path', { d: "M14.125 10.18v2.966c0.086-0.102 0.169-0.206 0.25-0.313v-3.56c-0.062 0.311-0.146 0.613-0.25 0.907z" }),
_('path', { d: "M6.125 15.778c0.083 0.020 0.166 0.039 0.25 0.056v-1.54c-0.084-0.022-0.167-0.045-0.25-0.070v1.553z" }),
_('path', { d: "M5.625 15.642c0.083 0.026 0.166 0.050 0.25 0.073v-1.57c-0.084-0.029-0.168-0.060-0.25-0.092v1.589z" }),
_('path', { d: "M6.625 14.354v1.528c0.083 0.014 0.166 0.027 0.25 0.039v-1.518c-0.084-0.015-0.167-0.031-0.25-0.049z" }),
_('path', { d: "M5.125 15.467c0.083 0.032 0.166 0.062 0.25 0.092v-1.611c-0.084-0.037-0.168-0.076-0.25-0.117v1.637z" }),
_('path', { d: "M2.375 4.741v-2.429c-0.085 0.084-0.169 0.171-0.25 0.259v2.645c0.077-0.162 0.16-0.321 0.25-0.475z" }),
_('path', { d: "M13.625 4.741c0.090 0.154 0.173 0.313 0.25 0.475v-2.645c-0.081-0.088-0.165-0.174-0.25-0.259v2.429z" }),
_('path', { d: "M2.625 13.925c0.082 0.074 0.165 0.146 0.25 0.217v-2.144c-0.087-0.111-0.17-0.226-0.25-0.342v2.27z" }),
_('path', { d: "M1.625 12.833c0.081 0.106 0.164 0.211 0.25 0.313v-2.966c-0.104-0.293-0.188-0.596-0.25-0.907v3.56z" }),
_('path', { d: "M4.625 15.255c0.083 0.039 0.166 0.076 0.25 0.112v-1.666c-0.084-0.046-0.168-0.094-0.25-0.144v1.699z" }),
_('path', { d: "M2.125 13.429c0.081 0.088 0.165 0.174 0.25 0.259v-2.429c-0.090-0.154-0.173-0.313-0.25-0.475v2.645z" }),
_('path', { d: "M3.125 14.343c0.082 0.063 0.165 0.125 0.25 0.185v-1.962c-0.086-0.087-0.169-0.176-0.25-0.268v2.044z" }),
_('path', { d: "M4.125 15c0.083 0.046 0.166 0.090 0.25 0.133v-1.737c-0.085-0.057-0.168-0.116-0.25-0.177v1.781z" }),
_('path', { d: "M3.625 14.698c0.082 0.054 0.166 0.107 0.25 0.157v-1.832c-0.085-0.070-0.169-0.142-0.25-0.216v1.891z" }),
_('path', { d: "M12.625 14.528c0.085-0.060 0.168-0.122 0.25-0.185v-2.044c-0.081 0.092-0.164 0.181-0.25 0.268v1.962z" }),
_('path', { d: "M14.125 5.82c0.104 0.293 0.188 0.596 0.25 0.907v-3.56c-0.081-0.106-0.164-0.211-0.25-0.313v2.966z" }),
_('path', { d: "M4.125 2.781c0.082-0.061 0.165-0.12 0.25-0.177v-1.737c-0.084 0.043-0.167 0.088-0.25 0.133v1.781z" }),
_('path', { d: "M5.125 2.169c0.082-0.041 0.166-0.080 0.25-0.117v-1.611c-0.084 0.029-0.167 0.060-0.25 0.092v1.637z" }),
_('path', { d: "M4.625 2.444c0.082-0.050 0.166-0.098 0.25-0.144v-1.666c-0.084 0.036-0.167 0.073-0.25 0.112v1.699z" }),
_('path', { d: "M6.625 1.646c0.083-0.018 0.166-0.034 0.25-0.049v-1.518c-0.084 0.012-0.167 0.025-0.25 0.039v1.528z" }),
_('path', { d: "M5.625 1.948c0.082-0.032 0.166-0.063 0.25-0.092v-1.57c-0.084 0.023-0.167 0.047-0.25 0.073v1.589z" }),
_('path', { d: "M6.125 1.775c0.083-0.025 0.166-0.049 0.25-0.070v-1.539c-0.084 0.017-0.167 0.036-0.25 0.056v1.553z" }),
_('path', { d: "M0.625 11.105c0.077 0.182 0.16 0.361 0.25 0.537v-7.283c-0.090 0.175-0.173 0.354-0.25 0.537v6.21z" }),
_('path', { d: "M3.125 3.701c0.081-0.092 0.164-0.181 0.25-0.268v-1.962c-0.085 0.060-0.168 0.122-0.25 0.185v2.044z" }),
_('path', { d: "M1.125 12.092c0.080 0.134 0.163 0.265 0.25 0.393v-8.971c-0.087 0.128-0.17 0.26-0.25 0.393v8.184z" }),
_('path', { d: "M0.125 9.416c0.062 0.345 0.146 0.682 0.25 1.010v-4.852c-0.104 0.328-0.188 0.665-0.25 1.010v2.833z" }),
_('path', { d: "M1.625 6.727c0.062-0.311 0.146-0.614 0.25-0.907v-2.966c-0.086 0.102-0.169 0.206-0.25 0.313v3.56z" }),
_('path', { d: "M2.625 4.344c0.080-0.117 0.163-0.231 0.25-0.343v-2.144c-0.085 0.071-0.168 0.143-0.25 0.217v2.27z" }),
_('path', { d: "M3.625 3.193c0.081-0.074 0.165-0.146 0.25-0.216v-1.832c-0.084 0.051-0.168 0.104-0.25 0.157v1.891z" }),
_('path', { d: "M12.125 2.977c0.085 0.070 0.169 0.142 0.25 0.216v-1.891c-0.082-0.054-0.166-0.107-0.25-0.157v1.832z" }),
_('path', { d: "M11.625 2.604c0.085 0.057 0.168 0.116 0.25 0.177v-1.781c-0.083-0.046-0.166-0.090-0.25-0.133v1.737z" }),
_('path', { d: "M11.125 2.299c0.084 0.046 0.168 0.094 0.25 0.144v-1.699c-0.083-0.038-0.166-0.076-0.25-0.112v1.666z" }),
_('path', { d: "M12.625 3.433c0.086 0.087 0.169 0.176 0.25 0.268v-2.044c-0.082-0.063-0.165-0.125-0.25-0.185v1.962z" }),
_('path', { d: "M10.625 2.052c0.084 0.037 0.168 0.076 0.25 0.117v-1.637c-0.083-0.032-0.166-0.062-0.25-0.092v1.611z" }),
_('path', { d: "M7.125 1.559c0.083-0.011 0.166-0.021 0.25-0.029v-1.506c-0.084 0.006-0.167 0.015-0.25 0.024v1.511z" }),
_('path', { d: "M13.125 4.002c0.087 0.111 0.17 0.226 0.25 0.343v-2.27c-0.082-0.074-0.165-0.146-0.25-0.217v2.144z" }),
_('path', { d: "M8.625 1.53c0.084 0.008 0.167 0.018 0.25 0.029v-1.511c-0.083-0.009-0.166-0.017-0.25-0.024v1.506z" }),
_('path', { d: "M8.125 1.502c0.084 0.002 0.167 0.005 0.25 0.009v-1.502c-0.083-0.004-0.166-0.006-0.25-0.007v1.5z" }),
_('path', { d: "M10.125 1.856c0.084 0.029 0.168 0.060 0.25 0.092v-1.589c-0.083-0.026-0.166-0.050-0.25-0.073v1.57z" }),
_('path', { d: "M7.625 1.511c0.083-0.005 0.166-0.008 0.25-0.009v-1.5c-0.084 0.001-0.167 0.004-0.25 0.007v1.502z" }),
_('path', { d: "M9.625 1.705c0.084 0.022 0.167 0.045 0.25 0.070v-1.553c-0.083-0.020-0.166-0.039-0.25-0.056v1.539z" }),
_('path', { d: "M9.125 1.597c0.084 0.015 0.167 0.031 0.25 0.049v-1.528c-0.083-0.014-0.166-0.027-0.25-0.039v1.518z" }),
_('path', { d: "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z" })
            );
        }
        function CircleUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleUp.SVG = CircleUpSVG;
        return CircleUp;
    })();
export const CircleRight = /*#__PURE__*/ (() => {
        function CircleRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0.633 11.125c0.036 0.084 0.073 0.167 0.112 0.25h1.699c-0.050-0.082-0.098-0.166-0.144-0.25h-1.666z" }),
_('path', { d: "M0.867 11.625c0.043 0.084 0.088 0.167 0.133 0.25h1.781c-0.061-0.082-0.12-0.165-0.177-0.25h-1.737z" }),
_('path', { d: "M1.144 12.125c0.051 0.084 0.104 0.168 0.157 0.25h1.891c-0.074-0.081-0.146-0.165-0.216-0.25h-1.832z" }),
_('path', { d: "M3.515 14.625c0.128 0.087 0.26 0.17 0.393 0.25h8.184c0.134-0.080 0.265-0.163 0.393-0.25h-8.971z" }),
_('path', { d: "M1.559 8.875c-0.011-0.083-0.021-0.166-0.029-0.25h-1.493v-0.25h1.474c-0.005-0.083-0.008-0.166-0.009-0.25h-1.464v-0.25h1.464c0.002-0.084 0.005-0.167 0.009-0.25h-1.474v-0.25h1.493c0.008-0.084 0.018-0.167 0.029-0.25h-1.511c-0.031 0.287-0.048 0.579-0.048 0.875s0.017 0.588 0.048 0.875h1.511z" }),
_('path', { d: "M1.857 13.125c0.071 0.085 0.143 0.168 0.217 0.25h2.27c-0.117-0.080-0.231-0.163-0.343-0.25h-2.144z" }),
_('path', { d: "M2.312 13.625c0.084 0.085 0.171 0.169 0.259 0.25h2.645c-0.162-0.077-0.321-0.16-0.475-0.25h-2.429z" }),
_('path', { d: "M0.441 10.625c0.029 0.084 0.060 0.167 0.092 0.25h1.637c-0.041-0.082-0.080-0.166-0.117-0.25h-1.611z" }),
_('path', { d: "M10.426 15.625h-4.852c0.328 0.104 0.665 0.188 1.010 0.25h2.833c0.345-0.062 0.682-0.146 1.010-0.25z" }),
_('path', { d: "M4.358 15.125c0.175 0.090 0.354 0.173 0.537 0.25h6.21c0.182-0.077 0.361-0.16 0.537-0.25h-7.283z" }),
_('path', { d: "M0.079 9.125c0.012 0.084 0.025 0.167 0.039 0.25h1.528c-0.018-0.083-0.034-0.166-0.049-0.25h-1.518z" }),
_('path', { d: "M0.286 10.125c0.023 0.084 0.047 0.167 0.073 0.25h1.589c-0.032-0.082-0.063-0.166-0.092-0.25h-1.57z" }),
_('path', { d: "M0.165 9.625c0.017 0.084 0.036 0.167 0.056 0.25h1.553c-0.025-0.083-0.049-0.166-0.070-0.25h-1.539z" }),
_('path', { d: "M5.82 14.125h-2.966c0.102 0.086 0.206 0.169 0.313 0.25h3.56c-0.311-0.062-0.613-0.146-0.907-0.25z" }),
_('path', { d: "M0.222 6.125c-0.020 0.083-0.039 0.166-0.056 0.25h1.54c0.022-0.084 0.045-0.167 0.070-0.25h-1.554z" }),
_('path', { d: "M0.358 5.625c-0.026 0.083-0.050 0.166-0.073 0.25h1.57c0.029-0.084 0.060-0.168 0.092-0.25h-1.589z" }),
_('path', { d: "M1.646 6.625h-1.528c-0.014 0.083-0.027 0.166-0.039 0.25h1.518c0.015-0.084 0.031-0.167 0.049-0.25z" }),
_('path', { d: "M0.533 5.125c-0.032 0.083-0.062 0.166-0.092 0.25h1.611c0.037-0.084 0.076-0.168 0.117-0.25h-1.637z" }),
_('path', { d: "M11.259 2.375h2.429c-0.084-0.085-0.171-0.169-0.259-0.25h-2.645c0.162 0.077 0.321 0.16 0.475 0.25z" }),
_('path', { d: "M11.259 13.625c-0.154 0.090-0.313 0.173-0.475 0.25h2.645c0.088-0.081 0.174-0.165 0.259-0.25h-2.429z" }),
_('path', { d: "M2.075 2.625c-0.074 0.082-0.146 0.165-0.217 0.25h2.144c0.111-0.087 0.226-0.17 0.343-0.25h-2.27z" }),
_('path', { d: "M3.167 1.625c-0.106 0.081-0.211 0.164-0.313 0.25h2.966c0.293-0.104 0.596-0.188 0.907-0.25h-3.56z" }),
_('path', { d: "M0.745 4.625c-0.039 0.083-0.076 0.166-0.112 0.25h1.666c0.046-0.084 0.094-0.168 0.144-0.25h-1.699z" }),
_('path', { d: "M2.571 2.125c-0.088 0.081-0.174 0.165-0.259 0.25h2.429c0.154-0.090 0.313-0.173 0.475-0.25h-2.645z" }),
_('path', { d: "M1.657 3.125c-0.063 0.082-0.125 0.165-0.185 0.25h1.962c0.087-0.086 0.176-0.169 0.268-0.25h-2.044z" }),
_('path', { d: "M1 4.125c-0.046 0.083-0.090 0.166-0.133 0.25h1.737c0.057-0.085 0.116-0.168 0.177-0.25h-1.781z" }),
_('path', { d: "M1.302 3.625c-0.054 0.082-0.107 0.166-0.157 0.25h1.832c0.070-0.085 0.142-0.169 0.216-0.25h-1.891z" }),
_('path', { d: "M1.472 12.625c0.060 0.085 0.122 0.168 0.185 0.25h2.044c-0.092-0.081-0.181-0.164-0.268-0.25h-1.962z" }),
_('path', { d: "M10.18 14.125c-0.293 0.104-0.596 0.188-0.907 0.25h3.56c0.106-0.081 0.211-0.164 0.313-0.25h-2.966z" }),
_('path', { d: "M13.219 4.125c0.061 0.082 0.12 0.165 0.177 0.25h1.737c-0.043-0.084-0.088-0.167-0.133-0.25h-1.781z" }),
_('path', { d: "M13.831 5.125c0.041 0.082 0.080 0.166 0.117 0.25h1.611c-0.029-0.084-0.060-0.167-0.092-0.25h-1.637z" }),
_('path', { d: "M13.556 4.625c0.050 0.082 0.098 0.166 0.144 0.25h1.666c-0.036-0.084-0.073-0.167-0.112-0.25h-1.699z" }),
_('path', { d: "M14.354 6.625c0.018 0.083 0.034 0.166 0.049 0.25h1.518c-0.012-0.084-0.025-0.167-0.039-0.25h-1.528z" }),
_('path', { d: "M14.052 5.625c0.032 0.082 0.063 0.166 0.092 0.25h1.57c-0.023-0.084-0.047-0.167-0.073-0.25h-1.589z" }),
_('path', { d: "M14.225 6.125c0.025 0.083 0.049 0.166 0.070 0.25h1.539c-0.017-0.084-0.036-0.167-0.056-0.25h-1.553z" }),
_('path', { d: "M4.895 0.625c-0.182 0.077-0.361 0.16-0.537 0.25h7.283c-0.175-0.090-0.354-0.173-0.537-0.25h-6.21z" }),
_('path', { d: "M12.299 3.125c0.092 0.081 0.181 0.164 0.268 0.25h1.962c-0.060-0.085-0.122-0.168-0.185-0.25h-2.044z" }),
_('path', { d: "M3.908 1.125c-0.134 0.080-0.265 0.163-0.393 0.25h8.971c-0.128-0.087-0.26-0.17-0.393-0.25h-8.184z" }),
_('path', { d: "M6.584 0.125c-0.345 0.062-0.682 0.146-1.010 0.25h4.852c-0.328-0.104-0.665-0.188-1.010-0.25h-2.833z" }),
_('path', { d: "M9.273 1.625c0.311 0.062 0.614 0.146 0.907 0.25h2.966c-0.102-0.086-0.206-0.169-0.313-0.25h-3.56z" }),
_('path', { d: "M11.656 2.625c0.117 0.080 0.231 0.163 0.342 0.25h2.144c-0.071-0.085-0.143-0.168-0.217-0.25h-2.27z" }),
_('path', { d: "M12.807 3.625c0.074 0.081 0.146 0.165 0.216 0.25h1.832c-0.051-0.084-0.104-0.168-0.157-0.25h-1.891z" }),
_('path', { d: "M13.023 12.125c-0.070 0.085-0.142 0.169-0.216 0.25h1.891c0.054-0.082 0.107-0.166 0.157-0.25h-1.832z" }),
_('path', { d: "M13.396 11.625c-0.057 0.085-0.116 0.168-0.177 0.25h1.781c0.046-0.083 0.090-0.166 0.133-0.25h-1.737z" }),
_('path', { d: "M13.701 11.125c-0.046 0.084-0.094 0.168-0.144 0.25h1.699c0.039-0.083 0.076-0.166 0.112-0.25h-1.666z" }),
_('path', { d: "M12.567 12.625c-0.087 0.086-0.176 0.169-0.268 0.25h2.044c0.063-0.082 0.125-0.165 0.185-0.25h-1.962z" }),
_('path', { d: "M13.948 10.625c-0.037 0.084-0.076 0.168-0.117 0.25h1.637c0.032-0.083 0.062-0.166 0.092-0.25h-1.611z" }),
_('path', { d: "M14.441 7.125c0.011 0.083 0.021 0.166 0.029 0.25h1.506c-0.006-0.084-0.015-0.167-0.024-0.25h-1.511z" }),
_('path', { d: "M11.998 13.125c-0.111 0.087-0.226 0.17-0.342 0.25h2.27c0.074-0.082 0.146-0.165 0.217-0.25h-2.144z" }),
_('path', { d: "M14.47 8.625c-0.008 0.084-0.018 0.167-0.029 0.25h1.511c0.009-0.083 0.017-0.166 0.024-0.25h-1.506z" }),
_('path', { d: "M14.498 8.125c-0.002 0.084-0.005 0.167-0.009 0.25h1.502c0.004-0.083 0.006-0.166 0.007-0.25h-1.5z" }),
_('path', { d: "M14.144 10.125c-0.029 0.084-0.060 0.168-0.092 0.25h1.589c0.026-0.083 0.050-0.166 0.073-0.25h-1.57z" }),
_('path', { d: "M14.489 7.625c0.005 0.083 0.008 0.166 0.009 0.25h1.5c-0.001-0.084-0.004-0.167-0.007-0.25h-1.502z" }),
_('path', { d: "M14.295 9.625c-0.022 0.084-0.045 0.167-0.070 0.25h1.553c0.020-0.083 0.039-0.166 0.056-0.25h-1.539z" }),
_('path', { d: "M14.403 9.125c-0.015 0.084-0.031 0.167-0.049 0.25h1.528c0.014-0.083 0.027-0.166 0.039-0.25h-1.518z" }),
_('path', { d: "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z" })
            );
        }
        function CircleRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleRight.SVG = CircleRightSVG;
        return CircleRight;
    })();
export const CircleDown = /*#__PURE__*/ (() => {
        function CircleDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.875 0.633c-0.084 0.036-0.167 0.073-0.25 0.112v1.699c0.082-0.050 0.166-0.098 0.25-0.144v-1.666z" }),
_('path', { d: "M4.375 0.867c-0.084 0.043-0.167 0.088-0.25 0.133v1.781c0.082-0.061 0.165-0.12 0.25-0.177v-1.737z" }),
_('path', { d: "M3.875 1.144c-0.084 0.051-0.168 0.104-0.25 0.157v1.891c0.081-0.074 0.165-0.146 0.25-0.216v-1.832z" }),
_('path', { d: "M1.375 3.515c-0.087 0.128-0.17 0.26-0.25 0.393v8.184c0.080 0.134 0.163 0.265 0.25 0.393v-8.971z" }),
_('path', { d: "M7.125 1.559c0.083-0.011 0.166-0.021 0.25-0.029v-1.493h0.25v1.474c0.083-0.005 0.166-0.008 0.25-0.009v-1.464h0.25v1.464c0.084 0.002 0.167 0.005 0.25 0.009v-1.474h0.25v1.493c0.084 0.008 0.167 0.018 0.25 0.029v-1.511c-0.287-0.031-0.579-0.048-0.875-0.048s-0.588 0.017-0.875 0.048v1.511z" }),
_('path', { d: "M2.875 1.857c-0.085 0.071-0.168 0.143-0.25 0.217v2.27c0.080-0.117 0.163-0.231 0.25-0.343v-2.144z" }),
_('path', { d: "M2.375 2.312c-0.085 0.084-0.169 0.171-0.25 0.259v2.645c0.077-0.162 0.16-0.321 0.25-0.475v-2.429z" }),
_('path', { d: "M5.375 0.441c-0.084 0.029-0.167 0.060-0.25 0.092v1.637c0.082-0.041 0.166-0.080 0.25-0.117v-1.611z" }),
_('path', { d: "M0.375 10.426v-4.852c-0.104 0.328-0.188 0.665-0.25 1.010v2.833c0.062 0.345 0.146 0.682 0.25 1.010z" }),
_('path', { d: "M0.875 4.358c-0.090 0.175-0.173 0.354-0.25 0.537v6.21c0.077 0.182 0.16 0.361 0.25 0.537v-7.283z" }),
_('path', { d: "M6.875 0.079c-0.084 0.012-0.167 0.025-0.25 0.039v1.528c0.083-0.018 0.166-0.034 0.25-0.049v-1.518z" }),
_('path', { d: "M5.875 0.286c-0.084 0.023-0.167 0.047-0.25 0.073v1.589c0.082-0.032 0.166-0.063 0.25-0.092v-1.57z" }),
_('path', { d: "M6.375 0.165c-0.084 0.017-0.167 0.036-0.25 0.056v1.553c0.083-0.025 0.166-0.049 0.25-0.070v-1.539z" }),
_('path', { d: "M1.875 5.82v-2.966c-0.086 0.102-0.169 0.206-0.25 0.313v3.56c0.062-0.311 0.146-0.613 0.25-0.907z" }),
_('path', { d: "M9.875 0.222c-0.083-0.020-0.166-0.039-0.25-0.056v1.54c0.084 0.022 0.167 0.045 0.25 0.070v-1.554z" }),
_('path', { d: "M10.375 0.358c-0.083-0.026-0.166-0.050-0.25-0.073v1.57c0.084 0.029 0.168 0.060 0.25 0.092v-1.589z" }),
_('path', { d: "M9.375 1.646v-1.528c-0.083-0.014-0.166-0.027-0.25-0.039v1.518c0.084 0.015 0.167 0.031 0.25 0.049z" }),
_('path', { d: "M10.875 0.533c-0.083-0.032-0.166-0.062-0.25-0.092v1.611c0.084 0.037 0.168 0.076 0.25 0.117v-1.637z" }),
_('path', { d: "M13.625 11.259v2.429c0.085-0.084 0.169-0.171 0.25-0.259v-2.645c-0.077 0.162-0.16 0.321-0.25 0.475z" }),
_('path', { d: "M2.375 11.259c-0.090-0.154-0.173-0.313-0.25-0.475v2.645c0.081 0.088 0.165 0.174 0.25 0.259v-2.429z" }),
_('path', { d: "M13.375 2.075c-0.082-0.074-0.165-0.146-0.25-0.217v2.144c0.087 0.111 0.17 0.226 0.25 0.343v-2.27z" }),
_('path', { d: "M14.375 3.167c-0.081-0.106-0.164-0.211-0.25-0.313v2.966c0.104 0.293 0.188 0.596 0.25 0.907v-3.56z" }),
_('path', { d: "M11.375 0.745c-0.083-0.039-0.166-0.076-0.25-0.112v1.666c0.084 0.046 0.168 0.094 0.25 0.144v-1.699z" }),
_('path', { d: "M13.875 2.571c-0.081-0.088-0.165-0.174-0.25-0.259v2.429c0.090 0.154 0.173 0.313 0.25 0.475v-2.645z" }),
_('path', { d: "M12.875 1.657c-0.082-0.063-0.165-0.125-0.25-0.185v1.962c0.086 0.087 0.169 0.176 0.25 0.268v-2.044z" }),
_('path', { d: "M11.875 1c-0.083-0.046-0.166-0.090-0.25-0.133v1.737c0.085 0.057 0.168 0.116 0.25 0.177v-1.781z" }),
_('path', { d: "M12.375 1.302c-0.082-0.054-0.166-0.107-0.25-0.157v1.832c0.085 0.070 0.169 0.142 0.25 0.216v-1.891z" }),
_('path', { d: "M3.375 1.472c-0.085 0.060-0.168 0.122-0.25 0.185v2.044c0.081-0.092 0.164-0.181 0.25-0.268v-1.962z" }),
_('path', { d: "M1.875 10.18c-0.104-0.293-0.188-0.596-0.25-0.907v3.56c0.081 0.106 0.164 0.211 0.25 0.313v-2.966z" }),
_('path', { d: "M11.875 13.219c-0.082 0.061-0.165 0.12-0.25 0.177v1.737c0.084-0.043 0.167-0.088 0.25-0.133v-1.781z" }),
_('path', { d: "M10.875 13.831c-0.082 0.041-0.166 0.080-0.25 0.117v1.611c0.084-0.029 0.167-0.060 0.25-0.092v-1.637z" }),
_('path', { d: "M11.375 13.556c-0.082 0.050-0.166 0.098-0.25 0.144v1.666c0.084-0.036 0.167-0.073 0.25-0.112v-1.699z" }),
_('path', { d: "M9.375 14.354c-0.083 0.018-0.166 0.034-0.25 0.049v1.518c0.084-0.012 0.167-0.025 0.25-0.039v-1.528z" }),
_('path', { d: "M10.375 14.052c-0.082 0.032-0.166 0.063-0.25 0.092v1.57c0.084-0.023 0.167-0.047 0.25-0.073v-1.589z" }),
_('path', { d: "M9.875 14.225c-0.083 0.025-0.166 0.049-0.25 0.070v1.539c0.084-0.017 0.167-0.036 0.25-0.056v-1.553z" }),
_('path', { d: "M15.375 4.895c-0.077-0.182-0.16-0.361-0.25-0.537v7.283c0.090-0.175 0.173-0.354 0.25-0.537v-6.21z" }),
_('path', { d: "M12.875 12.299c-0.081 0.092-0.164 0.181-0.25 0.268v1.962c0.085-0.060 0.168-0.122 0.25-0.185v-2.044z" }),
_('path', { d: "M14.875 3.908c-0.080-0.134-0.163-0.265-0.25-0.393v8.971c0.087-0.128 0.17-0.26 0.25-0.393v-8.184z" }),
_('path', { d: "M15.875 6.584c-0.062-0.345-0.146-0.682-0.25-1.010v4.852c0.104-0.328 0.188-0.665 0.25-1.010v-2.833z" }),
_('path', { d: "M14.375 9.273c-0.062 0.311-0.146 0.614-0.25 0.907v2.966c0.086-0.102 0.169-0.206 0.25-0.313v-3.56z" }),
_('path', { d: "M13.375 11.656c-0.080 0.117-0.163 0.231-0.25 0.342v2.144c0.085-0.071 0.168-0.143 0.25-0.217v-2.27z" }),
_('path', { d: "M12.375 12.807c-0.081 0.074-0.165 0.146-0.25 0.216v1.832c0.084-0.051 0.168-0.104 0.25-0.157v-1.891z" }),
_('path', { d: "M3.875 13.023c-0.085-0.070-0.169-0.142-0.25-0.216v1.891c0.082 0.054 0.166 0.107 0.25 0.157v-1.832z" }),
_('path', { d: "M4.375 13.396c-0.085-0.057-0.168-0.116-0.25-0.177v1.781c0.083 0.046 0.166 0.090 0.25 0.133v-1.737z" }),
_('path', { d: "M4.875 13.701c-0.084-0.046-0.168-0.094-0.25-0.144v1.699c0.083 0.039 0.166 0.076 0.25 0.112v-1.666z" }),
_('path', { d: "M3.375 12.567c-0.086-0.087-0.169-0.176-0.25-0.268v2.044c0.082 0.063 0.165 0.125 0.25 0.185v-1.962z" }),
_('path', { d: "M5.375 13.948c-0.084-0.037-0.168-0.076-0.25-0.117v1.637c0.083 0.032 0.166 0.062 0.25 0.092v-1.611z" }),
_('path', { d: "M8.875 14.441c-0.083 0.011-0.166 0.021-0.25 0.029v1.506c0.084-0.006 0.167-0.015 0.25-0.024v-1.511z" }),
_('path', { d: "M2.875 11.998c-0.087-0.111-0.17-0.226-0.25-0.342v2.27c0.082 0.074 0.165 0.146 0.25 0.217v-2.144z" }),
_('path', { d: "M7.375 14.47c-0.084-0.008-0.167-0.018-0.25-0.029v1.511c0.083 0.009 0.166 0.017 0.25 0.024v-1.506z" }),
_('path', { d: "M7.875 14.498c-0.084-0.002-0.167-0.005-0.25-0.009v1.502c0.083 0.004 0.166 0.006 0.25 0.007v-1.5z" }),
_('path', { d: "M5.875 14.144c-0.084-0.029-0.168-0.060-0.25-0.092v1.589c0.083 0.026 0.166 0.050 0.25 0.073v-1.57z" }),
_('path', { d: "M8.375 14.489c-0.083 0.005-0.166 0.008-0.25 0.009v1.5c0.084-0.001 0.167-0.004 0.25-0.007v-1.502z" }),
_('path', { d: "M6.375 14.295c-0.084-0.022-0.167-0.045-0.25-0.070v1.553c0.083 0.020 0.166 0.039 0.25 0.056v-1.539z" }),
_('path', { d: "M6.875 14.403c-0.084-0.015-0.167-0.031-0.25-0.049v1.528c0.083 0.014 0.166 0.027 0.25 0.039v-1.518z" }),
_('path', { d: "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z" })
            );
        }
        function CircleDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleDown.SVG = CircleDownSVG;
        return CircleDown;
    })();
export const CircleLeft = /*#__PURE__*/ (() => {
        function CircleLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15.367 11.125c-0.036 0.084-0.073 0.167-0.112 0.25h-1.699c0.050-0.082 0.098-0.166 0.144-0.25h1.666z" }),
_('path', { d: "M15.133 11.625c-0.043 0.084-0.088 0.167-0.133 0.25h-1.781c0.061-0.082 0.12-0.165 0.177-0.25h1.737z" }),
_('path', { d: "M14.856 12.125c-0.051 0.084-0.104 0.168-0.157 0.25h-1.891c0.074-0.081 0.146-0.165 0.216-0.25h1.832z" }),
_('path', { d: "M12.485 14.625c-0.128 0.087-0.26 0.17-0.393 0.25h-8.184c-0.134-0.080-0.265-0.163-0.393-0.25h8.971z" }),
_('path', { d: "M14.441 8.875c0.011-0.083 0.021-0.166 0.029-0.25h1.493v-0.25h-1.474c0.005-0.083 0.008-0.166 0.009-0.25h1.464v-0.25h-1.464c-0.002-0.084-0.005-0.167-0.009-0.25h1.474v-0.25h-1.493c-0.008-0.084-0.018-0.167-0.029-0.25h1.511c0.031 0.287 0.048 0.579 0.048 0.875s-0.017 0.588-0.048 0.875h-1.511z" }),
_('path', { d: "M14.143 13.125c-0.071 0.085-0.143 0.168-0.217 0.25h-2.27c0.117-0.080 0.231-0.163 0.342-0.25h2.144z" }),
_('path', { d: "M13.688 13.625c-0.084 0.085-0.171 0.169-0.259 0.25h-2.645c0.162-0.077 0.321-0.16 0.475-0.25h2.429z" }),
_('path', { d: "M15.559 10.625c-0.029 0.084-0.060 0.167-0.092 0.25h-1.637c0.041-0.082 0.080-0.166 0.117-0.25h1.611z" }),
_('path', { d: "M5.574 15.625h4.852c-0.328 0.104-0.665 0.188-1.010 0.25h-2.833c-0.345-0.062-0.682-0.146-1.010-0.25z" }),
_('path', { d: "M11.642 15.125c-0.175 0.090-0.354 0.173-0.537 0.25h-6.21c-0.182-0.077-0.361-0.16-0.537-0.25h7.283z" }),
_('path', { d: "M15.921 9.125c-0.012 0.084-0.025 0.167-0.039 0.25h-1.528c0.018-0.083 0.034-0.166 0.049-0.25h1.518z" }),
_('path', { d: "M15.714 10.125c-0.023 0.084-0.047 0.167-0.073 0.25h-1.589c0.032-0.082 0.063-0.166 0.092-0.25h1.57z" }),
_('path', { d: "M15.835 9.625c-0.017 0.084-0.036 0.167-0.056 0.25h-1.553c0.025-0.083 0.049-0.166 0.070-0.25h1.539z" }),
_('path', { d: "M10.18 14.125h2.966c-0.102 0.086-0.206 0.169-0.313 0.25h-3.56c0.311-0.062 0.613-0.146 0.907-0.25z" }),
_('path', { d: "M15.778 6.125c0.020 0.083 0.039 0.166 0.056 0.25h-1.54c-0.022-0.084-0.045-0.167-0.070-0.25h1.553z" }),
_('path', { d: "M15.642 5.625c0.026 0.083 0.050 0.166 0.073 0.25h-1.57c-0.029-0.084-0.060-0.168-0.092-0.25h1.589z" }),
_('path', { d: "M14.354 6.625h1.528c0.014 0.083 0.027 0.166 0.039 0.25h-1.518c-0.015-0.084-0.031-0.167-0.049-0.25z" }),
_('path', { d: "M15.467 5.125c0.032 0.083 0.062 0.166 0.092 0.25h-1.611c-0.037-0.084-0.076-0.168-0.117-0.25h1.637z" }),
_('path', { d: "M4.741 2.375h-2.429c0.084-0.085 0.171-0.169 0.259-0.25h2.645c-0.162 0.077-0.321 0.16-0.475 0.25z" }),
_('path', { d: "M4.741 13.625c0.154 0.090 0.313 0.173 0.475 0.25h-2.645c-0.088-0.081-0.174-0.165-0.259-0.25h2.429z" }),
_('path', { d: "M13.925 2.625c0.074 0.082 0.146 0.165 0.217 0.25h-2.144c-0.111-0.087-0.226-0.17-0.342-0.25h2.27z" }),
_('path', { d: "M12.833 1.625c0.106 0.081 0.211 0.164 0.313 0.25h-2.966c-0.293-0.104-0.596-0.188-0.907-0.25h3.56z" }),
_('path', { d: "M15.255 4.625c0.039 0.083 0.076 0.166 0.112 0.25h-1.666c-0.046-0.084-0.094-0.168-0.144-0.25h1.699z" }),
_('path', { d: "M13.429 2.125c0.088 0.081 0.174 0.165 0.259 0.25h-2.429c-0.154-0.090-0.313-0.173-0.475-0.25h2.645z" }),
_('path', { d: "M14.343 3.125c0.063 0.082 0.125 0.165 0.185 0.25h-1.962c-0.087-0.086-0.176-0.169-0.268-0.25h2.044z" }),
_('path', { d: "M15 4.125c0.046 0.083 0.090 0.166 0.133 0.25h-1.737c-0.057-0.085-0.116-0.168-0.177-0.25h1.781z" }),
_('path', { d: "M14.698 3.625c0.054 0.082 0.107 0.166 0.157 0.25h-1.832c-0.070-0.085-0.142-0.169-0.216-0.25h1.891z" }),
_('path', { d: "M14.528 12.625c-0.060 0.085-0.122 0.168-0.185 0.25h-2.044c0.092-0.081 0.181-0.164 0.268-0.25h1.962z" }),
_('path', { d: "M5.82 14.125c0.293 0.104 0.596 0.188 0.907 0.25h-3.56c-0.106-0.081-0.211-0.164-0.313-0.25h2.966z" }),
_('path', { d: "M2.781 4.125c-0.061 0.082-0.12 0.165-0.177 0.25h-1.737c0.043-0.084 0.088-0.167 0.133-0.25h1.781z" }),
_('path', { d: "M2.169 5.125c-0.041 0.082-0.080 0.166-0.117 0.25h-1.611c0.029-0.084 0.060-0.167 0.092-0.25h1.637z" }),
_('path', { d: "M2.444 4.625c-0.050 0.082-0.098 0.166-0.144 0.25h-1.666c0.036-0.084 0.073-0.167 0.112-0.25h1.699z" }),
_('path', { d: "M1.646 6.625c-0.018 0.083-0.034 0.166-0.049 0.25h-1.518c0.012-0.084 0.025-0.167 0.039-0.25h1.528z" }),
_('path', { d: "M1.948 5.625c-0.032 0.082-0.063 0.166-0.092 0.25h-1.57c0.023-0.084 0.047-0.167 0.073-0.25h1.589z" }),
_('path', { d: "M1.775 6.125c-0.025 0.083-0.049 0.166-0.070 0.25h-1.539c0.017-0.084 0.036-0.167 0.056-0.25h1.553z" }),
_('path', { d: "M11.105 0.625c0.182 0.077 0.361 0.16 0.537 0.25h-7.283c0.175-0.090 0.354-0.173 0.537-0.25h6.21z" }),
_('path', { d: "M3.701 3.125c-0.092 0.081-0.181 0.164-0.268 0.25h-1.962c0.060-0.085 0.122-0.168 0.185-0.25h2.044z" }),
_('path', { d: "M12.092 1.125c0.134 0.080 0.265 0.163 0.393 0.25h-8.971c0.128-0.087 0.26-0.17 0.393-0.25h8.184z" }),
_('path', { d: "M9.416 0.125c0.345 0.062 0.682 0.146 1.010 0.25h-4.852c0.328-0.104 0.665-0.188 1.010-0.25h2.833z" }),
_('path', { d: "M6.727 1.625c-0.311 0.062-0.614 0.146-0.907 0.25h-2.966c0.102-0.086 0.206-0.169 0.313-0.25h3.56z" }),
_('path', { d: "M4.344 2.625c-0.117 0.080-0.231 0.163-0.343 0.25h-2.144c0.071-0.085 0.143-0.168 0.217-0.25h2.27z" }),
_('path', { d: "M3.193 3.625c-0.074 0.081-0.146 0.165-0.216 0.25h-1.832c0.051-0.084 0.104-0.168 0.157-0.25h1.891z" }),
_('path', { d: "M2.977 12.125c0.070 0.085 0.142 0.169 0.216 0.25h-1.891c-0.054-0.082-0.107-0.166-0.157-0.25h1.832z" }),
_('path', { d: "M2.604 11.625c0.057 0.085 0.116 0.168 0.177 0.25h-1.781c-0.046-0.083-0.090-0.166-0.133-0.25h1.737z" }),
_('path', { d: "M2.299 11.125c0.046 0.084 0.094 0.168 0.144 0.25h-1.699c-0.038-0.083-0.076-0.166-0.112-0.25h1.666z" }),
_('path', { d: "M3.433 12.625c0.087 0.086 0.176 0.169 0.268 0.25h-2.044c-0.063-0.082-0.125-0.165-0.185-0.25h1.962z" }),
_('path', { d: "M2.052 10.625c0.037 0.084 0.076 0.168 0.117 0.25h-1.637c-0.032-0.083-0.062-0.166-0.092-0.25h1.611z" }),
_('path', { d: "M1.559 7.125c-0.011 0.083-0.021 0.166-0.029 0.25h-1.506c0.006-0.084 0.015-0.167 0.024-0.25h1.511z" }),
_('path', { d: "M4.002 13.125c0.111 0.087 0.226 0.17 0.343 0.25h-2.27c-0.074-0.082-0.146-0.165-0.217-0.25h2.144z" }),
_('path', { d: "M1.53 8.625c0.008 0.084 0.018 0.167 0.029 0.25h-1.511c-0.009-0.083-0.017-0.166-0.024-0.25h1.506z" }),
_('path', { d: "M1.502 8.125c0.002 0.084 0.005 0.167 0.009 0.25h-1.502c-0.004-0.083-0.006-0.166-0.007-0.25h1.5z" }),
_('path', { d: "M1.856 10.125c0.029 0.084 0.060 0.168 0.092 0.25h-1.589c-0.026-0.083-0.050-0.166-0.073-0.25h1.57z" }),
_('path', { d: "M1.511 7.625c-0.005 0.083-0.008 0.166-0.009 0.25h-1.5c0.001-0.084 0.004-0.167 0.007-0.25h1.502z" }),
_('path', { d: "M1.705 9.625c0.022 0.084 0.045 0.167 0.070 0.25h-1.553c-0.020-0.083-0.039-0.166-0.056-0.25h1.539z" }),
_('path', { d: "M1.597 9.125c0.015 0.084 0.031 0.167 0.049 0.25h-1.528c-0.014-0.083-0.027-0.166-0.039-0.25h1.518z" }),
_('path', { d: "M10.457 11.043l-1.414 1.414-4.457-4.457 4.457-4.457 1.414 1.414-3.043 3.043z" })
            );
        }
        function CircleLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleLeft.SVG = CircleLeftSVG;
        return CircleLeft;
    })();
export const CircleUp2 = /*#__PURE__*/ (() => {
        function CircleUp2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z" }),
_('path', { d: "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z" })
            );
        }
        function CircleUp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleUp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleUp2.SVG = CircleUp2SVG;
        return CircleUp2;
    })();
export const CircleRight2 = /*#__PURE__*/ (() => {
        function CircleRight2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z" })
            );
        }
        function CircleRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleRight2.SVG = CircleRight2SVG;
        return CircleRight2;
    })();
export const CircleDown2 = /*#__PURE__*/ (() => {
        function CircleDown2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z" }),
_('path', { d: "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z" })
            );
        }
        function CircleDown2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleDown2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleDown2.SVG = CircleDown2SVG;
        return CircleDown2;
    })();
export const CircleLeft2 = /*#__PURE__*/ (() => {
        function CircleLeft2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z" }),
_('path', { d: "M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z" })
            );
        }
        function CircleLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleLeft2.SVG = CircleLeft2SVG;
        return CircleLeft2;
    })();
export const CircleUpLeft = /*#__PURE__*/ (() => {
        function CircleUpLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z" }),
_('path', { d: "M5 11h2v-2.586l3.243 3.243 1.414-1.414-3.243-3.243h2.586v-2h-6z" })
            );
        }
        function CircleUpLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleUpLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleUpLeft.SVG = CircleUpLeftSVG;
        return CircleUpLeft;
    })();
export const CircleUp3 = /*#__PURE__*/ (() => {
        function CircleUp3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z" }),
_('path', { d: "M12 7.5l-4-4-4 4 1.5 1.5 1.5-1.5v4.5h2v-4.5l1.5 1.5z" })
            );
        }
        function CircleUp3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleUp3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleUp3.SVG = CircleUp3SVG;
        return CircleUp3;
    })();
export const CircleUpRight = /*#__PURE__*/ (() => {
        function CircleUpRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z" }),
_('path', { d: "M5 5v2h2.586l-3.243 3.243 1.414 1.414 3.243-3.243v2.586h2v-6z" })
            );
        }
        function CircleUpRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleUpRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleUpRight.SVG = CircleUpRightSVG;
        return CircleUpRight;
    })();
export const CircleRight3 = /*#__PURE__*/ (() => {
        function CircleRight3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M8.5 12l4-4-4-4-1.5 1.5 1.5 1.5h-4.5v2h4.5l-1.5 1.5z" })
            );
        }
        function CircleRight3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleRight3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleRight3.SVG = CircleRight3SVG;
        return CircleRight3;
    })();
export const CircleDownRight = /*#__PURE__*/ (() => {
        function CircleDownRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" }),
_('path', { d: "M11 5h-2v2.586l-3.243-3.243-1.414 1.414 3.243 3.243h-2.586v2h6z" })
            );
        }
        function CircleDownRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleDownRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleDownRight.SVG = CircleDownRightSVG;
        return CircleDownRight;
    })();
export const CircleDown3 = /*#__PURE__*/ (() => {
        function CircleDown3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 4.418 3.582 8 8 8s8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5z" }),
_('path', { d: "M4 8.5l4 4 4-4-1.5-1.5-1.5 1.5v-4.5h-2v4.5l-1.5-1.5z" })
            );
        }
        function CircleDown3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleDown3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleDown3.SVG = CircleDown3SVG;
        return CircleDown3;
    })();
export const CircleDownLeft = /*#__PURE__*/ (() => {
        function CircleDownLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z" }),
_('path', { d: "M11 11v-2h-2.586l3.243-3.243-1.414-1.414-3.243 3.243v-2.586h-2v6z" })
            );
        }
        function CircleDownLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleDownLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleDownLeft.SVG = CircleDownLeftSVG;
        return CircleDownLeft;
    })();
export const CircleLeft3 = /*#__PURE__*/ (() => {
        function CircleLeft3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8c-4.418 0-8 3.582-8 8s3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5z" }),
_('path', { d: "M7.5 4l-4 4 4 4 1.5-1.5-1.5-1.5h4.5v-2h-4.5l1.5-1.5z" })
            );
        }
        function CircleLeft3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CircleLeft3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CircleLeft3.SVG = CircleLeft3SVG;
        return CircleLeft3;
    })();
export const CircleUpLeft2 = /*#__PURE__*/ (() => {
    function CircleUpLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM11 5v2h-2.586l3.243 3.243-1.414 1.414-3.243-3.243v2.586h-2v-6h6z" })
        );
    }
    function CircleUpLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleUpLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleUpLeft2.SVG = CircleUpLeft2SVG;
    return CircleUpLeft2;
})();
export const CircleUp4 = /*#__PURE__*/ (() => {
    function CircleUp4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM7 13v-5.5l-2 2-1.5-1.5 4.5-4.5 4.5 4.5-1.5 1.5-2-2v5.5h-2z" })
        );
    }
    function CircleUp4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleUp4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleUp4.SVG = CircleUp4SVG;
    return CircleUp4;
})();
export const CircleUpRight2 = /*#__PURE__*/ (() => {
    function CircleUpRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 11h-2v-2.586l-3.243 3.243-1.414-1.414 3.243-3.243h-2.586v-2h6v6z" })
        );
    }
    function CircleUpRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleUpRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleUpRight2.SVG = CircleUpRight2SVG;
    return CircleUpRight2;
})();
export const CircleRight4 = /*#__PURE__*/ (() => {
    function CircleRight4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM3 7h5.5l-2-2 1.5-1.5 4.5 4.5-4.5 4.5-1.5-1.5 2-2h-5.5v-2z" })
        );
    }
    function CircleRight4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleRight4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleRight4.SVG = CircleRight4SVG;
    return CircleRight4;
})();
export const CircleDownRight2 = /*#__PURE__*/ (() => {
    function CircleDownRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM5 11v-2h2.586l-3.243-3.243 1.414-1.414 3.243 3.243v-2.586h2v6h-6z" })
        );
    }
    function CircleDownRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleDownRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleDownRight2.SVG = CircleDownRight2SVG;
    return CircleDownRight2;
})();
export const CircleDown4 = /*#__PURE__*/ (() => {
    function CircleDown4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM9 3v5.5l2-2 1.5 1.5-4.5 4.5-4.5-4.5 1.5-1.5 2 2v-5.5h2z" })
        );
    }
    function CircleDown4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleDown4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleDown4.SVG = CircleDown4SVG;
    return CircleDown4;
})();
export const CircleDownLeft2 = /*#__PURE__*/ (() => {
    function CircleDownLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM5 5h2v2.586l3.243-3.243 1.414 1.414-3.243 3.243h2.586v2h-6v-6z" })
        );
    }
    function CircleDownLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleDownLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleDownLeft2.SVG = CircleDownLeft2SVG;
    return CircleDownLeft2;
})();
export const CircleLeft4 = /*#__PURE__*/ (() => {
    function CircleLeft4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM13 9h-5.5l2 2-1.5 1.5-4.5-4.5 4.5-4.5 1.5 1.5-2 2h5.5v2z" })
        );
    }
    function CircleLeft4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleLeft4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleLeft4.SVG = CircleLeft4SVG;
    return CircleLeft4;
})();
export const ArrowResize = /*#__PURE__*/ (() => {
    function ArrowResizeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 0h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-10.586 10.586v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l10.586-10.586v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1z" })
        );
    }
    function ArrowResize({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResizeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize.SVG = ArrowResizeSVG;
    return ArrowResize;
})();
export const ArrowResize2 = /*#__PURE__*/ (() => {
    function ArrowResize2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l10.586 10.586h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-10.586-10.586h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1z" })
        );
    }
    function ArrowResize2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize2.SVG = ArrowResize2SVG;
    return ArrowResize2;
})();
export const ArrowResize3 = /*#__PURE__*/ (() => {
    function ArrowResize3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.293 5.707l1.293 1.293h-9.172l1.293-1.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.391-0.39-1.024-0.39-1.414 0l-3 3c-0.391 0.391-0.391 1.024 0 1.414l3 3c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-1.293-1.293h9.172l-1.293 1.293c-0.39 0.391-0.39 1.024 0 1.414s1.024 0.391 1.414 0l3-3c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707l-3-3c-0.391-0.39-1.024-0.39-1.414 0s-0.39 1.024 0 1.414z" })
        );
    }
    function ArrowResize3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize3.SVG = ArrowResize3SVG;
    return ArrowResize3;
})();
export const ArrowResize4 = /*#__PURE__*/ (() => {
    function ArrowResize4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.293 11.293l-1.293 1.293v-9.172l1.293 1.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.39-0.391 0.39-1.024 0-1.414l-3-3c-0.391-0.391-1.024-0.391-1.414 0l-3 3c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l1.293-1.293v9.172l-1.293-1.293c-0.391-0.39-1.024-0.39-1.414 0s-0.391 1.024 0 1.414l3 3c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l3-3c0.39-0.391 0.39-1.024 0-1.414s-1.024-0.39-1.414 0z" })
        );
    }
    function ArrowResize4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize4.SVG = ArrowResize4SVG;
    return ArrowResize4;
})();
export const ArrowResize5 = /*#__PURE__*/ (() => {
    function ArrowResize5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.5 0l3.043 3.043-8.5 8.5-3.043-3.043v7.5h7.5l-3.043-3.043 8.5-8.5 3.043 3.043v-7.5z" })
        );
    }
    function ArrowResize5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize5.SVG = ArrowResize5SVG;
    return ArrowResize5;
})();
export const ArrowResize6 = /*#__PURE__*/ (() => {
    function ArrowResize6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 7.5l3.043-3.043 8.5 8.5-3.043 3.043h7.5v-7.5l-3.043 3.043-8.5-8.5 3.043-3.043h-7.5z" })
        );
    }
    function ArrowResize6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize6.SVG = ArrowResize6SVG;
    return ArrowResize6;
})();
export const ArrowResize7 = /*#__PURE__*/ (() => {
    function ArrowResize7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.5 8l-4.5 4.5v-3.5h-6v3.5l-4.5-4.5 4.5-4.5v3.5h6v-3.5l4.5 4.5z" })
        );
    }
    function ArrowResize7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize7.SVG = ArrowResize7SVG;
    return ArrowResize7;
})();
export const ArrowResize8 = /*#__PURE__*/ (() => {
    function ArrowResize8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l4.5 4.5h-3.5v6h3.5l-4.5 4.5-4.5-4.5h3.5v-6h-3.5l4.5-4.5z" })
        );
    }
    function ArrowResize8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowResize8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowResize8.SVG = ArrowResize8SVG;
    return ArrowResize8;
})();
export const SquareUpLeft = /*#__PURE__*/ (() => {
        function SquareUpLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 16h16v-16h-16v16zM14 2v12h-12v-12h12z" }),
_('path', { d: "M12 10.5l-4-4 2.5-2.5h-6.5v6.5l2.5-2.5 4 4z" })
            );
        }
        function SquareUpLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareUpLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareUpLeft.SVG = SquareUpLeftSVG;
        return SquareUpLeft;
    })();
export const SquareUp = /*#__PURE__*/ (() => {
        function SquareUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0v16h16v-16l-16 0zM14 14h-12v-12l12-0v12z" }),
_('path', { d: "M3.5 8l4.5-4.5 4.5 4.5h-3.5v5h-2v-5z" })
            );
        }
        function SquareUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareUp.SVG = SquareUpSVG;
        return SquareUp;
    })();
export const SquareUpRight = /*#__PURE__*/ (() => {
        function SquareUpRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0v16h16v-16h-16zM14 14h-12v-12h12v12z" }),
_('path', { d: "M5.5 12l4-4 2.5 2.5v-6.5h-6.5l2.5 2.5-4 4z" })
            );
        }
        function SquareUpRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareUpRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareUpRight.SVG = SquareUpRightSVG;
        return SquareUpRight;
    })();
export const SquareRight = /*#__PURE__*/ (() => {
        function SquareRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 0h-16v16h16l-0-16zM2 14v-12h12l0 12h-12z" }),
_('path', { d: "M8 3.5l4.5 4.5-4.5 4.5v-3.5h-5v-2h5z" })
            );
        }
        function SquareRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareRight.SVG = SquareRightSVG;
        return SquareRight;
    })();
export const SquareDownRight = /*#__PURE__*/ (() => {
        function SquareDownRightSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 0h-16v16h16v-16zM2 14v-12h12v12h-12z" }),
_('path', { d: "M4 5.5l4 4-2.5 2.5h6.5v-6.5l-2.5 2.5-4-4z" })
            );
        }
        function SquareDownRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareDownRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareDownRight.SVG = SquareDownRightSVG;
        return SquareDownRight;
    })();
export const SquareDown = /*#__PURE__*/ (() => {
        function SquareDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 16v-16h16v16l-16-0zM14 2h-12v12l12 0v-12z" }),
_('path', { d: "M3.5 8l4.5 4.5 4.5-4.5h-3.5v-5h-2v5z" })
            );
        }
        function SquareDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareDown.SVG = SquareDownSVG;
        return SquareDown;
    })();
export const SquareDownLeft = /*#__PURE__*/ (() => {
        function SquareDownLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 16v-16h-16v16h16zM2 2h12v12h-12v-12z" }),
_('path', { d: "M10.5 4l-4 4-2.5-2.5v6.5h6.5l-2.5-2.5 4-4z" })
            );
        }
        function SquareDownLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareDownLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareDownLeft.SVG = SquareDownLeftSVG;
        return SquareDownLeft;
    })();
export const SquareLeft = /*#__PURE__*/ (() => {
        function SquareLeftSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 16h16v-16h-16l0 16zM14 2v12h-12l-0-12h12z" }),
_('path', { d: "M8 12.5l-4.5-4.5 4.5-4.5v3.5h5v2h-5z" })
            );
        }
        function SquareLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SquareLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SquareLeft.SVG = SquareLeftSVG;
        return SquareLeft;
    })();
export const ArrowUp9 = /*#__PURE__*/ (() => {
    function ArrowUp9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0l-8 8h5v8l6 0v-8h5l-8-8zM10 7v8l-4-0v-8h-3.586l5.586-5.586 5.586 5.586h-3.586z" })
        );
    }
    function ArrowUp9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp9.SVG = ArrowUp9SVG;
    return ArrowUp9;
})();
export const ArrowRight9 = /*#__PURE__*/ (() => {
    function ArrowRight9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8l-8-8v5h-8l-0 6h8v5l8-8zM9 10h-8l0-4h8v-3.586l5.586 5.586-5.586 5.586v-3.586z" })
        );
    }
    function ArrowRight9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight9.SVG = ArrowRight9SVG;
    return ArrowRight9;
})();
export const ArrowDown9 = /*#__PURE__*/ (() => {
    function ArrowDown9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16l8-8h-5v-8l-6-0v8h-5l8 8zM6 9v-8l4 0v8h3.586l-5.586 5.586-5.586-5.586h3.586z" })
        );
    }
    function ArrowDown9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown9.SVG = ArrowDown9SVG;
    return ArrowDown9;
})();
export const ArrowLeft9 = /*#__PURE__*/ (() => {
    function ArrowLeft9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8l8 8v-5h8l0-6h-8v-5l-8 8zM7 6h8l-0 4h-8v3.586l-5.586-5.586 5.586-5.586v3.586z" })
        );
    }
    function ArrowLeft9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft9.SVG = ArrowLeft9SVG;
    return ArrowLeft9;
})();
export const ArrowUp10 = /*#__PURE__*/ (() => {
    function ArrowUp10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0l-8 8h5v8l6 0v-8h5l-8-8zM8.961 2.375l0.25 0.25h-2.422l0.25-0.25h1.922zM7.289 2.125l0.25-0.25h0.922l0.25 0.25h-1.422zM9.461 2.875l0.25 0.25h-3.422l0.25-0.25h2.922zM9.961 3.375l0.25 0.25h-4.422l0.25-0.25h3.922zM10.461 3.875l0.25 0.25h-5.422l0.25-0.25h4.922zM10.961 4.375l0.25 0.25h-6.422l0.25-0.25h5.922zM11.461 4.875l0.25 0.25h-7.422l0.25-0.25h6.922zM11.961 5.375l0.25 0.25h-8.422l0.25-0.25h7.922zM12.461 5.875l0.25 0.25h-9.422l0.25-0.25h8.922zM12.961 6.375l0.25 0.25h-10.422l0.25-0.25h9.922zM8.211 1.625h-0.422l0.211-0.211 0.211 0.211zM6 7.375h4v0.25h-4v-0.25zM6 7.875h4v0.25h-4v-0.25zM6 8.375h4v0.25h-4v-0.25zM6 8.875h4v0.25h-4v-0.25zM6 9.375h4v0.25h-4v-0.25zM6 9.875h4v0.25h-4v-0.25zM6 10.375h4v0.25h-4v-0.25zM6 10.875h4v0.25h-4v-0.25zM6 11.375h4v0.25h-4v-0.25zM6 11.875h4v0.25h-4v-0.25zM6 12.375h4v0.25h-4v-0.25zM6 12.875h4v0.25h-4v-0.25zM6 13.375h4v0.25h-4v-0.25zM6 13.875h4v0.25h-4v-0.25zM6 14.375h4v0.25h-4v-0.25zM6 15v-0.125h4v0.125l-4-0zM10 7v0.125h-4v-0.125h-3.586l0.125-0.125h10.922l0.125 0.125h-3.586z" })
        );
    }
    function ArrowUp10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp10.SVG = ArrowUp10SVG;
    return ArrowUp10;
})();
export const ArrowRight10 = /*#__PURE__*/ (() => {
    function ArrowRight10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8l-8-8v5h-8l-0 6h8v5l8-8zM13.625 8.961l-0.25 0.25v-2.422l0.25 0.25v1.922zM13.875 7.289l0.25 0.25v0.922l-0.25 0.25v-1.422zM13.125 9.461l-0.25 0.25v-3.422l0.25 0.25v2.922zM12.625 9.961l-0.25 0.25v-4.422l0.25 0.25v3.922zM12.125 10.461l-0.25 0.25v-5.422l0.25 0.25v4.922zM11.625 10.961l-0.25 0.25v-6.422l0.25 0.25v5.922zM11.125 11.461l-0.25 0.25v-7.422l0.25 0.25v6.922zM10.625 11.961l-0.25 0.25v-8.422l0.25 0.25v7.922zM10.125 12.461l-0.25 0.25v-9.422l0.25 0.25v8.922zM9.625 12.961l-0.25 0.25v-10.422l0.25 0.25v9.922zM14.375 8.211v-0.422l0.211 0.211-0.211 0.211zM8.625 6v4h-0.25v-4h0.25zM8.125 6v4h-0.25v-4h0.25zM7.625 6v4h-0.25v-4h0.25zM7.125 6v4h-0.25v-4h0.25zM6.625 6v4h-0.25v-4h0.25zM6.125 6v4h-0.25v-4h0.25zM5.625 6v4h-0.25v-4h0.25zM5.125 6v4h-0.25v-4h0.25zM4.625 6v4h-0.25v-4h0.25zM4.125 6v4h-0.25v-4h0.25zM3.625 6v4h-0.25v-4h0.25zM3.125 6v4h-0.25v-4h0.25zM2.625 6v4h-0.25v-4h0.25zM2.125 6v4h-0.25v-4h0.25zM1.625 6v4h-0.25v-4h0.25zM1 6h0.125v4h-0.125l0-4zM9 10h-0.125v-4h0.125v-3.586l0.125 0.125v10.922l-0.125 0.125v-3.586z" })
        );
    }
    function ArrowRight10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight10.SVG = ArrowRight10SVG;
    return ArrowRight10;
})();
export const ArrowDown10 = /*#__PURE__*/ (() => {
    function ArrowDown10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16l8-8h-5v-8l-6-0v8h-5l8 8zM7.039 13.625l-0.25-0.25h2.422l-0.25 0.25h-1.922zM8.711 13.875l-0.25 0.25h-0.922l-0.25-0.25h1.422zM6.539 13.125l-0.25-0.25h3.422l-0.25 0.25h-2.922zM6.039 12.625l-0.25-0.25h4.422l-0.25 0.25h-3.922zM5.539 12.125l-0.25-0.25h5.422l-0.25 0.25h-4.922zM5.039 11.625l-0.25-0.25h6.422l-0.25 0.25h-5.922zM4.539 11.125l-0.25-0.25h7.422l-0.25 0.25h-6.922zM4.039 10.625l-0.25-0.25h8.422l-0.25 0.25h-7.922zM3.539 10.125l-0.25-0.25h9.422l-0.25 0.25h-8.922zM3.039 9.625l-0.25-0.25h10.422l-0.25 0.25h-9.922zM7.789 14.375h0.422l-0.211 0.211-0.211-0.211zM10 8.625h-4v-0.25h4v0.25zM10 8.125h-4v-0.25h4v0.25zM10 7.625h-4v-0.25h4v0.25zM10 7.125h-4v-0.25h4v0.25zM10 6.625h-4v-0.25h4v0.25zM10 6.125h-4v-0.25h4v0.25zM10 5.625h-4v-0.25h4v0.25zM10 5.125h-4v-0.25h4v0.25zM10 4.625h-4v-0.25h4v0.25zM10 4.125h-4v-0.25h4v0.25zM10 3.625h-4v-0.25h4v0.25zM10 3.125h-4v-0.25h4v0.25zM10 2.625h-4v-0.25h4v0.25zM10 2.125h-4v-0.25h4v0.25zM10 1.625h-4v-0.25h4v0.25zM10 1v0.125h-4v-0.125l4 0zM6 9v-0.125h4v0.125h3.586l-0.125 0.125h-10.922l-0.125-0.125h3.586z" })
        );
    }
    function ArrowDown10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown10.SVG = ArrowDown10SVG;
    return ArrowDown10;
})();
export const ArrowLeft10 = /*#__PURE__*/ (() => {
    function ArrowLeft10SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8l8 8v-5h8l0-6h-8v-5l-8 8zM2.375 7.039l0.25-0.25v2.422l-0.25-0.25v-1.922zM2.125 8.711l-0.25-0.25v-0.922l0.25-0.25v1.422zM2.875 6.539l0.25-0.25v3.422l-0.25-0.25v-2.922zM3.375 6.039l0.25-0.25v4.422l-0.25-0.25v-3.922zM3.875 5.539l0.25-0.25v5.422l-0.25-0.25v-4.922zM4.375 5.039l0.25-0.25v6.422l-0.25-0.25v-5.922zM4.875 4.539l0.25-0.25v7.422l-0.25-0.25v-6.922zM5.375 4.039l0.25-0.25v8.422l-0.25-0.25v-7.922zM5.875 3.539l0.25-0.25v9.422l-0.25-0.25v-8.922zM6.375 3.039l0.25-0.25v10.422l-0.25-0.25v-9.922zM1.625 7.789v0.422l-0.211-0.211 0.211-0.211zM7.375 10v-4h0.25v4h-0.25zM7.875 10v-4h0.25v4h-0.25zM8.375 10v-4h0.25v4h-0.25zM8.875 10v-4h0.25v4h-0.25zM9.375 10v-4h0.25v4h-0.25zM9.875 10v-4h0.25v4h-0.25zM10.375 10v-4h0.25v4h-0.25zM10.875 10v-4h0.25v4h-0.25zM11.375 10v-4h0.25v4h-0.25zM11.875 10v-4h0.25v4h-0.25zM12.375 10v-4h0.25v4h-0.25zM12.875 10v-4h0.25v4h-0.25zM13.375 10v-4h0.25v4h-0.25zM13.875 10v-4h0.25v4h-0.25zM14.375 10v-4h0.25v4h-0.25zM15 10h-0.125v-4h0.125l-0 4zM7 6h0.125v4h-0.125v3.586l-0.125-0.125v-10.922l0.125-0.125v3.586z" })
        );
    }
    function ArrowLeft10({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft10SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft10.SVG = ArrowLeft10SVG;
    return ArrowLeft10;
})();
export const ArrowUpLeft4 = /*#__PURE__*/ (() => {
    function ArrowUpLeft4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.657 4.828l2.828-2.828h-8.485v8.485l2.828-2.828 8.132 6.010 0.707-0.707z" })
        );
    }
    function ArrowUpLeft4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpLeft4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpLeft4.SVG = ArrowUpLeft4SVG;
    return ArrowUpLeft4;
})();
export const ArrowUp11 = /*#__PURE__*/ (() => {
    function ArrowUp11SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 0l-6 6h4l1.5 10h1l1.5-10h4z" })
        );
    }
    function ArrowUp11({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp11SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp11.SVG = ArrowUp11SVG;
    return ArrowUp11;
})();
export const ArrowUpRight4 = /*#__PURE__*/ (() => {
    function ArrowUpRight4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.172 7.657l2.828 2.828v-8.485h-8.485l2.828 2.828-6.010 8.132 0.707 0.707z" })
        );
    }
    function ArrowUpRight4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpRight4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpRight4.SVG = ArrowUpRight4SVG;
    return ArrowUpRight4;
})();
export const ArrowRight11 = /*#__PURE__*/ (() => {
    function ArrowRight11SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8.5l-6-6v4l-10 1.5v1l10 1.5v4z" })
        );
    }
    function ArrowRight11({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight11SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight11.SVG = ArrowRight11SVG;
    return ArrowRight11;
})();
export const ArrowDownRight4 = /*#__PURE__*/ (() => {
    function ArrowDownRight4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.343 11.172l-2.828 2.828h8.485v-8.485l-2.828 2.828-8.132-6.010-0.707 0.707z" })
        );
    }
    function ArrowDownRight4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownRight4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownRight4.SVG = ArrowDownRight4SVG;
    return ArrowDownRight4;
})();
export const ArrowDown11 = /*#__PURE__*/ (() => {
    function ArrowDown11SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 16l6-6h-4l-1.5-10h-1l-1.5 10h-4z" })
        );
    }
    function ArrowDown11({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown11SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown11.SVG = ArrowDown11SVG;
    return ArrowDown11;
})();
export const ArrowDownLeft4 = /*#__PURE__*/ (() => {
    function ArrowDownLeft4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.828 8.343l-2.828-2.828v8.485h8.485l-2.828-2.828 6.010-8.132-0.707-0.707z" })
        );
    }
    function ArrowDownLeft4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownLeft4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownLeft4.SVG = ArrowDownLeft4SVG;
    return ArrowDownLeft4;
})();
export const ArrowLeft11 = /*#__PURE__*/ (() => {
    function ArrowLeft11SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8.5l6-6v4l10 1.5v1l-10 1.5v4z" })
        );
    }
    function ArrowLeft11({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft11SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft11.SVG = ArrowLeft11SVG;
    return ArrowLeft11;
})();
export const ArrowUpLeft5 = /*#__PURE__*/ (() => {
    function ArrowUpLeft5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 5h7l-3-3h-9.5v9.5l3 3v-7l7.5 7.5 2.5-2.5z" })
        );
    }
    function ArrowUpLeft5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpLeft5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpLeft5.SVG = ArrowUpLeft5SVG;
    return ArrowUpLeft5;
})();
export const ArrowUp12 = /*#__PURE__*/ (() => {
    function ArrowUp12SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 6.5v4l5-5v10.5h3v-10.5l5 5v-4l-6.5-6.5z" })
        );
    }
    function ArrowUp12({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp12SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp12.SVG = ArrowUp12SVG;
    return ArrowUp12;
})();
export const ArrowUpRight5 = /*#__PURE__*/ (() => {
    function ArrowUpRight5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.5 5h-7l3-3h9.5v9.5l-3 3v-7l-7.5 7.5-2.5-2.5z" })
        );
    }
    function ArrowUpRight5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUpRight5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUpRight5.SVG = ArrowUpRight5SVG;
    return ArrowUpRight5;
})();
export const ArrowRight12 = /*#__PURE__*/ (() => {
    function ArrowRight12SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.5 2h-4l5 5h-10.5v3h10.5l-5 5h4l6.5-6.5z" })
        );
    }
    function ArrowRight12({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight12SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight12.SVG = ArrowRight12SVG;
    return ArrowRight12;
})();
export const ArrowDownRight5 = /*#__PURE__*/ (() => {
    function ArrowDownRight5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 8.5v-7l3 3v9.5h-9.5l-3-3h7l-7.5-7.5 2.5-2.5z" })
        );
    }
    function ArrowDownRight5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownRight5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownRight5.SVG = ArrowDownRight5SVG;
    return ArrowDownRight5;
})();
export const ArrowDown12 = /*#__PURE__*/ (() => {
    function ArrowDown12SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 9.5v-4l-5 5v-10.5h-3v10.5l-5-5v4l6.5 6.5z" })
        );
    }
    function ArrowDown12({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown12SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown12.SVG = ArrowDown12SVG;
    return ArrowDown12;
})();
export const ArrowDownLeft5 = /*#__PURE__*/ (() => {
    function ArrowDownLeft5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.5 11h7l-3 3h-9.5v-9.5l3-3v7l7.5-7.5 2.5 2.5z" })
        );
    }
    function ArrowDownLeft5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDownLeft5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDownLeft5.SVG = ArrowDownLeft5SVG;
    return ArrowDownLeft5;
})();
export const ArrowLeft12 = /*#__PURE__*/ (() => {
    function ArrowLeft12SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 2h4l-5 5h10.5v3h-10.5l5 5h-4l-6.5-6.5z" })
        );
    }
    function ArrowLeft12({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft12SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft12.SVG = ArrowLeft12SVG;
    return ArrowLeft12;
})();
export const ArrowUp13 = /*#__PURE__*/ (() => {
    function ArrowUp13SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 7l-8-7-8 7h5.82l-1.82 9h8l-1.82-9h5.82zM10.82 15h-5.639l1.82-9h-4.339l5.339-4.671 5.339 4.671h-4.339l1.82 9z" })
        );
    }
    function ArrowUp13({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp13SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp13.SVG = ArrowUp13SVG;
    return ArrowUp13;
})();
export const ArrowRight13 = /*#__PURE__*/ (() => {
    function ArrowRight13SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9 16l7-8-7-8v5.82l-9-1.82v8l9-1.82v5.82zM1 10.82v-5.639l9 1.82v-4.339l4.671 5.339-4.671 5.339v-4.339l-9 1.82z" })
        );
    }
    function ArrowRight13({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight13SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight13.SVG = ArrowRight13SVG;
    return ArrowRight13;
})();
export const ArrowDown13 = /*#__PURE__*/ (() => {
    function ArrowDown13SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 9l8 7 8-7h-5.819l1.819-9h-8l1.82 9h-5.82zM5.18 1h5.639l-1.82 9h4.339l-5.339 4.671-5.339-4.671h4.339l-1.82-9z" })
        );
    }
    function ArrowDown13({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown13SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown13.SVG = ArrowDown13SVG;
    return ArrowDown13;
})();
export const ArrowLeft13 = /*#__PURE__*/ (() => {
    function ArrowLeft13SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 0l-7 8 7 8v-5.82l9 1.82v-8l-9 1.82v-5.82zM15 5.18v5.639l-9-1.82v4.339l-4.671-5.338 4.671-5.339v4.339l9-1.82z" })
        );
    }
    function ArrowLeft13({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft13SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft13.SVG = ArrowLeft13SVG;
    return ArrowLeft13;
})();
export const ArrowUp14 = /*#__PURE__*/ (() => {
    function ArrowUp14SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0l-7 16 7-3 7 3z" })
        );
    }
    function ArrowUp14({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp14SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp14.SVG = ArrowUp14SVG;
    return ArrowUp14;
})();
export const ArrowRight14 = /*#__PURE__*/ (() => {
    function ArrowRight14SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8l-16-7 3 7-3 7z" })
        );
    }
    function ArrowRight14({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight14SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight14.SVG = ArrowRight14SVG;
    return ArrowRight14;
})();
export const ArrowDown14 = /*#__PURE__*/ (() => {
    function ArrowDown14SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16l7-16-7 3-7-3z" })
        );
    }
    function ArrowDown14({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown14SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown14.SVG = ArrowDown14SVG;
    return ArrowDown14;
})();
export const ArrowLeft14 = /*#__PURE__*/ (() => {
    function ArrowLeft14SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8l16 7-3-7 3-7z" })
        );
    }
    function ArrowLeft14({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft14SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft14.SVG = ArrowLeft14SVG;
    return ArrowLeft14;
})();
export const CircleUp5 = /*#__PURE__*/ (() => {
    function CircleUp5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM11.5 7h-2.5v5h-2v-5h-2.5l3.5-3.5 3.5 3.5z" })
        );
    }
    function CircleUp5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleUp5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleUp5.SVG = CircleUp5SVG;
    return CircleUp5;
})();
export const CircleRight5 = /*#__PURE__*/ (() => {
    function CircleRight5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9 11.5v-2.5h-5v-2h5v-2.5l3.5 3.5-3.5 3.5z" })
        );
    }
    function CircleRight5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleRight5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleRight5.SVG = CircleRight5SVG;
    return CircleRight5;
})();
export const CircleDown5 = /*#__PURE__*/ (() => {
    function CircleDown5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8-8-3.582-8-8zM11.5 9h-2.5v-5h-2v5h-2.5l3.5 3.5 3.5-3.5z" })
        );
    }
    function CircleDown5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleDown5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleDown5.SVG = CircleDown5SVG;
    return CircleDown5;
})();
export const CircleLeft5 = /*#__PURE__*/ (() => {
    function CircleLeft5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM7 11.5v-2.5h5v-2h-5v-2.5l-3.5 3.5 3.5 3.5z" })
        );
    }
    function CircleLeft5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleLeft5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleLeft5.SVG = CircleLeft5SVG;
    return CircleLeft5;
})();
export const CircleUp6 = /*#__PURE__*/ (() => {
    function CircleUp6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14 8c0 3.314-2.686 6-6 6s-6-2.686-6-6c0-3.314 2.686-6 6-6s6 2.686 6 6zM11.5 7h-2.5v5h-2v-5h-2.5l3.5-3.5z" })
        );
    }
    function CircleUp6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleUp6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleUp6.SVG = CircleUp6SVG;
    return CircleUp6;
})();
export const CircleRight6 = /*#__PURE__*/ (() => {
    function CircleRight6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM9 11.5v-2.5h-5v-2h5v-2.5l3.5 3.5z" })
        );
    }
    function CircleRight6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleRight6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleRight6.SVG = CircleRight6SVG;
    return CircleRight6;
})();
export const CircleDown6 = /*#__PURE__*/ (() => {
    function CircleDown6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0-4.418 3.582-8 8-8s8 3.582 8 8-3.582 8-8 8-8-3.582-8-8zM14 8c0-3.314-2.686-6-6-6s-6 2.686-6 6c0 3.314 2.686 6 6 6s6-2.686 6-6zM11.5 9h-2.5v-5h-2v5h-2.5l3.5 3.5z" })
        );
    }
    function CircleDown6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleDown6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleDown6.SVG = CircleDown6SVG;
    return CircleDown6;
})();
export const CircleLeft6 = /*#__PURE__*/ (() => {
    function CircleLeft6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14c3.314 0 6-2.686 6-6s-2.686-6-6-6c-3.314 0-6 2.686-6 6s2.686 6 6 6zM7 11.5v-2.5h5v-2h-5v-2.5l-3.5 3.5z" })
        );
    }
    function CircleLeft6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleLeft6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleLeft6.SVG = CircleLeft6SVG;
    return CircleLeft6;
})();
export const ArrowUp15 = /*#__PURE__*/ (() => {
    function ArrowUp15SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 12l-8-8-8 8 8-4z" })
        );
    }
    function ArrowUp15({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp15SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp15.SVG = ArrowUp15SVG;
    return ArrowUp15;
})();
export const ArrowRight15 = /*#__PURE__*/ (() => {
    function ArrowRight15SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 16l8-8-8-8 4 8z" })
        );
    }
    function ArrowRight15({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight15SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight15.SVG = ArrowRight15SVG;
    return ArrowRight15;
})();
export const ArrowDown15 = /*#__PURE__*/ (() => {
    function ArrowDown15SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 4l8 8 8-8-8 4z" })
        );
    }
    function ArrowDown15({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown15SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown15.SVG = ArrowDown15SVG;
    return ArrowDown15;
})();
export const ArrowLeft15 = /*#__PURE__*/ (() => {
    function ArrowLeft15SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 0l-8 8 8 8-4-8z" })
        );
    }
    function ArrowLeft15({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft15SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft15.SVG = ArrowLeft15SVG;
    return ArrowLeft15;
})();
export const ArrowUp16 = /*#__PURE__*/ (() => {
    function ArrowUp16SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 15h6v1h-6zM5 13h6v1h-6zM5 11h6v1h-6zM8 0l7 7h-4v3h-6v-3h-4z" })
        );
    }
    function ArrowUp16({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowUp16SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowUp16.SVG = ArrowUp16SVG;
    return ArrowUp16;
})();
export const ArrowRight16 = /*#__PURE__*/ (() => {
    function ArrowRight16SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h1v6h-1zM2 5h1v6h-1zM4 5h1v6h-1zM16 8l-7-7v4h-3v6h3v4z" })
        );
    }
    function ArrowRight16({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowRight16SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowRight16.SVG = ArrowRight16SVG;
    return ArrowRight16;
})();
export const ArrowDown16 = /*#__PURE__*/ (() => {
    function ArrowDown16SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5 0h6v1h-6zM5 2h6v1h-6zM5 4h6v1h-6zM8 16l7-7h-4v-3h-6v3h-4z" })
        );
    }
    function ArrowDown16({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowDown16SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowDown16.SVG = ArrowDown16SVG;
    return ArrowDown16;
})();
export const ArrowLeft16 = /*#__PURE__*/ (() => {
    function ArrowLeft16SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 5h1v6h-1zM13 5h1v6h-1zM11 5h1v6h-1zM0 8l7-7v4h3v6h-3v4z" })
        );
    }
    function ArrowLeft16({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ArrowLeft16SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ArrowLeft16.SVG = ArrowLeft16SVG;
    return ArrowLeft16;
})();
export const MenuOpen = /*#__PURE__*/ (() => {
    function MenuOpenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 7l-4-4-4 4zM4 10l4 4 4-4z" })
        );
    }
    function MenuOpen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MenuOpenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MenuOpen.SVG = MenuOpenSVG;
    return MenuOpen;
})();
export const MenuOpen2 = /*#__PURE__*/ (() => {
    function MenuOpen2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 4l4 4 4-4zM4 9l4 4 4-4z" })
        );
    }
    function MenuOpen2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MenuOpen2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MenuOpen2.SVG = MenuOpen2SVG;
    return MenuOpen2;
})();
export const MenuClose = /*#__PURE__*/ (() => {
    function MenuCloseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 3l4 4 4-4zM12 14l-4-4-4 4z" })
        );
    }
    function MenuClose({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MenuCloseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MenuClose.SVG = MenuCloseSVG;
    return MenuClose;
})();
export const MenuClose2 = /*#__PURE__*/ (() => {
    function MenuClose2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 4l4 4 4-4zM12 13l-4-4-4 4z" })
        );
    }
    function MenuClose2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MenuClose2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    MenuClose2.SVG = MenuClose2SVG;
    return MenuClose2;
})();
export const Enter4 = /*#__PURE__*/ (() => {
    function Enter4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 1h-3v7h-7.5l2.5-2.5-2-2-6 6 6 6 2-2-2.5-2.5h10.5z" })
        );
    }
    function Enter4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enter4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enter4.SVG = Enter4SVG;
    return Enter4;
})();
export const Enter5 = /*#__PURE__*/ (() => {
    function Enter5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 1v7h-6v-4.5l-6 6 6 6v-4.5h9v-10z" })
        );
    }
    function Enter5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Enter5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Enter5.SVG = Enter5SVG;
    return Enter5;
})();
export const Esc = /*#__PURE__*/ (() => {
        function EscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8h2c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6v-2z" }),
_('path', { d: "M7.532 8.968l-5.25-5.25-2.282 2.282v-6h6l-2.282 2.282 5.25 5.25z" })
            );
        }
        function Esc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Esc.SVG = EscSVG;
        return Esc;
    })();
export const Enter6 = /*#__PURE__*/ (() => {
        function Enter6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8h2c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6v-2z" }),
_('path', { d: "M2.468 1.032l5.25 5.25 2.282-2.282v6h-6l2.282-2.282-5.25-5.25z" })
            );
        }
        function Enter6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Enter6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Enter6.SVG = Enter6SVG;
        return Enter6;
    })();
export const Backspace = /*#__PURE__*/ (() => {
        function BackspaceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.25 4h8.75v9h-8.75c-0.147 0-0.469-0.133-0.573-0.237l-4.263-4.263 4.263-4.263c0.104-0.104 0.426-0.237 0.573-0.237v0zM6.25 3v0c-0.412 0-0.989 0.239-1.28 0.53l-4.439 4.439c-0.292 0.292-0.292 0.769 0 1.061l4.439 4.439c0.292 0.292 0.868 0.53 1.28 0.53h9c0.412 0 0.75-0.338 0.75-0.75v-9.5c0-0.413-0.338-0.75-0.75-0.75h-9z" }),
_('path', { d: "M14 6.5l-1.5-1.5-2 2-2-2-1.5 1.5 2 2-2 2 1.5 1.5 2-2 2 2 1.5-1.5-2-2z" })
            );
        }
        function Backspace({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BackspaceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Backspace.SVG = BackspaceSVG;
        return Backspace;
    })();
export const Backspace2 = /*#__PURE__*/ (() => {
    function Backspace2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.25 3h-9c-0.412 0-0.989 0.239-1.28 0.53l-4.439 4.439c-0.292 0.292-0.292 0.769 0 1.061l4.439 4.439c0.292 0.292 0.868 0.53 1.28 0.53h9c0.412 0 0.75-0.338 0.75-0.75v-9.5c0-0.413-0.338-0.75-0.75-0.75zM14 10.5l-1.5 1.5-2-2-2 2-1.5-1.5 2-2-2-2 1.5-1.5 2 2 2-2 1.5 1.5-2 2 2 2z" })
        );
    }
    function Backspace2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Backspace2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Backspace2.SVG = Backspace2SVG;
    return Backspace2;
})();
export const Tab = /*#__PURE__*/ (() => {
        function TabSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M15 0h1v8h-1v-8z" }),
_('path', { d: "M0 8h1v8h-1v-8z" }),
_('path', { d: "M5 11h11v2h-11v2.5l-3.5-3.5 3.5-3.5v2.5z" }),
_('path', { d: "M11 5h-11v-2h11v-2.5l3.5 3.5-3.5 3.5z" })
            );
        }
        function Tab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Tab.SVG = TabSVG;
        return Tab;
    })();
export const Transmission = /*#__PURE__*/ (() => {
    function TransmissionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 6h-11v-2h11v-2.5l3.5 3.5-3.5 3.5zM4 10h11v2h-11v2.5l-3.5-3.5 3.5-3.5z" })
        );
    }
    function Transmission({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TransmissionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Transmission.SVG = TransmissionSVG;
    return Transmission;
})();
export const Transmission2 = /*#__PURE__*/ (() => {
    function Transmission2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 9.5v-3.5h-11v-2h11v-3.5l4.5 4.5-4.5 4.5zM5 10h11v2h-11v3.5l-4.5-4.5 4.5-4.5v3.5z" })
        );
    }
    function Transmission2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Transmission2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Transmission2.SVG = Transmission2SVG;
    return Transmission2;
})();
export const Sort = /*#__PURE__*/ (() => {
    function SortSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 4v11h-2v-11h-2.5l3.5-3.5 3.5 3.5zM10 12v-11h2v11h2.5l-3.5 3.5-3.5-3.5z" })
        );
    }
    function Sort({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SortSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sort.SVG = SortSVG;
    return Sort;
})();
export const Sort2 = /*#__PURE__*/ (() => {
    function Sort2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.5 11h3.5v-11h2v11h3.5l-4.5 4.5-4.5-4.5zM6 5v11h-2v-11h-3.5l4.5-4.5 4.5 4.5h-3.5z" })
        );
    }
    function Sort2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Sort2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sort2.SVG = Sort2SVG;
    return Sort2;
})();
export const MoveUp = /*#__PURE__*/ (() => {
        function MoveUpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 8v6h1v-6h2.5l-3-3-3 3z" }),
_('path', { d: "M1 3h1.5v1h-1.5v-1z" }),
_('path', { d: "M3 3h1.5v1h-1.5v-1z" }),
_('path', { d: "M5 3h1v1.5h-1v-1.5z" }),
_('path', { d: "M1 6.5h1v1.5h-1v-1.5z" }),
_('path', { d: "M2.5 7h1.5v1h-1.5v-1z" }),
_('path', { d: "M4.5 7h1.5v1h-1.5v-1z" }),
_('path', { d: "M1 4.5h1v1.5h-1v-1.5z" }),
_('path', { d: "M5 5h1v1.5h-1v-1.5z" }),
_('path', { d: "M5 11v3h-3v-3h3zM6 10h-5v5h5v-5z" })
            );
        }
        function MoveUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveUp.SVG = MoveUpSVG;
        return MoveUp;
    })();
export const MoveDown = /*#__PURE__*/ (() => {
        function MoveDownSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M12 11v-6h-1v6h-2.5l3 3 3-3z" }),
_('path', { d: "M5 4v3h-3v-3h3zM6 3h-5v5h5v-5z" }),
_('path', { d: "M1 10h1.5v1h-1.5v-1z" }),
_('path', { d: "M3 10h1.5v1h-1.5v-1z" }),
_('path', { d: "M5 10h1v1.5h-1v-1.5z" }),
_('path', { d: "M1 13.5h1v1.5h-1v-1.5z" }),
_('path', { d: "M2.5 14h1.5v1h-1.5v-1z" }),
_('path', { d: "M4.5 14h1.5v1h-1.5v-1z" }),
_('path', { d: "M1 11.5h1v1.5h-1v-1.5z" }),
_('path', { d: "M5 12h1v1.5h-1v-1.5z" })
            );
        }
        function MoveDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MoveDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MoveDown.SVG = MoveDownSVG;
        return MoveDown;
    })();
export const SortAlphaAsc = /*#__PURE__*/ (() => {
        function SortAlphaAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M14.5 16h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.101 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M15.947 6.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 4l1.191-2.382 1.191 2.382h-2.382z" })
            );
        }
        function SortAlphaAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAlphaAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAlphaAsc.SVG = SortAlphaAscSVG;
        return SortAlphaAsc;
    })();
export const SortAlphaDesc = /*#__PURE__*/ (() => {
        function SortAlphaDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M14.5 7h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.102 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M15.947 15.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 13l1.191-2.382 1.191 2.382h-2.382z" })
            );
        }
        function SortAlphaDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAlphaDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAlphaDesc.SVG = SortAlphaDescSVG;
        return SortAlphaDesc;
    })();
export const SortNumericAsc = /*#__PURE__*/ (() => {
        function SortNumericAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M13.5 7c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 10h2v2h-2v-2z" })
            );
        }
        function SortNumericAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortNumericAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortNumericAsc.SVG = SortNumericAscSVG;
        return SortNumericAsc;
    })();
export const SortNumbericDesc = /*#__PURE__*/ (() => {
        function SortNumbericDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M13.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 0h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 1h2v2h-2v-2z" })
            );
        }
        function SortNumbericDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortNumbericDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortNumbericDesc.SVG = SortNumbericDescSVG;
        return SortNumbericDesc;
    })();
export const SortAmountAsc = /*#__PURE__*/ (() => {
        function SortAmountAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M7 9h9v2h-9v-2z" }),
_('path', { d: "M7 6h7v2h-7v-2z" }),
_('path', { d: "M7 3h5v2h-5v-2z" }),
_('path', { d: "M7 0h3v2h-3v-2z" })
            );
        }
        function SortAmountAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAmountAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAmountAsc.SVG = SortAmountAscSVG;
        return SortAmountAsc;
    })();
export const SortAmountDesc = /*#__PURE__*/ (() => {
        function SortAmountDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M7 0h9v2h-9v-2z" }),
_('path', { d: "M7 3h7v2h-7v-2z" }),
_('path', { d: "M7 6h5v2h-5v-2z" }),
_('path', { d: "M7 9h3v2h-3v-2z" })
            );
        }
        function SortAmountDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortAmountDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortAmountDesc.SVG = SortAmountDescSVG;
        return SortAmountDesc;
    })();
export const SortTimeAsc = /*#__PURE__*/ (() => {
        function SortTimeAscSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M10.5 2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-2.5c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M16 5c0-2.757-2.243-5-5-5s-5 2.243-5 5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.86-1.277 3.428-3 3.873v-1.873l-3 2.5 3 2.5v-2.101c2.28-0.465 4-2.485 4-4.899z" })
            );
        }
        function SortTimeAsc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortTimeAscSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortTimeAsc.SVG = SortTimeAscSVG;
        return SortTimeAsc;
    })();
export const SortTimeDesc = /*#__PURE__*/ (() => {
        function SortTimeDescSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z" }),
_('path', { d: "M10.5 2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-2.5c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M6 5c0-2.757 2.243-5 5-5s5 2.243 5 5v0.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-0.5c0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.86 1.277 3.428 3 3.873v-1.873l3 2.5-3 2.5v-2.101c-2.279-0.465-4-2.485-4-4.899z" })
            );
        }
        function SortTimeDesc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SortTimeDescSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SortTimeDesc.SVG = SortTimeDescSVG;
        return SortTimeDesc;
    })();
export const Battery6 = /*#__PURE__*/ (() => {
        function Battery6SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h11v6h-11v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery6.SVG = Battery6SVG;
        return Battery6;
    })();
export const Battery5 = /*#__PURE__*/ (() => {
        function Battery5SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h10v6h-10v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery5.SVG = Battery5SVG;
        return Battery5;
    })();
export const Battery4 = /*#__PURE__*/ (() => {
        function Battery4SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h8v6h-8v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery4.SVG = Battery4SVG;
        return Battery4;
    })();
export const Battery3 = /*#__PURE__*/ (() => {
        function Battery3SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h6v6h-6v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery3.SVG = Battery3SVG;
        return Battery3;
    })();
export const Battery2 = /*#__PURE__*/ (() => {
        function Battery2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h4v6h-4v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery2.SVG = Battery2SVG;
        return Battery2;
    })();
export const Battery1 = /*#__PURE__*/ (() => {
        function Battery1SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2 6h2v6h-2v-6z" }),
_('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery1({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery1SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery1.SVG = Battery1SVG;
        return Battery1;
    })();
export const Battery0 = /*#__PURE__*/ (() => {
        function Battery0SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 4h-13c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h13c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1zM14 13h-13v-8h13v8z" }),
_('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" })
            );
        }
        function Battery0({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Battery0SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Battery0.SVG = Battery0SVG;
        return Battery0;
    })();
export const BatteryCharging = /*#__PURE__*/ (() => {
        function BatteryChargingSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 17 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 17 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16.5 7h-1v4h1c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" }),
_('path', { d: "M14 4h-3.622l-0.491 1h4.113v8h-5.774l-0.813 1h6.587c0.55 0 1-0.45 1-1v-8c0-0.55-0.45-1-1-1z" }),
_('path', { d: "M4.935 13h-3.935v-8h5.719l0.8-1h-6.519c-0.55 0-1 0.45-1 1v8c0 0.55 0.45 1 1 1h3.414l0.521-1z" }),
_('path', { d: "M11 8h-3.7l2.7-5.5-6 7.5h3.625l-3.125 6z" })
            );
        }
        function BatteryCharging({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BatteryChargingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        BatteryCharging.SVG = BatteryChargingSVG;
        return BatteryCharging;
    })();
export const KeyKeyboard = /*#__PURE__*/ (() => {
    function KeyKeyboardSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058z" })
        );
    }
    function KeyKeyboard({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyKeyboardSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyKeyboard.SVG = KeyKeyboardSVG;
    return KeyKeyboard;
})();
export const KeyA = /*#__PURE__*/ (() => {
    function KeyASVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058zM10.786 12h1.512l-3.673-8.016h-1.25l-3.673 8.016h1.512l0.916-2h3.738l0.916 2zM6.589 9l1.411-3.079 1.411 3.079h-2.822z" })
        );
    }
    function KeyA({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyASVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyA.SVG = KeyASVG;
    return KeyA;
})();
export const KeyUp = /*#__PURE__*/ (() => {
    function KeyUpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058zM11 8l-3-3-3 3h2v3h2v-3z" })
        );
    }
    function KeyUp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyUpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyUp.SVG = KeyUpSVG;
    return KeyUp;
})();
export const KeyRight = /*#__PURE__*/ (() => {
    function KeyRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058zM8 11l3-3-3-3v2h-3v2h3z" })
        );
    }
    function KeyRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyRight.SVG = KeyRightSVG;
    return KeyRight;
})();
export const KeyDown = /*#__PURE__*/ (() => {
    function KeyDownSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058zM5 8l3 3 3-3h-2v-3h-2v3z" })
        );
    }
    function KeyDown({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyDownSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyDown.SVG = KeyDownSVG;
    return KeyDown;
})();
export const KeyLeft = /*#__PURE__*/ (() => {
    function KeyLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM15.25 13.625h-2.438c-0 0-0 0-0 0 0.119-0.074 0.231-0.158 0.336-0.25l-0 0h2.102v0.25zM12.735 12.735c-0.332 0.332-0.771 0.515-1.235 0.515h-7c-0.465 0-0.903-0.183-1.235-0.515s-0.515-0.771-0.515-1.235v-7c0-0.465 0.183-0.903 0.515-1.235s0.771-0.515 1.235-0.515h7c0.465 0 0.903 0.183 1.235 0.515s0.515 0.771 0.515 1.235v7c0 0.465-0.183 0.903-0.515 1.235zM15.25 13.125h-1.855c-0 0-0 0-0 0 0.068-0.079 0.132-0.163 0.19-0.25-0 0-0 0-0 0h1.665v0.25zM15.25 12.625h-1.52c0.041-0.081 0.078-0.164 0.111-0.25h1.409v0.25zM15.25 12.125h-1.33c-0 0.001-0.001 0.002-0.001 0.003 0.022-0.083 0.039-0.167 0.052-0.253h1.278v0.25zM15.25 11.625h-1.253c0 0-0 0-0 0 0.002-0.042 0.003-0.083 0.003-0.125v-0.125h1.25v0.25zM15.25 11.125h-1.25v-0.25h1.25v0.25zM15.25 10.625h-1.25v-0.25h1.25v0.25zM15.25 10.125h-1.25v-0.25h1.25v0.25zM15.25 9.625h-1.25v-0.25h1.25v0.25zM15.25 9.125h-1.25v-0.25h1.25v0.25zM15.25 8.625h-1.25v-0.25h1.25v0.25zM15.25 8.125h-1.25v-0.25h1.25v0.25zM15.25 7.625h-1.25v-0.25h1.25v0.25zM15.25 7.125h-1.25v-0.25h1.25v0.25zM15.25 6.625h-1.25v-0.25h1.25v0.25zM15.25 6.125h-1.25v-0.25h1.25v0.25zM15.25 5.625h-1.25v-0.25h1.25v0.25zM15.25 5.125h-1.25v-0.25h1.25v0.25zM15.25 4.625h-1.25v-0.125c0-0.042-0.001-0.084-0.003-0.125 0 0 0 0 0 0h1.253v0.25zM15.25 4.125h-1.278c-0.013-0.086-0.031-0.17-0.052-0.253 0 0.001 0.001 0.002 0.001 0.003h1.33v0.25zM15.25 3.625h-1.409c-0.032-0.086-0.069-0.169-0.111-0.25h1.52v0.25zM15.25 3.125h-1.665c0 0 0 0 0 0-0.058-0.087-0.121-0.171-0.19-0.25h1.855v0.25zM15.25 2.125h-1.375l-0.25 0.25h1.625v0.25h-1.875l-0.109 0.109c-0.453-0.453-1.078-0.734-1.766-0.734h-7c-1.375 0-2.5 1.125-2.5 2.5v7c0 0.688 0.281 1.313 0.734 1.766l-0.109 0.109h0.227c0.105 0.092 0.217 0.176 0.336 0.25 0 0-0-0-0-0h-0.813l-0.25 0.25h1.598c0.245 0.081 0.506 0.125 0.777 0.125h7c0.271 0 0.532-0.044 0.777-0.125h2.973v0.125c0 0.063-0.005 0.126-0.014 0.188 0.003-0.021 0.006-0.042 0.008-0.063h-13.369l-0.25 0.25h13.567c-0.043 0.136-0.11 0.264-0.198 0.379 0.032-0.041 0.061-0.084 0.087-0.129h-13.706l-0.25 0.25h13.764c-0.002 0.002-0.005 0.005-0.007 0.007-0.108 0.108-0.231 0.193-0.365 0.255h-13.035c-0.134-0.062-0.257-0.147-0.365-0.255-0.237-0.237-0.368-0.55-0.368-0.882v-12c0-0.332 0.131-0.645 0.368-0.882s0.55-0.368 0.882-0.368h12c0.332 0 0.645 0.131 0.882 0.368 0.002 0.002 0.005 0.005 0.007 0.007h-0.014l-0.25 0.25h0.456c-0.026-0.044-0.055-0.088-0.087-0.129 0.088 0.115 0.155 0.243 0.198 0.379h-0.817l-0.25 0.25h1.119c-0.002-0.021-0.005-0.042-0.008-0.063 0.009 0.062 0.014 0.125 0.014 0.188v0.125zM15.192 14.375c0.013-0.040 0.023-0.080 0.032-0.121-0.009 0.041-0.019 0.081-0.032 0.121zM15.224 14.251c0.004-0.019 0.007-0.038 0.010-0.057-0.003 0.019-0.006 0.038-0.010 0.057zM14.889 14.875c0.018-0.018 0.035-0.036 0.051-0.055-0.016 0.019-0.033 0.037-0.051 0.055zM14.947 14.812c0.015-0.018 0.030-0.036 0.045-0.055-0.014 0.019-0.029 0.037-0.045 0.055zM14.889 1.125c0.018 0.018 0.035 0.036 0.051 0.055-0.016-0.019-0.033-0.037-0.051-0.055zM14.947 1.188c0.015 0.018 0.030 0.036 0.045 0.055-0.014-0.019-0.029-0.037-0.045-0.055zM15.192 1.625c0.013 0.040 0.023 0.080 0.032 0.121-0.009-0.041-0.019-0.081-0.032-0.121zM15.224 1.749c0.004 0.019 0.007 0.038 0.010 0.058-0.003-0.019-0.006-0.039-0.010-0.058zM8 5l-3 3 3 3v-2h3v-2h-3z" })
        );
    }
    function KeyLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( KeyLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    KeyLeft.SVG = KeyLeftSVG;
    return KeyLeft;
})();
export const Command = /*#__PURE__*/ (() => {
    function CommandSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 14c-1.379 0-2.5-1.121-2.5-2.5v-1.5h-2v1.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5h1.5v-2h-1.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5v1.5h2v-1.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5h-1.5v2h1.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5zM10 10v1.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5h-1.5zM4.5 10c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5v-1.5h-1.5zM7 9h2v-2h-2v2zM10 6h1.5c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5v1.5zM4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5h1.5v-1.5c0-0.827-0.673-1.5-1.5-1.5z" })
        );
    }
    function Command({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CommandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Command.SVG = CommandSVG;
    return Command;
})();
export const Shift = /*#__PURE__*/ (() => {
    function ShiftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 14h-5c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-2c-0.202 0-0.385-0.122-0.462-0.309s-0.035-0.402 0.108-0.545l5-5c0.195-0.195 0.512-0.195 0.707 0l5 5c0.143 0.143 0.186 0.358 0.108 0.545s-0.26 0.309-0.462 0.309h-2v5.5c0 0.276-0.224 0.5-0.5 0.5zM6 13h4v-5.5c0-0.276 0.224-0.5 0.5-0.5h1.293l-3.793-3.793-3.793 3.793h1.293c0.276 0 0.5 0.224 0.5 0.5v5.5z" })
        );
    }
    function Shift({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ShiftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Shift.SVG = ShiftSVG;
    return Shift;
})();
export const Ctrl = /*#__PURE__*/ (() => {
    function CtrlSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.5 7c-0.139 0-0.278-0.058-0.377-0.171l-3.124-3.57-3.124 3.57c-0.182 0.208-0.498 0.229-0.706 0.047s-0.229-0.498-0.047-0.706l3.5-4c0.095-0.108 0.232-0.171 0.376-0.171s0.281 0.062 0.376 0.171l3.5 4c0.182 0.208 0.161 0.524-0.047 0.706-0.095 0.083-0.212 0.124-0.329 0.124z" })
        );
    }
    function Ctrl({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CtrlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ctrl.SVG = CtrlSVG;
    return Ctrl;
})();
export const Opt = /*#__PURE__*/ (() => {
        function OptSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 13h-4c-0.198 0-0.377-0.116-0.457-0.297l-3.868-8.703h-4.675c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.198 0 0.377 0.116 0.457 0.297l3.868 8.703h3.675c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M14.5 4h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Opt({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Opt.SVG = OptSVG;
        return Opt;
    })();
export const CheckboxChecked = /*#__PURE__*/ (() => {
        function CheckboxCheckedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M0 0v16h16v-16h-16zM15 15h-14v-14h14v14z" }),
_('path', { d: "M2.5 8l1.5-1.5 2.5 2.5 5.5-5.5 1.5 1.5-7 7z" })
            );
        }
        function CheckboxChecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CheckboxCheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        CheckboxChecked.SVG = CheckboxCheckedSVG;
        return CheckboxChecked;
    })();
export const CheckboxUnchecked = /*#__PURE__*/ (() => {
    function CheckboxUncheckedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM15 15h-14v-14h14v14z" })
        );
    }
    function CheckboxUnchecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckboxUncheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckboxUnchecked.SVG = CheckboxUncheckedSVG;
    return CheckboxUnchecked;
})();
export const CheckboxPartial = /*#__PURE__*/ (() => {
    function CheckboxPartialSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM15 15h-14v-14h14v14zM4 4h8v8h-8z" })
        );
    }
    function CheckboxPartial({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckboxPartialSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckboxPartial.SVG = CheckboxPartialSVG;
    return CheckboxPartial;
})();
export const Square = /*#__PURE__*/ (() => {
    function SquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0h16v16h-16z" })
        );
    }
    function Square({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Square.SVG = SquareSVG;
    return Square;
})();
export const Triangle = /*#__PURE__*/ (() => {
    function TriangleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 4.144l5.402 9.356h-10.804l5.402-9.356zM8 1.144l-8 13.856h16l-8-13.856z" })
        );
    }
    function Triangle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TriangleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Triangle.SVG = TriangleSVG;
    return Triangle;
})();
export const Triangle2 = /*#__PURE__*/ (() => {
    function Triangle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1.144l-8 13.856h16z" })
        );
    }
    function Triangle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Triangle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Triangle2.SVG = Triangle2SVG;
    return Triangle2;
})();
export const Diamond3 = /*#__PURE__*/ (() => {
    function Diamond3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.5l-7.5 7.5 7.5 7.5 7.5-7.5-7.5-7.5zM2.5 8l5.5-5.5 5.5 5.5-5.5 5.5-5.5-5.5z" })
        );
    }
    function Diamond3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Diamond3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamond3.SVG = Diamond3SVG;
    return Diamond3;
})();
export const Diamond4 = /*#__PURE__*/ (() => {
    function Diamond4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.5 8l7.5-7.5 7.5 7.5-7.5 7.5-7.5-7.5z" })
        );
    }
    function Diamond4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Diamond4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Diamond4.SVG = Diamond4SVG;
    return Diamond4;
})();
export const CheckboxChecked2 = /*#__PURE__*/ (() => {
    function CheckboxChecked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z" })
        );
    }
    function CheckboxChecked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckboxChecked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckboxChecked2.SVG = CheckboxChecked2SVG;
    return CheckboxChecked2;
})();
export const CheckboxUnchecked2 = /*#__PURE__*/ (() => {
    function CheckboxUnchecked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z" })
        );
    }
    function CheckboxUnchecked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckboxUnchecked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckboxUnchecked2.SVG = CheckboxUnchecked2SVG;
    return CheckboxUnchecked2;
})();
export const CheckboxPartial2 = /*#__PURE__*/ (() => {
    function CheckboxPartial2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 14h-12v-12h12v12zM5 12h6c0.55 0 1-0.45 1-1v-6c0-0.55-0.45-1-1-1h-6c-0.55 0-1 0.45-1 1v6c0 0.55 0.45 1 1 1zM5 10.875h6v0.123c-0.001 0.001-0.001 0.001-0.002 0.002h-5.996c-0.001-0.001-0.001-0.001-0.002-0.002v-0.123zM5.002 5h5.996c0.001 0.001 0.001 0.001 0.002 0.002v0.123h-6v-0.123c0.001-0.001 0.001-0.001 0.002-0.002zM11 5.375v0.25h-6v-0.25h6zM11 5.875v0.25h-6v-0.25h6zM11 6.375v0.25h-6v-0.25h6zM11 6.875v0.25h-6v-0.25h6zM11 7.375v0.25h-6v-0.25h6zM11 7.875v0.25h-6v-0.25h6zM11 8.375v0.25h-6v-0.25h6zM11 8.875v0.25h-6v-0.25h6zM11 9.375v0.25h-6v-0.25h6zM11 9.875v0.25h-6v-0.25h6zM11 10.375v0.25h-6v-0.25h6z" })
        );
    }
    function CheckboxPartial2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckboxPartial2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckboxPartial2.SVG = CheckboxPartial2SVG;
    return CheckboxPartial2;
})();
export const RadioChecked = /*#__PURE__*/ (() => {
    function RadioCheckedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z" })
        );
    }
    function RadioChecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RadioCheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RadioChecked.SVG = RadioCheckedSVG;
    return RadioChecked;
})();
export const RadioChecked2 = /*#__PURE__*/ (() => {
    function RadioChecked2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z" })
        );
    }
    function RadioChecked2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RadioChecked2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RadioChecked2.SVG = RadioChecked2SVG;
    return RadioChecked2;
})();
export const RadioUnchecked = /*#__PURE__*/ (() => {
    function RadioUncheckedSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z" })
        );
    }
    function RadioUnchecked({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RadioUncheckedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    RadioUnchecked.SVG = RadioUncheckedSVG;
    return RadioUnchecked;
})();
export const ToggleOn = /*#__PURE__*/ (() => {
    function ToggleOnSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 4h-5c-3.038 0-5.5 2.462-5.5 5.5s2.462 5.5 5.5 5.5h5c3.038 0 5.5-2.462 5.5-5.5s-2.462-5.5-5.5-5.5zM10.5 12c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z" })
        );
    }
    function ToggleOn({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ToggleOnSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ToggleOn.SVG = ToggleOnSVG;
    return ToggleOn;
})();
export const ToggleOff = /*#__PURE__*/ (() => {
        function ToggleOffSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.5 6c0.935 0 1.814 0.364 2.475 1.025s1.025 1.54 1.025 2.475-0.364 1.814-1.025 2.475c-0.661 0.661-1.54 1.025-2.475 1.025h-5c-0.935 0-1.814-0.364-2.475-1.025s-1.025-1.54-1.025-2.475 0.364-1.814 1.025-2.475c0.661-0.661 1.54-1.025 2.475-1.025h5zM10.5 4h-5c-3.038 0-5.5 2.462-5.5 5.5s2.462 5.5 5.5 5.5h5c3.038 0 5.5-2.462 5.5-5.5s-2.462-5.5-5.5-5.5v0z" }),
_('path', { d: "M8 9.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5z" })
            );
        }
        function ToggleOff({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ToggleOffSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        ToggleOff.SVG = ToggleOffSVG;
        return ToggleOff;
    })();
export const CheckmarkCircle = /*#__PURE__*/ (() => {
    function CheckmarkCircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM6.5 12.031l-2.813-3.344 1.031-1.031 1.781 1.75 5.156-4.5 0.719 0.719-5.875 6.406z" })
        );
    }
    function CheckmarkCircle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CheckmarkCircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CheckmarkCircle.SVG = CheckmarkCircleSVG;
    return CheckmarkCircle;
})();
export const Circle = /*#__PURE__*/ (() => {
    function CircleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z" })
        );
    }
    function Circle({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Circle.SVG = CircleSVG;
    return Circle;
})();
export const Circle2 = /*#__PURE__*/ (() => {
    function Circle2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8c0-4.418 3.582-8 8-8s8 3.582 8 8c0 4.418-3.582 8-8 8s-8-3.582-8-8z" })
        );
    }
    function Circle2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Circle2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Circle2.SVG = Circle2SVG;
    return Circle2;
})();
export const Circles = /*#__PURE__*/ (() => {
        function CirclesSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 1c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 13c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z" }),
_('path', { d: "M11.75 8c0 2.071-1.679 3.75-3.75 3.75s-3.75-1.679-3.75-3.75c0-2.071 1.679-3.75 3.75-3.75s3.75 1.679 3.75 3.75z" })
            );
        }
        function Circles({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CirclesSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Circles.SVG = CirclesSVG;
        return Circles;
    })();
export const Circles2 = /*#__PURE__*/ (() => {
        function Circles2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 1c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 13c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z" }),
_('path', { d: "M8 5.25c1.516 0 2.75 1.234 2.75 2.75s-1.234 2.75-2.75 2.75-2.75-1.234-2.75-2.75 1.234-2.75 2.75-2.75zM8 4.25c-2.071 0-3.75 1.679-3.75 3.75s1.679 3.75 3.75 3.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75v0z" })
            );
        }
        function Circles2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Circles2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Circles2.SVG = Circles2SVG;
        return Circles2;
    })();
export const Crop = /*#__PURE__*/ (() => {
    function CropSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13 4l3-3-1-1-3 3h-7v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7zM5 5h5l-5 5v-5zM6 11l5-5v5h-5z" })
        );
    }
    function Crop({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CropSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Crop.SVG = CropSVG;
    return Crop;
})();
export const Crop2 = /*#__PURE__*/ (() => {
        function Crop2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 11v-11h-2v3h-3v2h3v8h8v3h2v-3h3v-2z" }),
_('path', { d: "M11 10h2v-7h-7v2h5z" })
            );
        }
        function Crop2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Crop2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Crop2.SVG = Crop2SVG;
        return Crop2;
    })();
export const MakeGroup = /*#__PURE__*/ (() => {
        function MakeGroupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 2h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z" }),
_('path', { d: "M11 6h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1zM11 3h2v2h-2v-2z" }),
_('path', { d: "M5 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM5 13h-2v-2h2v2z" }),
_('path', { d: "M13 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z" }),
_('path', { d: "M14 8h-1c-1.336 0-2.591-0.52-3.536-1.464s-1.464-2.2-1.464-3.536v-1c0-1.1-0.9-2-2-2h-4c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h1c1.336 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536v1c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zM15 14c0 0.265-0.105 0.515-0.295 0.705s-0.44 0.295-0.705 0.295h-4c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.44-0.295-0.705v-1c0-3.314-2.686-6-6-6h-1c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.441-0.295-0.705v-4c0-0.265 0.105-0.515 0.295-0.705s0.44-0.295 0.705-0.295h4c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v1c0 3.314 2.686 6 6 6h1c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v4z" })
            );
        }
        function MakeGroup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MakeGroupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        MakeGroup.SVG = MakeGroupSVG;
        return MakeGroup;
    })();
export const Ungroup = /*#__PURE__*/ (() => {
        function UngroupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z" }),
_('path', { d: "M11 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z" }),
_('path', { d: "M6 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z" }),
_('path', { d: "M11 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z" }),
_('path', { d: "M14.251 2.5l1.749-1.749v-0.751h-0.751l-1.749 1.749-1.749-1.749h-0.751v0.751l1.749 1.749-1.749 1.749v0.751h0.751l1.749-1.749 1.749 1.749h0.751v-0.751z" }),
_('path', { d: "M0 12h1v2h-1v-2z" }),
_('path', { d: "M0 9h1v2h-1v-2z" }),
_('path', { d: "M13 7h1v2h-1v-2z" }),
_('path', { d: "M13 13h1v2h-1v-2z" }),
_('path', { d: "M13 10h1v2h-1v-2z" }),
_('path', { d: "M0 6h1v2h-1v-2z" }),
_('path', { d: "M0 3h1v2h-1v-2z" }),
_('path', { d: "M8 2h2v1h-2v-1z" }),
_('path', { d: "M5 2h2v1h-2v-1z" }),
_('path', { d: "M2 2h2v1h-2v-1z" }),
_('path', { d: "M7 15h2v1h-2v-1z" }),
_('path', { d: "M10 15h2v1h-2v-1z" }),
_('path', { d: "M4 15h2v1h-2v-1z" }),
_('path', { d: "M1 15h2v1h-2v-1z" })
            );
        }
        function Ungroup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UngroupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ungroup.SVG = UngroupSVG;
        return Ungroup;
    })();
export const Vector = /*#__PURE__*/ (() => {
        function VectorSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5 5v2.339c-1.879 2.383-3 5.391-3 8.661h1c0-1.755 0.344-3.458 1.021-5.060 0.447-1.058 1.027-2.042 1.73-2.94h2.249v-2.249c0.898-0.703 1.882-1.283 2.94-1.73 1.602-0.678 3.304-1.021 5.060-1.021v-1c-3.27 0-6.278 1.121-8.661 3h-2.339zM5 15h2v1h-2v-1zM9 15h2v1h-2v-1zM15 13v2h-2v1h3v-3h-1zM15 5h1v2h-1v-2zM15 9h1v2h-1v-2z" }),
_('path', { d: "M1 5c-0.552 0-1 0.448-1 1s0.448 1 1 1v9h1v-10c0-0.552-0.448-1-1-1z" }),
_('path', { d: "M7 1c0-0.552-0.448-1-1-1s-1 0.448-1 1 0.448 1 1 1h10v-1h-9z" })
            );
        }
        function Vector({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( VectorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Vector.SVG = VectorSVG;
        return Vector;
    })();
export const Vector2 = /*#__PURE__*/ (() => {
    function Vector2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.635 8c0.44-0.275 0.825-0.606 1.153-0.993 0.824-0.972 1.126-2.108 1.223-3.007h0.989v-3h-3v3h1.001c-0.092 0.731-0.346 1.622-0.981 2.367-0.683 0.803-1.696 1.312-3.020 1.522v-0.889h-3v1h-4c0-0.552-0.448-1-1-1s-1 0.448-1 1v1h3.365c-0.44 0.275-0.825 0.606-1.153 0.993-0.824 0.972-1.127 2.108-1.223 3.007h-0.989v3h3v-3h-1.001c0.092-0.731 0.346-1.622 0.981-2.367 0.683-0.803 1.696-1.312 3.020-1.522v0.889h3v-1h5c0 0.552 0.448 1 1 1s1-0.448 1-1v-1h-4.365zM13 3v-1h1v1h-1zM2 14v1h-1v-1h1zM8 9h-1v-1h1v1z" })
        );
    }
    function Vector2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Vector2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vector2.SVG = Vector2SVG;
    return Vector2;
})();
export const Rulers = /*#__PURE__*/ (() => {
    function RulersSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 2v-2h-6v2h-2v6h2v8h6v-8h8v-6h-8zM2 7h-1v-4h1v4zM7 2h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h2v2h-4v-14h4v1zM15 7h-1v-2h-1v2h-1v-2h-1v2h-1v-2h-1v2h-1v-4h7v4z" })
        );
    }
    function Rulers({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RulersSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rulers.SVG = RulersSVG;
    return Rulers;
})();
export const Ruler = /*#__PURE__*/ (() => {
    function RulerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8h-16v6h16v-6zM14 13v-1h-1v1h-1v-2h-1v2h-1v-1h-1v1h-1v-2h-1v2h-1v-1h-1v1h-1v-2h-1v2h-2v-4h14v4h-1z" })
        );
    }
    function Ruler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RulerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ruler.SVG = RulerSVG;
    return Ruler;
})();
export const PencilRuler = /*#__PURE__*/ (() => {
        function PencilRulerSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.899 0.221c-0.093-0.139-0.25-0.222-0.417-0.221s-0.323 0.085-0.415 0.224l-1.984 3c-0.054 0.082-0.083 0.178-0.083 0.276v11.5c0 0.551 0.449 1 1 1h3c0.551 0 1-0.449 1-1v-11.5c0-0.099-0.030-0.196-0.085-0.279l-2.016-3zM3.092 2h0.798l1.11 1.652 0 10.348h-3v-10.35l1.092-1.65z" }),
_('path', { d: "M3.5 13c0.276 0 0.5-0.224 0.5-0.5v-8c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v8c0 0.276 0.224 0.5 0.5 0.5z" }),
_('path', { d: "M8 0v16h6v-16h-6zM13 2h-1v1h1v1h-2v1h2v1h-1v1h1v1h-2v1h2v1h-1v1h1v1h-2v1h2v2h-4v-14h4v1z" })
            );
        }
        function PencilRuler({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PencilRulerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        PencilRuler.SVG = PencilRulerSVG;
        return PencilRuler;
    })();
export const Scissors = /*#__PURE__*/ (() => {
    function ScissorsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.218 16c-0.85-0-1.912-0.519-2.369-1.678-0.064-0.151-0.133-0.335-0.214-0.547-0.259-0.68-0.65-1.707-1.059-2.132-0.15-0.156-0.265-0.269-0.359-0.36-0.084-0.081-0.154-0.15-0.217-0.219-0.063 0.069-0.134 0.138-0.217 0.219-0.093 0.091-0.209 0.204-0.358 0.359-0.409 0.425-0.8 1.453-1.059 2.132-0.081 0.212-0.151 0.396-0.214 0.547-0.457 1.159-1.519 1.678-2.369 1.678-0.166 0-0.317-0.020-0.449-0.060-0.837-0.251-1.344-1.186-1.263-2.325l0.012-0.131c0.103-0.919 0.662-1.827 1.576-2.556 0.792-0.632 1.728-1.025 2.444-1.025 0.142 0 0.272 0.015 0.391 0.046l0.491-1.007c-0.505-1.263-1.223-3.149-1.785-4.801-0.313-0.921-0.545-1.675-0.69-2.241-0.23-0.897-0.215-1.2-0.122-1.379l0.269-0.52 3.345 6.858 3.345-6.858 0.269 0.52c0.093 0.179 0.107 0.483-0.122 1.379-0.145 0.566-0.377 1.321-0.69 2.241-0.562 1.652-1.28 3.538-1.785 4.801l0.491 1.007c0.119-0.031 0.25-0.046 0.391-0.046 0.715 0 1.652 0.393 2.444 1.025 0.781 0.624 1.304 1.378 1.503 2.158l0.037-0.018 0.048 0.548c0.081 1.139-0.426 2.073-1.263 2.325-0.132 0.040-0.283 0.060-0.449 0.060-0 0-0 0-0 0zM10.839 13.78c0.592 1.074 1.12 1.234 1.383 1.234 0.358 0 0.626-0.289 0.678-0.568 0.034-0.183 0.040-0.372 0.018-0.561-0.089-0.755-0.604-1.403-1.021-1.814-0.573-0.565-1.215-0.939-1.628-1.103-0.041-0.014-0.066-0.016-0.078-0.016-0.008 0-0.011 0.001-0.011 0.001-0.12 0.078-0.264 0.985 0.658 2.827zM5.723 10.968c-0.41 0.164-1.048 0.539-1.618 1.103-0.414 0.411-0.927 1.059-1.015 1.814-0.022 0.188-0.016 0.377 0.018 0.561 0.052 0.279 0.318 0.568 0.674 0.568 0.261 0 0.787-0.161 1.375-1.234 0.916-1.842 0.774-2.748 0.653-2.828 0 0-0 0-0 0s-0.004-0.001-0.010-0.001c-0.011-0-0.037 0.002-0.077 0.016z" })
        );
    }
    function Scissors({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ScissorsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Scissors.SVG = ScissorsSVG;
    return Scissors;
})();
export const Scissors2 = /*#__PURE__*/ (() => {
    function Scissors2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.655 0l-0.269 0.52c-0.093 0.179-0.107 0.483 0.122 1.379 0.145 0.566 0.377 1.321 0.69 2.241 0.395 1.163 0.868 2.441 1.29 3.536l0.955-1.959-2.789-5.718zM13.93 13.616l-0.048-0.548-0.037 0.018c-0.199-0.78-0.722-1.534-1.503-2.158-0.792-0.633-1.729-1.025-2.444-1.025-0.142 0-0.272 0.015-0.391 0.046l-0.491-1.007c0.505-1.263 1.224-3.149 1.785-4.801 0.313-0.921 0.545-1.675 0.69-2.241 0.23-0.897 0.215-1.2 0.122-1.379l-0.269-0.52-4.852 9.948c-0.119-0.031-0.25-0.046-0.391-0.046-0.715 0-1.652 0.393-2.444 1.025-0.914 0.73-1.473 1.638-1.576 2.556l-0.012 0.131c-0.081 1.139 0.426 2.073 1.263 2.325 0.132 0.040 0.283 0.060 0.449 0.060 0.85 0 1.912-0.519 2.369-1.678 0.064-0.151 0.133-0.335 0.214-0.547 0.259-0.68 0.65-1.707 1.059-2.132 0.15-0.156 0.265-0.269 0.358-0.359 0.084-0.082 0.154-0.15 0.217-0.219 0.063 0.069 0.134 0.138 0.217 0.219 0.093 0.091 0.209 0.204 0.359 0.36 0.409 0.425 0.8 1.453 1.059 2.132 0.081 0.212 0.151 0.396 0.214 0.547 0.457 1.159 1.519 1.678 2.369 1.678 0 0 0 0 0 0 0.166 0 0.317-0.020 0.449-0.060 0.837-0.252 1.344-1.186 1.263-2.325zM5.157 13.78c-0.588 1.073-1.114 1.234-1.375 1.234-0.356 0-0.622-0.289-0.674-0.568-0.034-0.184-0.040-0.373-0.018-0.561 0.088-0.755 0.6-1.403 1.015-1.814 0.569-0.565 1.208-0.939 1.618-1.103 0.041-0.014 0.066-0.016 0.077-0.016 0.006 0 0.009 0.001 0.010 0.001s0 0 0-0c0.121 0.080 0.263 0.986-0.653 2.828zM12.9 14.446c-0.052 0.279-0.32 0.568-0.678 0.568-0.263 0-0.791-0.161-1.383-1.234-0.922-1.842-0.778-2.749-0.658-2.827 0 0 0.003-0.001 0.011-0.001 0.011 0 0.037 0.002 0.078 0.016 0.412 0.164 1.055 0.539 1.628 1.103 0.417 0.411 0.933 1.059 1.021 1.814 0.022 0.189 0.016 0.378-0.018 0.561z" })
        );
    }
    function Scissors2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Scissors2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Scissors2.SVG = Scissors2SVG;
    return Scissors2;
})();
export const Scissors3 = /*#__PURE__*/ (() => {
    function Scissors3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-0.1 0.064-0.193 0.138-0.277 0.218l-1.241-1.942 2.867-4.5c0.235-0.433 0.321-0.949 0.207-1.468-0.109-0.496-0.383-0.913-0.752-1.207l-0.192-0.122-3.398 5.314-3.398-5.314-0.192 0.122c-0.369 0.294-0.643 0.711-0.752 1.207-0.114 0.519-0.027 1.035 0.207 1.468l2.867 4.5-1.241 1.942c-0.085-0.081-0.177-0.154-0.277-0.218-1.163-0.744-2.95-0.028-3.992 1.601s-0.944 3.551 0.219 4.296c1.163 0.744 2.95 0.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667 0.219-4.296zM3.67 12.507c-0.469 0.733-1.071 1.089-1.478 1.179-0 0-0 0-0 0-0.133 0.029-0.317 0.047-0.443-0.033-0.139-0.089-0.231-0.324-0.247-0.629-0.025-0.494 0.151-1.076 0.483-1.594 0.469-0.733 1.071-1.089 1.478-1.179 0.133-0.029 0.317-0.047 0.443 0.033 0.139 0.089 0.231 0.324 0.247 0.629 0.025 0.495-0.151 1.076-0.483 1.594zM7.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.498 13.023c-0.016 0.305-0.108 0.54-0.247 0.629-0.125 0.080-0.31 0.062-0.443 0.033 0 0 0 0-0 0-0.407-0.089-1.009-0.446-1.478-1.179-0.332-0.519-0.508-1.1-0.483-1.594 0.016-0.305 0.108-0.54 0.247-0.629 0.125-0.080 0.31-0.062 0.443-0.033 0.407 0.089 1.009 0.446 1.478 1.179 0.332 0.519 0.508 1.1 0.483 1.594z" })
        );
    }
    function Scissors3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Scissors3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Scissors3.SVG = Scissors3SVG;
    return Scissors3;
})();
export const Haircut = /*#__PURE__*/ (() => {
        function HaircutSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 10c-0.364 0-0.706 0.098-1 0.269v-2.769c0-0.024-0.002-0.047-0.005-0.071l-1-7c-0.035-0.246-0.246-0.429-0.495-0.429s-0.46 0.183-0.495 0.429l-1 7c-0.003 0.023-0.005 0.047-0.005 0.071v2.769c-0.294-0.171-0.636-0.269-1-0.269-1.103 0-2 0.897-2 2s0.897 2 2 2 2-0.897 2-2v-4c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v4c0 0.801 0.474 1.494 1.156 1.813-0.1 0.214-0.156 0.449-0.156 0.687 0 0.827 0.673 1.5 1.5 1.5 0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5c-0.276 0-0.5-0.224-0.5-0.5 0-0.197 0.115-0.41 0.277-0.52 0.972-0.135 1.723-0.972 1.723-1.98 0-1.103-0.897-2-2-2zM2 13c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1zM7 13c-0.551 0-1-0.449-1-1s0.449-1 1-1 1 0.449 1 1-0.449 1-1 1z" }),
_('path', { d: "M15 0h-3.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v1h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.5v5c0 0.552 0.448 1 1 1s1-0.448 1-1v-13c0-0.552-0.448-1-1-1z" })
            );
        }
        function Haircut({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( HaircutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Haircut.SVG = HaircutSVG;
        return Haircut;
    })();
export const Comb = /*#__PURE__*/ (() => {
    function CombSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 5h-13c-0.552 0-1 0.448-1 1v5.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-3.5h1v3.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5.5c0-0.552-0.448-1-1-1z" })
        );
    }
    function Comb({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CombSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Comb.SVG = CombSVG;
    return Comb;
})();
export const Filter = /*#__PURE__*/ (() => {
    function FilterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 1.119-8 2.5v1.5l6 6v5c0 0.552 0.895 1 2 1s2-0.448 2-1v-5l6-6v-1.5c0-1.381-3.582-2.5-8-2.5zM1.475 2.169c0.374-0.213 0.9-0.416 1.52-0.586 1.374-0.376 3.152-0.583 5.005-0.583s3.631 0.207 5.005 0.583c0.62 0.17 1.146 0.372 1.52 0.586 0.247 0.141 0.38 0.26 0.442 0.331-0.062 0.071-0.195 0.19-0.442 0.331-0.374 0.213-0.9 0.416-1.52 0.586-1.374 0.376-3.152 0.583-5.005 0.583s-3.631-0.207-5.005-0.583c-0.62-0.17-1.146-0.372-1.52-0.586-0.247-0.141-0.38-0.26-0.442-0.331 0.062-0.071 0.195-0.19 0.442-0.331z" })
        );
    }
    function Filter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FilterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Filter.SVG = FilterSVG;
    return Filter;
})();
export const Filter2 = /*#__PURE__*/ (() => {
    function Filter2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 3.5c0-1.933-3.582-3.5-8-3.5s-8 1.567-8 3.5c0 0.615 0.363 1.193 1 1.696h-0l5 4.57v5.234c0 0.552 0.895 1 2 1s2-0.448 2-1v-5.234l5-4.57c0.637-0.502 1-1.080 1-1.696zM14.38 4.442l-5.38 4.883v5.472c-0.159 0.088-0.505 0.203-1 0.203s-0.841-0.115-1-0.203v-5.472l-5.38-4.883c-0.231-0.182-0.62-0.575-0.62-0.942 0-0.204 0.117-0.429 0.348-0.667 0.307-0.318 0.79-0.626 1.396-0.891 0.665-0.291 1.447-0.552 2.324-0.714 0.926-0.171 1.913-0.29 2.932-0.29s2.006 0.118 2.932 0.29c0.877 0.162 1.659 0.423 2.324 0.714 0.606 0.265 1.089 0.573 1.396 0.891 0.231 0.239 0.348 0.463 0.348 0.667 0 0.367-0.388 0.759-0.62 0.942zM3 3.633c0-0.755 2.239-1.367 5-1.367s5 0.612 5 1.367c0 0.755-2.239 1.367-5 1.367s-5-0.612-5-1.367z" })
        );
    }
    function Filter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Filter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Filter2.SVG = Filter2SVG;
    return Filter2;
})();
export const Filter3 = /*#__PURE__*/ (() => {
    function Filter3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 2l6 6v6l4-1v-5l6-6z" })
        );
    }
    function Filter3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Filter3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Filter3.SVG = Filter3SVG;
    return Filter3;
})();
export const Filter4 = /*#__PURE__*/ (() => {
    function Filter4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.586 3l-4.586 4.586v4.633l-2 0.5v-5.133l-4.586-4.586h11.172zM16 2h-16l6 6v6l4-1v-5l6-6z" })
        );
    }
    function Filter4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Filter4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Filter4.SVG = Filter4SVG;
    return Filter4;
})();
export const Font = /*#__PURE__*/ (() => {
    function FontSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.494 0.253c-1.414 0-2.322-0.253-3.779-0.253-4.708 0-6.903 2.681-6.903 5.404 0 1.604 0.76 2.132 2.259 2.132-0.106-0.232-0.296-0.486-0.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v0.385h4.947l1.688-8h3.091l0.689-2h-3.358l0.812-3.847c0.929 0.19 1.837 0.38 2.618 0.38 0.971 0 1.858-0.296 2.343-2.533-0.591 0.19-1.224 0.253-1.921 0.253z" })
        );
    }
    function Font({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FontSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Font.SVG = FontSVG;
    return Font;
})();
export const Ampersand = /*#__PURE__*/ (() => {
    function AmpersandSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.992 7.090c-0.942-0.328-1.966 0.383-1.992 1.384-0.019 0.352 0.34 0.619 0.672 0.496 0.276-0.102 0.274-0.312 0.332-0.549 0.059-0.239 0.238-0.423 0.495-0.427 0.173 0.005 0.51 0.126 0.51 0.493 0.002 0.625-0.382 1.205-0.97 1.431-0.252 0.097-0.547 0.132-0.814 0.077-0.378-0.065-0.57-0.288-0.859-0.475-0.169-0.155-0.365-0.293-0.59-0.409-1.661-0.856-3.973 0.382-3.777 2.375 0.025 0.352 0.414 0.572 0.729 0.412 0.233-0.119 0.241-0.325 0.296-0.546 0.169-0.68 0.748-1.206 1.475-1.172 0.262 0.003 0.681 0.174 0.906 0.412 0.368 0.387 0.396 0.889 0.335 1.388-0.202 1.645-1.518 3.067-3.241 3.029-2.721-0.029-3.824-3.624-2.291-5.608 0.507-0.656 1.228-1.103 2.020-1.331 0.284-0.082 0.647-0.023 0.8-0.335 0.136-0.277-0.027-0.618-0.327-0.688-0.682-0.235-1.28-0.379-1.774-0.958-0.38-0.446-0.59-1.004-0.6-1.588 0.016-1.146 0.917-2.23 2.171-2.346-0.004 0-0.008-0-0.013-0 1.388-0.064 2.518 0.957 2.592 2.345 0-0.006 0-0.012 0.001-0.017 0.009 0.327-0.236 0.609-0.576 0.604-0.1-0.003-0.179-0.036-0.271-0.081-0.385-0.249-0.079-0.702-0.402-0.977-0.337-0.286-0.869-0.014-0.833 0.427-0.005 0.386 0.196 0.79 0.47 1.052 0.79 0.754 2.175 0.397 2.422-0.718 0.366-1.752-1.146-3.492-2.776-3.858-1.327-0.298-2.736 0.193-3.603 1.244-0.948 1.149-1.111 2.826-0.366 4.122 0.236 0.413 0.557 0.775 0.934 1.060-1.466 0.73-2.512 2.32-2.557 4.001-0.060 2.269 1.64 4.082 3.807 4.525 1.979 0.404 4.168-0.377 5.256-2.125 0.513-0.824 0.752-1.874 0.568-2.804 0.606 0.086 1.239-0.053 1.752-0.403 1.072-0.732 1.738-2.886 0.090-3.46v0z" })
        );
    }
    function Ampersand({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AmpersandSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ampersand.SVG = AmpersandSVG;
    return Ampersand;
})();
export const Ligature = /*#__PURE__*/ (() => {
    function LigatureSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 13.622c0-0.001 0-0.001 0-0.002l-0.005-6.821-1.992 0.097h-3.936v-0.336c0-1.274 0.091-2.546 0.269-3.042 0.123-0.343 0.353-0.652 0.683-0.919 0.322-0.261 0.643-0.393 0.955-0.393 0.262 0 0.48 0.045 0.647 0.134 0.235 0.134 0.464 0.359 0.682 0.669 0.577 0.82 0.812 1.038 0.939 1.131 0.216 0.158 0.477 0.238 0.776 0.238 0.292 0 0.546-0.109 0.757-0.324 0.209-0.213 0.315-0.479 0.315-0.792 0-0.335-0.139-0.691-0.414-1.057-0.268-0.358-0.683-0.652-1.232-0.875-0.536-0.218-1.14-0.329-1.793-0.329-0.949 0-1.813 0.228-2.568 0.678-0.757 0.451-1.337 1.077-1.725 1.863-0.359 0.728-0.333 2.105-0.355 3.355h-1.965v1.116h1.962v5.073c0 1.12-0.342 1.422-0.472 1.583-0.179 0.222-0.509 0.455-0.944 0.455h-0.604v0.878h6.021v-0.878h-0.105c-1.424 0-1.828-0.154-1.828-1.888 0-0 0-0.001 0-0.001l-0.001-5.222h2.191c1.163 0 1.43 0.054 1.491 0.077 0.074 0.028 0.169 0.075 0.204 0.143 0.014 0.026 0.081 0.391 0.081 1.296v3.917c0 0.913-0.111 1.217-0.179 1.319-0.145 0.222-0.319 0.345-0.854 0.358v0.879h4.588v-0.873c-1.431 0-1.588-0.153-1.588-1.505z" })
        );
    }
    function Ligature({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LigatureSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ligature.SVG = LigatureSVG;
    return Ligature;
})();
export const Ligature2 = /*#__PURE__*/ (() => {
    function Ligature2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.364 14.335c-0.183 0-1.307-0.206-1.375-0.458-0.161-0.619-0.183-1.284-0.183-2.040v-8.453c0-1.261 0.252-1.994 0.252-1.994-0.023-0.115-0.138-0.367-0.275-0.367h-0.069c-0.069 0-0.871 0.504-1.605 0.504-0.596-0-0.967-0.527-1.655-0.527-2.892 0-4.249 2.349-4.249 5.672v0.173c0 0.069-0.046 0.138-0.115 0.138h-0.94c-0.115 0-0.344 0.642-0.344 0.94 0 0.092 0.023 0.137 0.069 0.137h1.215c0.069 0 0.115 0.092 0.115 0.16 0 2.040-0.023 4.052-0.023 4.052 0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.138 0.046-0.665-0.069-0.665-0.183 0-1.307-0.206-1.375-0.458-0.16-0.619-0.16-1.284-0.183-2.040v-3.639c0-0.069 0.069-0.138 0.138-0.138h2.361c0.16-0.321 0.275-0.711 0.275-0.917 0-0.138 0-0.16-0.115-0.16h-2.544c-0.046 0-0.115-0.069-0.115-0.115v-0.825c0-2.040 0.836-3.837 2.234-3.837 0.99 0 1.854 0.642 1.854 3.093 0 0 0 0 0 0 0.003 0.063 0.005 0.114 0.005 0.148v6.825c0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.137 0.046-0.665-0.069-0.665z" })
        );
    }
    function Ligature2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Ligature2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ligature2.SVG = Ligature2SVG;
    return Ligature2;
})();
export const FontSize = /*#__PURE__*/ (() => {
    function FontSizeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 0v5l2-3h4v13h-2v1h6v-1h-2v-13h4l2 3v-5zM4 9h2l1 1.5v-2.5h-7v2.5l1-1.5h2v6h-1v1h3v-1h-1z" })
        );
    }
    function FontSize({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FontSizeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FontSize.SVG = FontSizeSVG;
    return FontSize;
})();
export const Typography = /*#__PURE__*/ (() => {
    function TypographySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 0v5l2-3h4v13h-2l-1 1h8l-1-1h-2v-13h4l2 3v-5z" })
        );
    }
    function Typography({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TypographySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Typography.SVG = TypographySVG;
    return Typography;
})();
export const TextHeight = /*#__PURE__*/ (() => {
    function TextHeightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM10 1v4l-1-2h-3v11h2v1h-6v-1h2v-11h-3l-1 2v-4z" })
        );
    }
    function TextHeight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TextHeightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TextHeight.SVG = TextHeightSVG;
    return TextHeight;
})();
export const TextWidth = /*#__PURE__*/ (() => {
    function TextWidthSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 1v4l-1-2h-3v7h2v1h-6v-1h2v-7h-3l-1 2v-4z" })
        );
    }
    function TextWidth({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TextWidthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TextWidth.SVG = TextWidthSVG;
    return TextWidth;
})();
export const Height2 = /*#__PURE__*/ (() => {
    function Height2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM8 3h-6v10h6v-10zM10 1v0 14h-10v-14h10z" })
        );
    }
    function Height2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Height2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Height2.SVG = Height2SVG;
    return Height2;
})();
export const Width = /*#__PURE__*/ (() => {
    function WidthSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 3h-10v5h10v-5zM15 1v0 9h-14v-9h14z" })
        );
    }
    function Width({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WidthSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Width.SVG = WidthSVG;
    return Width;
})();
export const Bold = /*#__PURE__*/ (() => {
    function BoldSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.024 7.453v-0.135c1.817-0.337 3.954-1.262 3.954-3.651 0-1.211-0.572-2.221-1.497-2.81-0.959-0.622-2.204-0.858-4.122-0.858h-7.352v0.875c1.767 0.168 2.019 0.32 2.019 2.423v9.388c0 2.059-0.238 2.245-2.025 2.424v0.891h6.265c2.103 0 4.004-0.37 5.266-1.060 1.447-0.757 2.355-2.053 2.355-3.668 0-2.355-1.918-3.499-4.862-3.819zM6 2.406c0-0.505 0.050-0.858 0.219-1.043 0.151-0.135 0.589-0.32 1.144-0.32 1.38 0 2.726 0.841 2.726 3.079 0 2.002-1.11 2.927-3.533 2.927l-0.555-0v-4.643zM7.885 14.94c-1.38 0.034-1.885-0.488-1.885-2.322h0v-4.559h0.488c2.911 0 4.391 1.178 4.391 3.483 0 2.372-1.598 3.382-2.995 3.399z" })
        );
    }
    function Bold({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BoldSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bold.SVG = BoldSVG;
    return Bold;
})();
export const Underline = /*#__PURE__*/ (() => {
    function UnderlineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 14h12v2h-12zM11 0h3v1h-1v7c0 2.761-2.239 5-5 5s-5-2.239-5-5v-7h-1v-1h4v1h-1v7c0 1.654 1.57 3.125 3.5 3.125s3.5-1.471 3.5-3.125v-7h-1v-1z" })
        );
    }
    function Underline({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( UnderlineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Underline.SVG = UnderlineSVG;
    return Underline;
})();
export const Italic = /*#__PURE__*/ (() => {
    function ItalicSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 0v1h-2.040l-5.25 14h2.29v1h-7v-1h2.040l5.25-14h-2.29v-1z" })
        );
    }
    function Italic({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ItalicSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Italic.SVG = ItalicSVG;
    return Italic;
})();
export const Strikethrough = /*#__PURE__*/ (() => {
    function StrikethroughSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15 8v1h-2.842c0.532 0.715 0.842 1.575 0.842 2.5 0 2.485-2.239 4.5-5 4.5-2.574 0-4.693-1.75-4.969-4h2.031c0.109 0.442 0.363 0.855 0.741 1.195 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695s-0.285-1.23-0.802-1.695c-0.576-0.519-1.357-0.805-2.198-0.805h-7v-1h14zM8 7h-4.158c-0.532-0.715-0.842-1.575-0.842-2.5 0-2.485 2.239-4.5 5-4.5 2.574 0 4.693 1.75 4.969 4h-2.031c-0.11-0.442-0.363-0.855-0.741-1.195-0.576-0.519-1.357-0.805-2.198-0.805s-1.621 0.286-2.198 0.805c-0.517 0.466-0.802 1.068-0.802 1.695s0.285 1.23 0.802 1.695c0.577 0.519 1.357 0.805 2.198 0.805z" })
        );
    }
    function Strikethrough({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StrikethroughSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Strikethrough.SVG = StrikethroughSVG;
    return Strikethrough;
})();
export const Strikethrough2 = /*#__PURE__*/ (() => {
    function Strikethrough2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 0v5l2-3h4v5h2v-5h4l2 3v-5zM9 15v-5h-2v5h-2l-1 1h8l-1-1zM0 8h16v1h-16z" })
        );
    }
    function Strikethrough2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Strikethrough2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Strikethrough2.SVG = Strikethrough2SVG;
    return Strikethrough2;
})();
export const FontSize2 = /*#__PURE__*/ (() => {
    function FontSize2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M1 8h6v2h-2v6h-2v-6h-2zM15 4h-3.934v12h-2.133v-12h-3.934v-2h10z" })
        );
    }
    function FontSize2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FontSize2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    FontSize2.SVG = FontSize2SVG;
    return FontSize2;
})();
export const Bold2 = /*#__PURE__*/ (() => {
    function Bold2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.061 7.573c0.586-0.696 0.939-1.594 0.939-2.573 0-2.206-1.794-4-4-4h-5v14h6c2.206 0 4-1.794 4-4 0-1.452-0.778-2.726-1.939-3.427zM6 3h1.586c0.874 0 1.586 0.897 1.586 2s-0.711 2-1.586 2h-1.586v-4zM8.484 13h-2.484v-4h2.484c0.913 0 1.656 0.897 1.656 2s-0.743 2-1.656 2z" })
        );
    }
    function Bold2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Bold2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Bold2.SVG = Bold2SVG;
    return Bold2;
})();
export const Underline2 = /*#__PURE__*/ (() => {
    function Underline2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5s-5-2.015-5-4.5v-6.5h2v6.5c0 0.628 0.285 1.23 0.802 1.695 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695v-6.5zM3 13h10v2h-10z" })
        );
    }
    function Underline2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Underline2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Underline2.SVG = Underline2SVG;
    return Underline2;
})();
export const Italic2 = /*#__PURE__*/ (() => {
    function Italic2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z" })
        );
    }
    function Italic2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Italic2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Italic2.SVG = Italic2SVG;
    return Italic2;
})();
export const Strikethrough3 = /*#__PURE__*/ (() => {
    function Strikethrough3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 8v1h-3.664c0.43 0.602 0.664 1.292 0.664 2 0 1.107-0.573 2.172-1.572 2.921-0.927 0.696-2.145 1.079-3.428 1.079s-2.501-0.383-3.428-1.079c-0.999-0.749-1.572-1.814-1.572-2.921h2c0 1.084 1.374 2 3 2s3-0.916 3-2c0-1.084-1.374-2-3-2h-8v-1h4.68c-0.037-0.026-0.073-0.052-0.108-0.079-0.999-0.749-1.572-1.814-1.572-2.921s0.573-2.172 1.572-2.921c0.927-0.696 2.145-1.079 3.428-1.079s2.501 0.383 3.428 1.079c0.999 0.749 1.572 1.814 1.572 2.921h-2c0-1.084-1.374-2-3-2s-3 0.916-3 2c0 1.084 1.374 2 3 2 1.234 0 2.407 0.354 3.32 1h4.68z" })
        );
    }
    function Strikethrough3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Strikethrough3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Strikethrough3.SVG = Strikethrough3SVG;
    return Strikethrough3;
})();
export const Omega = /*#__PURE__*/ (() => {
    function OmegaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 14h4l1-2v4h-6v-3.347c2.049-0.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973s-5.5 2.622-5.5 5.973c0 2.572 1.451 4.77 3.5 5.653v3.347h-6v-4l1 2h4v-0.509c-2.932-1.038-5-3.553-5-6.491 0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491v0.509z" })
        );
    }
    function Omega({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( OmegaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Omega.SVG = OmegaSVG;
    return Omega;
})();
export const Sigma = /*#__PURE__*/ (() => {
    function SigmaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.713 11.48l0.694-1.48h0.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18v-3.547h15.313l0.688 4h-0.537l-0.293-0.607c-0.552-1.146-0.967-1.393-2.17-1.393h-10.344l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-0.65 2.713-1.52z" })
        );
    }
    function Sigma({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SigmaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Sigma.SVG = SigmaSVG;
    return Sigma;
})();
export const Nbsp = /*#__PURE__*/ (() => {
    function NbspSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7 9h-3v-2h3v-3h2v3h3v2h-3v3h-2zM16 10v6h-16v-6h2v4h12v-4z" })
        );
    }
    function Nbsp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NbspSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Nbsp.SVG = NbspSVG;
    return Nbsp;
})();
export const PageBreak = /*#__PURE__*/ (() => {
    function PageBreakSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h1.5l0.25 6h8l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-1.5l-0.25-4h-8l-0.25 4z" })
        );
    }
    function PageBreak({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PageBreakSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PageBreak.SVG = PageBreakSVG;
    return PageBreak;
})();
export const PageBreak2 = /*#__PURE__*/ (() => {
    function PageBreak2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h0.5l0.25 6h10l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-0.5l-0.25-5h-10l-0.25 5z" })
        );
    }
    function PageBreak2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PageBreak2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    PageBreak2.SVG = PageBreak2SVG;
    return PageBreak2;
})();
export const Superscript = /*#__PURE__*/ (() => {
    function SuperscriptSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 3.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z" })
        );
    }
    function Superscript({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SuperscriptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Superscript.SVG = SuperscriptSVG;
    return Superscript;
})();
export const Subscript = /*#__PURE__*/ (() => {
    function SubscriptSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 14.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z" })
        );
    }
    function Subscript({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SubscriptSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Subscript.SVG = SubscriptSVG;
    return Subscript;
})();
export const Superscript2 = /*#__PURE__*/ (() => {
        function Superscript2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM11 13l2.5-4 2.5 4h-5z" }),
_('path', { d: "M13.5 2h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z" })
            );
        }
        function Superscript2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Superscript2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Superscript2.SVG = Superscript2SVG;
        return Superscript2;
    })();
export const Subscript2 = /*#__PURE__*/ (() => {
        function Subscript2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM16 3l-2.5 4-2.5-4h5z" }),
_('path', { d: "M13.5 13h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z" })
            );
        }
        function Subscript2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Subscript2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Subscript2.SVG = Subscript2SVG;
        return Subscript2;
    })();
export const TextColor = /*#__PURE__*/ (() => {
    function TextColorSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z" })
        );
    }
    function TextColor({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TextColorSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    TextColor.SVG = TextColorSVG;
    return TextColor;
})();
export const Highlight = /*#__PURE__*/ (() => {
    function HighlightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M10.5 1.503l3.747 3.247 0.003-0.003-3.25-3.745 3.749 3.246 0.751 0.751-5.256 5.256c-0.463 0.463-1.174 0.534-1.714 0.214l0.719-0.722-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745 3.747 3.247 0.003-0.003-3.25-3.745zM11.251 0.751l-6.221 6.218c-0.131-0.221-0.196-0.47-0.196-0.719 0-0.36 0.137-0.721 0.41-0.994l5.256-5.256 0.751 0.751zM5.031 6.969l3.5 3.5-2.531 2.531h-6v-1z" })
        );
    }
    function Highlight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HighlightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Highlight.SVG = HighlightSVG;
    return Highlight;
})();
export const Pagebreak3 = /*#__PURE__*/ (() => {
    function Pagebreak3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z" })
        );
    }
    function Pagebreak3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pagebreak3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pagebreak3.SVG = Pagebreak3SVG;
    return Pagebreak3;
})();
export const ClearFormatting = /*#__PURE__*/ (() => {
    function ClearFormattingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 14h9v2h-9zM14 2h-4.727l-2.871 11h-2.067l2.871-11h-4.205v-2h11zM14.528 16l-2.028-2.028-2.028 2.028-0.972-0.972 2.028-2.028-2.028-2.028 0.972-0.972 2.028 2.028 2.028-2.028 0.972 0.972-2.028 2.028 2.028 2.028z" })
        );
    }
    function ClearFormatting({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ClearFormattingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ClearFormatting.SVG = ClearFormattingSVG;
    return ClearFormatting;
})();
export const Table = /*#__PURE__*/ (() => {
    function TableSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3v11h16v-11h-16zM6 10v-2h4v2h-4zM10 11v2h-4v-2h4zM10 5v2h-4v-2h4zM5 5v2h-4v-2h4zM1 8h4v2h-4v-2zM11 8h4v2h-4v-2zM11 7v-2h4v2h-4zM1 11h4v2h-4v-2zM11 13v-2h4v2h-4z" })
        );
    }
    function Table({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TableSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Table.SVG = TableSVG;
    return Table;
})();
export const Table2 = /*#__PURE__*/ (() => {
    function Table2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z" })
        );
    }
    function Table2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Table2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Table2.SVG = Table2SVG;
    return Table2;
})();
export const InsertTemplate = /*#__PURE__*/ (() => {
    function InsertTemplateSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 3h2v1h-2zM9 3h2v1h-2zM14 3v4h-3v-1h2v-2h-1v-1zM5 6h2v1h-2zM8 6h2v1h-2zM3 4v2h1v1h-2v-4h3v1zM6 9h2v1h-2zM9 9h2v1h-2zM14 9v4h-3v-1h2v-2h-1v-1zM5 12h2v1h-2zM8 12h2v1h-2zM3 10v2h1v1h-2v-4h3v1zM15 1h-14v14h14v-14zM16 0v0 16h-16v-16h16z" })
        );
    }
    function InsertTemplate({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InsertTemplateSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    InsertTemplate.SVG = InsertTemplateSVG;
    return InsertTemplate;
})();
export const Pilcrow = /*#__PURE__*/ (() => {
    function PilcrowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 0h8v2h-2v14h-2v-14h-2v14h-2v-8c-2.209 0-4-1.791-4-4s1.791-4 4-4z" })
        );
    }
    function Pilcrow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PilcrowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pilcrow.SVG = PilcrowSVG;
    return Pilcrow;
})();
export const Ltr = /*#__PURE__*/ (() => {
    function LtrSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM0 11l4-4-4-4z" })
        );
    }
    function Ltr({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LtrSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ltr.SVG = LtrSVG;
    return Ltr;
})();
export const Rtl = /*#__PURE__*/ (() => {
    function RtlSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM16 3l-4 4 4 4z" })
        );
    }
    function Rtl({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RtlSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rtl.SVG = RtlSVG;
    return Rtl;
})();
export const Ltr2 = /*#__PURE__*/ (() => {
        function Ltr2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 0c-1.657 0-3 1.343-3 3s1.343 3 3 3v5h1v-10h1v10h1v-10h2v-1h-5z" }),
_('path', { d: "M12 13v2.5l3-3-3-3v2.5h-8v1z" })
            );
        }
        function Ltr2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Ltr2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Ltr2.SVG = Ltr2SVG;
        return Ltr2;
    })();
export const Rtl2 = /*#__PURE__*/ (() => {
        function Rtl2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M7 0c-1.657 0-3 1.343-3 3s1.343 3 3 3v5h1v-10h1v10h1v-10h2v-1h-5z" }),
_('path', { d: "M4 12v-2.5l-3 3 3 3v-2.5h8v-1z" })
            );
        }
        function Rtl2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Rtl2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Rtl2.SVG = Rtl2SVG;
        return Rtl2;
    })();
export const Section = /*#__PURE__*/ (() => {
    function SectionSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.749 16c-0.771 0-1.424-0.225-1.939-0.669-0.519-0.447-0.782-0.969-0.782-1.552 0-0.283 0.103-0.527 0.307-0.726 0.207-0.202 0.465-0.309 0.748-0.309 0.281 0 0.534 0.1 0.732 0.29 0.195 0.187 0.294 0.435 0.294 0.736 0 0.177-0.029 0.372-0.086 0.58-0.056 0.206-0.068 0.312-0.068 0.364 0 0.058 0.014 0.126 0.121 0.199 0.199 0.138 0.439 0.204 0.732 0.204 0.353 0 0.667-0.123 0.962-0.375 0.29-0.249 0.431-0.505 0.431-0.782 0-0.308-0.082-0.575-0.252-0.816-0.287-0.402-0.826-0.874-1.603-1.401-1.248-0.835-2.079-1.559-2.54-2.211-0.358-0.511-0.539-1.061-0.539-1.636 0-0.579 0.19-1.155 0.564-1.713 0.32-0.477 0.794-0.908 1.41-1.283-0.33-0.355-0.577-0.689-0.736-0.995-0.201-0.387-0.303-0.787-0.303-1.189 0-0.747 0.295-1.393 0.878-1.92s1.31-0.795 2.161-0.795c0.783 0 1.441 0.22 1.956 0.654 0.521 0.439 0.785 0.952 0.785 1.524 0 0.292-0.109 0.553-0.324 0.776l-0.004 0.004c-0.125 0.124-0.353 0.271-0.735 0.271-0.299 0-0.561-0.098-0.758-0.283-0.196-0.184-0.296-0.405-0.296-0.656 0-0.108 0.027-0.272 0.084-0.515 0.028-0.115 0.042-0.221 0.042-0.316 0-0.162-0.058-0.285-0.183-0.39-0.129-0.108-0.314-0.161-0.565-0.161-0.389 0-0.708 0.118-0.975 0.361s-0.399 0.533-0.399 0.883c0 0.315 0.071 0.574 0.212 0.771 0.267 0.374 0.731 0.778 1.378 1.201 1.315 0.853 2.233 1.636 2.727 2.325 0.365 0.518 0.549 1.068 0.549 1.637 0 0.572-0.186 1.148-0.552 1.714-0.316 0.487-0.793 0.926-1.42 1.308 0.347 0.367 0.591 0.688 0.743 0.977 0.189 0.359 0.284 0.751 0.284 1.165 0 0.776-0.296 1.435-0.879 1.96s-1.31 0.79-2.161 0.79zM6.975 5.568c-0.753 0.452-1.12 0.972-1.12 1.583 0 0.356 0.102 0.674 0.31 0.973 0.311 0.436 0.926 0.97 1.825 1.583 0.381 0.259 0.724 0.511 1.025 0.751 0.767-0.461 1.14-0.974 1.14-1.565 0-0.322-0.127-0.668-0.378-1.030-0.263-0.378-0.826-0.872-1.674-1.467-0.443-0.306-0.821-0.583-1.128-0.827z" })
        );
    }
    function Section({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SectionSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Section.SVG = SectionSVG;
    return Section;
})();
export const ParagraphLeft = /*#__PURE__*/ (() => {
    function ParagraphLeftSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3h16v1h-16zM0 5h11v1h-11zM0 7h16v1h-16zM0 9h11v1h-11zM0 11h16v1h-16zM0 13h11v1h-11z" })
        );
    }
    function ParagraphLeft({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphLeftSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphLeft.SVG = ParagraphLeftSVG;
    return ParagraphLeft;
})();
export const ParagraphCenter = /*#__PURE__*/ (() => {
    function ParagraphCenterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3h16v1h-16zM3 5h10v1h-10zM3 9h10v1h-10zM3 13h10v1h-10zM0 7h16v1h-16zM0 11h16v1h-16z" })
        );
    }
    function ParagraphCenter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphCenterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphCenter.SVG = ParagraphCenterSVG;
    return ParagraphCenter;
})();
export const ParagraphRight = /*#__PURE__*/ (() => {
    function ParagraphRightSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 3h16v1h-16zM5 5h11v1h-11zM0 7h16v1h-16zM5 9h11v1h-11zM0 11h16v1h-16zM5 13h11v1h-11z" })
        );
    }
    function ParagraphRight({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphRightSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphRight.SVG = ParagraphRightSVG;
    return ParagraphRight;
})();
export const ParagraphJustify = /*#__PURE__*/ (() => {
    function ParagraphJustifySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 5h16v1h-16zM0 9h16v1h-16zM0 13h16v1h-16zM0 3h16v1h-16zM0 7h16v1h-16zM0 11h16v1h-16z" })
        );
    }
    function ParagraphJustify({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphJustifySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphJustify.SVG = ParagraphJustifySVG;
    return ParagraphJustify;
})();
export const ParagraphLeft2 = /*#__PURE__*/ (() => {
    function ParagraphLeft2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM0 4h10v2h-10zM0 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z" })
        );
    }
    function ParagraphLeft2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphLeft2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphLeft2.SVG = ParagraphLeft2SVG;
    return ParagraphLeft2;
})();
export const ParagraphCenter2 = /*#__PURE__*/ (() => {
    function ParagraphCenter2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM3 4h10v2h-10zM3 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z" })
        );
    }
    function ParagraphCenter2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphCenter2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphCenter2.SVG = ParagraphCenter2SVG;
    return ParagraphCenter2;
})();
export const ParagraphRight2 = /*#__PURE__*/ (() => {
    function ParagraphRight2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 4h10v2h-10zM6 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z" })
        );
    }
    function ParagraphRight2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphRight2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphRight2.SVG = ParagraphRight2SVG;
    return ParagraphRight2;
})();
export const ParagraphJustify2 = /*#__PURE__*/ (() => {
    function ParagraphJustify2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM0 4h16v2h-16zM0 7h16v2h-16zM0 10h16v2h-16zM0 13h16v2h-16z" })
        );
    }
    function ParagraphJustify2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphJustify2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphJustify2.SVG = ParagraphJustify2SVG;
    return ParagraphJustify2;
})();
export const IndentIncrease = /*#__PURE__*/ (() => {
    function IndentIncreaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z" })
        );
    }
    function IndentIncrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IndentIncreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IndentIncrease.SVG = IndentIncreaseSVG;
    return IndentIncrease;
})();
export const IndentDecrease = /*#__PURE__*/ (() => {
    function IndentDecreaseSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z" })
        );
    }
    function IndentDecrease({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IndentDecreaseSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IndentDecrease.SVG = IndentDecreaseSVG;
    return IndentDecrease;
})();
export const ParagraphLeft3 = /*#__PURE__*/ (() => {
    function ParagraphLeft3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM0 5h10v2h-10zM0 13h10v2h-10zM0 9h16v2h-16z" })
        );
    }
    function ParagraphLeft3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphLeft3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphLeft3.SVG = ParagraphLeft3SVG;
    return ParagraphLeft3;
})();
export const ParagraphCenter3 = /*#__PURE__*/ (() => {
    function ParagraphCenter3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM3 5h10v2h-10zM3 13h10v2h-10zM0 9h16v2h-16z" })
        );
    }
    function ParagraphCenter3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphCenter3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphCenter3.SVG = ParagraphCenter3SVG;
    return ParagraphCenter3;
})();
export const ParagraphRight3 = /*#__PURE__*/ (() => {
    function ParagraphRight3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 5h10v2h-10zM6 13h10v2h-10zM0 9h16v2h-16z" })
        );
    }
    function ParagraphRight3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphRight3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphRight3.SVG = ParagraphRight3SVG;
    return ParagraphRight3;
})();
export const ParagraphJustify3 = /*#__PURE__*/ (() => {
    function ParagraphJustify3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM0 9h16v2h-16zM0 5h16v2h-16zM0 13h16v2h-16z" })
        );
    }
    function ParagraphJustify3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ParagraphJustify3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    ParagraphJustify3.SVG = ParagraphJustify3SVG;
    return ParagraphJustify3;
})();
export const IndentIncrease2 = /*#__PURE__*/ (() => {
    function IndentIncrease2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 9h10v2h-10zM6 5h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z" })
        );
    }
    function IndentIncrease2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IndentIncrease2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IndentIncrease2.SVG = IndentIncrease2SVG;
    return IndentIncrease2;
})();
export const IndentDecrease2 = /*#__PURE__*/ (() => {
    function IndentDecrease2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1h16v2h-16zM6 9h10v2h-10zM6 5h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z" })
        );
    }
    function IndentDecrease2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IndentDecrease2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IndentDecrease2.SVG = IndentDecrease2SVG;
    return IndentDecrease2;
})();
export const Share = /*#__PURE__*/ (() => {
        function ShareSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10 7v2h3v5h-10v-5h3v-2h-5v9h14v-9z" }),
_('path', { d: "M7 5v8h2v-8h3.5l-4.5-4.5-4.5 4.5z" })
            );
        }
        function Share({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( ShareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Share.SVG = ShareSVG;
        return Share;
    })();
export const Share2 = /*#__PURE__*/ (() => {
    function Share2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 10c0 0 0.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zM11 12h-9v-6h1.967c0.158-0.186 0.327-0.365 0.508-0.534 0.687-0.644 1.509-1.135 2.439-1.466h-6.914v10h13v-4.197l-2 1.333v0.864z" })
        );
    }
    function Share2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Share2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Share2.SVG = Share2SVG;
    return Share2;
})();
export const NewTab = /*#__PURE__*/ (() => {
        function NewTabSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z" }),
_('path', { d: "M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z" })
            );
        }
        function NewTab({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NewTabSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NewTab.SVG = NewTabSVG;
        return NewTab;
    })();
export const NewTab2 = /*#__PURE__*/ (() => {
        function NewTab2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M3 1v12h12v-12h-12zM14 12h-10v-10h10v10zM2 14v-10.5l-1-1v12.5h12.5l-1-1h-10.5z" }),
_('path', { d: "M5.5 4l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5v-6.5z" })
            );
        }
        function NewTab2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( NewTab2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        NewTab2.SVG = NewTab2SVG;
        return NewTab2;
    })();
export const Popout = /*#__PURE__*/ (() => {
    function PopoutSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 2h-9c-0.825 0-1.5 0.675-1.5 1.5v1.5h-2.5c-0.825 0-1.5 0.675-1.5 1.5v6c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.5h2.5c0.825 0 1.5-0.675 1.5-1.5v-6c0-0.825-0.675-1.5-1.5-1.5zM11 12.5c0 0.271-0.229 0.5-0.5 0.5h-9c-0.271 0-0.5-0.229-0.5-0.5v-6c0-0.271 0.229-0.5 0.5-0.5h2.5v3.5c0 0.825 0.675 1.5 1.5 1.5h5.5v1.5zM15 9.5c0 0.271-0.229 0.5-0.5 0.5h-9c-0.271 0-0.5-0.229-0.5-0.5v-6c0-0.271 0.229-0.5 0.5-0.5h9c0.271 0 0.5 0.229 0.5 0.5v6z" })
        );
    }
    function Popout({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PopoutSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Popout.SVG = PopoutSVG;
    return Popout;
})();
export const Embed = /*#__PURE__*/ (() => {
        function EmbedSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z" }),
_('path', { d: "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z" })
            );
        }
        function Embed({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( EmbedSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Embed.SVG = EmbedSVG;
        return Embed;
    })();
export const Embed2 = /*#__PURE__*/ (() => {
        function Embed2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z" }),
_('path', { d: "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z" }),
_('path', { d: "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z" })
            );
        }
        function Embed2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Embed2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Embed2.SVG = Embed2SVG;
        return Embed2;
    })();
export const Markup = /*#__PURE__*/ (() => {
        function MarkupSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 24 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 24 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M17 7v-2h-2v-2h-2v2h-2v-2h-2v2h-2v2h2v2h-2v2h2v2h2v-2h2v2h2v-2h2v-2h-2v-2h2zM13 9h-2v-2h2v2z" }),
_('path', { d: "M8.707 1.707l-1.414-1.414-7.293 7.293v0.828l7.293 7.293 1.414-1.414-6.293-6.293z" }),
_('path', { d: "M15.293 1.707l1.414-1.414 7.293 7.293v0.828l-7.293 7.293-1.414-1.414 6.293-6.293z" })
            );
        }
        function Markup({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( MarkupSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Markup.SVG = MarkupSVG;
        return Markup;
    })();
export const Regexp = /*#__PURE__*/ (() => {
        function RegexpSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 21 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 21 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.964 7.134c-0.809-0.467-1.915-0.854-2.865-1.134 0.95-0.28 2.056-0.667 2.865-1.134 0.478-0.276 0.642-0.888 0.366-1.366s-0.888-0.642-1.366-0.366c-0.809 0.467-1.697 1.232-2.415 1.914 0.232-0.963 0.45-2.114 0.45-3.048 0-0.552-0.448-1-1-1s-1 0.448-1 1c0 0.934 0.218 2.086 0.45 3.048-0.717-0.683-1.606-1.447-2.415-1.914-0.478-0.276-1.090-0.112-1.366 0.366s-0.112 1.090 0.366 1.366c0.809 0.467 1.915 0.854 2.865 1.134-0.95 0.28-2.056 0.667-2.865 1.134-0.478 0.276-0.642 0.888-0.366 1.366s0.888 0.642 1.366 0.366c0.809-0.467 1.697-1.232 2.415-1.914-0.232 0.963-0.45 2.114-0.45 3.048 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.934-0.218-2.086-0.45-3.048 0.717 0.683 1.606 1.447 2.415 1.914 0.478 0.276 1.090 0.112 1.366-0.366s0.112-1.090-0.366-1.366z" }),
_('path', { d: "M7 13.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" }),
_('path', { d: "M0 16l4-16h2l-4 16z" }),
_('path', { d: "M15 16l4-16h2l-4 16z" })
            );
        }
        function Regexp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RegexpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Regexp.SVG = RegexpSVG;
        return Regexp;
    })();
export const Regexp2 = /*#__PURE__*/ (() => {
    function Regexp2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.15 0h-11.235c-0.562 0-1.106 0.442-1.21 0.983l-2.688 14.034c-0.104 0.541 0.271 0.983 0.833 0.983h11.235c0.562 0 1.106-0.442 1.21-0.983l2.688-14.034c0.104-0.541-0.271-0.983-0.833-0.983zM11.964 9.134c0.478 0.276 0.642 0.888 0.366 1.366s-0.888 0.642-1.366 0.366c-0.809-0.467-1.697-1.232-2.415-1.914 0.232 0.963 0.45 2.114 0.45 3.048 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.934 0.218-2.085 0.45-3.048-0.717 0.683-1.606 1.447-2.415 1.914-0.478 0.276-1.090 0.112-1.366-0.366s-0.112-1.090 0.366-1.366c0.809-0.467 1.915-0.854 2.865-1.134-0.95-0.28-2.056-0.667-2.865-1.134-0.478-0.276-0.642-0.888-0.366-1.366s0.888-0.642 1.366-0.366c0.809 0.467 1.697 1.232 2.415 1.914-0.232-0.963-0.45-2.114-0.45-3.048 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.934-0.218 2.086-0.45 3.048 0.717-0.683 1.606-1.447 2.415-1.914 0.478-0.276 1.090-0.112 1.366 0.366s0.112 1.090-0.366 1.366c-0.809 0.467-1.915 0.854-2.865 1.134 0.95 0.28 2.056 0.667 2.865 1.134z" })
        );
    }
    function Regexp2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Regexp2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Regexp2.SVG = Regexp2SVG;
    return Regexp2;
})();
export const Code = /*#__PURE__*/ (() => {
        function CodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 20 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 20 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4 5.5v-2c0-0.828 0.672-1.5 1.5-1.5h0.5v-2h-0.5c-1.933 0-3.5 1.567-3.5 3.5v2c0 0.828-0.672 1.5-1.5 1.5h-0.5v2h0.5c0.828 0 1.5 0.672 1.5 1.5v2c0 1.933 1.567 3.5 3.5 3.5h0.5v-2h-0.5c-0.828 0-1.5-0.672-1.5-1.5v-2c0-0.979-0.402-1.865-1.051-2.5 0.648-0.635 1.051-1.521 1.051-2.5z" }),
_('path', { d: "M16 5.5v-2c0-0.828-0.672-1.5-1.5-1.5h-0.5v-2h0.5c1.933 0 3.5 1.567 3.5 3.5v2c0 0.828 0.672 1.5 1.5 1.5h0.5v2h-0.5c-0.828 0-1.5 0.672-1.5 1.5v2c0 1.933-1.567 3.5-3.5 3.5h-0.5v-2h0.5c0.828 0 1.5-0.672 1.5-1.5v-2c0-0.979 0.402-1.865 1.051-2.5-0.648-0.635-1.051-1.521-1.051-2.5z" }),
_('path', { d: "M12 5.014c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" }),
_('path', { d: "M10 7.986c-1.105 0-2 0.895-2 2 0 1.074 0.5 1.925 2.034 1.998-0.456 0.643-1.143 0.896-2.034 0.98v1.188c0 0 4 0.349 4-4.165-0.004-1.105-0.895-2-2-2z" })
            );
        }
        function Code({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( CodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Code.SVG = CodeSVG;
        return Code;
    })();
export const CircleCss = /*#__PURE__*/ (() => {
    function CircleCssSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM7 4.111c-0.552 0-1 0.497-1 1.111v1.111c0 0.92-0.672 1.667-1.5 1.667 0.828 0 1.5 0.746 1.5 1.667v1.111c0 0.614 0.448 1.111 1 1.111v1.111h-1c-1.103 0-2-0.997-2-2.222v-1.111c0-0.614-0.448-1.111-1-1.111v-1.111c0.552 0 1-0.497 1-1.111v-1.111c0-1.225 0.897-2.222 2-2.222h1v1.111zM13 8.556c-0.552 0-1 0.498-1 1.111v1.111c0 1.225-0.897 2.222-2 2.222h-1v-1.111c0.552 0 1-0.497 1-1.111v-1.111c0-0.92 0.672-1.667 1.5-1.667-0.828 0-1.5-0.746-1.5-1.667v-1.111c0-0.614-0.448-1.111-1-1.111v-1.111h1c1.103 0 2 0.997 2 2.222v1.111c0 0.614 0.448 1.111 1 1.111v1.111z" })
        );
    }
    function CircleCss({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleCssSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleCss.SVG = CircleCssSVG;
    return CircleCss;
})();
export const CircleCode = /*#__PURE__*/ (() => {
    function CircleCodeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM6.707 10.293c0.391 0.391 0.391 1.024 0 1.414-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293l-3-3c-0.391-0.391-0.391-1.024 0-1.414l3-3c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-2.293 2.293 2.293 2.293zM10.707 11.707c-0.391 0.391-1.024 0.391-1.414 0s-0.391-1.024 0-1.414l2.293-2.293-2.293-2.293c-0.391-0.391-0.391-1.024 0-1.414 0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293l3 3c0.391 0.391 0.391 1.024 0 1.414l-3 3z" })
        );
    }
    function CircleCode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CircleCodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    CircleCode.SVG = CircleCodeSVG;
    return CircleCode;
})();
export const Terminal = /*#__PURE__*/ (() => {
    function TerminalSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z" })
        );
    }
    function Terminal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TerminalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Terminal.SVG = TerminalSVG;
    return Terminal;
})();
export const Unicode = /*#__PURE__*/ (() => {
        function UnicodeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 10h-3v-3h-1v3h-3v1h3v3h1v-3h3z" }),
_('path', { d: "M6 4v8c0 1.103-0.897 2-2 2s-2-0.897-2-2v-8h-2v8c0 2.209 1.791 4 4 4s4-1.791 4-4v-8h-2z" })
            );
        }
        function Unicode({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( UnicodeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Unicode.SVG = UnicodeSVG;
        return Unicode;
    })();
export const SevenSegment0 = /*#__PURE__*/ (() => {
    function SevenSegment0SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2l1-1-1-1h-6l-1 1 1 1zM12 1.5l-1 1v4l1 1 1-1v-4zM5 6.5v-4l-1-1-1 1v4l1 1zM11 9.5v4l1 1 1-1v-4l-1-1zM5 13.5v-4l-1-1-1 1v4l1 1zM5 14l-1 1 1 1h6l1-1-1-1z" })
        );
    }
    function SevenSegment0({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment0SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment0.SVG = SevenSegment0SVG;
    return SevenSegment0;
})();
export const SevenSegment1 = /*#__PURE__*/ (() => {
    function SevenSegment1SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 1.5l-1 1v4l1 1 1-1v-4zM11 9.5v4l1 1 1-1v-4l-1-1z" })
        );
    }
    function SevenSegment1({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment1SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment1.SVG = SevenSegment1SVG;
    return SevenSegment1;
})();
export const SevenSegment2 = /*#__PURE__*/ (() => {
    function SevenSegment2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM12 7.5l-1-1v-4l1-1 1 1v4zM4 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6zM4 15l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment2.SVG = SevenSegment2SVG;
    return SevenSegment2;
})();
export const SevenSegment3 = /*#__PURE__*/ (() => {
    function SevenSegment3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM12 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6zM4 15l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment3.SVG = SevenSegment3SVG;
    return SevenSegment3;
})();
export const SevenSegment4 = /*#__PURE__*/ (() => {
    function SevenSegment4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12 7.5l-1-1v-4l1-1 1 1v4zM4 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment4.SVG = SevenSegment4SVG;
    return SevenSegment4;
})();
export const SevenSegment5 = /*#__PURE__*/ (() => {
    function SevenSegment5SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM4 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6zM4 15l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment5({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment5SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment5.SVG = SevenSegment5SVG;
    return SevenSegment5;
})();
export const SevenSegment6 = /*#__PURE__*/ (() => {
    function SevenSegment6SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM4 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4zM4 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6zM4 15l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment6({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment6SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment6.SVG = SevenSegment6SVG;
    return SevenSegment6;
})();
export const SevenSegment7 = /*#__PURE__*/ (() => {
    function SevenSegment7SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM12 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4z" })
        );
    }
    function SevenSegment7({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment7SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment7.SVG = SevenSegment7SVG;
    return SevenSegment7;
})();
export const SevenSegment8 = /*#__PURE__*/ (() => {
    function SevenSegment8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 2l1-1-1-1h-6l-1 1 1 1zM12 1.5l-1 1v4l1 1 1-1v-4zM5 6.5v-4l-1-1-1 1v4l1 1zM11 9.5v4l1 1 1-1v-4l-1-1zM5 13.5v-4l-1-1-1 1v4l1 1zM4 8l1 1h6l1-1-1-1h-6zM5 14l-1 1 1 1h6l1-1-1-1z" })
        );
    }
    function SevenSegment8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment8.SVG = SevenSegment8SVG;
    return SevenSegment8;
})();
export const SevenSegment9 = /*#__PURE__*/ (() => {
    function SevenSegment9SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 1l1-1h6l1 1-1 1h-6zM12 7.5l-1-1v-4l1-1 1 1v4zM4 7.5l-1-1v-4l1-1 1 1v4zM12 14.5l-1-1v-4l1-1 1 1v4zM4 8l1-1h6l1 1-1 1h-6zM4 15l1-1h6l1 1-1 1h-6z" })
        );
    }
    function SevenSegment9({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SevenSegment9SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    SevenSegment9.SVG = SevenSegment9SVG;
    return SevenSegment9;
})();
export const Share3 = /*#__PURE__*/ (() => {
    function Share3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.5 11c-0.706 0-1.342 0.293-1.797 0.763l-6.734-3.367c0.021-0.129 0.032-0.261 0.032-0.396s-0.011-0.267-0.032-0.396l6.734-3.367c0.455 0.47 1.091 0.763 1.797 0.763 1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.119-2.5 2.5c0 0.135 0.011 0.267 0.031 0.396l-6.734 3.367c-0.455-0.47-1.091-0.763-1.797-0.763-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c0.706 0 1.343-0.293 1.797-0.763l6.734 3.367c-0.021 0.129-0.031 0.261-0.031 0.396 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z" })
        );
    }
    function Share3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Share3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Share3.SVG = Share3SVG;
    return Share3;
})();
export const Share4 = /*#__PURE__*/ (() => {
    function Share4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM8 4c1.105 0 2.105 0.448 2.828 1.172l1.414-1.414c-1.086-1.086-2.586-1.757-4.243-1.757-2.612 0-4.834 1.67-5.658 4h-2.342v2h4c0-2.209 1.791-4 4-4zM12 8c0 2.209-1.791 4-4 4-1.105 0-2.105-0.448-2.828-1.172l-1.414 1.414c1.086 1.086 2.586 1.757 4.243 1.757 2.612 0 4.834-1.67 5.658-4h2.342v-2h-4z" })
        );
    }
    function Share4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Share4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Share4.SVG = Share4SVG;
    return Share4;
})();
export const Mail = /*#__PURE__*/ (() => {
    function MailSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.467 1.2 2.667 2.667 2.667h10.666c1.468 0 2.667-1.2 2.667-2.667v-10.666c0-1.467-1.199-2.667-2.667-2.667zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z" })
        );
    }
    function Mail({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( MailSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mail.SVG = MailSVG;
    return Mail;
})();
export const Mail2 = /*#__PURE__*/ (() => {
    function Mail2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM13.333 2c0.125 0 0.243 0.036 0.344 0.099l-5.678 4.694-5.677-4.694c0.101-0.063 0.219-0.099 0.344-0.099h10.666zM2.667 14c-0.030 0-0.060-0.002-0.089-0.006l3.525-4.89-0.457-0.457-3.646 3.646v-9.549l6 7.256 6-7.256v9.549l-3.646-3.646-0.457 0.457 3.525 4.89c-0.029 0.004-0.059 0.006-0.088 0.006h-10.666z" })
        );
    }
    function Mail2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mail2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mail2.SVG = Mail2SVG;
    return Mail2;
})();
export const Mail3 = /*#__PURE__*/ (() => {
    function Mail3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM2.854 13.854l-1.207-1.207 4-4 0.457 0.457-3.25 4.75zM2.396 3.104l0.457-0.457 5.146 4.146 5.146-4.146 0.457 0.457-5.604 6.604-5.604-6.604zM13.146 13.854l-3.25-4.75 0.457-0.457 4 4-1.207 1.207z" })
        );
    }
    function Mail3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mail3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mail3.SVG = Mail3SVG;
    return Mail3;
})();
export const Mail4 = /*#__PURE__*/ (() => {
    function Mail4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z" })
        );
    }
    function Mail4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Mail4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Mail4.SVG = Mail4SVG;
    return Mail4;
})();
export const Amazon = /*#__PURE__*/ (() => {
        function AmazonSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-0.163-0.147-0.019-0.35 0.178-0.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-0.403 6.041-1.238 0.294-0.125 0.544 0.197 0.253 0.409z" }),
_('path', { d: "M15.191 13c-0.225-0.287-1.481-0.137-2.047-0.069-0.172 0.019-0.197-0.128-0.044-0.238 1.003-0.703 2.647-0.5 2.838-0.266 0.194 0.238-0.050 1.884-0.991 2.672-0.144 0.122-0.281 0.056-0.219-0.103 0.216-0.528 0.688-1.709 0.463-1.997z" }),
_('path', { d: "M11.053 11.838l0.003 0.003c0.387-0.341 1.084-0.95 1.478-1.278 0.156-0.125 0.128-0.334 0.006-0.509-0.353-0.488-0.728-0.884-0.728-1.784v-3c0-1.272 0.088-2.438-0.847-3.313-0.738-0.706-1.963-0.956-2.9-0.956-1.831 0-3.875 0.684-4.303 2.947-0.047 0.241 0.131 0.369 0.287 0.403l1.866 0.203c0.175-0.009 0.3-0.181 0.334-0.356 0.159-0.778 0.813-1.156 1.547-1.156 0.397 0 0.847 0.144 1.081 0.5 0.269 0.397 0.234 0.938 0.234 1.397v0.25c-1.116 0.125-2.575 0.206-3.619 0.666-1.206 0.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-0.322 3.172-1.403 0.35 0.506 0.463 0.753 1.103 1.284 0.147 0.078 0.328 0.072 0.456-0.044zM9.113 7.144c0 0.75 0.019 1.375-0.359 2.041-0.306 0.544-0.791 0.875-1.331 0.875-0.737 0-1.169-0.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v0.416z" })
            );
        }
        function Amazon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AmazonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Amazon.SVG = AmazonSVG;
        return Amazon;
    })();
export const Google = /*#__PURE__*/ (() => {
    function GoogleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.159 6.856v2.744h4.537c-0.184 1.178-1.372 3.45-4.537 3.45-2.731 0-4.959-2.262-4.959-5.050s2.228-5.050 4.959-5.050c1.553 0 2.594 0.663 3.188 1.234l2.172-2.091c-1.394-1.306-3.2-2.094-5.359-2.094-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-0.525-0.056-0.925-0.125-1.325l-7.556-0.003z" })
        );
    }
    function Google({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GoogleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Google.SVG = GoogleSVG;
    return Google;
})();
export const Google2 = /*#__PURE__*/ (() => {
    function Google2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z" })
        );
    }
    function Google2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Google2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Google2.SVG = Google2SVG;
    return Google2;
})();
export const Google3 = /*#__PURE__*/ (() => {
    function Google3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z" })
        );
    }
    function Google3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Google3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Google3.SVG = Google3SVG;
    return Google3;
})();
export const GooglePlus = /*#__PURE__*/ (() => {
        function GooglePlusSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.091 7.147v1.747h2.888c-0.116 0.75-0.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c0.991 0 1.65 0.422 2.028 0.784l1.381-1.331c-0.888-0.828-2.037-1.331-3.409-1.331-2.816 0.003-5.091 2.278-5.091 5.094s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-0.334-0.037-0.591-0.081-0.844h-4.806z" }),
_('path', { d: "M16 7h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z" })
            );
        }
        function GooglePlus({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GooglePlusSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GooglePlus.SVG = GooglePlusSVG;
        return GooglePlus;
    })();
export const GooglePlus2 = /*#__PURE__*/ (() => {
    function GooglePlus2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM14 8h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1z" })
        );
    }
    function GooglePlus2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GooglePlus2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GooglePlus2.SVG = GooglePlus2SVG;
    return GooglePlus2;
})();
export const GooglePlus3 = /*#__PURE__*/ (() => {
    function GooglePlus3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM13 8v1h-1v-1h-1v-1h1v-1h1v1h1v1h-1z" })
        );
    }
    function GooglePlus3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GooglePlus3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    GooglePlus3.SVG = GooglePlus3SVG;
    return GooglePlus3;
})();
export const Hangouts = /*#__PURE__*/ (() => {
    function HangoutsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.997 0c-3.816 0-6.909 3.094-6.909 6.909 0 3.616 3.294 6.547 6.909 6.547v2.544c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3zM12 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3z" })
        );
    }
    function Hangouts({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HangoutsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hangouts.SVG = HangoutsSVG;
    return Hangouts;
})();
export const GoogleDrive = /*#__PURE__*/ (() => {
        function GoogleDriveSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.844 10l-2.884 5h9.072l2.884-5z" }),
_('path', { d: "M15.506 9l-4.619-8h-5.775l4.619 8z" }),
_('path', { d: "M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z" })
            );
        }
        function GoogleDrive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( GoogleDriveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        GoogleDrive.SVG = GoogleDriveSVG;
        return GoogleDrive;
    })();
export const Facebook = /*#__PURE__*/ (() => {
    function FacebookSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z" })
        );
    }
    function Facebook({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FacebookSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Facebook.SVG = FacebookSVG;
    return Facebook;
})();
export const Facebook2 = /*#__PURE__*/ (() => {
    function Facebook2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h6.5v-7h-2v-2h2v-1c0-1.653 1.347-3 3-3h2v2h-2c-0.55 0-1 0.45-1 1v1h3l-0.5 2h-2.5v7h4.5c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5z" })
        );
    }
    function Facebook2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Facebook2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Facebook2.SVG = Facebook2SVG;
    return Facebook2;
})();
export const Instagram = /*#__PURE__*/ (() => {
    function InstagramSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11 2.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v2c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-2zM8 5c1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.656 0-3-1.344-3-3s1.344-3 3-3zM14 13.5v0c0 0.275-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5v0-6.5h1.1c-0.066 0.322-0.1 0.656-0.1 1 0 2.762 2.237 5 5 5s5-2.238 5-5c0-0.344-0.034-0.678-0.1-1h1.1v6.5z" })
        );
    }
    function Instagram({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( InstagramSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Instagram.SVG = InstagramSVG;
    return Instagram;
})();
export const Whatsapp = /*#__PURE__*/ (() => {
    function WhatsappSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.641 2.325c-1.497-1.5-3.488-2.325-5.609-2.325-4.369 0-7.925 3.556-7.925 7.928 0 1.397 0.366 2.763 1.059 3.963l-1.125 4.109 4.203-1.103c1.159 0.631 2.463 0.966 3.787 0.966h0.003c0 0 0 0 0 0 4.369 0 7.928-3.556 7.928-7.928 0-2.119-0.825-4.109-2.322-5.609zM8.034 14.525v0c-1.184 0-2.344-0.319-3.356-0.919l-0.241-0.144-2.494 0.653 0.666-2.431-0.156-0.25c-0.663-1.047-1.009-2.259-1.009-3.506 0-3.634 2.956-6.591 6.594-6.591 1.759 0 3.416 0.688 4.659 1.931 1.244 1.247 1.928 2.9 1.928 4.662-0.003 3.637-2.959 6.594-6.591 6.594zM11.647 9.588c-0.197-0.1-1.172-0.578-1.353-0.644s-0.313-0.1-0.447 0.1c-0.131 0.197-0.512 0.644-0.628 0.778-0.116 0.131-0.231 0.15-0.428 0.050s-0.838-0.309-1.594-0.984c-0.588-0.525-0.987-1.175-1.103-1.372s-0.013-0.306 0.088-0.403c0.091-0.088 0.197-0.231 0.297-0.347s0.131-0.197 0.197-0.331c0.066-0.131 0.034-0.247-0.016-0.347s-0.447-1.075-0.609-1.472c-0.159-0.388-0.325-0.334-0.447-0.341-0.116-0.006-0.247-0.006-0.378-0.006s-0.347 0.050-0.528 0.247c-0.181 0.197-0.694 0.678-0.694 1.653s0.709 1.916 0.809 2.050c0.1 0.131 1.397 2.134 3.384 2.991 0.472 0.203 0.841 0.325 1.128 0.419 0.475 0.15 0.906 0.128 1.247 0.078 0.381-0.056 1.172-0.478 1.338-0.941s0.166-0.859 0.116-0.941c-0.047-0.088-0.178-0.137-0.378-0.238z" })
        );
    }
    function Whatsapp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WhatsappSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Whatsapp.SVG = WhatsappSVG;
    return Whatsapp;
})();
export const Spotify = /*#__PURE__*/ (() => {
    function SpotifySVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zM11.681 11.559c-0.159 0.241-0.441 0.319-0.681 0.159-1.881-1.159-4.241-1.4-7.041-0.759-0.281 0.081-0.519-0.119-0.6-0.359-0.081-0.281 0.119-0.519 0.359-0.6 3.041-0.681 5.681-0.4 7.759 0.881 0.281 0.119 0.322 0.438 0.203 0.678zM12.641 9.359c-0.2 0.281-0.559 0.4-0.841 0.2-2.159-1.319-5.441-1.719-7.959-0.919-0.319 0.081-0.681-0.081-0.759-0.4-0.081-0.319 0.081-0.681 0.4-0.759 2.919-0.881 6.519-0.441 9 1.081 0.238 0.119 0.359 0.519 0.159 0.797zM12.719 7.119c-2.559-1.519-6.841-1.681-9.281-0.919-0.4 0.119-0.8-0.119-0.919-0.481-0.119-0.4 0.119-0.8 0.481-0.919 2.841-0.841 7.519-0.681 10.481 1.081 0.359 0.2 0.481 0.681 0.281 1.041-0.203 0.278-0.681 0.397-1.044 0.197z" })
        );
    }
    function Spotify({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SpotifySVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Spotify.SVG = SpotifySVG;
    return Spotify;
})();
export const Telegram = /*#__PURE__*/ (() => {
    function TelegramSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM11.931 5.484l-1.313 6.184c-0.091 0.441-0.356 0.544-0.725 0.341l-2-1.478-0.959 0.934c-0.112 0.109-0.2 0.2-0.4 0.2-0.259 0-0.216-0.097-0.303-0.344l-0.681-2.237-1.978-0.616c-0.428-0.131-0.431-0.425 0.097-0.634l7.706-2.975c0.35-0.159 0.691 0.084 0.556 0.625z" })
        );
    }
    function Telegram({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TelegramSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Telegram.SVG = TelegramSVG;
    return Telegram;
})();
export const Twitter = /*#__PURE__*/ (() => {
    function TwitterSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 3.538c-0.588 0.263-1.222 0.438-1.884 0.516 0.678-0.406 1.197-1.050 1.444-1.816-0.634 0.375-1.338 0.65-2.084 0.797-0.6-0.638-1.453-1.034-2.397-1.034-1.813 0-3.281 1.469-3.281 3.281 0 0.256 0.028 0.506 0.084 0.747-2.728-0.138-5.147-1.444-6.766-3.431-0.281 0.484-0.444 1.050-0.444 1.65 0 1.138 0.578 2.144 1.459 2.731-0.538-0.016-1.044-0.166-1.488-0.409 0 0.013 0 0.028 0 0.041 0 1.591 1.131 2.919 2.634 3.219-0.275 0.075-0.566 0.116-0.866 0.116-0.212 0-0.416-0.022-0.619-0.059 0.419 1.303 1.631 2.253 3.066 2.281-1.125 0.881-2.538 1.406-4.078 1.406-0.266 0-0.525-0.016-0.784-0.047 1.456 0.934 3.181 1.475 5.034 1.475 6.037 0 9.341-5.003 9.341-9.341 0-0.144-0.003-0.284-0.009-0.425 0.641-0.459 1.197-1.038 1.637-1.697z" })
        );
    }
    function Twitter({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TwitterSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Twitter.SVG = TwitterSVG;
    return Twitter;
})();
export const Vine = /*#__PURE__*/ (() => {
    function VineSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.012 7.953c-0.412 0.094-0.809 0.137-1.169 0.137-2.019 0-3.572-1.409-3.572-3.862 0-1.203 0.466-1.825 1.122-1.825 0.625 0 1.041 0.559 1.041 1.697 0 0.647-0.172 1.356-0.3 1.775 0 0 0.622 1.084 2.322 0.753 0.363-0.803 0.556-1.841 0.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-0.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016h-2.722c1.259 9.675 5.006 12.756 6 13.347 0.559 0.337 1.044 0.322 1.556 0.031 0.806-0.456 3.222-2.875 4.563-5.703 0.563 0 1.238-0.066 1.909-0.219v-1.906z" })
        );
    }
    function Vine({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VineSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vine.SVG = VineSVG;
    return Vine;
})();
export const Vk = /*#__PURE__*/ (() => {
    function VkSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.959 11.2l-1.463 0.022c0 0-0.316 0.063-0.728-0.222-0.547-0.375-1.063-1.353-1.466-1.225-0.406 0.128-0.394 1.006-0.394 1.006s0.003 0.188-0.091 0.287c-0.1 0.109-0.3 0.131-0.3 0.131h-0.653c0 0-1.444 0.088-2.716-1.238-1.388-1.444-2.612-4.309-2.612-4.309s-0.072-0.188 0.006-0.278c0.087-0.103 0.322-0.109 0.322-0.109l1.566-0.009c0 0 0.147 0.025 0.253 0.103 0.088 0.063 0.134 0.184 0.134 0.184s0.253 0.641 0.588 1.219c0.653 1.128 0.959 1.375 1.181 1.256 0.322-0.175 0.225-1.597 0.225-1.597s0.006-0.516-0.162-0.744c-0.131-0.178-0.378-0.231-0.484-0.244-0.088-0.013 0.056-0.216 0.244-0.309 0.281-0.138 0.778-0.147 1.366-0.141 0.456 0.003 0.591 0.034 0.769 0.075 0.541 0.131 0.356 0.634 0.356 1.841 0 0.388-0.069 0.931 0.209 1.109 0.119 0.078 0.412 0.012 1.147-1.234 0.347-0.591 0.609-1.284 0.609-1.284s0.056-0.125 0.144-0.178c0.091-0.053 0.213-0.037 0.213-0.037l1.647-0.009c0 0 0.494-0.059 0.575 0.166 0.084 0.234-0.184 0.781-0.856 1.678-1.103 1.472-1.228 1.334-0.309 2.184 0.875 0.813 1.056 1.209 1.088 1.259 0.356 0.6-0.406 0.647-0.406 0.647z" })
        );
    }
    function Vk({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VkSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vk.SVG = VkSVG;
    return Vk;
})();
export const Renren = /*#__PURE__*/ (() => {
        function RenrenSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.644 0.166c-3.769 0.634-6.644 3.913-6.644 7.862 0 1.963 0.713 3.759 1.887 5.15 2.791-1.35 4.744-4.406 4.756-7.966v-5.047z" }),
_('path', { d: "M9.356 0.166c3.769 0.634 6.644 3.913 6.644 7.862 0 1.963-0.713 3.759-1.887 5.15-2.791-1.35-4.744-4.406-4.756-7.966v-5.047z" }),
_('path', { d: "M7.972 10.041c-0.497 2.056-1.981 3.813-3.828 4.981 1.138 0.622 2.441 0.978 3.828 0.978s2.691-0.356 3.828-0.978c-1.847-1.169-3.331-2.925-3.828-4.981z" })
            );
        }
        function Renren({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( RenrenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Renren.SVG = RenrenSVG;
        return Renren;
    })();
export const SinaWeibo = /*#__PURE__*/ (() => {
        function SinaWeiboSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.722 14.031c-2.65 0.262-4.938-0.938-5.109-2.675-0.172-1.741 1.837-3.359 4.484-3.622 2.65-0.263 4.938 0.938 5.106 2.675 0.175 1.741-1.834 3.362-4.481 3.622zM12.019 8.259c-0.225-0.069-0.381-0.113-0.262-0.409 0.256-0.644 0.281-1.197 0.003-1.594-0.519-0.741-1.941-0.703-3.569-0.019 0 0-0.513 0.222-0.381-0.181 0.25-0.806 0.213-1.478-0.178-1.869-0.884-0.884-3.234 0.034-5.25 2.050-1.506 1.503-2.381 3.106-2.381 4.491 0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188z" }),
_('path', { d: "M14.909 3.416c-1.050-1.166-2.6-1.609-4.031-1.306v0c-0.331 0.072-0.541 0.397-0.469 0.725 0.072 0.331 0.394 0.541 0.725 0.469 1.019-0.216 2.119 0.1 2.866 0.928s0.95 1.956 0.628 2.944v0c-0.103 0.322 0.072 0.666 0.394 0.772 0.322 0.103 0.666-0.072 0.772-0.394v-0.003c0.45-1.381 0.166-2.969-0.884-4.134z" }),
_('path', { d: "M13.294 4.875c-0.512-0.569-1.269-0.784-1.963-0.634-0.284 0.059-0.466 0.344-0.406 0.628 0.063 0.284 0.344 0.466 0.625 0.403v0c0.341-0.072 0.709 0.034 0.959 0.309 0.25 0.278 0.319 0.656 0.209 0.987v0c-0.088 0.275 0.063 0.575 0.341 0.666 0.278 0.088 0.575-0.063 0.666-0.341 0.219-0.678 0.081-1.453-0.431-2.019z" }),
_('path', { d: "M6.869 10.884c-0.094 0.159-0.297 0.234-0.456 0.169-0.159-0.063-0.206-0.244-0.116-0.397 0.094-0.153 0.291-0.228 0.447-0.169 0.156 0.056 0.213 0.234 0.125 0.397zM6.022 11.966c-0.256 0.409-0.806 0.588-1.219 0.4-0.406-0.184-0.528-0.659-0.272-1.059 0.253-0.397 0.784-0.575 1.194-0.403 0.416 0.178 0.55 0.65 0.297 1.063zM6.984 9.072c-1.259-0.328-2.684 0.3-3.231 1.409-0.559 1.131-0.019 2.391 1.253 2.803 1.319 0.425 2.875-0.228 3.416-1.447 0.534-1.197-0.131-2.425-1.438-2.766z" })
            );
        }
        function SinaWeibo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SinaWeiboSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        SinaWeibo.SVG = SinaWeiboSVG;
        return SinaWeibo;
    })();
export const Rss = /*#__PURE__*/ (() => {
    function RssSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z" })
        );
    }
    function Rss({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RssSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rss.SVG = RssSVG;
    return Rss;
})();
export const Rss2 = /*#__PURE__*/ (() => {
    function Rss2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.359 12.988c-0.75 0-1.359-0.603-1.359-1.353 0-0.744 0.609-1.356 1.359-1.356 0.753 0 1.359 0.613 1.359 1.356 0 0.75-0.609 1.353-1.359 1.353zM7.772 13c0-1.278-0.497-2.481-1.397-3.381-0.903-0.903-2.1-1.4-3.375-1.4v-1.956c3.713 0 6.738 3.022 6.738 6.737h-1.966zM11.244 13c0-4.547-3.697-8.25-8.241-8.25v-1.956c5.625 0 10.203 4.581 10.203 10.206h-1.963z" })
        );
    }
    function Rss2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Rss2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Rss2.SVG = Rss2SVG;
    return Rss2;
})();
export const Youtube = /*#__PURE__*/ (() => {
    function YoutubeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.841 4.8c0 0-0.156-1.103-0.637-1.587-0.609-0.637-1.291-0.641-1.603-0.678-2.237-0.163-5.597-0.163-5.597-0.163h-0.006c0 0-3.359 0-5.597 0.163-0.313 0.038-0.994 0.041-1.603 0.678-0.481 0.484-0.634 1.587-0.634 1.587s-0.159 1.294-0.159 2.591v1.213c0 1.294 0.159 2.591 0.159 2.591s0.156 1.103 0.634 1.588c0.609 0.637 1.409 0.616 1.766 0.684 1.281 0.122 5.441 0.159 5.441 0.159s3.363-0.006 5.6-0.166c0.313-0.037 0.994-0.041 1.603-0.678 0.481-0.484 0.637-1.588 0.637-1.588s0.159-1.294 0.159-2.591v-1.213c-0.003-1.294-0.162-2.591-0.162-2.591zM6.347 10.075v-4.497l4.322 2.256-4.322 2.241z" })
        );
    }
    function Youtube({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YoutubeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Youtube.SVG = YoutubeSVG;
    return Youtube;
})();
export const Youtube2 = /*#__PURE__*/ (() => {
        function Youtube2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 40 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 40 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M5.375 2.647c0.003-0.014 0.005-0.023 0.006-0.028l0.016-0.118-0.74-0.004c-0.668-0.004-0.873 0-0.891 0.017-0.009 0.008-0.24 0.885-0.651 2.473-0.196 0.758-0.361 1.363-0.367 1.345s-0.24-0.883-0.522-1.922c-0.281-1.039-0.517-1.894-0.524-1.901-0.010-0.010-0.906-0.014-1.632-0.008-0.105 0.001-0.164-0.205 0.938 3.299 0.152 0.485 0.381 1.172 0.507 1.526 0.146 0.408 0.25 0.724 0.321 0.987 0.126 0.501 0.13 0.815 0.103 1.182-0.032 0.423-0.036 3.413-0.005 3.463 0.024 0.038 1.425 0.056 1.558 0.020 0.021-0.006 0.035-0.026 0.045-0.139 0.033-0.097 0.036-0.484 0.036-2.090v-2.051l0.090-0.283c0.059-0.185 0.206-0.672 0.328-1.082s0.269-0.9 0.327-1.090c0.529-1.724 1.033-3.419 1.047-3.516l0.011-0.079z" }),
_('path', { d: "M13.221 5.135l-0 0.107-0.017 0-0.009 2.953-0.009 2.863-0.229 0.233c-0.257 0.261-0.462 0.361-0.648 0.314-0.203-0.051-0.197 0.028-0.214-3.356l-0.016-3.115h-1.474v0.107h-0.017v3.38c0 3.621-0 3.619 0.184 3.982 0.146 0.29 0.36 0.431 0.725 0.479h0c0.481 0.064 1-0.154 1.481-0.622l0.209-0.203v0.351c0 0.303 0.009 0.353 0.064 0.368 0.090 0.025 1.206 0.027 1.326 0.002l0.1-0.021v-0.104l0.017-0.003v-7.736l-1.472 0.020z" }),
_('path', { d: "M9.483 6.661c-0.14-0.599-0.401-1.002-0.832-1.28-0.676-0.437-1.449-0.484-2.165-0.13-0.522 0.258-0.859 0.686-1.032 1.314-0.021 0.075-0.036 0.138-0.047 0.231-0.044 0.222-0.049 0.552-0.061 2.093-0.018 2.374 0.010 2.656 0.307 3.195 0.292 0.529 0.897 0.917 1.556 0.997 0.198 0.024 0.6-0.013 0.832-0.078 0.525-0.146 1.029-0.561 1.252-1.032 0.096-0.204 0.154-0.345 0.189-0.604 0.065-0.353 0.070-0.925 0.070-2.381-0-1.857-0.006-2.060-0.068-2.326zM7.802 11.5c-0.124 0.094-0.34 0.135-0.515 0.098-0.135-0.029-0.318-0.241-0.374-0.434-0.070-0.241-0.075-3.594-0.015-4.251 0.1-0.329 0.378-0.501 0.682-0.419 0.237 0.064 0.358 0.212 0.427 0.523 0.051 0.231 0.057 0.518 0.046 2.207-0.007 1.12-0.011 1.668-0.048 1.962-0.037 0.185-0.099 0.235-0.203 0.315z" }),
_('path', { d: "M35.944 8.346h0.712l-0.011-0.645c-0.011-0.592-0.020-0.659-0.099-0.82-0.125-0.253-0.309-0.366-0.601-0.366-0.351 0-0.573 0.17-0.678 0.518-0.045 0.148-0.092 1.167-0.058 1.255 0.019 0.049 0.121 0.058 0.735 0.058z" }),
_('path', { d: "M31.184 6.879c-0.095-0.191-0.272-0.286-0.477-0.278-0.16 0.006-0.337 0.073-0.508 0.203l-0.127 0.097v4.634l0.127 0.097c0.288 0.22 0.604 0.266 0.822 0.12 0.086-0.058 0.142-0.137 0.186-0.263 0.057-0.164 0.062-0.375 0.055-2.325-0.008-2.032-0.012-2.152-0.078-2.285z" }),
_('path', { d: "M40.014 4.791c-0.142-1.701-0.255-2.253-0.605-2.962-0.465-0.939-1.136-1.434-2.092-1.543-0.739-0.084-3.521-0.203-6.094-0.26-4.456-0.099-11.782 0.092-12.718 0.331-0.432 0.111-0.757 0.299-1.094 0.634-0.591 0.588-0.944 1.432-1.085 2.6-0.323 2.666-0.33 5.886-0.019 8.649 0.134 1.188 0.41 1.96 0.928 2.596 0.323 0.397 0.881 0.734 1.379 0.835 0.35 0.071 2.1 0.169 4.65 0.26 0.38 0.014 1.385 0.037 2.235 0.052 1.77 0.031 5.025 0.013 6.886-0.039 1.252-0.035 3.534-0.128 3.961-0.161 0.12-0.009 0.398-0.027 0.618-0.039 0.739-0.042 1.209-0.196 1.65-0.543 0.571-0.449 1.013-1.278 1.2-2.251 0.177-0.92 0.295-2.559 0.319-4.42 0.020-1.555-0.007-2.393-0.119-3.741zM22.27 4.175l-0.828 0.010-0.036 8.83-0.718 0.009c-0.555 0.008-0.724-0.001-0.737-0.036-0.010-0.025-0.021-2.016-0.026-4.424l-0.009-4.379-1.617-0.020v-1.38l4.779 0.019 0.020 1.36-0.828 0.010zM27.347 9.236v3.797h-1.308v-0.4c0-0.301-0.011-0.4-0.047-0.4-0.026 0-0.144 0.099-0.263 0.22-0.259 0.263-0.565 0.474-0.827 0.572-0.542 0.203-1.056 0.084-1.275-0.293-0.201-0.345-0.204-0.423-0.204-4.005v-3.29h1.307l0.010 3.098c0.010 3.044 0.011 3.1 0.084 3.224 0.097 0.164 0.244 0.209 0.478 0.144 0.138-0.038 0.232-0.105 0.455-0.327l0.282-0.28v-5.859h1.308v3.797zM32.449 12.491c-0.115 0.257-0.372 0.508-0.583 0.57-0.549 0.162-0.99 0.030-1.499-0.449-0.158-0.149-0.305-0.269-0.327-0.269-0.027 0-0.041 0.116-0.041 0.345v0.345h-1.308v-10.248h1.308v1.672c0 0.919 0.012 1.672 0.027 1.672s0.153-0.122 0.307-0.27c0.354-0.341 0.649-0.491 1.024-0.519 0.669-0.051 1.068 0.294 1.25 1.080 0.057 0.245 0.062 0.525 0.062 2.798-0 2.768-0 2.78-0.221 3.273zM37.984 10.971c-0.012 0.285-0.046 0.612-0.077 0.727-0.182 0.674-0.666 1.152-1.366 1.348-0.942 0.264-1.98-0.168-2.394-0.997-0.232-0.465-0.241-0.558-0.241-2.831 0-1.853 0.007-2.081 0.066-2.334 0.168-0.715 0.584-1.178 1.289-1.435 0.204-0.074 0.417-0.113 0.63-0.117 0.761-0.016 1.515 0.393 1.832 1.059 0.213 0.449 0.24 0.642 0.261 1.908l0.019 1.136-2.789 0.019-0.010 0.763c-0.015 1.077 0.058 1.408 0.349 1.603 0.244 0.165 0.62 0.152 0.824-0.027 0.192-0.168 0.246-0.349 0.265-0.877l0.017-0.463h1.347l-0.022 0.518z" })
            );
        }
        function Youtube2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Youtube2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Youtube2.SVG = Youtube2SVG;
        return Youtube2;
    })();
export const Twitch = /*#__PURE__*/ (() => {
        function TwitchSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M1.5 0l-1.5 2.5v11.5h4v2h2l2-2h2.5l4.5-4.5v-9.5h-13.5zM13 8.5l-2.5 2.5h-2.5l-2 2v-2h-3v-9h10v6.5z" }),
_('path', { d: "M9.5 4h1.5v4h-1.5v-4z" }),
_('path', { d: "M6.5 4h1.5v4h-1.5v-4z" })
            );
        }
        function Twitch({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( TwitchSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Twitch.SVG = TwitchSVG;
        return Twitch;
    })();
export const Vimeo = /*#__PURE__*/ (() => {
    function VimeoSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.994 4.281c-0.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-0.931 0-1.722-0.859-2.366-2.581-0.431-1.578-0.859-3.156-1.291-4.734-0.478-1.722-0.991-2.581-1.541-2.581-0.119 0-0.538 0.253-1.256 0.753l-0.753-0.969c0.791-0.694 1.569-1.388 2.334-2.081 1.053-0.909 1.844-1.387 2.372-1.438 1.244-0.119 2.013 0.731 2.3 2.553 0.309 1.966 0.525 3.188 0.647 3.666 0.359 1.631 0.753 2.447 1.184 2.447 0.334 0 0.838-0.528 1.509-1.588 0.669-1.056 1.028-1.862 1.078-2.416 0.097-0.912-0.262-1.372-1.078-1.372-0.384 0-0.778 0.088-1.184 0.263 0.787-2.575 2.287-3.825 4.506-3.753 1.641 0.044 2.416 1.109 2.322 3.194z" })
        );
    }
    function Vimeo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( VimeoSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vimeo.SVG = VimeoSVG;
    return Vimeo;
})();
export const Vimeo2 = /*#__PURE__*/ (() => {
    function Vimeo2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13.463 5.313c-0.050 1.125-0.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-0.675 0-1.244-0.622-1.709-1.866-0.313-1.141-0.622-2.281-0.934-3.422-0.344-1.244-0.716-1.866-1.112-1.866-0.087 0-0.391 0.181-0.906 0.544l-0.544-0.7c0.572-0.5 1.134-1.003 1.687-1.503 0.763-0.656 1.331-1.003 1.712-1.038 0.9-0.087 1.453 0.528 1.662 1.844 0.225 1.422 0.381 2.303 0.469 2.65 0.259 1.178 0.544 1.766 0.856 1.766 0.241 0 0.606-0.381 1.091-1.147s0.744-1.347 0.778-1.747c0.069-0.659-0.191-0.991-0.778-0.991-0.278 0-0.563 0.063-0.856 0.191 0.569-1.859 1.653-2.766 3.256-2.712 1.188 0.034 1.747 0.803 1.678 2.309z" })
        );
    }
    function Vimeo2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Vimeo2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Vimeo2.SVG = Vimeo2SVG;
    return Vimeo2;
})();
export const Lanyrd = /*#__PURE__*/ (() => {
    function LanyrdSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.85 12.012l-5.444 1.781c-1.244 0.406-1.369 0.341-1.931-1.4l-1.375-4.259c-0.328-1.009-1.328-3.728-1.497-4.25-0.313-0.969-0.313-1.022 1.516-1.616 1.431-0.469 1.491-0.453 2.009 1.163 0.419 1.3 0.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c0.738-0.244 0.984-0.231 1.194 0.678l0.15 0.688c0.175 0.797-0.228 1-0.656 1.137z" })
        );
    }
    function Lanyrd({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LanyrdSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lanyrd.SVG = LanyrdSVG;
    return Lanyrd;
})();
export const Flickr = /*#__PURE__*/ (() => {
    function FlickrSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5zM9 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z" })
        );
    }
    function Flickr({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlickrSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flickr.SVG = FlickrSVG;
    return Flickr;
})();
export const Flickr2 = /*#__PURE__*/ (() => {
    function Flickr2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12.5 5v0c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5c0-1.933 1.567-3.5 3.5-3.5zM0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z" })
        );
    }
    function Flickr2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flickr2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flickr2.SVG = Flickr2SVG;
    return Flickr2;
})();
export const Flickr3 = /*#__PURE__*/ (() => {
    function Flickr3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z" })
        );
    }
    function Flickr3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flickr3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flickr3.SVG = Flickr3SVG;
    return Flickr3;
})();
export const Flickr4 = /*#__PURE__*/ (() => {
    function Flickr4SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z" })
        );
    }
    function Flickr4({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Flickr4SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flickr4.SVG = Flickr4SVG;
    return Flickr4;
})();
export const Dribbble = /*#__PURE__*/ (() => {
    function DribbbleSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z" })
        );
    }
    function Dribbble({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DribbbleSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Dribbble.SVG = DribbbleSVG;
    return Dribbble;
})();
export const Behance = /*#__PURE__*/ (() => {
        function BehanceSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M4.641 3.206c0.472 0 0.897 0.041 1.284 0.125 0.388 0.081 0.716 0.219 0.994 0.406 0.275 0.188 0.487 0.438 0.644 0.75 0.15 0.309 0.225 0.697 0.225 1.156 0 0.497-0.112 0.909-0.338 1.241-0.228 0.331-0.559 0.6-1.003 0.813 0.606 0.175 1.053 0.481 1.353 0.916 0.3 0.438 0.444 0.963 0.444 1.581 0 0.5-0.097 0.928-0.287 1.291-0.194 0.366-0.456 0.662-0.778 0.891-0.325 0.231-0.7 0.4-1.119 0.509-0.416 0.109-0.844 0.166-1.287 0.166h-4.772v-9.844h4.641zM4.359 7.181c0.384 0 0.703-0.091 0.953-0.275 0.25-0.181 0.369-0.481 0.369-0.894 0-0.228-0.041-0.419-0.122-0.566-0.084-0.147-0.194-0.263-0.334-0.344-0.138-0.084-0.294-0.141-0.478-0.172-0.178-0.034-0.366-0.050-0.556-0.050h-2.025v2.3h2.194zM4.478 11.372c0.213 0 0.416-0.019 0.606-0.063 0.194-0.044 0.366-0.109 0.509-0.209 0.144-0.097 0.266-0.225 0.353-0.394 0.088-0.166 0.128-0.378 0.128-0.637 0-0.506-0.144-0.869-0.428-1.088-0.284-0.216-0.662-0.322-1.131-0.322h-2.35v2.709h2.313z" }),
_('path', { d: "M11.331 11.338c0.294 0.287 0.716 0.431 1.266 0.431 0.394 0 0.738-0.1 1.022-0.3s0.456-0.412 0.522-0.631h1.725c-0.278 0.859-0.697 1.469-1.272 1.838-0.566 0.369-1.259 0.556-2.063 0.556-0.563 0-1.066-0.091-1.519-0.269-0.453-0.181-0.831-0.434-1.15-0.766-0.309-0.331-0.553-0.725-0.725-1.188-0.169-0.459-0.256-0.969-0.256-1.519 0-0.534 0.088-1.031 0.262-1.491 0.178-0.463 0.422-0.859 0.747-1.194s0.706-0.6 1.156-0.794c0.447-0.194 0.941-0.291 1.488-0.291 0.603 0 1.131 0.116 1.584 0.353 0.45 0.234 0.822 0.55 1.113 0.944s0.497 0.847 0.625 1.353c0.128 0.506 0.172 1.034 0.137 1.588h-5.147c0 0.559 0.188 1.094 0.484 1.378zM13.578 7.594c-0.231-0.256-0.628-0.397-1.106-0.397-0.313 0-0.572 0.053-0.778 0.159-0.203 0.106-0.369 0.237-0.497 0.394-0.125 0.156-0.213 0.325-0.262 0.503-0.050 0.172-0.081 0.331-0.091 0.469h3.188c-0.047-0.5-0.219-0.869-0.453-1.128z" }),
_('path', { d: "M10.444 4h3.991v0.972h-3.991v-0.972z" })
            );
        }
        function Behance({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( BehanceSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Behance.SVG = BehanceSVG;
        return Behance;
    })();
export const Behance2 = /*#__PURE__*/ (() => {
        function Behance2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.316 7.009c0.203-0.147 0.3-0.391 0.3-0.728 0-0.188-0.031-0.341-0.097-0.459-0.069-0.119-0.156-0.213-0.272-0.278-0.112-0.069-0.241-0.116-0.388-0.141-0.144-0.028-0.297-0.041-0.453-0.041h-1.647v1.869h1.781c0.313 0.003 0.572-0.072 0.775-0.222z" }),
_('path', { d: "M6.594 8.697c-0.231-0.175-0.537-0.262-0.919-0.262h-1.916v2.203h1.878c0.175 0 0.338-0.016 0.494-0.050s0.297-0.088 0.416-0.169c0.119-0.078 0.216-0.184 0.287-0.319s0.106-0.309 0.106-0.519c0-0.412-0.116-0.706-0.347-0.884z" }),
_('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM10.488 4.209h3.241v0.791h-3.241v-0.791zM8.463 10.725c-0.156 0.297-0.369 0.537-0.631 0.725-0.266 0.188-0.569 0.325-0.909 0.416-0.338 0.091-0.688 0.134-1.044 0.134h-3.878v-7.997h3.769c0.381 0 0.728 0.034 1.044 0.1 0.313 0.066 0.581 0.178 0.806 0.331 0.222 0.153 0.397 0.356 0.522 0.609 0.122 0.25 0.184 0.566 0.184 0.938 0 0.403-0.091 0.737-0.275 1.006s-0.453 0.487-0.816 0.659c0.494 0.141 0.856 0.391 1.097 0.744 0.244 0.356 0.363 0.784 0.363 1.284 0.003 0.409-0.075 0.759-0.231 1.050zM14.991 9.488h-4.178c0 0.456 0.156 0.891 0.394 1.125 0.238 0.231 0.581 0.35 1.028 0.35 0.322 0 0.597-0.081 0.831-0.244 0.231-0.162 0.372-0.334 0.425-0.512h1.4c-0.225 0.697-0.566 1.194-1.031 1.494-0.459 0.3-1.022 0.45-1.675 0.45-0.456 0-0.866-0.075-1.234-0.219-0.369-0.147-0.675-0.353-0.934-0.622-0.253-0.269-0.447-0.591-0.588-0.966-0.137-0.372-0.209-0.787-0.209-1.234 0-0.434 0.072-0.838 0.213-1.213 0.144-0.375 0.344-0.7 0.606-0.969 0.262-0.272 0.575-0.487 0.938-0.647 0.363-0.156 0.762-0.234 1.206-0.234 0.491 0 0.919 0.094 1.287 0.287 0.366 0.191 0.666 0.447 0.903 0.769s0.403 0.688 0.509 1.1c0.103 0.406 0.137 0.834 0.109 1.284z" }),
_('path', { d: "M12.134 7.247c-0.253 0-0.466 0.044-0.631 0.131s-0.3 0.194-0.403 0.319c-0.103 0.128-0.172 0.263-0.213 0.409-0.041 0.141-0.066 0.269-0.072 0.381h2.588c-0.037-0.406-0.178-0.706-0.366-0.916-0.194-0.213-0.512-0.325-0.903-0.325z" })
            );
        }
        function Behance2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Behance2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Behance2.SVG = Behance2SVG;
        return Behance2;
    })();
export const Deviantart = /*#__PURE__*/ (() => {
    function DeviantartSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.953 2.909v-2.909h-2.909l-0.291 0.294-1.375 2.616-0.431 0.291h-4.9v3.994h2.694l0.241 0.291-2.934 5.606v2.909h2.909l0.291-0.294 1.375-2.616 0.431-0.291h4.9v-3.994h-2.694l-0.241-0.294z" })
        );
    }
    function Deviantart({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DeviantartSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Deviantart.SVG = DeviantartSVG;
    return Deviantart;
})();
export const Icon500Px = /*#__PURE__*/ (() => {
    function Icon500PxSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M3.953 10.512c0.003 0.009 0.088 0.238 0.134 0.353 0.263 0.622 0.641 1.184 1.122 1.666s1.041 0.859 1.666 1.122c0.647 0.272 1.331 0.412 2.037 0.412s1.394-0.137 2.037-0.412c0.625-0.262 1.184-0.641 1.666-1.122s0.859-1.041 1.122-1.666c0.272-0.647 0.412-1.331 0.412-2.037s-0.137-1.394-0.412-2.037c-0.262-0.625-0.641-1.184-1.122-1.666s-1.041-0.859-1.666-1.122c-0.647-0.272-1.331-0.413-2.037-0.413-0.716 0-1.431 0.144-2.066 0.413-0.509 0.216-1.372 0.769-1.875 1.291l-0.003 0.003v-4.313h7.241c0.262-0.003 0.262-0.372 0.262-0.491 0-0.122 0-0.487-0.266-0.491h-7.828c-0.213 0-0.344 0.178-0.344 0.341v6.066c0 0.197 0.244 0.338 0.472 0.384 0.444 0.094 0.544-0.047 0.653-0.197l0.016-0.019c0.166-0.247 0.681-0.766 0.688-0.772 0.806-0.806 1.884-1.25 3.037-1.25 1.147 0 2.222 0.444 3.028 1.25 0.809 0.809 1.256 1.881 1.256 3.019 0 1.141-0.444 2.216-1.25 3.019-0.794 0.794-1.906 1.25-3.047 1.25-0.772 0-1.519-0.206-2.159-0.597l0.003-3.688c0-0.491 0.213-1.028 0.572-1.431 0.409-0.463 0.972-0.716 1.588-0.716 0.594 0 1.15 0.225 1.566 0.634 0.409 0.406 0.637 0.95 0.637 1.528 0 1.231-0.969 2.197-2.206 2.197-0.238 0-0.672-0.106-0.691-0.109-0.25-0.075-0.356 0.272-0.391 0.387-0.134 0.441 0.069 0.528 0.109 0.541 0.397 0.125 0.659 0.147 1.003 0.147 1.747 0 3.169-1.422 3.169-3.169 0-1.734-1.422-3.144-3.166-3.144-0.856 0-1.659 0.328-2.263 0.919-0.575 0.566-0.903 1.319-0.903 2.069v0.019c-0.003 0.094-0.003 2.306-0.006 3.031l-0.003-0.003c-0.328-0.363-0.653-0.919-0.869-1.488-0.084-0.222-0.275-0.184-0.534-0.103-0.125 0.034-0.469 0.141-0.391 0.394v0zM7.675 9.647c0 0.106 0.097 0.2 0.156 0.253l0.019 0.019c0.1 0.097 0.194 0.147 0.281 0.147 0.072 0 0.116-0.034 0.131-0.050 0.044-0.041 0.537-0.544 0.588-0.591l0.553 0.55c0.050 0.056 0.106 0.088 0.172 0.088 0.088 0 0.184-0.053 0.284-0.156 0.238-0.244 0.119-0.375 0.063-0.438l-0.559-0.559 0.584-0.588c0.128-0.137 0.016-0.284-0.097-0.397-0.162-0.162-0.322-0.206-0.422-0.112l-0.581 0.581-0.588-0.588c-0.031-0.031-0.072-0.047-0.113-0.047-0.078 0-0.172 0.053-0.275 0.156-0.181 0.181-0.219 0.306-0.125 0.406l0.588 0.584-0.584 0.584c-0.053 0.050-0.078 0.103-0.075 0.156zM8.953 1.716c-0.938 0-1.938 0.191-2.669 0.506-0.078 0.031-0.125 0.094-0.134 0.181-0.009 0.084 0.013 0.194 0.069 0.337 0.047 0.116 0.166 0.425 0.4 0.334 0.75-0.288 1.581-0.444 2.334-0.444 0.856 0 1.688 0.169 2.469 0.497 0.622 0.263 1.206 0.644 1.844 1.194 0.047 0.041 0.097 0.059 0.147 0.059 0.125 0 0.244-0.122 0.347-0.237 0.169-0.191 0.287-0.35 0.119-0.509-0.609-0.575-1.275-1.006-2.1-1.356-0.894-0.372-1.847-0.563-2.825-0.563zM14.006 13.3v0c-0.113-0.113-0.209-0.178-0.294-0.203s-0.162-0.006-0.222 0.053l-0.056 0.056c-0.581 0.581-1.259 1.037-2.012 1.356-0.781 0.331-1.609 0.497-2.463 0.497-0.856 0-1.684-0.169-2.463-0.497-0.753-0.319-1.431-0.775-2.013-1.356-0.606-0.606-1.063-1.284-1.356-2.012-0.288-0.713-0.381-1.247-0.413-1.422-0.003-0.016-0.006-0.028-0.006-0.037-0.041-0.206-0.231-0.222-0.503-0.178-0.112 0.019-0.459 0.072-0.428 0.319v0.006c0.091 0.578 0.253 1.144 0.481 1.681 0.366 0.866 0.891 1.644 1.559 2.313s1.447 1.191 2.313 1.559c0.897 0.378 1.85 0.572 2.831 0.572s1.934-0.194 2.831-0.572c0.866-0.366 1.644-0.891 2.313-1.559 0 0 0.037-0.037 0.059-0.059 0.069-0.084 0.134-0.225-0.159-0.516z" })
        );
    }
    function Icon500Px({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Icon500PxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Icon500Px.SVG = Icon500PxSVG;
    return Icon500Px;
})();
export const Steam = /*#__PURE__*/ (() => {
    function SteamSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM14.975 2.025c-1.367-1.367-3.583-1.367-4.95 0-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.43 0.022-0.856 0.132-1.249 0.328l-2.467-1.928c-0.571-0.446-1.396-0.345-1.842 0.226s-0.345 1.396 0.226 1.842l2.436 1.905c-0.265 1.043 0.010 2.196 0.827 3.012 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.891-3.484c0.723-0.104 1.419-0.434 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95zM6 14.105c-1.162 0-2.105-0.942-2.105-2.105 0-0.011 0.001-0.022 0.001-0.033l1.046 0.817c0.24 0.188 0.525 0.278 0.807 0.278 0.39 0 0.776-0.173 1.035-0.504 0.446-0.571 0.345-1.396-0.226-1.842l-0.992-0.776c0.14-0.029 0.285-0.045 0.434-0.045 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105zM12.5 7c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z" })
        );
    }
    function Steam({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SteamSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Steam.SVG = SteamSVG;
    return Steam;
})();
export const Steam2 = /*#__PURE__*/ (() => {
    function Steam2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.749 13.063c0.424 0 0.84-0.205 1.093-0.585 0.402-0.603 0.239-1.418-0.364-1.82l-1.032-0.688c0.177-0.048 0.362-0.074 0.554-0.074 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105c-1.131 0-2.054-0.893-2.102-2.012l1.124 0.749c0.224 0.149 0.477 0.221 0.727 0.221zM13.333 0c1.467 0 2.667 1.2 2.667 2.667v10.666c0 1.468-1.2 2.667-2.667 2.667h-10.666c-1.467 0-2.667-1.199-2.667-2.667v-3.172l1.896 1.264c-0.182 0.987 0.108 2.044 0.872 2.808 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.892-3.484c0.723-0.104 1.419-0.433 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95s-3.583-1.367-4.95 0c-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.498 0.025-0.99 0.168-1.433 0.428l-3.404-2.269v-4.339c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5zM10 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z" })
        );
    }
    function Steam2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Steam2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Steam2.SVG = Steam2SVG;
    return Steam2;
})();
export const Dropbox = /*#__PURE__*/ (() => {
        function DropboxSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.5 0.5l-3.5 3 4.5 3 3.5-3z" }),
_('path', { d: "M8 3.5l-3.5-3-4.5 3 3.5 3z" }),
_('path', { d: "M12.5 6.5l3.5 3-4.5 2.5-3.5-3z" }),
_('path', { d: "M8 9l-4.5-2.5-3.5 3 4.5 2.5z" }),
_('path', { d: "M11.377 13.212l-3.377-2.895-3.377 2.895-2.123-1.179v1.467l5.5 2.5 5.5-2.5v-1.467z" })
            );
        }
        function Dropbox({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( DropboxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Dropbox.SVG = DropboxSVG;
        return Dropbox;
    })();
export const Onedrive = /*#__PURE__*/ (() => {
    function OnedriveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.482 12.944c-0.942-0.235-1.466-0.984-1.468-2.095-0-0.355 0.025-0.525 0.114-0.754 0.217-0.56 0.793-0.982 1.55-1.138 0.377-0.077 0.493-0.16 0.493-0.353 0-0.060 0.045-0.24 0.1-0.399 0.249-0.724 0.71-1.327 1.202-1.573 0.515-0.258 0.776-0.316 1.399-0.313 0.886 0.005 1.327 0.197 1.945 0.846l0.34 0.357 0.304-0.105c1.473-0.51 2.942 0.358 3.061 1.809l0.032 0.397 0.29 0.104c0.829 0.297 1.218 0.92 1.148 1.837-0.046 0.599-0.326 1.078-0.77 1.315l-0.209 0.112-4.638 0.009c-3.564 0.007-4.697-0.006-4.893-0.055v0zM1.613 12.281c-0.565-0.142-1.164-0.67-1.445-1.273-0.159-0.342-0.168-0.393-0.168-0.998 0-0.576 0.014-0.668 0.14-0.954 0.267-0.603 0.78-1.038 1.422-1.21 0.136-0.036 0.263-0.094 0.283-0.128s0.043-0.221 0.050-0.415c0.045-1.206 0.794-2.269 1.839-2.61 0.565-0.184 1.306-0.202 1.92 0.058 0.195 0.082 0.173 0.1 0.585-0.471 0.244-0.338 0.705-0.695 1.108-0.909 0.435-0.231 0.887-0.337 1.428-0.336 1.512 0.004 2.815 1.003 3.297 2.529 0.154 0.487 0.146 0.624-0.035 0.628-0.079 0.002-0.306 0.048-0.505 0.102l-0.361 0.099-0.329-0.348c-0.928-0.98-2.441-1.192-3.728-0.522-0.514 0.268-0.927 0.652-1.239 1.153-0.222 0.357-0.506 1.024-0.506 1.189 0 0.117-0.090 0.176-0.474 0.309-1.189 0.412-1.883 1.364-1.882 2.582 0 0.443 0.108 0.986 0.258 1.296 0.057 0.117 0.088 0.228 0.070 0.247-0.046 0.049-1.525 0.032-1.73-0.019v0z" })
        );
    }
    function Onedrive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( OnedriveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Onedrive.SVG = OnedriveSVG;
    return Onedrive;
})();
export const Github = /*#__PURE__*/ (() => {
    function GithubSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0.198c-4.418 0-8 3.582-8 8 0 3.535 2.292 6.533 5.471 7.591 0.4 0.074 0.547-0.174 0.547-0.385 0-0.191-0.008-0.821-0.011-1.489-2.226 0.484-2.695-0.944-2.695-0.944-0.364-0.925-0.888-1.171-0.888-1.171-0.726-0.497 0.055-0.486 0.055-0.486 0.803 0.056 1.226 0.824 1.226 0.824 0.714 1.223 1.872 0.869 2.328 0.665 0.072-0.517 0.279-0.87 0.508-1.070-1.777-0.202-3.645-0.888-3.645-3.954 0-0.873 0.313-1.587 0.824-2.147-0.083-0.202-0.357-1.015 0.077-2.117 0 0 0.672-0.215 2.201 0.82 0.638-0.177 1.322-0.266 2.002-0.269 0.68 0.003 1.365 0.092 2.004 0.269 1.527-1.035 2.198-0.82 2.198-0.82 0.435 1.102 0.162 1.916 0.079 2.117 0.513 0.56 0.823 1.274 0.823 2.147 0 3.073-1.872 3.749-3.653 3.947 0.287 0.248 0.543 0.735 0.543 1.481 0 1.070-0.009 1.932-0.009 2.195 0 0.213 0.144 0.462 0.55 0.384 3.177-1.059 5.466-4.057 5.466-7.59 0-4.418-3.582-8-8-8z" })
        );
    }
    function Github({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GithubSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Github.SVG = GithubSVG;
    return Github;
})();
export const Npm = /*#__PURE__*/ (() => {
    function NpmSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM13 13h-2v-8h-3v8h-5v-10h10v10z" })
        );
    }
    function Npm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( NpmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Npm.SVG = NpmSVG;
    return Npm;
})();
export const Basecamp = /*#__PURE__*/ (() => {
    function BasecampSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838-0.719 1.347-1.222 2.822-1.453 4.331-0.025 0.172-0.050 0.344-0.069 0.519-0.009 0.094-0.019 0.188-0.025 0.281-0.009 0.119-0.003 0.156 0.059 0.256 0.187 0.303 0.409 0.584 0.659 0.838 0.512 0.525 1.134 0.928 1.794 1.241 1.503 0.709 3.2 0.966 4.85 1.022 1.703 0.056 3.453-0.084 5.081-0.616 1.391-0.453 2.731-1.244 3.503-2.522 0.084-0.137 0.025-0.341 0.009-0.5-0.019-0.191-0.044-0.378-0.075-0.566-0.056-0.369-0.131-0.731-0.222-1.094-0.181-0.738-0.428-1.463-0.728-2.159-1.088-2.525-3.1-5.219-5.963-5.775-0.322-0.063-0.65-0.094-0.978-0.094zM8.1 13.909c-1.784 0-3.728-0.159-5.334-1.019-0.625-0.334-1.262-0.819-1.563-1.484-0.087-0.194-0.056-0.269-0.016-0.497 0.028-0.147 0.041-0.291 0.106-0.428 0.091-0.191 0.184-0.378 0.281-0.566 0.328-0.634 0.681-1.262 1.091-1.853 0.203-0.291 0.419-0.578 0.669-0.828 0.175-0.175 0.388-0.362 0.634-0.422 0.756-0.181 1.334 0.694 1.794 1.134 0.222 0.213 0.519 0.453 0.85 0.412 0.228-0.028 0.431-0.206 0.594-0.353 0.553-0.497 0.997-1.112 1.456-1.691 0.228-0.284 0.453-0.572 0.7-0.844 0.166-0.184 0.347-0.394 0.569-0.513 0.397-0.216 0.903 0.228 1.178 0.456 0.469 0.391 0.884 0.847 1.281 1.309 0.378 0.441 0.744 0.888 1.066 1.372 0.497 0.75 0.928 1.55 1.322 2.359 0.084 0.175 0.113 0.294 0.144 0.488 0.019 0.106 0.059 0.228 0.044 0.338-0.022 0.153-0.128 0.319-0.206 0.444-0.188 0.297-0.441 0.553-0.719 0.769-1.166 0.903-2.744 1.203-4.178 1.338-0.588 0.056-1.175 0.078-1.762 0.078z" })
        );
    }
    function Basecamp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BasecampSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Basecamp.SVG = BasecampSVG;
    return Basecamp;
})();
export const Trello = /*#__PURE__*/ (() => {
    function TrelloSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7 12c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-8c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v8zM13 9c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-5c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v5z" })
        );
    }
    function Trello({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TrelloSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Trello.SVG = TrelloSVG;
    return Trello;
})();
export const Wordpress = /*#__PURE__*/ (() => {
    function WordpressSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2 8c0 2.313 1.38 4.312 3.382 5.259l-2.862-7.637c-0.333 0.727-0.52 1.531-0.52 2.378zM12.050 7.705c0-0.722-0.266-1.222-0.495-1.612-0.304-0.482-0.589-0.889-0.589-1.371 0-0.537 0.418-1.037 1.008-1.037 0.027 0 0.052 0.003 0.078 0.005-1.067-0.953-2.49-1.534-4.052-1.534-2.096 0-3.94 1.048-5.013 2.634 0.141 0.004 0.274 0.007 0.386 0.007 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.361 0.444 0.038 0.482 0 0-0.325 0.037-0.687 0.055l2.185 6.33 1.313-3.835-0.935-2.495c-0.323-0.019-0.629-0.055-0.629-0.055-0.323-0.019-0.285-0.5 0.038-0.482 0 0 0.991 0.074 1.58 0.074 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.362 0.444 0.038 0.482 0 0-0.326 0.037-0.687 0.055l2.168 6.282 0.599-1.947c0.259-0.809 0.457-1.389 0.457-1.889zM8.105 8.511l-1.8 5.095c0.538 0.154 1.106 0.238 1.695 0.238 0.699 0 1.369-0.117 1.992-0.331-0.016-0.025-0.031-0.052-0.043-0.081l-1.844-4.921zM13.265 5.196c0.026 0.186 0.040 0.386 0.040 0.601 0 0.593-0.114 1.259-0.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051 0-1.016-0.267-1.971-0.735-2.803zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z" })
        );
    }
    function Wordpress({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WordpressSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wordpress.SVG = WordpressSVG;
    return Wordpress;
})();
export const Joomla = /*#__PURE__*/ (() => {
    function JoomlaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.156 4.323c0.513-0.513 1.344-0.513 1.856-0l0.122 0.123 1.58-1.581-0.123-0.123c-0.9-0.902-2.164-1.217-3.319-0.946-0.166-1.018-1.048-1.796-2.112-1.796-1.182 0-2.14 0.96-2.14 2.143 0 1.021 0.712 1.875 1.667 2.091-0.362 1.21-0.066 2.576 0.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561c-0.511-0.511-0.512-1.346 0.003-1.861zM15.98 2.143c0-1.184-0.958-2.143-2.14-2.143-1.082 0-1.976 0.804-2.12 1.847-1.204-0.354-2.559-0.055-3.51 0.897l-3.56 3.561 1.58 1.581 3.559-3.56c0.515-0.515 1.344-0.514 1.854-0.003 0.512 0.513 0.512 1.346-0.001 1.859l-0.122 0.122 1.578 1.582 0.123-0.124c0.945-0.946 1.245-2.293 0.9-3.494 1.049-0.138 1.858-1.037 1.858-2.125zM14.16 11.735c0.283-1.163-0.031-2.443-0.939-3.352l-3.555-3.562-1.58 1.58 3.555 3.563c0.515 0.516 0.514 1.345 0.003 1.857-0.513 0.513-1.344 0.513-1.857-0l-0.121-0.122-1.578 1.582 0.121 0.121c0.961 0.962 2.338 1.257 3.553 0.883 0.197 0.979 1.061 1.716 2.098 1.716 1.181 0 2.14-0.959 2.14-2.143 0-1.081-0.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562c-0.511 0.512-1.344 0.513-1.859-0.002-0.513-0.514-0.513-1.345-0.001-1.859l0.122-0.121-1.579-1.58-0.121 0.12c-0.918 0.919-1.228 2.216-0.929 3.39-0.944 0.223-1.646 1.072-1.646 2.086-0 1.184 0.958 2.143 2.14 2.143 1.017-0.001 1.869-0.71 2.087-1.662 1.167 0.29 2.453-0.020 3.365-0.934l3.555-3.562-1.578-1.582z" })
        );
    }
    function Joomla({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( JoomlaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Joomla.SVG = JoomlaSVG;
    return Joomla;
})();
export const Ello = /*#__PURE__*/ (() => {
    function ElloSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.885 9.212c-0.575 2.23-2.584 3.788-4.885 3.788s-4.31-1.558-4.885-3.788c-0.097-0.377 0.131-0.764 0.508-0.861 0.058-0.015 0.118-0.023 0.177-0.023 0.322 0 0.604 0.218 0.684 0.531 0.414 1.605 1.86 2.727 3.516 2.727s3.102-1.121 3.516-2.727c0.081-0.313 0.362-0.531 0.684-0.531 0.060 0 0.12 0.008 0.178 0.023 0.183 0.047 0.336 0.163 0.432 0.326s0.123 0.353 0.075 0.536z" })
        );
    }
    function Ello({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ElloSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ello.SVG = ElloSVG;
    return Ello;
})();
export const Blogger = /*#__PURE__*/ (() => {
    function BloggerSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.966 6h-0.897c-0.549 0-1.031-0.465-1.069-1v0c0-2.854-2.301-5-5.175-5h-2.622c-2.872 0-5.201 2.313-5.203 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165v-3.662c0-0.57-0.46-1.173-1.034-1.173zM5 4h3c0.55 0 1 0.45 1 1s-0.45 1-1 1h-3c-0.55 0-1-0.45-1-1s0.45-1 1-1zM11 12h-6c-0.55 0-1-0.45-1-1s0.45-1 1-1h6c0.55 0 1 0.45 1 1s-0.45 1-1 1z" })
        );
    }
    function Blogger({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( BloggerSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Blogger.SVG = BloggerSVG;
    return Blogger;
})();
export const Blogger2 = /*#__PURE__*/ (() => {
        function Blogger2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 10.125c0 2.141-1.741 3.875-3.897 3.875h-4.2c-2.156 0-3.903-1.734-3.903-3.875v-4.25c0-2.141 1.747-3.875 3.903-3.875h1.966c2.156 0 3.881 1.609 3.881 3.75 0.028 0.4 0.391 0.75 0.8 0.75h0.672c0.431 0 0.775 0.453 0.775 0.881v2.744z" }),
_('path', { d: "M11 10c0 0.55-0.45 1-1 1h-4c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v0z" }),
_('path', { d: "M9 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v0z" })
            );
        }
        function Blogger2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Blogger2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Blogger2.SVG = Blogger2SVG;
        return Blogger2;
    })();
export const Tumblr = /*#__PURE__*/ (() => {
    function TumblrSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.001 7l-0 3.659c0 0.928-0.012 1.463 0.086 1.727 0.098 0.262 0.342 0.534 0.609 0.691 0.354 0.212 0.758 0.318 1.214 0.318 0.81 0 1.289-0.107 2.090-0.633v2.405c-0.683 0.321-1.279 0.509-1.833 0.639-0.555 0.129-1.154 0.194-1.798 0.194-0.732 0-1.163-0.092-1.725-0.276-0.562-0.185-1.042-0.45-1.438-0.79-0.398-0.343-0.672-0.706-0.826-1.091s-0.23-0.944-0.23-1.676v-5.611h-2.147v-2.266c0.628-0.204 1.331-0.497 1.778-0.877 0.449-0.382 0.809-0.839 1.080-1.374 0.272-0.534 0.459-1.214 0.561-2.039h2.579l-0 4h3.999v3h-3.999z" })
        );
    }
    function Tumblr({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TumblrSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tumblr.SVG = TumblrSVG;
    return Tumblr;
})();
export const Tumblr2 = /*#__PURE__*/ (() => {
    function Tumblr2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.434 12.884c-0.472 0.222-0.9 0.378-1.281 0.469-0.381 0.088-0.797 0.134-1.241 0.134-0.506 0-0.803-0.063-1.191-0.191s-0.719-0.309-0.994-0.544c-0.275-0.238-0.463-0.488-0.569-0.753s-0.159-0.65-0.159-1.156v-3.872h-1.5v-1.563c0.434-0.141 0.938-0.344 1.244-0.606 0.309-0.263 0.559-0.578 0.744-0.947 0.188-0.369 0.316-0.837 0.388-1.406h1.569v2.55h2.556v1.972h-2.553v2.831c0 0.641-0.009 1.009 0.059 1.191s0.238 0.369 0.422 0.475c0.244 0.147 0.525 0.219 0.838 0.219 0.559 0 1.116-0.181 1.669-0.544v1.741z" })
        );
    }
    function Tumblr2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Tumblr2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tumblr2.SVG = Tumblr2SVG;
    return Tumblr2;
})();
export const Yahoo = /*#__PURE__*/ (() => {
    function YahooSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.878 9.203v0c1.759-3.088 4.666-8.125 5.463-9.203-0.35 0.234-0.887 0.353-1.381 0.466l-0.747-0.466c-0.6 1.119-2.813 4.734-4.222 7.050-1.428-2.366-3.119-5.097-4.222-7.050-0.875 0.188-1.237 0.197-2.109 0v0 0c0 0 0 0 0 0v0c1.731 2.606 4.503 7.572 5.447 9.203v0l-0.128 6.797 1.013-0.466v-0.012l1.012 0.478-0.125-6.797z" })
        );
    }
    function Yahoo({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YahooSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Yahoo.SVG = YahooSVG;
    return Yahoo;
})();
export const Yahoo2 = /*#__PURE__*/ (() => {
    function Yahoo2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.019 1.087c-2.828 0-5.5-0.372-8.019-1.087 0 5.653 0 14.581 0 16 2.522-0.716 5.194-1.088 8.019-1.088 2.794 0 5.459 0.363 7.981 1.088 0-5.444 0-10.153 0-16-2.522 0.725-5.184 1.087-7.981 1.087zM12.45 2.453l-0.097 0.153c-0.091 0.144-0.172 0.266-0.284 0.438-0.15 0.225-0.431 0.672-0.769 1.247-0.094 0.159-0.209 0.35-0.328 0.556-0.228 0.384-0.484 0.819-0.688 1.162-0.084 0.147-0.169 0.297-0.256 0.447-0.225 0.391-0.456 0.794-0.678 1.181-0.228 0.403-0.453 0.8-0.678 1.194v0.397c0 0.55 0.012 1.15 0.031 1.684 0.009 0.244 0.019 0.678 0.031 1.137 0.012 0.547 0.025 1.113 0.041 1.4l0.003 0.088v0.009l-0.094-0.025c-0.037-0.009-0.072-0.019-0.109-0.028-0.113-0.025-0.234-0.044-0.353-0.056-0.072-0.006-0.147-0.009-0.222-0.009 0 0 0 0 0 0s0 0 0 0c-0.075 0-0.15 0.003-0.222 0.009-0.119 0.012-0.241 0.031-0.353 0.056-0.037 0.009-0.075 0.019-0.109 0.028l-0.094 0.025v-0.009l0.003-0.088c0.013-0.284 0.028-0.853 0.041-1.4 0.009-0.459 0.022-0.894 0.031-1.137 0.022-0.537 0.031-1.134 0.031-1.684v-0.397c-0.225-0.397-0.45-0.791-0.678-1.194-0.222-0.391-0.453-0.791-0.675-1.181-0.088-0.15-0.172-0.3-0.256-0.447-0.2-0.347-0.459-0.781-0.688-1.162-0.122-0.203-0.237-0.397-0.328-0.556-0.338-0.575-0.619-1.019-0.769-1.247-0.112-0.172-0.194-0.294-0.284-0.438l-0.097-0.153 0.175 0.050c0.222 0.063 0.45 0.094 0.694 0.094s0.478-0.031 0.697-0.094l0.053-0.016 0.028 0.047c0.431 0.778 1.591 2.684 2.284 3.825 0.237 0.394 0.428 0.703 0.522 0.862 0 0 0 0 0-0.003 0 0 0 0 0 0.003 0.094-0.156 0.284-0.469 0.522-0.862 0.694-1.138 1.853-3.044 2.284-3.825l0.028-0.047 0.053 0.016c0.219 0.063 0.453 0.094 0.697 0.094s0.472-0.031 0.694-0.094l0.166-0.050z" })
        );
    }
    function Yahoo2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Yahoo2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Yahoo2.SVG = Yahoo2SVG;
    return Yahoo2;
})();
export const Tux = /*#__PURE__*/ (() => {
    function TuxSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.87 11.514c-1.28 0.596-2.471 0.589-3.271 0.532-0.954-0.069-1.721-0.33-2.058-0.558-0.208-0.141-0.49-0.086-0.631 0.122s-0.086 0.49 0.122 0.631c0.542 0.367 1.501 0.64 2.503 0.712 0.17 0.012 0.356 0.020 0.557 0.020 0.872 0 1.979-0.083 3.163-0.634 0.228-0.106 0.326-0.376 0.22-0.604s-0.376-0.326-0.604-0.22zM13.921 10.841c0.044-3.948 0.449-11.409-7.109-10.806-7.463 0.601-5.484 8.484-5.595 11.124-0.099 1.397-0.562 3.104-1.217 4.841h2.017c0.207-0.736 0.36-1.464 0.425-2.159 0.122 0.085 0.252 0.167 0.391 0.245 0.226 0.133 0.42 0.31 0.626 0.497 0.48 0.438 1.025 0.934 2.089 0.996 0.071 0.004 0.143 0.006 0.214 0.006 1.077 0 1.813-0.471 2.404-0.85 0.283-0.181 0.528-0.338 0.759-0.413 0.655-0.205 1.227-0.536 1.655-0.957 0.067-0.066 0.129-0.133 0.187-0.202 0.238 0.873 0.564 1.856 0.926 2.836h4.307c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693c0-0 0-0-0-0.001-0.074-1.288 0.542-2.372 1.377-2.421s1.571 0.957 1.645 2.245c0 0 0 0 0 0.001 0.004 0.069 0.006 0.138 0.006 0.206-0.264 0.066-0.503 0.163-0.717 0.275-0.001-0.010-0.001-0.019-0.002-0.029 0-0 0-0 0-0-0.071-0.731-0.462-1.284-0.873-1.234s-0.686 0.684-0.614 1.415c0 0 0 0 0 0 0.031 0.319 0.123 0.604 0.251 0.819-0.032 0.025-0.122 0.091-0.225 0.166-0.078 0.057-0.172 0.126-0.286 0.21-0.311-0.408-0.524-0.993-0.562-1.655zM10.395 11.878c-0.030 0.681-0.92 1.322-1.743 1.579l-0.005 0.002c-0.342 0.111-0.647 0.306-0.97 0.513-0.543 0.347-1.104 0.706-1.914 0.706-0.053 0-0.108-0.002-0.161-0.005-0.742-0.043-1.090-0.36-1.529-0.761-0.232-0.211-0.472-0.43-0.781-0.611l-0.007-0.004c-0.667-0.377-1.081-0.845-1.108-1.253-0.013-0.203 0.077-0.378 0.268-0.522 0.416-0.312 0.695-0.516 0.879-0.651 0.205-0.15 0.267-0.195 0.313-0.239 0.033-0.031 0.068-0.065 0.106-0.103 0.382-0.371 1.021-0.993 2.002-0.993 0.6 0 1.264 0.231 1.971 0.686 0.333 0.217 0.623 0.317 0.99 0.444 0.252 0.087 0.539 0.186 0.922 0.35l0.006 0.003c0.357 0.147 0.78 0.415 0.76 0.858zM10.198 10.278c-0.069-0.035-0.14-0.068-0.215-0.098-0.345-0.148-0.622-0.248-0.852-0.328 0.127-0.248 0.206-0.558 0.213-0.894 0-0 0-0 0-0 0.018-0.818-0.395-1.483-0.922-1.484s-0.968 0.661-0.986 1.479c0 0 0 0 0 0-0.001 0.027-0.001 0.053-0 0.080-0.324-0.149-0.643-0.258-0.956-0.324-0.001-0.031-0.003-0.061-0.004-0.092 0-0 0-0.001 0-0.001-0.030-1.491 0.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642c0 0 0 0.001 0 0.001 0.014 0.674-0.167 1.295-0.475 1.776z" })
        );
    }
    function Tux({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( TuxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Tux.SVG = TuxSVG;
    return Tux;
})();
export const Appleinc = /*#__PURE__*/ (() => {
    function AppleincSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M12.367 8.501c-0.020-2.026 1.652-2.998 1.727-3.046-0.94-1.375-2.404-1.564-2.926-1.585-1.246-0.126-2.431 0.734-3.064 0.734-0.631 0-1.607-0.715-2.64-0.696-1.358 0.020-2.61 0.79-3.31 2.006-1.411 2.448-0.361 6.076 1.014 8.061 0.672 0.972 1.473 2.064 2.525 2.025 1.013-0.040 1.396-0.656 2.621-0.656s1.569 0.656 2.641 0.635c1.090-0.020 1.781-0.991 2.448-1.966 0.772-1.128 1.089-2.219 1.108-2.275-0.024-0.011-2.126-0.816-2.147-3.236zM10.353 2.555c0.558-0.677 0.935-1.617 0.832-2.555-0.804 0.033-1.779 0.536-2.356 1.212-0.518 0.6-0.971 1.557-0.85 2.476 0.898 0.070 1.815-0.456 2.373-1.132z" })
        );
    }
    function Appleinc({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( AppleincSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Appleinc.SVG = AppleincSVG;
    return Appleinc;
})();
export const Finder = /*#__PURE__*/ (() => {
        function FinderSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8.894 12.16c-0-0.001-0-0.001-0-0.002 0 0.001 0 0.001 0 0.002z" }),
_('path', { d: "M8.916 12.727c-0-0.004-0-0.007-0.001-0.011 0 0.004 0 0.007 0.001 0.011z" }),
_('path', { d: "M8.903 12.442c-0-0.003-0-0.006-0-0.008 0 0.003 0 0.006 0 0.008z" }),
_('path', { d: "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h7.716c0.001 0 0.001 0 0.002 0s0.001-0 0.002-0h6.28c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM3 3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1zM15 15h-5.86c-0.105-0.658-0.17-1.336-0.209-1.994 0 0.002 0 0.004 0 0.005-0.308 0.034-0.618 0.051-0.931 0.051-2.088 0-4.1-0.76-5.664-2.141-0.233-0.206-0.255-0.561-0.050-0.794s0.561-0.255 0.794-0.050c1.358 1.199 3.105 1.859 4.919 1.859 0.298 0 0.595-0.018 0.888-0.053-0.034-1.847 0.107-3.311 0.11-3.334 0.014-0.141-0.032-0.28-0.127-0.385s-0.229-0.164-0.371-0.164h-1.487c0.022-0.541 0.079-1.466 0.234-2.503 0.295-1.981 0.812-3.528 1.502-4.497h6.251v14z" }),
_('path', { d: "M12.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z" }),
_('path', { d: "M8.445 13.050c-0.057 0.003-0.114 0.005-0.171 0.007 0.057-0.002 0.114-0.004 0.171-0.007z" }),
_('path', { d: "M8 13.063c0.073 0 0.146-0.001 0.22-0.003-0.073 0.002-0.146 0.003-0.22 0.003z" }),
_('path', { d: "M8.423 11.925c0.012-0.001 0.024-0.001 0.037-0.002-0.012 0.001-0.024 0.001-0.037 0.002z" }),
_('path', { d: "M8.204 11.934c0.017-0 0.034-0.001 0.050-0.002-0.017 0.001-0.034 0.001-0.050 0.002z" }),
_('path', { d: "M13.713 10.128c-0.206-0.233-0.561-0.255-0.794-0.050-1.135 1.002-2.542 1.627-4.032 1.806 0.007 0.364 0.020 0.742 0.043 1.127 1.749-0.191 3.403-0.916 4.733-2.090 0.233-0.206 0.255-0.561 0.050-0.794z" }),
_('path', { d: "M8.93 13.012c-0.072 0.008-0.144 0.015-0.216 0.021 0.072-0.006 0.144-0.013 0.216-0.021z" }),
_('path', { d: "M8.68 13.035c-0.061 0.005-0.122 0.009-0.183 0.013 0.061-0.004 0.122-0.008 0.183-0.013z" })
            );
        }
        function Finder({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FinderSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Finder.SVG = FinderSVG;
        return Finder;
    })();
export const Android = /*#__PURE__*/ (() => {
        function AndroidSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM2 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM3.5 11.5c0 0.828 0.672 1.5 1.5 1.5v0 2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2c0.828 0 1.5-0.672 1.5-1.5v-5.5h-9v5.5z" }),
_('path', { d: "M12.472 5c-0.152-1.373-0.922-2.559-2.025-3.276l0.5-1.001c0.123-0.247 0.023-0.547-0.224-0.671s-0.547-0.023-0.671 0.224l-0.502 1.004-0.13-0.052c-0.446-0.148-0.924-0.229-1.42-0.229s-0.974 0.081-1.42 0.229l-0.13 0.052-0.502-1.004c-0.123-0.247-0.424-0.347-0.671-0.224s-0.347 0.424-0.224 0.671l0.5 1.001c-1.103 0.716-1.873 1.903-2.025 3.276v0.5h8.972v-0.5h-0.028zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.001-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.002-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5z" })
            );
        }
        function Android({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( AndroidSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Android.SVG = AndroidSVG;
        return Android;
    })();
export const Windows = /*#__PURE__*/ (() => {
    function WindowsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M6.441 7.999c-0.745-0.383-1.47-0.577-2.154-0.577-0.093 0-0.187 0.003-0.28 0.011-0.873 0.072-1.671 0.303-2.184 0.482-0.136 0.050-0.276 0.103-0.419 0.161l-1.403 4.866c0.964-0.357 1.817-0.53 2.598-0.53 1.263 0 2.18 0.472 2.937 0.958 0.359-1.217 1.219-4.158 1.476-5.036-0.187-0.114-0.376-0.228-0.571-0.333zM8.255 9.235l-1.413 4.909c0.419 0.24 1.83 1.001 2.91 1.001 0.872 0 1.848-0.223 2.982-0.684l1.349-4.718c-0.916 0.296-1.795 0.446-2.617 0.446-1.499 0-2.549-0.486-3.211-0.952zM4.575 5.762c1.205 0.012 2.096 0.472 2.835 0.945l1.449-4.958c-0.305-0.175-1.106-0.611-1.685-0.759-0.381-0.089-0.782-0.135-1.206-0.135-0.809 0.015-1.694 0.218-2.701 0.622l-1.382 4.853c1.013-0.382 1.885-0.568 2.689-0.568 0.001 0 0.002 0 0.002 0zM16 3.096c-0.919 0.357-1.816 0.539-2.672 0.539-1.433 0-2.489-0.497-3.173-0.974l-1.437 4.972c0.965 0.62 2.005 0.936 3.096 0.936 0.89 0 1.812-0.214 2.742-0.636l-0.003-0.035 0.058-0.014 1.39-4.788z" })
        );
    }
    function Windows({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WindowsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Windows.SVG = WindowsSVG;
    return Windows;
})();
export const Windows8 = /*#__PURE__*/ (() => {
    function Windows8SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.005 8l-0.005-4.876 6-0.815v5.691zM7 2.164l7.998-1.164v7h-7.998zM15 9l-0.002 7-7.998-1.125v-5.875zM6 14.747l-5.995-0.822-0-4.926h5.995z" })
        );
    }
    function Windows8({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Windows8SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Windows8.SVG = Windows8SVG;
    return Windows8;
})();
export const Soundcloud = /*#__PURE__*/ (() => {
    function SoundcloudSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.937 8.034c-0.283 0-0.552 0.055-0.798 0.154-0.164-1.787-1.723-3.188-3.625-3.188-0.465 0-0.917 0.088-1.317 0.237-0.156 0.058-0.197 0.117-0.197 0.233v6.292c0 0.121 0.098 0.222 0.221 0.234 0.005 0.001 5.68 0.003 5.717 0.003 1.139 0 2.062-0.888 2.062-1.983s-0.924-1.983-2.063-1.983zM6.25 12h0.5l0.25-3.503-0.25-3.497h-0.5l-0.25 3.497zM4.75 12h-0.5l-0.25-2.543 0.25-2.457h0.5l0.25 2.5zM2.25 12h0.5l0.25-2-0.25-2h-0.5l-0.25 2zM0.25 11h0.5l0.25-1-0.25-1h-0.5l-0.25 1z" })
        );
    }
    function Soundcloud({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SoundcloudSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Soundcloud.SVG = SoundcloudSVG;
    return Soundcloud;
})();
export const Soundcloud2 = /*#__PURE__*/ (() => {
    function Soundcloud2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM2.75 11h-0.5l-0.25-1.5 0.25-1.5h0.5l0.25 1.5-0.25 1.5zM4.75 11h-0.5l-0.25-2 0.25-2h0.5l0.25 2-0.25 2zM6.75 11h-0.5l-0.25-3 0.25-3h0.5l0.25 3-0.25 3zM12.894 11c-0.031 0-4.706-0.003-4.709-0.003-0.1-0.009-0.181-0.097-0.184-0.2v-5.394c0-0.1 0.034-0.15 0.162-0.2 0.331-0.128 0.703-0.203 1.088-0.203 1.566 0 2.85 1.2 2.987 2.734 0.203-0.084 0.425-0.131 0.656-0.131 0.938 0 1.7 0.762 1.7 1.7s-0.762 1.697-1.7 1.697z" })
        );
    }
    function Soundcloud2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Soundcloud2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Soundcloud2.SVG = Soundcloud2SVG;
    return Soundcloud2;
})();
export const Skype = /*#__PURE__*/ (() => {
        function SkypeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6.65 0.584c-0.025-0.016-0.053-0.028-0.078-0.041-0.028 0.006-0.053 0.009-0.081 0.016l0.159 0.025z" }),
_('path', { d: "M0.575 6.578c-0.006 0.028-0.009 0.056-0.012 0.081 0.016 0.025 0.025 0.050 0.041 0.075l-0.028-0.156z" }),
_('path', { d: "M15.419 9.416c0.006-0.028 0.009-0.056 0.016-0.084-0.016-0.025-0.025-0.050-0.041-0.075l0.025 0.159z" }),
_('path', { d: "M9.25 15.359c0.025 0.016 0.053 0.028 0.078 0.041 0.028-0.006 0.056-0.009 0.084-0.012l-0.162-0.028z" }),
_('path', { d: "M15.434 9.331c-0.006 0.028-0.009 0.056-0.016 0.084l-0.028-0.162c0.016 0.028 0.028 0.053 0.044 0.078 0.081-0.45 0.125-0.909 0.125-1.369 0-1.019-0.2-2.009-0.594-2.941-0.381-0.9-0.925-1.709-1.619-2.403s-1.503-1.238-2.4-1.619c-0.931-0.394-1.922-0.594-2.941-0.594-0.481 0-0.963 0.044-1.431 0.134 0 0-0.003 0-0.003 0 0.025 0.012 0.053 0.025 0.078 0.041l-0.159-0.025c0.028-0.006 0.053-0.009 0.081-0.016-0.644-0.341-1.366-0.525-2.097-0.525-1.194 0-2.319 0.466-3.163 1.309s-1.309 1.969-1.309 3.163c0 0.759 0.197 1.509 0.563 2.169 0.006-0.028 0.009-0.056 0.012-0.081l0.028 0.159c-0.016-0.025-0.028-0.050-0.041-0.075-0.075 0.428-0.112 0.866-0.112 1.303 0 1.019 0.2 2.009 0.594 2.941 0.381 0.9 0.925 1.706 1.619 2.4s1.503 1.238 2.403 1.619c0.931 0.394 1.922 0.594 2.941 0.594 0.444 0 0.887-0.041 1.322-0.119-0.025-0.016-0.050-0.028-0.078-0.041l0.162 0.028c-0.028 0.006-0.056 0.009-0.084 0.012 0.669 0.378 1.428 0.581 2.2 0.581 1.194 0 2.319-0.466 3.162-1.309s1.309-1.969 1.309-3.162c-0.003-0.759-0.2-1.509-0.569-2.175zM8.034 12.591c-2.684 0-3.884-1.319-3.884-2.309 0-0.506 0.375-0.863 0.891-0.863 1.15 0 0.85 1.65 2.994 1.65 1.097 0 1.703-0.597 1.703-1.206 0-0.366-0.181-0.772-0.903-0.95l-2.388-0.597c-1.922-0.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6 0.913 3.6 2.131 0 0.522-0.453 0.825-0.969 0.825-0.981 0-0.8-1.356-2.775-1.356-0.981 0-1.522 0.444-1.522 1.078s0.775 0.838 1.447 0.991l1.769 0.394c1.934 0.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z" })
            );
        }
        function Skype({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SkypeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Skype.SVG = SkypeSVG;
        return Skype;
    })();
export const Reddit = /*#__PURE__*/ (() => {
    function RedditSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10.049 12.137c0.258-0.203 0.631-0.159 0.834 0.099s0.159 0.631-0.099 0.834c-0.717 0.565-1.81 0.93-2.783 0.93s-2.066-0.365-2.784-0.93c-0.258-0.203-0.302-0.576-0.099-0.834s0.576-0.302 0.834-0.099c0.413 0.325 1.23 0.675 2.049 0.675s1.636-0.35 2.049-0.675zM16 8c0-1.105-0.895-2-2-2-0.752 0-1.406 0.415-1.748 1.028-1.028-0.562-2.28-0.926-3.645-1.010l1.193-2.68 2.284 0.659c0.206 0.583 0.761 1.002 1.415 1.002 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.571 0-1.068 0.319-1.321 0.789l-2.545-0.735c-0.285-0.082-0.587 0.058-0.707 0.329l-1.621 3.641c-1.33 0.094-2.551 0.453-3.557 1.004-0.342-0.613-0.996-1.028-1.748-1.028-1.105 0-2 0.895-2 2 0 0.817 0.491 1.52 1.193 1.83-0.126 0.375-0.193 0.767-0.193 1.17 0 2.761 3.134 5 7 5s7-2.239 7-5c0-0.403-0.067-0.795-0.193-1.17 0.703-0.31 1.193-1.013 1.193-1.83zM13.5 2.938c0.311 0 0.563 0.252 0.563 0.563s-0.252 0.563-0.563 0.563-0.563-0.252-0.563-0.563 0.252-0.563 0.563-0.563zM1 8c0-0.551 0.449-1 1-1 0.399 0 0.743 0.234 0.904 0.573-0.523 0.396-0.956 0.854-1.276 1.355-0.368-0.148-0.628-0.508-0.628-0.928zM8 14.813c-3.21 0-5.813-1.707-5.813-3.813s2.602-3.813 5.813-3.813c3.21 0 5.813 1.707 5.813 3.813s-2.602 3.813-5.813 3.813zM14.372 8.928c-0.32-0.502-0.753-0.959-1.276-1.355 0.161-0.338 0.505-0.573 0.904-0.573 0.551 0 1 0.449 1 1 0 0.42-0.26 0.78-0.628 0.928z" })
        );
    }
    function Reddit({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( RedditSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Reddit.SVG = RedditSVG;
    return Reddit;
})();
export const Hackernews = /*#__PURE__*/ (() => {
    function HackernewsSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM8.5 9.125v3.375h-1v-3.375l-2.734-5.125h1.134l2.1 3.938 2.1-3.938h1.134l-2.734 5.125z" })
        );
    }
    function Hackernews({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HackernewsSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Hackernews.SVG = HackernewsSVG;
    return Hackernews;
})();
export const Wikipedia = /*#__PURE__*/ (() => {
    function WikipediaSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.106 3.65c0 0.050-0.016 0.097-0.047 0.141-0.031 0.041-0.066 0.063-0.106 0.063-0.313 0.031-0.569 0.131-0.766 0.3-0.2 0.169-0.403 0.497-0.613 0.975l-3.225 7.272c-0.022 0.069-0.081 0.1-0.178 0.1-0.075 0-0.134-0.034-0.178-0.1l-1.809-3.781-2.081 3.781c-0.044 0.069-0.1 0.1-0.178 0.1-0.094 0-0.153-0.034-0.184-0.1l-3.166-7.269c-0.197-0.45-0.406-0.766-0.625-0.944s-0.525-0.291-0.916-0.331c-0.034 0-0.066-0.019-0.094-0.053-0.031-0.034-0.044-0.075-0.044-0.122 0-0.119 0.034-0.178 0.1-0.178 0.281 0 0.578 0.013 0.888 0.038 0.288 0.025 0.556 0.038 0.809 0.038 0.256 0 0.563-0.013 0.913-0.038 0.366-0.025 0.691-0.038 0.975-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.022 0.175-0.063 0.175c-0.281 0.022-0.506 0.094-0.669 0.216s-0.244 0.281-0.244 0.481c0 0.1 0.034 0.228 0.1 0.378l2.616 5.912 1.487-2.806-1.384-2.903c-0.25-0.519-0.453-0.853-0.612-1.003s-0.403-0.241-0.728-0.275c-0.031 0-0.056-0.019-0.084-0.053s-0.041-0.075-0.041-0.122c0-0.119 0.028-0.178 0.088-0.178 0.281 0 0.541 0.013 0.778 0.038 0.228 0.025 0.469 0.038 0.728 0.038 0.253 0 0.519-0.013 0.803-0.038 0.291-0.025 0.578-0.038 0.859-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.019 0.175-0.063 0.175c-0.566 0.038-0.847 0.2-0.847 0.481 0 0.125 0.066 0.322 0.197 0.588l0.916 1.859 0.912-1.7c0.125-0.241 0.191-0.444 0.191-0.606 0-0.388-0.281-0.594-0.847-0.619-0.050 0-0.075-0.059-0.075-0.175 0-0.044 0.012-0.081 0.037-0.119s0.050-0.056 0.075-0.056c0.203 0 0.45 0.013 0.747 0.038 0.281 0.025 0.516 0.038 0.697 0.038 0.131 0 0.322-0.013 0.575-0.031 0.319-0.028 0.588-0.044 0.803-0.044 0.050 0 0.075 0.050 0.075 0.15 0 0.134-0.047 0.203-0.137 0.203-0.328 0.034-0.594 0.125-0.794 0.272s-0.45 0.481-0.75 1.006l-1.222 2.237 1.644 3.35 2.428-5.647c0.084-0.206 0.125-0.397 0.125-0.569 0-0.412-0.281-0.631-0.847-0.659-0.050 0-0.075-0.059-0.075-0.175 0-0.119 0.037-0.178 0.113-0.178 0.206 0 0.45 0.013 0.734 0.038 0.262 0.025 0.481 0.038 0.656 0.038 0.188 0 0.4-0.013 0.644-0.038 0.253-0.025 0.481-0.038 0.684-0.038 0.063 0 0.094 0.050 0.094 0.15z" })
        );
    }
    function Wikipedia({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( WikipediaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Wikipedia.SVG = WikipediaSVG;
    return Wikipedia;
})();
export const Linkedin = /*#__PURE__*/ (() => {
    function LinkedinSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z" })
        );
    }
    function Linkedin({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LinkedinSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Linkedin.SVG = LinkedinSVG;
    return Linkedin;
})();
export const Linkedin2 = /*#__PURE__*/ (() => {
        function Linkedin2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z" }),
_('path', { d: "M1 6h3v9h-3v-9z" }),
_('path', { d: "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" })
            );
        }
        function Linkedin2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Linkedin2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Linkedin2.SVG = Linkedin2SVG;
        return Linkedin2;
    })();
export const Lastfm = /*#__PURE__*/ (() => {
    function LastfmSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M7.056 11.972l-0.588-1.594c0 0-0.953 1.063-2.381 1.063-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l0.588 1.831c0.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-0.697 3.813-2.528 0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.513-1.044-1.063 0-0.622 0.494-0.991 1.3-0.991 0.881 0 1.356 0.331 1.428 1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262 0.622-3.262 2.622 0 1.247 0.606 2.034 2.125 2.4l1.247 0.294c0.934 0.219 1.247 0.606 1.247 1.137 0 0.678-0.659 0.953-1.906 0.953-1.85 0-2.622-0.972-3.059-2.309l-0.606-1.831c-0.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-0.972 3.059-0.972v0z" })
        );
    }
    function Lastfm({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LastfmSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lastfm.SVG = LastfmSVG;
    return Lastfm;
})();
export const Lastfm2 = /*#__PURE__*/ (() => {
    function Lastfm2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.666 11.887c-2.775 0-3.737-1.25-4.25-2.806l-0.513-1.603c-0.384-1.172-0.834-2.084-2.244-2.084-0.978 0-1.972 0.706-1.972 2.678 0 1.541 0.784 2.503 1.894 2.503 1.25 0 2.084-0.931 2.084-0.931l0.513 1.394c0 0-0.866 0.85-2.678 0.85-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206 0.769 3.881 2.853l0.528 1.603c0.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-0.241 1.669-0.834 0-0.466-0.272-0.803-1.091-0.994l-1.091-0.256c-1.331-0.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631 0.594 2.759 2.038l-1.603 0.194c-0.066-0.691-0.481-0.978-1.25-0.978-0.706 0-1.137 0.322-1.137 0.866 0 0.481 0.209 0.769 0.912 0.931l1.025 0.225c1.378 0.322 2.116 0.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z" })
        );
    }
    function Lastfm2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Lastfm2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Lastfm2.SVG = Lastfm2SVG;
    return Lastfm2;
})();
export const Delicious = /*#__PURE__*/ (() => {
    function DeliciousSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0 0v16h16v-16h-16zM8 15v-7h-7v-7h7v7h7v7h-7z" })
        );
    }
    function Delicious({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( DeliciousSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Delicious.SVG = DeliciousSVG;
    return Delicious;
})();
export const Stumbleupon = /*#__PURE__*/ (() => {
        function StumbleuponSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 5c-0.55 0-1 0.45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-1.653 1.347-3 3-3s3 1.347 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.331-0.45-0.781-1-0.781z" }),
_('path', { d: "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.769 0.45 1.219 1 1.219s1-0.45 1-1v-2h2v2z" })
            );
        }
        function Stumbleupon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( StumbleuponSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Stumbleupon.SVG = StumbleuponSVG;
        return Stumbleupon;
    })();
export const Stumbleupon2 = /*#__PURE__*/ (() => {
    function Stumbleupon2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.313 0h-10.625c-1.478 0-2.688 1.209-2.688 2.688v10.625c0 1.478 1.209 2.688 2.688 2.688h10.625c1.478 0 2.688-1.209 2.688-2.688v-10.625c0-1.478-1.209-2.688-2.688-2.688zM8 5c-0.551 0-1 0.449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2h2v2c0 0.551 0.449 1 1 1s1-0.449 1-1v-4c0-1.654 1.346-3 3-3s3 1.346 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.333-0.449-0.781-1-0.781zM15 10c0 1.654-1.346 3-3 3s-3-1.346-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.77 0.449 1.219 1 1.219s1-0.449 1-1v-2h2v2z" })
        );
    }
    function Stumbleupon2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Stumbleupon2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stumbleupon2.SVG = Stumbleupon2SVG;
    return Stumbleupon2;
})();
export const Stackoverflow = /*#__PURE__*/ (() => {
    function StackoverflowSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M16 10v6h-16v-6h2v4h12v-4zM3 11h10v2h-10zM3.237 8.835l0.433-1.953 9.763 2.164-0.433 1.953zM4.37 4.821l0.845-1.813 9.063 4.226-0.845 1.813zM15.496 5.648l-1.218 1.587-7.934-6.088 0.88-1.147h0.91z" })
        );
    }
    function Stackoverflow({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( StackoverflowSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Stackoverflow.SVG = StackoverflowSVG;
    return Stackoverflow;
})();
export const Pinterest = /*#__PURE__*/ (() => {
    function PinterestSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 1.069c-3.828 0-6.931 3.103-6.931 6.931 0 2.938 1.828 5.444 4.406 6.453-0.059-0.547-0.116-1.391 0.025-1.988 0.125-0.541 0.813-3.444 0.813-3.444s-0.206-0.416-0.206-1.028c0-0.963 0.559-1.684 1.253-1.684 0.591 0 0.878 0.444 0.878 0.975 0 0.594-0.378 1.484-0.575 2.306-0.166 0.691 0.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 0.597 0.228 1.234 0.516 1.581 0.056 0.069 0.066 0.128 0.047 0.2-0.053 0.219-0.169 0.691-0.194 0.787-0.031 0.128-0.1 0.153-0.231 0.094-0.866-0.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-0.703 0-1.362-0.366-1.588-0.797 0 0-0.347 1.322-0.431 1.647-0.156 0.603-0.578 1.356-0.862 1.816 0.65 0.2 1.337 0.309 2.053 0.309 3.828 0 6.931-3.103 6.931-6.931 0-3.831-3.103-6.934-6.931-6.934z" })
        );
    }
    function Pinterest({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( PinterestSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pinterest.SVG = PinterestSVG;
    return Pinterest;
})();
export const Pinterest2 = /*#__PURE__*/ (() => {
    function Pinterest2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8 0c-4.412 0-8 3.587-8 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zM8 14.931c-0.716 0-1.403-0.109-2.053-0.309 0.281-0.459 0.706-1.216 0.862-1.816 0.084-0.325 0.431-1.647 0.431-1.647 0.225 0.431 0.888 0.797 1.587 0.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016 0.541 2.281 1.406 2.684 0.131 0.063 0.2 0.034 0.231-0.094 0.022-0.097 0.141-0.566 0.194-0.787 0.016-0.069 0.009-0.131-0.047-0.2-0.287-0.347-0.516-0.988-0.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-0.947 3.175-2.178 3.175-0.681 0-1.191-0.563-1.025-1.253 0.197-0.825 0.575-1.713 0.575-2.306 0-0.531-0.284-0.975-0.878-0.975-0.697 0-1.253 0.719-1.253 1.684 0 0.612 0.206 1.028 0.206 1.028s-0.688 2.903-0.813 3.444c-0.141 0.6-0.084 1.441-0.025 1.988-2.578-1.006-4.406-3.512-4.406-6.45 0-3.828 3.103-6.931 6.931-6.931s6.931 3.103 6.931 6.931c0 3.828-3.103 6.931-6.931 6.931z" })
        );
    }
    function Pinterest2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Pinterest2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Pinterest2.SVG = Pinterest2SVG;
    return Pinterest2;
})();
export const Xing = /*#__PURE__*/ (() => {
    function XingSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.884 10.406h-1.728c-0.103 0-0.181-0.047-0.225-0.119-0.047-0.075-0.047-0.169 0-0.266l1.838-3.244c0.003-0.003 0.003-0.006 0-0.009l-1.169-2.025c-0.047-0.097-0.056-0.191-0.009-0.266 0.044-0.072 0.131-0.109 0.237-0.109h1.731c0.266 0 0.397 0.172 0.481 0.325 0 0 1.181 2.063 1.191 2.075-0.069 0.125-1.869 3.303-1.869 3.303-0.094 0.162-0.219 0.334-0.478 0.334zM13.069 2.378l-3.831 6.775c-0.003 0.003-0.003 0.009 0 0.012l2.441 4.456c0.047 0.097 0.050 0.194 0.003 0.269-0.044 0.072-0.125 0.109-0.231 0.109h-1.728c-0.266 0-0.397-0.175-0.484-0.328 0 0-2.453-4.5-2.459-4.512 0.122-0.216 3.85-6.828 3.85-6.828 0.094-0.166 0.206-0.328 0.463-0.328h1.753c0.103 0 0.188 0.041 0.231 0.109 0.044 0.072 0.044 0.169-0.006 0.266z" })
        );
    }
    function Xing({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( XingSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Xing.SVG = XingSVG;
    return Xing;
})();
export const Xing2 = /*#__PURE__*/ (() => {
        function Xing2SVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M2.431 3.159c-0.138 0-0.256 0.050-0.316 0.144-0.059 0.1-0.050 0.225 0.013 0.353l1.559 2.7c0.003 0.006 0.003 0.009 0 0.013l-2.45 4.331c-0.063 0.128-0.059 0.256 0 0.353 0.059 0.094 0.163 0.156 0.3 0.156h2.306c0.344 0 0.513-0.234 0.628-0.447 0 0 2.397-4.241 2.491-4.406-0.009-0.016-1.588-2.766-1.588-2.766-0.116-0.203-0.287-0.431-0.644-0.431h-2.3z" }),
_('path', { d: "M12.125 0c-0.344 0-0.494 0.216-0.619 0.441 0 0-4.972 8.816-5.134 9.106 0.009 0.016 3.278 6.016 3.278 6.016 0.116 0.203 0.291 0.441 0.644 0.441h2.306c0.137 0 0.247-0.053 0.306-0.147 0.063-0.1 0.059-0.228-0.006-0.356l-3.25-5.947c-0.003-0.006-0.003-0.009 0-0.016l5.109-9.034c0.063-0.128 0.066-0.256 0.006-0.356-0.059-0.094-0.169-0.147-0.306-0.147h-2.334z" })
            );
        }
        function Xing2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( Xing2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Xing2.SVG = Xing2SVG;
        return Xing2;
    })();
export const Flattr = /*#__PURE__*/ (() => {
    function FlattrSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M5.743 0c-3.802 0-5.743 2.19-5.743 6.279v0 8.579l3.725-3.729v-4.358c0-1.694 0.449-2.772 1.955-3.014v0c0.526-0.103 1.621-0.067 2.317-0.067v0 2.587c0 0.024 0.003 0.066 0.009 0.087v0c0.029 0.105 0.124 0.181 0.236 0.182v0c0.063 0 0.123-0.033 0.184-0.093v0l6.455-6.453-9.139-0.001zM12.275 4.871v4.358c0 1.694-0.449 2.772-1.955 3.014v0c-0.526 0.103-1.621 0.067-2.317 0.067v0-2.587c0-0.023-0.003-0.066-0.009-0.087v0c-0.029-0.105-0.124-0.182-0.236-0.182v0c-0.064-0-0.123 0.033-0.184 0.093v0l-6.455 6.453 9.139 0.001c3.802 0 5.743-2.19 5.743-6.279v0-8.579l-3.725 3.729z" })
        );
    }
    function Flattr({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FlattrSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Flattr.SVG = FlattrSVG;
    return Flattr;
})();
export const Foursquare = /*#__PURE__*/ (() => {
    function FoursquareSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M13.306 1.408c-0.188-0.256-0.488-0.408-0.806-0.408h-9.5c-0.552 0-1 0.448-1 1v12c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.382 0.076 0.26 0 0.516-0.102 0.707-0.293l3.707-3.707h2.586c0.437 0 0.824-0.284 0.954-0.702l2.5-8c0.095-0.304 0.040-0.634-0.149-0.891zM10.515 5h-3.515c-0.552 0-1 0.448-1 1s0.448 1 1 1h2.89l-0.625 2h-2.265c-0.265 0-0.52 0.105-0.707 0.293l-2.293 2.293v-8.586h7.14l-0.625 2z" })
        );
    }
    function Foursquare({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FoursquareSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Foursquare.SVG = FoursquareSVG;
    return Foursquare;
})();
export const Yelp = /*#__PURE__*/ (() => {
    function YelpSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M9.514 10.21c-0.27 0.272-0.042 0.768-0.042 0.768l2.033 3.394c0 0 0.334 0.447 0.623 0.447 0.29 0 0.577-0.239 0.577-0.239l1.607-2.297c0 0 0.162-0.29 0.166-0.544 0.006-0.361-0.538-0.46-0.538-0.46l-3.805-1.222c-0 0-0.373-0.099-0.621 0.152zM9.321 8.5c0.195 0.33 0.732 0.234 0.732 0.234l3.796-1.109c0 0 0.517-0.21 0.591-0.491 0.072-0.281-0.085-0.619-0.085-0.619l-1.814-2.137c0 0-0.157-0.27-0.483-0.297-0.36-0.031-0.581 0.405-0.581 0.405l-2.145 3.375c0 0-0.19 0.336-0.010 0.64zM7.527 7.184c0.447-0.11 0.518-0.759 0.518-0.759l-0.030-5.404c0 0-0.067-0.667-0.367-0.847-0.47-0.285-0.609-0.136-0.744-0.116l-3.151 1.171c0 0-0.309 0.102-0.469 0.36-0.23 0.365 0.233 0.899 0.233 0.899l3.276 4.465c0 0 0.323 0.334 0.735 0.233zM6.749 9.371c0.011-0.417-0.5-0.667-0.5-0.667l-3.387-1.711c0 0-0.502-0.207-0.746-0.063-0.187 0.11-0.352 0.31-0.368 0.486l-0.221 2.716c0 0-0.033 0.471 0.089 0.685 0.173 0.304 0.741 0.092 0.741 0.092l3.955-0.874c0.154-0.103 0.423-0.113 0.438-0.664zM7.732 10.837c-0.339-0.174-0.746 0.187-0.746 0.187l-2.648 2.915c0 0-0.33 0.446-0.246 0.72 0.079 0.257 0.21 0.384 0.396 0.474l2.659 0.839c0 0 0.322 0.067 0.567-0.004 0.347-0.1 0.283-0.643 0.283-0.643l0.060-3.947c-0 0-0.014-0.38-0.324-0.541z" })
        );
    }
    function Yelp({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( YelpSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Yelp.SVG = YelpSVG;
    return Yelp;
})();
export const Paypal = /*#__PURE__*/ (() => {
        function PaypalSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M14.531 4.822c-0.747 3.316-3.053 5.066-6.688 5.066h-1.209l-0.841 5.338h-1.013l-0.053 0.344c-0.034 0.228 0.141 0.431 0.369 0.431h2.588c0.306 0 0.566-0.222 0.616-0.525l0.025-0.131 0.488-3.091 0.031-0.169c0.047-0.303 0.309-0.525 0.616-0.525h0.384c2.506 0 4.469-1.019 5.044-3.963 0.216-1.119 0.134-2.069-0.356-2.775z" }),
_('path', { d: "M12.984 1.206c-0.741-0.844-2.081-1.206-3.794-1.206h-4.972c-0.35 0-0.65 0.253-0.703 0.6l-2.072 13.131c-0.041 0.259 0.159 0.494 0.422 0.494h3.072l0.772-4.891-0.025 0.153c0.053-0.347 0.35-0.6 0.7-0.6h1.459c2.866 0 5.109-1.162 5.766-4.531 0.019-0.1 0.037-0.197 0.050-0.291 0.194-1.244 0-2.094-0.675-2.859z" })
            );
        }
        function Paypal({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( PaypalSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Paypal.SVG = PaypalSVG;
        return Paypal;
    })();
export const Chrome = /*#__PURE__*/ (() => {
    function ChromeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.036 6.977l-2.29-3.966c1.466-1.835 3.722-3.012 6.254-3.012 2.929 0 5.489 1.574 6.883 3.922h-6.528c-0.117-0.010-0.236-0.016-0.356-0.016-1.904 0-3.509 1.307-3.964 3.071zM10.864 5.078h4.585c0.355 0.905 0.551 1.891 0.551 2.922 0 4.388-3.533 7.95-7.909 7.999l3.272-5.667c0.461-0.662 0.731-1.466 0.731-2.332 0-1.143-0.471-2.178-1.23-2.922zM5.094 8c0-1.603 1.304-2.906 2.906-2.906s2.906 1.304 2.906 2.906c0 1.602-1.304 2.906-2.906 2.906s-2.906-1.304-2.906-2.906zM9.097 11.944l-2.29 3.967c-3.852-0.576-6.806-3.899-6.806-7.911 0-1.425 0.373-2.763 1.026-3.922l3.266 5.657c0.654 1.392 2.070 2.359 3.707 2.359 0.38 0 0.747-0.052 1.097-0.149z" })
        );
    }
    function Chrome({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( ChromeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Chrome.SVG = ChromeSVG;
    return Chrome;
})();
export const Firefox = /*#__PURE__*/ (() => {
    function FirefoxSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.977 5.221l-0.185 1.189c0 0-0.265-2.201-0.59-3.024-0.498-1.261-0.719-1.251-0.72-1.249 0.333 0.847 0.273 1.302 0.273 1.302s-0.591-1.609-2.152-2.121c-1.729-0.567-2.665-0.412-2.773-0.383-0.016-0-0.032-0-0.047-0 0.013 0.001 0.025 0.002 0.038 0.003-0.001 0-0.001 0.001-0.001 0.001 0.007 0.009 1.911 0.333 2.249 0.797 0 0-0.809 0-1.614 0.232-0.036 0.010 2.961 0.374 3.574 3.37 0 0-0.329-0.686-0.735-0.802 0.267 0.813 0.199 2.356-0.056 3.123-0.033 0.099-0.066-0.426-0.568-0.652 0.161 1.151-0.010 2.976-0.808 3.479-0.062 0.039 0.5-1.802 0.113-1.090-2.23 3.419-4.866 1.578-6.051 0.767 0.607 0.132 1.76-0.021 2.271-0.4 0.001-0 0.001-0.001 0.002-0.001 0.554-0.379 0.882-0.656 1.177-0.59s0.491-0.23 0.262-0.493c-0.229-0.263-0.786-0.625-1.539-0.428-0.531 0.139-1.19 0.727-2.194 0.132-0.771-0.457-0.844-0.837-0.851-1.1 0.019-0.093 0.043-0.18 0.072-0.26 0.089-0.248 0.358-0.323 0.508-0.382 0.254 0.044 0.473 0.123 0.703 0.241 0.003-0.076 0.004-0.178-0-0.293 0.022-0.044 0.008-0.176-0.027-0.337-0.020-0.161-0.053-0.328-0.106-0.48 0-0 0-0 0-0s0.002-0.001 0.002-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.002 0.002-0.004 0.003-0.007 0.016-0.072 0.188-0.211 0.402-0.361 0.192-0.134 0.417-0.277 0.595-0.387 0.157-0.098 0.277-0.17 0.302-0.189 0.010-0.007 0.021-0.016 0.034-0.026 0.002-0.002 0.005-0.004 0.007-0.006s0.003-0.002 0.004-0.004c0.085-0.067 0.211-0.194 0.237-0.462 0-0.001 0-0.001 0-0.002 0.001-0.008 0.001-0.016 0.002-0.024 0-0.006 0.001-0.011 0.001-0.017 0-0.004 0-0.009 0.001-0.013 0-0.011 0.001-0.021 0.001-0.032 0-0.001 0-0.001 0-0.002 0-0.026-0-0.053-0.002-0.081-0.001-0.016-0.002-0.030-0.005-0.043-0-0.001-0-0.001-0-0.002s-0.001-0.003-0.001-0.004-0.001-0.005-0.002-0.007c-0-0-0-0-0-0.001-0.001-0.003-0.002-0.005-0.003-0.007-0-0-0-0-0-0-0.027-0.064-0.13-0.088-0.554-0.096-0-0-0.001-0-0.001-0v0c-0.173-0.003-0.399-0.003-0.695-0.002-0.52 0.002-0.807-0.508-0.898-0.705 0.126-0.695 0.489-1.19 1.085-1.525 0.011-0.006 0.009-0.012-0.004-0.015 0.117-0.071-1.41-0.002-2.112 0.891-0.623-0.155-1.166-0.144-1.635-0.035-0.090-0.003-0.202-0.014-0.335-0.041-0.311-0.282-0.757-0.803-0.781-1.425 0 0-0.001 0.001-0.004 0.003-0-0.006-0.001-0.012-0.001-0.018 0 0-0.949 0.729-0.807 2.717-0 0.032-0.001 0.062-0.002 0.092-0.257 0.348-0.384 0.641-0.394 0.706-0.228 0.463-0.458 1.16-0.646 2.218 0 0 0.131-0.417 0.395-0.889-0.194 0.594-0.346 1.518-0.257 2.904 0 0 0.024-0.307 0.107-0.75 0.065 0.86 0.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791 0.419 0.035 0.845 0.035 1.272 0.003 0.039-0.003 0.079-0.006 0.118-0.009 0.484-0.034 0.971-0.107 1.457-0.224 6.643-1.606 5.921-9.628 5.921-9.628z" })
        );
    }
    function Firefox({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( FirefoxSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Firefox.SVG = FirefoxSVG;
    return Firefox;
})();
export const Ie = /*#__PURE__*/ (() => {
    function IeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M11.472 9.825h3.688c0.028-0.256 0.040-0.517 0.040-0.784 0-1.253-0.336-2.429-0.924-3.442 0.607-1.614 0.586-2.984-0.227-3.803-0.773-0.77-2.848-0.645-5.194 0.394-0.174-0.013-0.349-0.020-0.526-0.020-3.22 0-5.921 2.216-6.667 5.201 1.010-1.293 2.072-2.231 3.492-2.913-0.129 0.121-0.882 0.87-1.009 0.996-3.743 3.742-4.923 8.63-3.653 9.9 0.965 0.965 2.715 0.802 4.725-0.182 0.934 0.476 1.992 0.744 3.113 0.744 3.018 0 5.575-1.942 6.501-4.648h-3.717c-0.511 0.943-1.512 1.586-2.66 1.586s-2.148-0.642-2.66-1.586c-0.227-0.426-0.358-0.915-0.358-1.432v-0.011h6.035zM5.442 8.013c0.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728h-5.774zM14.015 2.559c0.524 0.529 0.511 1.503 0.063 2.719-0.768-1.17-1.883-2.093-3.2-2.619 1.408-0.604 2.553-0.684 3.137-0.1zM1.461 15.113c-0.668-0.669-0.467-2.072 0.394-3.763 0.536 1.504 1.581 2.767 2.927 3.581-1.491 0.677-2.712 0.792-3.321 0.182z" })
        );
    }
    function Ie({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Ie.SVG = IeSVG;
    return Ie;
})();
export const Edge = /*#__PURE__*/ (() => {
    function EdgeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.241 7.103c0.469-3.7 2.994-7.056 7.519-7.103 2.731 0.053 4.978 1.291 6.316 3.65 0.672 1.231 0.881 2.525 0.925 3.953v1.678h-10.041c0.047 4.141 6.094 4 8.697 2.175v3.372c-1.525 0.916-4.984 1.734-7.662 0.681-2.281-0.856-3.906-3.244-3.897-5.541-0.075-2.978 1.481-4.95 3.897-6.072-0.513 0.634-0.903 1.334-1.106 2.547h5.669c0 0 0.331-3.388-3.209-3.388-3.338 0.116-5.744 2.056-7.106 4.047v0z" })
        );
    }
    function Edge({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( EdgeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Edge.SVG = EdgeSVG;
    return Edge;
})();
export const Safari = /*#__PURE__*/ (() => {
        function SafariSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM14.975 7.388l-0.016-0.166c0.003 0.056 0.009 0.109 0.016 0.166zM13.881 4.2l-0.113-0.169c0.037 0.056 0.075 0.112 0.113 0.169zM13.447 3.603l-0.069-0.084c0.025 0.028 0.047 0.056 0.069 0.084zM12.478 2.619l-0.084-0.069c0.031 0.025 0.056 0.047 0.084 0.069zM11.969 2.231l-0.169-0.112c0.056 0.038 0.113 0.075 0.169 0.112zM8.778 1.044l-0.169-0.016c0.056 0.003 0.113 0.009 0.169 0.016zM7.388 1.025l-0.169 0.016c0.056-0.003 0.112-0.009 0.169-0.016zM4.2 2.119l-0.169 0.112c0.056-0.038 0.112-0.075 0.169-0.112zM3.603 2.553l-0.081 0.066c0.028-0.022 0.053-0.044 0.081-0.066zM2.619 3.522l-0.069 0.084c0.025-0.028 0.047-0.056 0.069-0.084zM2.231 4.031l-0.112 0.169c0.038-0.056 0.075-0.112 0.112-0.169zM1.044 7.222l-0.016 0.169c0.003-0.056 0.009-0.112 0.016-0.169zM1.025 8.613l0.016 0.169c-0.003-0.056-0.009-0.113-0.016-0.169zM2.119 11.797l0.112 0.169c-0.038-0.053-0.075-0.109-0.112-0.169zM2.25 11.994l1.247-0.834-0.138-0.209-1.247 0.834c-0.566-0.878-0.938-1.887-1.063-2.975l0.747-0.075-0.025-0.25-0.747 0.075c-0.012-0.144-0.019-0.291-0.022-0.438h1.5v-0.25h-1.5c0.003-0.147 0.009-0.291 0.022-0.438l0.747 0.072 0.025-0.25-0.747-0.072c0.125-1.088 0.5-2.097 1.066-2.975l1.247 0.834 0.138-0.209-1.25-0.828c0.084-0.119 0.169-0.237 0.259-0.35l0.578 0.475 0.159-0.194-0.578-0.475c0.094-0.112 0.194-0.219 0.294-0.325l1.059 1.059 0.178-0.178-1.059-1.059c0.106-0.1 0.212-0.2 0.322-0.294l0.475 0.581 0.194-0.159-0.475-0.578c0.116-0.091 0.231-0.178 0.35-0.263l0.834 1.247 0.209-0.138-0.834-1.247c0.878-0.566 1.888-0.938 2.975-1.063l0.075 0.747 0.25-0.025-0.075-0.747c0.144-0.012 0.291-0.019 0.438-0.022v1.5h0.25v-1.5c0.147 0.003 0.291 0.009 0.438 0.022l-0.072 0.747 0.25 0.025 0.072-0.747c1.088 0.125 2.097 0.5 2.975 1.066l-0.834 1.247 0.209 0.138 0.834-1.247c0.119 0.084 0.238 0.169 0.35 0.259l-0.475 0.578 0.194 0.159 0.475-0.578c0.113 0.094 0.219 0.194 0.325 0.294l-0.4 0.391-5.469 3.647-3.647 5.469-0.391 0.391c-0.1-0.106-0.2-0.213-0.294-0.322l0.578-0.475-0.159-0.194-0.578 0.475c-0.091-0.113-0.175-0.231-0.259-0.35zM2.619 12.478c-0.022-0.028-0.044-0.053-0.066-0.081l0.066 0.081zM3.522 13.381l0.081 0.066c-0.028-0.022-0.053-0.044-0.081-0.066zM4.031 13.766l0.169 0.113c-0.056-0.034-0.112-0.072-0.169-0.113zM7.222 14.956l0.169 0.016c-0.056-0.003-0.112-0.009-0.169-0.016zM8.613 14.975l0.166-0.016c-0.056 0.003-0.109 0.009-0.166 0.016zM11.8 13.881l0.169-0.113c-0.056 0.037-0.113 0.075-0.169 0.113zM12.397 13.447l0.084-0.069c-0.028 0.025-0.056 0.047-0.084 0.069zM12.944 12.956l0.012-0.012c-0.003 0.003-0.009 0.009-0.012 0.012zM13.381 12.478l0.069-0.084c-0.025 0.028-0.047 0.056-0.069 0.084zM13.491 12.344l-0.578-0.475-0.159 0.194 0.578 0.475c-0.094 0.113-0.194 0.219-0.294 0.325l-1.059-1.059-0.178 0.178 1.059 1.059c-0.106 0.1-0.213 0.2-0.322 0.294l-0.475-0.581-0.194 0.159 0.475 0.578c-0.116 0.091-0.231 0.178-0.35 0.262l-0.834-1.247-0.209 0.137 0.834 1.247c-0.878 0.566-1.887 0.938-2.975 1.063l-0.075-0.747-0.25 0.025 0.075 0.747c-0.144 0.012-0.291 0.019-0.438 0.022v-1.5h-0.25v1.5c-0.147-0.003-0.291-0.009-0.438-0.022l0.072-0.747-0.25-0.025-0.072 0.747c-1.088-0.125-2.097-0.5-2.975-1.066l0.834-1.247-0.209-0.137-0.828 1.247c-0.119-0.084-0.237-0.169-0.35-0.259l0.475-0.578-0.194-0.159-0.475 0.578c-0.112-0.094-0.219-0.194-0.325-0.294l0.394-0.391 5.469-3.647 3.647-5.469 0.391-0.391c0.1 0.106 0.2 0.212 0.294 0.322l-0.578 0.475 0.159 0.194 0.578-0.475c0.091 0.116 0.178 0.231 0.262 0.35l-1.247 0.834 0.137 0.209 1.247-0.834c0.566 0.878 0.938 1.888 1.063 2.975l-0.747 0.075 0.025 0.25 0.747-0.075c0.012 0.144 0.019 0.291 0.022 0.438h-1.5v0.25h1.5c-0.003 0.147-0.009 0.291-0.022 0.438l-0.747-0.072-0.025 0.25 0.747 0.072c-0.125 1.088-0.5 2.097-1.066 2.975l-1.247-0.834-0.137 0.209 1.247 0.834c-0.081 0.113-0.169 0.228-0.259 0.344zM14.975 8.609c-0.006 0.056-0.009 0.113-0.016 0.169l0.016-0.169zM13.881 11.8c-0.037 0.056-0.075 0.113-0.113 0.169l0.113-0.169z" }),
_('path', { d: "M6.758 1.111l0.293 1.471-0.245 0.049-0.293-1.471 0.245-0.049z" }),
_('path', { d: "M9.245 14.89l-0.293-1.471 0.245-0.049 0.293 1.471-0.245 0.049z" }),
_('path', { d: "M6.088 1.264l0.218 0.718-0.239 0.073-0.218-0.718 0.239-0.073z" }),
_('path', { d: "M9.913 14.733l-0.218-0.718 0.239-0.073 0.218 0.718-0.239 0.073z" }),
_('path', { d: "M5.438 1.486l0.574 1.386-0.231 0.096-0.574-1.386 0.231-0.096z" }),
_('path', { d: "M10.564 14.515l-0.574-1.386 0.231-0.096 0.574 1.386-0.231 0.096z" }),
_('path', { d: "M4.588 1.885l0.22-0.118 0.354 0.661-0.22 0.118-0.354-0.661z" }),
_('path', { d: "M11.408 14.114l-0.22 0.118-0.354-0.661 0.22-0.118 0.354 0.661z" }),
_('path', { d: "M1.884 4.591l0.662 0.353-0.118 0.221-0.661-0.353 0.118-0.221z" }),
_('path', { d: "M14.113 11.409l-0.662-0.353 0.118-0.22 0.662 0.353-0.118 0.22z" }),
_('path', { d: "M2.872 6.010l-1.386-0.574 0.096-0.231 1.386 0.574-0.096 0.231z" }),
_('path', { d: "M13.13 9.989l1.386 0.574-0.096 0.231-1.386-0.574 0.096-0.231z" }),
_('path', { d: "M1.337 5.85l0.718 0.218-0.073 0.239-0.718-0.218 0.073-0.239z" }),
_('path', { d: "M14.661 10.151l-0.718-0.218 0.073-0.239 0.718 0.218-0.073 0.239z" }),
_('path', { d: "M1.157 6.512l1.471 0.293-0.049 0.245-1.471-0.293 0.049-0.245z" }),
_('path', { d: "M14.84 9.488l-1.471-0.293 0.049-0.245 1.471 0.293-0.049 0.245z" }),
_('path', { d: "M1.109 9.243l1.471-0.293 0.049 0.245-1.471 0.293-0.049-0.245z" }),
_('path', { d: "M14.888 6.757l-1.471 0.293-0.049-0.245 1.471-0.293 0.049 0.245z" }),
_('path', { d: "M1.265 9.914l0.718-0.218 0.073 0.239-0.718 0.218-0.073-0.239z" }),
_('path', { d: "M14.734 6.089l-0.718 0.218-0.073-0.239 0.718-0.218 0.073 0.239z" }),
_('path', { d: "M1.58 10.796l-0.096-0.231 1.386-0.574 0.096 0.231-1.386 0.574z" }),
_('path', { d: "M14.419 5.207l0.096 0.231-1.386 0.574-0.096-0.231 1.386-0.574z" }),
_('path', { d: "M1.888 11.41l-0.118-0.22 0.661-0.354 0.118 0.22-0.661 0.354z" }),
_('path', { d: "M14.116 4.59l0.118 0.22-0.661 0.354-0.118-0.22 0.661-0.354z" }),
_('path', { d: "M4.811 14.232l-0.22-0.118 0.354-0.661 0.22 0.118-0.354 0.661z" }),
_('path', { d: "M11.189 1.767l0.22 0.118-0.353 0.661-0.22-0.118 0.353-0.661z" }),
_('path', { d: "M5.207 14.419l0.574-1.386 0.231 0.096-0.574 1.386-0.231-0.096z" }),
_('path', { d: "M10.795 1.58l-0.574 1.386-0.231-0.096 0.574-1.386 0.231 0.096z" }),
_('path', { d: "M6.088 14.735l-0.239-0.073 0.218-0.718 0.239 0.073-0.218 0.718z" }),
_('path', { d: "M9.912 1.264l0.239 0.073-0.218 0.718-0.239-0.073 0.218-0.718z" }),
_('path', { d: "M6.757 14.888l-0.245-0.049 0.293-1.471 0.245 0.049-0.293 1.471z" }),
_('path', { d: "M9.243 1.109l0.245 0.049-0.293 1.471-0.245-0.049 0.293-1.471z" })
            );
        }
        function Safari({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( SafariSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Safari.SVG = SafariSVG;
        return Safari;
    })();
export const Opera = /*#__PURE__*/ (() => {
        function OperaSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M16 8v0 0c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966 0.3-4.597-0.137 2.016-0.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c0.634-0.438 2.547-1.137 4.597-0.138 1.637 1.466 2.669 3.597 2.669 5.966v0 0z" }),
_('path', { d: "M5.366 3.491c-0.884 1.044-1.456 2.587-1.494 4.322 0 0.003 0 0.372 0 0.378 0.038 1.731 0.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434 1.172 0 2.269-0.356 3.206-0.978-1.419 1.266-3.287 2.034-5.334 2.034-0.128 0-0.256-0.003-0.381-0.009-4.241-0.2-7.619-3.7-7.619-7.991 0-4.419 3.581-8 8-8 0.009 0 0.019 0 0.031 0 2.037 0.006 3.894 0.775 5.303 2.038-0.938-0.622-2.034-0.981-3.206-0.981-1.906 0-3.612 0.944-4.763 2.434z" })
            );
        }
        function Opera({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( OperaSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        Opera.SVG = OperaSVG;
        return Opera;
    })();
export const FilePdf = /*#__PURE__*/ (() => {
        function FilePdfSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FilePdf({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FilePdfSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FilePdf.SVG = FilePdfSVG;
        return FilePdf;
    })();
export const FileOpenoffice = /*#__PURE__*/ (() => {
        function FileOpenofficeSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M10.785 7.37c-0.948-0.448-2.156-0.538-3.044 0.095 1.080-0.103 2.265 0.076 3.049 0.893 0.75-0.861 1.939-1.022 3.015-0.933-0.898-0.596-2.082-0.516-3.019-0.054v0zM10.401 9.465c-1.068-0.025-2.101 0.362-2.986 0.939-1.675-0.712-3.793-0.58-5.219 0.609 0.411-0.015 0.813-0.116 1.22-0.169 1.487-0.148 3.072 0.221 4.196 1.247 0.465-0.68 1.119-1.223 1.87-1.561 0.986-0.477 2.096-0.526 3.169-0.539-0.651-0.448-1.478-0.531-2.249-0.526z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FileOpenoffice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileOpenofficeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileOpenoffice.SVG = FileOpenofficeSVG;
        return FileOpenoffice;
    })();
export const FileWord = /*#__PURE__*/ (() => {
        function FileWordSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M9.997 7.436h0.691l-0.797 3.534-1.036-4.969h-1.665l-1.205 4.969-0.903-4.969h-1.741l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998h-2.663v1.435z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FileWord({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileWordSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileWord.SVG = FileWordSVG;
        return FileWord;
    })();
export const FileExcel = /*#__PURE__*/ (() => {
        function FileExcelSVG({ originalSize, style, svgRef, ...props }) {
            return _('svg', {
                    width: originalSize ? 16 : '1em',
                    height: originalSize ? 16 : '1em',
                    viewBox: "0 0 16 16",
                    ref: svgRef,
                    style: { fill: 'currentColor', ...style },
                    ...props
                },
                _('path', { d: "M11.61 6h-2.114l-1.496 2.204-1.496-2.204h-2.114l2.534 3.788-2.859 4.212h3.935v-1.431h-0.784l0.784-1.172 1.741 2.603h2.194l-2.859-4.212 2.534-3.788z" }),
_('path', { d: "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z" })
            );
        }
        function FileExcel({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
            return _('span', {
                    className: 'anticon ' + className,
                    ref: spanRef, ...props
                },
                _( FileExcelSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
            );
        }
        FileExcel.SVG = FileExcelSVG;
        return FileExcel;
    })();
export const Libreoffice = /*#__PURE__*/ (() => {
    function LibreofficeSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046 0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5 0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129 0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z" })
        );
    }
    function Libreoffice({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( LibreofficeSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Libreoffice.SVG = LibreofficeSVG;
    return Libreoffice;
})();
export const HtmlFive = /*#__PURE__*/ (() => {
    function HtmlFiveSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.26 4.71h-6.758l0.161 1.809h6.437l-0.485 5.422-3.623 1.004-3.618-1.004-0.247-2.774h1.773l0.126 1.41 1.967 0.53 0.004-0.001 1.968-0.531 0.204-2.29h-6.121l-0.476-5.341h8.847l-0.158 1.766z" })
        );
    }
    function HtmlFive({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HtmlFiveSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HtmlFive.SVG = HtmlFiveSVG;
    return HtmlFive;
})();
export const HtmlFive2 = /*#__PURE__*/ (() => {
    function HtmlFive2SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.668 13.482l-4.644 1.287v0.007l-0.012-0.004-0.012 0.004v-0.007l-4.644-1.287-1.098-12.304h11.508l-1.098 12.304zM10.168 8.284l-0.204 2.29-1.972 0.532-1.967-0.53-0.126-1.41h-1.773l0.247 2.774 3.626 1.003 3.615-1.003 0.485-5.422h-6.437l-0.161-1.809h6.758l0.158-1.766h-8.847l0.477 5.341z" })
        );
    }
    function HtmlFive2({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( HtmlFive2SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    HtmlFive2.SVG = HtmlFive2SVG;
    return HtmlFive2;
})();
export const Css3 = /*#__PURE__*/ (() => {
    function Css3SVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M2.381 0.758l-0.537 2.686h10.934l-0.342 1.735h-10.94l-0.53 2.686h10.933l-0.61 3.063-4.406 1.46-3.819-1.46 0.261-1.329h-2.686l-0.639 3.224 6.316 2.417 7.281-2.417 2.403-12.066z" })
        );
    }
    function Css3({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( Css3SVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Css3.SVG = Css3SVG;
    return Css3;
})();
export const Git = /*#__PURE__*/ (() => {
    function GitSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M15.698 7.287l-6.986-6.986c-0.402-0.402-1.055-0.402-1.457 0l-1.623 1.623 1.221 1.221c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5 0 0.232-0.053 0.451-0.146 0.647l2 2c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5c0-0.232 0.053-0.451 0.146-0.647l-2-2c-0.048 0.023-0.097 0.043-0.147 0.061v4.171c0.583 0.206 1 0.761 1 1.414 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.653 0.417-1.208 1-1.414v-4.171c-0.583-0.206-1-0.761-1-1.414 0-0.232 0.053-0.451 0.146-0.647l-1.221-1.221-4.623 4.623c-0.402 0.403-0.402 1.055 0 1.458l6.986 6.986c0.402 0.402 1.054 0.402 1.457 0l6.953-6.953c0.402-0.403 0.402-1.055-0-1.458z" })
        );
    }
    function Git({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( GitSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Git.SVG = GitSVG;
    return Git;
})();
export const Codepen = /*#__PURE__*/ (() => {
    function CodepenSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.777 5.751l-7-4.667c-0.168-0.112-0.387-0.112-0.555 0l-7 4.667c-0.139 0.093-0.223 0.249-0.223 0.416v4.667c0 0.167 0.084 0.323 0.223 0.416l7 4.667c0.084 0.056 0.181 0.084 0.277 0.084s0.193-0.028 0.277-0.084l7-4.667c0.139-0.093 0.223-0.249 0.223-0.416v-4.667c0-0.167-0.084-0.323-0.223-0.416zM7.5 10.232l-2.599-1.732 2.599-1.732 2.599 1.732-2.599 1.732zM8 5.899v-3.465l5.599 3.732-2.599 1.732-3-2zM7 5.899l-3 2-2.599-1.732 5.599-3.732v3.465zM3.099 8.5l-2.099 1.399v-2.798l2.099 1.399zM4 9.101l3 2v3.465l-5.599-3.732 2.599-1.732zM8 11.101l3-2 2.599 1.732-5.599 3.732v-3.465zM11.901 8.5l2.099-1.399v2.798l-2.099-1.399z" })
        );
    }
    function Codepen({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( CodepenSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Codepen.SVG = CodepenSVG;
    return Codepen;
})();
export const Svg = /*#__PURE__*/ (() => {
    function SvgSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M14.5 6.5c-0.444 0-0.843 0.193-1.118 0.5h-2.968l2.099-2.099c0.411 0.023 0.83-0.123 1.144-0.437 0.586-0.586 0.586-1.536 0-2.121s-1.536-0.586-2.121 0c-0.314 0.314-0.46 0.733-0.437 1.144l-2.099 2.099v-2.968c0.307-0.275 0.5-0.674 0.5-1.118 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.444 0.193 0.843 0.5 1.118v2.968l-2.099-2.099c0.023-0.411-0.123-0.83-0.437-1.144-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.314 0.314 0.733 0.46 1.144 0.437l2.099 2.099h-2.968c-0.275-0.307-0.674-0.5-1.118-0.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.444 0 0.843-0.193 1.118-0.5h2.968l-2.099 2.099c-0.411-0.023-0.83 0.123-1.144 0.437-0.586 0.586-0.586 1.536 0 2.121s1.536 0.586 2.121 0c0.314-0.314 0.46-0.733 0.437-1.144l2.099-2.099v2.968c-0.307 0.275-0.5 0.674-0.5 1.118 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.444-0.193-0.843-0.5-1.118v-2.968l2.099 2.099c-0.023 0.411 0.123 0.83 0.437 1.144 0.586 0.586 1.536 0.586 2.121 0s0.586-1.536 0-2.121c-0.314-0.314-0.733-0.46-1.144-0.437l-2.099-2.099h2.968c0.275 0.307 0.674 0.5 1.118 0.5 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5z" })
        );
    }
    function Svg({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( SvgSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    Svg.SVG = SvgSVG;
    return Svg;
})();
export const IcoMoon = /*#__PURE__*/ (() => {
    function IcoMoonSVG({ originalSize, style, svgRef, ...props }) {
        return _('svg', {
                width: originalSize ? 16 : '1em',
                height: originalSize ? 16 : '1em',
                viewBox: "0 0 16 16",
                ref: svgRef,
                style: { fill: 'currentColor', ...style },
                ...props
            },
            _('path', { d: "M4.055 8c0-1.022 0.829-1.851 1.851-1.851s1.851 0.829 1.851 1.851c0 1.022-0.829 1.851-1.851 1.851s-1.851-0.829-1.851-1.851zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM5.928 14.989c-2.406-1.4-4.023-4.005-4.023-6.989s1.617-5.589 4.023-6.989c2.406 1.399 4.025 4.005 4.025 6.989s-1.618 5.589-4.025 6.989z" })
        );
    }
    function IcoMoon({ className = '', originalSize, spanRef, svgProps, svgRef, ...props }) {
        return _('span', {
                className: 'anticon ' + className,
                ref: spanRef, ...props
            },
            _( IcoMoonSVG, { originalSize: originalSize, svgRef: svgRef, ...svgProps } )
        );
    }
    IcoMoon.SVG = IcoMoonSVG;
    return IcoMoon;
})();
